// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   App
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     8/23/2024 12:14:28 PM
************************************************/

export enum AppMetaDataItemNames {
    AccessControl = 'AccessControl',
    Accident = 'Accident',
    Attachment = 'Attachment',
    AttachmentAttachmentFile = 'attachment_AttachmentFile',
    AttachmentAttachmentFolder = 'attachment_AttachmentFolder',
    AttachmentConversion = 'AttachmentConversion',
    AttachmentConversionPermit = 'AttachmentConversionPermit',
    AttachmentConversionPermitMedia = 'AttachmentConversionPermitMedia',
    AttachmentFile = 'AttachmentFile',
    AttachmentFileVersion = 'AttachmentFileVersion',
    AttachmentFolder = 'AttachmentFolder',
    AttachmentObject = 'AttachmentObject',
    Auction = 'Auction',
    AuditIssue = 'AuditIssue',
    AuditIssueRating = 'AuditIssueRating',
    AuditIssueRiskType = 'AuditIssueRiskType',
    AuditIssueStatus = 'AuditIssueStatus',
    BidHistory = 'BidHistory',
    Billing = 'Billing',
    BillingDepartment = 'BillingDepartment',
    ChangeRequest = 'ChangeRequest',
    Checklist = 'Checklist',
    CodeSet = 'CodeSet',
    CodeValue = 'CodeValue',
    Collaboration = 'Collaboration',
    CollaborationDepartment = 'CollaborationDepartment',
    CollaborationPm = 'CollaborationPm',
    Company = 'Company',
    CompanyLicense = 'CompanyLicense',
    CompanyLicenseType = 'CompanyLicenseType',
    CovidConfiguration = 'CovidConfiguration',
    CovidTestResultType = 'CovidTestResultType',
    CovidTestStatus = 'CovidTestStatus',
    CovidTestType = 'CovidTestType',
    CovidVaccinationStatus = 'CovidVaccinationStatus',
    CovidVaccinationSubmissionStatus = 'CovidVaccinationSubmissionStatus',
    CovidVaccineType = 'CovidVaccineType',
    CovidWorkStatus = 'CovidWorkStatus',
    CustomerSatisfaction = 'CustomerSatisfaction',
    DboEthosCounty = 'dbo_Ethos_County',
    DepartmentAdditionalBurden = 'DepartmentAdditionalBurden',
    DepartmentMap = 'DepartmentMap',
    DepartmentRole = 'DepartmentRole',
    DevwareCustomAttributeValue = 'devware_CustomAttributeValue',
    DWOSGFinData = 'DW_OSGFinData',
    DWOSGFinDataLatest = 'DW_OSGFinDataLatest',
    DWPeoplePaySummary = 'DW_PeoplePaySummary',
    DWPersonMerge = 'DW_PersonMerge',
    DWPersonMergeLog = 'DW_PersonMergeLog',
    DWTrustForecastData = 'DW_TrustForecastData',
    DWWorkInProcess = 'DW_WorkInProcess',
    EmaulationUser = 'EmaulationUser',
    EmployeeReminderNotification = 'EmployeeReminderNotification',
    EmployeeReview = 'EmployeeReview',
    EmployeeReviewAnswer = 'EmployeeReviewAnswer',
    EmployeeReviewAnswerValue = 'EmployeeReviewAnswerValue',
    EmployeeReviewCategory = 'EmployeeReviewCategory',
    EmployeeReviewQuestion = 'EmployeeReviewQuestion',
    EmployeeReviewQuestionRequest = 'EmployeeReviewQuestionRequest',
    EmployeeReviewQuestionRequestDetail = 'EmployeeReviewQuestionRequestDetail',
    EmployeeReviewQuestionRequestStatus = 'EmployeeReviewQuestionRequestStatus',
    EmployeeReviewQuestionSetup = 'EmployeeReviewQuestionSetup',
    EmployeeReviewQuestionSetupDetail = 'EmployeeReviewQuestionSetupDetail',
    EmployeeReviewQuestionSetupLevel = 'EmployeeReviewQuestionSetupLevel',
    EmployeeReviewQuestionSkill = 'EmployeeReviewQuestionSkill',
    EmployeeReviewQuestionType = 'EmployeeReviewQuestionType',
    EmployeeReviewStatus = 'EmployeeReviewStatus',
    EmployeeReviewSummary = 'EmployeeReviewSummary',
    EmployeeReviewSummaryStatus = 'EmployeeReviewSummaryStatus',
    EmployeeReviewSummaryType = 'EmployeeReviewSummaryType',
    EmployeeServiceDates = 'EmployeeServiceDates',
    EmployeeSummary = 'EmployeeSummary',
    EmployeeSummaryChangeType = 'EmployeeSummaryChangeType',
    EmployeeSummaryHistory = 'EmployeeSummaryHistory',
    EmployeeTest = 'EmployeeTest',
    EmployeeTrainingNeeded = 'EmployeeTrainingNeeded',
    EmployeeVaccinationSubmission = 'EmployeeVaccinationSubmission',
    EmsNote = 'ems_Note',
    EmsUserExtended = 'ems_UserExtended',
    Equipment = 'Equipment',
    EquipmentCompany = 'EquipmentCompany',
    Escalation = 'Escalation',
    EthosAddress = 'Ethos_Address',
    EthosCodeSet = 'Ethos_CodeSet',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosCountry = 'Ethos_Country',
    EthosCustomer = 'Ethos_Customer',
    EthosJob = 'Ethos_Job',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberMembership = 'Ethos_JobNumberMembership',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobNumberPriority = 'Ethos_JobNumberPriority',
    EthosJobSite = 'Ethos_JobSite',
    EthosJobSow = 'Ethos_JobSow',
    EthosLaborMetrics = 'Ethos_LaborMetrics',
    EthosOpportunity = 'Ethos_Opportunity',
    EthosRoUserLaborSummary = 'Ethos_roUserLaborSummary',
    EthosServiceUser = 'Ethos_ServiceUser',
    EthosSite = 'Ethos_Site',
    EthosSow = 'Ethos_Sow',
    EthosStaffingAgency = 'Ethos_StaffingAgency',
    EthosStateProvince = 'Ethos_StateProvince',
    EthosSubcontractorBranch = 'Ethos_SubcontractorBranch',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterCompany = 'Ethos_WachterCompany',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    EthosWachterDivision = 'Ethos_WachterDivision',
    EthosWachterJobTitle = 'Ethos_WachterJobTitle',
    EthosWachterTeam = 'Ethos_WachterTeam',
    EthosWorkflowStatus = 'Ethos_WorkflowStatus',
    EthosWorkflowStatusSet = 'Ethos_WorkflowStatusSet',
    EthosRoleMap = 'EthosRoleMap',
    EthosRoles = 'EthosRoles',
    EthosUserDetail = 'EthosUserDetail',
    EthosUserRole = 'EthosUserRole',
    FieldEmployeesPayRate = 'FieldEmployeesPayRate',
    FiveStarRating = 'FiveStarRating',
    FleetVehicle = 'fleet_Vehicle',
    Inspection = 'Inspection',
    InspectionResult = 'InspectionResult',
    InspectionStatus = 'InspectionStatus',
    IssueSubtype = 'IssueSubtype',
    IssueSubtypeSeverity = 'IssueSubtypeSeverity',
    IssueType = 'IssueType',
    Kickoff = 'Kickoff',
    KickoffChecklist = 'KickoffChecklist',
    Licenses = 'Licenses',
    LicenseType = 'LicenseType',
    Maintenance = 'Maintenance',
    MaintenanceService = 'MaintenanceService',
    MedicalRecord = 'MedicalRecord',
    MemoOfRecord = 'MemoOfRecord',
    Message = 'Message',
    Milestone = 'Milestone',
    MilestoneCheckpoint = 'MilestoneCheckpoint',
    MissingForeignKeys = 'MissingForeignKeys',
    MorMemoOfRecordNotificationGroup = 'mor_MemoOfRecordNotificationGroup',
    MorNotificationConfig = 'mor_NotificationConfig',
    MtlUserExtended = 'mtl_UserExtended',
    Note = 'Note',
    NotesNote = 'notes_Note',
    NotesNoteParent = 'notes_NoteParent',
    NoteType = 'NoteType',
    NumbersNote = 'numbers_Note',
    NumbersRoUserProjection = 'numbers_roUserProjection',
    OrganizationalEntity = 'OrganizationalEntity',
    OrganizationalMembership = 'OrganizationalMembership',
    OrganizationalType = 'OrganizationalType',
    OrganizationalUnit = 'OrganizationalUnit',
    OverheadProjection = 'OverheadProjection',
    OverheadTeamPhase = 'OverheadTeamPhase',
    PafHistory = 'PafHistory',
    PassHistory = 'PassHistory',
    PayJobChange = 'PayJobChange',
    PayJobChangeEmail = 'PayJobChangeEmail',
    PayJobChangeUsersRead = 'PayJobChangeUsersRead',
    PayJobChangeWorkflowEmail = 'PayJobChangeWorkflowEmail',
    PeoplePayHistoryCurrentPreviousInitial = 'PeoplePayHistoryCurrentPreviousInitial',
    PeoplePayHistoryCurrentPreviousInitialV2 = 'PeoplePayHistoryCurrentPreviousInitialV2',
    PerformanceMetrics = 'PerformanceMetrics',
    Permit = 'Permit',
    PermitPermitType = 'PermitPermitType',
    PermitRequest = 'permitRequest',
    PermitRequestPermit = 'PermitRequestPermit',
    PermitRequestPermitType = 'PermitRequestPermitType',
    Permits2AccessControl = 'permits2_AccessControl',
    Permits2Inspection = 'permits2_Inspection',
    Permits2Permit = 'permits2_Permit',
    Permits2PermitPermitType = 'permits2_PermitPermitType',
    Permits2PermitStatus = 'permits2_PermitStatus',
    Permits2RequiredCable = 'permits2_RequiredCable',
    Permits2RoInspections = 'permits2_roInspections',
    Permits2RoPermits = 'permits2_roPermits',
    PermitStatus = 'PermitStatus',
    PlateHistory = 'PlateHistory',
    PolicyType = 'PolicyType',
    ProjectMilestone = 'ProjectMilestone',
    ProjectsKickoff = 'projects_Kickoff',
    ProofOfInsurance = 'ProofOfInsurance',
    ProofOfInsuranceJobTitles = 'ProofOfInsuranceJobTitles',
    ProofOfInsuranceStatus = 'ProofOfInsuranceStatus',
    ProofOfInsuranceSummary = 'ProofOfInsuranceSummary',
    ProofOfInsuranceSummaryStatus = 'ProofOfInsuranceSummaryStatus',
    Rating = 'Rating',
    RatingQuestion = 'RatingQuestion',
    RatingType = 'RatingType',
    Reporting = 'Reporting',
    Request = 'Request',
    RequestEquipment = 'RequestEquipment',
    RequestPreferences = 'RequestPreferences',
    RequiredCable = 'RequiredCable',
    ResourceCost = 'resourceCost',
    Review = 'Review',
    RoEthosUserBurdon = 'ro_EthosUserBurdon',
    RoAccident = 'roAccident',
    RoActiveChangeRequest = 'roActiveChangeRequest',
    RoActiveSubordinates = 'roActiveSubordinates',
    RoAllSupervisorsSubordinates = 'roAllSupervisorsSubordinates',
    RoAllSupervisorsSubordinatesOptimized = 'roAllSupervisorsSubordinatesOptimized',
    RoAllSupervisorsSubordinatesOriginal = 'roAllSupervisorsSubordinatesOriginal',
    RoAttachmentFileNamesCombined = 'roAttachmentFileNamesCombined',
    RoAuction = 'roAuction',
    RoAuditIssue = 'roAuditIssue',
    RoAuditSupervisorAccess = 'roAuditSupervisorAccess',
    RoAvStarRatingNspTech = 'roAvStarRatingNspTech',
    RoCollaboration = 'roCollaboration',
    RoCustomerSatisfaction = 'roCustomerSatisfaction',
    RoEmployeeDetail = 'roEmployeeDetail',
    RoEmployeeDetailFull = 'roEmployeeDetailFull',
    RoEmployeeReviewSummaryCurrent = 'roEmployeeReviewSummaryCurrent',
    RoEmsPBi = 'roEmsPBi',
    RoEthosUser = 'roEthos_User',
    RoEthosUserAddSubTemp = 'roEthos_UserAddSubTemp',
    RoEthosUserGrid = 'roEthos_UserGrid',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoEthosTeamsAndOrganizationalUnits = 'roEthosTeamsAndOrganizationalUnits',
    RoFiscalYearRange = 'roFiscalYearRange',
    RoInspections = 'roInspections',
    RoIssueTypeSubtypeSeverity = 'roIssueTypeSubtypeSeverity',
    RoKickoff = 'roKickoff',
    RoLastAccidentSummary = 'roLastAccidentSummary',
    RoLicenseCountPerUser = 'roLicenseCountPerUser',
    RoLicenses = 'roLicenses',
    RoMaintenance = 'roMaintenance',
    RoMilestoneAndMilestoneCheckpoint = 'roMilestoneAndMilestoneCheckpoint',
    RoNspCommittedByDepartment = 'roNspCommittedByDepartment',
    RoNspCommittedByProjectManager = 'roNspCommittedByProjectManager',
    RoNspCommittedByTeam = 'roNspCommittedByTeam',
    RoNspCommittedByUnit = 'roNspCommittedByUnit',
    RoNspDwFinancialsByDepartmentByYear = 'roNspDwFinancialsByDepartmentByYear',
    RoNspDwFinancialsByProjectManagerByYear = 'roNspDwFinancialsByProjectManagerByYear',
    RoNspDwFinancialsByTeamByYear = 'roNspDwFinancialsByTeamByYear',
    RoNspDwFinancialsByUnitByYear = 'roNspDwFinancialsByUnitByYear',
    RoNspDwOverheadByDepartmentByYear = 'roNspDwOverheadByDepartmentByYear',
    RoNspDwOverheadByTeamByYear = 'roNspDwOverheadByTeamByYear',
    RoNSPFinancialNumbers = 'roNSPFinancialNumbers',
    RoNspFinancialNumbersByTeamByYear = 'roNspFinancialNumbersByTeamByYear',
    RoNspFinancialNumbersByTeamByYearBackup = 'roNspFinancialNumbersByTeamByYear_Backup',
    RoNspFinancialNumbersByTeamByYearOLD = 'roNspFinancialNumbersByTeamByYearOLD',
    RoNSPFinancialNumbersByYear = 'roNSPFinancialNumbersByYear',
    RoNspOverheadProjectedByDepartmentByYear = 'roNspOverheadProjectedByDepartmentByYear',
    RoNspOverheadProjectedByTeamByYear = 'roNspOverheadProjectedByTeamByYear',
    RoNspProjectedByDepartment = 'roNspProjectedByDepartment',
    RoNspProjectedByProjectManager = 'roNspProjectedByProjectManager',
    RoNspProjectedByTeam = 'roNspProjectedByTeam',
    RoNspProjectedByUnit = 'roNspProjectedByUnit',
    RoOrganizationalTeamUnitDept = 'roOrganizationalTeamUnitDept',
    RoOverheadCommittedByJobPhaseYear = 'roOverheadCommittedByJobPhaseYear',
    RoOverheadProjectedByJobPhaseYear = 'roOverheadProjectedByJobPhaseYear',
    RoOverheadProjectionByTeam = 'roOverheadProjectionByTeam',
    RoPafAccess = 'roPafAccess',
    RoPayJobChangeSubordinates = 'roPayJobChangeSubordinates',
    RoPermitRequestLastNote = 'roPermitRequestLastNote',
    RoPermitRequests = 'roPermitRequests',
    RoPermits = 'roPermits',
    RoPermitsBySubordinates = 'roPermitsBySubordinates',
    RoPositionHistory = 'roPositionHistory',
    RoProjectKickoff = 'roProjectKickoff',
    RoProjectManagersTeamUnitDept = 'roProjectManagersTeamUnitDept',
    RoRequest = 'roRequest',
    RoRequestContext = 'roRequestContext',
    RoStarRatingAvProjects = 'roStarRatingAvProjects',
    RoStarRatingAvProjectsPms = 'roStarRatingAvProjectsPms',
    RoStarRatingNotificationTargets = 'roStarRatingNotificationTargets',
    RoTerritoryStateProvince = 'roTerritoryStateProvince',
    RoUserProjection = 'roUserProjection',
    RoUserProjectionAnalyzed = 'roUserProjectionAnalyzed',
    RoUserSkillList = 'roUserSkillList',
    RoVehicle = 'roVehicle',
    RoVehicleAccidents = 'roVehicleAccidents',
    RoVehicleYears = 'roVehicleYears',
    RoWorkersComp = 'roWorkersComp',
    RoWorkplaceAccident = 'roWorkplaceAccident',
    RoWorkplaceAccidentNotes = 'roWorkplaceAccidentNotes',
    RoYearRange = 'roYearRange',
    ServiceType = 'ServiceType',
    StageAuditLog = 'StageAuditLog',
    Stakeholder = 'Stakeholder',
    StarRatingAvProjects = 'StarRatingAvProjects',
    StarRatingFieldExperience = 'StarRatingFieldExperience',
    StarRatingNotification = 'StarRatingNotification',
    StarRatingNotificationType = 'StarRatingNotificationType',
    SuggestedCompositeIndexes = 'SuggestedCompositeIndexes',
    SuggestedForeignKeyIndexes = 'SuggestedForeignKeyIndexes',
    TeamAssignment = 'TeamAssignment',
    TeamYearNumbers = 'TeamYearNumbers',
    Template = 'Template',
    TermResign = 'TermResign',
    Territory = 'Territory',
    TerritoryStateProvince = 'TerritoryStateProvince',
    Timer = 'Timer',
    TimerSkillMap = 'TimerSkillMap',
    TimerStatus = 'TimerStatus',
    TimerType = 'TimerType',
    TmpRoAllSupervisorsSubordinates = 'tmpRoAllSupervisorsSubordinates',
    TmpSysdiamgrasBackup20230417 = 'tmpSysdiamgrasBackup_2023_04_17',
    TravelRequest = 'travel_Request',
    Traveler = 'Traveler',
    TrustSyncLog = 'TrustSyncLog',
    TrustUserMerged = 'TrustUserMerged',
    UserExtended = 'UserExtended',
    UserExtendedEthosCustomer = 'UserExtendedEthos_Customer',
    UserRead = 'UserRead',
    UserTeamLookup = 'UserTeamLookup',
    UserYearNumbers = 'UserYearNumbers',
    Vehicle = 'Vehicle',
    VehicleAccident = 'VehicleAccident',
    VehicleType = 'VehicleType',
    WachterContainerStyle = 'WachterContainerStyle',
    WachterTeamDepartment = 'WachterTeamDepartment',
    WachterTeamOrganizationalUnit = 'WachterTeamOrganizationalUnit',
    WageExpense = 'WageExpense',
    WAppsRoles = 'wAppsRoles',
    WcNote = 'wc_Note',
    WcNotificationGroup = 'wc_NotificationGroup',
    WcUserProjection = 'wc_UserProjection',
    WcUserRead = 'wc_UserRead',
    Witness = 'Witness',
    WorkflowStatus = 'WorkflowStatus',
    WorkflowStatusSet = 'WorkflowStatusSet',
    WorkplaceAccident = 'workplaceAccident',
}

export enum AppMetaDataLookups {
    AccessControlAllItems = 2810,
    // duplicate lookup meaning found - these should be unique
    AccessControlAllItems_2846 = 2846,
    AccidentAllItems = 1395,
    ActiveJobNumberForKickoff = 2934,
    ActiveWachterCompanies = 2880,
    AllAvStarRatingPms = 2987,
    AllIssueSubtypes = 2904,
    AllIssueTypes = 2903,
    AttachmentAllItems = 1477,
    AttachmentConversionAllItems = 2856,
    AttachmentConversionPermitAllItems = 2859,
    AttachmentConversionPermitMediaAllItems = 2860,
    AttachmentFileAllItems = 1400,
    // duplicate lookup meaning found - these should be unique
    AttachmentFileAllItems_1712 = 1712,
    AttachmentFileVersionAllItems = 1713,
    AttachmentFolderAllItems = 1635,
    // duplicate lookup meaning found - these should be unique
    AttachmentFolderAllItems_1710 = 1710,
    AttachmentObjectAllItems = 1711,
    AuctionAllItems = 2939,
    AuditIssueAllItems = 2886,
    AuditIssueRatingAllItems = 2885,
    AuditIssueRiskTypeAllItems = 2887,
    AuditIssueStatusAllItems = 2888,
    BidHistoryAllItems = 2942,
    BillingAllItems = 2910,
    BillingDepartmentAllItems = 2924,
    ChangeRequestAllItems = 2902,
    ChecklistAllItems = 2917,
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueCompanyLicenseStatus = 2877,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueEquipmentRequestJobContext = 2995,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueFleetAuctionStatus = 2954,
    CodeValueFleetAuctionStatusActive = 2964,
    CodeValueFleetAuctionStatusCompleted = 2965,
    CodeValueFleetAuctionStatusNotStarted = 2963,
    CodeValueFleetDriveTrain = 2947,
    CodeValueFleetFuelType = 2948,
    CodeValueFleetOwnershipType = 2945,
    CodeValueFleetVehicleCondition = 2949,
    CodeValueFleetVehicleStatus = 2944,
    CodeValueFleetVehicleType = 2946,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitCableType = 1799,
    CodeValuePermitRequestAddAction = 2865,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestType = 1798,
    CodeValuePermitStatus = 1801,
    CodeValueTypesOfElectrical = 1847,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueEthosJobNumberType = 2868,
    CodeValueEthosSkill = 2840,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueJobType = 2821,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorkersCompClaimStatus = 2862,
    CodeValueWorksiteType = 1647,
    CollaborationAllItems = 1380,
    CollaborationDepartmentAllItems = 1379,
    CollaborationPmAllItems = 1376,
    CompanyAllItems = 1358,
    CompanyLicenseTypeSorted = 2901,
    CompanyLicenseAllItems = 2875,
    CompanyLicenseTypeAllItems = 2876,
    CountyLookup = 1809,
    CovidConfigurationAllItems = 1674,
    CovidTestResultTypeAllItems = 1663,
    CovidTestStatusAllItems = 1664,
    CovidTestTypeAllItems = 1670,
    CovidVaccinationStatusAllItems = 1665,
    CovidVaccinationSubmissionStatusAllItems = 1673,
    CovidVaccineTypeAllItems = 1666,
    CovidWorkStatusAllItems = 1667,
    CustomAttributeValueAllItems = 1490,
    CustomerSatisfactionAllItems = 1370,
    DepartmentAdditionalBurdenAllItems = 1551,
    DepartmentMapAllItems = 2968,
    DepartmentRoleAllItems = 1482,
    DWOSGFinDataAllItems = 1553,
    DWOSGFinDataLatestAllItems = 1554,
    DWPeoplePaySummaryAllItems = 1791,
    DWPersonMergeLogAllItems = 2976,
    DWTrustForecastDataAllItems = 1610,
    DWWorkInProcessAllItems = 1611,
    EmaulationUserAllItems = 1644,
    EmployeeReviewQuestionApprovedQuestions = 1767,
    EmployeeReminderNotificationAllItems = 1686,
    EmployeeReviewAllItems = 1741,
    EmployeeReviewAnswerAllItems = 1748,
    EmployeeReviewAnswerValueAllItems = 1745,
    EmployeeReviewCategoryAllItems = 1746,
    EmployeeReviewQuestionAllItems = 1747,
    EmployeeReviewQuestionRequestAllItems = 1762,
    EmployeeReviewQuestionRequestDetailAllItems = 1763,
    EmployeeReviewQuestionRequestStatusAllItems = 1761,
    EmployeeReviewQuestionSetupAllItems = 1765,
    EmployeeReviewQuestionSetupDetailAllItems = 1766,
    EmployeeReviewQuestionSetupLevelAllItems = 1764,
    EmployeeReviewQuestionSkillAllItems = 1760,
    EmployeeReviewQuestionTypeAllItems = 1749,
    EmployeeReviewStatusAllItems = 1740,
    EmployeeReviewSummaryAllItems = 1744,
    EmployeeReviewSummaryStatusAllItems = 1743,
    EmployeeReviewSummaryTypeAllItems = 1742,
    EmployeesByDeptIncTrainees = 2812,
    EmployeeServiceDatesAllItems = 1625,
    EmployeeSummaryAllItems = 1668,
    EmployeeSummaryChangeTypeAllItems = 1675,
    EmployeeSummaryHistoryAllItems = 1676,
    EmployeeTestAllItems = 1669,
    EmployeeTrainingNeededAllItems = 1524,
    EmployeeVaccinationSubmissionAllItems = 1672,
    EquipmentAllItems = 1360,
    EquipmentRequestContextByJobNumber = 2997,
    EquipmentRequestContextByPO = 2999,
    EquipmentRequestContextByWJID = 2998,
    EquipmentCompanyAllItems = 1359,
    EscalationAllItems = 2914,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosAddressAllItems = 1721,
    EthosCodeSetAllItems = 1630,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    EthosCountryAllItems = 1769,
    EthosCountyAllItems = 1810,
    EthosCustomerAllItems = 1523,
    EthosJobActiveOnly = 2841,
    EthosJobAllItems = 1716,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberEJNPJNFJN = 2869,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberMembershipAllItems = 2867,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobNumberPriorityAllItems = 2866,
    EthosJobSiteAllItems = 1717,
    EthosJobSowAllItems = 1718,
    EthosLaborMetricsAllItems = 1688,
    EthosOpportunityAllItems = 1793,
    EthosServiceUserAllItems = 1774,
    EthosSiteAllItems = 1719,
    EthosSowAllItems = 1720,
    EthosStaffingAgencyAllItems = 1522,
    EthosStateProvinceAllItems = 1366,
    EthosStateProvinceAllItemsShortName = 2953,
    EthosStateProvinceByCountry = 1771,
    EthosSubcontractorBranchAllItems = 1436,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserNSPUsers = 2981,
    EthosUserEmployeeGroups = 2858,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentByDivision = 2991,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterDepartmentAllItemsSimple = 2994,
    EthosWachterDivisionAllItems = 2980,
    EthosWachterJobTitleAllItems = 1387,
    EthosWachterTeamDivisionDepartment = 1496,
    EthosWachterTeamNSPLBU = 1709,
    EthosWachterTeamAllItems = 1415,
    EthosWachterTeamAllItemsWithDivision = 1860,
    EthosWorkflowStatusUserStatus = 1640,
    EthosWorkflowStatusAllItems = 1633,
    EthosWorkflowStatusSetAllItems = 1632,
    EthosRoleMapAllItems = 2830,
    EthosUserDetailAllItems = 1736,
    EthosUserRoleAllItems = 1737,
    FieldEmployeesPayRateAllItems = 1555,
    FieldRatingOfficeAllItems = 1843,
    FiveStarRatingAllItems = 1612,
    FleetAuctionStatusWorkflow = 2979,
    FleetMaintenanceDriver = 2966,
    FleetMaintenancePlate = 2975,
    FleetVehicleActiveUnitsOnly = 2957,
    FleetVehicleDriver = 2951,
    FleetVehicleDriverAlert = 2989,
    FleetVehicleFuelCard = 2988,
    FleetVehiclePlate = 2973,
    FleetVehiclePlateExpiration = 2974,
    FleetVehicleUnitID = 2950,
    FleetVehicleUnitsAll = 2967,
    FleetVehicleVIN = 2972,
    FleetVehicleYears = 2952,
    InspectionAllItems = 1862,
    // duplicate lookup meaning found - these should be unique
    InspectionAllItems_2848 = 2848,
    InspectionStatusV2 = 2855,
    InspectionResultAllItems = 2850,
    InspectionStatusAllItems = 2851,
    IssueIssueSubTypeALL = 1526,
    IssueSubtypesByIssueType = 2992,
    IssueSubtypeAllItems = 1516,
    IssueSubtypeAllItemsSimple = 2993,
    IssueSubtypeSeverityAllItems = 1521,
    IssueTypeAllItems = 1508,
    JobByOpportunityId = 1794,
    JobLookupWithJobNumber = 1729,
    JobSiteSiteInfo = 1788,
    JobNumberActive = 1872,
    JobNumberToCustJobName = 2870,
    JobSowScopeOfWorkAndSiteInfo = 1725,
    KickoffAllItems = 1495,
    // duplicate lookup meaning found - these should be unique
    KickoffAllItems_2918 = 2918,
    KickoffChecklistAllItems = 2915,
    LicensesAllItems = 1462,
    LicenseTypeAllItems = 1463,
    MaintenanceAllItems = 2937,
    MaintenanceServiceAllItems = 2958,
    MedicalRecordAllItems = 2932,
    MemoOfRecordAllItems = 1509,
    MemoOfRecordNotificationGroupAllItems = 1519,
    MessageAllItems = 1844,
    MilestoneAllItems = 1492,
    MilestoneCheckpointAllItems = 1491,
    NoAuctionFleetVehicles = 2990,
    NoteAllItems = 1505,
    // duplicate lookup meaning found - these should be unique
    NoteAllItems_1530 = 1530,
    // duplicate lookup meaning found - these should be unique
    NoteAllItems_1639 = 1639,
    // duplicate lookup meaning found - these should be unique
    NoteAllItems_1694 = 1694,
    // duplicate lookup meaning found - these should be unique
    NoteAllItems_1804 = 1804,
    NoteParentAllItems = 1805,
    NoteTypeAllItems = 1839,
    NotificationConfigAllItems = 2978,
    NotificationGroupAllItems = 1408,
    NSPInstallTechs = 2983,
    NSPInstallTechsTechOnly = 2984,
    OpportunityByCustomer = 2921,
    OrganizationalEntityAllItems = 2815,
    OrganizationalMembershipAllItems = 2816,
    OrganizationalTypeAllItems = 2814,
    OrganizationalUnitAllItems = 1778,
    OverheadJobNumbers = 1589,
    OverheadJobNumbersActive = 2962,
    OverheadProjectionAllItems = 1547,
    OverheadTeamPhaseAllItems = 1548,
    PafHistoryAllItems = 2941,
    PassHistoryAllItems = 2938,
    PayJobChangeAllItems = 1478,
    PayJobChangeEmailAllItems = 1484,
    PayJobChangeUsersReadAllItems = 1483,
    PayJobChangeWorkflowEmailAllItems = 2819,
    PeoplePayHistoryCurrentPreviousInitialAllItems = 1641,
    PeoplePayHistoryCurrentPreviousInitialV2AllItems = 1732,
    PerformanceMetricsAllItems = 1649,
    PermitAllItems = 1714,
    PermitJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    PermitStatusV2 = 2854,
    PermitV2AllItems = 2842,
    PermitPermitTypeAllItems = 1776,
    // duplicate lookup meaning found - these should be unique
    PermitPermitTypeAllItems_2843 = 2843,
    PermitRequestAllItems = 1671,
    PermitRequestPermitAllItems = 1806,
    PermitRequestPermitTypeAllItems = 1864,
    PermitStatusAllItems = 1859,
    // duplicate lookup meaning found - these should be unique
    PermitStatusAllItems_2849 = 2849,
    Permitv2JobTypeLookupNoJobNumber = 2845,
    PlateHistoryAllItems = 2940,
    PlenumRiseOutdoor = 1796,
    PolicyTypeAllItems = 1756,
    ProjectKickoffBillingFrequency = 2923,
    ProjectKickoffBillingType = 2922,
    ProjectKickoffJobNumberFromOpportunity = 2931,
    ProjectKickoffOpportunityWCustomer = 2927,
    ProjectKickoffChecklist = 2929,
    ProjectKickoffCustomers = 2920,
    ProjectManagementTeams = 2961,
    ProjectMilestoneAllItems = 2909,
    ProofOfInsuranceAllItems = 1755,
    ProofOfInsuranceJobTitlesAllItems = 1800,
    ProofOfInsuranceStatusAllItems = 1757,
    ProofOfInsuranceSummaryAllItems = 1775,
    ProofOfInsuranceSummaryStatusAllItems = 1790,
    RatingAllItems = 1840,
    RatingQuestionAllItems = 1842,
    RatingTypeAllItems = 1841,
    ReportingAllItems = 2912,
    RequestAllItems = 1356,
    // duplicate lookup meaning found - these should be unique
    RequestAllItems_1591 = 1591,
    RequestEquipmentAllItems = 1361,
    RequestPreferencesAllItems = 1593,
    RequiredCableAllItems = 1870,
    // duplicate lookup meaning found - these should be unique
    RequiredCableAllItems_2847 = 2847,
    ResourceCostAllItems = 1581,
    ReviewAllItems = 1443,
    RoEthosUserBurdonAllItems = 1550,
    RoAccidentAllItems = 1444,
    RoActiveChangeRequestAllItems = 2970,
    RoActiveSubordinatesAllItems = 2827,
    RoAllSupervisorsSubordinatesAllItems = 1609,
    RoAllSupervisorsSubordinatesOriginalAllItems = 1754,
    RoAttachmentFileNamesCombinedAllItems = 1594,
    RoAuctionAllItems = 2955,
    RoAuditSupervisorAccessAllItems = 2890,
    RoAvStarRatingNspTechAllItems = 2982,
    RoCollaborationAllItems = 1445,
    RoCustomerSatisfactionAllItems = 1446,
    RoEmployeeDetailAllItems = 1585,
    RoEmployeeDetailFullAllItems = 1584,
    RoEmployeeReviewSummaryCurrentAllItems = 1789,
    RoEmsPBiAllItems = 1637,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserAddSubTempAllItems = 1410,
    RoEthosUserGridAllItems = 1628,
    RoEthosUserOriginalAllItems = 1753,
    RoEthosTeamsAndOrganizationalUnitsAllItems = 1390,
    RoFiscalYearRangeAllItems = 1708,
    RoInspectionsAllItems = 1868,
    // duplicate lookup meaning found - these should be unique
    RoInspectionsAllItems_2852 = 2852,
    RoIssueTypeSubtypeSeverityAllItems = 1527,
    RoKickoffAllItems = 1627,
    RoLastAccidentSummaryAllItems = 2861,
    RoLicenseCountPerUserAllItems = 1645,
    RoLicensesAllItems = 1626,
    RoMaintenanceAllItems = 2956,
    RoMilestoneAndMilestoneCheckpointAllItems = 1494,
    RoNspCommittedByDepartmentAllItems = 1579,
    RoNspCommittedByProjectManagerAllItems = 1560,
    RoNspCommittedByTeamAllItems = 1577,
    RoNspCommittedByUnitAllItems = 1578,
    RoNspDwFinancialsByDepartmentByYearAllItems = 1570,
    RoNspDwFinancialsByProjectManagerByYearAllItems = 1567,
    RoNspDwFinancialsByTeamByYearAllItems = 1568,
    RoNspDwFinancialsByUnitByYearAllItems = 1569,
    RoNspDwOverheadByDepartmentByYearAllItems = 1557,
    RoNspDwOverheadByTeamByYearAllItems = 1566,
    RoNSPFinancialNumbersAllItems = 1565,
    RoNspFinancialNumbersByTeamByYearAllItems = 1574,
    RoNspFinancialNumbersByTeamByYearOLDAllItems = 1779,
    RoNSPFinancialNumbersByYearAllItems = 1571,
    RoNspOverheadProjectedByDepartmentByYearAllItems = 1572,
    RoNspOverheadProjectedByTeamByYearAllItems = 1580,
    RoNspProjectedByDepartmentAllItems = 1576,
    RoNspProjectedByProjectManagerAllItems = 1559,
    RoNspProjectedByTeamAllItems = 1573,
    RoNspProjectedByUnitAllItems = 1575,
    RoOrganizationalTeamUnitDeptAllItems = 1563,
    RoOverheadCommittedByJobPhaseYearAllItems = 1564,
    RoOverheadProjectedByJobPhaseYearAllItems = 1562,
    RoOverheadProjectionByTeamAllItems = 1561,
    RoPafAccessAllItems = 2857,
    RoPayJobChangeSubordinatesAllItems = 1770,
    RoPermitRequestLastNoteAllItems = 1861,
    RoPermitRequestsAllItems = 1808,
    RoPermitsAllItems = 1807,
    // duplicate lookup meaning found - these should be unique
    RoPermitsAllItems_2844 = 2844,
    RoPermitsBySubordinatesAllItems = 2863,
    RoPositionHistoryAllItems = 1643,
    RoProjectKickoffAllItems = 2935,
    RoProjectManagersTeamUnitDeptAllItems = 1558,
    RoRequestAllItems = 1600,
    RoRequestContextAllItems = 2996,
    RoStarRatingAvProjectsAllItems = 2985,
    RoStarRatingAvProjectsPmsAllItems = 2986,
    RoStarRatingNotificationTargetsAllItems = 1857,
    RoTerritoryStateProvinceAllItems = 1375,
    RoUserProjectionAllItems = 1533,
    // duplicate lookup meaning found - these should be unique
    RoUserProjectionAllItems_1590 = 1590,
    RoUserProjectionAnalyzedAllItems = 2971,
    RoUserSkillListAllItems = 2838,
    RoVehicleAllItems = 2943,
    RoVehicleAccidentsAllItems = 1552,
    RoVehicleYearsAllItems = 2907,
    RoWorkersCompAllItems = 2933,
    RoWorkplaceAccidentAllItems = 1730,
    RoWorkplaceAccidentNotesAllItems = 2906,
    RoYearRangeAllItems = 1556,
    ServiceTypesAllAlphabetical = 2960,
    ServiceTypeAllItems = 2959,
    StageAuditLogAllItems = 2864,
    StakeholderAllItems = 2913,
    StarRatingAvProjectsAllItems = 2969,
    StarRatingNotificationAllItems = 1856,
    StarRatingNotificationTypeAllItems = 1855,
    TeamAssignmentAllItems = 2911,
    TeamYearNumbersAllItems = 1698,
    TemplateActiveItems = 1357,
    TermResignAllItems = 1479,
    TerritoryAllItems = 1372,
    TerritoryStateProvinceAllItems = 1371,
    TimerAllItems = 2833,
    TimerSkillMapAllItems = 2839,
    TimerStatusAllItems = 2835,
    TimerStatusWithSort = 2836,
    TimerTypeAllItems = 2834,
    TmpRoAllSupervisorsSubordinatesAllItems = 2817,
    TravelerAllItems = 1592,
    TrustCodeSetAllItems = 1394,
    TrustCodeValueAllItems = 1388,
    TrustRoles = 2828,
    TrustSyncLogAllItems = 2818,
    TrustUserMergedAllItems = 1651,
    UserBurden = 2871,
    UserExtendedAllItems = 1364,
    // duplicate lookup meaning found - these should be unique
    UserExtendedAllItems_1583 = 1583,
    // duplicate lookup meaning found - these should be unique
    UserExtendedAllItems_1613 = 1613,
    UserExtendedEthosCustomerAllItems = 1642,
    UserProjectionAllItems = 1546,
    UserReadAllItems = 1520,
    // duplicate lookup meaning found - these should be unique
    UserReadAllItems_1531 = 1531,
    UserTeamLookupAllItems = 1699,
    UserYearNumbersAllItems = 1695,
    VehicleAllItems = 1540,
    // duplicate lookup meaning found - these should be unique
    VehicleAllItems_2936 = 2936,
    VehicleYears = 2908,
    VehicleAccidentAllItems = 1538,
    VehicleTypeAllItems = 1772,
    WachterDivisionByShortName = 2879,
    WachterDivisions = 1858,
    WachterContainerStyleAllItems = 1752,
    WachterTeamByDepartment = 1768,
    WachterTeamDepartmentAllItems = 1497,
    WachterTeamOrganizationalUnitAllItems = 1691,
    WageExpenseAllItems = 2905,
    WAppsRoles = 2829,
    WitnessAllItems = 1539,
    WJIDByJobNumber = 1871,
    WorkflowStatusJobNumberStatus = 1751,
    WorkflowStatusOpportunityStatus = 2925,
    WorkflowStatusPermitStatusDONOTUSE = 1728,
    WorkflowStatusProjectStatus = 2926,
    WorkflowStatusUserStatus = 2823,
    WorkflowStatusAllItems = 1636,
    WorkflowStatusSetAllItems = 1634,
    WorkplaceAccidentAllItems = 1646,
}

@Injectable({
    providedIn: 'root'
})
export class AppMetaDataService {

    AccessControl : AccessControlMetaData = new AccessControlMetaData();
    Permits2AccessControl : Permits2AccessControlMetaData = new Permits2AccessControlMetaData();
    Accident : AccidentMetaData = new AccidentMetaData();
    Attachment : AttachmentMetaData = new AttachmentMetaData();
    AttachmentConversion : AttachmentConversionMetaData = new AttachmentConversionMetaData();
    AttachmentConversionPermit : AttachmentConversionPermitMetaData = new AttachmentConversionPermitMetaData();
    AttachmentConversionPermitMedia : AttachmentConversionPermitMediaMetaData = new AttachmentConversionPermitMediaMetaData();
    AttachmentFile : AttachmentFileMetaData = new AttachmentFileMetaData();
    AttachmentAttachmentFile : AttachmentAttachmentFileMetaData = new AttachmentAttachmentFileMetaData();
    AttachmentFileVersion : AttachmentFileVersionMetaData = new AttachmentFileVersionMetaData();
    AttachmentFolder : AttachmentFolderMetaData = new AttachmentFolderMetaData();
    AttachmentAttachmentFolder : AttachmentAttachmentFolderMetaData = new AttachmentAttachmentFolderMetaData();
    AttachmentObject : AttachmentObjectMetaData = new AttachmentObjectMetaData();
    Auction : AuctionMetaData = new AuctionMetaData();
    AuditIssue : AuditIssueMetaData = new AuditIssueMetaData();
    AuditIssueRating : AuditIssueRatingMetaData = new AuditIssueRatingMetaData();
    AuditIssueRiskType : AuditIssueRiskTypeMetaData = new AuditIssueRiskTypeMetaData();
    AuditIssueStatus : AuditIssueStatusMetaData = new AuditIssueStatusMetaData();
    BidHistory : BidHistoryMetaData = new BidHistoryMetaData();
    Billing : BillingMetaData = new BillingMetaData();
    BillingDepartment : BillingDepartmentMetaData = new BillingDepartmentMetaData();
    ChangeRequest : ChangeRequestMetaData = new ChangeRequestMetaData();
    Checklist : ChecklistMetaData = new ChecklistMetaData();
    CodeSet : CodeSetMetaData = new CodeSetMetaData();
    CodeValue : CodeValueMetaData = new CodeValueMetaData();
    Collaboration : CollaborationMetaData = new CollaborationMetaData();
    CollaborationDepartment : CollaborationDepartmentMetaData = new CollaborationDepartmentMetaData();
    CollaborationPm : CollaborationPmMetaData = new CollaborationPmMetaData();
    Company : CompanyMetaData = new CompanyMetaData();
    CompanyLicense : CompanyLicenseMetaData = new CompanyLicenseMetaData();
    CompanyLicenseType : CompanyLicenseTypeMetaData = new CompanyLicenseTypeMetaData();
    CovidConfiguration : CovidConfigurationMetaData = new CovidConfigurationMetaData();
    CovidTestResultType : CovidTestResultTypeMetaData = new CovidTestResultTypeMetaData();
    CovidTestStatus : CovidTestStatusMetaData = new CovidTestStatusMetaData();
    CovidTestType : CovidTestTypeMetaData = new CovidTestTypeMetaData();
    CovidVaccinationStatus : CovidVaccinationStatusMetaData = new CovidVaccinationStatusMetaData();
    CovidVaccinationSubmissionStatus : CovidVaccinationSubmissionStatusMetaData = new CovidVaccinationSubmissionStatusMetaData();
    CovidVaccineType : CovidVaccineTypeMetaData = new CovidVaccineTypeMetaData();
    CovidWorkStatus : CovidWorkStatusMetaData = new CovidWorkStatusMetaData();
    DevwareCustomAttributeValue : DevwareCustomAttributeValueMetaData = new DevwareCustomAttributeValueMetaData();
    CustomerSatisfaction : CustomerSatisfactionMetaData = new CustomerSatisfactionMetaData();
    DepartmentAdditionalBurden : DepartmentAdditionalBurdenMetaData = new DepartmentAdditionalBurdenMetaData();
    DepartmentMap : DepartmentMapMetaData = new DepartmentMapMetaData();
    DepartmentRole : DepartmentRoleMetaData = new DepartmentRoleMetaData();
    DWOSGFinData : DWOSGFinDataMetaData = new DWOSGFinDataMetaData();
    DWOSGFinDataLatest : DWOSGFinDataLatestMetaData = new DWOSGFinDataLatestMetaData();
    DWPeoplePaySummary : DWPeoplePaySummaryMetaData = new DWPeoplePaySummaryMetaData();
    DWPersonMerge : DWPersonMergeMetaData = new DWPersonMergeMetaData();
    DWPersonMergeLog : DWPersonMergeLogMetaData = new DWPersonMergeLogMetaData();
    DWTrustForecastData : DWTrustForecastDataMetaData = new DWTrustForecastDataMetaData();
    DWWorkInProcess : DWWorkInProcessMetaData = new DWWorkInProcessMetaData();
    EmaulationUser : EmaulationUserMetaData = new EmaulationUserMetaData();
    EmployeeReminderNotification : EmployeeReminderNotificationMetaData = new EmployeeReminderNotificationMetaData();
    EmployeeReview : EmployeeReviewMetaData = new EmployeeReviewMetaData();
    EmployeeReviewAnswer : EmployeeReviewAnswerMetaData = new EmployeeReviewAnswerMetaData();
    EmployeeReviewAnswerValue : EmployeeReviewAnswerValueMetaData = new EmployeeReviewAnswerValueMetaData();
    EmployeeReviewCategory : EmployeeReviewCategoryMetaData = new EmployeeReviewCategoryMetaData();
    EmployeeReviewQuestion : EmployeeReviewQuestionMetaData = new EmployeeReviewQuestionMetaData();
    EmployeeReviewQuestionRequest : EmployeeReviewQuestionRequestMetaData = new EmployeeReviewQuestionRequestMetaData();
    EmployeeReviewQuestionRequestDetail : EmployeeReviewQuestionRequestDetailMetaData = new EmployeeReviewQuestionRequestDetailMetaData();
    EmployeeReviewQuestionRequestStatus : EmployeeReviewQuestionRequestStatusMetaData = new EmployeeReviewQuestionRequestStatusMetaData();
    EmployeeReviewQuestionSetup : EmployeeReviewQuestionSetupMetaData = new EmployeeReviewQuestionSetupMetaData();
    EmployeeReviewQuestionSetupDetail : EmployeeReviewQuestionSetupDetailMetaData = new EmployeeReviewQuestionSetupDetailMetaData();
    EmployeeReviewQuestionSetupLevel : EmployeeReviewQuestionSetupLevelMetaData = new EmployeeReviewQuestionSetupLevelMetaData();
    EmployeeReviewQuestionSkill : EmployeeReviewQuestionSkillMetaData = new EmployeeReviewQuestionSkillMetaData();
    EmployeeReviewQuestionType : EmployeeReviewQuestionTypeMetaData = new EmployeeReviewQuestionTypeMetaData();
    EmployeeReviewStatus : EmployeeReviewStatusMetaData = new EmployeeReviewStatusMetaData();
    EmployeeReviewSummary : EmployeeReviewSummaryMetaData = new EmployeeReviewSummaryMetaData();
    EmployeeReviewSummaryStatus : EmployeeReviewSummaryStatusMetaData = new EmployeeReviewSummaryStatusMetaData();
    EmployeeReviewSummaryType : EmployeeReviewSummaryTypeMetaData = new EmployeeReviewSummaryTypeMetaData();
    EmployeeServiceDates : EmployeeServiceDatesMetaData = new EmployeeServiceDatesMetaData();
    EmployeeSummary : EmployeeSummaryMetaData = new EmployeeSummaryMetaData();
    EmployeeSummaryChangeType : EmployeeSummaryChangeTypeMetaData = new EmployeeSummaryChangeTypeMetaData();
    EmployeeSummaryHistory : EmployeeSummaryHistoryMetaData = new EmployeeSummaryHistoryMetaData();
    EmployeeTest : EmployeeTestMetaData = new EmployeeTestMetaData();
    EmployeeTrainingNeeded : EmployeeTrainingNeededMetaData = new EmployeeTrainingNeededMetaData();
    EmployeeVaccinationSubmission : EmployeeVaccinationSubmissionMetaData = new EmployeeVaccinationSubmissionMetaData();
    Equipment : EquipmentMetaData = new EquipmentMetaData();
    EquipmentCompany : EquipmentCompanyMetaData = new EquipmentCompanyMetaData();
    Escalation : EscalationMetaData = new EscalationMetaData();
    EthosAddress : EthosAddressMetaData = new EthosAddressMetaData();
    EthosCodeSet : EthosCodeSetMetaData = new EthosCodeSetMetaData();
    EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    EthosCountry : EthosCountryMetaData = new EthosCountryMetaData();
    DboEthosCounty : DboEthosCountyMetaData = new DboEthosCountyMetaData();
    EthosCustomer : EthosCustomerMetaData = new EthosCustomerMetaData();
    EthosJob : EthosJobMetaData = new EthosJobMetaData();
    EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    EthosJobSite : EthosJobSiteMetaData = new EthosJobSiteMetaData();
    EthosJobSow : EthosJobSowMetaData = new EthosJobSowMetaData();
    EthosLaborMetrics : EthosLaborMetricsMetaData = new EthosLaborMetricsMetaData();
    EthosOpportunity : EthosOpportunityMetaData = new EthosOpportunityMetaData();
    EthosRoUserLaborSummary : EthosRoUserLaborSummaryMetaData = new EthosRoUserLaborSummaryMetaData();
    EthosServiceUser : EthosServiceUserMetaData = new EthosServiceUserMetaData();
    EthosSite : EthosSiteMetaData = new EthosSiteMetaData();
    EthosSow : EthosSowMetaData = new EthosSowMetaData();
    EthosStaffingAgency : EthosStaffingAgencyMetaData = new EthosStaffingAgencyMetaData();
    EthosStateProvince : EthosStateProvinceMetaData = new EthosStateProvinceMetaData();
    EthosSubcontractorBranch : EthosSubcontractorBranchMetaData = new EthosSubcontractorBranchMetaData();
    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    EthosWachterCompany : EthosWachterCompanyMetaData = new EthosWachterCompanyMetaData();
    EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    EthosWachterDivision : EthosWachterDivisionMetaData = new EthosWachterDivisionMetaData();
    EthosWachterJobTitle : EthosWachterJobTitleMetaData = new EthosWachterJobTitleMetaData();
    EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    EthosWorkflowStatus : EthosWorkflowStatusMetaData = new EthosWorkflowStatusMetaData();
    EthosWorkflowStatusSet : EthosWorkflowStatusSetMetaData = new EthosWorkflowStatusSetMetaData();
    EthosRoleMap : EthosRoleMapMetaData = new EthosRoleMapMetaData();
    EthosRoles : EthosRolesMetaData = new EthosRolesMetaData();
    EthosUserDetail : EthosUserDetailMetaData = new EthosUserDetailMetaData();
    EthosUserRole : EthosUserRoleMetaData = new EthosUserRoleMetaData();
    FieldEmployeesPayRate : FieldEmployeesPayRateMetaData = new FieldEmployeesPayRateMetaData();
    FiveStarRating : FiveStarRatingMetaData = new FiveStarRatingMetaData();
    Inspection : InspectionMetaData = new InspectionMetaData();
    Permits2Inspection : Permits2InspectionMetaData = new Permits2InspectionMetaData();
    InspectionResult : InspectionResultMetaData = new InspectionResultMetaData();
    InspectionStatus : InspectionStatusMetaData = new InspectionStatusMetaData();
    IssueSubtype : IssueSubtypeMetaData = new IssueSubtypeMetaData();
    IssueSubtypeSeverity : IssueSubtypeSeverityMetaData = new IssueSubtypeSeverityMetaData();
    IssueType : IssueTypeMetaData = new IssueTypeMetaData();
    Kickoff : KickoffMetaData = new KickoffMetaData();
    ProjectsKickoff : ProjectsKickoffMetaData = new ProjectsKickoffMetaData();
    KickoffChecklist : KickoffChecklistMetaData = new KickoffChecklistMetaData();
    Licenses : LicensesMetaData = new LicensesMetaData();
    LicenseType : LicenseTypeMetaData = new LicenseTypeMetaData();
    Maintenance : MaintenanceMetaData = new MaintenanceMetaData();
    MaintenanceService : MaintenanceServiceMetaData = new MaintenanceServiceMetaData();
    MedicalRecord : MedicalRecordMetaData = new MedicalRecordMetaData();
    MemoOfRecord : MemoOfRecordMetaData = new MemoOfRecordMetaData();
    MorMemoOfRecordNotificationGroup : MorMemoOfRecordNotificationGroupMetaData = new MorMemoOfRecordNotificationGroupMetaData();
    Message : MessageMetaData = new MessageMetaData();
    Milestone : MilestoneMetaData = new MilestoneMetaData();
    MilestoneCheckpoint : MilestoneCheckpointMetaData = new MilestoneCheckpointMetaData();
    MissingForeignKeys : MissingForeignKeysMetaData = new MissingForeignKeysMetaData();
    Note : NoteMetaData = new NoteMetaData();
    WcNote : WcNoteMetaData = new WcNoteMetaData();
    EmsNote : EmsNoteMetaData = new EmsNoteMetaData();
    NumbersNote : NumbersNoteMetaData = new NumbersNoteMetaData();
    NotesNote : NotesNoteMetaData = new NotesNoteMetaData();
    NotesNoteParent : NotesNoteParentMetaData = new NotesNoteParentMetaData();
    NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    MorNotificationConfig : MorNotificationConfigMetaData = new MorNotificationConfigMetaData();
    WcNotificationGroup : WcNotificationGroupMetaData = new WcNotificationGroupMetaData();
    OrganizationalEntity : OrganizationalEntityMetaData = new OrganizationalEntityMetaData();
    OrganizationalMembership : OrganizationalMembershipMetaData = new OrganizationalMembershipMetaData();
    OrganizationalType : OrganizationalTypeMetaData = new OrganizationalTypeMetaData();
    OrganizationalUnit : OrganizationalUnitMetaData = new OrganizationalUnitMetaData();
    OverheadProjection : OverheadProjectionMetaData = new OverheadProjectionMetaData();
    OverheadTeamPhase : OverheadTeamPhaseMetaData = new OverheadTeamPhaseMetaData();
    PafHistory : PafHistoryMetaData = new PafHistoryMetaData();
    PassHistory : PassHistoryMetaData = new PassHistoryMetaData();
    PayJobChange : PayJobChangeMetaData = new PayJobChangeMetaData();
    PayJobChangeEmail : PayJobChangeEmailMetaData = new PayJobChangeEmailMetaData();
    PayJobChangeUsersRead : PayJobChangeUsersReadMetaData = new PayJobChangeUsersReadMetaData();
    PayJobChangeWorkflowEmail : PayJobChangeWorkflowEmailMetaData = new PayJobChangeWorkflowEmailMetaData();
    PeoplePayHistoryCurrentPreviousInitial : PeoplePayHistoryCurrentPreviousInitialMetaData = new PeoplePayHistoryCurrentPreviousInitialMetaData();
    PeoplePayHistoryCurrentPreviousInitialV2 : PeoplePayHistoryCurrentPreviousInitialV2MetaData = new PeoplePayHistoryCurrentPreviousInitialV2MetaData();
    PerformanceMetrics : PerformanceMetricsMetaData = new PerformanceMetricsMetaData();
    Permit : PermitMetaData = new PermitMetaData();
    Permits2Permit : Permits2PermitMetaData = new Permits2PermitMetaData();
    PermitPermitType : PermitPermitTypeMetaData = new PermitPermitTypeMetaData();
    Permits2PermitPermitType : Permits2PermitPermitTypeMetaData = new Permits2PermitPermitTypeMetaData();
    PermitRequest : PermitRequestMetaData = new PermitRequestMetaData();
    PermitRequestPermit : PermitRequestPermitMetaData = new PermitRequestPermitMetaData();
    PermitRequestPermitType : PermitRequestPermitTypeMetaData = new PermitRequestPermitTypeMetaData();
    PermitStatus : PermitStatusMetaData = new PermitStatusMetaData();
    Permits2PermitStatus : Permits2PermitStatusMetaData = new Permits2PermitStatusMetaData();
    PlateHistory : PlateHistoryMetaData = new PlateHistoryMetaData();
    PolicyType : PolicyTypeMetaData = new PolicyTypeMetaData();
    ProjectMilestone : ProjectMilestoneMetaData = new ProjectMilestoneMetaData();
    ProofOfInsurance : ProofOfInsuranceMetaData = new ProofOfInsuranceMetaData();
    ProofOfInsuranceJobTitles : ProofOfInsuranceJobTitlesMetaData = new ProofOfInsuranceJobTitlesMetaData();
    ProofOfInsuranceStatus : ProofOfInsuranceStatusMetaData = new ProofOfInsuranceStatusMetaData();
    ProofOfInsuranceSummary : ProofOfInsuranceSummaryMetaData = new ProofOfInsuranceSummaryMetaData();
    ProofOfInsuranceSummaryStatus : ProofOfInsuranceSummaryStatusMetaData = new ProofOfInsuranceSummaryStatusMetaData();
    Rating : RatingMetaData = new RatingMetaData();
    RatingQuestion : RatingQuestionMetaData = new RatingQuestionMetaData();
    RatingType : RatingTypeMetaData = new RatingTypeMetaData();
    Reporting : ReportingMetaData = new ReportingMetaData();
    Request : RequestMetaData = new RequestMetaData();
    TravelRequest : TravelRequestMetaData = new TravelRequestMetaData();
    RequestEquipment : RequestEquipmentMetaData = new RequestEquipmentMetaData();
    RequestPreferences : RequestPreferencesMetaData = new RequestPreferencesMetaData();
    RequiredCable : RequiredCableMetaData = new RequiredCableMetaData();
    Permits2RequiredCable : Permits2RequiredCableMetaData = new Permits2RequiredCableMetaData();
    ResourceCost : ResourceCostMetaData = new ResourceCostMetaData();
    Review : ReviewMetaData = new ReviewMetaData();
    RoEthosUserBurdon : RoEthosUserBurdonMetaData = new RoEthosUserBurdonMetaData();
    RoAccident : RoAccidentMetaData = new RoAccidentMetaData();
    RoActiveChangeRequest : RoActiveChangeRequestMetaData = new RoActiveChangeRequestMetaData();
    RoActiveSubordinates : RoActiveSubordinatesMetaData = new RoActiveSubordinatesMetaData();
    RoAllSupervisorsSubordinates : RoAllSupervisorsSubordinatesMetaData = new RoAllSupervisorsSubordinatesMetaData();
    RoAllSupervisorsSubordinatesOptimized : RoAllSupervisorsSubordinatesOptimizedMetaData = new RoAllSupervisorsSubordinatesOptimizedMetaData();
    RoAllSupervisorsSubordinatesOriginal : RoAllSupervisorsSubordinatesOriginalMetaData = new RoAllSupervisorsSubordinatesOriginalMetaData();
    RoAttachmentFileNamesCombined : RoAttachmentFileNamesCombinedMetaData = new RoAttachmentFileNamesCombinedMetaData();
    RoAuction : RoAuctionMetaData = new RoAuctionMetaData();
    RoAuditIssue : RoAuditIssueMetaData = new RoAuditIssueMetaData();
    RoAuditSupervisorAccess : RoAuditSupervisorAccessMetaData = new RoAuditSupervisorAccessMetaData();
    RoAvStarRatingNspTech : RoAvStarRatingNspTechMetaData = new RoAvStarRatingNspTechMetaData();
    RoCollaboration : RoCollaborationMetaData = new RoCollaborationMetaData();
    RoCustomerSatisfaction : RoCustomerSatisfactionMetaData = new RoCustomerSatisfactionMetaData();
    RoEmployeeDetail : RoEmployeeDetailMetaData = new RoEmployeeDetailMetaData();
    RoEmployeeDetailFull : RoEmployeeDetailFullMetaData = new RoEmployeeDetailFullMetaData();
    RoEmployeeReviewSummaryCurrent : RoEmployeeReviewSummaryCurrentMetaData = new RoEmployeeReviewSummaryCurrentMetaData();
    RoEmsPBi : RoEmsPBiMetaData = new RoEmsPBiMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserAddSubTemp : RoEthosUserAddSubTempMetaData = new RoEthosUserAddSubTempMetaData();
    RoEthosUserGrid : RoEthosUserGridMetaData = new RoEthosUserGridMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    RoEthosTeamsAndOrganizationalUnits : RoEthosTeamsAndOrganizationalUnitsMetaData = new RoEthosTeamsAndOrganizationalUnitsMetaData();
    RoFiscalYearRange : RoFiscalYearRangeMetaData = new RoFiscalYearRangeMetaData();
    RoInspections : RoInspectionsMetaData = new RoInspectionsMetaData();
    Permits2RoInspections : Permits2RoInspectionsMetaData = new Permits2RoInspectionsMetaData();
    RoIssueTypeSubtypeSeverity : RoIssueTypeSubtypeSeverityMetaData = new RoIssueTypeSubtypeSeverityMetaData();
    RoKickoff : RoKickoffMetaData = new RoKickoffMetaData();
    RoLastAccidentSummary : RoLastAccidentSummaryMetaData = new RoLastAccidentSummaryMetaData();
    RoLicenseCountPerUser : RoLicenseCountPerUserMetaData = new RoLicenseCountPerUserMetaData();
    RoLicenses : RoLicensesMetaData = new RoLicensesMetaData();
    RoMaintenance : RoMaintenanceMetaData = new RoMaintenanceMetaData();
    RoMilestoneAndMilestoneCheckpoint : RoMilestoneAndMilestoneCheckpointMetaData = new RoMilestoneAndMilestoneCheckpointMetaData();
    RoNspCommittedByDepartment : RoNspCommittedByDepartmentMetaData = new RoNspCommittedByDepartmentMetaData();
    RoNspCommittedByProjectManager : RoNspCommittedByProjectManagerMetaData = new RoNspCommittedByProjectManagerMetaData();
    RoNspCommittedByTeam : RoNspCommittedByTeamMetaData = new RoNspCommittedByTeamMetaData();
    RoNspCommittedByUnit : RoNspCommittedByUnitMetaData = new RoNspCommittedByUnitMetaData();
    RoNspDwFinancialsByDepartmentByYear : RoNspDwFinancialsByDepartmentByYearMetaData = new RoNspDwFinancialsByDepartmentByYearMetaData();
    RoNspDwFinancialsByProjectManagerByYear : RoNspDwFinancialsByProjectManagerByYearMetaData = new RoNspDwFinancialsByProjectManagerByYearMetaData();
    RoNspDwFinancialsByTeamByYear : RoNspDwFinancialsByTeamByYearMetaData = new RoNspDwFinancialsByTeamByYearMetaData();
    RoNspDwFinancialsByUnitByYear : RoNspDwFinancialsByUnitByYearMetaData = new RoNspDwFinancialsByUnitByYearMetaData();
    RoNspDwOverheadByDepartmentByYear : RoNspDwOverheadByDepartmentByYearMetaData = new RoNspDwOverheadByDepartmentByYearMetaData();
    RoNspDwOverheadByTeamByYear : RoNspDwOverheadByTeamByYearMetaData = new RoNspDwOverheadByTeamByYearMetaData();
    RoNSPFinancialNumbers : RoNSPFinancialNumbersMetaData = new RoNSPFinancialNumbersMetaData();
    RoNspFinancialNumbersByTeamByYear : RoNspFinancialNumbersByTeamByYearMetaData = new RoNspFinancialNumbersByTeamByYearMetaData();
    RoNspFinancialNumbersByTeamByYearBackup : RoNspFinancialNumbersByTeamByYearBackupMetaData = new RoNspFinancialNumbersByTeamByYearBackupMetaData();
    RoNspFinancialNumbersByTeamByYearOLD : RoNspFinancialNumbersByTeamByYearOLDMetaData = new RoNspFinancialNumbersByTeamByYearOLDMetaData();
    RoNSPFinancialNumbersByYear : RoNSPFinancialNumbersByYearMetaData = new RoNSPFinancialNumbersByYearMetaData();
    RoNspOverheadProjectedByDepartmentByYear : RoNspOverheadProjectedByDepartmentByYearMetaData = new RoNspOverheadProjectedByDepartmentByYearMetaData();
    RoNspOverheadProjectedByTeamByYear : RoNspOverheadProjectedByTeamByYearMetaData = new RoNspOverheadProjectedByTeamByYearMetaData();
    RoNspProjectedByDepartment : RoNspProjectedByDepartmentMetaData = new RoNspProjectedByDepartmentMetaData();
    RoNspProjectedByProjectManager : RoNspProjectedByProjectManagerMetaData = new RoNspProjectedByProjectManagerMetaData();
    RoNspProjectedByTeam : RoNspProjectedByTeamMetaData = new RoNspProjectedByTeamMetaData();
    RoNspProjectedByUnit : RoNspProjectedByUnitMetaData = new RoNspProjectedByUnitMetaData();
    RoOrganizationalTeamUnitDept : RoOrganizationalTeamUnitDeptMetaData = new RoOrganizationalTeamUnitDeptMetaData();
    RoOverheadCommittedByJobPhaseYear : RoOverheadCommittedByJobPhaseYearMetaData = new RoOverheadCommittedByJobPhaseYearMetaData();
    RoOverheadProjectedByJobPhaseYear : RoOverheadProjectedByJobPhaseYearMetaData = new RoOverheadProjectedByJobPhaseYearMetaData();
    RoOverheadProjectionByTeam : RoOverheadProjectionByTeamMetaData = new RoOverheadProjectionByTeamMetaData();
    RoPafAccess : RoPafAccessMetaData = new RoPafAccessMetaData();
    RoPayJobChangeSubordinates : RoPayJobChangeSubordinatesMetaData = new RoPayJobChangeSubordinatesMetaData();
    RoPermitRequestLastNote : RoPermitRequestLastNoteMetaData = new RoPermitRequestLastNoteMetaData();
    RoPermitRequests : RoPermitRequestsMetaData = new RoPermitRequestsMetaData();
    RoPermits : RoPermitsMetaData = new RoPermitsMetaData();
    Permits2RoPermits : Permits2RoPermitsMetaData = new Permits2RoPermitsMetaData();
    RoPermitsBySubordinates : RoPermitsBySubordinatesMetaData = new RoPermitsBySubordinatesMetaData();
    RoPositionHistory : RoPositionHistoryMetaData = new RoPositionHistoryMetaData();
    RoProjectKickoff : RoProjectKickoffMetaData = new RoProjectKickoffMetaData();
    RoProjectManagersTeamUnitDept : RoProjectManagersTeamUnitDeptMetaData = new RoProjectManagersTeamUnitDeptMetaData();
    RoRequest : RoRequestMetaData = new RoRequestMetaData();
    RoRequestContext : RoRequestContextMetaData = new RoRequestContextMetaData();
    RoStarRatingAvProjects : RoStarRatingAvProjectsMetaData = new RoStarRatingAvProjectsMetaData();
    RoStarRatingAvProjectsPms : RoStarRatingAvProjectsPmsMetaData = new RoStarRatingAvProjectsPmsMetaData();
    RoStarRatingNotificationTargets : RoStarRatingNotificationTargetsMetaData = new RoStarRatingNotificationTargetsMetaData();
    RoTerritoryStateProvince : RoTerritoryStateProvinceMetaData = new RoTerritoryStateProvinceMetaData();
    RoUserProjection : RoUserProjectionMetaData = new RoUserProjectionMetaData();
    NumbersRoUserProjection : NumbersRoUserProjectionMetaData = new NumbersRoUserProjectionMetaData();
    RoUserProjectionAnalyzed : RoUserProjectionAnalyzedMetaData = new RoUserProjectionAnalyzedMetaData();
    RoUserSkillList : RoUserSkillListMetaData = new RoUserSkillListMetaData();
    RoVehicle : RoVehicleMetaData = new RoVehicleMetaData();
    RoVehicleAccidents : RoVehicleAccidentsMetaData = new RoVehicleAccidentsMetaData();
    RoVehicleYears : RoVehicleYearsMetaData = new RoVehicleYearsMetaData();
    RoWorkersComp : RoWorkersCompMetaData = new RoWorkersCompMetaData();
    RoWorkplaceAccident : RoWorkplaceAccidentMetaData = new RoWorkplaceAccidentMetaData();
    RoWorkplaceAccidentNotes : RoWorkplaceAccidentNotesMetaData = new RoWorkplaceAccidentNotesMetaData();
    RoYearRange : RoYearRangeMetaData = new RoYearRangeMetaData();
    ServiceType : ServiceTypeMetaData = new ServiceTypeMetaData();
    StageAuditLog : StageAuditLogMetaData = new StageAuditLogMetaData();
    Stakeholder : StakeholderMetaData = new StakeholderMetaData();
    StarRatingAvProjects : StarRatingAvProjectsMetaData = new StarRatingAvProjectsMetaData();
    StarRatingFieldExperience : StarRatingFieldExperienceMetaData = new StarRatingFieldExperienceMetaData();
    StarRatingNotification : StarRatingNotificationMetaData = new StarRatingNotificationMetaData();
    StarRatingNotificationType : StarRatingNotificationTypeMetaData = new StarRatingNotificationTypeMetaData();
    SuggestedCompositeIndexes : SuggestedCompositeIndexesMetaData = new SuggestedCompositeIndexesMetaData();
    SuggestedForeignKeyIndexes : SuggestedForeignKeyIndexesMetaData = new SuggestedForeignKeyIndexesMetaData();
    TeamAssignment : TeamAssignmentMetaData = new TeamAssignmentMetaData();
    TeamYearNumbers : TeamYearNumbersMetaData = new TeamYearNumbersMetaData();
    Template : TemplateMetaData = new TemplateMetaData();
    TermResign : TermResignMetaData = new TermResignMetaData();
    Territory : TerritoryMetaData = new TerritoryMetaData();
    TerritoryStateProvince : TerritoryStateProvinceMetaData = new TerritoryStateProvinceMetaData();
    Timer : TimerMetaData = new TimerMetaData();
    TimerSkillMap : TimerSkillMapMetaData = new TimerSkillMapMetaData();
    TimerStatus : TimerStatusMetaData = new TimerStatusMetaData();
    TimerType : TimerTypeMetaData = new TimerTypeMetaData();
    TmpRoAllSupervisorsSubordinates : TmpRoAllSupervisorsSubordinatesMetaData = new TmpRoAllSupervisorsSubordinatesMetaData();
    TmpSysdiamgrasBackup20230417 : TmpSysdiamgrasBackup20230417MetaData = new TmpSysdiamgrasBackup20230417MetaData();
    Traveler : TravelerMetaData = new TravelerMetaData();
    TrustSyncLog : TrustSyncLogMetaData = new TrustSyncLogMetaData();
    TrustUserMerged : TrustUserMergedMetaData = new TrustUserMergedMetaData();
    UserExtended : UserExtendedMetaData = new UserExtendedMetaData();
    MtlUserExtended : MtlUserExtendedMetaData = new MtlUserExtendedMetaData();
    EmsUserExtended : EmsUserExtendedMetaData = new EmsUserExtendedMetaData();
    UserExtendedEthosCustomer : UserExtendedEthosCustomerMetaData = new UserExtendedEthosCustomerMetaData();
    WcUserProjection : WcUserProjectionMetaData = new WcUserProjectionMetaData();
    UserRead : UserReadMetaData = new UserReadMetaData();
    WcUserRead : WcUserReadMetaData = new WcUserReadMetaData();
    UserTeamLookup : UserTeamLookupMetaData = new UserTeamLookupMetaData();
    UserYearNumbers : UserYearNumbersMetaData = new UserYearNumbersMetaData();
    Vehicle : VehicleMetaData = new VehicleMetaData();
    FleetVehicle : FleetVehicleMetaData = new FleetVehicleMetaData();
    VehicleAccident : VehicleAccidentMetaData = new VehicleAccidentMetaData();
    VehicleType : VehicleTypeMetaData = new VehicleTypeMetaData();
    WachterContainerStyle : WachterContainerStyleMetaData = new WachterContainerStyleMetaData();
    WachterTeamDepartment : WachterTeamDepartmentMetaData = new WachterTeamDepartmentMetaData();
    WachterTeamOrganizationalUnit : WachterTeamOrganizationalUnitMetaData = new WachterTeamOrganizationalUnitMetaData();
    WageExpense : WageExpenseMetaData = new WageExpenseMetaData();
    WAppsRoles : WAppsRolesMetaData = new WAppsRolesMetaData();
    Witness : WitnessMetaData = new WitnessMetaData();
    WorkflowStatus : WorkflowStatusMetaData = new WorkflowStatusMetaData();
    WorkflowStatusSet : WorkflowStatusSetMetaData = new WorkflowStatusSetMetaData();
    WorkplaceAccident : WorkplaceAccidentMetaData = new WorkplaceAccidentMetaData();
}

// Generated Classes for MetaData service
export class AccessControlMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AccessControl.';

    constructor() {
        this.ItemDetail.ItemId=2751;
        this.ItemDetail.ItemName='AccessControl';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccessControlId : string = this.i + 'AccessControlId';
    AccessControlCv : string = this.i + 'AccessControlCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
            /** Relation: Trust Code Value - Access Control Cv */
            CodeValueByAccessControlCv : {
                RelationName: 'CodeValue|AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvCodeValue',
                PropertyName: 'AccessControlCvCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|AccessControl|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|AccessControl|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class Permits2AccessControlMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_AccessControl.';

    constructor() {
        this.ItemDetail.ItemId=2780;
        this.ItemDetail.ItemName='permits2_AccessControl';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccessControlId : string = this.i + 'AccessControlId';
    AccessControlCv : string = this.i + 'AccessControlCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
            /** Relation: Trust Code Value - Access Control Cv */
            CodeValueByAccessControlCv : {
                RelationName: 'CodeValue|permits2_AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvCodeValue',
                PropertyName: 'AccessControlCvCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_AccessControl|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class AccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Accident.';

    constructor() {
        this.ItemDetail.ItemId=2392;
        this.ItemDetail.ItemName='Accident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccidentId : string = this.i + 'AccidentId';
    TypeCv : string = this.i + 'TypeCv';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    IsAtFault : string = this.i + 'IsAtFault';
    IsWachterInjury : string = this.i + 'IsWachterInjury';
    IsOtherInjury : string = this.i + 'IsOtherInjury';
    IsHospitalVisit : string = this.i + 'IsHospitalVisit';
    IsDoctorVisit : string = this.i + 'IsDoctorVisit';
    IsFirstAidOnly : string = this.i + 'IsFirstAidOnly';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDetail : string = this.i + 'InjuryDetail';
    DamageDetail : string = this.i + 'DamageDetail';
    IsDeleted : string = this.i + 'IsDeleted';
    StateProvinceId : string = this.i + 'StateProvinceId';
    WJID : string = this.i + 'WJID';
    HasPriorAccidents : string = this.i + 'HasPriorAccidents';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    RepairEstimate : string = this.i + 'RepairEstimate';
    City : string = this.i + 'City';
    Address : string = this.i + 'Address';
    OtherPartiesInjured : string = this.i + 'OtherPartiesInjured';
    MedicalNeeded : string = this.i + 'MedicalNeeded';
    AccidentCalledIntoHotline : string = this.i + 'AccidentCalledIntoHotline';
    Customer : string = this.i + 'Customer';
    JobNumber : string = this.i + 'JobNumber';
    Site : string = this.i + 'Site';
    JobsWorkedNote : string = this.i + 'JobsWorkedNote';
    ActionLeadingToAccident : string = this.i + 'ActionLeadingToAccident';
    HoursWorkedDescription : string = this.i + 'HoursWorkedDescription';
    RestOnAccidentDate : string = this.i + 'RestOnAccidentDate';
    WorkRestDayBefore : string = this.i + 'WorkRestDayBefore';
    WorkRestTwoDaysBefore : string = this.i + 'WorkRestTwoDaysBefore';
    PriorAccidentList : string = this.i + 'PriorAccidentList';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Trust Code Value - Type */
            CodeValueByTypeCv : {
                RelationName: 'CodeValue|Accident|TypeCv',
                FieldPrefix: 'TypeCvCodeValue',
                PropertyName: 'TypeCvCodeValue'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|Accident|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Accident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Accident|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|Accident|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
    };
}

export class AttachmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Attachment.';

    constructor() {
        this.ItemDetail.ItemId=2468;
        this.ItemDetail.ItemName='Attachment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentId : string = this.i + 'AttachmentId';
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    Id : string = this.i + 'Id';

    Relations = {
            /** Relation: Attachment - Attachment Id - One */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|Attachment|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Attachment File */
            AttachmentFile : {
                RelationName: 'AttachmentFile|Attachment|AttachmentFileId',
                FieldPrefix: 'AttachmentFile',
                PropertyName: 'AttachmentFile'
            },
            /** Relation: Attachment Folder - Many */
            AttachmentFolderByAttachmentId : {
                RelationName: 'Attachment|AttachmentFolder|AttachmentId',
                FieldPrefix: 'AttachmentAttachmentFolder',
                PropertyName: 'AttachmentAttachmentFolder'
            },
            /** Relation: Employee Training Needed - Many */
            EmployeeTrainingNeededByAttachmentId : {
                RelationName: 'Attachment|EmployeeTrainingNeeded|AttachmentId',
                FieldPrefix: 'AttachmentEmployeeTrainingNeeded',
                PropertyName: 'AttachmentEmployeeTrainingNeeded'
            },
            /** Relation: Licenses - Attachment Id - Many */
            LicensesByAttachmentFileId : {
                RelationName: 'AttachmentFile_Licenses_LicenseId',
                FieldPrefix: 'AttachmentFileIdLicenses',
                PropertyName: 'AttachmentFileIdLicenses'
            },
            /** Relation: Licenses - Attachment Id - Many */
            LicensesByLicenseId : {
                RelationName: 'Attachment|Licenses|LicenseId',
                FieldPrefix: 'LicenseIdLicenses',
                PropertyName: 'LicenseIdLicenses'
            },
            /** Relation: Memo Of Record - Many */
            MemoOfRecordByAttachmentId : {
                RelationName: 'Attachment|MemoOfRecord|AttachmentId',
                FieldPrefix: 'AttachmentMemoOfRecord',
                PropertyName: 'AttachmentMemoOfRecord'
            },
            /** Relation: Memo Of Record - Signed Documents - Many */
            MemoOfRecordBySignedDocumentsAttachmentId : {
                RelationName: 'Attachment|MemoOfRecord|SignedDocumentsAttachmentId',
                FieldPrefix: 'SignedDocumentsAttachmentMemoOfRecord',
                PropertyName: 'SignedDocumentsAttachmentMemoOfRecord'
            },
            /** Relation: Permit - Many */
            PermitByAttachmentId : {
                RelationName: 'Attachment|Permit|AttachmentId',
                FieldPrefix: 'AttachmentPermit',
                PropertyName: 'AttachmentPermit'
            },
            /** Relation: Permit Request - Many */
            PermitRequestByAttachmentId : {
                RelationName: 'Attachment|permitRequest|AttachmentId',
                FieldPrefix: 'AttachmentPermitRequest',
                PropertyName: 'AttachmentPermitRequest'
            },
            /** Relation: User Extended - Many */
            EmsUserExtendedByAttachmentId : {
                RelationName: 'Attachment|ems_UserExtended|AttachmentId',
                FieldPrefix: 'AttachmentEmsUserExtended',
                PropertyName: 'AttachmentEmsUserExtended'
            },
            /** Relation: User Extended - Sp Osg - Many */
            MtlUserExtendedByspOsgAttachmentId : {
                RelationName: 'Attachment|mtl_UserExtended|spOsgAttachmentId',
                FieldPrefix: 'SpOsgAttachmentMtlUserExtended',
                PropertyName: 'SpOsgAttachmentMtlUserExtended'
            },
            /** Relation: Vehicle Accident - Many */
            VehicleAccidentByAttachmentId : {
                RelationName: 'Attachment|VehicleAccident|AttachmentId',
                FieldPrefix: 'AttachmentVehicleAccident',
                PropertyName: 'AttachmentVehicleAccident'
            },
            /** Relation: Workplace Accident - Many */
            WorkplaceAccidentByAttachmentId : {
                RelationName: 'Attachment|workplaceAccident|AttachmentId',
                FieldPrefix: 'AttachmentWorkplaceAccident',
                PropertyName: 'AttachmentWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Workers Comp - Many */
            WorkplaceAccidentByWorkersCompAttachmentId : {
                RelationName: 'Attachment|workplaceAccident|WorkersCompAttachmentId',
                FieldPrefix: 'WorkersCompAttachmentWorkplaceAccident',
                PropertyName: 'WorkersCompAttachmentWorkplaceAccident'
            },
    };
}

export class AttachmentConversionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentConversion.';

    constructor() {
        this.ItemDetail.ItemId=2787;
        this.ItemDetail.ItemName='AttachmentConversion';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentConversionId : string = this.i + 'AttachmentConversionId';
    AttachmentObjectId : string = this.i + 'AttachmentObjectId';
    AttachmentFolderId : string = this.i + 'AttachmentFolderId';
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    WAppsFullFileName : string = this.i + 'wAppsFullFileName';
    MediaGroupId : string = this.i + 'MediaGroupId';
    MediaId : string = this.i + 'MediaId';
    CapFullFileName : string = this.i + 'CapFullFileName';
    IsFileConverted : string = this.i + 'IsFileConverted';
    SourceRecordUpdated : string = this.i + 'SourceRecordUpdated';
    SourceTable : string = this.i + 'SourceTable';
    SourceKeyValue : string = this.i + 'SourceKeyValue';

    Relations = {
            /** Relation: Attachment File */
            AttachmentAttachmentFile : {
                RelationName: 'attachment_AttachmentFile|AttachmentConversion|AttachmentFileId',
                FieldPrefix: 'AttachmentAttachmentFile',
                PropertyName: 'AttachmentAttachmentFile'
            },
            /** Relation: Attachment Folder */
            AttachmentAttachmentFolder : {
                RelationName: 'attachment_AttachmentFolder|AttachmentConversion|AttachmentFolderId',
                FieldPrefix: 'AttachmentAttachmentFolder',
                PropertyName: 'AttachmentAttachmentFolder'
            },
            /** Relation: Attachment Object */
            AttachmentObject : {
                RelationName: 'AttachmentObject|AttachmentConversion|AttachmentObjectId',
                FieldPrefix: 'AttachmentObject',
                PropertyName: 'AttachmentObject'
            },
    };
}

export class AttachmentConversionPermitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentConversionPermit.';

    constructor() {
        this.ItemDetail.ItemId=2789;
        this.ItemDetail.ItemName='AttachmentConversionPermit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentConversionPermitId : string = this.i + 'AttachmentConversionPermitId';
    PermitsV2Id : string = this.i + 'PermitsV2Id';
    OriginalPermitId : string = this.i + 'OriginalPermitId';
    OriginalPermitRequestId : string = this.i + 'OriginalPermitRequestId';
    PermitMediaGroupId : string = this.i + 'PermitMediaGroupId';
    PermitRequestMediaGroupId : string = this.i + 'PermitRequestMediaGroupId';
    PermitsV2IdMediaGroupId : string = this.i + 'PermitsV2IdMediaGroupId';
    FilesConverted : string = this.i + 'FilesConverted';
    PermitsV2Updated : string = this.i + 'PermitsV2Updated';
    PermitFileCount : string = this.i + 'PermitFileCount';
    PermitRequestFileCount : string = this.i + 'PermitRequestFileCount';

    Relations = {
            /** Relation: Permit - Permits V2 */
            Permits2PermitByPermitsV2Id : {
                RelationName: 'permits2_Permit|AttachmentConversionPermit|PermitsV2Id',
                FieldPrefix: 'PermitsV2IdPermits2Permit',
                PropertyName: 'PermitsV2IdPermits2Permit'
            },
            /** Relation: Attachment Conversion Permit Media */
            AttachmentConversionPermitMedia : {
                RelationName: 'AttachmentConversionPermit|AttachmentConversionPermitMedia|AttachmentConversionPermitId',
                FieldPrefix: 'AttachmentConversionPermitMedia',
                PropertyName: 'AttachmentConversionPermitMedia'
            },
    };
}

export class AttachmentConversionPermitMediaMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentConversionPermitMedia.';

    constructor() {
        this.ItemDetail.ItemId=2790;
        this.ItemDetail.ItemName='AttachmentConversionPermitMedia';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentConversionPermitMediaId : string = this.i + 'AttachmentConversionPermitMediaId';
    AttachmentConversionPermitId : string = this.i + 'AttachmentConversionPermitId';
    SourceMediaId : string = this.i + 'SourceMediaId';
    SourceFullFileName : string = this.i + 'SourceFullFileName';
    DestMediaId : string = this.i + 'DestMediaId';
    DestFullFileName : string = this.i + 'DestFullFileName';
    IsFileConverted : string = this.i + 'IsFileConverted';

    Relations = {
            /** Relation: Attachment Conversion Permit */
            AttachmentConversionPermit : {
                RelationName: 'AttachmentConversionPermit|AttachmentConversionPermitMedia|AttachmentConversionPermitId',
                FieldPrefix: 'AttachmentConversionPermit',
                PropertyName: 'AttachmentConversionPermit'
            },
    };
}

export class AttachmentFileMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentFile.';

    constructor() {
        this.ItemDetail.ItemId=2397;
        this.ItemDetail.ItemName='AttachmentFile';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    CurrentDisplay : string = this.i + 'CurrentDisplay';
    FileExtension : string = this.i + 'FileExtension';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    FileKey : string = this.i + 'FileKey';
    AttachmentFolderId : string = this.i + 'AttachmentFolderId';
    Size : string = this.i + 'Size';
    FileMD5 : string = this.i + 'FileMD5';

    Relations = {
            /** Relation: Memo Of Record - Attachment File Id */
            MemoOfRecordByAttachmentFileId : {
                RelationName: 'AttachmentId',
                FieldPrefix: 'AttachmentFileIdMemoOfRecord',
                PropertyName: 'AttachmentFileIdMemoOfRecord'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|AttachmentFile|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|AttachmentFile|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Attachment */
            Attachment : {
                RelationName: 'AttachmentFile|Attachment|AttachmentFileId',
                FieldPrefix: 'Attachment',
                PropertyName: 'Attachment'
            },
            /** Relation: Attachment File Version */
            AttachmentFileVersion : {
                RelationName: 'AttachmentFile|AttachmentFileVersion|AttachmentFileId',
                FieldPrefix: 'AttachmentFileVersion',
                PropertyName: 'AttachmentFileVersion'
            },
            /** Relation: Licenses */
            Licenses : {
                RelationName: 'AttachmentFile|Licenses|AttachmentFileId',
                FieldPrefix: 'Licenses',
                PropertyName: 'Licenses'
            },
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'AttachmentFile|ProofOfInsurance|AttachmentFileId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

export class AttachmentAttachmentFileMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'attachment_AttachmentFile.';

    constructor() {
        this.ItemDetail.ItemId=2631;
        this.ItemDetail.ItemName='attachment_AttachmentFile';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    AttachmentFolderId : string = this.i + 'AttachmentFolderId';
    CurrentDisplay : string = this.i + 'CurrentDisplay';
    FileExtension : string = this.i + 'FileExtension';
    FileKey : string = this.i + 'FileKey';
    Size : string = this.i + 'Size';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';

    Relations = {
            /** Relation: Attachment Folder */
            AttachmentAttachmentFolder : {
                RelationName: 'attachment_AttachmentFolder|attachment_AttachmentFile|AttachmentFolderId',
                FieldPrefix: 'AttachmentAttachmentFolder',
                PropertyName: 'AttachmentAttachmentFolder'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|attachment_AttachmentFile|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|attachment_AttachmentFile|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Attachment Conversion */
            AttachmentConversion : {
                RelationName: 'attachment_AttachmentFile|AttachmentConversion|AttachmentFileId',
                FieldPrefix: 'AttachmentConversion',
                PropertyName: 'AttachmentConversion'
            },
    };
}

export class AttachmentFileVersionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentFileVersion.';

    constructor() {
        this.ItemDetail.ItemId=2632;
        this.ItemDetail.ItemName='AttachmentFileVersion';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentFileVersion : string = this.i + 'AttachmentFileVersion';
    AttachmentFileId : string = this.i + 'AttachmentFileId';

    Relations = {
            /** Relation: Attachment File */
            AttachmentFile : {
                RelationName: 'AttachmentFile|AttachmentFileVersion|AttachmentFileId',
                FieldPrefix: 'AttachmentFile',
                PropertyName: 'AttachmentFile'
            },
    };
}

export class AttachmentFolderMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentFolder.';

    constructor() {
        this.ItemDetail.ItemId=2583;
        this.ItemDetail.ItemName='AttachmentFolder';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentFolderId : string = this.i + 'AttachmentFolderId';
    AttachmentId : string = this.i + 'AttachmentId';
    FolderName : string = this.i + 'FolderName';
    ParentAttachmentFolderId : string = this.i + 'ParentAttachmentFolderId';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    PermissionNeeded : string = this.i + 'PermissionNeeded';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|AttachmentFolder|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AttachmentFolder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AttachmentFolder|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class AttachmentAttachmentFolderMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'attachment_AttachmentFolder.';

    constructor() {
        this.ItemDetail.ItemId=2629;
        this.ItemDetail.ItemName='attachment_AttachmentFolder';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AttachmentFolderId : string = this.i + 'AttachmentFolderId';
    FolderName : string = this.i + 'FolderName';
    ParentAttachmentFolderId : string = this.i + 'ParentAttachmentFolderId';
    PermissionNeeded : string = this.i + 'PermissionNeeded';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Attachment Folder - Parent Attachment Folder - One */
            AttachmentAttachmentFolderByParentAttachmentFolderId : {
                RelationName: 'attachment_AttachmentFolder|attachment_AttachmentFolder|ParentAttachmentFolderId',
                FieldPrefix: 'ParentAttachmentAttachmentFolder',
                PropertyName: 'ParentAttachmentAttachmentFolder'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|attachment_AttachmentFolder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|attachment_AttachmentFolder|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Attachment Conversion */
            AttachmentConversion : {
                RelationName: 'attachment_AttachmentFolder|AttachmentConversion|AttachmentFolderId',
                FieldPrefix: 'AttachmentConversion',
                PropertyName: 'AttachmentConversion'
            },
            /** Relation: Attachment File */
            AttachmentAttachmentFile : {
                RelationName: 'attachment_AttachmentFolder|attachment_AttachmentFile|AttachmentFolderId',
                FieldPrefix: 'AttachmentAttachmentFile',
                PropertyName: 'AttachmentAttachmentFile'
            },
            /** Relation: Attachment Object - Parent - Many */
            AttachmentObjectByParentAttachmentFolderId : {
                RelationName: 'attachment_AttachmentFolder|AttachmentObject|ParentAttachmentFolderId',
                FieldPrefix: 'ParentAttachmentObject',
                PropertyName: 'ParentAttachmentObject'
            },
            /** Relation: Licenses - Attachment File - Many */
            LicensesByAttachmentFileId : {
                RelationName: 'attachment_AttachmentFolder|Licenses|AttachmentFileId',
                FieldPrefix: 'AttachmentFileIdLicenses',
                PropertyName: 'AttachmentFileIdLicenses'
            },
    };
}

export class AttachmentObjectMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AttachmentObject.';

    constructor() {
        this.ItemDetail.ItemId=2630;
        this.ItemDetail.ItemName='AttachmentObject';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ParentAttachmentFolderId : string = this.i + 'ParentAttachmentFolderId';
    AttachmentObjectId : string = this.i + 'AttachmentObjectId';

    Relations = {
            /** Relation: Attachment Folder - Parent Attachment Folder */
            AttachmentAttachmentFolderByParentAttachmentFolderId : {
                RelationName: 'attachment_AttachmentFolder|AttachmentObject|ParentAttachmentFolderId',
                FieldPrefix: 'ParentAttachmentAttachmentFolder',
                PropertyName: 'ParentAttachmentAttachmentFolder'
            },
            /** Relation: Attachment Conversion */
            AttachmentConversion : {
                RelationName: 'AttachmentObject|AttachmentConversion|AttachmentObjectId',
                FieldPrefix: 'AttachmentConversion',
                PropertyName: 'AttachmentConversion'
            },
    };
}

export class AuctionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Auction.';

    constructor() {
        this.ItemDetail.ItemId=3434;
        this.ItemDetail.ItemName='Auction';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AuctionId : string = this.i + 'AuctionId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointId : string = this.i + 'SharepointId';
    VehicleId : string = this.i + 'VehicleId';
    Color : string = this.i + 'Color';
    Mileage : string = this.i + 'Mileage';
    ConditionCv : string = this.i + 'ConditionCv';
    Duration : string = this.i + 'Duration';
    LegacyUnitId : string = this.i + 'LegacyUnitId';
    Description : string = this.i + 'Description';
    StatusCv : string = this.i + 'StatusCv';
    LocationCity : string = this.i + 'LocationCity';
    LocationStateProvinceId : string = this.i + 'LocationStateProvinceId';
    LocationZip : string = this.i + 'LocationZip';
    StartingPrice : string = this.i + 'StartingPrice';
    StartDateTime : string = this.i + 'StartDateTime';
    FinalPrice : string = this.i + 'FinalPrice';
    NoteParentId : string = this.i + 'NoteParentId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    Title : string = this.i + 'Title';
    EndDateTime : string = this.i + 'EndDateTime';

    Relations = {
            /** Relation: Trust Code Value - Condition */
            CodeValueByConditionCv : {
                RelationName: 'CodeValue|Auction|ConditionCv',
                FieldPrefix: 'ConditionCvCodeValue',
                PropertyName: 'ConditionCvCodeValue'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|Auction|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|Auction|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: State Province - Location State Province */
            EthosStateProvinceByLocationStateProvinceId : {
                RelationName: 'Ethos_StateProvince|Auction|LocationStateProvinceId',
                FieldPrefix: 'LocationEthosStateProvince',
                PropertyName: 'LocationEthosStateProvince'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Auction|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Auction|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'fleet_Vehicle|Auction|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Bid History */
            BidHistory : {
                RelationName: 'Auction|BidHistory|AuctionId',
                FieldPrefix: 'BidHistory',
                PropertyName: 'BidHistory'
            },
            /** Relation: Ro Auction */
            RoAuction : {
                RelationName: 'roAuction|Auction|AuctionId',
                FieldPrefix: 'RoAuction',
                PropertyName: 'RoAuction'
            },
    };
}

export class AuditIssueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AuditIssue.';

    constructor() {
        this.ItemDetail.ItemId=2810;
        this.ItemDetail.ItemName='AuditIssue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueId : string = this.i + 'IssueId';
    AuditName : string = this.i + 'AuditName';
    AuditStartDate : string = this.i + 'AuditStartDate';
    AuditCompleteDate : string = this.i + 'AuditCompleteDate';
    AuditorEthosUserId : string = this.i + 'AuditorEthosUserId';
    Process : string = this.i + 'Process';
    IssueDetail : string = this.i + 'IssueDetail';
    RecommendationDetail : string = this.i + 'RecommendationDetail';
    IssueRatingId : string = this.i + 'IssueRatingId';
    IssueRatingNote : string = this.i + 'IssueRatingNote';
    IssueRiskTypeId : string = this.i + 'IssueRiskTypeId';
    IssueOwnerEthosUserId : string = this.i + 'IssueOwnerEthosUserId';
    ELTManagerEthosUserId : string = this.i + 'ELTManagerEthosUserId';
    OwnerActionPlan : string = this.i + 'OwnerActionPlan';
    ActionPlanDueDate : string = this.i + 'ActionPlanDueDate';
    MediaGroupId : string = this.i + 'MediaGroupId';
    IssueStatusId : string = this.i + 'IssueStatusId';
    RequestUpdate : string = this.i + 'RequestUpdate';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    DelegatedOwnerEthosUserid : string = this.i + 'DelegatedOwnerEthosUserid';
    IssueName : string = this.i + 'IssueName';

    Relations = {
            /** Relation: Audit Issue Rating */
            AuditIssueRating : {
                RelationName: 'AuditIssueRating|AuditIssue|IssueRatingId',
                FieldPrefix: 'AuditIssueRating',
                PropertyName: 'AuditIssueRating'
            },
            /** Relation: Audit Issue Risk Type */
            AuditIssueRiskType : {
                RelationName: 'AuditIssueRiskType|AuditIssue|IssueRiskTypeId',
                FieldPrefix: 'AuditIssueRiskType',
                PropertyName: 'AuditIssueRiskType'
            },
            /** Relation: Audit Issue Status */
            AuditIssueStatus : {
                RelationName: 'AuditIssueStatus|AuditIssue|IssueStatusId',
                FieldPrefix: 'AuditIssueStatus',
                PropertyName: 'AuditIssueStatus'
            },
            /** Relation: Ethos User - Auditor */
            EthosUserByAuditorEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|AuditorEthosUserId',
                FieldPrefix: 'AuditorEthosEthosUser',
                PropertyName: 'AuditorEthosEthosUser'
            },
            /** Relation: Ethos User - Issue Owner */
            EthosUserByIssueOwnerEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|IssueOwnerEthosUserId',
                FieldPrefix: 'IssueOwnerEthosEthosUser',
                PropertyName: 'IssueOwnerEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - ELT */
            EthosUserByELTManagerEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|ELTManagerEthosUserId',
                FieldPrefix: 'ELTManagerEthosEthosUser',
                PropertyName: 'ELTManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Delegated Owner Ethos User */
            EthosUserByDelegatedOwnerEthosUserid : {
                RelationName: 'Ethos_User|AuditIssue|DelegatedOwnerEthosUserid',
                FieldPrefix: 'DelegatedOwnerEthosUseridEthosUser',
                PropertyName: 'DelegatedOwnerEthosUseridEthosUser'
            },
            /** Relation: Ro Audit Supervisor Access */
            RoAuditSupervisorAccess : {
                RelationName: 'roAuditSupervisorAccess|AuditIssue|IssueId',
                FieldPrefix: 'RoAuditSupervisorAccess',
                PropertyName: 'RoAuditSupervisorAccess'
            },
    };
}

export class AuditIssueRatingMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AuditIssueRating.';

    constructor() {
        this.ItemDetail.ItemId=2809;
        this.ItemDetail.ItemName='AuditIssueRating';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueRatingId : string = this.i + 'IssueRatingId';
    IssueRating : string = this.i + 'IssueRating';
    SortOrder : string = this.i + 'SortOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Audit Issue */
            AuditIssue : {
                RelationName: 'AuditIssueRating|AuditIssue|IssueRatingId',
                FieldPrefix: 'AuditIssue',
                PropertyName: 'AuditIssue'
            },
    };
}

export class AuditIssueRiskTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AuditIssueRiskType.';

    constructor() {
        this.ItemDetail.ItemId=2811;
        this.ItemDetail.ItemName='AuditIssueRiskType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueRiskTypeId : string = this.i + 'IssueRiskTypeId';
    IssueRiskType : string = this.i + 'IssueRiskType';
    SortOrder : string = this.i + 'SortOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Audit Issue */
            AuditIssue : {
                RelationName: 'AuditIssueRiskType|AuditIssue|IssueRiskTypeId',
                FieldPrefix: 'AuditIssue',
                PropertyName: 'AuditIssue'
            },
    };
}

export class AuditIssueStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AuditIssueStatus.';

    constructor() {
        this.ItemDetail.ItemId=2812;
        this.ItemDetail.ItemName='AuditIssueStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueStatusId : string = this.i + 'IssueStatusId';
    IssueStatus : string = this.i + 'IssueStatus';
    SortOrder : string = this.i + 'SortOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Audit Issue */
            AuditIssue : {
                RelationName: 'AuditIssueStatus|AuditIssue|IssueStatusId',
                FieldPrefix: 'AuditIssue',
                PropertyName: 'AuditIssue'
            },
    };
}

export class BidHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'BidHistory.';

    constructor() {
        this.ItemDetail.ItemId=3437;
        this.ItemDetail.ItemName='BidHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    BidHistoryId : string = this.i + 'BidHistoryId';
    AuctionId : string = this.i + 'AuctionId';
    BidderName : string = this.i + 'BidderName';
    Amount : string = this.i + 'Amount';
    Notes : string = this.i + 'Notes';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    AppUserId : string = this.i + 'AppUserId';

    Relations = {
            /** Relation: Auction */
            Auction : {
                RelationName: 'Auction|BidHistory|AuctionId',
                FieldPrefix: 'Auction',
                PropertyName: 'Auction'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|BidHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
    };
}

export class BillingMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Billing.';

    constructor() {
        this.ItemDetail.ItemId=3417;
        this.ItemDetail.ItemName='Billing';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    BillingId : string = this.i + 'BillingId';
    KickoffId : string = this.i + 'KickoffId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    BillingTypeCv : string = this.i + 'BillingTypeCv';
    JobNumberId : string = this.i + 'JobNumberId';
    ParentJobNumberId : string = this.i + 'ParentJobNumberId';
    InvoiceFrequencyCv : string = this.i + 'InvoiceFrequencyCv';
    EstimatedBillingDate : string = this.i + 'EstimatedBillingDate';
    Notes : string = this.i + 'Notes';
    HybridKey : string = this.i + 'HybridKey';
    InterdepartmentalBilling : string = this.i + 'InterdepartmentalBilling';

    Relations = {
            /** Relation: Trust Code Value - Billing Type */
            CodeValueByBillingTypeCv : {
                RelationName: 'Ethos_CodeValue|Billing|BillingTypeCv',
                FieldPrefix: 'BillingTypeCvCodeValue',
                PropertyName: 'BillingTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Invoice Frequency */
            CodeValueByInvoiceFrequencyCv : {
                RelationName: 'Ethos_CodeValue|Billing|InvoiceFrequencyCv',
                FieldPrefix: 'InvoiceFrequencyCvCodeValue',
                PropertyName: 'InvoiceFrequencyCvCodeValue'
            },
            /** Relation: Job Number - Parent Job Number */
            EthosJobNumberByParentJobNumberId : {
                RelationName: 'Ethos_JobNumber|Billing|ParentJobNumberId',
                FieldPrefix: 'ParentEthosJobNumber',
                PropertyName: 'ParentEthosJobNumber'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Billing|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|Billing|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Billing|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Billing|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Billing Department */
            BillingDepartment : {
                RelationName: 'Billing|BillingDepartment|BillingId',
                FieldPrefix: 'BillingDepartment',
                PropertyName: 'BillingDepartment'
            },
    };
}

export class BillingDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'BillingDepartment.';

    constructor() {
        this.ItemDetail.ItemId=3427;
        this.ItemDetail.ItemName='BillingDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    BillingDeptId : string = this.i + 'BillingDeptId';
    BillingId : string = this.i + 'BillingId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Billing */
            Billing : {
                RelationName: 'Billing|BillingDepartment|BillingId',
                FieldPrefix: 'Billing',
                PropertyName: 'Billing'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|BillingDepartment|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|BillingDepartment|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|BillingDepartment|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
    };
}

export class ChangeRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ChangeRequest.';

    constructor() {
        this.ItemDetail.ItemId=3411;
        this.ItemDetail.ItemName='ChangeRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ChangeRequestId : string = this.i + 'ChangeRequestId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    NoteId : string = this.i + 'NoteId';
    InProgress : string = this.i + 'InProgress';
    InitialPermitStatusId : string = this.i + 'InitialPermitStatusId';
    CompletedByUserId : string = this.i + 'CompletedByUserId';
    CompletedOnDateTime : string = this.i + 'CompletedOnDateTime';

    Relations = {
            /** Relation: Note */
            NotesNote : {
                RelationName: 'notes_Note|ChangeRequest|NoteId',
                FieldPrefix: 'NotesNote',
                PropertyName: 'NotesNote'
            },
            /** Relation: Permit Status - Initial Permit Status */
            Permits2PermitStatusByInitialPermitStatusId : {
                RelationName: 'permits2_PermitStatus|ChangeRequest|InitialPermitStatusId',
                FieldPrefix: 'InitialPermits2PermitStatus',
                PropertyName: 'InitialPermits2PermitStatus'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Completed By User */
            EthosUserByCompletedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosUser',
                PropertyName: 'CompletedByEthosUser'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'ChangeRequest|permits2_Permit|ChangeRequestId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class ChecklistMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Checklist.';

    constructor() {
        this.ItemDetail.ItemId=3424;
        this.ItemDetail.ItemName='Checklist';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ChecklistId : string = this.i + 'ChecklistId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    Item : string = this.i + 'Item';
    Number : string = this.i + 'Number';

    Relations = {
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Checklist|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Checklist|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Kickoff Checklist */
            KickoffChecklist : {
                RelationName: 'Checklist|KickoffChecklist|ChecklistId',
                FieldPrefix: 'KickoffChecklist',
                PropertyName: 'KickoffChecklist'
            },
    };
}

export class CodeSetMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeSet.';

    constructor() {
        this.ItemDetail.ItemId=2391;
        this.ItemDetail.ItemName='CodeSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeSetId : string = this.i + 'CodeSetId';
    CodeSetName : string = this.i + 'CodeSetName';
    IsCustomCodeSet : string = this.i + 'IsCustomCodeSet';

    Relations = {
            /** Relation: Trust Code Value */
            CodeValue : {
                RelationName: 'CodeSet|CodeValue|CodeSetId',
                FieldPrefix: 'CodeValue',
                PropertyName: 'CodeValue'
            },
    };
}

export class CodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2385;
        this.ItemDetail.ItemName='CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Trust Code Set */
            CodeSet : {
                RelationName: 'CodeSet|CodeValue|CodeSetId',
                FieldPrefix: 'CodeSet',
                PropertyName: 'CodeSet'
            },
            /** Relation: Access Control - Access Control Cv - Many */
            AccessControlByAccessControlCv : {
                RelationName: 'CodeValue|AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvAccessControl',
                PropertyName: 'AccessControlCvAccessControl'
            },
            /** Relation: Access Control - Access Control Cv - Many */
            Permits2AccessControlByAccessControlCv : {
                RelationName: 'CodeValue|permits2_AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvPermits2AccessControl',
                PropertyName: 'AccessControlCvPermits2AccessControl'
            },
            /** Relation: Accident - Type Cv - Many */
            AccidentByTypeCv : {
                RelationName: 'CodeValue|Accident|TypeCv',
                FieldPrefix: 'TypeCvAccident',
                PropertyName: 'TypeCvAccident'
            },
            /** Relation: Auction - Condition Cv - Many */
            AuctionByConditionCv : {
                RelationName: 'CodeValue|Auction|ConditionCv',
                FieldPrefix: 'ConditionCvAuction',
                PropertyName: 'ConditionCvAuction'
            },
            /** Relation: Auction - Status Cv - Many */
            AuctionByStatusCv : {
                RelationName: 'CodeValue|Auction|StatusCv',
                FieldPrefix: 'StatusCvAuction',
                PropertyName: 'StatusCvAuction'
            },
            /** Relation: Billing - Billing Type Cv - Many */
            BillingByBillingTypeCv : {
                RelationName: 'Ethos_CodeValue|Billing|BillingTypeCv',
                FieldPrefix: 'BillingTypeCvBilling',
                PropertyName: 'BillingTypeCvBilling'
            },
            /** Relation: Billing - Invoice Frequency Cv - Many */
            BillingByInvoiceFrequencyCv : {
                RelationName: 'Ethos_CodeValue|Billing|InvoiceFrequencyCv',
                FieldPrefix: 'InvoiceFrequencyCvBilling',
                PropertyName: 'InvoiceFrequencyCvBilling'
            },
            /** Relation: Company License - Status Cv - Many */
            CompanyLicenseByStatusCv : {
                RelationName: 'CodeValue|CompanyLicense|StatusCv',
                FieldPrefix: 'StatusCvCompanyLicense',
                PropertyName: 'StatusCvCompanyLicense'
            },
            /** Relation: Department Role - Role Cv - Many */
            DepartmentRoleByRoleCv : {
                RelationName: 'CodeValue|DepartmentRole|RoleCv',
                FieldPrefix: 'RoleCvDepartmentRole',
                PropertyName: 'RoleCvDepartmentRole'
            },
            /** Relation: Employee Training Needed - Issue Sub Type - Many */
            EmployeeTrainingNeededByIssueSubTypeId : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|IssueSubTypeId',
                FieldPrefix: 'IssueSubTypeIdEmployeeTrainingNeeded',
                PropertyName: 'IssueSubTypeIdEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Status Cv - Many */
            EmployeeTrainingNeededByStatusCv : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|StatusCv',
                FieldPrefix: 'StatusCvEmployeeTrainingNeeded',
                PropertyName: 'StatusCvEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Conclusion Cv - Many */
            EmployeeTrainingNeededByConclusionCv : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|ConclusionCv',
                FieldPrefix: 'ConclusionCvEmployeeTrainingNeeded',
                PropertyName: 'ConclusionCvEmployeeTrainingNeeded'
            },
            /** Relation: Five Star Rating - Rating Value - Many */
            FiveStarRatingByRatingValue : {
                RelationName: 'CodeValue|FiveStarRating|RatingValue',
                FieldPrefix: 'RatingValueFiveStarRating',
                PropertyName: 'RatingValueFiveStarRating'
            },
            /** Relation: Inspection - Preferred Time Of Day Cv - Many */
            InspectionByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvInspection',
                PropertyName: 'PreferredTimeOfDayCvInspection'
            },
            /** Relation: Inspection - Result Cv - Many */
            InspectionByResultCv : {
                RelationName: 'CodeValue|Inspection|ResultCv',
                FieldPrefix: 'ResultCvInspection',
                PropertyName: 'ResultCvInspection'
            },
            /** Relation: Inspection - Preferred Time Of Day Cv - Many */
            Permits2InspectionByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|permits2_Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvPermits2Inspection',
                PropertyName: 'PreferredTimeOfDayCvPermits2Inspection'
            },
            /** Relation: Licenses - Status Cv - Many */
            LicensesByStatusCv : {
                RelationName: 'CodeValue|Licenses|StatusCv',
                FieldPrefix: 'StatusCvLicenses',
                PropertyName: 'StatusCvLicenses'
            },
            /** Relation: Memo Of Record - Employee Type Cv - Many */
            MemoOfRecordByEmployeeTypeCv : {
                RelationName: 'CodeValue|MemoOfRecord|EmployeeTypeCv',
                FieldPrefix: 'EmployeeTypeCvMemoOfRecord',
                PropertyName: 'EmployeeTypeCvMemoOfRecord'
            },
            /** Relation: Memo Of Record - Status Cv - Many */
            MemoOfRecordByStatusCv : {
                RelationName: 'CodeValue|MemoOfRecord|StatusCv',
                FieldPrefix: 'StatusCvMemoOfRecord',
                PropertyName: 'StatusCvMemoOfRecord'
            },
            /** Relation: Memo Of Record - Conclusion Cv - Many */
            MemoOfRecordByConclusionCv : {
                RelationName: 'CodeValue|MemoOfRecord|ConclusionCv',
                FieldPrefix: 'ConclusionCvMemoOfRecord',
                PropertyName: 'ConclusionCvMemoOfRecord'
            },
            /** Relation: PAF Pay/Job Change - Status Cv - Many */
            PayJobChangeByStatusCv : {
                RelationName: 'CodeValue|PayJobChange|StatusCv',
                FieldPrefix: 'StatusCvPayJobChange',
                PropertyName: 'StatusCvPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - Pay Change Type Cv - Many */
            PayJobChangeByPayChangeTypeCv : {
                RelationName: 'CodeValue|PayJobChange|PayChangeTypeCv',
                FieldPrefix: 'PayChangeTypeCvPayJobChange',
                PropertyName: 'PayChangeTypeCvPayJobChange'
            },
            /** Relation: Pay Job Change Workflow Email - Status Cv - Many */
            PayJobChangeWorkflowEmailByStatusCv : {
                RelationName: 'CodeValue|PayJobChangeWorkflowEmail|StatusCv',
                FieldPrefix: 'StatusCvPayJobChangeWorkflowEmail',
                PropertyName: 'StatusCvPayJobChangeWorkflowEmail'
            },
            /** Relation: Permit - Cable Type Cv - Many */
            PermitByCableTypeCv : {
                RelationName: 'CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermit',
                PropertyName: 'CableTypeCvPermit'
            },
            /** Relation: Permit - Electrical Work Type Cv - Many */
            PermitByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermit',
                PropertyName: 'ElectricalWorkTypeCvPermit'
            },
            /** Relation: Permit - Fire Alarm Demo Install Cv - Many */
            PermitByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermit',
                PropertyName: 'FireAlarmDemoInstallCvPermit'
            },
            /** Relation: Permit - Access Control Type Cv - Many */
            PermitByAccessControlTypeCv : {
                RelationName: 'CodeValue|Permit|AccessControlTypeCv',
                FieldPrefix: 'AccessControlTypeCvPermit',
                PropertyName: 'AccessControlTypeCvPermit'
            },
            /** Relation: Permit - C C T V Install Type Cv - Many */
            PermitByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermit',
                PropertyName: 'CCTVInstallTypeCvPermit'
            },
            /** Relation: Permit - Electrical Different Type Cv - Many */
            PermitByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermit',
                PropertyName: 'ElectricalDifferentTypeCvPermit'
            },
            /** Relation: Permit - Electrical Outlet Type Cv - Many */
            PermitByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermit',
                PropertyName: 'ElectricalOutletTypeCvPermit'
            },
            /** Relation: Permit - Inspection State Cv - Many */
            PermitByInspectionStateCv : {
                RelationName: 'CodeValue|Permit|InspectionStateCv',
                FieldPrefix: 'InspectionStateCvPermit',
                PropertyName: 'InspectionStateCvPermit'
            },
            /** Relation: Permit - Permit Request Type Cv - Many */
            Permits2PermitByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvPermits2Permit',
                PropertyName: 'PermitRequestTypeCvPermits2Permit'
            },
            /** Relation: Permit - C C T V Install Type Cv - Many */
            Permits2PermitByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermits2Permit',
                PropertyName: 'CCTVInstallTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Different Type Cv - Many */
            Permits2PermitByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermits2Permit',
                PropertyName: 'ElectricalDifferentTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Outlet Type Cv - Many */
            Permits2PermitByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermits2Permit',
                PropertyName: 'ElectricalOutletTypeCvPermits2Permit'
            },
            /** Relation: Permit - Electrical Work Type Cv - Many */
            Permits2PermitByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermits2Permit',
                PropertyName: 'ElectricalWorkTypeCvPermits2Permit'
            },
            /** Relation: Permit - Fire Alarm Demo Install Cv - Many */
            Permits2PermitByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permits2_Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermits2Permit',
                PropertyName: 'FireAlarmDemoInstallCvPermits2Permit'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            PermitPermitTypeByPermitTypeCv : {
                RelationName: 'CodeValue|PermitPermitTypeOld|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitPermitType',
                PropertyName: 'PermitTypeCvPermitPermitType'
            },
            /** Relation: Permit Request - Electrical Work Type Cv - Many */
            PermitRequestByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermitRequest',
                PropertyName: 'ElectricalWorkTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Fire Alarm Demo Install Cv - Many */
            PermitRequestByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permitRequest|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermitRequest',
                PropertyName: 'FireAlarmDemoInstallCvPermitRequest'
            },
            /** Relation: Permit Request - Access Control C V - Many */
            PermitRequestByAccessControlCV : {
                RelationName: 'CodeValue|permitRequest|AccessControlCV',
                FieldPrefix: 'AccessControlCVPermitRequest',
                PropertyName: 'AccessControlCVPermitRequest'
            },
            /** Relation: Permit Request - Access Control Other Type Cv - Many */
            PermitRequestByAccessControlOtherTypeCv : {
                RelationName: 'CodeValue|permitRequest|AccessControlOtherTypeCv',
                FieldPrefix: 'AccessControlOtherTypeCvPermitRequest',
                PropertyName: 'AccessControlOtherTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Permit Request Type Cv - Many */
            PermitRequestByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permitRequest|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvPermitRequest',
                PropertyName: 'PermitRequestTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Audio Cable Type C V - Many */
            PermitRequestByAudioCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|AudioCableTypeCV',
                FieldPrefix: 'AudioCableTypeCVPermitRequest',
                PropertyName: 'AudioCableTypeCVPermitRequest'
            },
            /** Relation: Permit Request - C C T V Cable Type C V - Many */
            PermitRequestByCCTVCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|CCTVCableTypeCV',
                FieldPrefix: 'CCTVCableTypeCVPermitRequest',
                PropertyName: 'CCTVCableTypeCVPermitRequest'
            },
            /** Relation: Permit Request - C C T V Install Type Cv - Many */
            PermitRequestByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permitRequest|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermitRequest',
                PropertyName: 'CCTVInstallTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Status Cv - Many */
            PermitRequestByStatusCv : {
                RelationName: 'CodeValue|permitRequest|StatusCv',
                FieldPrefix: 'StatusCvPermitRequest',
                PropertyName: 'StatusCvPermitRequest'
            },
            /** Relation: Permit Request - Voice Data Cable Type C V - Many */
            PermitRequestByVoiceDataCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|VoiceDataCableTypeCV',
                FieldPrefix: 'VoiceDataCableTypeCVPermitRequest',
                PropertyName: 'VoiceDataCableTypeCVPermitRequest'
            },
            /** Relation: Permit Request - Electrical Different Type Cv - Many */
            PermitRequestByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermitRequest',
                PropertyName: 'ElectricalDifferentTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Electrical Outlet Type Cv - Many */
            PermitRequestByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermitRequest',
                PropertyName: 'ElectricalOutletTypeCvPermitRequest'
            },
            /** Relation: Permit Request Permit Type - Permit Type Cv - Many */
            PermitRequestPermitTypeByPermitTypeCv : {
                RelationName: 'CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequestPermitType',
                PropertyName: 'PermitTypeCvPermitRequestPermitType'
            },
            /** Relation: Request - Delivery Option Cv - Many */
            RequestByDeliveryOptionCv : {
                RelationName: 'CodeValue|Request|DeliveryOptionCv',
                FieldPrefix: 'DeliveryOptionCvRequest',
                PropertyName: 'DeliveryOptionCvRequest'
            },
            /** Relation: Request - Transportation Plan Cv - Many */
            TravelRequestByTransportationPlanCv : {
                RelationName: 'CodeValue|travel_Request|TransportationPlanCv',
                FieldPrefix: 'TransportationPlanCvTravelRequest',
                PropertyName: 'TransportationPlanCvTravelRequest'
            },
            /** Relation: Request - Travel Mode Cv - Many */
            TravelRequestByTravelModeCv : {
                RelationName: 'CodeValue|travel_Request|TravelModeCv',
                FieldPrefix: 'TravelModeCvTravelRequest',
                PropertyName: 'TravelModeCvTravelRequest'
            },
            /** Relation: Request - Airport Plan Cv - Many */
            TravelRequestByAirportPlanCv : {
                RelationName: 'CodeValue|travel_Request|AirportPlanCv',
                FieldPrefix: 'AirportPlanCvTravelRequest',
                PropertyName: 'AirportPlanCvTravelRequest'
            },
            /** Relation: Request - Lodging Plan Cv - Many */
            TravelRequestByLodgingPlanCv : {
                RelationName: 'CodeValue|travel_Request|LodgingPlanCv',
                FieldPrefix: 'LodgingPlanCvTravelRequest',
                PropertyName: 'LodgingPlanCvTravelRequest'
            },
            /** Relation: Request - Travel Type Cv - Many */
            TravelRequestByTravelTypeCv : {
                RelationName: 'CodeValue|travel_Request|TravelTypeCv',
                FieldPrefix: 'TravelTypeCvTravelRequest',
                PropertyName: 'TravelTypeCvTravelRequest'
            },
            /** Relation: Required Cable - Cable Type Cv - Many */
            Permits2RequiredCableByCableTypeCv : {
                RelationName: 'CodeValue|permits2_RequiredCable|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermits2RequiredCable',
                PropertyName: 'CableTypeCvPermits2RequiredCable'
            },
            /** Relation: PAF Term/Resign - Reason For Leaving Cv - Many */
            TermResignByReasonForLeavingCv : {
                RelationName: 'CodeValue|TermResign|ReasonForLeavingCv',
                FieldPrefix: 'ReasonForLeavingCvTermResign',
                PropertyName: 'ReasonForLeavingCvTermResign'
            },
            /** Relation: User Extended - Tech Type Cv - Many */
            MtlUserExtendedByTechTypeCv : {
                RelationName: 'CodeValue|mtl_UserExtended|TechTypeCv',
                FieldPrefix: 'TechTypeCvMtlUserExtended',
                PropertyName: 'TechTypeCvMtlUserExtended'
            },
            /** Relation: User Extended - Work Status Cv - Many */
            EmsUserExtendedByWorkStatusCv : {
                RelationName: 'CodeValue|ems_UserExtended|WorkStatusCv',
                FieldPrefix: 'WorkStatusCvEmsUserExtended',
                PropertyName: 'WorkStatusCvEmsUserExtended'
            },
            /** Relation: Vehicle - Vehicle Status Cv - Many */
            FleetVehicleByVehicleStatusCv : {
                RelationName: 'CodeValue|fleet_Vehicle|VehicleStatusCv',
                FieldPrefix: 'VehicleStatusCvFleetVehicle',
                PropertyName: 'VehicleStatusCvFleetVehicle'
            },
            /** Relation: Vehicle - Vehicle Type Cv - Many */
            FleetVehicleByVehicleTypeCv : {
                RelationName: 'CodeValue|fleet_Vehicle|VehicleTypeCv',
                FieldPrefix: 'VehicleTypeCvFleetVehicle',
                PropertyName: 'VehicleTypeCvFleetVehicle'
            },
            /** Relation: Vehicle - Ownership Type Cv - Many */
            FleetVehicleByOwnershipTypeCv : {
                RelationName: 'CodeValue|fleet_Vehicle|OwnershipTypeCv',
                FieldPrefix: 'OwnershipTypeCvFleetVehicle',
                PropertyName: 'OwnershipTypeCvFleetVehicle'
            },
            /** Relation: Vehicle - Drive Train Cv - Many */
            FleetVehicleByDriveTrainCv : {
                RelationName: 'CodeValue|fleet_Vehicle|DriveTrainCv',
                FieldPrefix: 'DriveTrainCvFleetVehicle',
                PropertyName: 'DriveTrainCvFleetVehicle'
            },
            /** Relation: Vehicle Accident - Accident At Fault Cv - Many */
            VehicleAccidentByAccidentAtFaultCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentAtFaultCv',
                FieldPrefix: 'AccidentAtFaultCvVehicleAccident',
                PropertyName: 'AccidentAtFaultCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Accident Type Cv - Many */
            VehicleAccidentByAccidentTypeCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvVehicleAccident',
                PropertyName: 'AccidentTypeCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Claim Insurance Company Cv - Many */
            VehicleAccidentByClaimInsuranceCompanyCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimInsuranceCompanyCv',
                FieldPrefix: 'ClaimInsuranceCompanyCvVehicleAccident',
                PropertyName: 'ClaimInsuranceCompanyCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Claim Status Cv - Many */
            VehicleAccidentByClaimStatusCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvVehicleAccident',
                PropertyName: 'ClaimStatusCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Vehicle Repaired Cv - Many */
            VehicleAccidentByVehicleRepairedCv : {
                RelationName: 'CodeValue|VehicleAccident|VehicleRepairedCv',
                FieldPrefix: 'VehicleRepairedCvVehicleAccident',
                PropertyName: 'VehicleRepairedCvVehicleAccident'
            },
            /** Relation: Workplace Accident - Injury Type Cv - Many */
            WorkplaceAccidentByInjuryTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|InjuryTypeCv',
                FieldPrefix: 'InjuryTypeCvWorkplaceAccident',
                PropertyName: 'InjuryTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Accident Type Cv - Many */
            WorkplaceAccidentByAccidentTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvWorkplaceAccident',
                PropertyName: 'AccidentTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Body Part Cv - Many */
            WorkplaceAccidentByBodyPartCv : {
                RelationName: 'CodeValue|workplaceAccident|BodyPartCv',
                FieldPrefix: 'BodyPartCvWorkplaceAccident',
                PropertyName: 'BodyPartCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Body Side Cv - Many */
            WorkplaceAccidentByBodySideCv : {
                RelationName: 'CodeValue|workplaceAccident|BodySideCv',
                FieldPrefix: 'BodySideCvWorkplaceAccident',
                PropertyName: 'BodySideCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Worksite Type Cv - Many */
            WorkplaceAccidentByWorksiteTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|WorksiteTypeCv',
                FieldPrefix: 'WorksiteTypeCvWorkplaceAccident',
                PropertyName: 'WorksiteTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Claim Status Cv - Many */
            WorkplaceAccidentByClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvWorkplaceAccident',
                PropertyName: 'ClaimStatusCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - In House Claim Status Cv - Many */
            WorkplaceAccidentByInHouseClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|InHouseClaimStatusCv',
                FieldPrefix: 'InHouseClaimStatusCvWorkplaceAccident',
                PropertyName: 'InHouseClaimStatusCvWorkplaceAccident'
            },
    };
}

export class CollaborationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Collaboration.';

    constructor() {
        this.ItemDetail.ItemId=2377;
        this.ItemDetail.ItemName='Collaboration';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CollaborationId : string = this.i + 'CollaborationId';
    FromDepartmentId : string = this.i + 'FromDepartmentId';
    FromPmUserId : string = this.i + 'FromPmUserId';
    ToDepartmentId : string = this.i + 'ToDepartmentId';
    ToPmUserId : string = this.i + 'ToPmUserId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerPm : string = this.i + 'CustomerPm';
    CustomerTitle : string = this.i + 'CustomerTitle';
    ProjectName : string = this.i + 'ProjectName';
    SiteCount : string = this.i + 'SiteCount';
    RevenuePerSite : string = this.i + 'RevenuePerSite';
    CollaborationDate : string = this.i + 'CollaborationDate';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - From Pm */
            EthosUserByFromPmUserId : {
                RelationName: 'Ethos_User|Collaboration|FromPmUserId',
                FieldPrefix: 'FromPmEthosUser',
                PropertyName: 'FromPmEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Collaboration|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Collaboration|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - To Pm User */
            EthosUserByToPmUserId : {
                RelationName: 'Ethos_User|Collaboration|ToPmUserId',
                FieldPrefix: 'ToPmEthosUser',
                PropertyName: 'ToPmEthosUser'
            },
            /** Relation: Wachter Department - From Department */
            EthosWachterDepartmentByFromDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|Collaboration|FromDepartmentId',
                FieldPrefix: 'FromDepartmentIdEthosWachterDepartment',
                PropertyName: 'FromDepartmentIdEthosWachterDepartment'
            },
            /** Relation: Wachter Department - To Department */
            EthosWachterDepartmentByToDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|Collaboration|ToDepartmentId',
                FieldPrefix: 'ToDepartmentIdEthosWachterDepartment',
                PropertyName: 'ToDepartmentIdEthosWachterDepartment'
            },
            /** Relation: Collaboration Department */
            CollaborationDepartment : {
                RelationName: 'Collaboration|CollaborationDepartment|CollaborationId',
                FieldPrefix: 'CollaborationDepartment',
                PropertyName: 'CollaborationDepartment'
            },
            /** Relation: Collaboration Pm */
            CollaborationPm : {
                RelationName: 'Collaboration|CollaborationPm|CollaborationId',
                FieldPrefix: 'CollaborationPm',
                PropertyName: 'CollaborationPm'
            },
    };
}

export class CollaborationDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CollaborationDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2376;
        this.ItemDetail.ItemName='CollaborationDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CollaborationDepartmentId : string = this.i + 'CollaborationDepartmentId';
    CollaborationId : string = this.i + 'CollaborationId';
    DepartmentId : string = this.i + 'DepartmentId';

    Relations = {
            /** Relation: Collaboration */
            Collaboration : {
                RelationName: 'Collaboration|CollaborationDepartment|CollaborationId',
                FieldPrefix: 'Collaboration',
                PropertyName: 'Collaboration'
            },
            /** Relation: Wachter Department - Department */
            EthosWachterDepartmentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|CollaborationDepartment|DepartmentId',
                FieldPrefix: 'DepartmentIdEthosWachterDepartment',
                PropertyName: 'DepartmentIdEthosWachterDepartment'
            },
    };
}

export class CollaborationPmMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CollaborationPm.';

    constructor() {
        this.ItemDetail.ItemId=2373;
        this.ItemDetail.ItemName='CollaborationPm';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CollaborationPmId : string = this.i + 'CollaborationPmId';
    CollaborationId : string = this.i + 'CollaborationId';
    ProjectManagerId : string = this.i + 'ProjectManagerId';

    Relations = {
            /** Relation: Collaboration */
            Collaboration : {
                RelationName: 'Collaboration|CollaborationPm|CollaborationId',
                FieldPrefix: 'Collaboration',
                PropertyName: 'Collaboration'
            },
            /** Relation: Ethos User - Project Manager */
            EthosUserByProjectManagerId : {
                RelationName: 'Ethos_User|CollaborationPm|ProjectManagerId',
                FieldPrefix: 'ProjectManagerIdEthosUser',
                PropertyName: 'ProjectManagerIdEthosUser'
            },
    };
}

export class CompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Company.';

    constructor() {
        this.ItemDetail.ItemId=2355;
        this.ItemDetail.ItemName='Company';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CompanyId : string = this.i + 'CompanyId';
    Company : string = this.i + 'Company';
    AcctNumber : string = this.i + 'AcctNumber';
    Email : string = this.i + 'Email';
    CompanyOrder : string = this.i + 'CompanyOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Request */
            Request : {
                RelationName: 'Company|Request|CompanyId',
                FieldPrefix: 'Request',
                PropertyName: 'Request'
            },
    };
}

export class CompanyLicenseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CompanyLicense.';

    constructor() {
        this.ItemDetail.ItemId=2801;
        this.ItemDetail.ItemName='CompanyLicense';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CompanyLicenseId : string = this.i + 'CompanyLicenseId';
    Title : string = this.i + 'Title';
    LicenseId : string = this.i + 'LicenseId';
    CompanyLicenseTypeId : string = this.i + 'CompanyLicenseTypeId';
    ExpirationDate : string = this.i + 'ExpirationDate';
    IssueDate : string = this.i + 'IssueDate';
    IsBond : string = this.i + 'IsBond';
    StateId : string = this.i + 'StateId';
    County : string = this.i + 'County';
    City : string = this.i + 'City';
    Authority : string = this.i + 'Authority';
    BondExpirationDate : string = this.i + 'BondExpirationDate';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    NoteParentId : string = this.i + 'NoteParentId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    StatusCv : string = this.i + 'StatusCv';
    QualifierUserId : string = this.i + 'QualifierUserId';
    WachterCompanyId : string = this.i + 'WachterCompanyId';
    SequenceId : string = this.i + 'SequenceId';
    IsQualifierExpected : string = this.i + 'IsQualifierExpected';

    Relations = {
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|CompanyLicense|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Company License Type */
            CompanyLicenseType : {
                RelationName: 'CompanyLicenseType|CompanyLicense|CompanyLicenseTypeId',
                FieldPrefix: 'CompanyLicenseType',
                PropertyName: 'CompanyLicenseType'
            },
            /** Relation: State Province - State */
            EthosStateProvinceByStateId : {
                RelationName: 'Ethos_StateProvince|CompanyLicense|StateId',
                FieldPrefix: 'StateIdEthosStateProvince',
                PropertyName: 'StateIdEthosStateProvince'
            },
            /** Relation: Ethos User - Qualifier User */
            EthosUserByQualifierUserId : {
                RelationName: 'Ethos_User|CompanyLicense|QualifierUserId',
                FieldPrefix: 'QualifierEthosUser',
                PropertyName: 'QualifierEthosUser'
            },
            /** Relation: Ethos Wachter Company */
            EthosWachterCompany : {
                RelationName: 'Ethos_WachterCompany|CompanyLicense|achterCompanyId',
                FieldPrefix: 'EthosWachterCompany',
                PropertyName: 'EthosWachterCompany'
            },
    };
}

export class CompanyLicenseTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CompanyLicenseType.';

    constructor() {
        this.ItemDetail.ItemId=2802;
        this.ItemDetail.ItemName='CompanyLicenseType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CompanyLicenseTypeId : string = this.i + 'CompanyLicenseTypeId';
    Display : string = this.i + 'Display';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Company License */
            CompanyLicense : {
                RelationName: 'CompanyLicenseType|CompanyLicense|CompanyLicenseTypeId',
                FieldPrefix: 'CompanyLicense',
                PropertyName: 'CompanyLicense'
            },
    };
}

export class CovidConfigurationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidConfiguration.';

    constructor() {
        this.ItemDetail.ItemId=2616;
        this.ItemDetail.ItemName='CovidConfiguration';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidConfigurationId : string = this.i + 'CovidConfigurationId';
    TestFrequencyDays : string = this.i + 'TestFrequencyDays';
    QuarantineDays : string = this.i + 'QuarantineDays';
    TestStartAfterPositiveDays : string = this.i + 'TestStartAfterPositiveDays';
    EffectiveStartDate : string = this.i + 'EffectiveStartDate';
    RequireWeeklyTesting : string = this.i + 'RequireWeeklyTesting';
    EffectiveEndDate : string = this.i + 'EffectiveEndDate';
    ShowHomePageContent : string = this.i + 'ShowHomePageContent';
    HomePageMessage : string = this.i + 'HomePageMessage';
    ReminderEmail1DaysBefore : string = this.i + 'ReminderEmail1DaysBefore';
    ReminderEmail2DaysBefore : string = this.i + 'ReminderEmail2DaysBefore';
    ReminderEmail3DaysBefore : string = this.i + 'ReminderEmail3DaysBefore';

    Relations = {
    };
}

export class CovidTestResultTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestResultType.';

    constructor() {
        this.ItemDetail.ItemId=2605;
        this.ItemDetail.ItemName='CovidTestResultType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestResultTypeId : string = this.i + 'CovidTestResultTypeId';
    CovidTestResultType : string = this.i + 'CovidTestResultType';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestResultType|EmployeeTest|CovidTestResultTypeId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

export class CovidTestStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestStatus.';

    constructor() {
        this.ItemDetail.ItemId=2606;
        this.ItemDetail.ItemName='CovidTestStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestStatusId : string = this.i + 'CovidTestStatusId';
    CovidTestStatus : string = this.i + 'CovidTestStatus';
    CovidTestStatusActionTest : string = this.i + 'CovidTestStatusActionTest';
    ButtonClasses : string = this.i + 'ButtonClasses';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestStatus|EmployeeTest|CovidTestStatusId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

export class CovidTestTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestType.';

    constructor() {
        this.ItemDetail.ItemId=2612;
        this.ItemDetail.ItemName='CovidTestType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestTypeId : string = this.i + 'CovidTestTypeId';
    CovidTestType : string = this.i + 'CovidTestType';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestType|EmployeeTest|CovidTestTypeId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

export class CovidVaccinationStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccinationStatus.';

    constructor() {
        this.ItemDetail.ItemId=2607;
        this.ItemDetail.ItemName='CovidVaccinationStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    CovidVaccinationStatus : string = this.i + 'CovidVaccinationStatus';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummary|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
            /** Relation: Employee Summary History - Previous - Many */
            EmployeeSummaryHistoryByPreviousCovidVaccinationStatusId : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|PreviousCovidVaccinationStatusId',
                FieldPrefix: 'PreviousEmployeeSummaryHistory',
                PropertyName: 'PreviousEmployeeSummaryHistory'
            },
            /** Relation: Employee Vaccination Submission */
            EmployeeVaccinationSubmission : {
                RelationName: 'CovidVaccinationStatus|EmployeeVaccinationSubmission|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeVaccinationSubmission',
                PropertyName: 'EmployeeVaccinationSubmission'
            },
    };
}

export class CovidVaccinationSubmissionStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccinationSubmissionStatus.';

    constructor() {
        this.ItemDetail.ItemId=2615;
        this.ItemDetail.ItemName='CovidVaccinationSubmissionStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccinationSubmissionStatusId : string = this.i + 'CovidVaccinationSubmissionStatusId';
    StatusDisplay : string = this.i + 'StatusDisplay';
    StatusActionText : string = this.i + 'StatusActionText';
    ButtonClasses : string = this.i + 'ButtonClasses';

    Relations = {
            /** Relation: Employee Vaccination Submission */
            EmployeeVaccinationSubmission : {
                RelationName: 'CovidVaccinationSubmissionStatus|EmployeeVaccinationSubmission|CovidVaccinationSubmissionStatusId',
                FieldPrefix: 'EmployeeVaccinationSubmission',
                PropertyName: 'EmployeeVaccinationSubmission'
            },
    };
}

export class CovidVaccineTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccineType.';

    constructor() {
        this.ItemDetail.ItemId=2608;
        this.ItemDetail.ItemName='CovidVaccineType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccineTypeId : string = this.i + 'CovidVaccineTypeId';
    CovidVaccineType : string = this.i + 'CovidVaccineType';
    RequiredShots : string = this.i + 'RequiredShots';

    Relations = {
            /** Relation: Employee Summary - Booster Vaccine1 Type - Many */
            EmployeeSummaryByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdEmployeeSummary',
                PropertyName: 'BoosterVaccine1TypeIdEmployeeSummary'
            },
            /** Relation: Employee Summary - Vaccine Type - Many */
            EmployeeSummaryByVaccineTypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|VaccineTypeId',
                FieldPrefix: 'VaccineTypeIdEmployeeSummary',
                PropertyName: 'VaccineTypeIdEmployeeSummary'
            },
            /** Relation: Employee Vaccination Submission - Vaccination Type - Many */
            EmployeeVaccinationSubmissionByVaccinationTypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|VaccinationTypeId',
                FieldPrefix: 'VaccinationTypeIdEmployeeVaccinationSubmission',
                PropertyName: 'VaccinationTypeIdEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Vaccination Submission - Booster Vaccine1 Type - Many */
            EmployeeVaccinationSubmissionByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdEmployeeVaccinationSubmission',
                PropertyName: 'BoosterVaccine1TypeIdEmployeeVaccinationSubmission'
            },
    };
}

export class CovidWorkStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidWorkStatus.';

    constructor() {
        this.ItemDetail.ItemId=2609;
        this.ItemDetail.ItemName='CovidWorkStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    CovidWorkStatus : string = this.i + 'CovidWorkStatus';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'CovidWorkStatus|EmployeeSummary|CovidWorkStatusId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|CovidWorkStatusId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
            /** Relation: Employee Summary History - Previous - Many */
            EmployeeSummaryHistoryByPreviousCovidWorkStatusId : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|PreviousCovidWorkStatusId',
                FieldPrefix: 'PreviousEmployeeSummaryHistory',
                PropertyName: 'PreviousEmployeeSummaryHistory'
            },
    };
}

export class DevwareCustomAttributeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'devware_CustomAttributeValue.';

    constructor() {
        this.ItemDetail.ItemId=2479;
        this.ItemDetail.ItemName='devware_CustomAttributeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CustomAttributeValueId : string = this.i + 'CustomAttributeValueId';
    MetaDataItemId : string = this.i + 'MetaDataItemId';
    KeyValue : string = this.i + 'KeyValue';
    RowIndex : string = this.i + 'RowIndex';
    CustomAttr1Value : string = this.i + 'CustomAttr1Value';
    CustomAttr1Display : string = this.i + 'CustomAttr1Display';
    CustomAttr2Value : string = this.i + 'CustomAttr2Value';
    CustomAttr2Display : string = this.i + 'CustomAttr2Display';
    CustomAttr3Value : string = this.i + 'CustomAttr3Value';
    CustomAttr3Display : string = this.i + 'CustomAttr3Display';
    CustomAttr4Value : string = this.i + 'CustomAttr4Value';
    CustomAttr4Display : string = this.i + 'CustomAttr4Display';
    CustomAttr5Value : string = this.i + 'CustomAttr5Value';
    CustomAttr5Display : string = this.i + 'CustomAttr5Display';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';

    Relations = {
    };
}

export class CustomerSatisfactionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CustomerSatisfaction.';

    constructor() {
        this.ItemDetail.ItemId=2367;
        this.ItemDetail.ItemName='CustomerSatisfaction';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CustomerSatisfactionId : string = this.i + 'CustomerSatisfactionId';
    Customer : string = this.i + 'Customer';
    PmUserId : string = this.i + 'PmUserId';
    City : string = this.i + 'City';
    State : string = this.i + 'State';
    SiteLocation : string = this.i + 'SiteLocation';
    Description : string = this.i + 'Description';
    Damage : string = this.i + 'Damage';
    CustomerSatisfactionDate : string = this.i + 'CustomerSatisfactionDate';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Project Manager */
            EthosUserByPmUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|PmUserId',
                FieldPrefix: 'PmEthosUser',
                PropertyName: 'PmEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class DepartmentAdditionalBurdenMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DepartmentAdditionalBurden.';

    constructor() {
        this.ItemDetail.ItemId=2518;
        this.ItemDetail.ItemName='DepartmentAdditionalBurden';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    DepartmentAdditionalBurdenId : string = this.i + 'DepartmentAdditionalBurdenId';
    EthosDepartmentId : string = this.i + 'Ethos_DepartmentId';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    AdditionalBurdenAmount : string = this.i + 'AdditionalBurdenAmount';

    Relations = {
            /** Relation: Wachter Department - Ethos Department */
            EthosWachterDepartmentByEthosDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|DepartmentAdditionalBurden|Ethos_DepartmentId',
                FieldPrefix: 'EthosDepartmentIdEthosWachterDepartment',
                PropertyName: 'EthosDepartmentIdEthosWachterDepartment'
            },
    };
}

export class DepartmentMapMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DepartmentMap.';

    constructor() {
        this.ItemDetail.ItemId=3443;
        this.ItemDetail.ItemName='DepartmentMap';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    DepartmentMapId : string = this.i + 'DepartmentMapId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    Group : string = this.i + 'Group';

    Relations = {
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|DepartmentMap|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
    };
}

export class DepartmentRoleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DepartmentRole.';

    constructor() {
        this.ItemDetail.ItemId=2473;
        this.ItemDetail.ItemName='DepartmentRole';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    DepartmentRoleId : string = this.i + 'DepartmentRoleId';
    EthosWachterDepartmentId : string = this.i + 'Ethos_WachterDepartmentId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    RoleCv : string = this.i + 'RoleCv';

    Relations = {
            /** Relation: Trust Code Value - Role */
            CodeValueByRoleCv : {
                RelationName: 'CodeValue|DepartmentRole|RoleCv',
                FieldPrefix: 'RoleCvCodeValue',
                PropertyName: 'RoleCvCodeValue'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|DepartmentRole|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Department - Wachter Department */
            EthosWachterDepartmentByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|DepartmentRole|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosEthosWachterDepartment',
                PropertyName: 'EthosEthosWachterDepartment'
            },
    };
}

export class DWOSGFinDataMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_OSGFinData.';

    constructor() {
        this.ItemDetail.ItemId=2520;
        this.ItemDetail.ItemName='DW_OSGFinData';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    MonthIdALT : string = this.i + 'MonthIdALT';
    Period : string = this.i + 'Period';
    Month : string = this.i + 'Month';
    MonthShort : string = this.i + 'MonthShort';
    Section01 : string = this.i + 'Section_01';
    OpportunityId : string = this.i + 'OpportunityId';
    OpportunityNo : string = this.i + 'OpportunityNo';
    OpportunityName : string = this.i + 'OpportunityName';
    JobNumberId : string = this.i + 'JobNumberId';
    ETHOSJobNumberId : string = this.i + 'ETHOSJobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    JobNameLong : string = this.i + 'JobNameLong';
    JobStatus : string = this.i + 'JobStatus';
    JobGroup : string = this.i + 'JobGroup';
    JobRestrictedShort : string = this.i + 'JobRestrictedShort';
    JobRestricted : string = this.i + 'JobRestricted';
    RevRecMethod : string = this.i + 'RevRecMethod';
    JobCategory : string = this.i + 'JobCategory';
    JobNumberType : string = this.i + 'JobNumberType';
    JobType : string = this.i + 'JobType';
    JobBillingType : string = this.i + 'JobBillingType';
    JobFacilityType : string = this.i + 'JobFacilityType';
    JobInvoiceType : string = this.i + 'JobInvoiceType';
    JobStartDate : string = this.i + 'JobStartDate';
    JobEndDate : string = this.i + 'JobEndDate';
    JobCloseDate : string = this.i + 'JobCloseDate';
    JobDurationDays : string = this.i + 'JobDurationDays';
    JobWorkDays : string = this.i + 'JobWorkDays';
    ProjectManager : string = this.i + 'ProjectManager';
    SrProjectManager : string = this.i + 'SrProjectManager';
    Section02 : string = this.i + 'Section_02';
    PhaseCode : string = this.i + 'PhaseCode';
    Phase : string = this.i + 'Phase';
    PhaseLong : string = this.i + 'PhaseLong';
    Section03 : string = this.i + 'Section_03';
    TeamId : string = this.i + 'TeamId';
    TeamCode : string = this.i + 'TeamCode';
    Team : string = this.i + 'Team';
    TeamLong : string = this.i + 'TeamLong';
    DepartmentCode : string = this.i + 'DepartmentCode';
    Department : string = this.i + 'Department';
    DepartmentLong : string = this.i + 'DepartmentLong';
    DivisionCode : string = this.i + 'DivisionCode';
    Division : string = this.i + 'Division';
    DivisionLong : string = this.i + 'DivisionLong';
    CompanyCode : string = this.i + 'CompanyCode';
    Company : string = this.i + 'Company';
    CompanyLong : string = this.i + 'CompanyLong';
    Section04 : string = this.i + 'Section_04';
    CustomerChildId : string = this.i + 'CustomerChildId';
    ETHOSCustomerId : string = this.i + 'ETHOSCustomerId';
    CustomerChildNo : string = this.i + 'CustomerChildNo';
    CustomerChild : string = this.i + 'CustomerChild';
    CustomerId : string = this.i + 'CustomerId';
    CustomerNo : string = this.i + 'CustomerNo';
    Customer : string = this.i + 'Customer';
    CustomerAlias : string = this.i + 'CustomerAlias';
    CustomerNAM : string = this.i + 'CustomerNAM';
    Section05 : string = this.i + 'Section_05';
    FcHours : string = this.i + 'fcHours';
    FcHoursYtd : string = this.i + 'fcHours_Ytd';
    FcHoursJtd : string = this.i + 'fcHours_Jtd';
    FcRev : string = this.i + 'fcRev';
    FcRevYtd : string = this.i + 'fcRev_Ytd';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCost : string = this.i + 'fcCost';
    FcCostYtd : string = this.i + 'fcCost_Ytd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    Revenue : string = this.i + 'Revenue';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenue : string = this.i + 'pcRevenue';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    Hours : string = this.i + 'Hours';
    HoursYtd : string = this.i + 'Hours_Ytd';
    HoursJtd : string = this.i + 'Hours_Jtd';
    Cost : string = this.i + 'Cost';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    Overhead : string = this.i + 'Overhead';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';
    Section06 : string = this.i + 'Section_06';
    LatestRecordperPeriod : string = this.i + 'LatestRecordperPeriod';
    LatestRecordperYear : string = this.i + 'LatestRecordperYear';
    LatestRecord : string = this.i + 'LatestRecord';
    OSGFinDataId : string = this.i + 'OSGFinDataId';

    Relations = {
    };
}

export class DWOSGFinDataLatestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_OSGFinDataLatest.';

    constructor() {
        this.ItemDetail.ItemId=2521;
        this.ItemDetail.ItemName='DW_OSGFinDataLatest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    MonthIdALT : string = this.i + 'MonthIdALT';
    Period : string = this.i + 'Period';
    Month : string = this.i + 'Month';
    MonthShort : string = this.i + 'MonthShort';
    Section01 : string = this.i + 'Section_01';
    OpportunityId : string = this.i + 'OpportunityId';
    OpportunityNo : string = this.i + 'OpportunityNo';
    OpportunityName : string = this.i + 'OpportunityName';
    JobNumberId : string = this.i + 'JobNumberId';
    ETHOSJobNumberId : string = this.i + 'ETHOSJobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    JobNameLong : string = this.i + 'JobNameLong';
    JobStatus : string = this.i + 'JobStatus';
    JobGroup : string = this.i + 'JobGroup';
    JobRestrictedShort : string = this.i + 'JobRestrictedShort';
    JobRestricted : string = this.i + 'JobRestricted';
    RevRecMethod : string = this.i + 'RevRecMethod';
    JobCategory : string = this.i + 'JobCategory';
    JobNumberType : string = this.i + 'JobNumberType';
    JobType : string = this.i + 'JobType';
    JobBillingType : string = this.i + 'JobBillingType';
    JobFacilityType : string = this.i + 'JobFacilityType';
    JobInvoiceType : string = this.i + 'JobInvoiceType';
    JobStartDate : string = this.i + 'JobStartDate';
    JobEndDate : string = this.i + 'JobEndDate';
    JobCloseDate : string = this.i + 'JobCloseDate';
    JobDurationDays : string = this.i + 'JobDurationDays';
    JobWorkDays : string = this.i + 'JobWorkDays';
    ProjectManager : string = this.i + 'ProjectManager';
    SrProjectManager : string = this.i + 'SrProjectManager';
    Section02 : string = this.i + 'Section_02';
    PhaseCode : string = this.i + 'PhaseCode';
    Phase : string = this.i + 'Phase';
    PhaseLong : string = this.i + 'PhaseLong';
    Section03 : string = this.i + 'Section_03';
    TeamId : string = this.i + 'TeamId';
    TeamCode : string = this.i + 'TeamCode';
    Team : string = this.i + 'Team';
    TeamLong : string = this.i + 'TeamLong';
    DepartmentCode : string = this.i + 'DepartmentCode';
    Department : string = this.i + 'Department';
    DepartmentLong : string = this.i + 'DepartmentLong';
    DivisionCode : string = this.i + 'DivisionCode';
    Division : string = this.i + 'Division';
    DivisionLong : string = this.i + 'DivisionLong';
    CompanyCode : string = this.i + 'CompanyCode';
    Company : string = this.i + 'Company';
    CompanyLong : string = this.i + 'CompanyLong';
    Section04 : string = this.i + 'Section_04';
    CustomerChildId : string = this.i + 'CustomerChildId';
    ETHOSCustomerId : string = this.i + 'ETHOSCustomerId';
    CustomerChildNo : string = this.i + 'CustomerChildNo';
    CustomerChild : string = this.i + 'CustomerChild';
    CustomerChildLong : string = this.i + 'CustomerChildLong';
    CustomerId : string = this.i + 'CustomerId';
    CustomerNo : string = this.i + 'CustomerNo';
    Customer : string = this.i + 'Customer';
    CustomerAlias : string = this.i + 'CustomerAlias';
    CustomerNAM : string = this.i + 'CustomerNAM';
    Section05 : string = this.i + 'Section_05';
    FcHours : string = this.i + 'fcHours';
    FcHoursYtd : string = this.i + 'fcHours_Ytd';
    FcHoursJtd : string = this.i + 'fcHours_Jtd';
    FcRev : string = this.i + 'fcRev';
    FcRevYtd : string = this.i + 'fcRev_Ytd';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCost : string = this.i + 'fcCost';
    FcCostYtd : string = this.i + 'fcCost_Ytd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    Revenue : string = this.i + 'Revenue';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenue : string = this.i + 'pcRevenue';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    Hours : string = this.i + 'Hours';
    HoursYtd : string = this.i + 'Hours_Ytd';
    HoursJtd : string = this.i + 'Hours_Jtd';
    Cost : string = this.i + 'Cost';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    Overhead : string = this.i + 'Overhead';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';
    Section06 : string = this.i + 'Section_06';
    LatestRecordperPeriod : string = this.i + 'LatestRecordperPeriod';
    LatestRecordperYear : string = this.i + 'LatestRecordperYear';
    LatestRecord : string = this.i + 'LatestRecord';
    OSGFinDataId : string = this.i + 'OSGFinDataId';
    PmEthosUserId : string = this.i + 'PmEthos_UserId';
    OrganizationalUnitId : string = this.i + 'OrganizationalUnitId';
    PhaseId : string = this.i + 'PhaseId';
    JobNumberIsOverhead : string = this.i + 'JobNumberIsOverhead';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    OSGFinDataDateTime : string = this.i + 'OSGFinDataDateTime';
    FcRevPYs : string = this.i + 'fcRev-PYs';
    FcpcRevPYs : string = this.i + 'fcpcRev-PYs';
    FcCostPYs : string = this.i + 'fcCost-PYs';
    FcGPPYs : string = this.i + 'fcGP-PYs';
    FcpcGPPYs : string = this.i + 'fcpcGP-PYs';
    OrganizationalEntityId : string = this.i + 'OrganizationalEntityId';

    Relations = {
            /** Relation: Organizational Entity */
            OrganizationalEntity : {
                RelationName: 'OrganizationalEntity|DW_OSGFinDataLatest|OrganizationalEntityId',
                FieldPrefix: 'OrganizationalEntity',
                PropertyName: 'OrganizationalEntity'
            },
    };
}

export class DWPeoplePaySummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_PeoplePaySummary.';

    constructor() {
        this.ItemDetail.ItemId=2692;
        this.ItemDetail.ItemName='DW_PeoplePaySummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PPSId : string = this.i + 'PPSId';
    PersonId : string = this.i + 'PersonId';
    ETHOSUserId : string = this.i + 'ETHOSUserId';
    ETHOSLoginId : string = this.i + 'ETHOSLoginId';
    AXPersonnelNo : string = this.i + 'AXPersonnelNo';
    AXWorkerNo : string = this.i + 'AXWorkerNo';
    SectionPERSON : string = this.i + 'Section_PERSON';
    Person : string = this.i + 'Person';
    PersonLong : string = this.i + 'PersonLong';
    LastNameFirst : string = this.i + 'LastNameFirst';
    LastNameFirstPreferred : string = this.i + 'LastNameFirstPreferred';
    FirstName : string = this.i + 'FirstName';
    MiddleName : string = this.i + 'MiddleName';
    LastName : string = this.i + 'LastName';
    PreferredName : string = this.i + 'PreferredName';
    EffectiveUserName : string = this.i + 'EffectiveUserName';
    Email : string = this.i + 'Email';
    JobTitle : string = this.i + 'JobTitle';
    PersonwJobTitle : string = this.i + 'PersonwJobTitle';
    SectionTIME : string = this.i + 'Section_TIME';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDateNoYr : string = this.i + 'BirthDateNoYr';
    HireDate : string = this.i + 'HireDate';
    YrsService : string = this.i + 'YrsService';
    StartDate : string = this.i + 'StartDate';
    AdjStartDate : string = this.i + 'AdjStartDate';
    ServiceDate : string = this.i + 'ServiceDate';
    ServiceAwardMonth : string = this.i + 'ServiceAwardMonth';
    TermDate : string = this.i + 'TermDate';
    ReportDate : string = this.i + 'ReportDate';
    SectionSUPERVISOR : string = this.i + 'Section_SUPERVISOR';
    SupervisorId : string = this.i + 'SupervisorId';
    SupETHOSUserId : string = this.i + 'SupETHOSUserId';
    Supervisor : string = this.i + 'Supervisor';
    SupervisorwJobTitle : string = this.i + 'SupervisorwJobTitle';
    SectionDIMENSIONs : string = this.i + 'Section_DIMENSIONs';
    GroupCode : string = this.i + 'GroupCode';
    Group : string = this.i + 'Group';
    GroupParent : string = this.i + 'GroupParent';
    JobFunctionCode : string = this.i + 'JobFunctionCode';
    JobFunction : string = this.i + 'JobFunction';
    Office : string = this.i + 'Office';
    ExemptStatus : string = this.i + 'ExemptStatus';
    StaffingAgency : string = this.i + 'StaffingAgency';
    Status : string = this.i + 'Status';
    Type : string = this.i + 'Type';
    TypeGroup : string = this.i + 'TypeGroup';
    SectionWACHTERORG : string = this.i + 'Section_WACHTERORG';
    PeopleTeamCode : string = this.i + 'PeopleTeamCode';
    PeopleTeam : string = this.i + 'PeopleTeam';
    PeopleTeamLong : string = this.i + 'PeopleTeamLong';
    PeopleTeamMethod : string = this.i + 'PeopleTeamMethod';
    PeopleDepartmentCode : string = this.i + 'PeopleDepartmentCode';
    PeopleDepartment : string = this.i + 'PeopleDepartment';
    PeopleDepartmentLong : string = this.i + 'PeopleDepartmentLong';
    PeopleDivisionCode : string = this.i + 'PeopleDivisionCode';
    PeopleDivision : string = this.i + 'PeopleDivision';
    PeopleDivisionLong : string = this.i + 'PeopleDivisionLong';
    PeopleBusinessCode : string = this.i + 'PeopleBusinessCode';
    PeopleBusiness : string = this.i + 'PeopleBusiness';
    PeopleBusinessLong : string = this.i + 'PeopleBusinessLong';
    PeopleGroupCode : string = this.i + 'PeopleGroupCode';
    PeopleGroup : string = this.i + 'PeopleGroup';
    PeopleGroupLong : string = this.i + 'PeopleGroupLong';
    SectionFLAGs : string = this.i + 'Section_FLAGs';
    HasHours : string = this.i + 'HasHours';
    HasJobTitle : string = this.i + 'HasJobTitle';
    HasSkillComm : string = this.i + 'HasSkillComm';
    HasSkillElectrical : string = this.i + 'HasSkillElectrical';
    HasSkillSecurity : string = this.i + 'HasSkillSecurity';
    HasValidSupervisor : string = this.i + 'HasValidSupervisor';
    HasValidTeam : string = this.i + 'HasValidTeam';
    IsActive : string = this.i + 'IsActive';
    IsEngineer : string = this.i + 'IsEngineer';
    IsTerminated : string = this.i + 'IsTerminated';
    IsWachterEmp : string = this.i + 'IsWachterEmp';
    SupForcedAssign : string = this.i + 'SupForcedAssign';
    SectionAMOUNTs : string = this.i + 'Section_AMOUNTs';
    PayRate : string = this.i + 'PayRate';
    PayRateCur : string = this.i + 'PayRate_cur';
    PayRateCurDate : string = this.i + 'PayRate_cur_Date';
    PayRateLast : string = this.i + 'PayRate_last';
    PayRateLastDate : string = this.i + 'PayRate_last_Date';
    PayRateFirst : string = this.i + 'PayRate_first';
    PayRateFirstDate : string = this.i + 'PayRate_first_Date';
    SinceLastRateChgDate : string = this.i + 'SinceLast_RateChg_Date';
    SinceLastRateChg : string = this.i + 'SinceLast_RateChg';
    SinceLastRateChgText : string = this.i + 'SinceLast_RateChg_Text';
    BurdenRate : string = this.i + 'BurdenRate';
    BurdenRateCur : string = this.i + 'BurdenRate_cur';
    BurdenRateCurDate : string = this.i + 'BurdenRate_cur_Date';
    BurdenRateLast : string = this.i + 'BurdenRate_last';
    BurdenRateLastDate : string = this.i + 'BurdenRate_last_Date';
    BurdenRateFirst : string = this.i + 'BurdenRate_first';
    BurdenRateFirstDate : string = this.i + 'BurdenRate_first_Date';
    BillRate : string = this.i + 'BillRate';
    BillRateCur : string = this.i + 'BillRate_cur';
    BillRateCurDate : string = this.i + 'BillRate_cur_Date';
    BillRateLast : string = this.i + 'BillRate_last';
    BillRateLastDate : string = this.i + 'BillRate_last_Date';
    BillRateFirst : string = this.i + 'BillRate_first';
    BillRateFirstDate : string = this.i + 'BillRate_first_Date';
    PersonIdMASTER : string = this.i + 'PersonId_MASTER';
    RowNo : string = this.i + 'RowNo';
    MaxRecord : string = this.i + 'Max_Record';
    DataAreaId : string = this.i + 'DataAreaId';
    DriveRate : string = this.i + 'DriveRate';
    DriveRateCur : string = this.i + 'DriveRate_cur';
    DriveRateCurDate : string = this.i + 'DriveRate_cur_Date';
    DriveRateLast : string = this.i + 'DriveRate_last';
    DriveRateLastDate : string = this.i + 'DriveRate_last_Date';
    DriveRateFirst : string = this.i + 'DriveRate_first';
    DriveRateFirstDate : string = this.i + 'DriveRate_first_Date';

    Relations = {
            /** Relation: User Extended - E T H O S User */
            EmsUserExtendedByETHOSUserId : {
                RelationName: 'dw_PeoplePaySummary|EmsUserExtended|Ethos_UserId',
                FieldPrefix: 'ETHOSUserIdEmsUserExtended',
                PropertyName: 'ETHOSUserIdEmsUserExtended'
            },
            /** Relation: Ro Ethos User Grid - E T H O S User */
            RoEthosUserGridByETHOSUserId : {
                RelationName: 'People Pay Summary -> Ro Ethos User Grid',
                FieldPrefix: 'ETHOSUserIdRoEthosUserGrid',
                PropertyName: 'ETHOSUserIdRoEthosUserGrid'
            },
            /** Relation: Ro Ethos User - E T H O S User */
            RoEthosUserByETHOSUserId : {
                RelationName: 'RoEthosUser -> PeoplePaySummary',
                FieldPrefix: 'ETHOSRoEthosUser',
                PropertyName: 'ETHOSRoEthosUser'
            },
            /** Relation: Resource Cost - E T H O S User - Many */
            ResourceCostByEthosUserId : {
                RelationName: 'DW_PeoplePaySummary|resourceCost|UserId',
                FieldPrefix: 'EthosUserIdResourceCost',
                PropertyName: 'EthosUserIdResourceCost'
            },
    };
}

export class DWPersonMergeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_PersonMerge.';

    constructor() {
        this.ItemDetail.ItemId=2797;
        this.ItemDetail.ItemName='DW_PersonMerge';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PMId : string = this.i + 'PMId';
    PersonMergeId : string = this.i + 'PersonMergeId';
    SectionFROM : string = this.i + 'Section_FROM';
    FROMPersonId : string = this.i + 'FROM_PersonId';
    FROMETHOSUserId : string = this.i + 'FROM_ETHOSUserId';
    FROMName : string = this.i + 'FROM_Name';
    FROMPersonGroupCode : string = this.i + 'FROM_PersonGroupCode';
    FROMPersonGroup : string = this.i + 'FROM_PersonGroup';
    FROMPersonGroupParent : string = this.i + 'FROM_PersonGroupParent';
    FROMPersonJobTitle : string = this.i + 'FROM_PersonJobTitle';
    FROMPersonStaffingAgency : string = this.i + 'FROM_PersonStaffingAgency';
    TermDate : string = this.i + 'TermDate';
    SectionTO : string = this.i + 'Section_TO';
    TOPersonId : string = this.i + 'TO_PersonId';
    TOETHOSUserId : string = this.i + 'TO_ETHOSUserId';
    TOName : string = this.i + 'TO_Name';
    TOPersonGroupCode : string = this.i + 'TO_PersonGroupCode';
    TOPersonGroup : string = this.i + 'TO_PersonGroup';
    TOPersonGroupParent : string = this.i + 'TO_PersonGroupParent';
    TOPersonJobTitle : string = this.i + 'TO_PersonJobTitle';
    TOPersonStaffingAgency : string = this.i + 'TO_PersonStaffingAgency';
    HireDate : string = this.i + 'HireDate';
    Rehire : string = this.i + 'Rehire';
    RehireDate : string = this.i + 'RehireDate';

    Relations = {
    };
}

export class DWPersonMergeLogMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_PersonMergeLog.';

    constructor() {
        this.ItemDetail.ItemId=3447;
        this.ItemDetail.ItemName='DW_PersonMergeLog';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PersonMergeLogId : string = this.i + 'PersonMergeLogId';
    PMId : string = this.i + 'PMId';
    FROMETHOSUserId : string = this.i + 'FROM_ETHOSUserId';
    TOETHOSUserId : string = this.i + 'TO_ETHOSUserId';

    Relations = {
    };
}

export class DWTrustForecastDataMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_TrustForecastData.';

    constructor() {
        this.ItemDetail.ItemId=2567;
        this.ItemDetail.ItemName='DW_TrustForecastData';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TransactionId : string = this.i + 'TransactionId';
    RecId : string = this.i + 'RecId';
    LedgerDimension : string = this.i + 'LedgerDimension';
    CategoryCode : string = this.i + 'CategoryCode';
    CurrencyCode : string = this.i + 'CurrencyCode';
    DataAreaId : string = this.i + 'DataAreaId';
    DataSourceCode : string = this.i + 'DataSourceCode';
    MeasureName : string = this.i + 'MeasureName';
    ForecastEntryCode : string = this.i + 'ForecastEntryCode';
    ForecastKindCode : string = this.i + 'ForecastKindCode';
    AXWorkerNo : string = this.i + 'AXWorkerNo';
    InvoiceNo : string = this.i + 'InvoiceNo';
    InvoiceLineNo : string = this.i + 'InvoiceLineNo';
    JobNumber : string = this.i + 'JobNumber';
    SubJobNumber : string = this.i + 'SubJobNumber';
    JobGroupCode : string = this.i + 'JobGroupCode';
    JobStatusCode : string = this.i + 'JobStatusCode';
    JobRestrictedCode : string = this.i + 'JobRestrictedCode';
    TransComment : string = this.i + 'TransComment';
    DepartmentCode : string = this.i + 'DepartmentCode';
    TeamCode : string = this.i + 'TeamCode';
    Year : string = this.i + 'Year';
    MonthNo : string = this.i + 'MonthNo';
    MonthIdALT : string = this.i + 'MonthIdALT';
    Period : string = this.i + 'Period';
    ReportDate : string = this.i + 'ReportDate';
    LedgerTransDate : string = this.i + 'LedgerTransDate';
    ProjTransDate : string = this.i + 'ProjTransDate';
    DateIssue : string = this.i + 'DateIssue';
    WIPPeriodDate : string = this.i + 'WIPPeriodDate';
    CreatedDate : string = this.i + 'CreatedDate';
    ModifiedDate : string = this.i + 'ModifiedDate';
    ActualCloseDate : string = this.i + 'ActualCloseDate';
    TrustIntegrationId : string = this.i + 'TrustIntegrationId';
    TrustSourceId : string = this.i + 'TrustSourceId';
    InPTC : string = this.i + '_InPTC';
    LCURForecastRev : string = this.i + 'LCUR_ForecastRev';
    LCURForecastCost : string = this.i + 'LCUR_ForecastCost';
    TransactionKey : string = this.i + 'TransactionKey';
    ActivityNo : string = this.i + 'ActivityNo';

    Relations = {
    };
}

export class DWWorkInProcessMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_WorkInProcess.';

    constructor() {
        this.ItemDetail.ItemId=2568;
        this.ItemDetail.ItemName='DW_WorkInProcess';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    MonthIdALT : string = this.i + 'MonthIdALT';
    Period : string = this.i + 'Period';
    Section01 : string = this.i + 'Section_01';
    DataAreaId : string = this.i + 'DataAreaId';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    WachterJobNumberId : string = this.i + 'WachterJobNumberId';
    Stage : string = this.i + 'Stage';
    JobStatusId : string = this.i + 'JobStatusId';
    JobStatus : string = this.i + 'JobStatus';
    JobGroupId : string = this.i + 'JobGroupId';
    JobGroup : string = this.i + 'JobGroup';
    JobRestrictedId : string = this.i + 'JobRestrictedId';
    JobRestrictedShort : string = this.i + 'JobRestrictedShort';
    JobRestricted : string = this.i + 'JobRestricted';
    RevRecMethod : string = this.i + 'RevRecMethod';
    ProjectManagerId : string = this.i + 'ProjectManagerId';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    ProjectManager : string = this.i + 'ProjectManager';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterTeamCode : string = this.i + 'WachterTeamCode';
    WachterTeamUserId : string = this.i + 'WachterTeamUserId';
    WachterTeamSteward : string = this.i + 'WachterTeamSteward';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDepartmentCode : string = this.i + 'WachterDepartmentCode';
    WachterDepartmentUserId : string = this.i + 'WachterDepartmentUserId';
    WachterDepartmentSteward : string = this.i + 'WachterDepartmentSteward';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    WachterDivisionCode : string = this.i + 'WachterDivisionCode';
    WachterDivisionUserId : string = this.i + 'WachterDivisionUserId';
    WachterDivisionSteward : string = this.i + 'WachterDivisionSteward';
    Section02 : string = this.i + 'Section_02';
    Section03 : string = this.i + 'Section_03';
    Section04 : string = this.i + 'Section_04';
    Section05 : string = this.i + 'Section_05';
    Section06 : string = this.i + 'Section_06';
    Section07 : string = this.i + 'Section_07';
    Section08 : string = this.i + 'Section_08';
    LastProcessed : string = this.i + 'LastProcessed';
    LastForecastRepl : string = this.i + 'LastForecastRepl';
    Section09 : string = this.i + 'Section_09';
    FcRevob : string = this.i + 'fcRevob';
    FcRevoh : string = this.i + 'fcRevoh';
    FcRevo : string = this.i + 'fcRevo';
    FcRevab : string = this.i + 'fcRevab';
    FcRevah : string = this.i + 'fcRevah';
    FcReva : string = this.i + 'fcReva';
    FcRevb : string = this.i + 'fcRevb';
    FcRevh : string = this.i + 'fcRevh';
    FcRev : string = this.i + 'fcRev';
    FcCostob : string = this.i + 'fcCostob';
    FcCostoh : string = this.i + 'fcCostoh';
    FcCosto : string = this.i + 'fcCosto';
    FcCostab : string = this.i + 'fcCostab';
    FcCostah : string = this.i + 'fcCostah';
    FcCosta : string = this.i + 'fcCosta';
    FcCostb : string = this.i + 'fcCostb';
    FcCosth : string = this.i + 'fcCosth';
    FcCost : string = this.i + 'fcCost';
    FcGPob : string = this.i + 'fcGPob';
    FcGPoh : string = this.i + 'fcGPoh';
    FcGPo : string = this.i + 'fcGPo';
    FcGPab : string = this.i + 'fcGPab';
    FcGPah : string = this.i + 'fcGPah';
    FcGPa : string = this.i + 'fcGPa';
    FcGPb : string = this.i + 'fcGPb';
    FcGPh : string = this.i + 'fcGPh';
    FcGP : string = this.i + 'fcGP';
    FcGPmob : string = this.i + 'fcGPmob';
    FcGPmoh : string = this.i + 'fcGPmoh';
    FcGPmo : string = this.i + 'fcGPmo';
    FcGPmab : string = this.i + 'fcGPmab';
    FcGPmah : string = this.i + 'fcGPmah';
    FcGPma : string = this.i + 'fcGPma';
    FcGPmb : string = this.i + 'fcGPmb';
    FcGPmh : string = this.i + 'fcGPmh';
    FcGPm : string = this.i + 'fcGPm';
    CostJtd : string = this.i + 'Cost_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostPrYr : string = this.i + 'Cost_PrYr';
    CostPrYrs : string = this.i + 'Cost_PrYrs';
    OverheadJtd : string = this.i + 'Overhead_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadPrYr : string = this.i + 'Overhead_PrYr';
    OverheadPrYrs : string = this.i + 'Overhead_PrYrs';
    PcRevJtd : string = this.i + 'pcRev_Jtd';
    PcRevYtd : string = this.i + 'pcRev_Ytd';
    PcRevPrYr : string = this.i + 'pcRev_PrYr';
    PcRevPrYrs : string = this.i + 'pcRev_PrYrs';
    PcRevDiffJtd : string = this.i + 'pcRevDiff_Jtd';
    PcRevDiffYtd : string = this.i + 'pcRevDiff_Ytd';
    PcRevDiffPrYr : string = this.i + 'pcRevDiff_PrYr';
    PcGPJtd : string = this.i + 'pcGP_Jtd';
    PcGPYtd : string = this.i + 'pcGP_Ytd';
    PcGPPrYr : string = this.i + 'pcGP_PrYr';
    PcGPmJtd : string = this.i + 'pcGPm_Jtd';
    PcGPmYtd : string = this.i + 'pcGPm_Ytd';
    PcGPmPrYr : string = this.i + 'pcGPm_PrYr';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenuePrYr : string = this.i + 'Revenue_PrYr';
    RevenuePrYrs : string = this.i + 'Revenue_PrYrs';
    GPJtd : string = this.i + 'GP_Jtd';
    GPYtd : string = this.i + 'GP_Ytd';
    GPPrYr : string = this.i + 'GP_PrYr';
    GPmJtd : string = this.i + 'GPm_Jtd';
    GPmYtd : string = this.i + 'GPm_Ytd';
    GPmPrYr : string = this.i + 'GPm_PrYr';
    BilledJtd : string = this.i + 'Billed_Jtd';
    BilledYtd : string = this.i + 'Billed_Ytd';
    BilledPrYr : string = this.i + 'Billed_PrYr';
    InvoicedJtd : string = this.i + 'Invoiced_Jtd';
    InvoicedYtd : string = this.i + 'Invoiced_Ytd';
    InvoicedPrYr : string = this.i + 'Invoiced_PrYr';
    SettledJtd : string = this.i + 'Settled_Jtd';
    SettledYtd : string = this.i + 'Settled_Ytd';
    SettledPrYr : string = this.i + 'Settled_PrYr';
    Complete : string = this.i + '%Complete';
    BacklogRev : string = this.i + 'Backlog_Rev';
    BacklogCost : string = this.i + 'Backlog_Cost';
    BacklogGP : string = this.i + 'Backlog_GP';
    BacklogGPm : string = this.i + 'Backlog_GPm';
    PcBacklogRev : string = this.i + 'pcBacklog_Rev';
    PcBacklogGP : string = this.i + 'pcBacklog_GP';
    PcBacklogGPm : string = this.i + 'pcBacklog_GPm';
    OverUnder : string = this.i + 'OverUnder';
    PcOverUnder : string = this.i + 'pcOverUnder';
    BacklogBill : string = this.i + 'Backlog_Bill';
    Settled : string = this.i + '%Settled';
    BalanceDue : string = this.i + 'BalanceDue';
    WithinTerms : string = this.i + 'WithinTerms';
    PastDue : string = this.i + 'PastDue';
    // Attribute code name is not unique - appending Meta Data Attribute Id;
    PastDue_24710 : string = this.i + 'PastDue%';
    Num1to30 : string = this.i + '1to30';
    Num31to60 : string = this.i + '31to60';
    Num61to90 : string = this.i + '61to90';
    Num91to120 : string = this.i + '91to120';
    Num121 : string = this.i + '121+';
    FcRevPYs : string = this.i + 'fcRev-PYs';
    FcpcRevPYs : string = this.i + 'fcpcRev-PYs';
    FcCostPYs : string = this.i + 'fcCost-PYs';
    FcGPPYs : string = this.i + 'fcGP-PYs';
    FcpcGPPYs : string = this.i + 'fcpcGP-PYs';
    FcGPmPYs : string = this.i + 'fcGPm-PYs';
    FcpcGPmPYs : string = this.i + 'fcpcGPm-PYs';
    WOTeamId : string = this.i + 'WOTeamId';

    Relations = {
    };
}

export class EmaulationUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmaulationUser.';

    constructor() {
        this.ItemDetail.ItemId=2590;
        this.ItemDetail.ItemName='EmaulationUser';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmulationUserId : string = this.i + 'EmulationUserId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmulateEthosUserId : string = this.i + 'EmulateEthos_UserId';

    Relations = {
            /** Relation: Ethos User - Emulated User */
            EthosUserByEmulateEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|EmulateEthos_UserId',
                FieldPrefix: 'EmulateEthosEthosUser',
                PropertyName: 'EmulateEthosEthosUser'
            },
            /** Relation: Ethos User - Logged in  User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EmployeeReminderNotificationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReminderNotification.';

    constructor() {
        this.ItemDetail.ItemId=2619;
        this.ItemDetail.ItemName='EmployeeReminderNotification';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    DaysUntilNextTest : string = this.i + 'DaysUntilNextTest';
    NextTestDate : string = this.i + 'NextTestDate';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    EmployeeReminderNotificationId : string = this.i + 'EmployeeReminderNotificationId';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'EmployeeSummary|EmployeeReminderNotification|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
    };
}

export class EmployeeReviewMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReview.';

    constructor() {
        this.ItemDetail.ItemId=2651;
        this.ItemDetail.ItemName='EmployeeReview';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewId : string = this.i + 'EmployeeReviewId';
    EmployeeReviewStatusId : string = this.i + 'EmployeeReviewStatusId';
    IsSupervisorReview : string = this.i + 'IsSupervisorReview';
    ResponsibleForBidding : string = this.i + 'ResponsibleForBidding';
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    ResponsibleForRevenue : string = this.i + 'ResponsibleForRevenue';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    DueDate : string = this.i + 'DueDate';
    SubmittedDateTime : string = this.i + 'SubmittedDateTime';

    Relations = {
            /** Relation: Employee Review Status */
            EmployeeReviewStatus : {
                RelationName: 'EmployeeReviewStatus|EmployeeReview|EmployeeReviewStatusId',
                FieldPrefix: 'EmployeeReviewStatus',
                PropertyName: 'EmployeeReviewStatus'
            },
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmployeeReviewSummary|EmployeeReview|EmployeeReviewSummaryId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReview|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReview|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReview|EmployeeReviewAnswer|EmployeeReviewId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
    };
}

export class EmployeeReviewAnswerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewAnswer.';

    constructor() {
        this.ItemDetail.ItemId=2658;
        this.ItemDetail.ItemName='EmployeeReviewAnswer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmplyeeReviewAnswerId : string = this.i + 'EmplyeeReviewAnswerId';
    EmployeeReviewId : string = this.i + 'EmployeeReviewId';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';
    EmployeeReviewAnswerValueId : string = this.i + 'EmployeeReviewAnswerValueId';
    AnswerValueText : string = this.i + 'AnswerValueText';

    Relations = {
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReview|EmployeeReviewAnswer|EmployeeReviewId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
            /** Relation: Employee Review Answer Value */
            EmployeeReviewAnswerValue : {
                RelationName: 'EmployeeReviewAnswerValue|EmployeeReviewAnswer|EmployeeReviewAnswerValueId',
                FieldPrefix: 'EmployeeReviewAnswerValue',
                PropertyName: 'EmployeeReviewAnswerValue'
            },
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewAnswer|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

export class EmployeeReviewAnswerValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewAnswerValue.';

    constructor() {
        this.ItemDetail.ItemId=2655;
        this.ItemDetail.ItemName='EmployeeReviewAnswerValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewAnswerValueId : string = this.i + 'EmployeeReviewAnswerValueId';
    AnswerDisplay : string = this.i + 'AnswerDisplay';
    AnswerDescription : string = this.i + 'AnswerDescription';
    Weight : string = this.i + 'Weight';

    Relations = {
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReviewAnswerValue|EmployeeReviewAnswer|EmployeeReviewAnswerValueId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
    };
}

export class EmployeeReviewCategoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewCategory.';

    constructor() {
        this.ItemDetail.ItemId=2656;
        this.ItemDetail.ItemName='EmployeeReviewCategory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewCategoryId : string = this.i + 'EmployeeReviewCategoryId';
    ReviewCategory : string = this.i + 'ReviewCategory';
    IconClasses : string = this.i + 'IconClasses';
    WachterContainerStyleId : string = this.i + 'WachterContainerStyleId';
    ReviewCategoryDescriptionHtml : string = this.i + 'ReviewCategoryDescriptionHtml';

    Relations = {
            /** Relation: Wachter Container Style */
            WachterContainerStyle : {
                RelationName: 'WachterContainerStyle|EmployeeReviewCategory|WachterContainerStyleId',
                FieldPrefix: 'WachterContainerStyle',
                PropertyName: 'WachterContainerStyle'
            },
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewCategory|EmployeeReviewQuestion|EmployeeReviewCategoryId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

export class EmployeeReviewQuestionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestion.';

    constructor() {
        this.ItemDetail.ItemId=2657;
        this.ItemDetail.ItemName='EmployeeReviewQuestion';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';
    EmployeeReviewCategoryId : string = this.i + 'EmployeeReviewCategoryId';
    Question : string = this.i + 'Question';
    QuestionDetail : string = this.i + 'QuestionDetail';
    EmployeeReviewQuestionTypeId : string = this.i + 'EmployeeReviewQuestionTypeId';
    QuestionOrder : string = this.i + 'QuestionOrder';
    EmployeeReviewQuestionSkillId : string = this.i + 'EmployeeReviewQuestionSkillId';
    EffectiveStartDate : string = this.i + 'EffectiveStartDate';
    EffectiveEndDate : string = this.i + 'EffectiveEndDate';

    Relations = {
            /** Relation: Employee Review Category */
            EmployeeReviewCategory : {
                RelationName: 'EmployeeReviewCategory|EmployeeReviewQuestion|EmployeeReviewCategoryId',
                FieldPrefix: 'EmployeeReviewCategory',
                PropertyName: 'EmployeeReviewCategory'
            },
            /** Relation: Employee Review Question Skill */
            EmployeeReviewQuestionSkill : {
                RelationName: 'EmployeeReviewQuestionSkill|EmployeeReviewQuestion|EmployeeReviewQuestionSkillId',
                FieldPrefix: 'EmployeeReviewQuestionSkill',
                PropertyName: 'EmployeeReviewQuestionSkill'
            },
            /** Relation: Employee Review Question Type */
            EmployeeReviewQuestionType : {
                RelationName: 'EmployeeReviewQuestionType|EmployeeReviewQuestion|EmployeeReviewQuestionTypeId',
                FieldPrefix: 'EmployeeReviewQuestionType',
                PropertyName: 'EmployeeReviewQuestionType'
            },
            /** Relation: Employee Review Answer */
            EmployeeReviewAnswer : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewAnswer|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewAnswer',
                PropertyName: 'EmployeeReviewAnswer'
            },
            /** Relation: Employee Review Question Request Detail */
            EmployeeReviewQuestionRequestDetail : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestionRequestDetail',
                PropertyName: 'EmployeeReviewQuestionRequestDetail'
            },
            /** Relation: Employee Review Question Setup Detail */
            EmployeeReviewQuestionSetupDetail : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestionSetupDetail',
                PropertyName: 'EmployeeReviewQuestionSetupDetail'
            },
    };
}

export class EmployeeReviewQuestionRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequest.';

    constructor() {
        this.ItemDetail.ItemId=2668;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestId : string = this.i + 'EmployeeReviewQuestionRequestId';
    EmployeeReviewQuestionRequestStatusId : string = this.i + 'EmployeeReviewQuestionRequestStatusId';
    SubmittedByEthosUserId : string = this.i + 'SubmittedByEthos_UserId';
    SubmittedByDateTime : string = this.i + 'SubmittedByDateTime';
    RejectedByEthosUserId : string = this.i + 'RejectedByEthos_UserId';
    RejectedByDateTime : string = this.i + 'RejectedByDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    ApprovedByEthosUserId : string = this.i + 'ApprovedByEthos_UserId';
    ApprovedByDateTime : string = this.i + 'ApprovedByDateTime';

    Relations = {
            /** Relation: Employee Review Question Request Status */
            EmployeeReviewQuestionRequestStatus : {
                RelationName: 'EmployeeReviewQuestionRequestStatus|EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestStatusId',
                FieldPrefix: 'EmployeeReviewQuestionRequestStatus',
                PropertyName: 'EmployeeReviewQuestionRequestStatus'
            },
            /** Relation: Ro Ethos User - Submitted By */
            RoEthosUserBySubmittedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|SubmittedBy',
                FieldPrefix: 'SubmittedByEthosRoEthosUser',
                PropertyName: 'SubmittedByEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Rejected By */
            RoEthosUserByRejectedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|RejectedBy',
                FieldPrefix: 'RejectedByEthosRoEthosUser',
                PropertyName: 'RejectedByEthosRoEthosUser'
            },
            /** Relation: Ethos User - Approved By */
            EthosUserByApprovedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|ApprovedByEthos_UserId',
                FieldPrefix: 'ApprovedByEthosEthosUser',
                PropertyName: 'ApprovedByEthosEthosUser'
            },
            /** Relation: Ethos User - Rejected By */
            EthosUserByRejectedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|RejectedByEthos_UserId',
                FieldPrefix: 'RejectedByEthosEthosUser',
                PropertyName: 'RejectedByEthosEthosUser'
            },
            /** Relation: Ethos User - Submitted By */
            EthosUserBySubmittedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|SubmittedByEthos_UserId',
                FieldPrefix: 'SubmittedByEthosEthosUser',
                PropertyName: 'SubmittedByEthosEthosUser'
            },
            /** Relation: Employee Review Question Request Detail */
            EmployeeReviewQuestionRequestDetail : {
                RelationName: 'EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionRequestId',
                FieldPrefix: 'EmployeeReviewQuestionRequestDetail',
                PropertyName: 'EmployeeReviewQuestionRequestDetail'
            },
    };
}

export class EmployeeReviewQuestionRequestDetailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequestDetail.';

    constructor() {
        this.ItemDetail.ItemId=2669;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequestDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestDetailId : string = this.i + 'EmployeeReviewQuestionRequestDetailId';
    EmployeeReviewQuestionRequestId : string = this.i + 'EmployeeReviewQuestionRequestId';
    Question : string = this.i + 'Question';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
            /** Relation: Employee Review Question Request */
            EmployeeReviewQuestionRequest : {
                RelationName: 'EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestDetail|EmployeeReviewQuestionRequestId',
                FieldPrefix: 'EmployeeReviewQuestionRequest',
                PropertyName: 'EmployeeReviewQuestionRequest'
            },
    };
}

export class EmployeeReviewQuestionRequestStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionRequestStatus.';

    constructor() {
        this.ItemDetail.ItemId=2667;
        this.ItemDetail.ItemName='EmployeeReviewQuestionRequestStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionRequestStatusId : string = this.i + 'EmployeeReviewQuestionRequestStatusId';
    ReviewStatus : string = this.i + 'ReviewStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';
    CurrentStatusActionText : string = this.i + 'CurrentStatusActionText';

    Relations = {
            /** Relation: Employee Review Question Request */
            EmployeeReviewQuestionRequest : {
                RelationName: 'EmployeeReviewQuestionRequestStatus|EmployeeReviewQuestionRequest|EmployeeReviewQuestionRequestStatusId',
                FieldPrefix: 'EmployeeReviewQuestionRequest',
                PropertyName: 'EmployeeReviewQuestionRequest'
            },
    };
}

export class EmployeeReviewQuestionSetupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetup.';

    constructor() {
        this.ItemDetail.ItemId=2671;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupId : string = this.i + 'EmployeeReviewQuestionSetupId';
    EmployeeReviewQuestionSetupLevelId : string = this.i + 'EmployeeReviewQuestionSetupLevelId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    ReviewYear : string = this.i + 'ReviewYear';
    HideRevenueQuestions : string = this.i + 'HideRevenueQuestions';
    HideBiddingQuestions : string = this.i + 'HideBiddingQuestions';

    Relations = {
            /** Relation: Employee Review Question Setup Level */
            EmployeeReviewQuestionSetupLevel : {
                RelationName: 'EmployeeReviewQuestionSetupLevel|EmployeeReviewQuestionSetup|EmployeereviewQuestionSetupLevelId',
                FieldPrefix: 'EmployeeReviewQuestionSetupLevel',
                PropertyName: 'EmployeeReviewQuestionSetupLevel'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|EmployeeReviewQuestionSetup|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|EmployeeReviewQuestionSetup|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Employee Review Question Setup Detail */
            EmployeeReviewQuestionSetupDetail : {
                RelationName: 'EmployeeReviewQuestionSetup|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionSetupId',
                FieldPrefix: 'EmployeeReviewQuestionSetupDetail',
                PropertyName: 'EmployeeReviewQuestionSetupDetail'
            },
    };
}

export class EmployeeReviewQuestionSetupDetailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetupDetail.';

    constructor() {
        this.ItemDetail.ItemId=2672;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetupDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupDetailId : string = this.i + 'EmployeeReviewQuestionSetupDetailId';
    EmployeeReviewQuestionSetupId : string = this.i + 'EmployeeReviewQuestionSetupId';
    EmployeeReviewQuestionId : string = this.i + 'EmployeeReviewQuestionId';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestion|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'EmployeeReviewQuestionSetup|EmployeeReviewQuestionSetupDetail|EmployeeReviewQuestionSetupId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
    };
}

export class EmployeeReviewQuestionSetupLevelMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSetupLevel.';

    constructor() {
        this.ItemDetail.ItemId=2670;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSetupLevel';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSetupLevelId : string = this.i + 'EmployeeReviewQuestionSetupLevelId';
    SetupLevel : string = this.i + 'SetupLevel';
    IconClass : string = this.i + 'IconClass';

    Relations = {
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'EmployeeReviewQuestionSetupLevel|EmployeeReviewQuestionSetup|EmployeereviewQuestionSetupLevelId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
    };
}

export class EmployeeReviewQuestionSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionSkill.';

    constructor() {
        this.ItemDetail.ItemId=2666;
        this.ItemDetail.ItemName='EmployeeReviewQuestionSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionSkillId : string = this.i + 'EmployeeReviewQuestionSkillId';
    SkillName : string = this.i + 'SkillName';
    IsSoftSkill : string = this.i + 'IsSoftSkill';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestionSkill|EmployeeReviewQuestion|EmployeeReviewQuestionSkillId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

export class EmployeeReviewQuestionTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewQuestionType.';

    constructor() {
        this.ItemDetail.ItemId=2659;
        this.ItemDetail.ItemName='EmployeeReviewQuestionType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewQuestionTypeId : string = this.i + 'EmployeeReviewQuestionTypeId';
    QuestionType : string = this.i + 'QuestionType';
    IsSoftSkill : string = this.i + 'IsSoftSkill';

    Relations = {
            /** Relation: Employee Review Question */
            EmployeeReviewQuestion : {
                RelationName: 'EmployeeReviewQuestionType|EmployeeReviewQuestion|EmployeeReviewQuestionTypeId',
                FieldPrefix: 'EmployeeReviewQuestion',
                PropertyName: 'EmployeeReviewQuestion'
            },
    };
}

export class EmployeeReviewStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewStatus.';

    constructor() {
        this.ItemDetail.ItemId=2650;
        this.ItemDetail.ItemName='EmployeeReviewStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewStatusId : string = this.i + 'EmployeeReviewStatusId';
    ReviewStatus : string = this.i + 'ReviewStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReviewStatus|EmployeeReview|EmployeeReviewStatusId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
    };
}

export class EmployeeReviewSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummary.';

    constructor() {
        this.ItemDetail.ItemId=2654;
        this.ItemDetail.ItemName='EmployeeReviewSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthosUserId';
    SupervisorEthosUserId : string = this.i + 'SupervisorEthosUserId';
    ReviewYear : string = this.i + 'ReviewYear';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    DueDate : string = this.i + 'DueDate';
    ReviewNotes : string = this.i + 'ReviewNotes';
    CompletedByEthosUserId : string = this.i + 'CompletedByEthos_UserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    ShowGraph : string = this.i + 'ShowGraph';

    Relations = {
            /** Relation: User Extended - Employee */
            EmsUserExtendedByEmployeeEthosUserId : {
                RelationName: 'EmployeeReviewSummary|UserExtended|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosUserIdEmsUserExtended',
                PropertyName: 'EmployeeEthosUserIdEmsUserExtended'
            },
            /** Relation: Emplyoee Review Summary Status */
            EmployeeReviewSummaryStatus : {
                RelationName: 'EmplyoeeReviewSummaryStatus|EmployeeReviewSummary|EmployeeReviewSummaryStatusId',
                FieldPrefix: 'EmployeeReviewSummaryStatus',
                PropertyName: 'EmployeeReviewSummaryStatus'
            },
            /** Relation: Employee Review Summary Type */
            EmployeeReviewSummaryType : {
                RelationName: 'EmployeeReviewSummaryType|EmployeeReviewSummary|EmployeeReviewSummaryTypeId',
                FieldPrefix: 'EmployeeReviewSummaryType',
                PropertyName: 'EmployeeReviewSummaryType'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Ethos User - Supervisor */
            EthosUserBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|SupervisorEthosUserId',
                FieldPrefix: 'SupervisorEthosEthosUser',
                PropertyName: 'SupervisorEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Completed By */
            EthosUserByCompletedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|CompletedByEthos_UserId',
                FieldPrefix: 'CompletedByEthosEthosUser',
                PropertyName: 'CompletedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Employee Review */
            EmployeeReview : {
                RelationName: 'EmployeeReviewSummary|EmployeeReview|EmployeeReviewSummaryId',
                FieldPrefix: 'EmployeeReview',
                PropertyName: 'EmployeeReview'
            },
    };
}

export class EmployeeReviewSummaryStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummaryStatus.';

    constructor() {
        this.ItemDetail.ItemId=2653;
        this.ItemDetail.ItemName='EmployeeReviewSummaryStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    ReviewSummaryStatus : string = this.i + 'ReviewSummaryStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmplyoeeReviewSummaryStatus|EmployeeReviewSummary|EmployeeReviewSummaryStatusId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
    };
}

export class EmployeeReviewSummaryTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReviewSummaryType.';

    constructor() {
        this.ItemDetail.ItemId=2652;
        this.ItemDetail.ItemName='EmployeeReviewSummaryType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    ReviewSummaryType : string = this.i + 'ReviewSummaryType';

    Relations = {
            /** Relation: Employee Review Summary */
            EmployeeReviewSummary : {
                RelationName: 'EmployeeReviewSummaryType|EmployeeReviewSummary|EmployeeReviewSummaryTypeId',
                FieldPrefix: 'EmployeeReviewSummary',
                PropertyName: 'EmployeeReviewSummary'
            },
    };
}

export class EmployeeServiceDatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeServiceDates.';

    constructor() {
        this.ItemDetail.ItemId=2574;
        this.ItemDetail.ItemName='EmployeeServiceDates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PersonnelNumber : string = this.i + 'PersonnelNumber';
    HireDate : string = this.i + 'HireDate';
    EmploymentStartDate : string = this.i + 'EmploymentStartDate';
    AdjustedServiceDate : string = this.i + 'AdjustedServiceDate';

    Relations = {
    };
}

export class EmployeeSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummary.';

    constructor() {
        this.ItemDetail.ItemId=2610;
        this.ItemDetail.ItemName='EmployeeSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    RequiresWeeklyTesting : string = this.i + 'RequiresWeeklyTesting';
    NextTestDate : string = this.i + 'NextTestDate';
    QuarantineStartDate : string = this.i + 'QuarantineStartDate';
    QuarantineEndDate : string = this.i + 'QuarantineEndDate';
    Vaccine1Date : string = this.i + 'Vaccine1Date';
    Vaccine2Date : string = this.i + 'Vaccine2Date';
    BoosterVaccine1TypeId : string = this.i + 'BoosterVaccine1TypeId';
    BoosterVaccine1Date : string = this.i + 'BoosterVaccine1Date';
    VaccinationCardFileId : string = this.i + 'VaccinationCardFileId';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    LastEmployeeTestId : string = this.i + 'LastEmployeeTestId';
    VaccineTypeId : string = this.i + 'VaccineTypeId';
    LastPositiveTestId : string = this.i + 'LastPositiveTestId';
    MedicalExemptionFileId : string = this.i + 'MedicalExemptionFileId';

    Relations = {
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummary|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
            /** Relation: Covid Vaccine Type - Booster Vaccination Type */
            CovidVaccineTypeByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdCovidVaccineType',
                PropertyName: 'BoosterVaccine1TypeIdCovidVaccineType'
            },
            /** Relation: Covid Vaccine Type - Vaccine Type */
            CovidVaccineTypeByVaccineTypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|VaccineTypeId',
                FieldPrefix: 'VaccineTypeIdCovidVaccineType',
                PropertyName: 'VaccineTypeIdCovidVaccineType'
            },
            /** Relation: Covid Work Status */
            CovidWorkStatus : {
                RelationName: 'CovidWorkStatus|EmployeeSummary|CovidWorkStatusId',
                FieldPrefix: 'CovidWorkStatus',
                PropertyName: 'CovidWorkStatus'
            },
            /** Relation: Employee Test - Last Employee Test */
            EmployeeTestByLastEmployeeTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastEmployeeTestId',
                FieldPrefix: 'LastEmployeeTest',
                PropertyName: 'LastEmployeeTest'
            },
            /** Relation: Employee Test - Last Positive Test */
            EmployeeTestByLastPositiveTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastPositiveTestId',
                FieldPrefix: 'LastPositiveTestIdEmployeeTest',
                PropertyName: 'LastPositiveTestIdEmployeeTest'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeSummary|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|EmployeeSummary|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|EmployeeSummary|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Employee Reminder Notification */
            EmployeeReminderNotification : {
                RelationName: 'EmployeeSummary|EmployeeReminderNotification|EmployeeSummaryId',
                FieldPrefix: 'EmployeeReminderNotification',
                PropertyName: 'EmployeeReminderNotification'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'EmployeeSummary|EmployeeSummaryHistory|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
    };
}

export class EmployeeSummaryChangeTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummaryChangeType.';

    constructor() {
        this.ItemDetail.ItemId=2617;
        this.ItemDetail.ItemName='EmployeeSummaryChangeType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmplyoeeSummaryChangeTypeId : string = this.i + 'EmplyoeeSummaryChangeTypeId';
    ChangeTypeDisplay : string = this.i + 'ChangeTypeDisplay';
    EmailEmployee : string = this.i + 'EmailEmployee';
    EmailSupervisor : string = this.i + 'EmailSupervisor';

    Relations = {
            /** Relation: Employee Summary History - Many */
            EmployeeSummaryHistoryByEmployeeSummaryChangeTypeId : {
                RelationName: 'EmployeeSummaryChangeType|EmployeeSummaryHistory|EmployeeSummaryChangeTypeId',
                FieldPrefix: 'EmployeeSummaryChangeTypeIdEmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryChangeTypeIdEmployeeSummaryHistory'
            },
    };
}

export class EmployeeSummaryHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummaryHistory.';

    constructor() {
        this.ItemDetail.ItemId=2618;
        this.ItemDetail.ItemName='EmployeeSummaryHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryHistoryId : string = this.i + 'EmployeeSummaryHistoryId';
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    EmployeeSummaryChangeTypeId : string = this.i + 'EmployeeSummaryChangeTypeId';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    PreviousCovidVaccinationStatusId : string = this.i + 'PreviousCovidVaccinationStatusId';
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    PreviousCovidWorkStatusId : string = this.i + 'PreviousCovidWorkStatusId';
    QuarantineStartDate : string = this.i + 'QuarantineStartDate';
    QuarantineEndDate : string = this.i + 'QuarantineEndDate';
    DetailNotificationsComplete : string = this.i + 'DetailNotificationsComplete';
    SummaryNotificationsComplete : string = this.i + 'SummaryNotificationsComplete';
    RequireWeeklyTesting : string = this.i + 'RequireWeeklyTesting';
    PreviousRequireWeeklyTesting : string = this.i + 'PreviousRequireWeeklyTesting';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
            /** Relation: Covid Vaccination Status - Previous Vaccination Status */
            CovidVaccinationStatusByPreviousCovidVaccinationStatusId : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|PreviousCovidVaccinationStatusId',
                FieldPrefix: 'PreviousCovidVaccinationStatus',
                PropertyName: 'PreviousCovidVaccinationStatus'
            },
            /** Relation: Covid Work Status */
            CovidWorkStatus : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|CovidWorkStatusId',
                FieldPrefix: 'CovidWorkStatus',
                PropertyName: 'CovidWorkStatus'
            },
            /** Relation: Covid Work Status - Previous Work Status */
            CovidWorkStatusByPreviousCovidWorkStatusId : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|PreviousCovidWorkStatusId',
                FieldPrefix: 'PreviousCovidWorkStatus',
                PropertyName: 'PreviousCovidWorkStatus'
            },
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'EmployeeSummary|EmployeeSummaryHistory|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Employee Summary Change Type - Emplyoee Summary Change Type */
            EmployeeSummaryChangeTypeByEmployeeSummaryChangeTypeId : {
                RelationName: 'EmployeeSummaryChangeType|EmployeeSummaryHistory|EmployeeSummaryChangeTypeId',
                FieldPrefix: 'EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType',
                PropertyName: 'EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType'
            },
    };
}

export class EmployeeTestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeTest.';

    constructor() {
        this.ItemDetail.ItemId=2611;
        this.ItemDetail.ItemName='EmployeeTest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeTestId : string = this.i + 'EmployeeTestId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    TestLocation : string = this.i + 'TestLocation';
    CovidTestTypeId : string = this.i + 'CovidTestTypeId';
    CovidTestResultTypeId : string = this.i + 'CovidTestResultTypeId';
    CovidTestStatusId : string = this.i + 'CovidTestStatusId';
    VerifiedByUserId : string = this.i + 'VerifiedByUserId';
    VerifiedDateTime : string = this.i + 'VerifiedDateTime';
    RejectedByUserId : string = this.i + 'RejectedByUserId';
    RejectedDateTime : string = this.i + 'RejectedDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    TestFileId : string = this.i + 'TestFileId';
    TestDateTime : string = this.i + 'TestDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    IsProcessed : string = this.i + 'IsProcessed';
    ProcessedDateTime : string = this.i + 'ProcessedDateTime';

    Relations = {
            /** Relation: Covid Test Result Type */
            CovidTestResultType : {
                RelationName: 'CovidTestResultType|EmployeeTest|CovidTestResultTypeId',
                FieldPrefix: 'CovidTestResultType',
                PropertyName: 'CovidTestResultType'
            },
            /** Relation: Covid Test Status */
            CovidTestStatus : {
                RelationName: 'CovidTestStatus|EmployeeTest|CovidTestStatusId',
                FieldPrefix: 'CovidTestStatus',
                PropertyName: 'CovidTestStatus'
            },
            /** Relation: Covid Test Type */
            CovidTestType : {
                RelationName: 'CovidTestType|EmployeeTest|CovidTestTypeId',
                FieldPrefix: 'CovidTestType',
                PropertyName: 'CovidTestType'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeTest|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: Ethos User - Verified By */
            EthosUserByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeTest|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEthosUser',
                PropertyName: 'VerifiedByEthosUser'
            },
            /** Relation: Ethos User - Rejected By */
            EthosUserByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeTest|RejectedByUserId',
                FieldPrefix: 'RejectedByEthosUser',
                PropertyName: 'RejectedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|EmployeeTest|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|EmployeeTest|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Employee Summary - Last - Many */
            EmployeeSummaryByLastEmployeeTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastEmployeeTestId',
                FieldPrefix: 'LastEmployeeSummary',
                PropertyName: 'LastEmployeeSummary'
            },
            /** Relation: Employee Summary - Last Positive Test - Many */
            EmployeeSummaryByLastPositiveTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastPositiveTestId',
                FieldPrefix: 'LastPositiveTestIdEmployeeSummary',
                PropertyName: 'LastPositiveTestIdEmployeeSummary'
            },
    };
}

export class EmployeeTrainingNeededMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeTrainingNeeded.';

    constructor() {
        this.ItemDetail.ItemId=2500;
        this.ItemDetail.ItemName='EmployeeTrainingNeeded';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeTrainingNeededId : string = this.i + 'EmployeeTrainingNeededId';
    ConclusionCv : string = this.i + 'ConclusionCv';
    IssueSubTypeId : string = this.i + 'IssueSubTypeId';
    StatusCv : string = this.i + 'StatusCv';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    AssignedToEthosUserId : string = this.i + 'AssignedToEthos_UserId';
    AttachmentId : string = this.i + 'AttachmentId';
    AssignedToEmailMessageId : string = this.i + 'AssignedToEmailMessageId';
    EventDate : string = this.i + 'EventDate';
    ClosedDate : string = this.i + 'ClosedDate';
    ReferenceText : string = this.i + 'ReferenceText';
    Customer : string = this.i + 'Customer';
    EventLocation : string = this.i + 'EventLocation';
    City : string = this.i + 'City';
    State : string = this.i + 'State';
    EmailCopyString : string = this.i + 'EmailCopyString';
    EventDescription : string = this.i + 'EventDescription';
    CreatedByEmailMessageId : string = this.i + 'CreatedByEmailMessageId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';
    CCEmailMessageId : string = this.i + 'CCEmailMessageId';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|EmployeeTrainingNeeded|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Trust Code Value - Issue Sub Type */
            CodeValueByIssueSubTypeId : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|IssueSubTypeId',
                FieldPrefix: 'IssueSubTypeIdCodeValue',
                PropertyName: 'IssueSubTypeIdCodeValue'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Conclusion */
            CodeValueByConclusionCv : {
                RelationName: 'EmployeeTrainingNeeded|CodeValue|ConclusionCv',
                FieldPrefix: 'ConclusionCvCodeValue',
                PropertyName: 'ConclusionCvCodeValue'
            },
            /** Relation: Ro Ethos User - Employee */
            RoEthosUserByEmployeeEthosUserId : {
                RelationName: 'EmployeeTrainingNeeded|roEthos_User|UserId',
                FieldPrefix: 'EmployeeEthosRoEthosUser',
                PropertyName: 'EmployeeEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Created By */
            RoEthosUserByCreatedByEthosUserId : {
                RelationName: 'EmployeeTrainingNeeded|roEthos_User|EmployeeTrainingNeededId',
                FieldPrefix: 'CreatedByEthosRoEthosUser',
                PropertyName: 'CreatedByEthosRoEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|AssignedToEthos_UserId',
                FieldPrefix: 'AssignedToEthosEthosUser',
                PropertyName: 'AssignedToEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Note */
            WcNote : {
                RelationName: 'EmployeeTrainingNeeded|Note|MemoOfRecordId',
                FieldPrefix: 'WcNote',
                PropertyName: 'WcNote'
            },
            /** Relation: User Read */
            WcUserRead : {
                RelationName: 'EmployeeTrainingNeeded|UserRead|EmployeeTrainingNeededId',
                FieldPrefix: 'WcUserRead',
                PropertyName: 'WcUserRead'
            },
    };
}

export class EmployeeVaccinationSubmissionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeVaccinationSubmission.';

    constructor() {
        this.ItemDetail.ItemId=2614;
        this.ItemDetail.ItemName='EmployeeVaccinationSubmission';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeVaccinationSubmissionId : string = this.i + 'EmployeeVaccinationSubmissionId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    SubmittedDateTime : string = this.i + 'SubmittedDateTime';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    VaccinationTypeId : string = this.i + 'VaccinationTypeId';
    Vaccine1Date : string = this.i + 'Vaccine1Date';
    Vaccine2Date : string = this.i + 'Vaccine2Date';
    BoosterVaccine1TypeId : string = this.i + 'BoosterVaccine1TypeId';
    BoosterVaccineDate : string = this.i + 'BoosterVaccineDate';
    VaccinationCardFileId : string = this.i + 'VaccinationCardFileId';
    CovidVaccinationSubmissionStatusId : string = this.i + 'CovidVaccinationSubmissionStatusId';
    VerifiedDateTime : string = this.i + 'VerifiedDateTime';
    RejectedByUserId : string = this.i + 'RejectedByUserId';
    RejectedDateTime : string = this.i + 'RejectedDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    VerifiedByUserId : string = this.i + 'VerifiedByUserId';

    Relations = {
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeVaccinationSubmission|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
            /** Relation: Covid Vaccination Submission Status */
            CovidVaccinationSubmissionStatus : {
                RelationName: 'CovidVaccinationSubmissionStatus|EmployeeVaccinationSubmission|CovidVaccinationSubmissionStatusId',
                FieldPrefix: 'CovidVaccinationSubmissionStatus',
                PropertyName: 'CovidVaccinationSubmissionStatus'
            },
            /** Relation: Covid Vaccine Type - Vaccination Type */
            CovidVaccineTypeByVaccinationTypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|VaccinationTypeId',
                FieldPrefix: 'VaccinationTypeIdCovidVaccineType',
                PropertyName: 'VaccinationTypeIdCovidVaccineType'
            },
            /** Relation: Covid Vaccine Type - Booster Vaccine1 Type */
            CovidVaccineTypeByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdCovidVaccineType',
                PropertyName: 'BoosterVaccine1TypeIdCovidVaccineType'
            },
            /** Relation: Ethos User - Employee User */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: Ethos User - Rejected By User */
            EthosUserByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|RejectedByUserId',
                FieldPrefix: 'RejectedByEthosUser',
                PropertyName: 'RejectedByEthosUser'
            },
            /** Relation: Ethos User - Verified By User */
            EthosUserByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEthosUser',
                PropertyName: 'VerifiedByEthosUser'
            },
    };
}

export class EquipmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Equipment.';

    constructor() {
        this.ItemDetail.ItemId=2357;
        this.ItemDetail.ItemName='Equipment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EquipmentId : string = this.i + 'EquipmentId';
    Description : string = this.i + 'Description';

    Relations = {
            /** Relation: Request Equipment */
            RequestEquipment : {
                RelationName: 'Equipment|RequestEquipment|EquipmentId',
                FieldPrefix: 'RequestEquipment',
                PropertyName: 'RequestEquipment'
            },
    };
}

export class EquipmentCompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EquipmentCompany.';

    constructor() {
        this.ItemDetail.ItemId=2356;
        this.ItemDetail.ItemName='EquipmentCompany';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EquipmentCompanyId : string = this.i + 'EquipmentCompanyId';
    CompanyId : string = this.i + 'CompanyId';
    EquipmentId : string = this.i + 'EquipmentId';
    DayPrice : string = this.i + 'Day Price';
    WeekPrice : string = this.i + 'Week Price';
    MonthPrice : string = this.i + 'Month Price';

    Relations = {
    };
}

export class EscalationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Escalation.';

    constructor() {
        this.ItemDetail.ItemId=3421;
        this.ItemDetail.ItemName='Escalation';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EscalationId : string = this.i + 'EscalationId';
    KickoffId : string = this.i + 'KickoffId';
    Order : string = this.i + 'Order';
    Name : string = this.i + 'Name';
    Title : string = this.i + 'Title';
    Department : string = this.i + 'Department';
    Company : string = this.i + 'Company';
    Phone : string = this.i + 'Phone';
    Email : string = this.i + 'Email';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    Role : string = this.i + 'Role';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|Escalation|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Escalation|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Escalation|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class EthosAddressMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Address.';

    constructor() {
        this.ItemDetail.ItemId=2640;
        this.ItemDetail.ItemName='Ethos_Address';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AddressId : string = this.i + 'AddressId';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PostalCode : string = this.i + 'PostalCode';
    CountyId : string = this.i + 'CountyId';
    CountyName : string = this.i + 'CountyName';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Ethos County */
            DboEthosCounty : {
                RelationName: 'dbo_Ethos_County|Ethos_Address|CountyId',
                FieldPrefix: 'DboEthosCounty',
                PropertyName: 'DboEthosCounty'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|Ethos_Address|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ethos Site */
            EthosSite : {
                RelationName: 'Ethos_Address|Ethos_Site|AddressId',
                FieldPrefix: 'EthosSite',
                PropertyName: 'EthosSite'
            },
            /** Relation: Staffing Agency - Address - Many */
            EthosStaffingAgencyByStaffingAgencyAddressId : {
                RelationName: 'Ethos_Address|Ethos_StaffingAgency|StaffingAgencyAddressId',
                FieldPrefix: 'StaffingAgencyEthosStaffingAgency',
                PropertyName: 'StaffingAgencyEthosStaffingAgency'
            },
    };
}

export class EthosCodeSetMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeSet.';

    constructor() {
        this.ItemDetail.ItemId=2578;
        this.ItemDetail.ItemName='Ethos_CodeSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeSetId : string = this.i + 'CodeSetId';
    CodeSetName : string = this.i + 'CodeSetName';
    IsCustomCodeSet : string = this.i + 'IsCustomCodeSet';

    Relations = {
            /** Relation: Ethos Code Value */
            EthosCodeValue : {
                RelationName: 'Ethos_CodeSet|Ethos_CodeValue|CodeSetId',
                FieldPrefix: 'EthosCodeValue',
                PropertyName: 'EthosCodeValue'
            },
            /** Relation: Ethos Code Value Custom */
            EthosCodeValueCustom : {
                RelationName: 'Ethos_CodeSet|Ethos_CodeValueCustom|CodeSetId',
                FieldPrefix: 'EthosCodeValueCustom',
                PropertyName: 'EthosCodeValueCustom'
            },
    };
}

export class EthosCodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2579;
        this.ItemDetail.ItemName='Ethos_CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';
    ImagePath : string = this.i + 'ImagePath';

    Relations = {
            /** Relation: Ethos Code Set */
            EthosCodeSet : {
                RelationName: 'Ethos_CodeSet|Ethos_CodeValue|CodeSetId',
                FieldPrefix: 'EthosCodeSet',
                PropertyName: 'EthosCodeSet'
            },
            /** Relation: Ethos Job - Job Category Cv - Many */
            EthosJobByJobCategoryCv : {
                RelationName: 'Ethos_CodeValue|Ethos_Job|JobCategoryCv',
                FieldPrefix: 'JobCategoryCvEthosJob',
                PropertyName: 'JobCategoryCvEthosJob'
            },
            /** Relation: Job Number - Invoice Delivery Type C V - Many */
            EthosJobNumberByInvoiceDeliveryTypeCV : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV',
                FieldPrefix: 'InvoiceDeliveryTypeCVEthosJobNumber',
                PropertyName: 'InvoiceDeliveryTypeCVEthosJobNumber'
            },
            /** Relation: Job Number - Forecast Status Cv - Many */
            EthosJobNumberByForecastStatusCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv',
                FieldPrefix: 'ForecastStatusCvEthosJobNumber',
                PropertyName: 'ForecastStatusCvEthosJobNumber'
            },
            /** Relation: Job Number - Job Number Type Cv - Many */
            EthosJobNumberByJobNumberTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv',
                FieldPrefix: 'JobNumberTypeCvEthosJobNumber',
                PropertyName: 'JobNumberTypeCvEthosJobNumber'
            },
            /** Relation: Ethos User - User Type Cv - Many */
            EthosUserByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosUser',
                PropertyName: 'UserTypeCvEthosUser'
            },
            /** Relation: Ethos User - Resource Group Cv - Many */
            EthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosUser',
                PropertyName: 'ResourceGroupCvEthosUser'
            },
            /** Relation: User Skill - Skill Cv - Many */
            EthosUserSkillBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosUserSkill',
                PropertyName: 'SkillCvEthosUserSkill'
            },
            /** Relation: Wachter Department - Department Type Cv - Many */
            EthosWachterDepartmentByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosWachterDepartment',
                PropertyName: 'DepartmentTypeCvEthosWachterDepartment'
            },
            /** Relation: Wachter Team - Team Type Cv - Many */
            EthosWachterTeamByTeamTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterTeam|TeamTypeCv',
                FieldPrefix: 'TeamTypeCvEthosWachterTeam',
                PropertyName: 'TeamTypeCvEthosWachterTeam'
            },
            /** Relation: Permit - Cable Type Cv - Many */
            PermitByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermit',
                PropertyName: 'CableTypeCvPermit'
            },
            /** Relation: Permit - Permit Type Cv - Many */
            PermitByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermit',
                PropertyName: 'PermitTypeCvPermit'
            },
            /** Relation: Permit - Permit Team Cv - Many */
            PermitByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermit',
                PropertyName: 'PermitTeamCvPermit'
            },
            /** Relation: Permit - Performing Work Cv - Many */
            PermitByPerformingWorkCv : {
                RelationName: 'Ethos_CodeValue|Permit|PerformingWorkCv',
                FieldPrefix: 'PerformingWorkCvPermit',
                PropertyName: 'PerformingWorkCvPermit'
            },
            /** Relation: Permit - Plenum Or Riser Cv - Many */
            PermitByPlenumOrRiserCv : {
                RelationName: 'Ethos_CodeValue|Permit|PlenumOrRiserCv',
                FieldPrefix: 'PlenumOrRiserCvPermit',
                PropertyName: 'PlenumOrRiserCvPermit'
            },
            /** Relation: Permit - Permit Team Cv - Many */
            Permits2PermitByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermits2Permit',
                PropertyName: 'PermitTeamCvPermits2Permit'
            },
            /** Relation: Permit - Plenum Riser Cv - Many */
            Permits2PermitByPlenumRiserCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PlenumRiserCv',
                FieldPrefix: 'PlenumRiserCvPermits2Permit',
                PropertyName: 'PlenumRiserCvPermits2Permit'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            PermitPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitPermitType',
                PropertyName: 'PermitTypeCvPermitPermitType'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            Permits2PermitPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermits2PermitPermitType',
                PropertyName: 'PermitTypeCvPermits2PermitPermitType'
            },
            /** Relation: Permit Request - Cable Type Cv - Many */
            PermitRequestByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermitRequest',
                PropertyName: 'CableTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Permit Team Cv - Many */
            PermitRequestByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermitRequest',
                PropertyName: 'PermitTeamCvPermitRequest'
            },
            /** Relation: Permit Request - Permit Type Cv - Many */
            PermitRequestByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequest',
                PropertyName: 'PermitTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Plenum Riser - Many */
            PermitRequestByPlenumRiser : {
                RelationName: 'Ethos_CodeValue|permitRequest|PlenumRiser',
                FieldPrefix: 'PlenumRiserPermitRequest',
                PropertyName: 'PlenumRiserPermitRequest'
            },
            /** Relation: Permit Request Permit - Permit Type C V - Many */
            PermitRequestPermitByPermitTypeCV : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermit|PermitTypeCV',
                FieldPrefix: 'PermitTypeCVPermitRequestPermit',
                PropertyName: 'PermitTypeCVPermitRequestPermit'
            },
            /** Relation: Permit Request Permit Type - Permit Type Cv - Many */
            PermitRequestPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequestPermitType',
                PropertyName: 'PermitTypeCvPermitRequestPermitType'
            },
            /** Relation: Required Cable - Permit Type Cv - Many */
            RequiredCableByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvRequiredCable',
                PropertyName: 'PermitTypeCvRequiredCable'
            },
            /** Relation: Required Cable - Permit Type Cv - Many */
            Permits2RequiredCableByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermits2RequiredCable',
                PropertyName: 'PermitTypeCvPermits2RequiredCable'
            },
            /** Relation: Ro Ethos User - Resource Group Cv - Many */
            RoEthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvRoEthosUser',
                PropertyName: 'ResourceGroupCvRoEthosUser'
            },
            /** Relation: Ro Ethos User - User Type Cv - Many */
            RoEthosUserByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvRoEthosUser',
                PropertyName: 'UserTypeCvRoEthosUser'
            },
            /** Relation: Star Rating Notification - User Type Cv - Many */
            StarRatingNotificationByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|StarRatingNotification|UserTypeCv',
                FieldPrefix: 'UserTypeCvStarRatingNotification',
                PropertyName: 'UserTypeCvStarRatingNotification'
            },
            /** Relation: Timer Skill Map - Ethos Skill Cv - Many */
            TimerSkillMapByEthosSkillCv : {
                RelationName: 'Ethos_CodeValue|TimerSkillMap|EthosSkillCv',
                FieldPrefix: 'EthosSkillCvTimerSkillMap',
                PropertyName: 'EthosSkillCvTimerSkillMap'
            },
    };
}

export class EthosCodeValueCustomMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom.';

    constructor() {
        this.ItemDetail.ItemId=2643;
        this.ItemDetail.ItemName='Ethos_CodeValueCustom';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueCustomId : string = this.i + 'CodeValueCustomId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Ethos Code Set */
            EthosCodeSet : {
                RelationName: 'Ethos_CodeSet|Ethos_CodeValueCustom|CodeSetId',
                FieldPrefix: 'EthosCodeSet',
                PropertyName: 'EthosCodeSet'
            },
            /** Relation: Ethos Site - Site Type Cv - Many */
            EthosSiteBySiteTypeCv : {
                RelationName: 'Ethos_CodeValueCustom|Ethos_Site|SiteTypeCv',
                FieldPrefix: 'SiteTypeCvEthosSite',
                PropertyName: 'SiteTypeCvEthosSite'
            },
    };
}

export class EthosCountryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Country.';

    constructor() {
        this.ItemDetail.ItemId=2673;
        this.ItemDetail.ItemName='Ethos_Country';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CountryId : string = this.i + 'CountryId';
    CountryName : string = this.i + 'CountryName';
    CountryShortName : string = this.i + 'CountryShortName';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';

    Relations = {
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_Country|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_Country|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_Country|Ethos_StateProvince|CountryId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'Ethos_Country|ProofOfInsurance|CountryId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

export class DboEthosCountyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'dbo_Ethos_County.';

    constructor() {
        this.ItemDetail.ItemId=2703;
        this.ItemDetail.ItemName='dbo_Ethos_County';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CountyId : string = this.i + 'CountyId';
    CountyName : string = this.i + 'CountyName';
    StateProvinceId : string = this.i + 'StateProvinceId';
    CreatedDatetime : string = this.i + 'CreatedDatetime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifedBy : string = this.i + 'ModifedBy';

    Relations = {
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|dbo_Ethos_County|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|dbo_Ethos_County|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modifed By */
            EthosUserByModifedBy : {
                RelationName: 'Ethos_User|dbo_Ethos_County|ModifedBy',
                FieldPrefix: 'ModifedByEthosUser',
                PropertyName: 'ModifedByEthosUser'
            },
            /** Relation: Ethos Address */
            EthosAddress : {
                RelationName: 'dbo_Ethos_County|Ethos_Address|CountyId',
                FieldPrefix: 'EthosAddress',
                PropertyName: 'EthosAddress'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'dbo_Ethos_County|permitRequest|CountyId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

export class EthosCustomerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Customer.';

    constructor() {
        this.ItemDetail.ItemId=2499;
        this.ItemDetail.ItemName='Ethos_Customer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CustomerId : string = this.i + 'CustomerId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    Active : string = this.i + 'Active';

    Relations = {
            /** Relation: Job Number - End - Many */
            EthosJobNumberByEndCustomerId : {
                RelationName: 'Ethos_Customer|Ethos_JobNumber|EndCustomerId',
                FieldPrefix: 'EndEthosJobNumber',
                PropertyName: 'EndEthosJobNumber'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_Customer|Ethos_JobNumber|CustomerId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'Ethos_Customer|Ethos_Opportunity|CustomerId',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_Customer|Ethos_User|CustomerId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: User Extended Ethos Customer */
            UserExtendedEthosCustomer : {
                RelationName: 'Ethos_Customer|UserExtendedEthos_Customer|CustomerId',
                FieldPrefix: 'UserExtendedEthosCustomer',
                PropertyName: 'UserExtendedEthosCustomer'
            },
    };
}

export class EthosJobMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Job.';

    constructor() {
        this.ItemDetail.ItemId=2635;
        this.ItemDetail.ItemName='Ethos_Job';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    JobEtcDateTime : string = this.i + 'JobEtcDateTime';
    LookUpKey : string = this.i + 'LookUpKey';
    JobStatusWs : string = this.i + 'JobStatusWs';
    JobStartDateTime : string = this.i + 'JobStartDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    JobDueDateTime : string = this.i + 'JobDueDateTime';
    CompletedByUserId : string = this.i + 'CompletedByUserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    IsTechOnSite : string = this.i + 'IsTechOnSite';
    JobCategoryCv : string = this.i + 'JobCategoryCv';
    JobNumberPriorityId : string = this.i + 'JobNumberPriorityId';

    Relations = {
            /** Relation: Ethos Code Value - Job Category */
            EthosCodeValueByJobCategoryCv : {
                RelationName: 'Ethos_CodeValue|Ethos_Job|JobCategoryCv',
                FieldPrefix: 'JobCategoryCvEthosCodeValue',
                PropertyName: 'JobCategoryCvEthosCodeValue'
            },
            /** Relation: Ethos Job Site */
            EthosJobSiteByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobSiteJobId',
                PropertyName: 'EthosJobSiteJobId'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority : {
                RelationName: 'Ethos_JobNumberPriority|Ethos_Job|JobNumberPriorityId',
                FieldPrefix: 'EthosJobNumberPriority',
                PropertyName: 'EthosJobNumberPriority'
            },
            /** Relation: Ethos User - Completed By User */
            EthosUserByCompletedByUserId : {
                RelationName: 'Ethos_User|Ethos_Job|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosUser',
                PropertyName: 'CompletedByEthosUser'
            },
            /** Relation: Ethos Workflow Status - Job Status */
            EthosWorkflowStatusByJobStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Job|JobStatusWs',
                FieldPrefix: 'JobStatusWsEthosWorkflowStatus',
                PropertyName: 'JobStatusWsEthosWorkflowStatus'
            },
            /** Relation: Job Number */
            EthosJobNumberByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobNumberJobNumberId',
                PropertyName: 'EthosJobNumberJobNumberId'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Ethos_Job|Permit|JobId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_Job|permits2_Permit|JobId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_Job|permitRequest|JobId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Permit Request - Job - Many */
            PermitRequestByWJID : {
                RelationName: 'Job|PermitRequest|JobId',
                FieldPrefix: 'WJIDPermitRequest',
                PropertyName: 'WJIDPermitRequest'
            },
            /** Relation: Rating - Job - Many */
            RatingByWachterJobId : {
                RelationName: 'Ethos_Job|Rating|WachterJobId',
                FieldPrefix: 'WachterRating',
                PropertyName: 'WachterRating'
            },
            /** Relation: Ro Star Rating Av Projects - Job - Many */
            RoStarRatingAvProjectsByWJID : {
                RelationName: 'roStarRatingAvProjects|Ethos_Job|WJID',
                FieldPrefix: 'WJIDRoStarRatingAvProjects',
                PropertyName: 'WJIDRoStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Job - Many */
            StarRatingAvProjectsByEthosJobId : {
                RelationName: 'Ethos_Job|StarRatingAvProjects|Ethos_JobId',
                FieldPrefix: 'EthosStarRatingAvProjects',
                PropertyName: 'EthosStarRatingAvProjects'
            },
            /** Relation: Star Rating - Field Experience - Job - Many */
            StarRatingFieldExperienceByEthosJobId : {
                RelationName: 'Ethos_Job|StarRatingFieldExperience|Ethos_JobId',
                FieldPrefix: 'EthosStarRatingFieldExperience',
                PropertyName: 'EthosStarRatingFieldExperience'
            },
            /** Relation: Timer - Job - Many */
            TimerByEthosJobId : {
                RelationName: 'Ethos_Job|Timer|Ethos_JobId',
                FieldPrefix: 'EthosTimer',
                PropertyName: 'EthosTimer'
            },
    };
}

export class EthosJobNumberMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';
    LookUpKey : string = this.i + 'LookUpKey';
    IsDeleted : string = this.i + 'IsDeleted';
    JobNumberTypeCv : string = this.i + 'JobNumberTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Invoice Delivery Type */
            EthosCodeValueByInvoiceDeliveryTypeCV : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV',
                FieldPrefix: 'InvoiceDeliveryTypeCVEthosCodeValue',
                PropertyName: 'InvoiceDeliveryTypeCVEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Forecast Status Cv */
            EthosCodeValueByForecastStatusCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv',
                FieldPrefix: 'ForecastStatusCvEthosCodeValue',
                PropertyName: 'ForecastStatusCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Job Number Type */
            EthosCodeValueByJobNumberTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv',
                FieldPrefix: 'JobNumberTypeCvEthosCodeValue',
                PropertyName: 'JobNumberTypeCvEthosCodeValue'
            },
            /** Relation: Customer - End Customer */
            EthosCustomerByEndCustomerId : {
                RelationName: 'Ethos_Customer|Ethos_JobNumber|EndCustomerId',
                FieldPrefix: 'EndEthosCustomer',
                PropertyName: 'EndEthosCustomer'
            },
            /** Relation: Customer */
            EthosCustomer : {
                RelationName: 'Ethos_Customer|Ethos_JobNumber|CustomerId',
                FieldPrefix: 'EthosCustomer',
                PropertyName: 'EthosCustomer'
            },
            /** Relation: Ethos Job */
            EthosJobByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobJobNumberId',
                PropertyName: 'EthosJobJobNumberId'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'Opportunity-JobNumber',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Ethos User - Project Mgr1 User */
            EthosUserByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosUser',
                PropertyName: 'ProjectMgr1EthosUser'
            },
            /** Relation: Ethos User - Project Mgr2 User */
            EthosUserByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosUser',
                PropertyName: 'ProjectMgr2EthosUser'
            },
            /** Relation: Ethos User - Asst Project Mgr User */
            EthosUserByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosUser',
                PropertyName: 'AsstProjectMgrEthosUser'
            },
            /** Relation: Ethos User - Senior Mgr User */
            EthosUserBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosUser',
                PropertyName: 'SeniorMgrEthosUser'
            },
            /** Relation: Ethos User - Lead Tech1 User */
            EthosUserByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosUser',
                PropertyName: 'LeadTech1EthosUser'
            },
            /** Relation: Ethos User - Lead Tech2 User */
            EthosUserByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosUser',
                PropertyName: 'LeadTech2EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval1 User */
            EthosUserByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosUser',
                PropertyName: 'InvoiceApproval1EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval2 User */
            EthosUserByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosUser',
                PropertyName: 'InvoiceApproval2EthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - Job Number Status */
            EthosWorkflowStatusByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberStatusWsEthosWorkflowStatus'
            },
            /** Relation: Billing - Parent - Many */
            BillingByParentJobNumberId : {
                RelationName: 'Ethos_JobNumber|Billing|ParentJobNumberId',
                FieldPrefix: 'ParentBilling',
                PropertyName: 'ParentBilling'
            },
            /** Relation: Billing */
            Billing : {
                RelationName: 'Ethos_JobNumber|Billing|JobNumberId',
                FieldPrefix: 'Billing',
                PropertyName: 'Billing'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Job Number Forecast */
            EthosJobNumberForecast : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumberForecast',
                PropertyName: 'EthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumberPhase',
                PropertyName: 'EthosJobNumberPhase'
            },
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumberPriority',
                PropertyName: 'EthosJobNumberPriority'
            },
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosUser',
                PropertyName: 'UserIdEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team - Overhead - Many */
            EthosWachterTeamByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
            /** Relation: Kickoff - Many */
            KickoffByEthosJobNumberId : {
                RelationName: 'Ethos_JobNumber|Kickoff|Ethos_JobNumberId',
                FieldPrefix: 'EthosKickoff',
                PropertyName: 'EthosKickoff'
            },
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'Ethos_JobNumber|projects_Kickoff|JobNumberId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Maintenance */
            Maintenance : {
                RelationName: 'Ethos_JobNumber|Maintenance|JobNumberId',
                FieldPrefix: 'Maintenance',
                PropertyName: 'Maintenance'
            },
            /** Relation: Overhead Projection */
            OverheadProjection : {
                RelationName: 'Ethos_JobNumber|OverheadProjection|JobNumberId',
                FieldPrefix: 'OverheadProjection',
                PropertyName: 'OverheadProjection'
            },
            /** Relation: Overhead Team Phase */
            OverheadTeamPhase : {
                RelationName: 'Ethos_JobNumber|OverheadTeamPhase|JobNumberId',
                FieldPrefix: 'OverheadTeamPhase',
                PropertyName: 'OverheadTeamPhase'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_JobNumber|permits2_Permit|JobNumberId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumberId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
            /** Relation: Ro Permits - Job Num - Many */
            Permits2RoPermitsByJobNumJobNumberId : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumJobNumberId',
                FieldPrefix: 'JobNumPermits2roPermits',
                PropertyName: 'JobNumPermits2roPermits'
            },
            /** Relation: Ro Project Kickoff */
            RoProjectKickoff : {
                RelationName: 'roProjectKickoff|JobMembership',
                FieldPrefix: 'RoProjectKickoff',
                PropertyName: 'RoProjectKickoff'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'Ethos_JobNumber|fleet_Vehicle|JobNumberId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'Ethos_JobNumber|workplaceAccident|JobNumberId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class EthosJobNumberForecastMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
    };
}

export class EthosJobNumberMembershipMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberMembership.';

    constructor() {
        this.ItemDetail.ItemId=2794;
        this.ItemDetail.ItemName='Ethos_JobNumberMembership';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberMembershipId : string = this.i + 'JobNumberMembershipId';
    UserId : string = this.i + 'UserId';
    JobNumberId : string = this.i + 'JobNumberId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosJobNumberPhaseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Workflow Status - Job Number Phase Status */
            EthosWorkflowStatusByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberPhaseStatusWsEthosWorkflowStatus'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Team - Job Number Phase - Many */
            EthosWachterTeamByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
    };
}

export class EthosJobNumberPriorityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPriority.';

    constructor() {
        this.ItemDetail.ItemId=2792;
        this.ItemDetail.ItemName='Ethos_JobNumberPriority';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPriorityId : string = this.i + 'JobNumberPriorityId';
    JobNumberId : string = this.i + 'JobNumberId';
    PriorityName : string = this.i + 'PriorityName';
    IsDeleted : string = this.i + 'IsDeleted';
    ResponseTimeInHours : string = this.i + 'ResponseTimeInHours';
    StraightHourlyBillingRate : string = this.i + 'StraightHourlyBillingRate';
    OvertimeHourlyBillingRate : string = this.i + 'OvertimeHourlyBillingRate';
    HolidayHourlyBillingRate : string = this.i + 'HolidayHourlyBillingRate';
    TravelHourlyBillingRate : string = this.i + 'TravelHourlyBillingRate';
    MileageBillingRate : string = this.i + 'MileageBillingRate';
    MaxTravelInHours : string = this.i + 'MaxTravelInHours';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    TripCharge : string = this.i + 'TripCharge';
    ExpediteFee : string = this.i + 'ExpediteFee';
    IsEscalationEnabled : string = this.i + 'IsEscalationEnabled';
    SendPriorityNotification : string = this.i + 'SendPriorityNotification';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumberPriority|Ethos_Job|JobNumberPriorityId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

export class EthosJobSiteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSite.';

    constructor() {
        this.ItemDetail.ItemId=2636;
        this.ItemDetail.ItemName='Ethos_JobSite';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSiteId : string = this.i + 'JobSiteId';
    JobId : string = this.i + 'JobId';
    SiteId : string = this.i + 'SiteId';
    IsDeleted : string = this.i + 'IsDeleted';
    LookUpKey : string = this.i + 'LookUpKey';
    SubJobNumber : string = this.i + 'SubJobNumber';
    FullJobNumber : string = this.i + 'FullJobNumber';

    Relations = {
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Site */
            EthosSite : {
                RelationName: 'Ethos_Site|Ethos_JobSite|SiteId',
                FieldPrefix: 'EthosSite',
                PropertyName: 'EthosSite'
            },
            /** Relation: Ethos Job */
            EthosJobByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobJobId',
                PropertyName: 'EthosJobJobId'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Ethos_JobSite|Permit|JobSiteId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'Ethos_JobSite|permits2_Permit|JobSiteId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_JobSite|PermitRequest|JobSiteId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Timer - Job Site - Many */
            TimerByEthosJobSiteId : {
                RelationName: 'Ethos_JobSite|Timer|Ethos_JobSiteId',
                FieldPrefix: 'EthosTimer',
                PropertyName: 'EthosTimer'
            },
    };
}

export class EthosJobSowMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSow.';

    constructor() {
        this.ItemDetail.ItemId=2637;
        this.ItemDetail.ItemName='Ethos_JobSow';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSowId : string = this.i + 'JobSowId';
    SowId : string = this.i + 'SowId';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Sow */
            EthosSow : {
                RelationName: 'Ethos_Sow|Ethos_JobSow|SowId',
                FieldPrefix: 'EthosSow',
                PropertyName: 'EthosSow'
            },
    };
}

export class EthosLaborMetricsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_LaborMetrics.';

    constructor() {
        this.ItemDetail.ItemId=2621;
        this.ItemDetail.ItemName='Ethos_LaborMetrics';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    HoursCurrentWeek : string = this.i + 'HoursCurrentWeek';
    HoursLastWeek : string = this.i + 'HoursLastWeek';
    AverageHours4Week : string = this.i + 'AverageHours4Week';
    AverageHours52Week : string = this.i + 'AverageHours52Week';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_LaborMetrics|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'roEthos_User|Ethos_LaborMetrics|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

export class EthosOpportunityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Opportunity.';

    constructor() {
        this.ItemDetail.ItemId=2693;
        this.ItemDetail.ItemName='Ethos_Opportunity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OpportunityId : string = this.i + 'OpportunityId';
    OpportunityStatusWs : string = this.i + 'OpportunityStatusWs';
    OpportunityName : string = this.i + 'OpportunityName';
    CustomerId : string = this.i + 'CustomerId';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    OpportunityManagerUserId : string = this.i + 'OpportunityManagerUserId';
    ProjectStatusWs : string = this.i + 'ProjectStatusWs';
    StartDate : string = this.i + 'StartDate';
    StopDate : string = this.i + 'StopDate';

    Relations = {
            /** Relation: Customer */
            EthosCustomer : {
                RelationName: 'Ethos_Customer|Ethos_Opportunity|CustomerId',
                FieldPrefix: 'EthosCustomer',
                PropertyName: 'EthosCustomer'
            },
            /** Relation: Ethos User - Opportunity Manager User */
            EthosUserByOpportunityManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|OpportunityManagerUserId',
                FieldPrefix: 'OpportunityManagerEthosUser',
                PropertyName: 'OpportunityManagerEthosUser'
            },
            /** Relation: Ethos User - Project Manager User */
            EthosUserByProjectManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosUser',
                PropertyName: 'ProjectManagerEthosUser'
            },
            /** Relation: Ethos Workflow Status - Opportunity Status */
            EthosWorkflowStatusByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosWorkflowStatus',
                PropertyName: 'OpportunityStatusWsEthosWorkflowStatus'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Opportunity-JobNumber',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_Opportunity|permitRequest|OpportunityId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ro Permits - Permit - Many */
            Permits2RoPermitsByPermitId : {
                RelationName: 'roPermits|Ethos_Opportunity|OpportunityId',
                FieldPrefix: 'PermitIdPermits2roPermits',
                PropertyName: 'PermitIdPermits2roPermits'
            },
    };
}

export class EthosRoUserLaborSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_roUserLaborSummary.';

    constructor() {
        this.ItemDetail.ItemId=2793;
        this.ItemDetail.ItemName='Ethos_roUserLaborSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    YTDAvgWeeklyHrs : string = this.i + 'YTD_AvgWeeklyHrs';
    Last12MonthsAvgWeeklyHrs : string = this.i + 'Last12Months_AvgWeeklyHrs';
    LastMonthAvgWeeklyHrs : string = this.i + 'LastMonth_AvgWeeklyHrs';
    LastWeekHrs : string = this.i + 'LastWeek_Hrs';
    ThisWeekHrs : string = this.i + 'ThisWeek_Hrs';

    Relations = {
    };
}

export class EthosServiceUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_ServiceUser.';

    constructor() {
        this.ItemDetail.ItemId=2676;
        this.ItemDetail.ItemName='Ethos_ServiceUser';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosServiceUserId : string = this.i + 'EthosServiceUserId';
    EthosUserId : string = this.i + 'Ethos_UserId';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_ServiceUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosSiteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Site.';

    constructor() {
        this.ItemDetail.ItemId=2638;
        this.ItemDetail.ItemName='Ethos_Site';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    SiteId : string = this.i + 'SiteId';
    IsDeleted : string = this.i + 'IsDeleted';
    SiteName : string = this.i + 'SiteName';
    AddressId : string = this.i + 'AddressId';
    SiteTypeCv : string = this.i + 'SiteTypeCv';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Ethos Address */
            EthosAddress : {
                RelationName: 'Ethos_Address|Ethos_Site|AddressId',
                FieldPrefix: 'EthosAddress',
                PropertyName: 'EthosAddress'
            },
            /** Relation: Ethos Code Value Custom - Site Type */
            EthosCodeValueCustomBySiteTypeCv : {
                RelationName: 'Ethos_CodeValueCustom|Ethos_Site|SiteTypeCv',
                FieldPrefix: 'SiteTypeCvEthosCodeValueCustom',
                PropertyName: 'SiteTypeCvEthosCodeValueCustom'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_Site|Ethos_JobSite|SiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
    };
}

export class EthosSowMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Sow.';

    constructor() {
        this.ItemDetail.ItemId=2639;
        this.ItemDetail.ItemName='Ethos_Sow';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    SowId : string = this.i + 'SowId';
    SowName : string = this.i + 'SowName';
    SowDescription : string = this.i + 'SowDescription';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_Sow|Ethos_JobSow|SowId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
    };
}

export class EthosStaffingAgencyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_StaffingAgency.';

    constructor() {
        this.ItemDetail.ItemId=2498;
        this.ItemDetail.ItemName='Ethos_StaffingAgency';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';
    ContactName : string = this.i + 'ContactName';
    ContactPhone : string = this.i + 'ContactPhone';
    StaffingAgencyAddressId : string = this.i + 'StaffingAgencyAddressId';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Ethos Address - Staffing Agency Address */
            EthosAddressByStaffingAgencyAddressId : {
                RelationName: 'Ethos_Address|Ethos_StaffingAgency|StaffingAgencyAddressId',
                FieldPrefix: 'StaffingAgencyEthosAddress',
                PropertyName: 'StaffingAgencyEthosAddress'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_StaffingAgency|Ethos_User|StaffingAgencyId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_StaffingAgency|roEthos_User|StaffingAgencyId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

export class EthosStateProvinceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_StateProvince.';

    constructor() {
        this.ItemDetail.ItemId=2363;
        this.ItemDetail.ItemName='Ethos_StateProvince';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StateProvinceId : string = this.i + 'StateProvinceId';
    CountryId : string = this.i + 'CountryId';
    StateProvinceName : string = this.i + 'StateProvinceName';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    StateCode : string = this.i + 'StateCode';

    Relations = {
            /** Relation: Ethos Country */
            EthosCountry : {
                RelationName: 'Ethos_Country|Ethos_StateProvince|CountryId',
                FieldPrefix: 'EthosCountry',
                PropertyName: 'EthosCountry'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_StateProvince|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_StateProvince|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Accident */
            Accident : {
                RelationName: 'Ethos_StateProvince|Accident|StateProvinceId',
                FieldPrefix: 'Accident',
                PropertyName: 'Accident'
            },
            /** Relation: Auction - Location - Many */
            AuctionByLocationStateProvinceId : {
                RelationName: 'Ethos_StateProvince|Auction|LocationStateProvinceId',
                FieldPrefix: 'LocationAuction',
                PropertyName: 'LocationAuction'
            },
            /** Relation: Company License - State - Many */
            CompanyLicenseByStateId : {
                RelationName: 'Ethos_StateProvince|CompanyLicense|StateId',
                FieldPrefix: 'StateIdCompanyLicense',
                PropertyName: 'StateIdCompanyLicense'
            },
            /** Relation: Ethos Address */
            EthosAddress : {
                RelationName: 'Ethos_StateProvince|Ethos_Address|StateProvinceId',
                FieldPrefix: 'EthosAddress',
                PropertyName: 'EthosAddress'
            },
            /** Relation: Ethos County */
            DboEthosCounty : {
                RelationName: 'Ethos_StateProvince|dbo_Ethos_County|StateProvinceId',
                FieldPrefix: 'DboEthosCounty',
                PropertyName: 'DboEthosCounty'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_StateProvince|Ethos_User|StateProvinceId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Licenses - State */
            LicensesByState : {
                RelationName: 'Ethos_StateProvince_Licenses_State',
                FieldPrefix: 'StateLicenses',
                PropertyName: 'StateLicenses'
            },
            /** Relation: Permit - Property Owner State - Many */
            PermitByPropertyOwnerStateId : {
                RelationName: 'Ethos_StateProvince|Permit|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerStateIdPermit',
                PropertyName: 'PropertyOwnerStateIdPermit'
            },
            /** Relation: Permit - Property Owner State - Many */
            Permits2PermitByPropertyOwnerStateId : {
                RelationName: 'Ethos_StateProvince|permits2_Permit|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerStateIdPermits2Permit',
                PropertyName: 'PropertyOwnerStateIdPermits2Permit'
            },
            /** Relation: Permit - Job Number - Many */
            Permits2PermitByJobNumberStateProvinceId : {
                RelationName: 'Ethos_StateProvince|permits2_Permit|JobNumberStateProvinceId',
                FieldPrefix: 'JobNumberPermits2Permit',
                PropertyName: 'JobNumberPermits2Permit'
            },
            /** Relation: Permit Request - Property Owner Name - Many */
            PermitRequestByPropertyOwnerName : {
                RelationName: 'Ethos_StateProvince|PermitRequest|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerNamePermitRequest',
                PropertyName: 'PropertyOwnerNamePermitRequest'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_StateProvince|permitRequest|StateProvinceId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'Ethos_StateProvince|ProofOfInsurance|StateProvinceId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
            /** Relation: Proof Of Insurance - License - Many */
            ProofOfInsuranceByLicenseStateProvinceId : {
                RelationName: 'Ethos_StateProvince|ProofOfInsurance|LicenseStateProvinceId',
                FieldPrefix: 'LicenseProofOfInsurance',
                PropertyName: 'LicenseProofOfInsurance'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_StateProvince|roEthos_User|StateProvinceId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Territory State Province - Many */
            TerritoryStateProvinceByEthosStateProvinceId : {
                RelationName: 'Ethos_StateProvince|TerritoryStateProvince|Ethos_StateProvinceId',
                FieldPrefix: 'EthosTerritoryStateProvince',
                PropertyName: 'EthosTerritoryStateProvince'
            },
            /** Relation: Vehicle - License Plate State - Many */
            VehicleByLicensePlateState : {
                RelationName: 'Ethos_StateProvince|Vehicle|LicensePlateState',
                FieldPrefix: 'LicensePlateStateVehicle',
                PropertyName: 'LicensePlateStateVehicle'
            },
            /** Relation: Vehicle - Driver License State - Many */
            VehicleByDriverLicenseState : {
                RelationName: 'Ethos_StateProvince|Vehicle|DriverLicenseState',
                FieldPrefix: 'DriverLicenseStateVehicle',
                PropertyName: 'DriverLicenseStateVehicle'
            },
            /** Relation: Vehicle - Driver State - Many */
            VehicleByDriverState : {
                RelationName: 'Ethos_StateProvince|Vehicle|DriverState',
                FieldPrefix: 'DriverStateVehicle',
                PropertyName: 'DriverStateVehicle'
            },
            /** Relation: Vehicle - Registration - Many */
            FleetVehicleByRegistrationStateProvinceId : {
                RelationName: 'Ethos_StateProvince|fleet_Vehicle|RegistrationStateProvinceId',
                FieldPrefix: 'RegistrationFleetVehicle',
                PropertyName: 'RegistrationFleetVehicle'
            },
            /** Relation: Vehicle Accident - Accident State - Many */
            VehicleAccidentByAccidentState : {
                RelationName: 'Ethos_StateProvince|VehicleAccident|AccidentState',
                FieldPrefix: 'AccidentStateVehicleAccident',
                PropertyName: 'AccidentStateVehicleAccident'
            },
            /** Relation: Vehicle Accident - Driver State - Many */
            VehicleAccidentByDriverState : {
                RelationName: 'Ethos_StateProvince|VehicleAccident|DriverState',
                FieldPrefix: 'DriverStateVehicleAccident',
                PropertyName: 'DriverStateVehicleAccident'
            },
            /** Relation: Workplace Accident - Accident State - Many */
            WorkplaceAccidentByAccidentState : {
                RelationName: 'Ethos_StateProvince|workplaceAccident|AccidentState',
                FieldPrefix: 'AccidentStateWorkplaceAccident',
                PropertyName: 'AccidentStateWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Employee State - Many */
            WorkplaceAccidentByEmployeeState : {
                RelationName: 'Ethos_StateProvince|workplaceAccident|EmployeeState',
                FieldPrefix: 'EmployeeStateWorkplaceAccident',
                PropertyName: 'EmployeeStateWorkplaceAccident'
            },
    };
}

export class EthosSubcontractorBranchMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_SubcontractorBranch.';

    constructor() {
        this.ItemDetail.ItemId=2433;
        this.ItemDetail.ItemName='Ethos_SubcontractorBranch';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    SubcontractorBranchId : string = this.i + 'SubcontractorBranchId';
    SubcontractorBranchName : string = this.i + 'SubcontractorBranchName';
    SubcontractorBranchIsDeleted : string = this.i + 'SubcontractorBranchIsDeleted';
    IsApprovedBranch : string = this.i + 'IsApprovedBranch';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SubcontractorName : string = this.i + 'SubcontractorName';
    SubcontractorIsDeleted : string = this.i + 'SubcontractorIsDeleted';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Five Star Rating */
            FiveStarRatingBySubcontractorBranchId : {
                RelationName: 'FiveStarRating|Ethos_SubcontractorBranch|SubcontractorBranchId',
                FieldPrefix: 'FiveStarRatingSubcontractorBranchId',
                PropertyName: 'FiveStarRatingSubcontractorBranchId'
            },
            /** Relation: Memo Of Record - Many */
            MemoOfRecordByEthosSubcontractorBranchId : {
                RelationName: 'Ethos_SubcontractorBranch|MemoOfRecord|Ethos_SubcontractorBranchId',
                FieldPrefix: 'EthosMemoOfRecord',
                PropertyName: 'EthosMemoOfRecord'
            },
    };
}

export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Customer */
            EthosCustomer : {
                RelationName: 'Ethos_Customer|Ethos_User|CustomerId',
                FieldPrefix: 'EthosCustomer',
                PropertyName: 'EthosCustomer'
            },
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosJobNumber',
                PropertyName: 'UserIdEthosJobNumber'
            },
            /** Relation: Staffing Agency */
            EthosStaffingAgency : {
                RelationName: 'Ethos_StaffingAgency|Ethos_User|StaffingAgencyId',
                FieldPrefix: 'EthosStaffingAgency',
                PropertyName: 'EthosStaffingAgency'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|Ethos_User|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Job Title */
            EthosWachterJobTitle : {
                RelationName: 'Ethos_WachterJobTitle|Ethos_User|WachterJobTitleId',
                FieldPrefix: 'EthosWachterJobTitle',
                PropertyName: 'EthosWachterJobTitle'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
            /** Relation: Access Control - Created By - Many */
            AccessControlByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAccessControl',
                PropertyName: 'CreatedByEthosAccessControl'
            },
            /** Relation: Access Control - Modified By - Many */
            AccessControlByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAccessControl',
                PropertyName: 'ModifiedByEthosAccessControl'
            },
            /** Relation: Access Control - Created By - Many */
            Permits2AccessControlByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermits2AccessControl',
                PropertyName: 'CreatedByEthosPermits2AccessControl'
            },
            /** Relation: Access Control - Modified By - Many */
            Permits2AccessControlByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermits2AccessControl',
                PropertyName: 'ModifiedByEthosPermits2AccessControl'
            },
            /** Relation: Accident - Modified By - Many */
            AccidentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Accident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAccident',
                PropertyName: 'ModifiedByEthosAccident'
            },
            /** Relation: Accident - Created By - Many */
            AccidentByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Accident|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAccident',
                PropertyName: 'CreatedByEthosAccident'
            },
            /** Relation: Accident - Employee - Many */
            AccidentByEmployeeUserId : {
                RelationName: 'Ethos_User|Accident|EmployeeUserId',
                FieldPrefix: 'EmployeeAccident',
                PropertyName: 'EmployeeAccident'
            },
            /** Relation: Attachment File - Modified By - Many */
            AttachmentAttachmentFileByModifiedBy : {
                RelationName: 'Ethos_User|attachment_AttachmentFile|ModifiedBy',
                FieldPrefix: 'ModifiedByAttachmentAttachmentFile',
                PropertyName: 'ModifiedByAttachmentAttachmentFile'
            },
            /** Relation: Attachment File - Modified By - Many */
            AttachmentFileByModifiedBy : {
                RelationName: 'Ethos_User|AttachmentFile|ModifiedBy',
                FieldPrefix: 'ModifiedByAttachmentFile',
                PropertyName: 'ModifiedByAttachmentFile'
            },
            /** Relation: Attachment File - Created By - Many */
            AttachmentAttachmentFileByCreatedBy : {
                RelationName: 'Ethos_User|attachment_AttachmentFile|CreatedBy',
                FieldPrefix: 'CreatedByAttachmentAttachmentFile',
                PropertyName: 'CreatedByAttachmentAttachmentFile'
            },
            /** Relation: Attachment File - Created By - Many */
            AttachmentFileByCreatedBy : {
                RelationName: 'Ethos_User|AttachmentFile|CreatedBy',
                FieldPrefix: 'CreatedByAttachmentFile',
                PropertyName: 'CreatedByAttachmentFile'
            },
            /** Relation: Attachment Folder - Modified By - Many */
            AttachmentAttachmentFolderByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|attachment_AttachmentFolder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAttachmentAttachmentFolder',
                PropertyName: 'ModifiedByEthosAttachmentAttachmentFolder'
            },
            /** Relation: Attachment Folder - Modified By - Many */
            AttachmentFolderByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AttachmentFolder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAttachmentFolder',
                PropertyName: 'ModifiedByEthosAttachmentFolder'
            },
            /** Relation: Attachment Folder - Created By - Many */
            AttachmentAttachmentFolderByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|attachment_AttachmentFolder|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAttachmentAttachmentFolder',
                PropertyName: 'CreatedByEthosAttachmentAttachmentFolder'
            },
            /** Relation: Attachment Folder - Created By - Many */
            AttachmentFolderByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AttachmentFolder|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAttachmentFolder',
                PropertyName: 'CreatedByEthosAttachmentFolder'
            },
            /** Relation: Auction - Created By - Many */
            AuctionByCreatedByUserId : {
                RelationName: 'Ethos_User|Auction|CreatedByUserId',
                FieldPrefix: 'CreatedByAuction',
                PropertyName: 'CreatedByAuction'
            },
            /** Relation: Auction - Modified By - Many */
            AuctionByModifiedByUserId : {
                RelationName: 'Ethos_User|Auction|ModifiedByUserId',
                FieldPrefix: 'ModifiedByAuction',
                PropertyName: 'ModifiedByAuction'
            },
            /** Relation: Audit Issue - Auditor Ethos - Many */
            AuditIssueByAuditorEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|AuditorEthosUserId',
                FieldPrefix: 'AuditorEthosAuditIssue',
                PropertyName: 'AuditorEthosAuditIssue'
            },
            /** Relation: Audit Issue - Issue Owner Ethos - Many */
            AuditIssueByIssueOwnerEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|IssueOwnerEthosUserId',
                FieldPrefix: 'IssueOwnerEthosAuditIssue',
                PropertyName: 'IssueOwnerEthosAuditIssue'
            },
            /** Relation: Audit Issue - Created By - Many */
            AuditIssueByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAuditIssue',
                PropertyName: 'CreatedByEthosAuditIssue'
            },
            /** Relation: Audit Issue - Modified By - Many */
            AuditIssueByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAuditIssue',
                PropertyName: 'ModifiedByEthosAuditIssue'
            },
            /** Relation: Audit Issue - E L T Manager Ethos - Many */
            AuditIssueByELTManagerEthosUserId : {
                RelationName: 'Ethos_User|AuditIssue|ELTManagerEthosUserId',
                FieldPrefix: 'ELTManagerEthosAuditIssue',
                PropertyName: 'ELTManagerEthosAuditIssue'
            },
            /** Relation: Audit Issue - Delegated Owner Ethos Userid - Many */
            AuditIssueByDelegatedOwnerEthosUserid : {
                RelationName: 'Ethos_User|AuditIssue|DelegatedOwnerEthosUserid',
                FieldPrefix: 'DelegatedOwnerEthosUseridAuditIssue',
                PropertyName: 'DelegatedOwnerEthosUseridAuditIssue'
            },
            /** Relation: Bid History - Created By - Many */
            BidHistoryByCreatedByUserId : {
                RelationName: 'Ethos_User|BidHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByBidHistory',
                PropertyName: 'CreatedByBidHistory'
            },
            /** Relation: Billing - Createdby - Many */
            BillingByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Billing|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosBilling',
                PropertyName: 'CreatedbyEthosBilling'
            },
            /** Relation: Billing - Modified By - Many */
            BillingByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Billing|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosBilling',
                PropertyName: 'ModifiedByEthosBilling'
            },
            /** Relation: Billing Department - Createdby - Many */
            BillingDepartmentByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|BillingDepartment|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosBillingDepartment',
                PropertyName: 'CreatedbyEthosBillingDepartment'
            },
            /** Relation: Billing Department - Modified By - Many */
            BillingDepartmentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|BillingDepartment|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosBillingDepartment',
                PropertyName: 'ModifiedByEthosBillingDepartment'
            },
            /** Relation: Change Request - Created By - Many */
            ChangeRequestByCreatedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CreatedByUserId',
                FieldPrefix: 'CreatedByChangeRequest',
                PropertyName: 'CreatedByChangeRequest'
            },
            /** Relation: Change Request - Completed By - Many */
            ChangeRequestByCompletedByUserId : {
                RelationName: 'Ethos_User|ChangeRequest|CompletedByUserId',
                FieldPrefix: 'CompletedByChangeRequest',
                PropertyName: 'CompletedByChangeRequest'
            },
            /** Relation: Checklist - Createdby - Many */
            ChecklistByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Checklist|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosChecklist',
                PropertyName: 'CreatedbyEthosChecklist'
            },
            /** Relation: Checklist - Modified By - Many */
            ChecklistByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Checklist|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosChecklist',
                PropertyName: 'ModifiedByEthosChecklist'
            },
            /** Relation: Collaboration - From Pm - Many */
            CollaborationByFromPmUserId : {
                RelationName: 'Ethos_User|Collaboration|FromPmUserId',
                FieldPrefix: 'FromPmCollaboration',
                PropertyName: 'FromPmCollaboration'
            },
            /** Relation: Collaboration - Modified By - Many */
            CollaborationByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Collaboration|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosCollaboration',
                PropertyName: 'ModifiedByEthosCollaboration'
            },
            /** Relation: Collaboration - Created By - Many */
            CollaborationByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Collaboration|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosCollaboration',
                PropertyName: 'CreatedByEthosCollaboration'
            },
            /** Relation: Collaboration - To Pm - Many */
            CollaborationByToPmUserId : {
                RelationName: 'Ethos_User|Collaboration|ToPmUserId',
                FieldPrefix: 'ToPmCollaboration',
                PropertyName: 'ToPmCollaboration'
            },
            /** Relation: Collaboration Pm - Project Manager - Many */
            CollaborationPmByProjectManagerId : {
                RelationName: 'Ethos_User|CollaborationPm|ProjectManagerId',
                FieldPrefix: 'ProjectManagerIdCollaborationPm',
                PropertyName: 'ProjectManagerIdCollaborationPm'
            },
            /** Relation: Company License - Qualifier - Many */
            CompanyLicenseByQualifierUserId : {
                RelationName: 'Ethos_User|CompanyLicense|QualifierUserId',
                FieldPrefix: 'QualifierCompanyLicense',
                PropertyName: 'QualifierCompanyLicense'
            },
            /** Relation: Customer Satisfaction - Modified By - Many */
            CustomerSatisfactionByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosCustomerSatisfaction',
                PropertyName: 'ModifiedByEthosCustomerSatisfaction'
            },
            /** Relation: Customer Satisfaction - Pm - Many */
            CustomerSatisfactionByPmUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|PmUserId',
                FieldPrefix: 'PmCustomerSatisfaction',
                PropertyName: 'PmCustomerSatisfaction'
            },
            /** Relation: Customer Satisfaction - Created By - Many */
            CustomerSatisfactionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|CustomerSatisfaction|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosCustomerSatisfaction',
                PropertyName: 'CreatedByEthosCustomerSatisfaction'
            },
            /** Relation: Department Role - Many */
            DepartmentRoleByEthosUserId : {
                RelationName: 'Ethos_User|DepartmentRole|Ethos_UserId',
                FieldPrefix: 'EthosDepartmentRole',
                PropertyName: 'EthosDepartmentRole'
            },
            /** Relation: Emulation User - Emulate - Many */
            EmaulationUserByEmulateEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|EmulateEthos_UserId',
                FieldPrefix: 'EmulateEthosEmaulationUser',
                PropertyName: 'EmulateEthosEmaulationUser'
            },
            /** Relation: Emulation User - Many */
            EmaulationUserByEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|Ethos_UserId',
                FieldPrefix: 'EthosEmaulationUser',
                PropertyName: 'EthosEmaulationUser'
            },
            /** Relation: Employee Review - Modified By - Many */
            EmployeeReviewByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReview|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEmployeeReview',
                PropertyName: 'ModifiedByEthosEmployeeReview'
            },
            /** Relation: Employee Review - Created By - Many */
            EmployeeReviewByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReview|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEmployeeReview',
                PropertyName: 'CreatedByEthosEmployeeReview'
            },
            /** Relation: Employee Review Question Request - Approved By - Many */
            EmployeeReviewQuestionRequestByApprovedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|ApprovedByEthos_UserId',
                FieldPrefix: 'ApprovedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'ApprovedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Review Question Request - Rejected By - Many */
            EmployeeReviewQuestionRequestByRejectedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|RejectedByEthos_UserId',
                FieldPrefix: 'RejectedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'RejectedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Review Question Request - Submitted By - Many */
            EmployeeReviewQuestionRequestBySubmittedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewQuestionRequest|SubmittedByEthos_UserId',
                FieldPrefix: 'SubmittedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'SubmittedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Review Summary - Employee Ethos - Many */
            EmployeeReviewSummaryByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEmployeeReviewSummary',
                PropertyName: 'EmployeeEthosEmployeeReviewSummary'
            },
            /** Relation: Employee Review Summary - Supervisor Ethos - Many */
            EmployeeReviewSummaryBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|SupervisorEthosUserId',
                FieldPrefix: 'SupervisorEthosEmployeeReviewSummary',
                PropertyName: 'SupervisorEthosEmployeeReviewSummary'
            },
            /** Relation: Employee Review Summary - Modified By - Many */
            EmployeeReviewSummaryByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEmployeeReviewSummary',
                PropertyName: 'ModifiedByEthosEmployeeReviewSummary'
            },
            /** Relation: Employee Review Summary - Completed By - Many */
            EmployeeReviewSummaryByCompletedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|CompletedByEthos_UserId',
                FieldPrefix: 'CompletedByEthosEmployeeReviewSummary',
                PropertyName: 'CompletedByEthosEmployeeReviewSummary'
            },
            /** Relation: Employee Review Summary - Createdby - Many */
            EmployeeReviewSummaryByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|EmployeeReviewSummary|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEmployeeReviewSummary',
                PropertyName: 'CreatedbyEthosEmployeeReviewSummary'
            },
            /** Relation: Employee Summary - Employee - Many */
            EmployeeSummaryByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeSummary|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeSummary',
                PropertyName: 'EmployeeEmployeeSummary'
            },
            /** Relation: Employee Summary - Modified By - Many */
            EmployeeSummaryByModifiedBy : {
                RelationName: 'Ethos_User|EmployeeSummary|ModifiedBy',
                FieldPrefix: 'ModifiedByEmployeeSummary',
                PropertyName: 'ModifiedByEmployeeSummary'
            },
            /** Relation: Employee Summary - Created By - Many */
            EmployeeSummaryByCreatedBy : {
                RelationName: 'Ethos_User|EmployeeSummary|CreatedBy',
                FieldPrefix: 'CreatedByEmployeeSummary',
                PropertyName: 'CreatedByEmployeeSummary'
            },
            /** Relation: Employee Test - Employee - Many */
            EmployeeTestByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeTest|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeTest',
                PropertyName: 'EmployeeEmployeeTest'
            },
            /** Relation: Employee Test - Verified By - Many */
            EmployeeTestByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeTest|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEmployeeTest',
                PropertyName: 'VerifiedByEmployeeTest'
            },
            /** Relation: Employee Test - Rejected By - Many */
            EmployeeTestByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeTest|RejectedByUserId',
                FieldPrefix: 'RejectedByEmployeeTest',
                PropertyName: 'RejectedByEmployeeTest'
            },
            /** Relation: Employee Test - Modified By - Many */
            EmployeeTestByModifiedBy : {
                RelationName: 'Ethos_User|EmployeeTest|ModifiedBy',
                FieldPrefix: 'ModifiedByEmployeeTest',
                PropertyName: 'ModifiedByEmployeeTest'
            },
            /** Relation: Employee Test - Created By - Many */
            EmployeeTestByCreatedBy : {
                RelationName: 'Ethos_User|EmployeeTest|CreatedBy',
                FieldPrefix: 'CreatedByEmployeeTest',
                PropertyName: 'CreatedByEmployeeTest'
            },
            /** Relation: Employee Training Needed - Modified By - Many */
            EmployeeTrainingNeededByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEmployeeTrainingNeeded',
                PropertyName: 'ModifiedByEthosEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Assigned To - Many */
            EmployeeTrainingNeededByAssignedToEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|AssignedToEthos_UserId',
                FieldPrefix: 'AssignedToEthosEmployeeTrainingNeeded',
                PropertyName: 'AssignedToEthosEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Created By - Many */
            EmployeeTrainingNeededByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEmployeeTrainingNeeded',
                PropertyName: 'CreatedByEthosEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Employee - Many */
            EmployeeTrainingNeededByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|EmployeeTrainingNeeded|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEmployeeTrainingNeeded',
                PropertyName: 'EmployeeEthosEmployeeTrainingNeeded'
            },
            /** Relation: Employee Vaccination Submission - Employee - Many */
            EmployeeVaccinationSubmissionByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeVaccinationSubmission',
                PropertyName: 'EmployeeEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Vaccination Submission - Rejected By - Many */
            EmployeeVaccinationSubmissionByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|RejectedByUserId',
                FieldPrefix: 'RejectedByEmployeeVaccinationSubmission',
                PropertyName: 'RejectedByEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Vaccination Submission - Verified By - Many */
            EmployeeVaccinationSubmissionByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEmployeeVaccinationSubmission',
                PropertyName: 'VerifiedByEmployeeVaccinationSubmission'
            },
            /** Relation: Escalation - Createdby - Many */
            EscalationByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Escalation|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEscalation',
                PropertyName: 'CreatedbyEthosEscalation'
            },
            /** Relation: Escalation - Modified By - Many */
            EscalationByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Escalation|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEscalation',
                PropertyName: 'ModifiedByEthosEscalation'
            },
            /** Relation: Ethos Country - Modified By - Many */
            EthosCountryByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_Country|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosCountry',
                PropertyName: 'ModifiedByEthosCountry'
            },
            /** Relation: Ethos Country - Created By - Many */
            EthosCountryByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_Country|CreatedBy',
                FieldPrefix: 'CreatedByEthosCountry',
                PropertyName: 'CreatedByEthosCountry'
            },
            /** Relation: Ethos County - Created By - Many */
            DboEthosCountyByCreatedBy : {
                RelationName: 'Ethos_User|dbo_Ethos_County|CreatedBy',
                FieldPrefix: 'CreatedByDboEthosCounty',
                PropertyName: 'CreatedByDboEthosCounty'
            },
            /** Relation: Ethos County - Modifed By - Many */
            DboEthosCountyByModifedBy : {
                RelationName: 'Ethos_User|dbo_Ethos_County|ModifedBy',
                FieldPrefix: 'ModifedByDboEthosCounty',
                PropertyName: 'ModifedByDboEthosCounty'
            },
            /** Relation: Ethos Job - Completed By - Many */
            EthosJobByCompletedByUserId : {
                RelationName: 'Ethos_User|Ethos_Job|CompletedByUserId',
                FieldPrefix: 'CompletedByEthosJob',
                PropertyName: 'CompletedByEthosJob'
            },
            /** Relation: Job Number - Project Mgr1 - Many */
            EthosJobNumberByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosJobNumber',
                PropertyName: 'ProjectMgr1EthosJobNumber'
            },
            /** Relation: Job Number - Project Mgr2 - Many */
            EthosJobNumberByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosJobNumber',
                PropertyName: 'ProjectMgr2EthosJobNumber'
            },
            /** Relation: Job Number - Asst Project Mgr - Many */
            EthosJobNumberByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosJobNumber',
                PropertyName: 'AsstProjectMgrEthosJobNumber'
            },
            /** Relation: Job Number - Senior Mgr - Many */
            EthosJobNumberBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosJobNumber',
                PropertyName: 'SeniorMgrEthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech1 - Many */
            EthosJobNumberByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosJobNumber',
                PropertyName: 'LeadTech1EthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech2 - Many */
            EthosJobNumberByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosJobNumber',
                PropertyName: 'LeadTech2EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval1 - Many */
            EthosJobNumberByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosJobNumber',
                PropertyName: 'InvoiceApproval1EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval2 - Many */
            EthosJobNumberByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosJobNumber',
                PropertyName: 'InvoiceApproval2EthosJobNumber'
            },
            /** Relation: Job Number Forecast - Created By - Many */
            EthosJobNumberForecastByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosJobNumberForecast',
                PropertyName: 'CreatedByEthosJobNumberForecast'
            },
            /** Relation: Job Number Forecast - Modified By - Many */
            EthosJobNumberForecastByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosJobNumberForecast',
                PropertyName: 'ModifiedByEthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Priority - Created By - Many */
            EthosJobNumberPriorityByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosJobNumberPriority',
                PropertyName: 'CreatedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Job Number Priority - Modified By - Many */
            EthosJobNumberPriorityByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosJobNumberPriority',
                PropertyName: 'ModifiedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Labor Metrics */
            EthosLaborMetrics : {
                RelationName: 'Ethos_User|Ethos_LaborMetrics|UserId',
                FieldPrefix: 'EthosLaborMetrics',
                PropertyName: 'EthosLaborMetrics'
            },
            /** Relation: Ethos Opportunity - Opportunity Manager - Many */
            EthosOpportunityByOpportunityManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|OpportunityManagerUserId',
                FieldPrefix: 'OpportunityManagerEthosOpportunity',
                PropertyName: 'OpportunityManagerEthosOpportunity'
            },
            /** Relation: Ethos Opportunity - Project Manager - Many */
            EthosOpportunityByProjectManagerUserId : {
                RelationName: 'Ethos_User|Ethos_Opportunity|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosOpportunity',
                PropertyName: 'ProjectManagerEthosOpportunity'
            },
            /** Relation: Ethos Service User - Many */
            EthosServiceUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_ServiceUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosServiceUser',
                PropertyName: 'EthosEthosServiceUser'
            },
            /** Relation: State Province - Created By - Many */
            EthosStateProvinceByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_StateProvince|CreatedBy',
                FieldPrefix: 'CreatedByEthosStateProvince',
                PropertyName: 'CreatedByEthosStateProvince'
            },
            /** Relation: State Province - Modified By - Many */
            EthosStateProvinceByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_StateProvince|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosStateProvince',
                PropertyName: 'ModifiedByEthosStateProvince'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Wachter Department - Department Director - Many */
            EthosWachterDepartmentByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosWachterDepartment',
                PropertyName: 'DepartmentDirectorEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Manager - Many */
            EthosWachterDepartmentByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosWachterDepartment',
                PropertyName: 'DepartmentManagerEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Asst Manager - Many */
            EthosWachterDepartmentByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosWachterDepartment',
                PropertyName: 'DepartmentAsstManagerEthosWachterDepartment'
            },
            /** Relation: Wachter Team - Team Leader - Many */
            EthosWachterTeamByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosWachterTeam',
                PropertyName: 'TeamLeaderEthosWachterTeam'
            },
            /** Relation: Ethos Role Map - Created By - Many */
            EthosRoleMapByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EthosRoleMap|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosRoleMap',
                PropertyName: 'CreatedByEthosEthosRoleMap'
            },
            /** Relation: Ethos Role Map - Modified By - Many */
            EthosRoleMapByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EthosRoleMap|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosRoleMap',
                PropertyName: 'ModifiedByEthosEthosRoleMap'
            },
            /** Relation: Inspection - Technician - Many */
            InspectionByTechnicianUserId : {
                RelationName: 'Ethos_User|Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianInspection',
                PropertyName: 'TechnicianInspection'
            },
            /** Relation: Inspection - Created By - Many */
            InspectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Inspection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosInspection',
                PropertyName: 'CreatedByEthosInspection'
            },
            /** Relation: Inspection - Created By - Many */
            Permits2InspectionByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|CreatedByUserId',
                FieldPrefix: 'CreatedByPermits2Inspection',
                PropertyName: 'CreatedByPermits2Inspection'
            },
            /** Relation: Inspection - Technician - Many */
            Permits2InspectionByTechnicianUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianPermits2Inspection',
                PropertyName: 'TechnicianPermits2Inspection'
            },
            /** Relation: Kickoff - Createdby - Many */
            KickoffByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Kickoff|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosKickoff',
                PropertyName: 'CreatedbyEthosKickoff'
            },
            /** Relation: Kickoff - Modified By - Many */
            KickoffByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Kickoff|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosKickoff',
                PropertyName: 'ModifiedByEthosKickoff'
            },
            /** Relation: Kickoff - Createdby - Many */
            ProjectsKickoffByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosProjectsKickoff',
                PropertyName: 'CreatedbyEthosProjectsKickoff'
            },
            /** Relation: Kickoff - Modified By - Many */
            ProjectsKickoffByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosProjectsKickoff',
                PropertyName: 'ModifiedByEthosProjectsKickoff'
            },
            /** Relation: Kickoff - Lead Tech - Many */
            ProjectsKickoffByLeadTechUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|LeadTechUserId',
                FieldPrefix: 'LeadTechProjectsKickoff',
                PropertyName: 'LeadTechProjectsKickoff'
            },
            /** Relation: Kickoff Checklist - Createdby - Many */
            KickoffChecklistByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|KickoffChecklist|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosKickoffChecklist',
                PropertyName: 'CreatedbyEthosKickoffChecklist'
            },
            /** Relation: Kickoff Checklist - Modified By - Many */
            KickoffChecklistByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|KickoffChecklist|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosKickoffChecklist',
                PropertyName: 'ModifiedByEthosKickoffChecklist'
            },
            /** Relation: Licenses - Issued To */
            LicensesByIssuedTo : {
                RelationName: 'Ethos_User_Licenses_IssuedTo',
                FieldPrefix: 'IssuedToLicenses',
                PropertyName: 'IssuedToLicenses'
            },
            /** Relation: Licenses - Created By - Many */
            LicensesByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Licenses|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosLicenses',
                PropertyName: 'CreatedByEthosLicenses'
            },
            /** Relation: Licenses - Modified By - Many */
            LicensesByModifiedByEthosUserId : {
                RelationName: 'Ethos_User_Licenses_ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosLicenses',
                PropertyName: 'ModifiedByEthosLicenses'
            },
            /** Relation: Maintenance - Created By - Many */
            MaintenanceByCreatedByUserId : {
                RelationName: 'Ethos_User|Maintenance|CreatedByUserId',
                FieldPrefix: 'CreatedByMaintenance',
                PropertyName: 'CreatedByMaintenance'
            },
            /** Relation: Maintenance - Modified By - Many */
            MaintenanceByModifiedByUserId : {
                RelationName: 'Ethos_User|Maintenance|ModifiedByUserId',
                FieldPrefix: 'ModifiedByMaintenance',
                PropertyName: 'ModifiedByMaintenance'
            },
            /** Relation: Maintenance - Driver - Many */
            MaintenanceByDriverUserId : {
                RelationName: 'Ethos_User|Maintenance|DriverUserId',
                FieldPrefix: 'DriverMaintenance',
                PropertyName: 'DriverMaintenance'
            },
            /** Relation: Medical Record - Created By - Many */
            MedicalRecordByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosMedicalRecord',
                PropertyName: 'CreatedByEthosMedicalRecord'
            },
            /** Relation: Medical Record - Modified By - Many */
            MedicalRecordByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosMedicalRecord',
                PropertyName: 'ModifiedByEthosMedicalRecord'
            },
            /** Relation: Memo Of Record - Employee - Many */
            MemoOfRecordByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosMemoOfRecord',
                PropertyName: 'EmployeeEthosMemoOfRecord'
            },
            /** Relation: Memo Of Record - Supervisor - Many */
            MemoOfRecordBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|SupervisorEthos_UserId',
                FieldPrefix: 'SupervisorEthosMemoOfRecord',
                PropertyName: 'SupervisorEthosMemoOfRecord'
            },
            /** Relation: Memo Of Record - Assigned To - Many */
            MemoOfRecordByAssignedToEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|AssignedToEthos_UserId',
                FieldPrefix: 'AssignedToEthosMemoOfRecord',
                PropertyName: 'AssignedToEthosMemoOfRecord'
            },
            /** Relation: Memo Of Record - Modified By - Many */
            MemoOfRecordByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosMemoOfRecord',
                PropertyName: 'ModifiedByEthosMemoOfRecord'
            },
            /** Relation: Memo Of Record - Created By - Many */
            MemoOfRecordByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|CreatedByEthos_UserId_NotUsed',
                FieldPrefix: 'CreatedByEthosMemoOfRecord',
                PropertyName: 'CreatedByEthosMemoOfRecord'
            },
            /** Relation: Note - Created By - Many */
            NoteByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosNote',
                PropertyName: 'CreatedByEthosNote'
            },
            /** Relation: Note - Created By - Many */
            WcNoteByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosWcNote',
                PropertyName: 'CreatedByEthosWcNote'
            },
            /** Relation: Note - Created By - Many */
            NotesNoteByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosNotesNote',
                PropertyName: 'CreatedByEthosNotesNote'
            },
            /** Relation: Note - Many */
            NumbersNoteByEthosUserId : {
                RelationName: 'Ethos_User|numbers_Note|Ethos_UserId',
                FieldPrefix: 'EthosNumbersNote',
                PropertyName: 'EthosNumbersNote'
            },
            /** Relation: Note - Modified By - Many */
            NotesNoteByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosNotesNote',
                PropertyName: 'ModifiedByEthosNotesNote'
            },
            /** Relation: Notification Config - Supervisor - Many */
            MorNotificationConfigBySupervisorUserId : {
                RelationName: 'Ethos_User|NotificationConfig|SupervisorUserId',
                FieldPrefix: 'SupervisorMorNotificationConfig',
                PropertyName: 'SupervisorMorNotificationConfig'
            },
            /** Relation: Organizational Entity - Created By - Many */
            OrganizationalEntityByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalEntity|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOrganizationalEntity',
                PropertyName: 'CreatedByEthosOrganizationalEntity'
            },
            /** Relation: Organizational Membership - Many */
            OrganizationalMembershipByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalMembership|Ethos_UserId',
                FieldPrefix: 'EthosOrganizationalMembership',
                PropertyName: 'EthosOrganizationalMembership'
            },
            /** Relation: Organizational Unit - Created By - Many */
            OrganizationalUnitByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalUnit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOrganizationalUnit',
                PropertyName: 'CreatedByEthosOrganizationalUnit'
            },
            /** Relation: Organizational Unit - Director - Many */
            OrganizationalUnitByDirectorEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalUnit|DirectorEthos_UserId',
                FieldPrefix: 'DirectorEthosOrganizationalUnit',
                PropertyName: 'DirectorEthosOrganizationalUnit'
            },
            /** Relation: Overhead Projection - Modified By - Many */
            OverheadProjectionByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosOverheadProjection',
                PropertyName: 'ModifiedByEthosOverheadProjection'
            },
            /** Relation: Overhead Projection - Created By - Many */
            OverheadProjectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOverheadProjection',
                PropertyName: 'CreatedByEthosOverheadProjection'
            },
            /** Relation: Overhead Team Phase - Modified By - Many */
            OverheadTeamPhaseByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosOverheadTeamPhase',
                PropertyName: 'ModifiedByEthosOverheadTeamPhase'
            },
            /** Relation: Overhead Team Phase - Created By - Many */
            OverheadTeamPhaseByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOverheadTeamPhase',
                PropertyName: 'CreatedByEthosOverheadTeamPhase'
            },
            /** Relation: Paf History - Created By - Many */
            PafHistoryByCreatedByUserId : {
                RelationName: 'Ethos_User|PafHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByPafHistory',
                PropertyName: 'CreatedByPafHistory'
            },
            /** Relation: Pass History - Created By - Many */
            PassHistoryByCreatedByUserId : {
                RelationName: 'Ethos_User|PassHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByPassHistory',
                PropertyName: 'CreatedByPassHistory'
            },
            /** Relation: PAF Pay/Job Change - Employee - Many */
            PayJobChangeByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosPayJobChange',
                PropertyName: 'EmployeeEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - Createdby - Many */
            PayJobChangeByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosPayJobChange',
                PropertyName: 'CreatedbyEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - New Manager - Many */
            PayJobChangeByNewManagerEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|NewManagerEthos_UserId',
                FieldPrefix: 'NewManagerEthosPayJobChange',
                PropertyName: 'NewManagerEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - Modified By - Many */
            PayJobChangeByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPayJobChange',
                PropertyName: 'ModifiedByEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - Status Assigned To - Many */
            PayJobChangeByStatusAssignedToEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|StatusAssignedToEthos_UserId',
                FieldPrefix: 'StatusAssignedToEthosPayJobChange',
                PropertyName: 'StatusAssignedToEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - Rejected By - Many */
            PayJobChangeByRejectedByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|RejectedByEthos_UserId',
                FieldPrefix: 'RejectedByEthosPayJobChange',
                PropertyName: 'RejectedByEthosPayJobChange'
            },
            /** Relation: Pay Job Change Users Read - Many */
            PayJobChangeUsersReadByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChangeUsersRead|Ethos_UserId',
                FieldPrefix: 'EthosPayJobChangeUsersRead',
                PropertyName: 'EthosPayJobChangeUsersRead'
            },
            /** Relation: Permit - Requested By User - Many */
            PermitByRequestedByUser : {
                RelationName: 'Ethos_User|Permit|RequestedByUser',
                FieldPrefix: 'RequestedByUserPermit',
                PropertyName: 'RequestedByUserPermit'
            },
            /** Relation: Permit - Created By - Many */
            PermitByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermit',
                PropertyName: 'CreatedByEthosPermit'
            },
            /** Relation: Permit - Modified By - Many */
            PermitByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermit',
                PropertyName: 'ModifiedByEthosPermit'
            },
            /** Relation: Permit - Assigned To User - Many */
            PermitByAssignedToUser : {
                RelationName: 'Ethos_User|Permit|AssignedToUser',
                FieldPrefix: 'AssignedToUserPermit',
                PropertyName: 'AssignedToUserPermit'
            },
            /** Relation: Permit - Created By - Many */
            Permits2PermitByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|CreatedByUserId',
                FieldPrefix: 'CreatedByPermits2Permit',
                PropertyName: 'CreatedByPermits2Permit'
            },
            /** Relation: Permit - Modified By - Many */
            Permits2PermitByModifiedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|ModifiedByUserId',
                FieldPrefix: 'ModifiedByPermits2Permit',
                PropertyName: 'ModifiedByPermits2Permit'
            },
            /** Relation: Permit - Requested By - Many */
            Permits2PermitByRequestedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|RequestedByUserId',
                FieldPrefix: 'RequestedByPermits2Permit',
                PropertyName: 'RequestedByPermits2Permit'
            },
            /** Relation: Permit - Assigned To - Many */
            Permits2PermitByAssignedToUserId : {
                RelationName: 'Ethos_User|permits2_Permit|AssignedToUserId',
                FieldPrefix: 'AssignedToPermits2Permit',
                PropertyName: 'AssignedToPermits2Permit'
            },
            /** Relation: Permit Request - Created By - Many */
            PermitRequestByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermitRequest',
                PropertyName: 'CreatedByEthosPermitRequest'
            },
            /** Relation: Permit Request - Assigned To - Many */
            PermitRequestByAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|AssignedToUserId',
                FieldPrefix: 'AssignedToPermitRequest',
                PropertyName: 'AssignedToPermitRequest'
            },
            /** Relation: Permit Request - Secondary Assigned To - Many */
            PermitRequestBySecondaryAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|SecondaryAssignedToUserId',
                FieldPrefix: 'SecondaryAssignedToPermitRequest',
                PropertyName: 'SecondaryAssignedToPermitRequest'
            },
            /** Relation: Permit Request - Requested By - Many */
            PermitRequestByRequestedByUserId : {
                RelationName: 'Ethos_User|permitRequest|RequestedByUserId',
                FieldPrefix: 'RequestedByPermitRequest',
                PropertyName: 'RequestedByPermitRequest'
            },
            /** Relation: Permit Request - Modified By - Many */
            PermitRequestByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermitRequest',
                PropertyName: 'ModifiedByEthosPermitRequest'
            },
            /** Relation: Plate History - Created By - Many */
            PlateHistoryByCreatedByUserId : {
                RelationName: 'Ethos_User|PlateHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByPlateHistory',
                PropertyName: 'CreatedByPlateHistory'
            },
            /** Relation: Project Milestone - Createdby - Many */
            ProjectMilestoneByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|ProjectMilestone|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosProjectMilestone',
                PropertyName: 'CreatedbyEthosProjectMilestone'
            },
            /** Relation: Project Milestone - Modified By - Many */
            ProjectMilestoneByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ProjectMilestone|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosProjectMilestone',
                PropertyName: 'ModifiedByEthosProjectMilestone'
            },
            /** Relation: Proof Of Insurance - Modified By - Many */
            ProofOfInsuranceByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ProofOfInsurance|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosProofOfInsurance',
                PropertyName: 'ModifiedByEthosProofOfInsurance'
            },
            /** Relation: Proof Of Insurance - Created By - Many */
            ProofOfInsuranceByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|ProofOfInsurance|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosProofOfInsurance',
                PropertyName: 'CreatedByEthosProofOfInsurance'
            },
            /** Relation: Proof Of Insurance Job Titles */
            ProofOfInsuranceJobTitlesByWachterJobTitleId : {
                RelationName: 'Ethos_User|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'ProofOfInsuranceJobTitlesWachterJobTitleId',
                PropertyName: 'ProofOfInsuranceJobTitlesWachterJobTitleId'
            },
            /** Relation: Proof Of Insurance Summary - Employee - Many */
            ProofOfInsuranceSummaryByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|EthosUser|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosProofOfInsuranceSummary',
                PropertyName: 'EmployeeEthosProofOfInsuranceSummary'
            },
            /** Relation: Rating - Created By - Many */
            RatingByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Rating|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRating',
                PropertyName: 'CreatedByEthosRating'
            },
            /** Relation: Reporting - Createdby - Many */
            ReportingByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Reporting|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosReporting',
                PropertyName: 'CreatedbyEthosReporting'
            },
            /** Relation: Reporting - Modified By - Many */
            ReportingByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Reporting|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosReporting',
                PropertyName: 'ModifiedByEthosReporting'
            },
            /** Relation: Request - Created By - Many */
            RequestByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Request|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRequest',
                PropertyName: 'CreatedByEthosRequest'
            },
            /** Relation: Request - Modified By - Many */
            RequestByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Request|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRequest',
                PropertyName: 'ModifiedByEthosRequest'
            },
            /** Relation: Request - Project Manager - Many */
            TravelRequestByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|travel_Request|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosTravelRequest',
                PropertyName: 'ProjectManagerEthosTravelRequest'
            },
            /** Relation: Request - Traveler - Many */
            TravelRequestByTravelerEthosUserId : {
                RelationName: 'Ethos_User|travel_Request|TravelerEthos_UserId',
                FieldPrefix: 'TravelerEthosTravelRequest',
                PropertyName: 'TravelerEthosTravelRequest'
            },
            /** Relation: Request Preferences - Modified By - Many */
            RequestPreferencesByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequestPreferences|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRequestPreferences',
                PropertyName: 'ModifiedByEthosRequestPreferences'
            },
            /** Relation: Request Preferences - Created By - Many */
            RequestPreferencesByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequestPreferences|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRequestPreferences',
                PropertyName: 'CreatedByEthosRequestPreferences'
            },
            /** Relation: Required Cable - Modified By - Many */
            RequiredCableByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRequiredCable',
                PropertyName: 'ModifiedByEthosRequiredCable'
            },
            /** Relation: Required Cable - Created By - Many */
            RequiredCableByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRequiredCable',
                PropertyName: 'CreatedByEthosRequiredCable'
            },
            /** Relation: Required Cable - Created By - Many */
            Permits2RequiredCableByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermits2RequiredCable',
                PropertyName: 'CreatedByEthosPermits2RequiredCable'
            },
            /** Relation: Required Cable - Modified By - Many */
            Permits2RequiredCableByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermits2RequiredCable',
                PropertyName: 'ModifiedByEthosPermits2RequiredCable'
            },
            /** Relation: Resource Cost - Current User Ethos - Many */
            ResourceCostByCurrentUserEthosId : {
                RelationName: 'Ethos_User|resourceCost|CurrentUserEthosId',
                FieldPrefix: 'CurrentUserEthosIdResourceCost',
                PropertyName: 'CurrentUserEthosIdResourceCost'
            },
            /** Relation: Resource Cost - Many */
            ResourceCostByEthosUserId : {
                RelationName: 'Ethos_User|resourceCost|Ethos_UserId',
                FieldPrefix: 'EthosResourceCost',
                PropertyName: 'EthosResourceCost'
            },
            /** Relation: Review - Modified By - Many */
            ReviewByModifiedByUserId : {
                RelationName: 'Ethos_User|Review|ModifiedByUserId',
                FieldPrefix: 'ModifiedByReview',
                PropertyName: 'ModifiedByReview'
            },
            /** Relation: Review - Created By - Many */
            ReviewByCreatedByUserId : {
                RelationName: 'Ethos_User|Review|CreatedByUserId',
                FieldPrefix: 'CreatedByReview',
                PropertyName: 'CreatedByReview'
            },
            /** Relation: Ro Ethos User Burdon - Many */
            RoEthosUserBurdonByEthosUserId : {
                RelationName: 'roEthos_UserBurden|Ethos_User|UserId',
                FieldPrefix: 'EthosRoEthosUserBurdon',
                PropertyName: 'EthosRoEthosUserBurdon'
            },
            /** Relation: Ro All Supervisors Subordinates */
            RoAllSupervisorsSubordinates : {
                RelationName: 'Ethos_User|roAllSupervisorsSubordinates|UserId',
                FieldPrefix: 'RoAllSupervisorsSubordinates',
                PropertyName: 'RoAllSupervisorsSubordinates'
            },
            /** Relation: Ro All Supervisors Subordinates - Supervisor - Many */
            RoAllSupervisorsSubordinatesBySupervisorUserId : {
                RelationName: 'Ethos_User|roAllSupervisorsSubordinates|SupervisorUserId',
                FieldPrefix: 'SupervisorRoAllSupervisorsSubordinates',
                PropertyName: 'SupervisorRoAllSupervisorsSubordinates'
            },
            /** Relation: Ro Employee Review Summary Current - Employee Ethos - Many */
            RoEmployeeReviewSummaryCurrentByEmployeeEthosUserId : {
                RelationName: 'roEmployeeReviewSummaryCurrent|EthosUser|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosRoEmployeeReviewSummaryCurrent',
                PropertyName: 'EmployeeEthosRoEmployeeReviewSummaryCurrent'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ro Permits - Project Manager - Many */
            Permits2RoPermitsByProjectManagerUserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerPermits2roPermits',
                PropertyName: 'ProjectManagerPermits2roPermits'
            },
            /** Relation: Ro Permits - Project Manager2 - Many */
            Permits2RoPermitsByProjectManager2UserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManager2UserId',
                FieldPrefix: 'ProjectManager2Permits2roPermits',
                PropertyName: 'ProjectManager2Permits2roPermits'
            },
            /** Relation: Stage Audit Log - Status Updated By - Many */
            StageAuditLogByStatusUpdatedByUserId : {
                RelationName: 'Ethos_User|StageAuditLog|StatusUpdatedByUserId',
                FieldPrefix: 'StatusUpdatedByStageAuditLog',
                PropertyName: 'StatusUpdatedByStageAuditLog'
            },
            /** Relation: Stakeholder - Createdby - Many */
            StakeholderByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Stakeholder|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosStakeholder',
                PropertyName: 'CreatedbyEthosStakeholder'
            },
            /** Relation: Stakeholder - Modified By - Many */
            StakeholderByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Stakeholder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosStakeholder',
                PropertyName: 'ModifiedByEthosStakeholder'
            },
            /** Relation: Star Rating Av Projects - Created By - Many */
            StarRatingAvProjectsByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosStarRatingAvProjects',
                PropertyName: 'CreatedByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Followed Up By - Many */
            StarRatingAvProjectsByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosStarRatingAvProjects',
                PropertyName: 'FollowedUpByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Modified By - Many */
            StarRatingAvProjectsByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosStarRatingAvProjects',
                PropertyName: 'ModifiedByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Project Manager - Many */
            StarRatingAvProjectsByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosStarRatingAvProjects',
                PropertyName: 'ProjectManagerEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Nsp Install Technician - Many */
            StarRatingAvProjectsByNspInstallTechnicianUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|NspInstallTechnicianUserId',
                FieldPrefix: 'NspInstallTechnicianStarRatingAvProjects',
                PropertyName: 'NspInstallTechnicianStarRatingAvProjects'
            },
            /** Relation: Star Rating - Field Experience - Project Manager - Many */
            StarRatingFieldExperienceByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosStarRatingFieldExperience',
                PropertyName: 'ProjectManagerEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Created By - Many */
            StarRatingFieldExperienceByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosStarRatingFieldExperience',
                PropertyName: 'CreatedByEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Modified By - Many */
            StarRatingFieldExperienceByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosStarRatingFieldExperience',
                PropertyName: 'ModifiedByEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Followed Up By - Many */
            StarRatingFieldExperienceByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosStarRatingFieldExperience',
                PropertyName: 'FollowedUpByEthosStarRatingFieldExperience'
            },
            /** Relation: Template - Modified By - Many */
            TemplateByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Template|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosTemplate',
                PropertyName: 'ModifiedByEthosTemplate'
            },
            /** Relation: Template - Createdby - Many */
            TemplateByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Template|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosTemplate',
                PropertyName: 'CreatedbyEthosTemplate'
            },
            /** Relation: PAF Term/Resign - Employee - Many */
            TermResignByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|TermResign|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosTermResign',
                PropertyName: 'EmployeeEthosTermResign'
            },
            /** Relation: PAF Term/Resign - Modified By - Many */
            TermResignByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|TermResign|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosTermResign',
                PropertyName: 'ModifiedByEthosTermResign'
            },
            /** Relation: PAF Term/Resign - Createdby - Many */
            TermResignByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|TermResign|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosTermResign',
                PropertyName: 'CreatedbyEthosTermResign'
            },
            /** Relation: Territory - Modified By - Many */
            TerritoryByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Territory|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosTerritory',
                PropertyName: 'ModifiedByEthosTerritory'
            },
            /** Relation: Territory - Created By - Many */
            TerritoryByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Territory|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosTerritory',
                PropertyName: 'CreatedByEthosTerritory'
            },
            /** Relation: Timer - Createdby - Many */
            TimerByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Timer|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosTimer',
                PropertyName: 'CreatedbyEthosTimer'
            },
            /** Relation: Timer - Modified By - Many */
            TimerByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Timer|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosTimer',
                PropertyName: 'ModifiedByEthosTimer'
            },
            /** Relation: Timer - Tech - Many */
            TimerByTechEthosUserId : {
                RelationName: 'Ethos_User|Timer|TechEthos_UserId',
                FieldPrefix: 'TechEthosTimer',
                PropertyName: 'TechEthosTimer'
            },
            /** Relation: Traveler - Modified By - Many */
            TravelerByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Traveler|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosTraveler',
                PropertyName: 'ModifiedByEthosTraveler'
            },
            /** Relation: Traveler - Traveler - Many */
            TravelerByTravelerEthosUserId : {
                RelationName: 'Ethos_User|Traveler|TravelerEthos_UserId',
                FieldPrefix: 'TravelerEthosTraveler',
                PropertyName: 'TravelerEthosTraveler'
            },
            /** Relation: Traveler - Created By - Many */
            TravelerByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Traveler|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosTraveler',
                PropertyName: 'CreatedByEthosTraveler'
            },
            /** Relation: Trust User Merged - New  - Many */
            TrustUserMergedByNewUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|New_UserId',
                FieldPrefix: 'NewTrustUserMerged',
                PropertyName: 'NewTrustUserMerged'
            },
            /** Relation: Trust User Merged - Old  - Many */
            TrustUserMergedByOldUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|Old_UserId',
                FieldPrefix: 'OldTrustUserMerged',
                PropertyName: 'OldTrustUserMerged'
            },
            /** Relation: User Extended - Many */
            UserExtendedByEthosUserId : {
                RelationName: 'Ethos_User|UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosUserExtended',
                PropertyName: 'EthosUserExtended'
            },
            /** Relation: User Extended - Many */
            MtlUserExtendedByEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosMtlUserExtended',
                PropertyName: 'EthosMtlUserExtended'
            },
            /** Relation: User Extended - Fos - Many */
            MtlUserExtendedByFosEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|FosEthos_UserId',
                FieldPrefix: 'FosEthosMtlUserExtended',
                PropertyName: 'FosEthosMtlUserExtended'
            },
            /** Relation: User Extended - Fos Office Supervisor - Many */
            EmsUserExtendedByFosOfficeSupervisorEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|FosOfficeSupervisorEthos_UserId',
                FieldPrefix: 'FosOfficeSupervisorEthosEmsUserExtended',
                PropertyName: 'FosOfficeSupervisorEthosEmsUserExtended'
            },
            /** Relation: User Extended - Hiring Manager - Many */
            EmsUserExtendedByHiringManagerEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|HiringManagerEthos_UserId',
                FieldPrefix: 'HiringManagerEthosEmsUserExtended',
                PropertyName: 'HiringManagerEthosEmsUserExtended'
            },
            /** Relation: User Extended - Hiring Manager - Many */
            MtlUserExtendedByHiringManagerEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|HiringManagerEthos_UserId',
                FieldPrefix: 'HiringManagerEthosMtlUserExtended',
                PropertyName: 'HiringManagerEthosMtlUserExtended'
            },
            /** Relation: User Extended - Modified By - Many */
            EmsUserExtendedByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEmsUserExtended',
                PropertyName: 'ModifiedByEthosEmsUserExtended'
            },
            /** Relation: User Extended - Modified By - Many */
            MtlUserExtendedByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosMtlUserExtended',
                PropertyName: 'ModifiedByEthosMtlUserExtended'
            },
            /** Relation: User Extended - Operations Manager - Many */
            EmsUserExtendedByOperationsManagerEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|OperationsManagerEthos_UserId',
                FieldPrefix: 'OperationsManagerEthosEmsUserExtended',
                PropertyName: 'OperationsManagerEthosEmsUserExtended'
            },
            /** Relation: User Extended - Previous Manager - Many */
            EmsUserExtendedByPreviousManager : {
                RelationName: 'Ethos_User|ems_UserExtended|PreviousManager',
                FieldPrefix: 'PreviousManagerEmsUserExtended',
                PropertyName: 'PreviousManagerEmsUserExtended'
            },
            /** Relation: User Extended - Created By - Many */
            EmsUserExtendedByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEmsUserExtended',
                PropertyName: 'CreatedByEthosEmsUserExtended'
            },
            /** Relation: User Extended - Employee - Many */
            EmsUserExtendedByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEmsUserExtended',
                PropertyName: 'EmployeeEthosEmsUserExtended'
            },
            /** Relation: User Projection - Modified By - Many */
            WcUserProjectionByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWcUserProjection',
                PropertyName: 'ModifiedByEthosWcUserProjection'
            },
            /** Relation: User Projection - Created By - Many */
            WcUserProjectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosWcUserProjection',
                PropertyName: 'CreatedByEthosWcUserProjection'
            },
            /** Relation: User Projection - Many */
            WcUserProjectionByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|Ethos_UserId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
            /** Relation: User Read - Many */
            WcUserReadByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserRead|Ethos_UserId',
                FieldPrefix: 'EthosWcUserRead',
                PropertyName: 'EthosWcUserRead'
            },
            /** Relation: User Read - Many */
            UserReadByEthosUserId : {
                RelationName: 'Ethos_User|UserRead|Ethos_UserId',
                FieldPrefix: 'EthosUserRead',
                PropertyName: 'EthosUserRead'
            },
            /** Relation: Vehicle - Modified By - Many */
            VehicleByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicle',
                PropertyName: 'ModifiedByEthosVehicle'
            },
            /** Relation: Vehicle - Createdby - Many */
            VehicleByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicle',
                PropertyName: 'CreatedbyEthosVehicle'
            },
            /** Relation: Vehicle - Driver - Many */
            FleetVehicleByDriverUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|DriverUserId',
                FieldPrefix: 'DriverFleetVehicle',
                PropertyName: 'DriverFleetVehicle'
            },
            /** Relation: Vehicle - Created By - Many */
            FleetVehicleByCreatedByUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|CreatedByUserId',
                FieldPrefix: 'CreatedByFleetVehicle',
                PropertyName: 'CreatedByFleetVehicle'
            },
            /** Relation: Vehicle - Modified By - Many */
            FleetVehicleByModifiedByUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|ModifiedByUserId',
                FieldPrefix: 'ModifiedByFleetVehicle',
                PropertyName: 'ModifiedByFleetVehicle'
            },
            /** Relation: Vehicle Accident - Modified By - Many */
            VehicleAccidentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicleAccident',
                PropertyName: 'ModifiedByEthosVehicleAccident'
            },
            /** Relation: Vehicle Accident - Createdby - Many */
            VehicleAccidentByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicleAccident',
                PropertyName: 'CreatedbyEthosVehicleAccident'
            },
            /** Relation: Wage Expense - Created By - Many */
            WageExpenseByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosWageExpense',
                PropertyName: 'CreatedByEthosWageExpense'
            },
            /** Relation: Wage Expense - Modified By - Many */
            WageExpenseByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWageExpense',
                PropertyName: 'ModifiedByEthosWageExpense'
            },
            /** Relation: Witness - Modified By - Many */
            WitnessByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Witness|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWitness',
                PropertyName: 'ModifiedByEthosWitness'
            },
            /** Relation: Witness - Createdby - Many */
            WitnessByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Witness|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosWitness',
                PropertyName: 'CreatedbyEthosWitness'
            },
            /** Relation: Workplace Accident - Modified By - Many */
            WorkplaceAccidentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWorkplaceAccident',
                PropertyName: 'ModifiedByEthosWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Createdby - Many */
            WorkplaceAccidentByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosWorkplaceAccident',
                PropertyName: 'CreatedbyEthosWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Many */
            WorkplaceAccidentByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|Ethos_UserId',
                FieldPrefix: 'EthosWorkplaceAccident',
                PropertyName: 'EthosWorkplaceAccident'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos Code Value - Skill */
            EthosCodeValueBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosCodeValue',
                PropertyName: 'SkillCvEthosCodeValue'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosWachterCompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterCompany.';

    constructor() {
        this.ItemDetail.ItemId=2804;
        this.ItemDetail.ItemName='Ethos_WachterCompany';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterCompanyId : string = this.i + 'WachterCompanyId';
    WachterCompanyName : string = this.i + 'WachterCompanyName';
    WachterCompanyShortName : string = this.i + 'WachterCompanyShortName';
    PresidentUserId : string = this.i + 'PresidentUserId';
    VicePresidentUserId : string = this.i + 'VicePresidentUserId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Company License */
            CompanyLicense : {
                RelationName: 'Ethos_WachterCompany|CompanyLicense|achterCompanyId',
                FieldPrefix: 'CompanyLicense',
                PropertyName: 'CompanyLicense'
            },
    };
}

export class EthosWachterDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2388;
        this.ItemDetail.ItemName='Ethos_WachterDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentTypeCv : string = this.i + 'DepartmentTypeCv';
    DepartmentTypeMeaning : string = this.i + 'DepartmentTypeMeaning';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DepartmentDirectorUserId : string = this.i + 'DepartmentDirectorUserId';
    IsDeleted : string = this.i + 'IsDeleted';
    DepartmentManagerUserId : string = this.i + 'DepartmentManagerUserId';
    DepartmentAsstManagerUserId : string = this.i + 'DepartmentAsstManagerUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos Code Value - Department Type */
            EthosCodeValueByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosCodeValue',
                PropertyName: 'DepartmentTypeCvEthosCodeValue'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId',
                FieldPrefix: 'EthosJobNumberPhase',
                PropertyName: 'EthosJobNumberPhase'
            },
            /** Relation: Ethos User - Department Director User */
            EthosUserByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosUser',
                PropertyName: 'DepartmentDirectorEthosUser'
            },
            /** Relation: Ethos User - Department Manager User */
            EthosUserByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosUser',
                PropertyName: 'DepartmentManagerEthosUser'
            },
            /** Relation: Ethos User - Department Asst Manager User */
            EthosUserByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosUser',
                PropertyName: 'DepartmentAsstManagerEthosUser'
            },
            /** Relation: Ethos Wachter Division */
            EthosWachterDivision : {
                RelationName: 'WachterDepartment|WachterDivision|WachterDivisionId',
                FieldPrefix: 'EthosWachterDivision',
                PropertyName: 'EthosWachterDivision'
            },
            /** Relation: Billing Department */
            BillingDepartment : {
                RelationName: 'Ethos_WachterDepartment|BillingDepartment|WachterDepartmentId',
                FieldPrefix: 'BillingDepartment',
                PropertyName: 'BillingDepartment'
            },
            /** Relation: Collaboration - From Department - Many */
            CollaborationByFromDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|Collaboration|FromDepartmentId',
                FieldPrefix: 'FromDepartmentIdCollaboration',
                PropertyName: 'FromDepartmentIdCollaboration'
            },
            /** Relation: Collaboration - To Department - Many */
            CollaborationByToDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|Collaboration|ToDepartmentId',
                FieldPrefix: 'ToDepartmentIdCollaboration',
                PropertyName: 'ToDepartmentIdCollaboration'
            },
            /** Relation: Collaboration Department - Department - Many */
            CollaborationDepartmentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|CollaborationDepartment|DepartmentId',
                FieldPrefix: 'DepartmentIdCollaborationDepartment',
                PropertyName: 'DepartmentIdCollaborationDepartment'
            },
            /** Relation: Department Additional Burden - Ethos Department - Many */
            DepartmentAdditionalBurdenByEthosDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|DepartmentAdditionalBurden|Ethos_DepartmentId',
                FieldPrefix: 'EthosDepartmentIdDepartmentAdditionalBurden',
                PropertyName: 'EthosDepartmentIdDepartmentAdditionalBurden'
            },
            /** Relation: Department Map */
            DepartmentMap : {
                RelationName: 'Ethos_WachterDepartment|DepartmentMap|WachterDepartmentId',
                FieldPrefix: 'DepartmentMap',
                PropertyName: 'DepartmentMap'
            },
            /** Relation: Department Role - Many */
            DepartmentRoleByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|DepartmentRole|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosDepartmentRole',
                PropertyName: 'EthosDepartmentRole'
            },
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'Ethos_WachterDepartment|EmployeeReviewQuestionSetup|WachterDepartmentId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Memo Of Record - Many */
            MemoOfRecordByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|MemoOfRecord|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosMemoOfRecord',
                PropertyName: 'EthosMemoOfRecord'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'Ethos_WachterDepartment|NotificationConfig|WachterDepartmentId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
            /** Relation: Organizational Unit - Many */
            OrganizationalUnitByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|OrganizationalUnit|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosOrganizationalUnit',
                PropertyName: 'EthosOrganizationalUnit'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Star Rating Notification */
            StarRatingNotification : {
                RelationName: 'Ethos_WachterDepartment|StarRatingNotification|WachterDepartmentId',
                FieldPrefix: 'StarRatingNotification',
                PropertyName: 'StarRatingNotification'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'Ethos_WachterDepartment|fleet_Vehicle|WachterDepartmentId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Workplace Accident - Department - Many */
            WorkplaceAccidentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|workplaceAccident|DepartmentId',
                FieldPrefix: 'DepartmentIdWorkplaceAccident',
                PropertyName: 'DepartmentIdWorkplaceAccident'
            },
    };
}

export class EthosWachterDivisionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDivision.';

    constructor() {
        this.ItemDetail.ItemId=2803;
        this.ItemDetail.ItemName='Ethos_WachterDivision';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    WachterCompanyId : string = this.i + 'WachterCompanyId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    PresidentUserId : string = this.i + 'PresidentUserId';
    VicePresidentUserId : string = this.i + 'VicePresidentUserId';
    DirectorUserId : string = this.i + 'DirectorUserId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    AxIntegrationId : string = this.i + 'AxIntegrationId';

    Relations = {
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'WachterDepartment|WachterDivision|WachterDivisionId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'Ethos_WachterDivision|NotificationConfig|WachterDivisionId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
    };
}

export class EthosWachterJobTitleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterJobTitle.';

    constructor() {
        this.ItemDetail.ItemId=2384;
        this.ItemDetail.ItemName='Ethos_WachterJobTitle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    WachterJobTitleDescription : string = this.i + 'WachterJobTitleDescription';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_WachterJobTitle|Ethos_User|WachterJobTitleId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Memo Of Record - Employee - Many */
            MemoOfRecordByEmployeeEthosWachterJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|MemoOfRecord|EmployeeEthos_WachterJobTitleId',
                FieldPrefix: 'EmployeeEthosMemoOfRecord',
                PropertyName: 'EmployeeEthosMemoOfRecord'
            },
            /** Relation: Organizational Membership */
            OrganizationalMembership : {
                RelationName: 'Ethos_WachterJobTitle|OrganizationalMembership|WachterJobTitleId',
                FieldPrefix: 'OrganizationalMembership',
                PropertyName: 'OrganizationalMembership'
            },
            /** Relation: PAF Pay/Job Change - New Job Title - Many */
            PayJobChangeByNewJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|PayJobChange|NewJobTitleId',
                FieldPrefix: 'NewJobTitleIdPayJobChange',
                PropertyName: 'NewJobTitleIdPayJobChange'
            },
            /** Relation: Proof Of Insurance Job Titles */
            ProofOfInsuranceJobTitles : {
                RelationName: 'Ethos_WachterJobTitle|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'ProofOfInsuranceJobTitles',
                PropertyName: 'ProofOfInsuranceJobTitles'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterJobTitle|roEthos_User|WachterJobTitleId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

export class EthosWachterTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterTeam.';

    constructor() {
        this.ItemDetail.ItemId=2412;
        this.ItemDetail.ItemName='Ethos_WachterTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamTypeCv : string = this.i + 'TeamTypeCv';
    TeamTypeMeaning : string = this.i + 'TeamTypeMeaning';
    TeamName : string = this.i + 'TeamName';
    TeamLeaderUserId : string = this.i + 'TeamLeaderUserId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    IsDeleted : string = this.i + 'IsDeleted';
    OverheadJobNumberId : string = this.i + 'OverheadJobNumberId';
    OverheadJobNumberPhaseId : string = this.i + 'OverheadJobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos Code Value - Team Type */
            EthosCodeValueByTeamTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterTeam|TeamTypeCv',
                FieldPrefix: 'TeamTypeCvEthosCodeValue',
                PropertyName: 'TeamTypeCvEthosCodeValue'
            },
            /** Relation: Job Number - Overhead Job Number */
            EthosJobNumberByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosJobNumber',
                PropertyName: 'OverheadEthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase - Overhead Job Number Phase */
            EthosJobNumberPhaseByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosJobNumberPhase',
                PropertyName: 'OverheadEthosJobNumberPhase'
            },
            /** Relation: Ethos User - Team Leader User */
            EthosUserByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosUser',
                PropertyName: 'TeamLeaderEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Employee Review Question Setup */
            EmployeeReviewQuestionSetup : {
                RelationName: 'Ethos_WachterTeam|EmployeeReviewQuestionSetup|WachterTeamId',
                FieldPrefix: 'EmployeeReviewQuestionSetup',
                PropertyName: 'EmployeeReviewQuestionSetup'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Memo Of Record - Many */
            MemoOfRecordByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|MemoOfRecord|Ethos_WachterTeamId',
                FieldPrefix: 'EthosMemoOfRecord',
                PropertyName: 'EthosMemoOfRecord'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'Ethos_WachterTeam|NotificationConfig|WachterTeamId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
            /** Relation: PAF Pay/Job Change - New - Many */
            PayJobChangeByNewEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|PayJobChange|NewEthos_WachterTeamId',
                FieldPrefix: 'NewEthosPayJobChange',
                PropertyName: 'NewEthosPayJobChange'
            },
            /** Relation: Resource Cost - Current User Team - Many */
            ResourceCostByCurrentUserTeamId : {
                RelationName: 'Ethos_WachterTeam|resourceCost|CurrentUserTeamId',
                FieldPrefix: 'CurrentUserTeamIdResourceCost',
                PropertyName: 'CurrentUserTeamIdResourceCost'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Team Assignment */
            TeamAssignment : {
                RelationName: 'Ethos_WachterTeam|TeamAssignment|WachterTeamId',
                FieldPrefix: 'TeamAssignment',
                PropertyName: 'TeamAssignment'
            },
            /** Relation: Team Year Numbers - Ethos Team - Many */
            TeamYearNumbersByEthosTeamId : {
                RelationName: 'TeamYearNumbers_WachterTeam_WachterTeamId',
                FieldPrefix: 'EthosTeamIdTeamYearNumbers',
                PropertyName: 'EthosTeamIdTeamYearNumbers'
            },
            /** Relation: User Projection - Many */
            WcUserProjectionByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|wc_UserProjection|Ethos_WachterTeamId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
            /** Relation: User Team Lookup - Team - Many */
            UserTeamLookupByTeamId : {
                RelationName: 'Ethos_WachterTeam|UserTeamLookup|TeamId',
                FieldPrefix: 'TeamIdUserTeamLookup',
                PropertyName: 'TeamIdUserTeamLookup'
            },
            /** Relation: User Year Numbers */
            UserYearNumbers : {
                RelationName: 'Ethos_WachterTeam|UserYearNumbers|WachterTeamId',
                FieldPrefix: 'UserYearNumbers',
                PropertyName: 'UserYearNumbers'
            },
            /** Relation: Wachter Team Organizational Unit - Many */
            WachterTeamOrganizationalUnitByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|WachterTeamOrganizationalUnit|Ethos_WachterTeamId',
                FieldPrefix: 'EthosWachterTeamOrganizationalUnit',
                PropertyName: 'EthosWachterTeamOrganizationalUnit'
            },
    };
}

export class EthosWorkflowStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatus.';

    constructor() {
        this.ItemDetail.ItemId=2581;
        this.ItemDetail.ItemName='Ethos_WorkflowStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusId : string = this.i + 'WorkflowStatusId';
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatus : string = this.i + 'WorkflowStatus';
    WorkflowStatusMeaning : string = this.i + 'WorkflowStatusMeaning';
    WorkflowStatusOrder : string = this.i + 'WorkflowStatusOrder';
    IsActive : string = this.i + 'IsActive';
    WorkflowStatusShortName : string = this.i + 'WorkflowStatusShortName';

    Relations = {
            /** Relation: Ethos Workflow Status Set */
            EthosWorkflowStatusSet : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatusSet',
                PropertyName: 'EthosWorkflowStatusSet'
            },
            /** Relation: Ethos Job - Job Status Ws - Many */
            EthosJobByJobStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Job|JobStatusWs',
                FieldPrefix: 'JobStatusWsEthosJob',
                PropertyName: 'JobStatusWsEthosJob'
            },
            /** Relation: Job Number - Job Number Status Ws - Many */
            EthosJobNumberByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosJobNumber',
                PropertyName: 'JobNumberStatusWsEthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase - Job Number Phase Status Ws - Many */
            EthosJobNumberPhaseByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosJobNumberPhase',
                PropertyName: 'JobNumberPhaseStatusWsEthosJobNumberPhase'
            },
            /** Relation: Ethos Opportunity - Opportunity Status Ws - Many */
            EthosOpportunityByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosOpportunity',
                PropertyName: 'OpportunityStatusWsEthosOpportunity'
            },
            /** Relation: Ethos User - User Status Ws - Many */
            EthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosUser',
                PropertyName: 'UserStatusWsEthosUser'
            },
            /** Relation: Permit - Permit Status Ws - Many */
            PermitByPermitStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Permit|PermitStatusWs',
                FieldPrefix: 'PermitStatusWsPermit',
                PropertyName: 'PermitStatusWsPermit'
            },
            /** Relation: Ro Ethos User - User Status Ws - Many */
            RoEthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsRoEthosUser',
                PropertyName: 'UserStatusWsRoEthosUser'
            },
    };
}

export class EthosWorkflowStatusSetMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatusSet.';

    constructor() {
        this.ItemDetail.ItemId=2580;
        this.ItemDetail.ItemName='Ethos_WorkflowStatusSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatusSetName : string = this.i + 'WorkflowStatusSetName';
    MetaDataItemId : string = this.i + 'MetaDataItemId';
    MetaDataAttributeId : string = this.i + 'MetaDataAttributeId';
    RelatedCodeSetId : string = this.i + 'RelatedCodeSetId';
    UseTransitions : string = this.i + 'UseTransitions';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Ethos Workflow Status */
            EthosWorkflowStatus : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatus',
                PropertyName: 'EthosWorkflowStatus'
            },
    };
}

export class EthosRoleMapMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EthosRoleMap.';

    constructor() {
        this.ItemDetail.ItemId=2766;
        this.ItemDetail.ItemName='EthosRoleMap';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosRoleMapId : string = this.i + 'EthosRoleMapId';
    EthosRoleId : string = this.i + 'EthosRoleId';
    WAppsRoleId : string = this.i + 'wAppsRoleId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: W Apps Roles - W Apps Role */
            WAppsRolesBywAppsRoleId : {
                RelationName: 'EthosRoleMap|wAppsRole',
                FieldPrefix: 'WAppsWAppsRoles',
                PropertyName: 'WAppsWAppsRoles'
            },
            /** Relation: Ethos Roles - Ethos Role */
            EthosRolesByEthosRoleId : {
                RelationName: 'EthosRoleMap|EthosRoles',
                FieldPrefix: 'EthosEthosRoles',
                PropertyName: 'EthosEthosRoles'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|EthosRoleMap|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|EthosRoleMap|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class EthosRolesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EthosRoles.';

    constructor() {
        this.ItemDetail.ItemId=2767;
        this.ItemDetail.ItemName='EthosRoles';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RoleId : string = this.i + 'RoleId';
    RoleName : string = this.i + 'RoleName';
    RoleDescription : string = this.i + 'RoleDescription';

    Relations = {
            /** Relation: Ethos Role Map - Role - Many */
            EthosRoleMapByEthosRoleId : {
                RelationName: 'EthosRoleMap|EthosRoles',
                FieldPrefix: 'EthosEthosRoleMap',
                PropertyName: 'EthosEthosRoleMap'
            },
    };
}

export class EthosUserDetailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EthosUserDetail.';

    constructor() {
        this.ItemDetail.ItemId=2646;
        this.ItemDetail.ItemName='EthosUserDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    ActiveDirectoryUserName : string = this.i + 'ActiveDirectoryUserName';
    AXUserName : string = this.i + 'AXUserName';
    AXUserRecId : string = this.i + 'AXUserRecId';
    UserTypeCV : string = this.i + 'UserTypeCV';
    UserType : string = this.i + 'UserType';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterTeamId : string = this.i + 'WachterTeamId';

    Relations = {
            /** Relation: Ethos User Role - User - Many */
            EthosUserRoleByUserid : {
                RelationName: 'SSOUserDetail| UserRole|UserId',
                FieldPrefix: 'UseridEthosUserRole',
                PropertyName: 'UseridEthosUserRole'
            },
    };
}

export class EthosUserRoleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EthosUserRole.';

    constructor() {
        this.ItemDetail.ItemId=2647;
        this.ItemDetail.ItemName='EthosUserRole';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Userid : string = this.i + 'Userid';
    RoleId : string = this.i + 'RoleId';
    RoleName : string = this.i + 'RoleName';
    RoleDescription : string = this.i + 'RoleDescription';
    UserRoleId : string = this.i + 'UserRoleId';

    Relations = {
            /** Relation: SSO Ethos User Detail - User */
            EthosUserDetailByUserid : {
                RelationName: 'SSOUserDetail| UserRole|UserId',
                FieldPrefix: 'UseridEthosUserDetail',
                PropertyName: 'UseridEthosUserDetail'
            },
    };
}

export class FieldEmployeesPayRateMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'FieldEmployeesPayRate.';

    constructor() {
        this.ItemDetail.ItemId=2522;
        this.ItemDetail.ItemName='FieldEmployeesPayRate';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    PayRate : string = this.i + 'PayRate';
    Company : string = this.i + 'Company';

    Relations = {
    };
}

export class FiveStarRatingMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'FiveStarRating.';

    constructor() {
        this.ItemDetail.ItemId=2569;
        this.ItemDetail.ItemName='FiveStarRating';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiveStarRatingId : string = this.i + 'FiveStarRatingId';
    RatedEthosUserId : string = this.i + 'RatedEthos_UserId';
    SubcontractorBranchId : string = this.i + 'SubcontractorBranchId';
    RatingValue : string = this.i + 'RatingValue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    IsSubcontractor : string = this.i + 'IsSubcontractor';

    Relations = {
            /** Relation: Trust Code Value - Rating */
            CodeValueByRatingValue : {
                RelationName: 'CodeValue|FiveStarRating|RatingValue',
                FieldPrefix: 'RatingValueCodeValue',
                PropertyName: 'RatingValueCodeValue'
            },
            /** Relation: Subcontractor Branch */
            EthosSubcontractorBranchBySubcontractorBranchId : {
                RelationName: 'FiveStarRating|Ethos_SubcontractorBranch|SubcontractorBranchId',
                FieldPrefix: 'EthosSubcontractorBranchSubcontractorBranchId',
                PropertyName: 'EthosSubcontractorBranchSubcontractorBranchId'
            },
            /** Relation: Ro Ethos User - Employee Name - Many */
            RoEthosUserByUserId : {
                RelationName: 'FiveStarRating|roEthosUser|RatedEthos_Userid',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
    };
}

export class InspectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Inspection.';

    constructor() {
        this.ItemDetail.ItemId=2746;
        this.ItemDetail.ItemName='Inspection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    AdditionalInspectionNeeded : string = this.i + 'AdditionalInspectionNeeded';

    Relations = {
            /** Relation: Trust Code Value - Preferred Time Of Day */
            CodeValueByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvCodeValue',
                PropertyName: 'PreferredTimeOfDayCvCodeValue'
            },
            /** Relation: Trust Code Value - Result */
            CodeValueByResultCv : {
                RelationName: 'CodeValue|Inspection|ResultCv',
                FieldPrefix: 'ResultCvCodeValue',
                PropertyName: 'ResultCvCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|Inspection|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Ethos User - Technician */
            EthosUserByTechnicianUserId : {
                RelationName: 'Ethos_User|Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianEthosUser',
                PropertyName: 'TechnicianEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Inspection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class Permits2InspectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_Inspection.';

    constructor() {
        this.ItemDetail.ItemId=2782;
        this.ItemDetail.ItemName='permits2_Inspection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    SyncStatus : string = this.i + 'SyncStatus';
    Subcontractor : string = this.i + 'Subcontractor';
    UseSub : string = this.i + 'UseSub';

    Relations = {
            /** Relation: Trust Code Value - Preferred Time Of Day */
            CodeValueByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|permits2_Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvCodeValue',
                PropertyName: 'PreferredTimeOfDayCvCodeValue'
            },
            /** Relation: Inspection Result - Result */
            InspectionResultByResultCv : {
                RelationName: 'InspectionResult|permits2_Inspection|ResultCv',
                FieldPrefix: 'ResultCvInspectionResult',
                PropertyName: 'ResultCvInspectionResult'
            },
            /** Relation: Inspection Status */
            InspectionStatus : {
                RelationName: 'InspectionStatus|permits2_Inspection|InspectionStatusId',
                FieldPrefix: 'InspectionStatus',
                PropertyName: 'InspectionStatus'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_Inspection|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Technician */
            EthosUserByTechnicianUserId : {
                RelationName: 'Ethos_User|permits2_Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianEthosUser',
                PropertyName: 'TechnicianEthosUser'
            },
    };
}

export class InspectionResultMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'InspectionResult.';

    constructor() {
        this.ItemDetail.ItemId=2784;
        this.ItemDetail.ItemName='InspectionResult';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionResultId : string = this.i + 'InspectionResultId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    Order : string = this.i + 'Order';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Inspection - Result Cv - Many */
            Permits2InspectionByResultCv : {
                RelationName: 'InspectionResult|permits2_Inspection|ResultCv',
                FieldPrefix: 'ResultCvPermits2Inspection',
                PropertyName: 'ResultCvPermits2Inspection'
            },
    };
}

export class InspectionStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'InspectionStatus.';

    constructor() {
        this.ItemDetail.ItemId=2785;
        this.ItemDetail.ItemName='InspectionStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    Order : string = this.i + 'Order';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Inspection */
            Permits2Inspection : {
                RelationName: 'InspectionStatus|permits2_Inspection|InspectionStatusId',
                FieldPrefix: 'Permits2Inspection',
                PropertyName: 'Permits2Inspection'
            },
    };
}

export class IssueSubtypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'IssueSubtype.';

    constructor() {
        this.ItemDetail.ItemId=2493;
        this.ItemDetail.ItemName='IssueSubtype';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueSubtypeId : string = this.i + 'IssueSubtypeId';
    IssueTypeId : string = this.i + 'IssueTypeId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    SortOrder : string = this.i + 'SortOrder';
    IsActive : string = this.i + 'IsActive';
    IssueSubtypeSeverityId : string = this.i + 'IssueSubtypeSeverityId';

    Relations = {
            /** Relation: Issue Subtype Severity */
            IssueSubtypeSeverity : {
                RelationName: 'IssueSubtypeSeverity|IssueSubtype|IssueSubtypeSeverityId',
                FieldPrefix: 'IssueSubtypeSeverity',
                PropertyName: 'IssueSubtypeSeverity'
            },
            /** Relation: Issue Type */
            IssueType : {
                RelationName: 'IssueType|IssueSubtype|IssueTypeId',
                FieldPrefix: 'IssueType',
                PropertyName: 'IssueType'
            },
            /** Relation: Memo Of Record - Issue Sub Type - Many */
            MemoOfRecordByIssueSubTypeId : {
                RelationName: 'IssueSubtype|MemoOfRecord|IssueSubTypeId',
                FieldPrefix: 'IssueSubTypeIdMemoOfRecord',
                PropertyName: 'IssueSubTypeIdMemoOfRecord'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'IssueSubtype|NotificationConfig|IssueSubtypeId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
    };
}

export class IssueSubtypeSeverityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'IssueSubtypeSeverity.';

    constructor() {
        this.ItemDetail.ItemId=2497;
        this.ItemDetail.ItemName='IssueSubtypeSeverity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueSubtypeSeverityId : string = this.i + 'IssueSubtypeSeverityId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    SortOrder : string = this.i + 'SortOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Issue Subtype */
            IssueSubtype : {
                RelationName: 'IssueSubtypeSeverity|IssueSubtype|IssueSubtypeSeverityId',
                FieldPrefix: 'IssueSubtype',
                PropertyName: 'IssueSubtype'
            },
    };
}

export class IssueTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'IssueType.';

    constructor() {
        this.ItemDetail.ItemId=2491;
        this.ItemDetail.ItemName='IssueType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueTypeId : string = this.i + 'IssueTypeId';
    Display : string = this.i + 'Display';
    IsNotifyWachterSupervisor : string = this.i + 'IsNotifyWachterSupervisor';
    IsNotifySubcontractorSubervisor : string = this.i + 'IsNotifySubcontractorSubervisor';
    IsNotifyAgencySupervisor : string = this.i + 'IsNotifyAgencySupervisor';
    IssueTypeOrder : string = this.i + 'IssueTypeOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Issue Subtype */
            IssueSubtype : {
                RelationName: 'IssueType|IssueSubtype|IssueTypeId',
                FieldPrefix: 'IssueSubtype',
                PropertyName: 'IssueSubtype'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'IssueType|NotificationConfig|IssueTypeId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
    };
}

export class KickoffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Kickoff.';

    constructor() {
        this.ItemDetail.ItemId=2484;
        this.ItemDetail.ItemName='Kickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffId : string = this.i + 'KickoffId';
    EthosJobNumberId : string = this.i + 'Ethos_JobNumberId';
    BillingInvoiceDate : string = this.i + 'BillingInvoiceDate';
    CloseoutMeetingDate : string = this.i + 'CloseoutMeetingDate';
    CloseoutDeliverableCompletedByDate : string = this.i + 'CloseoutDeliverableCompletedByDate';
    ExternalKickoffDate : string = this.i + 'ExternalKickoffDate';
    ScheduledStartDate : string = this.i + 'ScheduledStartDate';
    ScheduledEndDate : string = this.i + 'ScheduledEndDate';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    ChangeOrderProcessDescription : string = this.i + 'ChangeOrderProcessDescription';
    CustomerPaymentProcedure : string = this.i + 'CustomerPaymentProcedure';
    CustomerAccountingContactDetail : string = this.i + 'CustomerAccountingContactDetail';
    DeliverablesForBilling : string = this.i + 'DeliverablesForBilling';
    EscalationPathDescription : string = this.i + 'EscalationPathDescription';
    IntroductionText : string = this.i + 'IntroductionText';
    CommunicationDescription : string = this.i + 'CommunicationDescription';
    SafetyPlanDescription : string = this.i + 'SafetyPlanDescription';
    SiteContactInformation : string = this.i + 'SiteContactInformation';
    IsBillingACH : string = this.i + 'IsBillingACH';
    IsBuyerSignatureRequired : string = this.i + 'IsBuyerSignatureRequired';
    IsMonthlyBilling : string = this.i + 'IsMonthlyBilling';
    IsWrittenBillingApprovalRequired : string = this.i + 'IsWrittenBillingApprovalRequired';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    StakeholderInformation : string = this.i + 'StakeholderInformation';
    AttendeeInformation : string = this.i + 'AttendeeInformation';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    OtherNotes : string = this.i + 'OtherNotes';

    Relations = {
            /** Relation: Job Number - Job Number */
            EthosJobNumberByEthosJobNumberId : {
                RelationName: 'Ethos_JobNumber|Kickoff|Ethos_JobNumberId',
                FieldPrefix: 'EthosEthosJobNumber',
                PropertyName: 'EthosEthosJobNumber'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Kickoff|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Kickoff|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Milestone */
            Milestone : {
                RelationName: 'Kickoff|Milestone|KickoffId',
                FieldPrefix: 'Milestone',
                PropertyName: 'Milestone'
            },
            /** Relation: Ro Kickoff */
            RoKickoff : {
                RelationName: 'Kickoff|roKickoff|KickoffId',
                FieldPrefix: 'RoKickoff',
                PropertyName: 'RoKickoff'
            },
    };
}

export class ProjectsKickoffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'projects_Kickoff.';

    constructor() {
        this.ItemDetail.ItemId=3425;
        this.ItemDetail.ItemName='projects_Kickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffId : string = this.i + 'KickoffId';
    LeadTimeWts : string = this.i + 'LeadTimeWts';
    StageTime : string = this.i + 'StageTime';
    ConfigurationTime : string = this.i + 'ConfigurationTime';
    CustomerSpoc : string = this.i + 'CustomerSpoc';
    FollowUpMeetings : string = this.i + 'FollowUpMeetings';
    Ppe : string = this.i + 'Ppe';
    SpecialRequirements : string = this.i + 'SpecialRequirements';
    QualityProgramDetails : string = this.i + 'QualityProgramDetails';
    Scope : string = this.i + 'Scope';
    Deliverables : string = this.i + 'Deliverables';
    RequiresEquipOrValidation : string = this.i + 'RequiresEquipOrValidation';
    ValidationNotes : string = this.i + 'ValidationNotes';
    ChangeOrderPlan : string = this.i + 'ChangeOrderPlan';
    CopResponsibility : string = this.i + 'CopResponsibility';
    HelpDesk : string = this.i + 'HelpDesk';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    CompletionDate : string = this.i + 'CompletionDate';
    IsCriticalCare : string = this.i + 'IsCriticalCare';
    ExternalDueDate : string = this.i + 'ExternalDueDate';
    PermittingProcess : string = this.i + 'PermittingProcess';
    BudgetHours : string = this.i + 'BudgetHours';
    IsLicensedRequired : string = this.i + 'IsLicensedRequired';
    LeadTechUserId : string = this.i + 'LeadTechUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    ParentKickoffId : string = this.i + 'ParentKickoffId';
    LicensingRequired : string = this.i + 'LicensingRequired';
    HelpContactDetails : string = this.i + 'HelpContactDetails';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|projects_Kickoff|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Kickoff - Parent Kickoff - One */
            ProjectsKickoffByParentKickoffId : {
                RelationName: 'projects_Kickoff|projects_Kickoff|ParentKickoffId',
                FieldPrefix: 'ParentProjectsKickoff',
                PropertyName: 'ParentProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Lead Tech User */
            EthosUserByLeadTechUserId : {
                RelationName: 'Ethos_User|projects_Kickoff|LeadTechUserId',
                FieldPrefix: 'LeadTechEthosUser',
                PropertyName: 'LeadTechEthosUser'
            },
            /** Relation: Billing */
            Billing : {
                RelationName: 'projects_Kickoff|Billing|KickoffId',
                FieldPrefix: 'Billing',
                PropertyName: 'Billing'
            },
            /** Relation: Escalation */
            Escalation : {
                RelationName: 'projects_Kickoff|Escalation|KickoffId',
                FieldPrefix: 'Escalation',
                PropertyName: 'Escalation'
            },
            /** Relation: Kickoff Checklist */
            KickoffChecklist : {
                RelationName: 'projects_Kickoff|KickoffChecklist|KickoffId',
                FieldPrefix: 'KickoffChecklist',
                PropertyName: 'KickoffChecklist'
            },
            /** Relation: Project Milestone */
            ProjectMilestone : {
                RelationName: 'projects_Kickoff|ProjectMilestone|KickoffId',
                FieldPrefix: 'ProjectMilestone',
                PropertyName: 'ProjectMilestone'
            },
            /** Relation: Reporting */
            Reporting : {
                RelationName: 'projects_Kickoff|Reporting|KickoffId',
                FieldPrefix: 'Reporting',
                PropertyName: 'Reporting'
            },
            /** Relation: Ro Project Kickoff */
            RoProjectKickoff : {
                RelationName: 'roProjectKickoff|Project_Kickoff|KickoffId',
                FieldPrefix: 'RoProjectKickoff',
                PropertyName: 'RoProjectKickoff'
            },
            /** Relation: Stakeholder */
            Stakeholder : {
                RelationName: 'projects_Kickoff|Stakeholder|KickoffId',
                FieldPrefix: 'Stakeholder',
                PropertyName: 'Stakeholder'
            },
            /** Relation: Team Assignment */
            TeamAssignment : {
                RelationName: 'projects_Kickoff|TeamAssignment|KickoffId',
                FieldPrefix: 'TeamAssignment',
                PropertyName: 'TeamAssignment'
            },
    };
}

export class KickoffChecklistMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'KickoffChecklist.';

    constructor() {
        this.ItemDetail.ItemId=3422;
        this.ItemDetail.ItemName='KickoffChecklist';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffChecklistId : string = this.i + 'KickoffChecklistId';
    KickoffId : string = this.i + 'KickoffId';
    ChecklistId : string = this.i + 'ChecklistId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Checklist */
            Checklist : {
                RelationName: 'Checklist|KickoffChecklist|ChecklistId',
                FieldPrefix: 'Checklist',
                PropertyName: 'Checklist'
            },
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|KickoffChecklist|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|KickoffChecklist|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|KickoffChecklist|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class LicensesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Licenses.';

    constructor() {
        this.ItemDetail.ItemId=2458;
        this.ItemDetail.ItemName='Licenses';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    LicenseId : string = this.i + 'LicenseId';
    LicenseNumber : string = this.i + 'LicenseNumber';
    IssueDate : string = this.i + 'IssueDate';
    ExpirationDate : string = this.i + 'ExpirationDate';
    IssuedTo : string = this.i + 'IssuedTo';
    LicenseType : string = this.i + 'LicenseType';
    State : string = this.i + 'State';
    County : string = this.i + 'County';
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    StatusCv : string = this.i + 'StatusCv';
    NinetyDayNotification : string = this.i + 'NinetyDayNotification';
    SixtyDayNotification : string = this.i + 'SixtyDayNotification';
    ThirtyDayNotification : string = this.i + 'ThirtyDayNotification';
    Notes : string = this.i + 'Notes';
    HR217 : string = this.i + 'HR217';
    IsCertificate : string = this.i + 'IsCertificate';
    RejectedReason : string = this.i + 'RejectedReason';
    MediaGroupId : string = this.i + 'MediaGroupId';
    CeuRequired : string = this.i + 'CeuRequired';
    CeuDetails : string = this.i + 'CeuDetails';

    Relations = {
            /** Relation: Attachment - Attachment File */
            AttachmentByAttachmentFileId : {
                RelationName: 'Attachment|Licenses|AttachmentFileId',
                FieldPrefix: 'AttachmentFileAttachment',
                PropertyName: 'AttachmentFileAttachment'
            },
            /** Relation: Attachment - License */
            AttachmentByLicenseId : {
                RelationName: 'Attachment|Licenses|LicenseId',
                FieldPrefix: 'LicenseIdAttachment',
                PropertyName: 'LicenseIdAttachment'
            },
            /** Relation: Attachment File */
            AttachmentFile : {
                RelationName: 'AttachmentFile|Licenses|AttachmentFileId',
                FieldPrefix: 'AttachmentFile',
                PropertyName: 'AttachmentFile'
            },
            /** Relation: Attachment Folder - Attachment File */
            AttachmentAttachmentFolderByAttachmentFileId : {
                RelationName: 'attachment_AttachmentFolder|Licenses|AttachmentFileId',
                FieldPrefix: 'AttachmentFileIdAttachmentAttachmentFolder',
                PropertyName: 'AttachmentFileIdAttachmentAttachmentFolder'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|Licenses|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: License Type - License Type */
            LicenseTypeByLicenseType : {
                RelationName: 'LicenseType|Licenses|LicenseType',
                FieldPrefix: 'LicenseTypeLicenseType',
                PropertyName: 'LicenseTypeLicenseType'
            },
            /** Relation: State Province - State */
            EthosStateProvinceByState : {
                RelationName: 'Ethos_StateProvince_Licenses_State',
                FieldPrefix: 'StateEthosStateProvince',
                PropertyName: 'StateEthosStateProvince'
            },
            /** Relation: Ethos User - Issued To */
            EthosUserByIssuedTo : {
                RelationName: 'Ethos_User_Licenses_IssuedTo',
                FieldPrefix: 'IssuedToEthosUser',
                PropertyName: 'IssuedToEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Licenses|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User_Licenses_ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ro Ethos User - Issued To */
            RoEthosUserByIssuedTo : {
                RelationName: 'Licenses|RoEthosUser|IssuedTo',
                FieldPrefix: 'IssuedToRoEthosUser',
                PropertyName: 'IssuedToRoEthosUser'
            },
            /** Relation: Ro Attachment File Names Combined */
            RoAttachmentFileNamesCombined : {
                RelationName: 'Licenses|roAttachmentFileNamesCombined|LicenseId',
                FieldPrefix: 'RoAttachmentFileNamesCombined',
                PropertyName: 'RoAttachmentFileNamesCombined'
            },
    };
}

export class LicenseTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'LicenseType.';

    constructor() {
        this.ItemDetail.ItemId=2459;
        this.ItemDetail.ItemName='LicenseType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    LicenseTypeId : string = this.i + 'LicenseTypeId';
    LicenseName : string = this.i + 'LicenseName';
    HideFiles : string = this.i + 'HideFiles';

    Relations = {
            /** Relation: Licenses - Many */
            LicensesByLicenseType : {
                RelationName: 'LicenseType|Licenses|LicenseType',
                FieldPrefix: 'LicenseTypeLicenses',
                PropertyName: 'LicenseTypeLicenses'
            },
    };
}

export class MaintenanceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Maintenance.';

    constructor() {
        this.ItemDetail.ItemId=3432;
        this.ItemDetail.ItemName='Maintenance';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MaintenanceId : string = this.i + 'MaintenanceId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointId : string = this.i + 'SharepointId';
    VehicleId : string = this.i + 'VehicleId';
    Date : string = this.i + 'Date';
    DriverUserId : string = this.i + 'DriverUserId';
    RawDriverName : string = this.i + 'RawDriverName';
    JobNumberId : string = this.i + 'JobNumberId';
    Odometer : string = this.i + 'Odometer';
    Cost : string = this.i + 'Cost';
    PONumber : string = this.i + 'PONumber';
    ServiceProvider : string = this.i + 'ServiceProvider';
    ServiceType : string = this.i + 'ServiceType';
    CurrentLicensePlate : string = this.i + 'CurrentLicensePlate';
    NoteParentId : string = this.i + 'NoteParentId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    Phase : string = this.i + 'Phase';
    IsEmployee : string = this.i + 'IsEmployee';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Maintenance|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|Maintenance|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Maintenance|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Maintenance|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Driver User */
            EthosUserByDriverUserId : {
                RelationName: 'Ethos_User|Maintenance|DriverUserId',
                FieldPrefix: 'DriverEthosUser',
                PropertyName: 'DriverEthosUser'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'fleet_Vehicle|Maintenance|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Maintenance Service */
            MaintenanceService : {
                RelationName: 'Maintenance|MaintenanceService|MaintenanceId',
                FieldPrefix: 'MaintenanceService',
                PropertyName: 'MaintenanceService'
            },
            /** Relation: Ro Maintenance */
            RoMaintenance : {
                RelationName: 'roMaintenance|Maintenance|MaintenanceId',
                FieldPrefix: 'RoMaintenance',
                PropertyName: 'RoMaintenance'
            },
    };
}

export class MaintenanceServiceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MaintenanceService.';

    constructor() {
        this.ItemDetail.ItemId=3441;
        this.ItemDetail.ItemName='MaintenanceService';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MaintenanceServiceId : string = this.i + 'MaintenanceServiceId';
    MaintenanceId : string = this.i + 'MaintenanceId';
    ServiceTypeId : string = this.i + 'ServiceTypeId';

    Relations = {
            /** Relation: Maintenance */
            Maintenance : {
                RelationName: 'Maintenance|MaintenanceService|MaintenanceId',
                FieldPrefix: 'Maintenance',
                PropertyName: 'Maintenance'
            },
            /** Relation: Service Type */
            ServiceType : {
                RelationName: 'ServiceType|MaintenanceService|ServiceTypeId',
                FieldPrefix: 'ServiceType',
                PropertyName: 'ServiceType'
            },
    };
}

export class MedicalRecordMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MedicalRecord.';

    constructor() {
        this.ItemDetail.ItemId=3413;
        this.ItemDetail.ItemName='MedicalRecord';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MedicalRecordId : string = this.i + 'MedicalRecordId';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Details : string = this.i + 'Details';
    TreatmentDateTime : string = this.i + 'TreatmentDateTime';
    Cost : string = this.i + 'Cost';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident|MedicalRecord|WorkplaceAccidentId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class MemoOfRecordMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MemoOfRecord.';

    constructor() {
        this.ItemDetail.ItemId=2492;
        this.ItemDetail.ItemName='MemoOfRecord';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MemoOfRecordId : string = this.i + 'MemoOfRecordId';
    ConclusionCv : string = this.i + 'ConclusionCv';
    EmployeeTypeCv : string = this.i + 'EmployeeTypeCv';
    StatusCv : string = this.i + 'StatusCv';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    EthosSubcontractorBranchId : string = this.i + 'Ethos_SubcontractorBranchId';
    SupervisorEthosUserId : string = this.i + 'SupervisorEthos_UserId';
    AssignedToEthosUserId : string = this.i + 'AssignedToEthos_UserId';
    EthosWachterDepartmentId : string = this.i + 'Ethos_WachterDepartmentId';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    EmployeeEthosWachterJobTitleId : string = this.i + 'EmployeeEthos_WachterJobTitleId';
    AssignedToEmailMessageId : string = this.i + 'AssignedToEmailMessageId';
    EventDate : string = this.i + 'EventDate';
    ClosedDate : string = this.i + 'ClosedDate';
    Cost : string = this.i + 'Cost';
    EmployeeName : string = this.i + 'EmployeeName';
    SupervisorName : string = this.i + 'SupervisorName';
    EmployeeDepartment : string = this.i + 'EmployeeDepartment';
    EmployeeTitle : string = this.i + 'EmployeeTitle';
    ReferenceText : string = this.i + 'ReferenceText';
    Customer : string = this.i + 'Customer';
    EventLocation : string = this.i + 'EventLocation';
    City : string = this.i + 'City';
    State : string = this.i + 'State';
    EmailCopyString : string = this.i + 'EmailCopyString';
    EventDescription : string = this.i + 'EventDescription';
    BackgroundDescription : string = this.i + 'BackgroundDescription';
    BusinessImpactDescription : string = this.i + 'BusinessImpactDescription';
    LessonsLearnedDescription : string = this.i + 'LessonsLearnedDescription';
    CreatedByEmailMessageId : string = this.i + 'CreatedByEmailMessageId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';
    CCEmailMessageId : string = this.i + 'CCEmailMessageId';
    IssueSubTypeId : string = this.i + 'IssueSubTypeId';
    AttachmentId : string = this.i + 'AttachmentId';
    SignedDocumentsAttachmentId : string = this.i + 'SignedDocumentsAttachmentId';
    WillUseAgain : string = this.i + 'WillUseAgain';
    WillUseAgainDescription : string = this.i + 'WillUseAgainDescription';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|MemoOfRecord|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Attachment - Signed Documents Attachment */
            AttachmentBySignedDocumentsAttachmentId : {
                RelationName: 'Attachment|MemoOfRecord|SignedDocumentsAttachmentId',
                FieldPrefix: 'SignedDocumentsAttachmentAttachment',
                PropertyName: 'SignedDocumentsAttachmentAttachment'
            },
            /** Relation: Trust Code Value - Employee Type */
            CodeValueByEmployeeTypeCv : {
                RelationName: 'CodeValue|MemoOfRecord|EmployeeTypeCv',
                FieldPrefix: 'EmployeeTypeCvCodeValue',
                PropertyName: 'EmployeeTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|MemoOfRecord|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Conclusion */
            CodeValueByConclusionCv : {
                RelationName: 'CodeValue|MemoOfRecord|ConclusionCv',
                FieldPrefix: 'ConclusionCvCodeValue',
                PropertyName: 'ConclusionCvCodeValue'
            },
            /** Relation: Issue Subtype - Issue Sub Type */
            IssueSubtypeByIssueSubTypeId : {
                RelationName: 'IssueSubtype|MemoOfRecord|IssueSubTypeId',
                FieldPrefix: 'IssueSubTypeIdIssueSubtype',
                PropertyName: 'IssueSubTypeIdIssueSubtype'
            },
            /** Relation: Subcontractor Branch - Subcontractor Branch */
            EthosSubcontractorBranchByEthosSubcontractorBranchId : {
                RelationName: 'Ethos_SubcontractorBranch|MemoOfRecord|Ethos_SubcontractorBranchId',
                FieldPrefix: 'EthosEthosSubcontractorBranch',
                PropertyName: 'EthosEthosSubcontractorBranch'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Ethos User - Supervisor */
            EthosUserBySupervisorEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|SupervisorEthos_UserId',
                FieldPrefix: 'SupervisorEthosEthosUser',
                PropertyName: 'SupervisorEthosEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|AssignedToEthos_UserId',
                FieldPrefix: 'AssignedToEthosEthosUser',
                PropertyName: 'AssignedToEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|CreatedByEthos_UserId_NotUsed',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ro Ethos User - Created By */
            RoEthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRoEthosUser',
                PropertyName: 'CreatedByEthosRoEthosUser'
            },
            /** Relation: Wachter Department - Wachter Department */
            EthosWachterDepartmentByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|MemoOfRecord|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosEthosWachterDepartment',
                PropertyName: 'EthosEthosWachterDepartment'
            },
            /** Relation: Wachter Job Title - Wachter Job Title */
            EthosWachterJobTitleByEmployeeEthosWachterJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|MemoOfRecord|EmployeeEthos_WachterJobTitleId',
                FieldPrefix: 'EmployeeEthosEthosWachterJobTitle',
                PropertyName: 'EmployeeEthosEthosWachterJobTitle'
            },
            /** Relation: Wachter Team - Wachter Team */
            EthosWachterTeamByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|MemoOfRecord|Ethos_WachterTeamId',
                FieldPrefix: 'EthosEthosWachterTeam',
                PropertyName: 'EthosEthosWachterTeam'
            },
            /** Relation: Attachment File - Attachment - Many */
            AttachmentFileByAttachmentFileId : {
                RelationName: 'AttachmentId',
                FieldPrefix: 'AttachmentFileIdAttachmentFile',
                PropertyName: 'AttachmentFileIdAttachmentFile'
            },
            /** Relation: Memo Of Record Notification Group */
            MorMemoOfRecordNotificationGroup : {
                RelationName: 'MemoOfRecord|MemoOfRecordNotificationGroup|MemoOfRecordId',
                FieldPrefix: 'MorMemoOfRecordNotificationGroup',
                PropertyName: 'MorMemoOfRecordNotificationGroup'
            },
            /** Relation: Note */
            Note : {
                RelationName: 'MemoOfRecord|Note|MemoOfRecordId',
                FieldPrefix: 'Note',
                PropertyName: 'Note'
            },
            /** Relation: User Read */
            UserRead : {
                RelationName: 'MemoOfRecord|UserRead|MemoOfRecordId',
                FieldPrefix: 'UserRead',
                PropertyName: 'UserRead'
            },
    };
}

export class MorMemoOfRecordNotificationGroupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'mor_MemoOfRecordNotificationGroup.';

    constructor() {
        this.ItemDetail.ItemId=2495;
        this.ItemDetail.ItemName='mor_MemoOfRecordNotificationGroup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MemoOfRecordNotificationGroupId : string = this.i + 'MemoOfRecordNotificationGroupId';
    MemoOfRecordId : string = this.i + 'MemoOfRecordId';
    NotificationGroupId : string = this.i + 'NotificationGroupId';

    Relations = {
            /** Relation: Memo Of Record */
            MemoOfRecord : {
                RelationName: 'MemoOfRecord|MemoOfRecordNotificationGroup|MemoOfRecordId',
                FieldPrefix: 'MemoOfRecord',
                PropertyName: 'MemoOfRecord'
            },
            /** Relation: Notification Group */
            WcNotificationGroup : {
                RelationName: 'wc_NotificationGroup|MemoOfRecordNotificationGroup|NotificationGroupId',
                FieldPrefix: 'WcNotificationGroup',
                PropertyName: 'WcNotificationGroup'
            },
    };
}

export class MessageMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Message.';

    constructor() {
        this.ItemDetail.ItemId=2737;
        this.ItemDetail.ItemName='Message';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MessageText : string = this.i + 'MessageText';

    Relations = {
    };
}

export class MilestoneMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Milestone.';

    constructor() {
        this.ItemDetail.ItemId=2481;
        this.ItemDetail.ItemName='Milestone';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneId : string = this.i + 'MilestoneId';
    KickoffId : string = this.i + 'KickoffId';
    Description : string = this.i + 'Description';
    DueDate : string = this.i + 'DueDate';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
            /** Relation: Kickoff */
            Kickoff : {
                RelationName: 'Kickoff|Milestone|KickoffId',
                FieldPrefix: 'Kickoff',
                PropertyName: 'Kickoff'
            },
            /** Relation: Milestone Checkpoint */
            MilestoneCheckpoint : {
                RelationName: 'Milestone|MilestoneCheckpoint|MilestoneId',
                FieldPrefix: 'MilestoneCheckpoint',
                PropertyName: 'MilestoneCheckpoint'
            },
    };
}

export class MilestoneCheckpointMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MilestoneCheckpoint.';

    constructor() {
        this.ItemDetail.ItemId=2480;
        this.ItemDetail.ItemName='MilestoneCheckpoint';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneCheckpointId : string = this.i + 'MilestoneCheckpointId';
    MilestoneId : string = this.i + 'MilestoneId';
    CheckpointDate : string = this.i + 'CheckpointDate';
    IsCheckpointCompleted : string = this.i + 'IsCheckpointCompleted';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
            /** Relation: Milestone */
            Milestone : {
                RelationName: 'Milestone|MilestoneCheckpoint|MilestoneId',
                FieldPrefix: 'Milestone',
                PropertyName: 'Milestone'
            },
    };
}

export class MissingForeignKeysMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MissingForeignKeys.';

    constructor() {
        this.ItemDetail.ItemId=2762;
        this.ItemDetail.ItemName='MissingForeignKeys';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CREATECommented : string = this.i + 'CREATE_Commented';
    DROPCommented : string = this.i + 'DROP_Commented';
    FQN : string = this.i + 'FQN';
    Schema : string = this.i + 'schema';
    Table : string = this.i + 'table';
    ColumnName : string = this.i + 'column_name';
    PkTbl : string = this.i + 'pk_tbl';
    PkCol : string = this.i + 'pk_col';
    CREATE : string = this.i + 'CREATE';
    DROP : string = this.i + 'DROP';

    Relations = {
    };
}

export class NoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Note.';

    constructor() {
        this.ItemDetail.ItemId=2488;
        this.ItemDetail.ItemName='Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    MemoOfRecordId : string = this.i + 'MemoOfRecordId';
    Note : string = this.i + 'Note';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Memo Of Record */
            MemoOfRecord : {
                RelationName: 'MemoOfRecord|Note|MemoOfRecordId',
                FieldPrefix: 'MemoOfRecord',
                PropertyName: 'MemoOfRecord'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class WcNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wc_Note.';

    constructor() {
        this.ItemDetail.ItemId=2504;
        this.ItemDetail.ItemName='wc_Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    Note : string = this.i + 'Note';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    EmployeeTrainingNeededId : string = this.i + 'EmployeeTrainingNeededId';

    Relations = {
            /** Relation: Employee Training Needed */
            EmployeeTrainingNeeded : {
                RelationName: 'EmployeeTrainingNeeded|Note|MemoOfRecordId',
                FieldPrefix: 'EmployeeTrainingNeeded',
                PropertyName: 'EmployeeTrainingNeeded'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class EmsNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ems_Note.';

    constructor() {
        this.ItemDetail.ItemId=2586;
        this.ItemDetail.ItemName='ems_Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    UserExtendedId : string = this.i + 'UserExtendedId';
    Note : string = this.i + 'Note';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';

    Relations = {
    };
}

export class NumbersNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'numbers_Note.';

    constructor() {
        this.ItemDetail.ItemId=2624;
        this.ItemDetail.ItemName='numbers_Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    Note : string = this.i + 'Note';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    EthosUserId : string = this.i + 'Ethos_UserId';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|numbers_Note|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class NotesNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'notes_Note.';

    constructor() {
        this.ItemDetail.ItemId=2697;
        this.ItemDetail.ItemName='notes_Note';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteId : string = this.i + 'NoteId';
    NoteParentId : string = this.i + 'NoteParentId';
    Note : string = this.i + 'Note';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    NoteTypeId : string = this.i + 'NoteTypeId';
    AccessoryData : string = this.i + 'AccessoryData';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|notes_Note|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Note Type */
            NoteType : {
                RelationName: 'NoteType|notes_Note|NoteTypeId',
                FieldPrefix: 'NoteType',
                PropertyName: 'NoteType'
            },
            /** Relation: Permit - Accessory Data */
            PermitByAccessoryData : {
                RelationName: 'Note -> Permit with Accessory Data',
                FieldPrefix: 'AccessoryDataPermit',
                PropertyName: 'AccessoryDataPermit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|notes_Note|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Change Request */
            ChangeRequest : {
                RelationName: 'notes_Note|ChangeRequest|NoteId',
                FieldPrefix: 'ChangeRequest',
                PropertyName: 'ChangeRequest'
            },
    };
}

export class NotesNoteParentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'notes_NoteParent.';

    constructor() {
        this.ItemDetail.ItemId=2698;
        this.ItemDetail.ItemName='notes_NoteParent';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteParentId : string = this.i + 'NoteParentId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';

    Relations = {
            /** Relation: Auction */
            Auction : {
                RelationName: 'notes_NoteParent|Auction|NoteParentId',
                FieldPrefix: 'Auction',
                PropertyName: 'Auction'
            },
            /** Relation: Maintenance */
            Maintenance : {
                RelationName: 'notes_NoteParent|Maintenance|NoteParentId',
                FieldPrefix: 'Maintenance',
                PropertyName: 'Maintenance'
            },
            /** Relation: Note */
            NotesNote : {
                RelationName: 'notes_NoteParent|notes_Note|NoteParentId',
                FieldPrefix: 'NotesNote',
                PropertyName: 'NotesNote'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'notes_NoteParent|Permit|NoteParentId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'notes_NoteParent|permits2_Permit|NoteParentId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'notes_NoteParent|permitRequest|NoteParentId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Star Rating - Field Experience */
            StarRatingFieldExperience : {
                RelationName: 'notes_NoteParent|StarRatingFieldExperience|NoteParentId',
                FieldPrefix: 'StarRatingFieldExperience',
                PropertyName: 'StarRatingFieldExperience'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'notes_NoteParent|fleet_Vehicle|NoteParentId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'notes_NoteParent|workplaceAccident|NoteParentId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
            /** Relation: Workplace Accident - Workers Comp - Many */
            WorkplaceAccidentByWorkersCompNoteParentId : {
                RelationName: 'notes_NoteParent|workplaceAccident|WorkersCompNoteParentId',
                FieldPrefix: 'WorkersCompWorkplaceAccident',
                PropertyName: 'WorkersCompWorkplaceAccident'
            },
    };
}

export class NoteTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'NoteType.';

    constructor() {
        this.ItemDetail.ItemId=2732;
        this.ItemDetail.ItemName='NoteType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteTypeId : string = this.i + 'NoteTypeId';
    NoteType : string = this.i + 'NoteType';
    MetaDataLookupId : string = this.i + 'MetaDataLookupId';

    Relations = {
            /** Relation: Note */
            NotesNote : {
                RelationName: 'NoteType|notes_Note|NoteTypeId',
                FieldPrefix: 'NotesNote',
                PropertyName: 'NotesNote'
            },
    };
}

export class MorNotificationConfigMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'mor_NotificationConfig.';

    constructor() {
        this.ItemDetail.ItemId=3449;
        this.ItemDetail.ItemName='mor_NotificationConfig';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NotificationConfigId : string = this.i + 'NotificationConfigId';
    NotificationGroupId : string = this.i + 'NotificationGroupId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    IssueTypeId : string = this.i + 'IssueTypeId';
    IssueSubtypeId : string = this.i + 'IssueSubtypeId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    To : string = this.i + 'To';
    Cc : string = this.i + 'Cc';
    Bcc : string = this.i + 'Bcc';

    Relations = {
            /** Relation: Issue Subtype */
            IssueSubtype : {
                RelationName: 'IssueSubtype|NotificationConfig|IssueSubtypeId',
                FieldPrefix: 'IssueSubtype',
                PropertyName: 'IssueSubtype'
            },
            /** Relation: Issue Type */
            IssueType : {
                RelationName: 'IssueType|NotificationConfig|IssueTypeId',
                FieldPrefix: 'IssueType',
                PropertyName: 'IssueType'
            },
            /** Relation: Notification Group */
            WcNotificationGroup : {
                RelationName: 'wc_NotificationGroup|NotificationConfig|NotificationGroupId',
                FieldPrefix: 'WcNotificationGroup',
                PropertyName: 'WcNotificationGroup'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|NotificationConfig|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|NotificationConfig|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Ethos Wachter Division */
            EthosWachterDivision : {
                RelationName: 'Ethos_WachterDivision|NotificationConfig|WachterDivisionId',
                FieldPrefix: 'EthosWachterDivision',
                PropertyName: 'EthosWachterDivision'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|NotificationConfig|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
    };
}

export class WcNotificationGroupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wc_NotificationGroup.';

    constructor() {
        this.ItemDetail.ItemId=2405;
        this.ItemDetail.ItemName='wc_NotificationGroup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NotificationGroupId : string = this.i + 'NotificationGroupId';
    NotificationTypeCv : string = this.i + 'NotificationTypeCv';
    GroupName : string = this.i + 'GroupName';
    NotificationEmailAddress : string = this.i + 'NotificationEmailAddress';
    NotificationEmailCopy : string = this.i + 'NotificationEmailCopy';
    IsDeleted : string = this.i + 'IsDeleted';
    SortOrder : string = this.i + 'SortOrder';

    Relations = {
            /** Relation: Memo Of Record Notification Group */
            MorMemoOfRecordNotificationGroup : {
                RelationName: 'wc_NotificationGroup|MemoOfRecordNotificationGroup|NotificationGroupId',
                FieldPrefix: 'MorMemoOfRecordNotificationGroup',
                PropertyName: 'MorMemoOfRecordNotificationGroup'
            },
            /** Relation: Notification Config */
            MorNotificationConfig : {
                RelationName: 'wc_NotificationGroup|NotificationConfig|NotificationGroupId',
                FieldPrefix: 'MorNotificationConfig',
                PropertyName: 'MorNotificationConfig'
            },
    };
}

export class OrganizationalEntityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OrganizationalEntity.';

    constructor() {
        this.ItemDetail.ItemId=2756;
        this.ItemDetail.ItemName='OrganizationalEntity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OrganizationalEntityId : string = this.i + 'OrganizationalEntityId';
    Name : string = this.i + 'Name';
    OrganizationalTypeId : string = this.i + 'OrganizationalTypeId';
    Alias : string = this.i + 'Alias';
    HasRevenue : string = this.i + 'HasRevenue';
    OrganizationalParentEntityId : string = this.i + 'OrganizationalParentEntityId';
    EthosKeyId : string = this.i + 'EthosKeyId';
    OverheadParentEntityId : string = this.i + 'OverheadParentEntityId';
    IsActive : string = this.i + 'IsActive';
    AssignmentStartDatetime : string = this.i + 'AssignmentStartDatetime';
    AssignmentEndDatetime : string = this.i + 'AssignmentEndDatetime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Organizational Entity - Organizational Parent Entity - One */
            OrganizationalEntityByOrganizationalParentEntityId : {
                RelationName: 'OrganizationalEntity|OrganizationalEntity|OrganizationalParentEntityId',
                FieldPrefix: 'OrganizationalParentEntityIdOrganizationalEntity',
                PropertyName: 'OrganizationalParentEntityIdOrganizationalEntity'
            },
            /** Relation: Organizational Type */
            OrganizationalType : {
                RelationName: 'OrganizationalType|OrganizationalEntity|OrganizationalTypeId',
                FieldPrefix: 'OrganizationalType',
                PropertyName: 'OrganizationalType'
            },
            /** Relation: Organizational Entity - Overhead Parent Entity - One */
            OrganizationalEntityByOverheadParentEntityId : {
                RelationName: 'OrganizationalEntity|OrganizationalEntity|OverheadParentEntityId',
                FieldPrefix: 'OverheadParentEntityIdOrganizationalEntity',
                PropertyName: 'OverheadParentEntityIdOrganizationalEntity'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalEntity|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: D W O S G Fin Data Latest */
            DWOSGFinDataLatest : {
                RelationName: 'OrganizationalEntity|DW_OSGFinDataLatest|OrganizationalEntityId',
                FieldPrefix: 'DWOSGFinDataLatest',
                PropertyName: 'DWOSGFinDataLatest'
            },
            /** Relation: Organizational Membership */
            OrganizationalMembership : {
                RelationName: 'OrganizationalEntity|OrganizationalMembership|OrganizationalEntityId',
                FieldPrefix: 'OrganizationalMembership',
                PropertyName: 'OrganizationalMembership'
            },
            /** Relation: Overhead Team Phase */
            OverheadTeamPhase : {
                RelationName: 'OrganizationalEntity|OverheadTeamPhase|OrganizationalEntityId',
                FieldPrefix: 'OverheadTeamPhase',
                PropertyName: 'OverheadTeamPhase'
            },
    };
}

export class OrganizationalMembershipMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OrganizationalMembership.';

    constructor() {
        this.ItemDetail.ItemId=2757;
        this.ItemDetail.ItemName='OrganizationalMembership';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OrganizationalMembershipId : string = this.i + 'OrganizationalMembershipId';
    OrganizationalEntityId : string = this.i + 'OrganizationalEntityId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    LeadershipLevel : string = this.i + 'LeadershipLevel';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    IsActive : string = this.i + 'IsActive';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Organizational Entity */
            OrganizationalEntity : {
                RelationName: 'OrganizationalEntity|OrganizationalMembership|OrganizationalEntityId',
                FieldPrefix: 'OrganizationalEntity',
                PropertyName: 'OrganizationalEntity'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalMembership|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Job Title */
            EthosWachterJobTitle : {
                RelationName: 'Ethos_WachterJobTitle|OrganizationalMembership|WachterJobTitleId',
                FieldPrefix: 'EthosWachterJobTitle',
                PropertyName: 'EthosWachterJobTitle'
            },
    };
}

export class OrganizationalTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OrganizationalType.';

    constructor() {
        this.ItemDetail.ItemId=2755;
        this.ItemDetail.ItemName='OrganizationalType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OrganizationalTypeId : string = this.i + 'OrganizationalTypeId';
    Name : string = this.i + 'Name';
    ParentTypeId : string = this.i + 'ParentTypeId';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Organizational Type - Parent Type - One */
            OrganizationalTypeByParentTypeId : {
                RelationName: 'OrganizationalType|OrganizationalType|ParentTypeId',
                FieldPrefix: 'ParentTypeIdOrganizationalType',
                PropertyName: 'ParentTypeIdOrganizationalType'
            },
            /** Relation: Organizational Entity */
            OrganizationalEntity : {
                RelationName: 'OrganizationalType|OrganizationalEntity|OrganizationalTypeId',
                FieldPrefix: 'OrganizationalEntity',
                PropertyName: 'OrganizationalEntity'
            },
    };
}

export class OrganizationalUnitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OrganizationalUnit.';

    constructor() {
        this.ItemDetail.ItemId=2680;
        this.ItemDetail.ItemName='OrganizationalUnit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OrganizationalUnitId : string = this.i + 'OrganizationalUnitId';
    UnitName : string = this.i + 'UnitName';
    DirectorEthosUserId : string = this.i + 'DirectorEthos_UserId';
    EthosWachterDepartmentId : string = this.i + 'Ethos_WachterDepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    IsActive : string = this.i + 'IsActive';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalUnit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Director Ethos User */
            EthosUserByDirectorEthosUserId : {
                RelationName: 'Ethos_User|OrganizationalUnit|DirectorEthos_UserId',
                FieldPrefix: 'DirectorEthosEthosUser',
                PropertyName: 'DirectorEthosEthosUser'
            },
            /** Relation: Wachter Department - Ethos Wachter Department */
            EthosWachterDepartmentByEthosWachterDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|OrganizationalUnit|Ethos_WachterDepartmentId',
                FieldPrefix: 'EthosEthosWachterDepartment',
                PropertyName: 'EthosEthosWachterDepartment'
            },
    };
}

export class OverheadProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OverheadProjection.';

    constructor() {
        this.ItemDetail.ItemId=2514;
        this.ItemDetail.ItemName='OverheadProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    FiscalYear : string = this.i + 'FiscalYear';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    Hours : string = this.i + 'Hours';
    Notes : string = this.i + 'Notes';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|OverheadProjection|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class OverheadTeamPhaseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OverheadTeamPhase.';

    constructor() {
        this.ItemDetail.ItemId=2515;
        this.ItemDetail.ItemName='OverheadTeamPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadTeamPhaseId : string = this.i + 'OverheadTeamPhaseId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    FiscalYear : string = this.i + 'FiscalYear';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    OrganizationalEntityId : string = this.i + 'OrganizationalEntityId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|OverheadTeamPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Organizational Entity */
            OrganizationalEntity : {
                RelationName: 'OrganizationalEntity|OverheadTeamPhase|OrganizationalEntityId',
                FieldPrefix: 'OrganizationalEntity',
                PropertyName: 'OrganizationalEntity'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class PafHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PafHistory.';

    constructor() {
        this.ItemDetail.ItemId=3436;
        this.ItemDetail.ItemName='PafHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PafHistoryId : string = this.i + 'PafHistoryId';
    VehicleId : string = this.i + 'VehicleId';
    Note : string = this.i + 'Note';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|PafHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'fleet_Vehicle|PafHistory|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
    };
}

export class PassHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PassHistory.';

    constructor() {
        this.ItemDetail.ItemId=3433;
        this.ItemDetail.ItemName='PassHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PassHistoryId : string = this.i + 'PassHistoryId';
    VehicleId : string = this.i + 'VehicleId';
    ActivationDate : string = this.i + 'ActivationDate';
    AccountNumber : string = this.i + 'AccountNumber';
    AccountName : string = this.i + 'AccountName';
    TransponderSerialNumber : string = this.i + 'TransponderSerialNumber';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|PassHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'fleet_Vehicle|PassHistory|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
    };
}

export class PayJobChangeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChange.';

    constructor() {
        this.ItemDetail.ItemId=2469;
        this.ItemDetail.ItemName='PayJobChange';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    EffectiveDate : string = this.i + 'EffectiveDate';
    CurrentWage : string = this.i + 'CurrentWage';
    NewWage : string = this.i + 'NewWage';
    Notes : string = this.i + 'Notes';
    IsPayChange : string = this.i + 'IsPayChange';
    IsOrganizationalChange : string = this.i + 'IsOrganizationalChange';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    NewManagerEthosUserId : string = this.i + 'NewManagerEthos_UserId';
    PayChangeTypeCv : string = this.i + 'PayChangeTypeCv';
    StatusCv : string = this.i + 'StatusCv';
    StatusAssignedToEthosUserId : string = this.i + 'StatusAssignedToEthos_UserId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    NewJobTitleId : string = this.i + 'NewJobTitleId';
    WagePercentChange : string = this.i + 'WagePercentChange';
    NewEthosWachterTeamId : string = this.i + 'NewEthos_WachterTeamId';
    RejectedNotes : string = this.i + 'RejectedNotes';
    RejectedByEthosUserId : string = this.i + 'RejectedByEthos_UserId';

    Relations = {
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|PayJobChange|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Pay Change Type */
            CodeValueByPayChangeTypeCv : {
                RelationName: 'CodeValue|PayJobChange|PayChangeTypeCv',
                FieldPrefix: 'PayChangeTypeCvCodeValue',
                PropertyName: 'PayChangeTypeCvCodeValue'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - New Manager */
            EthosUserByNewManagerEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|NewManagerEthos_UserId',
                FieldPrefix: 'NewManagerEthosEthosUser',
                PropertyName: 'NewManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByStatusAssignedToEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|StatusAssignedToEthos_UserId',
                FieldPrefix: 'StatusAssignedToEthosEthosUser',
                PropertyName: 'StatusAssignedToEthosEthosUser'
            },
            /** Relation: Ro All Supervisors Subordinates - Employee */
            RoAllSupervisorsSubordinatesByEmployeeEthosUserId : {
                RelationName: 'PayJobChange|roAllSupervisorSubordinates|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosRoAllSupervisorsSubordinates',
                PropertyName: 'EmployeeEthosRoAllSupervisorsSubordinates'
            },
            /** Relation: Ro All Supervisors Subordinates - Created By */
            RoAllSupervisorsSubordinatesByCreatedbyEthosUserId : {
                RelationName: 'PayJobChange|roAllSupervisorSubordinates|CreatedBy',
                FieldPrefix: 'CreatedbyEthosRoAllSupervisorsSubordinates',
                PropertyName: 'CreatedbyEthosRoAllSupervisorsSubordinates'
            },
            /** Relation: Ethos User - Rejected By Ethos User */
            EthosUserByRejectedByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChange|RejectedByEthos_UserId',
                FieldPrefix: 'RejectedByEthosEthosUser',
                PropertyName: 'RejectedByEthosEthosUser'
            },
            /** Relation: Wachter Job Title - New Job Title */
            EthosWachterJobTitleByNewJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|PayJobChange|NewJobTitleId',
                FieldPrefix: 'NewJobTitleIdEthosWachterJobTitle',
                PropertyName: 'NewJobTitleIdEthosWachterJobTitle'
            },
            /** Relation: Wachter Team - Wachter Team */
            EthosWachterTeamByNewEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|PayJobChange|NewEthos_WachterTeamId',
                FieldPrefix: 'NewEthosEthosWachterTeam',
                PropertyName: 'NewEthosEthosWachterTeam'
            },
            /** Relation: Pay Job Change Email */
            PayJobChangeEmail : {
                RelationName: 'PayJobChange|PayJobChangeEmail|PayJobChangeId',
                FieldPrefix: 'PayJobChangeEmail',
                PropertyName: 'PayJobChangeEmail'
            },
            /** Relation: Pay Job Change Users Read */
            PayJobChangeUsersRead : {
                RelationName: 'PayJobChange|PayJobChangeUsersRead|PayJobChangeId',
                FieldPrefix: 'PayJobChangeUsersRead',
                PropertyName: 'PayJobChangeUsersRead'
            },
            /** Relation: Pay Job Change Workflow Email */
            PayJobChangeWorkflowEmail : {
                RelationName: 'PayJobChangeWorkflowEmail > PayJobChange',
                FieldPrefix: 'PayJobChangeWorkflowEmail',
                PropertyName: 'PayJobChangeWorkflowEmail'
            },
            /** Relation: Ro Paf Access */
            RoPafAccess : {
                RelationName: 'roPafAccess|PayJobChange|PayJobChangeId',
                FieldPrefix: 'RoPafAccess',
                PropertyName: 'RoPafAccess'
            },
    };
}

export class PayJobChangeEmailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChangeEmail.';

    constructor() {
        this.ItemDetail.ItemId=2475;
        this.ItemDetail.ItemName='PayJobChangeEmail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeEmail : string = this.i + 'PayJobChangeEmail';
    EmailId : string = this.i + 'EmailId';
    PayJobChangeId : string = this.i + 'PayJobChangeId';

    Relations = {
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'PayJobChange|PayJobChangeEmail|PayJobChangeId',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
    };
}

export class PayJobChangeUsersReadMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChangeUsersRead.';

    constructor() {
        this.ItemDetail.ItemId=2474;
        this.ItemDetail.ItemName='PayJobChangeUsersRead';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeUsersRead : string = this.i + 'PayJobChangeUsersRead';
    EthosUserId : string = this.i + 'Ethos_UserId';
    PayJobChangeId : string = this.i + 'PayJobChangeId';

    Relations = {
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'PayJobChange|PayJobChangeUsersRead|PayJobChangeId',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|PayJobChangeUsersRead|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class PayJobChangeWorkflowEmailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChangeWorkflowEmail.';

    constructor() {
        this.ItemDetail.ItemId=2753;
        this.ItemDetail.ItemName='PayJobChangeWorkflowEmail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeWorkflowEmailId : string = this.i + 'PayJobChangeWorkflowEmailId';
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    StatusCv : string = this.i + 'StatusCv';
    IsOrgChange : string = this.i + 'IsOrgChange';
    ActionId : string = this.i + 'ActionId';
    ActionResult : string = this.i + 'ActionResult';
    PublicKey : string = this.i + 'PublicKey';

    Relations = {
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|PayJobChangeWorkflowEmail|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'PayJobChangeWorkflowEmail > PayJobChange',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
    };
}

export class PeoplePayHistoryCurrentPreviousInitialMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PeoplePayHistoryCurrentPreviousInitial.';

    constructor() {
        this.ItemDetail.ItemId=2587;
        this.ItemDetail.ItemName='PeoplePayHistoryCurrentPreviousInitial';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ETHOSUserId : string = this.i + 'ETHOSUserId';
    PayRecord : string = this.i + 'PayRecord';
    EffectiveDate : string = this.i + 'EffectiveDate';
    PayRate : string = this.i + 'PayRate';
    PayRateOrder : string = this.i + 'PayRateOrder';

    Relations = {
            /** Relation: User Extended - E T H O S User */
            EmsUserExtendedByETHOSUserId : {
                RelationName: 'UserExtended|PeoplePayHistoryCurrentPreviousInitial|EthosUserId',
                FieldPrefix: 'ETHOSUserIdEmsUserExtended',
                PropertyName: 'ETHOSUserIdEmsUserExtended'
            },
    };
}

export class PeoplePayHistoryCurrentPreviousInitialV2MetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PeoplePayHistoryCurrentPreviousInitialV2.';

    constructor() {
        this.ItemDetail.ItemId=2642;
        this.ItemDetail.ItemName='PeoplePayHistoryCurrentPreviousInitialV2';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ETHOSUserId : string = this.i + 'ETHOSUserId';
    PayRecord : string = this.i + 'PayRecord';
    EffectiveDate : string = this.i + 'EffectiveDate';
    PayRate : string = this.i + 'PayRate';
    PayRateOrder : string = this.i + 'PayRateOrder';

    Relations = {
            /** Relation: User Extended - E T H O S User */
            EmsUserExtendedByETHOSUserId : {
                RelationName: 'EMS People Pay Historwy',
                FieldPrefix: 'ETHOSUserIdEmsUserExtended',
                PropertyName: 'ETHOSUserIdEmsUserExtended'
            },
    };
}

export class PerformanceMetricsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PerformanceMetrics.';

    constructor() {
        this.ItemDetail.ItemId=2593;
        this.ItemDetail.ItemName='PerformanceMetrics';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    PerformanceAllTime : string = this.i + 'PerformanceAllTime';
    KudosAllTime : string = this.i + 'KudosAllTime';
    BehaiverAllTime : string = this.i + 'BehaiverAllTime';
    MisconductAllTime : string = this.i + 'MisconductAllTime';
    PerformanceThisYear : string = this.i + 'PerformanceThisYear';
    KudoThisYear : string = this.i + 'KudoThisYear';
    BehaiverThisYear : string = this.i + 'BehaiverThisYear';
    MisconductThisYear : string = this.i + 'MisconductThisYear';
    VehicleAccidentsAllTime : string = this.i + 'VehicleAccidentsAllTime';
    VehicleAccidentsThisYear : string = this.i + 'VehicleAccidentsThisYear';
    WorkplaceAccidentsAllTime : string = this.i + 'WorkplaceAccidentsAllTime';
    WorkplaceAccidentsThisYear : string = this.i + 'WorkplaceAccidentsThisYear';

    Relations = {
            /** Relation: User Extended - User - Many */
            EmsUserExtendedByEmployeeEthosUserId : {
                RelationName: 'UserExtended|PerformanceMetrics|UserId',
                FieldPrefix: 'EmployeeEthosEmsUserExtended',
                PropertyName: 'EmployeeEthosEmsUserExtended'
            },
    };
}

export class PermitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Permit.';

    constructor() {
        this.ItemDetail.ItemId=2633;
        this.ItemDetail.ItemName='Permit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUser : string = this.i + 'RequestedByUser';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    DueDate : string = this.i + 'DueDate';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubcontractorLicense : string = this.i + 'SubcontractorLicense';
    AssignedToUser : string = this.i + 'AssignedToUser';
    FloorCount : string = this.i + 'FloorCount';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCablingPresent : string = this.i + 'UndergroundCablingPresent';
    CablingInConduitPresent : string = this.i + 'CablingInConduitPresent';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    CableTypeCv : string = this.i + 'CableTypeCv';
    PermitStatusWs : string = this.i + 'PermitStatusWs';
    JobId : string = this.i + 'JobId';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    AttachmentId : string = this.i + 'AttachmentId';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    JobSiteId : string = this.i + 'JobSiteId';
    SharepointId : string = this.i + 'SharepointId';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    NoteParentId : string = this.i + 'NoteParentId';
    PermitRequestid : string = this.i + 'PermitRequestid';
    OverallContractValuation : string = this.i + 'OverallContractValuation';
    PlenumOrRiserCv : string = this.i + 'PlenumOrRiserCv';
    CableQuantity : string = this.i + 'CableQuantity';
    HasCameras : string = this.i + 'HasCameras';
    CameraQuantity : string = this.i + 'CameraQuantity';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakerQuantity : string = this.i + 'SpeakerQuantity';
    InitiationDeviceQuantity : string = this.i + 'InitiationDeviceQuantity';
    NACQuantity : string = this.i + 'NACQuantity';
    SwappingOutPanel : string = this.i + 'SwappingOutPanel';
    OutletQuantity : string = this.i + 'OutletQuantity';
    HasCardReaders : string = this.i + 'HasCardReaders';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    HasPaging : string = this.i + 'HasPaging';
    AlarmPanelInstallation : string = this.i + 'AlarmPanelInstallation';
    DeviceType : string = this.i + 'DeviceType';
    OverallSOWValuation : string = this.i + 'OverallSOWValuation';
    TotalAmps : string = this.i + 'TotalAmps';
    ElectricalPanelQuantity : string = this.i + 'ElectricalPanelQuantity';
    CircuitQuantity : string = this.i + 'CircuitQuantity';
    AccessControlTypeCv : string = this.i + 'AccessControlTypeCv';
    AccessControlQuantity : string = this.i + 'AccessControlQuantity';
    AlarmPanelQuantity : string = this.i + 'AlarmPanelQuantity';
    FilesInSharepoint : string = this.i + 'FilesInSharepoint';
    CriticalPower : string = this.i + 'CriticalPower';
    RoomCount : string = this.i + 'RoomCount';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    CableTypeOtherName : string = this.i + 'CableTypeOtherName';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    AccessControlOther : string = this.i + 'AccessControlOther';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    InfoNeededNote : string = this.i + 'InfoNeededNote';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedJobCompletionDate : string = this.i + 'EstimatedJobCompletionDate';
    FireAlarmAdditionalDevices : string = this.i + 'FireAlarmAdditionalDevices';
    PlenumRated : string = this.i + 'PlenumRated';
    WorkplaceSquareFeet : string = this.i + 'WorkplaceSquareFeet';
    ExpirationDate : string = this.i + 'ExpirationDate';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    FollowUpDate : string = this.i + 'FollowUpDate';
    Jurisdiction : string = this.i + 'Jurisdiction';
    FollowUpDescription : string = this.i + 'FollowUpDescription';
    InspectionStateCv : string = this.i + 'InspectionStateCv';
    MediaGroupId : string = this.i + 'MediaGroupId';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|Permit|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Ethos Code Value - Cable Type */
            EthosCodeValueByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvEthosCodeValue',
                PropertyName: 'CableTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Performing Work */
            EthosCodeValueByPerformingWorkCv : {
                RelationName: 'Ethos_CodeValue|Permit|PerformingWorkCv',
                FieldPrefix: 'PerformingWorkCvEthosCodeValue',
                PropertyName: 'PerformingWorkCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Plenum Or Riser */
            EthosCodeValueByPlenumOrRiserCv : {
                RelationName: 'Ethos_CodeValue|Permit|PlenumOrRiserCv',
                FieldPrefix: 'PlenumOrRiserCvEthosCodeValue',
                PropertyName: 'PlenumOrRiserCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByCableTypeCv : {
                RelationName: 'CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvCodeValue',
                PropertyName: 'CableTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Fire Alarm Demo Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Trust Code Value - Access Control Type */
            CodeValueByAccessControlTypeCv : {
                RelationName: 'CodeValue|Permit|AccessControlTypeCv',
                FieldPrefix: 'AccessControlTypeCvCodeValue',
                PropertyName: 'AccessControlTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - C C T V Install Type */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Different Type */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Inspection State */
            CodeValueByInspectionStateCv : {
                RelationName: 'CodeValue|Permit|InspectionStateCv',
                FieldPrefix: 'InspectionStateCvCodeValue',
                PropertyName: 'InspectionStateCvCodeValue'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Permit|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Permit|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|Permit|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Ro Permits */
            RoPermits : {
                RelationName: 'roPermit}Permit|PermitId',
                FieldPrefix: 'RoPermits',
                PropertyName: 'RoPermits'
            },
            /** Relation: Permit Request - Permit Request */
            PermitRequestByPermitRequestid : {
                RelationName: 'permitRequest|Permit|PermitRequestid',
                FieldPrefix: 'PermitRequestidPermitRequest',
                PropertyName: 'PermitRequestidPermitRequest'
            },
            /** Relation: State Province - Property Owner State */
            EthosStateProvinceByPropertyOwnerStateId : {
                RelationName: 'Ethos_StateProvince|Permit|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerStateIdEthosStateProvince',
                PropertyName: 'PropertyOwnerStateIdEthosStateProvince'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUser : {
                RelationName: 'Ethos_User|Permit|RequestedByUser',
                FieldPrefix: 'RequestedByUserEthosUser',
                PropertyName: 'RequestedByUserEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUser : {
                RelationName: 'Ethos_User|Permit|AssignedToUser',
                FieldPrefix: 'AssignedToUserEthosUser',
                PropertyName: 'AssignedToUserEthosUser'
            },
            /** Relation: Ethos Workflow Status - Permit Status */
            EthosWorkflowStatusByPermitStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Permit|PermitStatusWs',
                FieldPrefix: 'PermitStatusWsEthosWorkflowStatus',
                PropertyName: 'PermitStatusWsEthosWorkflowStatus'
            },
            /** Relation: Access Control */
            AccessControl : {
                RelationName: 'Permit|AccessControl|PermitId',
                FieldPrefix: 'AccessControl',
                PropertyName: 'AccessControl'
            },
            /** Relation: Inspection */
            Inspection : {
                RelationName: 'Permit|Inspection|PermitId',
                FieldPrefix: 'Inspection',
                PropertyName: 'Inspection'
            },
            /** Relation: Note - Accessory Data - Many */
            NotesNoteByAccessoryData : {
                RelationName: 'Note -> Permit with Accessory Data',
                FieldPrefix: 'AccessoryDataNotesNote',
                PropertyName: 'AccessoryDataNotesNote'
            },
            /** Relation: Permit Permit Type */
            PermitPermitType : {
                RelationName: 'Permit|PermitPermitType|PermitId',
                FieldPrefix: 'PermitPermitType',
                PropertyName: 'PermitPermitType'
            },
            /** Relation: Permit Request - Data Cable - Many */
            PermitRequestByDataCablePermitId : {
                RelationName: 'Permit|permitRequest|DataCablePermitId',
                FieldPrefix: 'DataCablePermitRequest',
                PropertyName: 'DataCablePermitRequest'
            },
            /** Relation: Permit Request Permit */
            PermitRequestPermit : {
                RelationName: 'Permit|PermitRequests|PermitId',
                FieldPrefix: 'PermitRequestPermit',
                PropertyName: 'PermitRequestPermit'
            },
            /** Relation: Required Cable */
            RequiredCable : {
                RelationName: 'Permit|RequiredCable|PermitId',
                FieldPrefix: 'RequiredCable',
                PropertyName: 'RequiredCable'
            },
            /** Relation: Ro Inspections */
            RoInspections : {
                RelationName: 'roInspections|Permit|PermitId',
                FieldPrefix: 'RoInspections',
                PropertyName: 'RoInspections'
            },
    };
}

export class Permits2PermitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_Permit.';

    constructor() {
        this.ItemDetail.ItemId=2777;
        this.ItemDetail.ItemName='permits2_Permit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    LegacyPermitRequestId : string = this.i + 'LegacyPermitRequestId';
    LegacyPermitId : string = this.i + 'LegacyPermitId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    PermitRequestTypeCv : string = this.i + 'PermitRequestTypeCv';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    RushRequested : string = this.i + 'RushRequested';
    DueDate : string = this.i + 'DueDate';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    EmailCopyString : string = this.i + 'EmailCopyString';
    AssignedToUserId : string = this.i + 'AssignedToUserId';
    FollowUpDate : string = this.i + 'FollowUpDate';
    IsLicenceRequired : string = this.i + 'IsLicenceRequired';
    HasLicenseFile : string = this.i + 'HasLicenseFile';
    FollowUpDescription : string = this.i + 'FollowUpDescription';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedCompletionDate : string = this.i + 'EstimatedCompletionDate';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';
    Jurisdiction : string = this.i + 'Jurisdiction';
    NoteParentId : string = this.i + 'NoteParentId';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubContractorLicenseNumber : string = this.i + 'SubContractorLicenseNumber';
    CardReader : string = this.i + 'CardReader';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    Paging : string = this.i + 'Paging';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    VoiceDataPlenumRated : string = this.i + 'VoiceDataPlenumRated';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVPlenumRated : string = this.i + 'CCTVPlenumRated';
    HasCameras : string = this.i + 'HasCameras';
    CamerasQuantity : string = this.i + 'CamerasQuantity';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    AudioPlenumRated : string = this.i + 'AudioPlenumRated';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakersQuantity : string = this.i + 'SpeakersQuantity';
    IsSwappingOutPanel : string = this.i + 'IsSwappingOutPanel';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    FireAlarmInitiatingDevices : string = this.i + 'FireAlarmInitiatingDevices';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    OutletQuantity : string = this.i + 'OutletQuantity';
    TotalAmps : string = this.i + 'TotalAmps';
    PanelsQuantity : string = this.i + 'PanelsQuantity';
    CircuitsQuantity : string = this.i + 'CircuitsQuantity';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    HasPanelInstallation : string = this.i + 'HasPanelInstallation';
    BurglarAlarmPanelQuantity : string = this.i + 'BurglarAlarmPanelQuantity';
    BurglarAlarmDeviceType : string = this.i + 'BurglarAlarmDeviceType';
    NumberOfRooms : string = this.i + 'NumberOfRooms';
    FloorCount : string = this.i + 'FloorCount';
    PlenumRiserCv : string = this.i + 'PlenumRiserCv';
    HasUndergroundCabling : string = this.i + 'HasUndergroundCabling';
    HasCableInConduit : string = this.i + 'HasCableInConduit';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    GCPermitNumber : string = this.i + 'GCPermitNumber';
    ValuationOverallContract : string = this.i + 'ValuationOverallContract';
    ValuationOverallSOW : string = this.i + 'ValuationOverallSOW';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    CountOfNac : string = this.i + 'CountOfNac';
    FacilityFootage : string = this.i + 'FacilityFootage';
    WorkplaceFootage : string = this.i + 'WorkplaceFootage';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    MergeDeleted : string = this.i + 'MergeDeleted';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    PermitCost : string = this.i + 'PermitCost';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    ExpirationDate : string = this.i + 'ExpirationDate';
    InfoNeededNote : string = this.i + 'InfoNeededNote';
    FilesInSharepoint : string = this.i + 'FilesInSharepoint';
    SharepointId : string = this.i + 'SharepointId';
    PermitStatusId : string = this.i + 'PermitStatusId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    SubPanelQuantity : string = this.i + 'SubPanelQuantity';
    FixtureQuantity : string = this.i + 'FixtureQuantity';
    AdditionalNotesElectrical : string = this.i + 'AdditionalNotesElectrical';
    CountAdditionalDevicesFire : string = this.i + 'CountAdditionalDevicesFire';
    AdditionalDeviceDescriptionFire : string = this.i + 'AdditionalDeviceDescriptionFire';
    CountAdditionalDevicesBurglar : string = this.i + 'CountAdditionalDevicesBurglar';
    AdditionalDeviceDescriptionBurglar : string = this.i + 'AdditionalDeviceDescriptionBurglar';
    CompleteDate : string = this.i + 'CompleteDate';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    PermitRequired : string = this.i + 'PermitRequired';
    HasExceptions : string = this.i + 'HasExceptions';
    InspectionRequired : string = this.i + 'InspectionRequired';
    ApplyForPermit : string = this.i + 'ApplyForPermit';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberAddress1 : string = this.i + 'JobNumberAddress1';
    JobNumberAddress2 : string = this.i + 'JobNumberAddress2';
    JobNumberCity : string = this.i + 'JobNumberCity';
    JobNumberStateProvinceId : string = this.i + 'JobNumberStateProvinceId';
    JobNumberPostalCode : string = this.i + 'JobNumberPostalCode';
    ChangeRequestId : string = this.i + 'ChangeRequestId';

    Relations = {
            /** Relation: Change Request */
            ChangeRequest : {
                RelationName: 'ChangeRequest|permits2_Permit|ChangeRequestId',
                FieldPrefix: 'ChangeRequest',
                PropertyName: 'ChangeRequest'
            },
            /** Relation: Trust Code Value - Permit Request Type */
            CodeValueByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvCodeValue',
                PropertyName: 'PermitRequestTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Type of Install */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Different Types of Electrical */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permits2_Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Demo or Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permits2_Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Plenum Or Riser */
            EthosCodeValueByPlenumRiserCv : {
                RelationName: 'Ethos_CodeValue|permits2_Permit|PlenumRiserCv',
                FieldPrefix: 'PlenumRiserCvEthosCodeValue',
                PropertyName: 'PlenumRiserCvEthosCodeValue'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|permits2_Permit|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|permits2_Permit|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|permits2_Permit|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|permits2_Permit|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|permits2.Permit|PermitId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
            /** Relation: Permit Status */
            Permits2PermitStatus : {
                RelationName: 'permits2_PermitStatus|permits2_Permit|PermitStatusId',
                FieldPrefix: 'Permits2PermitStatus',
                PropertyName: 'Permits2PermitStatus'
            },
            /** Relation: State Province - Property Owner State */
            EthosStateProvinceByPropertyOwnerStateId : {
                RelationName: 'Ethos_StateProvince|permits2_Permit|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerStateIdEthosStateProvince',
                PropertyName: 'PropertyOwnerStateIdEthosStateProvince'
            },
            /** Relation: State Province - Job Number State Province */
            EthosStateProvinceByJobNumberStateProvinceId : {
                RelationName: 'Ethos_StateProvince|permits2_Permit|JobNumberStateProvinceId',
                FieldPrefix: 'JobNumberEthosStateProvince',
                PropertyName: 'JobNumberEthosStateProvince'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUserId : {
                RelationName: 'Ethos_User|permits2_Permit|RequestedByUserId',
                FieldPrefix: 'RequestedByEthosUser',
                PropertyName: 'RequestedByEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUserId : {
                RelationName: 'Ethos_User|permits2_Permit|AssignedToUserId',
                FieldPrefix: 'AssignedToEthosUser',
                PropertyName: 'AssignedToEthosUser'
            },
            /** Relation: Access Control */
            Permits2AccessControl : {
                RelationName: 'permits2_Permit|permits2_AccessControl|PermitId',
                FieldPrefix: 'Permits2AccessControl',
                PropertyName: 'Permits2AccessControl'
            },
            /** Relation: Attachment Conversion Permit - S V2 - Many */
            AttachmentConversionPermitByPermitsV2Id : {
                RelationName: 'permits2_Permit|AttachmentConversionPermit|PermitsV2Id',
                FieldPrefix: 'PermitsV2IdAttachmentConversionPermit',
                PropertyName: 'PermitsV2IdAttachmentConversionPermit'
            },
            /** Relation: Inspection */
            Permits2Inspection : {
                RelationName: 'permits2_Permit|permits2_Inspection|PermitId',
                FieldPrefix: 'Permits2Inspection',
                PropertyName: 'Permits2Inspection'
            },
            /** Relation: Permit Permit Type */
            Permits2PermitPermitType : {
                RelationName: 'permits2_Permit|permits2_PermitPermitType|PermitId',
                FieldPrefix: 'Permits2PermitPermitType',
                PropertyName: 'Permits2PermitPermitType'
            },
            /** Relation: Required Cable */
            Permits2RequiredCable : {
                RelationName: 'permits2_Permit|permits2_RequiredCable|PermitId',
                FieldPrefix: 'Permits2RequiredCable',
                PropertyName: 'Permits2RequiredCable'
            },
            /** Relation: Ro Active Change Request */
            RoActiveChangeRequest : {
                RelationName: 'roActiveChangeRequest|permits2_Permit:PermitId',
                FieldPrefix: 'RoActiveChangeRequest',
                PropertyName: 'RoActiveChangeRequest'
            },
            /** Relation: Ro Inspections */
            Permits2RoInspections : {
                RelationName: 'roInspections|Permitv2|PermitId',
                FieldPrefix: 'Permits2roInspections',
                PropertyName: 'Permits2roInspections'
            },
            /** Relation: Stage Audit Log */
            StageAuditLog : {
                RelationName: 'permits2_Permit|StageAuditLog|PermitId',
                FieldPrefix: 'StageAuditLog',
                PropertyName: 'StageAuditLog'
            },
    };
}

export class PermitPermitTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2678;
        this.ItemDetail.ItemName='PermitPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitPermitTypeId : string = this.i + 'PermitPermitTypeId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Permit Type */
            CodeValueByPermitTypeCv : {
                RelationName: 'CodeValue|PermitPermitTypeOld|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvCodeValue',
                PropertyName: 'PermitTypeCvCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|PermitPermitType|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}

export class Permits2PermitPermitTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_PermitPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2778;
        this.ItemDetail.ItemName='permits2_PermitPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitPermitTypeId : string = this.i + 'PermitPermitTypeId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_PermitPermitType|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class PermitRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permitRequest.';

    constructor() {
        this.ItemDetail.ItemId=2613;
        this.ItemDetail.ItemName='permitRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    StatusCv : string = this.i + 'StatusCv';
    DueDate : string = this.i + 'DueDate';
    WJID : string = this.i + 'WJID';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    PulledOnline : string = this.i + 'PulledOnline';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    Valuation : string = this.i + 'Valuation';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubLicenseNumber : string = this.i + 'SubLicenseNumber';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    AssignedToUserId : string = this.i + 'AssignedToUserId';
    NumberOfFloors : string = this.i + 'NumberOfFloors';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    PlenumOrRiser : string = this.i + 'PlenumOrRiser';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCabling : string = this.i + 'UndergroundCabling';
    CablingInConduit : string = this.i + 'CablingInConduit';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    Address : string = this.i + 'Address';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    Zipcode : string = this.i + 'Zipcode';
    AttachmentId : string = this.i + 'AttachmentId';
    JobSiteId : string = this.i + 'JobSiteId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    ConstructionType : string = this.i + 'ConstructionType';
    JobId : string = this.i + 'JobId';
    OpportunityId : string = this.i + 'OpportunityId';
    DataCableQuantity : string = this.i + 'DataCableQuantity';
    HasCameras : string = this.i + 'HasCameras';
    CamerasQuantity : string = this.i + 'CamerasQuantity';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakersQuantity : string = this.i + 'SpeakersQuantity';
    HasFireAlarm : string = this.i + 'HasFireAlarm';
    NumberAditionalDevices : string = this.i + 'NumberAditionalDevices';
    NumberNaNC : string = this.i + 'NumberNaNC';
    IsSwappingOutPanel : string = this.i + 'IsSwappingOutPanel';
    HasElectrical : string = this.i + 'HasElectrical';
    OutletQuantity : string = this.i + 'OutletQuantity';
    TotalAmps : string = this.i + 'TotalAmps';
    PanelsQuantity : string = this.i + 'PanelsQuantity';
    CircuitsQuantity : string = this.i + 'CircuitsQuantity';
    HasAccessControl : string = this.i + 'HasAccessControl';
    AccessControlCV : string = this.i + 'AccessControlCV';
    AccessControlQuantity : string = this.i + 'AccessControlQuantity';
    CardReader : string = this.i + 'CardReader';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    Paging : string = this.i + 'Paging';
    HasPanelInstalation : string = this.i + 'HasPanelInstalation';
    BuglarAlarmPanelQuantity : string = this.i + 'BuglarAlarmPanelQuantity';
    BuglarAlarmDeviceType : string = this.i + 'BuglarAlarmDeviceType';
    PerformWork : string = this.i + 'PerformWork';
    SubContractorLicenseNumber : string = this.i + 'SubContractorLicenseNumber';
    SpecificDescription : string = this.i + 'SpecificDescription';
    NumberOfRooms : string = this.i + 'NumberOfRooms';
    FacilitySquareFootage : string = this.i + 'FacilitySquareFootage';
    WorkspaceSquareFootage : string = this.i + 'WorkspaceSquareFootage';
    PlenumRiser : string = this.i + 'PlenumRiser';
    HasUndergroundCabling : string = this.i + 'HasUndergroundCabling';
    HasCableInConduit : string = this.i + 'HasCableInConduit';
    ValuationOverallContract : string = this.i + 'ValuationOverallContract';
    ValuationOverallSOW : string = this.i + 'ValuationOverallSOW';
    ExpectedStartDate : string = this.i + 'ExpectedStartDate';
    ExpectedCompletion : string = this.i + 'ExpectedCompletion';
    PermitRequestTypeCv : string = this.i + 'PermitRequestTypeCv';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    DataCablePermitId : string = this.i + 'DataCablePermitId';
    SecondaryAssignedToUserId : string = this.i + 'SecondaryAssignedToUserId';
    CriticalPower : string = this.i + 'CriticalPower';
    JobSiteAddress1 : string = this.i + 'JobSiteAddress1';
    JobSiteAddress2 : string = this.i + 'JobSiteAddress2';
    CountyId : string = this.i + 'CountyId';
    PostalCode : string = this.i + 'PostalCode';
    PermitRequestJobType : string = this.i + 'PermitRequestJobType';
    GCPresent : string = this.i + 'GCPresent';
    HasAudioVisual : string = this.i + 'HasAudioVisual';
    HasBurglarAlarm : string = this.i + 'HasBurglarAlarm';
    VoiceDataCableTypeCV : string = this.i + 'VoiceDataCableTypeCV';
    VoiceDataQuantity : string = this.i + 'VoiceDataQuantity';
    VoiceDataPlenumRated : string = this.i + 'VoiceDataPlenumRated';
    HasCCTV : string = this.i + 'HasCCTV';
    CCTVCableTypeCV : string = this.i + 'CCTVCableTypeCV';
    CCTVQuantity : string = this.i + 'CCTVQuantity';
    CCTVPlenumRated : string = this.i + 'CCTVPlenumRated';
    HasAudio : string = this.i + 'HasAudio';
    AudioCableTypeCV : string = this.i + 'AudioCableTypeCV';
    AudioQuantity : string = this.i + 'AudioQuantity';
    AudioPlenumRated : string = this.i + 'AudioPlenumRated';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    HasDataVoice : string = this.i + 'HasDataVoice';
    GCPermitNumber : string = this.i + 'GCPermitNumber';
    FloorCount : string = this.i + 'FloorCount';
    DataVoiceOtherCable : string = this.i + 'DataVoiceOtherCable';
    CCTVOtherCable : string = this.i + 'CCTVOtherCable';
    AudioVisualOtherCable : string = this.i + 'AudioVisualOtherCable';
    NoteParentId : string = this.i + 'NoteParentId';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    FireAlarmInitiatingDevices : string = this.i + 'FireAlarmInitiatingDevices';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    AccessControlOther : string = this.i + 'AccessControlOther';
    AccessControlOtherTypeCv : string = this.i + 'AccessControlOtherTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    IsLicenceRequired : string = this.i + 'IsLicenceRequired';
    HasLicenseFile : string = this.i + 'HasLicenseFile';
    WorkplaceSquareFeet : string = this.i + 'WorkplaceSquareFeet';
    FollowUpDate : string = this.i + 'FollowUpDate';
    RushRequested : string = this.i + 'RushRequested';
    RequestCompleteDate : string = this.i + 'RequestCompleteDate';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    Jurisdiction : string = this.i + 'Jurisdiction';
    FollowUpDescription : string = this.i + 'FollowUpDescription';
    EmailCopyString : string = this.i + 'EmailCopyString';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|permitRequest|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Ethos Code Value - (NOT USED) */
            EthosCodeValueByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|CableTypeCv',
                FieldPrefix: 'CableTypeCvEthosCodeValue',
                PropertyName: 'CableTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - (NOT USED) */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Plenum or Riser */
            EthosCodeValueByPlenumRiser : {
                RelationName: 'Ethos_CodeValue|permitRequest|PlenumRiser',
                FieldPrefix: 'PlenumRiserEthosCodeValue',
                PropertyName: 'PlenumRiserEthosCodeValue'
            },
            /** Relation: Trust Code Value - Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Demo or Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permitRequest|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Trust Code Value - (NOT USED) */
            CodeValueByAccessControlCV : {
                RelationName: 'CodeValue|permitRequest|AccessControlCV',
                FieldPrefix: 'AccessControlCVCodeValue',
                PropertyName: 'AccessControlCVCodeValue'
            },
            /** Relation: Trust Code Value - (NOT USED) */
            CodeValueByAccessControlOtherTypeCv : {
                RelationName: 'CodeValue|permitRequest|AccessControlOtherTypeCv',
                FieldPrefix: 'AccessControlOtherTypeCvCodeValue',
                PropertyName: 'AccessControlOtherTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Permit Request Type */
            CodeValueByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permitRequest|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvCodeValue',
                PropertyName: 'PermitRequestTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - (NOT USED) */
            CodeValueByAudioCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|AudioCableTypeCV',
                FieldPrefix: 'AudioCableTypeCVCodeValue',
                PropertyName: 'AudioCableTypeCVCodeValue'
            },
            /** Relation: Trust Code Value - (NOT USED) */
            CodeValueByCCTVCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|CCTVCableTypeCV',
                FieldPrefix: 'CCTVCableTypeCVCodeValue',
                PropertyName: 'CCTVCableTypeCVCodeValue'
            },
            /** Relation: Trust Code Value - Type of Install */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permitRequest|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|permitRequest|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Trust Code Value - (NOT USED) */
            CodeValueByVoiceDataCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|VoiceDataCableTypeCV',
                FieldPrefix: 'VoiceDataCableTypeCVCodeValue',
                PropertyName: 'VoiceDataCableTypeCVCodeValue'
            },
            /** Relation: Trust Code Value - Different Types of Electrical */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Ethos County */
            DboEthosCounty : {
                RelationName: 'dbo_Ethos_County|permitRequest|CountyId',
                FieldPrefix: 'DboEthosCounty',
                PropertyName: 'DboEthosCounty'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|permitRequest|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job - (NOT USED) */
            EthosJobByWJID : {
                RelationName: 'Job|PermitRequest|JobId',
                FieldPrefix: 'WJIDEthosJob',
                PropertyName: 'WJIDEthosJob'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|PermitRequest|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|permitRequest|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'Ethos_Opportunity|permitRequest|OpportunityId',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Permit - (NOT USED) */
            PermitByDataCablePermitId : {
                RelationName: 'Permit|permitRequest|DataCablePermitId',
                FieldPrefix: 'DataCablePermit',
                PropertyName: 'DataCablePermit'
            },
            /** Relation: Ro Permit Requests */
            RoPermitRequests : {
                RelationName: 'roPermitRequests|permitRequest|PermitRequestId',
                FieldPrefix: 'RoPermitRequests',
                PropertyName: 'RoPermitRequests'
            },
            /** Relation: Ro Permit Request Last Note */
            RoPermitRequestLastNote : {
                RelationName: 'roPermitRequestLastNote|PermitRequest|PermitRequestId',
                FieldPrefix: 'RoPermitRequestLastNote',
                PropertyName: 'RoPermitRequestLastNote'
            },
            /** Relation: State Province - (NOT USED) */
            EthosStateProvinceByPropertyOwnerName : {
                RelationName: 'Ethos_StateProvince|PermitRequest|PropertyOwnerStateId',
                FieldPrefix: 'PropertyOwnerNameEthosStateProvince',
                PropertyName: 'PropertyOwnerNameEthosStateProvince'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|permitRequest|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|AssignedToUserId',
                FieldPrefix: 'AssignedToEthosUser',
                PropertyName: 'AssignedToEthosUser'
            },
            /** Relation: Ethos User - Secondary Assigned To */
            EthosUserBySecondaryAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|SecondaryAssignedToUserId',
                FieldPrefix: 'SecondaryAssignedToEthosUser',
                PropertyName: 'SecondaryAssignedToEthosUser'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUserId : {
                RelationName: 'Ethos_User|permitRequest|RequestedByUserId',
                FieldPrefix: 'RequestedByEthosUser',
                PropertyName: 'RequestedByEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Access Control */
            AccessControl : {
                RelationName: 'permitRequest|AccessControl|PermitRequestId',
                FieldPrefix: 'AccessControl',
                PropertyName: 'AccessControl'
            },
            /** Relation: Permit - Request ID - Many */
            PermitByPermitRequestid : {
                RelationName: 'permitRequest|Permit|PermitRequestid',
                FieldPrefix: 'PermitRequestidPermit',
                PropertyName: 'PermitRequestidPermit'
            },
            /** Relation: Permit Request Permit */
            PermitRequestPermit : {
                RelationName: 'permitRequest|PermitRequestPermit|PermitRequestId',
                FieldPrefix: 'PermitRequestPermit',
                PropertyName: 'PermitRequestPermit'
            },
            /** Relation: Permit Request Permit Type */
            PermitRequestPermitType : {
                RelationName: 'permitRequest|PermitRequestPermitType|PermitRequestId',
                FieldPrefix: 'PermitRequestPermitType',
                PropertyName: 'PermitRequestPermitType'
            },
            /** Relation: Required Cable */
            RequiredCable : {
                RelationName: 'permitRequest|RequiredCable|PermitRequestId',
                FieldPrefix: 'RequiredCable',
                PropertyName: 'RequiredCable'
            },
    };
}

export class PermitRequestPermitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitRequestPermit.';

    constructor() {
        this.ItemDetail.ItemId=2699;
        this.ItemDetail.ItemName='PermitRequestPermit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCV : string = this.i + 'PermitTypeCV';
    PermitRequestPermitId : string = this.i + 'PermitRequestPermitId';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCV : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermit|PermitTypeCV',
                FieldPrefix: 'PermitTypeCVEthosCodeValue',
                PropertyName: 'PermitTypeCVEthosCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|PermitRequests|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|PermitRequestPermit|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

export class PermitRequestPermitTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitRequestPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2747;
        this.ItemDetail.ItemName='PermitRequestPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestPermitTypeId : string = this.i + 'PermitRequestPermitTypeId';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Trust Code Value - Permit Type */
            CodeValueByPermitTypeCv : {
                RelationName: 'CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvCodeValue',
                PropertyName: 'PermitTypeCvCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|PermitRequestPermitType|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

export class PermitStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitStatus.';

    constructor() {
        this.ItemDetail.ItemId=2744;
        this.ItemDetail.ItemName='PermitStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitStatusId : string = this.i + 'PermitStatusId';
    PermitStatusDisplay : string = this.i + 'PermitStatusDisplay';
    PermitSsatusMeaning : string = this.i + 'PermitSsatusMeaning';
    PermitStatusOrder : string = this.i + 'PermitStatusOrder';
    IsActive : string = this.i + 'IsActive';
    PermitStatusShortName : string = this.i + 'PermitStatusShortName';

    Relations = {
    };
}

export class Permits2PermitStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_PermitStatus.';

    constructor() {
        this.ItemDetail.ItemId=2783;
        this.ItemDetail.ItemName='permits2_PermitStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitStatusId : string = this.i + 'PermitStatusId';
    PermitStatusDisplay : string = this.i + 'PermitStatusDisplay';
    PermitStatusMeaning : string = this.i + 'PermitStatusMeaning';
    PermitStatusOrder : string = this.i + 'PermitStatusOrder';
    IsActive : string = this.i + 'IsActive';
    PermitStatusShortName : string = this.i + 'PermitStatusShortName';

    Relations = {
            /** Relation: Change Request - Initial - Many */
            ChangeRequestByInitialPermitStatusId : {
                RelationName: 'permits2_PermitStatus|ChangeRequest|InitialPermitStatusId',
                FieldPrefix: 'InitialChangeRequest',
                PropertyName: 'InitialChangeRequest'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_PermitStatus|permits2_Permit|PermitStatusId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Stage Audit Log */
            StageAuditLog : {
                RelationName: 'permits2_PermitStatus|StageAuditLog|PermitStatusId',
                FieldPrefix: 'StageAuditLog',
                PropertyName: 'StageAuditLog'
            },
    };
}

export class PlateHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PlateHistory.';

    constructor() {
        this.ItemDetail.ItemId=3435;
        this.ItemDetail.ItemName='PlateHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PlateHistoryId : string = this.i + 'PlateHistoryId';
    VehicleId : string = this.i + 'VehicleId';
    LicensePlate : string = this.i + 'LicensePlate';
    PlateExpirationDate : string = this.i + 'PlateExpirationDate';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|PlateHistory|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'fleet_Vehicle|PlateHistory|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
    };
}

export class PolicyTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PolicyType.';

    constructor() {
        this.ItemDetail.ItemId=2664;
        this.ItemDetail.ItemName='PolicyType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PolicyTypeId : string = this.i + 'PolicyTypeId';
    PolicyType : string = this.i + 'PolicyType';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'PolicyType|ProofOfInsurance|PolicyTypeId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

export class ProjectMilestoneMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProjectMilestone.';

    constructor() {
        this.ItemDetail.ItemId=3416;
        this.ItemDetail.ItemName='ProjectMilestone';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProjectMilestoneId : string = this.i + 'ProjectMilestoneId';
    KickoffId : string = this.i + 'KickoffId';
    Name : string = this.i + 'Name';
    Description : string = this.i + 'Description';
    StartDate : string = this.i + 'StartDate';
    EndDate : string = this.i + 'EndDate';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|ProjectMilestone|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|ProjectMilestone|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ProjectMilestone|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class ProofOfInsuranceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsurance.';

    constructor() {
        this.ItemDetail.ItemId=2663;
        this.ItemDetail.ItemName='ProofOfInsurance';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceId : string = this.i + 'ProofOfInsuranceId';
    PolicyNumber : string = this.i + 'PolicyNumber';
    PolicyTypeId : string = this.i + 'PolicyTypeId';
    IssuedTo : string = this.i + 'IssuedTo';
    InsuranceCompany : string = this.i + 'InsuranceCompany';
    IssueDate : string = this.i + 'IssueDate';
    ExpirationDate : string = this.i + 'ExpirationDate';
    LicenseVerified : string = this.i + 'LicenseVerified';
    POIStatusId : string = this.i + 'POIStatusId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    Notes : string = this.i + 'Notes';
    CountryId : string = this.i + 'CountryId';
    StateProvinceId : string = this.i + 'StateProvinceId';
    VehicleTypeId : string = this.i + 'VehicleTypeId';
    ProofOfInsuranceSummaryId : string = this.i + 'ProofOfInsuranceSummaryId';
    SignedCorpFleetPolicy : string = this.i + 'SignedCorpFleetPolicy';
    IsCurrent : string = this.i + 'IsCurrent';
    LicenseStateProvinceId : string = this.i + 'LicenseStateProvinceId';
    LicenseIssueDate : string = this.i + 'LicenseIssueDate';
    LicenseExpirationDate : string = this.i + 'LicenseExpirationDate';
    LicenseRestrictions : string = this.i + 'LicenseRestrictions';

    Relations = {
            /** Relation: Attachment File */
            AttachmentFile : {
                RelationName: 'AttachmentFile|ProofOfInsurance|AttachmentFileId',
                FieldPrefix: 'AttachmentFile',
                PropertyName: 'AttachmentFile'
            },
            /** Relation: Ethos Country */
            EthosCountry : {
                RelationName: 'Ethos_Country|ProofOfInsurance|CountryId',
                FieldPrefix: 'EthosCountry',
                PropertyName: 'EthosCountry'
            },
            /** Relation: Proof Of Insurance Status */
            ProofOfInsuranceStatus : {
                RelationName: 'ProofOfInsuranceStatus|ProofOfInsurance|POIStatusId',
                FieldPrefix: 'ProofOfInsuranceStatus',
                PropertyName: 'ProofOfInsuranceStatus'
            },
            /** Relation: Policy Type */
            PolicyType : {
                RelationName: 'PolicyType|ProofOfInsurance|PolicyTypeId',
                FieldPrefix: 'PolicyType',
                PropertyName: 'PolicyType'
            },
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummary : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsurance|ProofOfInsuranceSummaryId',
                FieldPrefix: 'ProofOfInsuranceSummary',
                PropertyName: 'ProofOfInsuranceSummary'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|ProofOfInsurance|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: State Province - License State Province */
            EthosStateProvinceByLicenseStateProvinceId : {
                RelationName: 'Ethos_StateProvince|ProofOfInsurance|LicenseStateProvinceId',
                FieldPrefix: 'LicenseEthosStateProvince',
                PropertyName: 'LicenseEthosStateProvince'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ProofOfInsurance|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|ProofOfInsurance|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Vehicle Type */
            VehicleType : {
                RelationName: 'VehicleType|ProofOfInsurance|VehicleTypeId',
                FieldPrefix: 'VehicleType',
                PropertyName: 'VehicleType'
            },
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummaryByProofOfInsuranceSummaryId : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsuranceSummary|ProofOfInsuranceSummaryId',
                FieldPrefix: 'ProofOfInsuranceSummaryProofOfInsuranceSummaryId',
                PropertyName: 'ProofOfInsuranceSummaryProofOfInsuranceSummaryId'
            },
    };
}

export class ProofOfInsuranceJobTitlesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceJobTitles.';

    constructor() {
        this.ItemDetail.ItemId=2696;
        this.ItemDetail.ItemName='ProofOfInsuranceJobTitles';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceJobTitlesId : string = this.i + 'ProofOfInsuranceJobTitlesId';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';

    Relations = {
            /** Relation: Wachter Job Title */
            EthosWachterJobTitle : {
                RelationName: 'Ethos_WachterJobTitle|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'EthosWachterJobTitle',
                PropertyName: 'EthosWachterJobTitle'
            },
            /** Relation: Ethos User */
            EthosUserByWachterJobTitleId : {
                RelationName: 'Ethos_User|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'EthosUserWachterJobTitleId',
                PropertyName: 'EthosUserWachterJobTitleId'
            },
    };
}

export class ProofOfInsuranceStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceStatus.';

    constructor() {
        this.ItemDetail.ItemId=2665;
        this.ItemDetail.ItemName='ProofOfInsuranceStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    POIStatusId : string = this.i + 'POIStatusId';
    POIStatus : string = this.i + 'POIStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'ProofOfInsuranceStatus|ProofOfInsurance|POIStatusId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

export class ProofOfInsuranceSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceSummary.';

    constructor() {
        this.ItemDetail.ItemId=2677;
        this.ItemDetail.ItemName='ProofOfInsuranceSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceSummaryId : string = this.i + 'ProofOfInsuranceSummaryId';
    IsApprovedDriver : string = this.i + 'IsApprovedDriver';
    CanUsePersonalVehicle : string = this.i + 'CanUsePersonalVehicle';
    HasPoiOnPersonalVehicle : string = this.i + 'HasPoiOnPersonalVehicle';
    NeedsTrustUpdate : string = this.i + 'NeedsTrustUpdate';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    ProofOfInsuranceSummaryStatusId : string = this.i + 'ProofOfInsuranceSummaryStatusId';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsuranceByProofOfInsuranceSummaryId : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsuranceSummary|ProofOfInsuranceSummaryId',
                FieldPrefix: 'ProofOfInsuranceProofOfInsuranceSummaryId',
                PropertyName: 'ProofOfInsuranceProofOfInsuranceSummaryId'
            },
            /** Relation: Proof Of Insurance Summary Status */
            ProofOfInsuranceSummaryStatus : {
                RelationName: 'ProofOfInsuranceSummaryStatus|ProofOfInsuranceSummary|ProofOfInsuranceSummaryStatusId',
                FieldPrefix: 'ProofOfInsuranceSummaryStatus',
                PropertyName: 'ProofOfInsuranceSummaryStatus'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|EthosUser|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsurance|ProofOfInsuranceSummaryId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
            /** Relation: User Extended */
            EmsUserExtendedByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|UserExtended|EmployeeId',
                FieldPrefix: 'EmsUserExtendedEmployeeEthosUserId',
                PropertyName: 'EmsUserExtendedEmployeeEthosUserId'
            },
    };
}

export class ProofOfInsuranceSummaryStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceSummaryStatus.';

    constructor() {
        this.ItemDetail.ItemId=2691;
        this.ItemDetail.ItemName='ProofOfInsuranceSummaryStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceSummaryStatusId : string = this.i + 'ProofOfInsuranceSummaryStatusId';
    ProofOfInsuranceSummaryStatusDisplay : string = this.i + 'ProofOfInsuranceSummaryStatusDisplay';

    Relations = {
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummary : {
                RelationName: 'ProofOfInsuranceSummaryStatus|ProofOfInsuranceSummary|ProofOfInsuranceSummaryStatusId',
                FieldPrefix: 'ProofOfInsuranceSummary',
                PropertyName: 'ProofOfInsuranceSummary'
            },
    };
}

export class RatingMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Rating.';

    constructor() {
        this.ItemDetail.ItemId=2733;
        this.ItemDetail.ItemName='Rating';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RatingId : string = this.i + 'RatingId';
    RatingTypeId : string = this.i + 'RatingTypeId';
    QuestionId : string = this.i + 'QuestionId';
    ResponseInt : string = this.i + 'ResponseInt';
    ResponseText : string = this.i + 'ResponseText';
    ResponderName : string = this.i + 'ResponderName';
    ResponderCompanyId : string = this.i + 'ResponderCompanyId';
    WachterJobId : string = this.i + 'WachterJobId';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Ethos Job - Wachter Job */
            EthosJobByWachterJobId : {
                RelationName: 'Ethos_Job|Rating|WachterJobId',
                FieldPrefix: 'WachterEthosJob',
                PropertyName: 'WachterEthosJob'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Rating|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class RatingQuestionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RatingQuestion.';

    constructor() {
        this.ItemDetail.ItemId=2735;
        this.ItemDetail.ItemName='RatingQuestion';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RatingQuestionId : string = this.i + 'RatingQuestionId';
    RatingTypeId : string = this.i + 'RatingTypeId';
    Question : string = this.i + 'Question';
    QuestionOrder : string = this.i + 'QuestionOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class RatingTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RatingType.';

    constructor() {
        this.ItemDetail.ItemId=2734;
        this.ItemDetail.ItemName='RatingType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RatingTypeId : string = this.i + 'RatingTypeId';
    Display : string = this.i + 'Display';
    Description : string = this.i + 'Description';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class ReportingMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Reporting.';

    constructor() {
        this.ItemDetail.ItemId=3419;
        this.ItemDetail.ItemName='Reporting';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ReportingId : string = this.i + 'ReportingId';
    KickoffId : string = this.i + 'KickoffId';
    Name : string = this.i + 'Name';
    Owner : string = this.i + 'Owner';
    Recipient : string = this.i + 'Recipient';
    Contents : string = this.i + 'Contents';
    Frequency : string = this.i + 'Frequency';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|Reporting|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Reporting|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Reporting|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class RequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Request.';

    constructor() {
        this.ItemDetail.ItemId=2353;
        this.ItemDetail.ItemName='Request';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestId : string = this.i + 'RequestId';
    CompanyId : string = this.i + 'CompanyId';
    DeliveryOptionCv : string = this.i + 'DeliveryOptionCv';
    CompanyEmail : string = this.i + 'CompanyEmail';
    EmailCopyString : string = this.i + 'EmailCopyString';
    AcountNumber : string = this.i + 'AcountNumber';
    NeededByDateTime : string = this.i + 'NeededByDateTime';
    DeliveredByDateTime : string = this.i + 'DeliveredByDateTime';
    PickupByDateTime : string = this.i + 'PickupByDateTime';
    IsAutoPickup : string = this.i + 'IsAutoPickup';
    AreSubstitutionsAllowed : string = this.i + 'AreSubstitutionsAllowed';
    HasProtectionPlan : string = this.i + 'HasProtectionPlan';
    Notes : string = this.i + 'Notes';
    JobNumber : string = this.i + 'JobNumber';
    JobSiteAddress : string = this.i + 'JobSiteAddress';
    SiteContactName : string = this.i + 'SiteContactName';
    SiteContactPhoneNumber : string = this.i + 'SiteContactPhoneNumber';
    DropOffArea : string = this.i + 'DropOffArea';
    RequesterNameAndNumber : string = this.i + 'RequesterNameAndNumber';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';
    AutoPickupText : string = this.i + 'AutoPickupText';
    JobName : string = this.i + 'JobName';
    LookUpTarget : string = this.i + 'LookUpTarget';

    Relations = {
            /** Relation: Trust Code Value - Delivery Option */
            CodeValueByDeliveryOptionCv : {
                RelationName: 'CodeValue|Request|DeliveryOptionCv',
                FieldPrefix: 'DeliveryOptionCvCodeValue',
                PropertyName: 'DeliveryOptionCvCodeValue'
            },
            /** Relation: Company */
            Company : {
                RelationName: 'Company|Request|CompanyId',
                FieldPrefix: 'Company',
                PropertyName: 'Company'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Request|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Request|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Request Equipment */
            RequestEquipment : {
                RelationName: 'Request|RequestEquipment|RequestId',
                FieldPrefix: 'RequestEquipment',
                PropertyName: 'RequestEquipment'
            },
            /** Relation: Ro Ethos User - Created By - Many */
            RoEthosUserByUserId : {
                RelationName: 'equipmentRequest|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
    };
}

export class TravelRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'travel_Request.';

    constructor() {
        this.ItemDetail.ItemId=2554;
        this.ItemDetail.ItemName='travel_Request';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestId : string = this.i + 'RequestId';
    JobNumberWjid : string = this.i + 'JobNumberWjid';
    DepartureLocation : string = this.i + 'DepartureLocation';
    DestinationLocation : string = this.i + 'DestinationLocation';
    DestinationArrivalDate : string = this.i + 'DestinationArrivalDate';
    ReturningDate : string = this.i + 'ReturningDate';
    TravelModeCv : string = this.i + 'TravelModeCv';
    TraveModeComment : string = this.i + 'TraveModeComment';
    FlightPreference : string = this.i + 'FlightPreference';
    AirportPlanCv : string = this.i + 'AirportPlanCv';
    AirportPlanComment : string = this.i + 'AirportPlanComment';
    TransportationPlanCv : string = this.i + 'TransportationPlanCv';
    TransportationPlanComment : string = this.i + 'TransportationPlanComment';
    LodgingPlanCv : string = this.i + 'LodgingPlanCv';
    LodgingPlanComment : string = this.i + 'LodgingPlanComment';
    TravelRequestComments : string = this.i + 'TravelRequestComments';
    TravelTypeCv : string = this.i + 'TravelTypeCv';
    TravelTypeComment : string = this.i + 'TravelTypeComment';
    ProjectManagerEthosUserId : string = this.i + 'ProjectManagerEthos_UserId';
    Customer : string = this.i + 'Customer';
    CustomerPm : string = this.i + 'CustomerPm';
    TravelReason : string = this.i + 'TravelReason';
    PotentialRevenue : string = this.i + 'PotentialRevenue';
    NumberOfSites : string = this.i + 'NumberOfSites';
    ProjectDuration : string = this.i + 'ProjectDuration';
    MeetingNotes : string = this.i + 'MeetingNotes';
    TravelerEthosUserId : string = this.i + 'TravelerEthos_UserId';
    Preferences : string = this.i + 'Preferences';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ParkingPassNeeded : string = this.i + 'ParkingPassNeeded';
    ParkingPassReturned : string = this.i + 'ParkingPassReturned';

    Relations = {
            /** Relation: Trust Code Value - Transportation Plan */
            CodeValueByTransportationPlanCv : {
                RelationName: 'CodeValue|travel_Request|TransportationPlanCv',
                FieldPrefix: 'TransportationPlanCvCodeValue',
                PropertyName: 'TransportationPlanCvCodeValue'
            },
            /** Relation: Trust Code Value - Travel Mode */
            CodeValueByTravelModeCv : {
                RelationName: 'CodeValue|travel_Request|TravelModeCv',
                FieldPrefix: 'TravelModeCvCodeValue',
                PropertyName: 'TravelModeCvCodeValue'
            },
            /** Relation: Trust Code Value - Airport Plan */
            CodeValueByAirportPlanCv : {
                RelationName: 'CodeValue|travel_Request|AirportPlanCv',
                FieldPrefix: 'AirportPlanCvCodeValue',
                PropertyName: 'AirportPlanCvCodeValue'
            },
            /** Relation: Trust Code Value - Lodging Plan */
            CodeValueByLodgingPlanCv : {
                RelationName: 'CodeValue|travel_Request|LodgingPlanCv',
                FieldPrefix: 'LodgingPlanCvCodeValue',
                PropertyName: 'LodgingPlanCvCodeValue'
            },
            /** Relation: Trust Code Value - Travel Type */
            CodeValueByTravelTypeCv : {
                RelationName: 'CodeValue|travel_Request|TravelTypeCv',
                FieldPrefix: 'TravelTypeCvCodeValue',
                PropertyName: 'TravelTypeCvCodeValue'
            },
            /** Relation: Ethos User - Project Manager Ethos User */
            EthosUserByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|travel_Request|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosEthosUser',
                PropertyName: 'ProjectManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Traveler Ethos User */
            EthosUserByTravelerEthosUserId : {
                RelationName: 'Ethos_User|travel_Request|TravelerEthos_UserId',
                FieldPrefix: 'TravelerEthosEthosUser',
                PropertyName: 'TravelerEthosEthosUser'
            },
            /** Relation: Ro Ethos User - Project Manager Ethos User */
            RoEthosUserByProjectManagerEthosUserId : {
                RelationName: 'roEthos_User|travel_Request|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosRoEthosUser',
                PropertyName: 'ProjectManagerEthosRoEthosUser'
            },
            /** Relation: Request Preferences */
            RequestPreferences : {
                RelationName: 'travel_Request|RequestPreferences|RequestId',
                FieldPrefix: 'RequestPreferences',
                PropertyName: 'RequestPreferences'
            },
            /** Relation: Ro Ethos User - Created By Ethos User - Many */
            RoEthosUserByUserId : {
                RelationName: 'Request|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
            /** Relation: Ro Request */
            RoRequest : {
                RelationName: 'Travel_Request|Travel_roRequest|RequestId',
                FieldPrefix: 'RoRequest',
                PropertyName: 'RoRequest'
            },
            /** Relation: Traveler */
            Traveler : {
                RelationName: 'travel_Request|Traveler|RequestId',
                FieldPrefix: 'Traveler',
                PropertyName: 'Traveler'
            },
    };
}

export class RequestEquipmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RequestEquipment.';

    constructor() {
        this.ItemDetail.ItemId=2358;
        this.ItemDetail.ItemName='RequestEquipment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestEquipmentId : string = this.i + 'RequestEquipmentId';
    RequestId : string = this.i + 'RequestId';
    EquipmentId : string = this.i + 'EquipmentId';
    Quantity : string = this.i + 'Quantity';
    Comments : string = this.i + 'Comments';
    EquipmentText : string = this.i + 'EquipmentText';

    Relations = {
            /** Relation: Equipment */
            Equipment : {
                RelationName: 'Equipment|RequestEquipment|EquipmentId',
                FieldPrefix: 'Equipment',
                PropertyName: 'Equipment'
            },
            /** Relation: Request */
            Request : {
                RelationName: 'Request|RequestEquipment|RequestId',
                FieldPrefix: 'Request',
                PropertyName: 'Request'
            },
    };
}

export class RequestPreferencesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RequestPreferences.';

    constructor() {
        this.ItemDetail.ItemId=2556;
        this.ItemDetail.ItemName='RequestPreferences';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestPreferencesId : string = this.i + 'RequestPreferencesId';
    RequestId : string = this.i + 'RequestId';
    PreferenceCv : string = this.i + 'PreferenceCv';
    PreferenceComment : string = this.i + 'PreferenceComment';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Request */
            TravelRequest : {
                RelationName: 'travel_Request|RequestPreferences|RequestId',
                FieldPrefix: 'TravelRequest',
                PropertyName: 'TravelRequest'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequestPreferences|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequestPreferences|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class RequiredCableMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RequiredCable.';

    constructor() {
        this.ItemDetail.ItemId=2750;
        this.ItemDetail.ItemName='RequiredCable';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequiredCableId : string = this.i + 'RequiredCableId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|RequiredCable|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|RequiredCable|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class Permits2RequiredCableMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_RequiredCable.';

    constructor() {
        this.ItemDetail.ItemId=2781;
        this.ItemDetail.ItemName='permits2_RequiredCable';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequiredCableId : string = this.i + 'RequiredCableId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permits2_RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByCableTypeCv : {
                RelationName: 'CodeValue|permits2_RequiredCable|CableTypeCv',
                FieldPrefix: 'CableTypeCvCodeValue',
                PropertyName: 'CableTypeCvCodeValue'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|permits2_RequiredCable|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permits2_RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class ResourceCostMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'resourceCost.';

    constructor() {
        this.ItemDetail.ItemId=2548;
        this.ItemDetail.ItemName='resourceCost';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ResourceCostId : string = this.i + 'resourceCostId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    CurrentUserTeamId : string = this.i + 'CurrentUserTeamId';
    CurrentUserEthosId : string = this.i + 'CurrentUserEthosId';

    Relations = {
            /** Relation: Ro Ethos User Burdon */
            RoEthosUserBurdon : {
                RelationName: 'roEthos_UserBurden|resourceCost|UserId',
                FieldPrefix: 'RoEthosUserBurdon',
                PropertyName: 'RoEthosUserBurdon'
            },
            /** Relation: D W People Pay Summary - Ethos User */
            DWPeoplePaySummaryByEthosUserId : {
                RelationName: 'DW_PeoplePaySummary|resourceCost|UserId',
                FieldPrefix: 'EthosUserIdDWPeoplePaySummary',
                PropertyName: 'EthosUserIdDWPeoplePaySummary'
            },
            /** Relation: Ethos User - Current User Ethos */
            EthosUserByCurrentUserEthosId : {
                RelationName: 'Ethos_User|resourceCost|CurrentUserEthosId',
                FieldPrefix: 'CurrentUserEthosIdEthosUser',
                PropertyName: 'CurrentUserEthosIdEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|resourceCost|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Team - Current User Team */
            EthosWachterTeamByCurrentUserTeamId : {
                RelationName: 'Ethos_WachterTeam|resourceCost|CurrentUserTeamId',
                FieldPrefix: 'CurrentUserTeamIdEthosWachterTeam',
                PropertyName: 'CurrentUserTeamIdEthosWachterTeam'
            },
    };
}

export class ReviewMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Review.';

    constructor() {
        this.ItemDetail.ItemId=2440;
        this.ItemDetail.ItemName='Review';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ReviewId : string = this.i + 'ReviewId';
    ReviewDate : string = this.i + 'ReviewDate';
    FollowUpDate : string = this.i + 'FollowUpDate';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Review|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Review|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
    };
}

export class RoEthosUserBurdonMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ro_EthosUserBurdon.';

    constructor() {
        this.ItemDetail.ItemId=2517;
        this.ItemDetail.ItemName='ro_EthosUserBurdon';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    RegularPay : string = this.i + 'RegularPay';
    OTPay : string = this.i + 'OTPay';
    DTPay : string = this.i + 'DTPay';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'roEthos_UserBurden|Ethos_User|UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Resource Cost */
            ResourceCost : {
                RelationName: 'roEthos_UserBurden|resourceCost|UserId',
                FieldPrefix: 'ResourceCost',
                PropertyName: 'ResourceCost'
            },
    };
}

export class RoAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAccident.';

    constructor() {
        this.ItemDetail.ItemId=2441;
        this.ItemDetail.ItemName='roAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccidentId : string = this.i + 'AccidentId';
    TypeCv : string = this.i + 'TypeCv';
    AccidentType : string = this.i + 'AccidentType';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    EmployeeName : string = this.i + 'EmployeeName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDepartment : string = this.i + 'WachterDepartment';
    IsAtFault : string = this.i + 'IsAtFault';
    IsWachterInjury : string = this.i + 'IsWachterInjury';
    IsOtherInjury : string = this.i + 'IsOtherInjury';
    IsHospitalVisit : string = this.i + 'IsHospitalVisit';
    IsDoctorVisit : string = this.i + 'IsDoctorVisit';
    IsFirstAidOnly : string = this.i + 'IsFirstAidOnly';
    Treatment : string = this.i + 'Treatment';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDetail : string = this.i + 'InjuryDetail';
    DamageDetail : string = this.i + 'DamageDetail';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByDateTimeCentral : string = this.i + 'ModifiedByDateTimeCentral';
    ModifiedWeekEndingDate : string = this.i + 'ModifiedWeekEndingDate';
    ReportDate : string = this.i + 'ReportDate';
    HasPriorAccidents : string = this.i + 'HasPriorAccidents';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    Address : string = this.i + 'Address';
    CityState : string = this.i + 'CityState';
    WJID : string = this.i + 'WJID';
    OtherPartiesInjured : string = this.i + 'OtherPartiesInjured';
    MedicalNeeded : string = this.i + 'MedicalNeeded';
    AccidentCalledIntoHotline : string = this.i + 'AccidentCalledIntoHotline';
    Customer : string = this.i + 'Customer';
    JobNumber : string = this.i + 'JobNumber';
    Site : string = this.i + 'Site';
    JobsWorkedNote : string = this.i + 'JobsWorkedNote';
    ActionLeadingToAccident : string = this.i + 'ActionLeadingToAccident';
    HoursWorkedDescription : string = this.i + 'HoursWorkedDescription';
    RestOnAccidentDate : string = this.i + 'RestOnAccidentDate';
    WorkRestDayBefore : string = this.i + 'WorkRestDayBefore';
    WorkRestTwoDaysBefore : string = this.i + 'WorkRestTwoDaysBefore';
    PriorAccidentList : string = this.i + 'PriorAccidentList';
    RepairEstimate : string = this.i + 'RepairEstimate';
    CreatedByDateTimeCentral : string = this.i + 'CreatedByDateTimeCentral';

    Relations = {
    };
}

export class RoActiveChangeRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roActiveChangeRequest.';

    constructor() {
        this.ItemDetail.ItemId=3445;
        this.ItemDetail.ItemName='roActiveChangeRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    ChangeRequestId : string = this.i + 'ChangeRequestId';
    CompletedByUserId : string = this.i + 'CompletedByUserId';
    HasActiveRequest : string = this.i + 'HasActiveRequest';

    Relations = {
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'roActiveChangeRequest|permits2_Permit:PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class RoActiveSubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roActiveSubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2765;
        this.ItemDetail.ItemName='roActiveSubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Depth : string = this.i + 'depth';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Status : string = this.i + 'Status';
    Terminated : string = this.i + 'Terminated';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';

    Relations = {
    };
}

export class RoAllSupervisorsSubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAllSupervisorsSubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2566;
        this.ItemDetail.ItemName='roAllSupervisorsSubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Depth : string = this.i + 'Depth';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roAllSupervisorsSubordinates|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roAllSupervisorsSubordinates|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: PAF Pay/Job Change - User - Many */
            PayJobChangeByEmployeeEthosUserId : {
                RelationName: 'PayJobChange|roAllSupervisorSubordinates|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosPayJobChange',
                PropertyName: 'EmployeeEthosPayJobChange'
            },
            /** Relation: PAF Pay/Job Change - User - Many */
            PayJobChangeByCreatedbyEthosUserId : {
                RelationName: 'PayJobChange|roAllSupervisorSubordinates|CreatedBy',
                FieldPrefix: 'CreatedbyEthosPayJobChange',
                PropertyName: 'CreatedbyEthosPayJobChange'
            },
            /** Relation: Ro Ethos User Grid - User - Many */
            RoEthosUserGridByEmployeeUserId : {
                RelationName: 'roAllSupervisorsSubordinates|roEthos_UserGrid|UserId',
                FieldPrefix: 'EmployeeRoEthosUserGrid',
                PropertyName: 'EmployeeRoEthosUserGrid'
            },
            /** Relation: User Extended - User - Many */
            EmsUserExtendedByEmployeeEthosUserId : {
                RelationName: 'RoAllSupervisorsSubordinates|ems_UserExtended|Ethos_UserId',
                FieldPrefix: 'EmployeeEthosEmsUserExtended',
                PropertyName: 'EmployeeEthosEmsUserExtended'
            },
    };
}

export class RoAllSupervisorsSubordinatesOptimizedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAllSupervisorsSubordinatesOptimized.';

    constructor() {
        this.ItemDetail.ItemId=2791;
        this.ItemDetail.ItemName='roAllSupervisorsSubordinatesOptimized';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Depth : string = this.i + 'Depth';

    Relations = {
    };
}

export class RoAllSupervisorsSubordinatesOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAllSupervisorsSubordinatesOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2662;
        this.ItemDetail.ItemName='roAllSupervisorsSubordinatesOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Depth : string = this.i + 'Depth';

    Relations = {
    };
}

export class RoAttachmentFileNamesCombinedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAttachmentFileNamesCombined.';

    constructor() {
        this.ItemDetail.ItemId=2557;
        this.ItemDetail.ItemName='roAttachmentFileNamesCombined';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    LicenseId : string = this.i + 'LicenseId';
    AttachmentName : string = this.i + 'AttachmentName';

    Relations = {
            /** Relation: Licenses */
            Licenses : {
                RelationName: 'Licenses|roAttachmentFileNamesCombined|LicenseId',
                FieldPrefix: 'Licenses',
                PropertyName: 'Licenses'
            },
    };
}

export class RoAuctionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAuction.';

    constructor() {
        this.ItemDetail.ItemId=3439;
        this.ItemDetail.ItemName='roAuction';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AuctionId : string = this.i + 'AuctionId';
    CurrentBid : string = this.i + 'CurrentBid';
    FinalBid : string = this.i + 'FinalBid';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    StatusCv : string = this.i + 'StatusCv';
    AppUserId : string = this.i + 'AppUserId';

    Relations = {
            /** Relation: Auction */
            Auction : {
                RelationName: 'roAuction|Auction|AuctionId',
                FieldPrefix: 'Auction',
                PropertyName: 'Auction'
            },
    };
}

export class RoAuditIssueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAuditIssue.';

    constructor() {
        this.ItemDetail.ItemId=2814;
        this.ItemDetail.ItemName='roAuditIssue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueId : string = this.i + 'IssueId';
    AuditName : string = this.i + 'AuditName';
    AuditStartDate : string = this.i + 'AuditStartDate';
    AuditCompleteDate : string = this.i + 'AuditCompleteDate';
    Auditor : string = this.i + 'Auditor';
    Process : string = this.i + 'Process';
    IssueName : string = this.i + 'IssueName';
    IssueDetail : string = this.i + 'IssueDetail';
    RecommendationDetail : string = this.i + 'RecommendationDetail';
    IssueRating : string = this.i + 'IssueRating';
    IssueRatingNote : string = this.i + 'IssueRatingNote';
    IssueRiskType : string = this.i + 'IssueRiskType';
    IssueOwner : string = this.i + 'IssueOwner';
    ELT : string = this.i + 'ELT';
    DelegatedOwner : string = this.i + 'DelegatedOwner';
    OwnerActionPlan : string = this.i + 'OwnerActionPlan';
    ActionPlanDueDate : string = this.i + 'ActionPlanDueDate';
    IssueStatus : string = this.i + 'IssueStatus';
    RequestUpdate : string = this.i + 'RequestUpdate';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoAuditSupervisorAccessMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAuditSupervisorAccess.';

    constructor() {
        this.ItemDetail.ItemId=2813;
        this.ItemDetail.ItemName='roAuditSupervisorAccess';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueId : string = this.i + 'IssueId';
    Owner : string = this.i + 'Owner';
    Auditor : string = this.i + 'Auditor';
    Delegate : string = this.i + 'Delegate';
    CreatedBy : string = this.i + 'CreatedBy';
    ELT : string = this.i + 'ELT';
    ViewableBy : string = this.i + 'ViewableBy';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    ReportingLevels : string = this.i + 'ReportingLevels';

    Relations = {
            /** Relation: Audit Issue */
            AuditIssue : {
                RelationName: 'roAuditSupervisorAccess|AuditIssue|IssueId',
                FieldPrefix: 'AuditIssue',
                PropertyName: 'AuditIssue'
            },
    };
}

export class RoAvStarRatingNspTechMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAvStarRatingNspTech.';

    constructor() {
        this.ItemDetail.ItemId=3450;
        this.ItemDetail.ItemName='roAvStarRatingNspTech';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    TechUserId : string = this.i + 'TechUserId';

    Relations = {
    };
}

export class RoCollaborationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roCollaboration.';

    constructor() {
        this.ItemDetail.ItemId=2442;
        this.ItemDetail.ItemName='roCollaboration';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CollaborationId : string = this.i + 'CollaborationId';
    FromDepartmentId : string = this.i + 'FromDepartmentId';
    FromDepartment : string = this.i + 'FromDepartment';
    FromPmUserId : string = this.i + 'FromPmUserId';
    FromPm : string = this.i + 'FromPm';
    ToDepartmentId : string = this.i + 'ToDepartmentId';
    ToDepartment : string = this.i + 'ToDepartment';
    ToPmUserId : string = this.i + 'ToPmUserId';
    ToPm : string = this.i + 'ToPm';
    CustomerName : string = this.i + 'CustomerName';
    CustomerPm : string = this.i + 'CustomerPm';
    CustomerTitle : string = this.i + 'CustomerTitle';
    ProjectName : string = this.i + 'ProjectName';
    SiteCount : string = this.i + 'SiteCount';
    RevenuePerSite : string = this.i + 'RevenuePerSite';
    CollaborationDate : string = this.i + 'CollaborationDate';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByDateTimeCentral : string = this.i + 'ModifiedByDateTimeCentral';
    ModifiedWeekEndingDate : string = this.i + 'ModifiedWeekEndingDate';
    TotalRevenue : string = this.i + 'TotalRevenue';
    ReportDate : string = this.i + 'ReportDate';
    CreatedByDateTimeCentral : string = this.i + 'CreatedByDateTimeCentral';

    Relations = {
    };
}

export class RoCustomerSatisfactionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roCustomerSatisfaction.';

    constructor() {
        this.ItemDetail.ItemId=2443;
        this.ItemDetail.ItemName='roCustomerSatisfaction';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CustomerSatisfactionId : string = this.i + 'CustomerSatisfactionId';
    Customer : string = this.i + 'Customer';
    PmUserId : string = this.i + 'PmUserId';
    ProjectManager : string = this.i + 'ProjectManager';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDepartment : string = this.i + 'WachterDepartment';
    City : string = this.i + 'City';
    State : string = this.i + 'State';
    SiteLocation : string = this.i + 'SiteLocation';
    Description : string = this.i + 'Description';
    CostOrGain : string = this.i + 'CostOrGain';
    CustomerSatisfactionDate : string = this.i + 'CustomerSatisfactionDate';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByDateTimeCentral : string = this.i + 'ModifiedByDateTimeCentral';
    ModifiedWeekEndingDate : string = this.i + 'ModifiedWeekEndingDate';
    ReportDate : string = this.i + 'ReportDate';
    CreatedByDateTimeCentral : string = this.i + 'CreatedByDateTimeCentral';

    Relations = {
    };
}

export class RoEmployeeDetailMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEmployeeDetail.';

    constructor() {
        this.ItemDetail.ItemId=2551;
        this.ItemDetail.ItemName='roEmployeeDetail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    BirthdayAnniversaryDate : string = this.i + 'BirthdayAnniversaryDate';
    EmpHireDate : string = this.i + 'empHireDate';
    HiredAnniversaryDate : string = this.i + 'HiredAnniversaryDate';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    StartedAnniversaryDate : string = this.i + 'StartedAnniversaryDate';
    Email : string = this.i + 'Email';
    HasVehicle : string = this.i + 'HasVehicle';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    OfficeName : string = this.i + 'OfficeName';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    SupervisorNameLastFirstPrefered : string = this.i + 'SupervisorNameLastFirstPrefered';
    SupervisorNameFirstPreferedLast : string = this.i + 'SupervisorNameFirstPreferedLast';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    FosEthosUserId : string = this.i + 'FosEthos_UserId';
    FosNameLastFirstPrefered : string = this.i + 'FosNameLastFirstPrefered';
    FosNameFirstPreferedLast : string = this.i + 'FosNameFirstPreferedLast';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    HiringManagerNameLastFirstPrefered : string = this.i + 'HiringManagerNameLastFirstPrefered';
    HiringManagerNameFirstPreferedLast : string = this.i + 'HiringManagerNameFirstPreferedLast';
    CurrentPay : string = this.i + 'CurrentPay';
    LastEvalDate : string = this.i + 'LastEvalDate';
    EmployeeType : string = this.i + 'EmployeeType';
    OrientationDate : string = this.i + 'OrientationDate';
    TeamName : string = this.i + 'TeamName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    TechType : string = this.i + 'TechType';
    TerritoryName : string = this.i + 'TerritoryName';
    OperationsManagerEthosUserId : string = this.i + 'OperationsManagerEthos_UserId';
    OperationsManagerNameLastFirstPrefered : string = this.i + 'OperationsManagerNameLastFirstPrefered';
    OperationsManagerNameFirstPreferedLast : string = this.i + 'OperationsManagerNameFirstPreferedLast';
    FosDistanceInMiles : string = this.i + 'FosDistanceInMiles';
    AXId : string = this.i + 'AXId';

    Relations = {
    };
}

export class RoEmployeeDetailFullMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEmployeeDetailFull.';

    constructor() {
        this.ItemDetail.ItemId=2550;
        this.ItemDetail.ItemName='roEmployeeDetailFull';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    HiredAnniversaryDate : string = this.i + 'HiredAnniversaryDate';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    StartedAnniversaryDate : string = this.i + 'StartedAnniversaryDate';
    OrientationDate : string = this.i + 'OrientationDate';
    BirthdayAnniversaryDate : string = this.i + 'BirthdayAnniversaryDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Email : string = this.i + 'Email';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    UserExtendedId : string = this.i + 'UserExtendedId';
    TechType : string = this.i + 'TechType';
    CurrentPay : string = this.i + 'CurrentPay';
    LastEvalDate : string = this.i + 'LastEvalDate';
    PayChangeDate : string = this.i + 'PayChangeDate';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    SupervisorUserName : string = this.i + 'SupervisorUserName';
    SupervisorFirstName : string = this.i + 'SupervisorFirstName';
    SupervisorLastName : string = this.i + 'SupervisorLastName';
    SupervisorMiddleName : string = this.i + 'SupervisorMiddleName';
    SupervisorPreferredName : string = this.i + 'SupervisorPreferredName';
    SupervisorSuffix : string = this.i + 'SupervisorSuffix';
    SupervisorOfficePhone : string = this.i + 'SupervisorOfficePhone';
    SupervisorMobilePhone : string = this.i + 'SupervisorMobilePhone';
    SupervisorJobTitle : string = this.i + 'SupervisorJobTitle';
    SupervisorEmail : string = this.i + 'SupervisorEmail';
    SupervisorPictureAttachmentFileKey : string = this.i + 'SupervisorPictureAttachmentFileKey';
    SupervisorPictureAttachmentFileExtension : string = this.i + 'SupervisorPictureAttachmentFileExtension';
    Supervisor : string = this.i + 'Supervisor';
    SupervisorNameLastPrefered : string = this.i + 'SupervisorNameLastPrefered';
    SupervisorNameLastFirstPrefered : string = this.i + 'SupervisorNameLastFirstPrefered';
    SupervisorNameFirstLast : string = this.i + 'SupervisorNameFirstLast';
    SupervisorNamePreferedLast : string = this.i + 'SupervisorNamePreferedLast';
    SupervisorNameFirstPreferedLast : string = this.i + 'SupervisorNameFirstPreferedLast';
    SupervisorNameFirstMiddleLast : string = this.i + 'SupervisorNameFirstMiddleLast';
    FosEthosUserId : string = this.i + 'FosEthos_UserId';
    FosOfficePhone : string = this.i + 'FosOfficePhone';
    FosMobilePhone : string = this.i + 'FosMobilePhone';
    FosEmail : string = this.i + 'FosEmail';
    FosPictureAttachmentFileKey : string = this.i + 'FosPictureAttachmentFileKey';
    FosPictureAttachmentFileExtension : string = this.i + 'FosPictureAttachmentFileExtension';
    FosNameLastFirst : string = this.i + 'FosNameLastFirst';
    FosNameLastPrefered : string = this.i + 'FosNameLastPrefered';
    FosNameLastFirstPrefered : string = this.i + 'FosNameLastFirstPrefered';
    FosNameFirstLast : string = this.i + 'FosNameFirstLast';
    FosNamePreferedLast : string = this.i + 'FosNamePreferedLast';
    FosNameFirstPreferedLast : string = this.i + 'FosNameFirstPreferedLast';
    FosNameFirstMiddleLast : string = this.i + 'FosNameFirstMiddleLast';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    HiringManagerOfficePhone : string = this.i + 'HiringManagerOfficePhone';
    HiringManagerMobilePhone : string = this.i + 'HiringManagerMobilePhone';
    HiringManagerEmail : string = this.i + 'HiringManagerEmail';
    HiringManagerPictureAttachmentFileKey : string = this.i + 'HiringManagerPictureAttachmentFileKey';
    HiringManagerPictureAttachmentFileExtension : string = this.i + 'HiringManagerPictureAttachmentFileExtension';
    HiringManagerNameLastFirst : string = this.i + 'HiringManagerNameLastFirst';
    HiringManagerNameLastPrefered : string = this.i + 'HiringManagerNameLastPrefered';
    HiringManagerNameLastFirstPrefered : string = this.i + 'HiringManagerNameLastFirstPrefered';
    HiringManagerNameFirstLast : string = this.i + 'HiringManagerNameFirstLast';
    HiringManagerNamePreferedLast : string = this.i + 'HiringManagerNamePreferedLast';
    HiringManagerNameFirstPreferedLast : string = this.i + 'HiringManagerNameFirstPreferedLast';
    HiringManagerNameFirstMiddleLast : string = this.i + 'HiringManagerNameFirstMiddleLast';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    TerritoryDescription : string = this.i + 'TerritoryDescription';
    OperationsManagerEthosUserId : string = this.i + 'OperationsManagerEthos_UserId';
    OperationsManagerOfficePhone : string = this.i + 'OperationsManagerOfficePhone';
    OperationsManagerMobilePhone : string = this.i + 'OperationsManagerMobilePhone';
    OperationsManagerEmail : string = this.i + 'OperationsManagerEmail';
    OperationsManagerPictureAttachmentFileKey : string = this.i + 'OperationsManagerPictureAttachmentFileKey';
    OperationsManagerPictureAttachmentFileExtension : string = this.i + 'OperationsManagerPictureAttachmentFileExtension';
    OperationsManagerNameLastFirst : string = this.i + 'OperationsManagerNameLastFirst';
    OperationsManagerNameLastPrefered : string = this.i + 'OperationsManagerNameLastPrefered';
    OperationsManagerNameLastFirstPrefered : string = this.i + 'OperationsManagerNameLastFirstPrefered';
    OperationsManagerNameFirstLast : string = this.i + 'OperationsManagerNameFirstLast';
    OperationsManagerNamePreferedLast : string = this.i + 'OperationsManagerNamePreferedLast';
    OperationsManagerNameFirstPreferedLast : string = this.i + 'OperationsManagerNameFirstPreferedLast';
    OperationsManagerNameFirstMiddleLast : string = this.i + 'OperationsManagerNameFirstMiddleLast';
    AXId : string = this.i + 'AXId';

    Relations = {
    };
}

export class RoEmployeeReviewSummaryCurrentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEmployeeReviewSummaryCurrent.';

    constructor() {
        this.ItemDetail.ItemId=2690;
        this.ItemDetail.ItemName='roEmployeeReviewSummaryCurrent';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeReviewSummaryId : string = this.i + 'EmployeeReviewSummaryId';
    EmployeeReviewSummaryStatusId : string = this.i + 'EmployeeReviewSummaryStatusId';
    EmployeeReviewSummaryTypeId : string = this.i + 'EmployeeReviewSummaryTypeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthosUserId';
    SupervisorEthosUserId : string = this.i + 'SupervisorEthosUserId';
    ReviewYear : string = this.i + 'ReviewYear';
    DueDate : string = this.i + 'DueDate';
    ReviewNotes : string = this.i + 'ReviewNotes';
    CompletedByEthosUserId : string = this.i + 'CompletedByEthos_UserId';
    CompletedByDateTime : string = this.i + 'CompletedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ShowGraph : string = this.i + 'ShowGraph';

    Relations = {
            /** Relation: Ethos User - Employee Ethos User */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'roEmployeeReviewSummaryCurrent|EthosUser|EmployeeEthosUserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
    };
}

export class RoEmsPBiMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEmsPBi.';

    constructor() {
        this.ItemDetail.ItemId=2585;
        this.ItemDetail.ItemName='roEmsPBi';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Depth : string = this.i + 'depth';

    Relations = {
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Request - User Id */
            TravelRequestByUserId : {
                RelationName: 'Request|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdTravelRequest',
                PropertyName: 'UserIdTravelRequest'
            },
            /** Relation: Ro Request - User Id */
            RoRequestByUserId : {
                RelationName: 'roRequest|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdRoRequest',
                PropertyName: 'UserIdRoRequest'
            },
            /** Relation: Five Star Rating - User Id */
            FiveStarRatingByUserId : {
                RelationName: 'FiveStarRating|roEthosUser|CreatedByEthos_Userid',
                FieldPrefix: 'UserIdFiveStarRating',
                PropertyName: 'UserIdFiveStarRating'
            },
            /** Relation: Request - User Id */
            RequestByUserId : {
                RelationName: 'equipmentRequest|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdRequest',
                PropertyName: 'UserIdRequest'
            },
            /** Relation: User Extended - User Id */
            EmsUserExtendedByUserId : {
                RelationName: 'EmsUserExtended|roEthos_User|EmployeeEthos_UserId',
                FieldPrefix: 'UserIdEmsUserExtended',
                PropertyName: 'UserIdEmsUserExtended'
            },
            /** Relation: Staffing Agency */
            EthosStaffingAgency : {
                RelationName: 'Ethos_StaffingAgency|roEthos_User|StaffingAgencyId',
                FieldPrefix: 'EthosStaffingAgency',
                PropertyName: 'EthosStaffingAgency'
            },
            /** Relation: State Province */
            EthosStateProvince : {
                RelationName: 'Ethos_StateProvince|roEthos_User|StateProvinceId',
                FieldPrefix: 'EthosStateProvince',
                PropertyName: 'EthosStateProvince'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Territory */
            Territory : {
                RelationName: 'Territory|roEthos_User|TerritoryId',
                FieldPrefix: 'Territory',
                PropertyName: 'Territory'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Wachter Job Title */
            EthosWachterJobTitle : {
                RelationName: 'Ethos_WachterJobTitle|roEthos_User|WachterJobTitleId',
                FieldPrefix: 'EthosWachterJobTitle',
                PropertyName: 'EthosWachterJobTitle'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
            /** Relation: D W People Pay Summary - E T H O S - Many */
            DWPeoplePaySummaryByETHOSUserId : {
                RelationName: 'RoEthosUser -> PeoplePaySummary',
                FieldPrefix: 'ETHOSDWPeoplePaySummary',
                PropertyName: 'ETHOSDWPeoplePaySummary'
            },
            /** Relation: Employee Review Question Request - Submitted By Ethos  - Many */
            EmployeeReviewQuestionRequestBySubmittedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|SubmittedBy',
                FieldPrefix: 'SubmittedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'SubmittedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Review Question Request - Rejected By Ethos  - Many */
            EmployeeReviewQuestionRequestByRejectedByEthosUserId : {
                RelationName: 'EmployeeReviewQuestionRequest|roEthosUser|RejectedBy',
                FieldPrefix: 'RejectedByEthosEmployeeReviewQuestionRequest',
                PropertyName: 'RejectedByEthosEmployeeReviewQuestionRequest'
            },
            /** Relation: Employee Training Needed - Employee Ethos  - Many */
            EmployeeTrainingNeededByEmployeeEthosUserId : {
                RelationName: 'EmployeeTrainingNeeded|roEthos_User|UserId',
                FieldPrefix: 'EmployeeEthosEmployeeTrainingNeeded',
                PropertyName: 'EmployeeEthosEmployeeTrainingNeeded'
            },
            /** Relation: Employee Training Needed - Created By Ethos  - Many */
            EmployeeTrainingNeededByCreatedByEthosUserId : {
                RelationName: 'EmployeeTrainingNeeded|roEthos_User|EmployeeTrainingNeededId',
                FieldPrefix: 'CreatedByEthosEmployeeTrainingNeeded',
                PropertyName: 'CreatedByEthosEmployeeTrainingNeeded'
            },
            /** Relation: Ethos Labor Metrics */
            EthosLaborMetrics : {
                RelationName: 'roEthos_User|Ethos_LaborMetrics|UserId',
                FieldPrefix: 'EthosLaborMetrics',
                PropertyName: 'EthosLaborMetrics'
            },
            /** Relation: Licenses - Issued To - Many */
            LicensesByIssuedTo : {
                RelationName: 'Licenses|RoEthosUser|IssuedTo',
                FieldPrefix: 'IssuedToLicenses',
                PropertyName: 'IssuedToLicenses'
            },
            /** Relation: Memo Of Record - Created By Ethos  - Many */
            MemoOfRecordByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MemoOfRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosMemoOfRecord',
                PropertyName: 'CreatedByEthosMemoOfRecord'
            },
            /** Relation: Request - Project Manager Ethos  - Many */
            TravelRequestByProjectManagerEthosUserId : {
                RelationName: 'roEthos_User|travel_Request|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosTravelRequest',
                PropertyName: 'ProjectManagerEthosTravelRequest'
            },
            /** Relation: Ro Request - Project Manager Ethos  - Many */
            RoRequestByProjectManagerEthosUserId : {
                RelationName: 'roRequest|roEthos_User|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosRoRequest',
                PropertyName: 'ProjectManagerEthosRoRequest'
            },
            /** Relation: User Extended - Ethos  - Many */
            MtlUserExtendedByEthosUserId : {
                RelationName: 'roEthos_User|mtl_UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosMtlUserExtended',
                PropertyName: 'EthosMtlUserExtended'
            },
            /** Relation: User Projection - Ethos  - Many */
            WcUserProjectionByEthosUserId : {
                RelationName: 'roEthos_User|wc_UserProjection|UserId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
            /** Relation: User Year Numbers - Ethos  - Many */
            UserYearNumbersByEthosUserId : {
                RelationName: 'UserYearNumbers_EthosUser',
                FieldPrefix: 'EthosUserYearNumbers',
                PropertyName: 'EthosUserYearNumbers'
            },
            /** Relation: Vehicle Accident - Employee - Many */
            VehicleAccidentByEmployeeId : {
                RelationName: 'VehicleAccident|roEthos_User|UserId',
                FieldPrefix: 'EmployeeIdVehicleAccident',
                PropertyName: 'EmployeeIdVehicleAccident'
            },
            /** Relation: Vehicle Accident - Createdby Ethos  - Many */
            VehicleAccidentByCreatedbyEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicleAccident',
                PropertyName: 'CreatedbyEthosVehicleAccident'
            },
            /** Relation: Vehicle Accident - Modified By Ethos  - Many */
            VehicleAccidentByModifiedByEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicleAccident',
                PropertyName: 'ModifiedByEthosVehicleAccident'
            },
    };
}

export class RoEthosUserAddSubTempMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserAddSubTemp.';

    constructor() {
        this.ItemDetail.ItemId=2407;
        this.ItemDetail.ItemName='roEthos_UserAddSubTemp';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';

    Relations = {
    };
}

export class RoEthosUserGridMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserGrid.';

    constructor() {
        this.ItemDetail.ItemId=2577;
        this.ItemDetail.ItemName='roEthos_UserGrid';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    EmployeeProfilePicUserId : string = this.i + 'EmployeeProfilePicUserId';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserStatusWs : string = this.i + 'UserStatusWs';
    SupUserId : string = this.i + 'SupUserId';
    Email : string = this.i + 'Email';
    HasVehicle : string = this.i + 'HasVehicle';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    EmployeeType : string = this.i + 'EmployeeType';
    NAME : string = this.i + 'NAME';
    AverageHours52Week : string = this.i + 'AverageHours52Week';

    Relations = {
            /** Relation: User Extended - Employee User */
            EmsUserExtendedByEmployeeUserId : {
                RelationName: 'UserExtended|roEthos_UserGrid|EmployeeUserId',
                FieldPrefix: 'EmployeeUserIdEmsUserExtended',
                PropertyName: 'EmployeeUserIdEmsUserExtended'
            },
            /** Relation: Ro All Supervisors Subordinates - Employee User */
            RoAllSupervisorsSubordinatesByEmployeeUserId : {
                RelationName: 'roAllSupervisorsSubordinates|roEthos_UserGrid|UserId',
                FieldPrefix: 'EmployeeRoAllSupervisorsSubordinates',
                PropertyName: 'EmployeeRoAllSupervisorsSubordinates'
            },
            /** Relation: D W People Pay Summary - Employee User - Many */
            DWPeoplePaySummaryByETHOSUserId : {
                RelationName: 'People Pay Summary -> Ro Ethos User Grid',
                FieldPrefix: 'ETHOSUserIdDWPeoplePaySummary',
                PropertyName: 'ETHOSUserIdDWPeoplePaySummary'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class RoEthosTeamsAndOrganizationalUnitsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthosTeamsAndOrganizationalUnits.';

    constructor() {
        this.ItemDetail.ItemId=2387;
        this.ItemDetail.ItemName='roEthosTeamsAndOrganizationalUnits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamName : string = this.i + 'TeamName';
    IsTeam : string = this.i + 'IsTeam';

    Relations = {
    };
}

export class RoFiscalYearRangeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roFiscalYearRange.';

    constructor() {
        this.ItemDetail.ItemId=2628;
        this.ItemDetail.ItemName='roFiscalYearRange';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    YearId : string = this.i + 'YearId';
    FiscalYear : string = this.i + 'FiscalYear';

    Relations = {
    };
}

export class RoInspectionsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roInspections.';

    constructor() {
        this.ItemDetail.ItemId=2749;
        this.ItemDetail.ItemName='roInspections';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TechMobile : string = this.i + 'TechMobile';
    TechOffice : string = this.i + 'TechOffice';
    TechEmail : string = this.i + 'TechEmail';
    InspectionId : string = this.i + 'InspectionId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    AdditionalInspectionNeeded : string = this.i + 'AdditionalInspectionNeeded';
    PreferredTimeOfDay : string = this.i + 'PreferredTimeOfDay';
    Result : string = this.i + 'Result';
    TechFirstName : string = this.i + 'TechFirstName';
    TechLastName : string = this.i + 'TechLastName';

    Relations = {
            /** Relation: Permit */
            Permit : {
                RelationName: 'roInspections|Permit|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}

export class Permits2RoInspectionsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_roInspections.';

    constructor() {
        this.ItemDetail.ItemId=2786;
        this.ItemDetail.ItemName='permits2_roInspections';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    PreferredTimeOfDay : string = this.i + 'PreferredTimeOfDay';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    Result : string = this.i + 'Result';
    ResultCv : string = this.i + 'ResultCv';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    TechFirstName : string = this.i + 'TechFirstName';
    TechLastName : string = this.i + 'TechLastName';
    TechOffice : string = this.i + 'TechOffice';
    TechMobile : string = this.i + 'TechMobile';
    TechEmail : string = this.i + 'TechEmail';
    InspectionType : string = this.i + 'InspectionType';
    AvailableDates : string = this.i + 'AvailableDates';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    InspectionStatusId : string = this.i + 'InspectionStatusId';
    Subcontractor : string = this.i + 'Subcontractor';
    UseSub : string = this.i + 'UseSub';

    Relations = {
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'roInspections|Permitv2|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
    };
}

export class RoIssueTypeSubtypeSeverityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roIssueTypeSubtypeSeverity.';

    constructor() {
        this.ItemDetail.ItemId=2501;
        this.ItemDetail.ItemName='roIssueTypeSubtypeSeverity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssueSubtypeId : string = this.i + 'IssueSubtypeId';
    IssueSubtype : string = this.i + 'IssueSubtype';
    IssueSubtypeAlt : string = this.i + 'IssueSubtypeAlt';
    IssueSubtypeSortOrder : string = this.i + 'IssueSubtypeSortOrder';
    IssueSubtypeIsActive : string = this.i + 'IssueSubtypeIsActive';
    IssueTypeId : string = this.i + 'IssueTypeId';
    IssueGroup : string = this.i + 'IssueGroup';
    IssueGroupAlt : string = this.i + 'IssueGroupAlt';
    IsNotifyWachterSupervisor : string = this.i + 'IsNotifyWachterSupervisor';
    IsNotifySubcontractorSubervisor : string = this.i + 'IsNotifySubcontractorSubervisor';
    IsNotifyAgencySupervisor : string = this.i + 'IsNotifyAgencySupervisor';
    IssueTypeSortOrder : string = this.i + 'IssueTypeSortOrder';
    IssueTypeIsActive : string = this.i + 'IssueTypeIsActive';
    IssueSubtypeSeverityId : string = this.i + 'IssueSubtypeSeverityId';
    Severity : string = this.i + 'Severity';
    SeveritySortOrder : string = this.i + 'SeveritySortOrder';
    SeverityIsActive : string = this.i + 'SeverityIsActive';
    IssueGroupSubtype : string = this.i + 'IssueGroupSubtype';
    IssueGroupSubtypeAlt : string = this.i + 'IssueGroupSubtypeAlt';

    Relations = {
    };
}

export class RoKickoffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roKickoff.';

    constructor() {
        this.ItemDetail.ItemId=2576;
        this.ItemDetail.ItemName='roKickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    KickoffId : string = this.i + 'KickoffId';
    EthosJobNumberId : string = this.i + 'Ethos_JobNumberId';
    BillingInvoiceDate : string = this.i + 'BillingInvoiceDate';
    CloseoutMeetingDate : string = this.i + 'CloseoutMeetingDate';
    CloseoutDeliverableCompletedByDate : string = this.i + 'CloseoutDeliverableCompletedByDate';
    ExternalKickoffDate : string = this.i + 'ExternalKickoffDate';
    ScheduledStartDate : string = this.i + 'ScheduledStartDate';
    ScheduledEndDate : string = this.i + 'ScheduledEndDate';
    AttendeeInformation : string = this.i + 'AttendeeInformation';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    ChangeOrderProcessDescription : string = this.i + 'ChangeOrderProcessDescription';
    CustomerPaymentProcedure : string = this.i + 'CustomerPaymentProcedure';
    CustomerAccountingContactDetail : string = this.i + 'CustomerAccountingContactDetail';
    DeliverablesForBilling : string = this.i + 'DeliverablesForBilling';
    EscalationPathDescription : string = this.i + 'EscalationPathDescription';
    IntroductionText : string = this.i + 'IntroductionText';
    CommunicationDescription : string = this.i + 'CommunicationDescription';
    SafetyPlanDescription : string = this.i + 'SafetyPlanDescription';
    SiteContactInformation : string = this.i + 'SiteContactInformation';
    StakeholderInformation : string = this.i + 'StakeholderInformation';
    OtherNotes : string = this.i + 'OtherNotes';
    IsBillingACH : string = this.i + 'IsBillingACH';
    IsBuyerSignatureRequired : string = this.i + 'IsBuyerSignatureRequired';
    IsMonthlyBilling : string = this.i + 'IsMonthlyBilling';
    IsWrittenBillingApprovalRequired : string = this.i + 'IsWrittenBillingApprovalRequired';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    JobNumber : string = this.i + 'JobNumber';
    JobYear : string = this.i + 'JobYear';
    WachterTeamCode : string = this.i + 'WachterTeamCode';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    ProjectManager : string = this.i + 'ProjectManager';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    WachterDepartmentCode : string = this.i + 'WachterDepartmentCode';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    WachterDivisionCode : string = this.i + 'WachterDivisionCode';

    Relations = {
            /** Relation: Kickoff */
            Kickoff : {
                RelationName: 'Kickoff|roKickoff|KickoffId',
                FieldPrefix: 'Kickoff',
                PropertyName: 'Kickoff'
            },
    };
}

export class RoLastAccidentSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roLastAccidentSummary.';

    constructor() {
        this.ItemDetail.ItemId=2776;
        this.ItemDetail.ItemName='roLastAccidentSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    LastWorkplaceAccidentDateTime : string = this.i + 'LastWorkplaceAccidentDateTime';
    DaysSinceWorkplaceAccident : string = this.i + 'DaysSinceWorkplaceAccident';
    LastVehicleAccidentDateTime : string = this.i + 'LastVehicleAccidentDateTime';
    DaysSinceVehicleAccident : string = this.i + 'DaysSinceVehicleAccident';

    Relations = {
    };
}

export class RoLicenseCountPerUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roLicenseCountPerUser.';

    constructor() {
        this.ItemDetail.ItemId=2591;
        this.ItemDetail.ItemName='roLicenseCountPerUser';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssuedTo : string = this.i + 'IssuedTo';
    LicenseCount : string = this.i + 'LicenseCount';

    Relations = {
    };
}

export class RoLicensesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roLicenses.';

    constructor() {
        this.ItemDetail.ItemId=2575;
        this.ItemDetail.ItemName='roLicenses';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    IssuedTo : string = this.i + 'IssuedTo';
    LicenseTypeId : string = this.i + 'LicenseTypeId';
    LicenseType : string = this.i + 'LicenseType';
    ExpirationDate : string = this.i + 'ExpirationDate';

    Relations = {
            /** Relation: User Extended - Issued To */
            EmsUserExtendedByIssuedTo : {
                RelationName: 'EmsUserExtended|roLicenses|EmployeeEthos_UserId',
                FieldPrefix: 'IssuedToEmsUserExtended',
                PropertyName: 'IssuedToEmsUserExtended'
            },
    };
}

export class RoMaintenanceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roMaintenance.';

    constructor() {
        this.ItemDetail.ItemId=3440;
        this.ItemDetail.ItemName='roMaintenance';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MaintenanceId : string = this.i + 'MaintenanceId';
    SortableUnitId : string = this.i + 'SortableUnitId';
    DriverName : string = this.i + 'DriverName';
    JobNumberId : string = this.i + 'JobNumberId';
    VIN : string = this.i + 'VIN';
    VehicleId : string = this.i + 'VehicleId';

    Relations = {
            /** Relation: Maintenance */
            Maintenance : {
                RelationName: 'roMaintenance|Maintenance|MaintenanceId',
                FieldPrefix: 'Maintenance',
                PropertyName: 'Maintenance'
            },
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'roMaintenance|Vehicle|VehicleId',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
    };
}

export class RoMilestoneAndMilestoneCheckpointMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roMilestoneAndMilestoneCheckpoint.';

    constructor() {
        this.ItemDetail.ItemId=2483;
        this.ItemDetail.ItemName='roMilestoneAndMilestoneCheckpoint';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MilestoneId : string = this.i + 'MilestoneId';
    KickoffId : string = this.i + 'KickoffId';
    Description : string = this.i + 'Description';
    DueDate : string = this.i + 'DueDate';
    MilestoneCheckpointId : string = this.i + 'MilestoneCheckpointId';
    CheckpointDate : string = this.i + 'CheckpointDate';
    IsCheckpointCompleted : string = this.i + 'IsCheckpointCompleted';

    Relations = {
    };
}

export class RoNspCommittedByDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspCommittedByDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2546;
        this.ItemDetail.ItemName='roNspCommittedByDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspCommittedByProjectManagerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspCommittedByProjectManager.';

    constructor() {
        this.ItemDetail.ItemId=2527;
        this.ItemDetail.ItemName='roNspCommittedByProjectManager';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspCommittedByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspCommittedByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2544;
        this.ItemDetail.ItemName='roNspCommittedByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspCommittedByUnitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspCommittedByUnit.';

    constructor() {
        this.ItemDetail.ItemId=2545;
        this.ItemDetail.ItemName='roNspCommittedByUnit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspDwFinancialsByDepartmentByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwFinancialsByDepartmentByYear.';

    constructor() {
        this.ItemDetail.ItemId=2537;
        this.ItemDetail.ItemName='roNspDwFinancialsByDepartmentByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    DepartmentId : string = this.i + 'DepartmentId';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';

    Relations = {
    };
}

export class RoNspDwFinancialsByProjectManagerByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwFinancialsByProjectManagerByYear.';

    constructor() {
        this.ItemDetail.ItemId=2534;
        this.ItemDetail.ItemName='roNspDwFinancialsByProjectManagerByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';
    FcRevPYs : string = this.i + 'fcRev-PYs';
    FcpcRevPYs : string = this.i + 'fcpcRev-PYs';
    FcCostPYs : string = this.i + 'fcCost-PYs';
    FcGPPYs : string = this.i + 'fcGP-PYs';
    FcpcGPPYs : string = this.i + 'fcpcGP-PYs';

    Relations = {
    };
}

export class RoNspDwFinancialsByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwFinancialsByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2535;
        this.ItemDetail.ItemName='roNspDwFinancialsByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';

    Relations = {
    };
}

export class RoNspDwFinancialsByUnitByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwFinancialsByUnitByYear.';

    constructor() {
        this.ItemDetail.ItemId=2536;
        this.ItemDetail.ItemName='roNspDwFinancialsByUnitByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';

    Relations = {
    };
}

export class RoNspDwOverheadByDepartmentByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwOverheadByDepartmentByYear.';

    constructor() {
        this.ItemDetail.ItemId=2524;
        this.ItemDetail.ItemName='roNspDwOverheadByDepartmentByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    DepartmentId : string = this.i + 'DepartmentId';
    OverheadYtd : string = this.i + 'Overhead_Ytd';

    Relations = {
    };
}

export class RoNspDwOverheadByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwOverheadByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2533;
        this.ItemDetail.ItemName='roNspDwOverheadByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    OverheadYtd : string = this.i + 'Overhead_Ytd';

    Relations = {
    };
}

export class RoNSPFinancialNumbersMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNSPFinancialNumbers.';

    constructor() {
        this.ItemDetail.ItemId=2532;
        this.ItemDetail.ItemName='roNSPFinancialNumbers';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    PMNameFirstPreferredLast : string = this.i + 'PMNameFirstPreferredLast';
    PMNameLastFirstPreferred : string = this.i + 'PMNameLastFirstPreferred';
    PMNameFirstLast : string = this.i + 'PMNameFirstLast';
    PMNamePreferredLast : string = this.i + 'PMNamePreferredLast';
    EthosTitle : string = this.i + 'EthosTitle';
    EthosEmail : string = this.i + 'EthosEmail';
    EthosSupId : string = this.i + 'EthosSupId';
    SupNameFirstPreferredLast : string = this.i + 'SupNameFirstPreferredLast';
    SupNameLastFirstPreferred : string = this.i + 'SupNameLastFirstPreferred';
    SupNameFirstLast : string = this.i + 'SupNameFirstLast';
    SupNamePreferredLast : string = this.i + 'SupNamePreferredLast';
    TeamId : string = this.i + 'TeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    DepartmentId : string = this.i + 'DepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';
    PyCommittedRevenue : string = this.i + 'PyCommittedRevenue';
    PyCommittedCost : string = this.i + 'PyCommittedCost';
    PyCommittedTeamRevenue : string = this.i + 'PyCommittedTeamRevenue';
    PyCommittedTeamCost : string = this.i + 'PyCommittedTeamCost';
    PyCommittedTeamPercentage : string = this.i + 'PyCommittedTeamPercentage';
    PyCommittedTeamOverhead : string = this.i + 'PyCommittedTeamOverhead';
    PyCommittedUnitRevenue : string = this.i + 'PyCommittedUnitRevenue';
    PyCommittedUnitCost : string = this.i + 'PyCommittedUnitCost';
    PyCommittedUnitPercentage : string = this.i + 'PyCommittedUnitPercentage';
    PyCommittedUnitOverhead : string = this.i + 'PyCommittedUnitOverhead';
    PyCommittedDepartmentRevenue : string = this.i + 'PyCommittedDepartmentRevenue';
    PyCommittedDepartmentCost : string = this.i + 'PyCommittedDepartmentCost';
    PyCommittedDepartmentPercentage : string = this.i + 'PyCommittedDepartmentPercentage';
    PyCommittedDepartmentOverhead : string = this.i + 'PyCommittedDepartmentOverhead';
    PyCommittedGrossProfit : string = this.i + 'PyCommittedGrossProfit';
    PyCommittedNetProfit : string = this.i + 'PyCommittedNetProfit';
    PyProjectedRevenue : string = this.i + 'PyProjectedRevenue';
    PyProjectedCost : string = this.i + 'PyProjectedCost';
    PyProjectedTeamRevenue : string = this.i + 'PyProjectedTeamRevenue';
    PyProjectedTeamCost : string = this.i + 'PyProjectedTeamCost';
    PyProjectedTeamPercentage : string = this.i + 'PyProjectedTeamPercentage';
    PyProjectedTeamOverhead : string = this.i + 'PyProjectedTeamOverhead';
    PyProjectedUnitRevenue : string = this.i + 'PyProjectedUnitRevenue';
    PyProjectedUnitCost : string = this.i + 'PyProjectedUnitCost';
    PyProjectedUnitPercentage : string = this.i + 'PyProjectedUnitPercentage';
    PyProjectedUnitOverhead : string = this.i + 'PyProjectedUnitOverhead';
    PyProjectedDepartmentRevenue : string = this.i + 'PyProjectedDepartmentRevenue';
    PyProjectedDepartmentCost : string = this.i + 'PyProjectedDepartmentCost';
    PyProjectedDepartmentPercentage : string = this.i + 'PyProjectedDepartmentPercentage';
    PyProjectedDepartmentOverhead : string = this.i + 'PyProjectedDepartmentOverhead';
    PyProjectedGrossProfit : string = this.i + 'PyProjectedGrossProfit';
    PyProjectedNetProfit : string = this.i + 'PyProjectedNetProfit';
    PyYtdRevenue : string = this.i + 'PyYtdRevenue';
    PyYtdCost : string = this.i + 'PyYtdCost';
    PyYtdTeamRevenue : string = this.i + 'PyYtdTeamRevenue';
    PyYtdTeamCost : string = this.i + 'PyYtdTeamCost';
    PyYtdTeamPercentage : string = this.i + 'PyYtdTeamPercentage';
    PyYtdTeamOverhead : string = this.i + 'PyYtdTeamOverhead';
    PyYtdUnitRevenue : string = this.i + 'PyYtdUnitRevenue';
    PyYtdUnitCost : string = this.i + 'PyYtdUnitCost';
    PyYtdUnitPercentage : string = this.i + 'PyYtdUnitPercentage';
    PyYtdUnitOverhead : string = this.i + 'PyYtdUnitOverhead';
    PyYtdDepartmentRevenue : string = this.i + 'PyYtdDepartmentRevenue';
    PyYtdDepartmentCost : string = this.i + 'PyYtdDepartmentCost';
    PyYtdDepartmentPercentage : string = this.i + 'PyYtdDepartmentPercentage';
    PyYtdDepartmentOverhead : string = this.i + 'PyYtdDepartmentOverhead';
    PyYtdGrossProfit : string = this.i + 'PyYtdGrossProfit';
    PyYtdNetProfit : string = this.i + 'PyYtdNetProfit';
    PyPcRevenue : string = this.i + 'PyPcRevenue';
    PyPcCost : string = this.i + 'PyPcCost';
    PyPcTeamRevenue : string = this.i + 'PyPcTeamRevenue';
    PyPcTeamCost : string = this.i + 'PyPcTeamCost';
    PyPcTeamPercentage : string = this.i + 'PyPcTeamPercentage';
    PyPcTeamOverhead : string = this.i + 'PyPcTeamOverhead';
    PyPcUnitRevenue : string = this.i + 'PyPcUnitRevenue';
    PyPcUnitCost : string = this.i + 'PyPcUnitCost';
    PyPcUnitPercentage : string = this.i + 'PyPcUnitPercentage';
    PyPcUnitOverhead : string = this.i + 'PyPcUnitOverhead';
    PyPcDepartmentRevenue : string = this.i + 'PyPcDepartmentRevenue';
    PyPcDepartmentCost : string = this.i + 'PyPcDepartmentCost';
    PyPcDepartmentPercentage : string = this.i + 'PyPcDepartmentPercentage';
    PyPcDepartmentOverhead : string = this.i + 'PyPcDepartmentOverhead';
    PyPcGrossProfit : string = this.i + 'PyPcGrossProfit';
    PyPcNetProfit : string = this.i + 'PyPcNetProfit';
    CurYrCommittedRevenue : string = this.i + 'CurYrCommittedRevenue';
    CurYrCommittedCost : string = this.i + 'CurYrCommittedCost';
    CurYrCommittedTeamRevenue : string = this.i + 'CurYrCommittedTeamRevenue';
    CurYrCommittedTeamCost : string = this.i + 'CurYrCommittedTeamCost';
    CurYrCommittedTeamPercentage : string = this.i + 'CurYrCommittedTeamPercentage';
    CurYrCommittedTeamOverhead : string = this.i + 'CurYrCommittedTeamOverhead';
    CurYrCommittedUnitRevenue : string = this.i + 'CurYrCommittedUnitRevenue';
    CurYrCommittedUnitCost : string = this.i + 'CurYrCommittedUnitCost';
    CurYrCommittedUnitPercentage : string = this.i + 'CurYrCommittedUnitPercentage';
    CurYrCommittedUnitOverhead : string = this.i + 'CurYrCommittedUnitOverhead';
    CurYrCommittedDepartmentRevenue : string = this.i + 'CurYrCommittedDepartmentRevenue';
    CurYrCommittedDepartmentCost : string = this.i + 'CurYrCommittedDepartmentCost';
    CurYrCommittedDepartmentPercentage : string = this.i + 'CurYrCommittedDepartmentPercentage';
    CurYrCommittedDepartmentOverhead : string = this.i + 'CurYrCommittedDepartmentOverhead';
    CurYrCommittedGrossProfit : string = this.i + 'CurYrCommittedGrossProfit';
    CurYrCommittedNetProfit : string = this.i + 'CurYrCommittedNetProfit';
    CurYrProjectedRevenue : string = this.i + 'CurYrProjectedRevenue';
    CurYrProjectedCost : string = this.i + 'CurYrProjectedCost';
    CurYrProjectedDate : string = this.i + 'CurYrProjectedDate';
    CurYrProjectedTeamRevenue : string = this.i + 'CurYrProjectedTeamRevenue';
    CurYrProjectedTeamCost : string = this.i + 'CurYrProjectedTeamCost';
    CurYrProjectedTeamPercentage : string = this.i + 'CurYrProjectedTeamPercentage';
    CurYrProjectedTeamOverhead : string = this.i + 'CurYrProjectedTeamOverhead';
    CurYrProjectedUnitRevenue : string = this.i + 'CurYrProjectedUnitRevenue';
    CurYrProjectedUnitCost : string = this.i + 'CurYrProjectedUnitCost';
    CurYrProjectedUnitPercentage : string = this.i + 'CurYrProjectedUnitPercentage';
    CurYrProjectedUnitOverhead : string = this.i + 'CurYrProjectedUnitOverhead';
    CurYrProjectedDepartmentRevenue : string = this.i + 'CurYrProjectedDepartmentRevenue';
    CurYrProjectedDepartmentCost : string = this.i + 'CurYrProjectedDepartmentCost';
    CurYrProjectedDepartmentPercentage : string = this.i + 'CurYrProjectedDepartmentPercentage';
    CurYrProjectedDepartmentOverhead : string = this.i + 'CurYrProjectedDepartmentOverhead';
    CurYrProjectedGrossProfit : string = this.i + 'CurYrProjectedGrossProfit';
    CurYrProjectedNetProfit : string = this.i + 'CurYrProjectedNetProfit';
    CurYrYtdRevenue : string = this.i + 'CurYrYtdRevenue';
    CurYrYtdCost : string = this.i + 'CurYrYtdCost';
    CurYrYtdTeamRevenue : string = this.i + 'CurYrYtdTeamRevenue';
    CurYrYtdTeamCost : string = this.i + 'CurYrYtdTeamCost';
    CurYrYtdTeamPercentage : string = this.i + 'CurYrYtdTeamPercentage';
    CurYrYtdTeamOverhead : string = this.i + 'CurYrYtdTeamOverhead';
    CurYrYtdUnitRevenue : string = this.i + 'CurYrYtdUnitRevenue';
    CurYrYtdUnitCost : string = this.i + 'CurYrYtdUnitCost';
    CurYrYtdUnitPercentage : string = this.i + 'CurYrYtdUnitPercentage';
    CurYrYtdUnitOverhead : string = this.i + 'CurYrYtdUnitOverhead';
    CurYrYtdDepartmentRevenue : string = this.i + 'CurYrYtdDepartmentRevenue';
    CurYrYtdDepartmentCost : string = this.i + 'CurYrYtdDepartmentCost';
    CurYrYtdDepartmentPercentage : string = this.i + 'CurYrYtdDepartmentPercentage';
    CurYrYtdDepartmentOverhead : string = this.i + 'CurYrYtdDepartmentOverhead';
    CurYrYtdGrossProfit : string = this.i + 'CurYrYtdGrossProfit';
    CurYrYtdNetProfit : string = this.i + 'CurYrYtdNetProfit';
    CurYrPcRevenue : string = this.i + 'CurYrPcRevenue';
    CurYrPcCost : string = this.i + 'CurYrPcCost';
    CurYrPcTeamRevenue : string = this.i + 'CurYrPcTeamRevenue';
    CurYrPcTeamCost : string = this.i + 'CurYrPcTeamCost';
    CurYrPcTeamPercentage : string = this.i + 'CurYrPcTeamPercentage';
    CurYrPcTeamOverhead : string = this.i + 'CurYrPcTeamOverhead';
    CurYrPcUnitRevenue : string = this.i + 'CurYrPcUnitRevenue';
    CurYrPcUnitCost : string = this.i + 'CurYrPcUnitCost';
    CurYrPcUnitPercentage : string = this.i + 'CurYrPcUnitPercentage';
    CurYrPcUnitOverhead : string = this.i + 'CurYrPcUnitOverhead';
    CurYrPcDepartmentRevenue : string = this.i + 'CurYrPcDepartmentRevenue';
    CurYrPcDepartmentCost : string = this.i + 'CurYrPcDepartmentCost';
    CurYrPcDepartmentPercentage : string = this.i + 'CurYrPcDepartmentPercentage';
    CurYrPcDepartmentOverhead : string = this.i + 'CurYrPcDepartmentOverhead';
    CurYrPcGrossProfit : string = this.i + 'CurYrPcGrossProfit';
    CurYrPcNetProfit : string = this.i + 'CurYrPcNetProfit';
    CurYrForecastedRevenue : string = this.i + 'CurYrForecastedRevenue';
    CurYrForecastedCost : string = this.i + 'CurYrForecastedCost';
    CurYrForecastedTeamRevenue : string = this.i + 'CurYrForecastedTeamRevenue';
    CurYrForecastedTeamCost : string = this.i + 'CurYrForecastedTeamCost';
    CurYrForecastedTeamPercentage : string = this.i + 'CurYrForecastedTeamPercentage';
    CurYrForecastedTeamOverhead : string = this.i + 'CurYrForecastedTeamOverhead';
    CurYrForecastedUnitRevenue : string = this.i + 'CurYrForecastedUnitRevenue';
    CurYrForecastedUnitCost : string = this.i + 'CurYrForecastedUnitCost';
    CurYrForecastedUnitPercentage : string = this.i + 'CurYrForecastedUnitPercentage';
    CurYrForecastedUnitOverhead : string = this.i + 'CurYrForecastedUnitOverhead';
    CurYrForecastedDepartmentRevenue : string = this.i + 'CurYrForecastedDepartmentRevenue';
    CurYrForecastedDepartmentCost : string = this.i + 'CurYrForecastedDepartmentCost';
    CurYrForecastedDepartmentPercentage : string = this.i + 'CurYrForecastedDepartmentPercentage';
    CurYrForecastedDepartmentOverhead : string = this.i + 'CurYrForecastedDepartmentOverhead';
    CurYrForecastedGrossProfit : string = this.i + 'CurYrForecastedGrossProfit';
    CurYrForecastedNetProfit : string = this.i + 'CurYrForecastedNetProfit';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2541;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    UnitName : string = this.i + 'UnitName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';
    SubUnitName : string = this.i + 'SubUnitName';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearBackupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYear_Backup.';

    constructor() {
        this.ItemDetail.ItemId=2754;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYear_Backup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    UnitName : string = this.i + 'UnitName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearOLDMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYearOLD.';

    constructor() {
        this.ItemDetail.ItemId=2681;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYearOLD';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedFiscalYear : string = this.i + 'CommittedFiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedUnitRevenue : string = this.i + 'CommittedUnitRevenue';
    CommittedUnitCost : string = this.i + 'CommittedUnitCost';
    CommittedUnitPercentage : string = this.i + 'CommittedUnitPercentage';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentRevenue : string = this.i + 'CommittedDepartmentRevenue';
    CommittedDepartmentCost : string = this.i + 'CommittedDepartmentCost';
    CommittedDepartmentPercentage : string = this.i + 'CommittedDepartmentPercentage';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    ProjectedFiscalYear : string = this.i + 'ProjectedFiscalYear';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedUnitRevenue : string = this.i + 'ProjectedUnitRevenue';
    ProjectedUnitCost : string = this.i + 'ProjectedUnitCost';
    ProjectedUnitPercentage : string = this.i + 'ProjectedUnitPercentage';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentRevenue : string = this.i + 'ProjectedDepartmentRevenue';
    ProjectedDepartmentCost : string = this.i + 'ProjectedDepartmentCost';
    ProjectedDepartmentPercentage : string = this.i + 'ProjectedDepartmentPercentage';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    YtdFiscalYear : string = this.i + 'YtdFiscalYear';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdUnitRevenue : string = this.i + 'YtdUnitRevenue';
    YtdUnitCost : string = this.i + 'YtdUnitCost';
    YtdUnitPercentage : string = this.i + 'YtdUnitPercentage';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentRevenue : string = this.i + 'YtdDepartmentRevenue';
    YtdDepartmentCost : string = this.i + 'YtdDepartmentCost';
    YtdDepartmentPercentage : string = this.i + 'YtdDepartmentPercentage';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    PcFiscalYear : string = this.i + 'PcFiscalYear';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcUnitRevenue : string = this.i + 'PcUnitRevenue';
    PcUnitCost : string = this.i + 'PcUnitCost';
    PcUnitPercentage : string = this.i + 'PcUnitPercentage';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentRevenue : string = this.i + 'PcDepartmentRevenue';
    PcDepartmentCost : string = this.i + 'PcDepartmentCost';
    PcDepartmentPercentage : string = this.i + 'PcDepartmentPercentage';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    ForecastedFiscalYear : string = this.i + 'ForecastedFiscalYear';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedUnitRevenue : string = this.i + 'ForecastedUnitRevenue';
    ForecastedUnitCost : string = this.i + 'ForecastedUnitCost';
    ForecastedUnitPercentage : string = this.i + 'ForecastedUnitPercentage';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentRevenue : string = this.i + 'ForecastedDepartmentRevenue';
    ForecastedDepartmentCost : string = this.i + 'ForecastedDepartmentCost';
    ForecastedDepartmentPercentage : string = this.i + 'ForecastedDepartmentPercentage';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';

    Relations = {
    };
}

export class RoNSPFinancialNumbersByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNSPFinancialNumbersByYear.';

    constructor() {
        this.ItemDetail.ItemId=2538;
        this.ItemDetail.ItemName='roNSPFinancialNumbersByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    PMNameFirstPreferredLast : string = this.i + 'PMNameFirstPreferredLast';
    PMNameLastFirstPreferred : string = this.i + 'PMNameLastFirstPreferred';
    PMNameFirstLast : string = this.i + 'PMNameFirstLast';
    PMNamePreferredLast : string = this.i + 'PMNamePreferredLast';
    EthosTitle : string = this.i + 'EthosTitle';
    EthosEmail : string = this.i + 'EthosEmail';
    EthosSupId : string = this.i + 'EthosSupId';
    SupNameFirstPreferredLast : string = this.i + 'SupNameFirstPreferredLast';
    SupNameLastFirstPreferred : string = this.i + 'SupNameLastFirstPreferred';
    SupNameFirstLast : string = this.i + 'SupNameFirstLast';
    SupNamePreferredLast : string = this.i + 'SupNamePreferredLast';
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedFiscalYear : string = this.i + 'CommittedFiscalYear';
    CommittedRevenue : string = this.i + 'CommittedRevenue';
    CommittedCost : string = this.i + 'CommittedCost';
    CommittedDate : string = this.i + 'CommittedDate';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamPercentage : string = this.i + 'CommittedTeamPercentage';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedUnitRevenue : string = this.i + 'CommittedUnitRevenue';
    CommittedUnitCost : string = this.i + 'CommittedUnitCost';
    CommittedUnitPercentage : string = this.i + 'CommittedUnitPercentage';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentRevenue : string = this.i + 'CommittedDepartmentRevenue';
    CommittedDepartmentCost : string = this.i + 'CommittedDepartmentCost';
    CommittedDepartmentPercentage : string = this.i + 'CommittedDepartmentPercentage';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    CommittedGrossProfit : string = this.i + 'CommittedGrossProfit';
    CommittedNetProfit : string = this.i + 'CommittedNetProfit';
    CommittedGrossProfitMargin : string = this.i + 'CommittedGrossProfitMargin';
    CommittedNetProfitMargin : string = this.i + 'CommittedNetProfitMargin';
    ProjectedFiscalYear : string = this.i + 'ProjectedFiscalYear';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ProjectedCost : string = this.i + 'ProjectedCost';
    ProjectedDate : string = this.i + 'ProjectedDate';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamPercentage : string = this.i + 'ProjectedTeamPercentage';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedUnitRevenue : string = this.i + 'ProjectedUnitRevenue';
    ProjectedUnitCost : string = this.i + 'ProjectedUnitCost';
    ProjectedUnitPercentage : string = this.i + 'ProjectedUnitPercentage';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentRevenue : string = this.i + 'ProjectedDepartmentRevenue';
    ProjectedDepartmentCost : string = this.i + 'ProjectedDepartmentCost';
    ProjectedDepartmentPercentage : string = this.i + 'ProjectedDepartmentPercentage';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    ProjectedGrossProfit : string = this.i + 'ProjectedGrossProfit';
    ProjectedNetProfit : string = this.i + 'ProjectedNetProfit';
    ProjectedGrossProfitMargin : string = this.i + 'ProjectedGrossProfitMargin';
    ProjectedNetProfitMargin : string = this.i + 'ProjectedNetProfitMargin';
    YtdFiscalYear : string = this.i + 'YtdFiscalYear';
    YtdRevenue : string = this.i + 'YtdRevenue';
    YtdCost : string = this.i + 'YtdCost';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamPercentage : string = this.i + 'YtdTeamPercentage';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdUnitRevenue : string = this.i + 'YtdUnitRevenue';
    YtdUnitCost : string = this.i + 'YtdUnitCost';
    YtdUnitPercentage : string = this.i + 'YtdUnitPercentage';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentRevenue : string = this.i + 'YtdDepartmentRevenue';
    YtdDepartmentCost : string = this.i + 'YtdDepartmentCost';
    YtdDepartmentPercentage : string = this.i + 'YtdDepartmentPercentage';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    YtdGrossProfit : string = this.i + 'YtdGrossProfit';
    YtdNetProfit : string = this.i + 'YtdNetProfit';
    YtdGrossProfitMargin : string = this.i + 'YtdGrossProfitMargin';
    YtdNetProfitMargin : string = this.i + 'YtdNetProfitMargin';
    PcFiscalYear : string = this.i + 'PcFiscalYear';
    PcRevenue : string = this.i + 'PcRevenue';
    PcCost : string = this.i + 'PcCost';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamPercentage : string = this.i + 'PcTeamPercentage';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcUnitRevenue : string = this.i + 'PcUnitRevenue';
    PcUnitCost : string = this.i + 'PcUnitCost';
    PcUnitPercentage : string = this.i + 'PcUnitPercentage';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentRevenue : string = this.i + 'PcDepartmentRevenue';
    PcDepartmentCost : string = this.i + 'PcDepartmentCost';
    PcDepartmentPercentage : string = this.i + 'PcDepartmentPercentage';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    PcGrossProfit : string = this.i + 'PcGrossProfit';
    PcNetProfit : string = this.i + 'PcNetProfit';
    PcGrossProfitMargin : string = this.i + 'PcGrossProfitMargin';
    PcNetProfitMargin : string = this.i + 'PcNetProfitMargin';
    ForecastedFiscalYear : string = this.i + 'ForecastedFiscalYear';
    ForecastedRevenue : string = this.i + 'ForecastedRevenue';
    ForecastedCost : string = this.i + 'ForecastedCost';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamPercentage : string = this.i + 'ForecastedTeamPercentage';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedUnitRevenue : string = this.i + 'ForecastedUnitRevenue';
    ForecastedUnitCost : string = this.i + 'ForecastedUnitCost';
    ForecastedUnitPercentage : string = this.i + 'ForecastedUnitPercentage';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentRevenue : string = this.i + 'ForecastedDepartmentRevenue';
    ForecastedDepartmentCost : string = this.i + 'ForecastedDepartmentCost';
    ForecastedDepartmentPercentage : string = this.i + 'ForecastedDepartmentPercentage';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';
    ForecastedGrossProfit : string = this.i + 'ForecastedGrossProfit';
    ForecastedNetProfit : string = this.i + 'ForecastedNetProfit';
    ForecastedGrossProfitMargin : string = this.i + 'ForecastedGrossProfitMargin';
    ForecastedNetProfitMargin : string = this.i + 'ForecastedNetProfitMargin';
    YtdForecastedFiscalYear : string = this.i + 'YtdForecastedFiscalYear';
    YtdForecastedRevenue : string = this.i + 'YtdForecastedRevenue';
    YtdForecastedCost : string = this.i + 'YtdForecastedCost';
    YtdForecastedTeamRevenue : string = this.i + 'YtdForecastedTeamRevenue';
    YtdForecastedTeamCost : string = this.i + 'YtdForecastedTeamCost';
    YtdForecastedTeamPercentage : string = this.i + 'YtdForecastedTeamPercentage';
    YtdForecastedTeamOverhead : string = this.i + 'YtdForecastedTeamOverhead';
    YtdForecastedUnitRevenue : string = this.i + 'YtdForecastedUnitRevenue';
    YtdForecastedUnitCost : string = this.i + 'YtdForecastedUnitCost';
    YtdForecastedUnitPercentage : string = this.i + 'YtdForecastedUnitPercentage';
    YtdForecastedUnitOverhead : string = this.i + 'YtdForecastedUnitOverhead';
    YtdForecastedDepartmentRevenue : string = this.i + 'YtdForecastedDepartmentRevenue';
    YtdForecastedDepartmentCost : string = this.i + 'YtdForecastedDepartmentCost';
    YtdForecastedDepartmentPercentage : string = this.i + 'YtdForecastedDepartmentPercentage';
    YtdForecastedDepartmentOverhead : string = this.i + 'YtdForecastedDepartmentOverhead';
    YtdForecastedGrossProfit : string = this.i + 'YtdForecastedGrossProfit';
    YtdForecastedNetProfit : string = this.i + 'YtdForecastedNetProfit';
    YtdForecastedGrossProfitMargin : string = this.i + 'YtdForecastedGrossProfitMargin';
    YtdForecastedNetProfitMargin : string = this.i + 'YtdForecastedNetProfitMargin';

    Relations = {
    };
}

export class RoNspOverheadProjectedByDepartmentByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspOverheadProjectedByDepartmentByYear.';

    constructor() {
        this.ItemDetail.ItemId=2539;
        this.ItemDetail.ItemName='roNspOverheadProjectedByDepartmentByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspOverheadProjectedByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspOverheadProjectedByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2547;
        this.ItemDetail.ItemName='roNspOverheadProjectedByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    OrganizationalUnitId : string = this.i + 'OrganizationalUnitId';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspProjectedByDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspProjectedByDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2543;
        this.ItemDetail.ItemName='roNspProjectedByDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspProjectedByProjectManagerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspProjectedByProjectManager.';

    constructor() {
        this.ItemDetail.ItemId=2526;
        this.ItemDetail.ItemName='roNspProjectedByProjectManager';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspProjectedByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspProjectedByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2540;
        this.ItemDetail.ItemName='roNspProjectedByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspProjectedByUnitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspProjectedByUnit.';

    constructor() {
        this.ItemDetail.ItemId=2542;
        this.ItemDetail.ItemName='roNspProjectedByUnit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoOrganizationalTeamUnitDeptMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOrganizationalTeamUnitDept.';

    constructor() {
        this.ItemDetail.ItemId=2530;
        this.ItemDetail.ItemName='roOrganizationalTeamUnitDept';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TeamId : string = this.i + 'TeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    DepartmentId : string = this.i + 'DepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';

    Relations = {
    };
}

export class RoOverheadCommittedByJobPhaseYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadCommittedByJobPhaseYear.';

    constructor() {
        this.ItemDetail.ItemId=2531;
        this.ItemDetail.ItemName='roOverheadCommittedByJobPhaseYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoOverheadProjectedByJobPhaseYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadProjectedByJobPhaseYear.';

    constructor() {
        this.ItemDetail.ItemId=2529;
        this.ItemDetail.ItemName='roOverheadProjectedByJobPhaseYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoOverheadProjectionByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadProjectionByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2528;
        this.ItemDetail.ItemName='roOverheadProjectionByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoPafAccessMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPafAccess.';

    constructor() {
        this.ItemDetail.ItemId=2788;
        this.ItemDetail.ItemName='roPafAccess';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    Employee : string = this.i + 'Employee';
    ViewableBy : string = this.i + 'ViewableBy';
    ReportingLevels : string = this.i + 'ReportingLevels';

    Relations = {
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'roPafAccess|PayJobChange|PayJobChangeId',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
    };
}

export class RoPayJobChangeSubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPayJobChangeSubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2674;
        this.ItemDetail.ItemName='roPayJobChangeSubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    EmployeeSupervisorUserId : string = this.i + 'EmployeeSupervisorUserId';
    EmployeeSupervisorName : string = this.i + 'EmployeeSupervisorName';
    EmployeeSupervisorDepth : string = this.i + 'EmployeeSupervisorDepth';
    CreatedBySupervisorUserId : string = this.i + 'CreatedBySupervisorUserId';
    CreatedBySupervisorName : string = this.i + 'CreatedBySupervisorName';
    CreatedBySupervisorDepth : string = this.i + 'CreatedBySupervisorDepth';

    Relations = {
    };
}

export class RoPermitRequestLastNoteMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitRequestLastNote.';

    constructor() {
        this.ItemDetail.ItemId=2745;
        this.ItemDetail.ItemName='roPermitRequestLastNote';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    Note : string = this.i + 'Note';
    NoteId : string = this.i + 'NoteId';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'roPermitRequestLastNote|PermitRequest|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

export class RoPermitRequestsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitRequests.';

    constructor() {
        this.ItemDetail.ItemId=2701;
        this.ItemDetail.ItemName='roPermitRequests';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    JobId : string = this.i + 'JobId';
    OpportunityId : string = this.i + 'OpportunityId';
    JobNumberId : string = this.i + 'JobNumberId';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    CountyId : string = this.i + 'CountyId';
    StateProvinceId : string = this.i + 'StateProvinceId';
    CountyName : string = this.i + 'CountyName';
    StateProvinceName : string = this.i + 'StateProvinceName';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'roPermitRequests|permitRequest|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

export class RoPermitsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermits.';

    constructor() {
        this.ItemDetail.ItemId=2700;
        this.ItemDetail.ItemName='roPermits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUser : string = this.i + 'RequestedByUser';
    PermitStatusWs : string = this.i + 'PermitStatusWs';
    DueDate : string = this.i + 'DueDate';
    JobId : string = this.i + 'JobId';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubcontractorLicense : string = this.i + 'SubcontractorLicense';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    AssignedToUser : string = this.i + 'AssignedToUser';
    FloorCount : string = this.i + 'FloorCount';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    CableTypeCv : string = this.i + 'CableTypeCv';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCablingPresent : string = this.i + 'UndergroundCablingPresent';
    CablingInConduitPresent : string = this.i + 'CablingInConduitPresent';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    AttachmentId : string = this.i + 'AttachmentId';
    JobSiteId : string = this.i + 'JobSiteId';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    SharepointId : string = this.i + 'SharepointId';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    NoteParentId : string = this.i + 'NoteParentId';
    JobNumberId : string = this.i + 'JobNumberId';
    OpportunityId : string = this.i + 'OpportunityId';
    OverallContractValuation : string = this.i + 'OverallContractValuation';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    SiteTypeCv : string = this.i + 'SiteTypeCv';
    JobNumberName : string = this.i + 'JobNumberName';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    CountyId : string = this.i + 'CountyId';
    CountyName : string = this.i + 'CountyName';
    InspectionStateCv : string = this.i + 'InspectionStateCv';

    Relations = {
            /** Relation: Permit */
            Permit : {
                RelationName: 'roPermit}Permit|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}

export class Permits2RoPermitsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permits2_roPermits.';

    constructor() {
        this.ItemDetail.ItemId=2779;
        this.ItemDetail.ItemName='permits2_roPermits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    InspectionNeeded : string = this.i + 'InspectionNeeded';
    HasAssociatedJobId : string = this.i + 'HasAssociatedJobId';
    JobAddress1 : string = this.i + 'JobAddress1';
    JobAddress2 : string = this.i + 'JobAddress2';
    JobCity : string = this.i + 'JobCity';
    JobCountyId : string = this.i + 'JobCountyId';
    JobCountyName : string = this.i + 'JobCountyName';
    JobStateId : string = this.i + 'JobStateId';
    JobStateName : string = this.i + 'JobStateName';
    JobStateShortName : string = this.i + 'JobStateShortName';
    JobPostalCode : string = this.i + 'JobPostalCode';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    ProjectManagerEmail : string = this.i + 'ProjectManagerEmail';
    CustomerName : string = this.i + 'CustomerName';
    ProjectManager2UserId : string = this.i + 'ProjectManager2UserId';
    JobNumJobNumberId : string = this.i + 'JobNumJobNumberId';
    JobNumAddress1 : string = this.i + 'JobNumAddress1';
    JobNumAddress2 : string = this.i + 'JobNumAddress2';
    JobNumCity : string = this.i + 'JobNumCity';
    JobNumStateId : string = this.i + 'JobNumStateId';
    JobNumStateName : string = this.i + 'JobNumStateName';
    JobNumStateShortName : string = this.i + 'JobNumStateShortName';
    JobNumPostalCode : string = this.i + 'JobNumPostalCode';
    SummaryDescription : string = this.i + 'SummaryDescription';
    JobNumber : string = this.i + 'JobNumber';
    JobSiteId : string = this.i + 'JobSiteId';
    IsActive : string = this.i + 'IsActive';
    IsComplete : string = this.i + 'IsComplete';
    ProjectManager2Email : string = this.i + 'ProjectManager2Email';
    InspDueDate : string = this.i + 'InspDueDate';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Job Number - Job Num Job Number */
            EthosJobNumberByJobNumJobNumberId : {
                RelationName: 'roPermits|Ethos_JobNumber|JobNumJobNumberId',
                FieldPrefix: 'JobNumEthosJobNumber',
                PropertyName: 'JobNumEthosJobNumber'
            },
            /** Relation: Ethos Opportunity - Permit */
            EthosOpportunityByPermitId : {
                RelationName: 'roPermits|Ethos_Opportunity|OpportunityId',
                FieldPrefix: 'PermitIdEthosOpportunity',
                PropertyName: 'PermitIdEthosOpportunity'
            },
            /** Relation: Ethos User - Project Manager User */
            EthosUserByProjectManagerUserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManagerUserId',
                FieldPrefix: 'ProjectManagerEthosUser',
                PropertyName: 'ProjectManagerEthosUser'
            },
            /** Relation: Ethos User - Project Manager2 User */
            EthosUserByProjectManager2UserId : {
                RelationName: 'roPermits|Ethos_User|ProjectManager2UserId',
                FieldPrefix: 'ProjectManager2EthosUser',
                PropertyName: 'ProjectManager2EthosUser'
            },
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'roPermits|permits2.Permit|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Ro Permits By Subordinates */
            RoPermitsBySubordinates : {
                RelationName: 'roPermits|roPermitsBySubordinates|PermitId',
                FieldPrefix: 'RoPermitsBySubordinates',
                PropertyName: 'RoPermitsBySubordinates'
            },
    };
}

export class RoPermitsBySubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitsBySubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2795;
        this.ItemDetail.ItemName='roPermitsBySubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    ViewableBy : string = this.i + 'ViewableBy';
    ReportingLevels : string = this.i + 'ReportingLevels';

    Relations = {
            /** Relation: Ro Permits */
            Permits2RoPermits : {
                RelationName: 'roPermits|roPermitsBySubordinates|PermitId',
                FieldPrefix: 'Permits2roPermits',
                PropertyName: 'Permits2roPermits'
            },
    };
}

export class RoPositionHistoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPositionHistory.';

    constructor() {
        this.ItemDetail.ItemId=2589;
        this.ItemDetail.ItemName='roPositionHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    Title : string = this.i + 'Title';
    ChangeDate : string = this.i + 'ChangeDate';

    Relations = {
    };
}

export class RoProjectKickoffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roProjectKickoff.';

    constructor() {
        this.ItemDetail.ItemId=3430;
        this.ItemDetail.ItemName='roProjectKickoff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    Customer : string = this.i + 'Customer';
    JobNumber : string = this.i + 'JobNumber';
    ProjectName : string = this.i + 'ProjectName';
    ProjectManagerUserId : string = this.i + 'ProjectManagerUserId';
    StartDate : string = this.i + 'StartDate';
    EndDate : string = this.i + 'EndDate';
    KickoffId : string = this.i + 'KickoffId';
    CustomerId : string = this.i + 'CustomerId';
    CustomerShortName : string = this.i + 'CustomerShortName';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'roProjectKickoff|JobMembership',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'roProjectKickoff|Project_Kickoff|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
    };
}

export class RoProjectManagersTeamUnitDeptMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roProjectManagersTeamUnitDept.';

    constructor() {
        this.ItemDetail.ItemId=2525;
        this.ItemDetail.ItemName='roProjectManagersTeamUnitDept';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    HasRevenue : string = this.i + 'HasRevenue';
    PMNameFirstPreferredLast : string = this.i + 'PMNameFirstPreferredLast';
    PMNameLastFirstPreferred : string = this.i + 'PMNameLastFirstPreferred';
    PMNameFirstLast : string = this.i + 'PMNameFirstLast';
    PMNamePreferredLast : string = this.i + 'PMNamePreferredLast';
    EthosTitle : string = this.i + 'EthosTitle';
    EthosEmail : string = this.i + 'EthosEmail';
    EthosSupId : string = this.i + 'EthosSupId';
    SupNameFirstPreferredLast : string = this.i + 'SupNameFirstPreferredLast';
    SupNameLastFirstPreferred : string = this.i + 'SupNameLastFirstPreferred';
    SupNameFirstLast : string = this.i + 'SupNameFirstLast';
    SupNamePreferredLast : string = this.i + 'SupNamePreferredLast';
    TeamId : string = this.i + 'TeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    DepartmentId : string = this.i + 'DepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';

    Relations = {
    };
}

export class RoRequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequest.';

    constructor() {
        this.ItemDetail.ItemId=2558;
        this.ItemDetail.ItemName='roRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestId : string = this.i + 'RequestId';
    JobNumberWjid : string = this.i + 'JobNumberWjid';
    DepartureLocation : string = this.i + 'DepartureLocation';
    DestinationLocation : string = this.i + 'DestinationLocation';
    DestinationArrivalDate : string = this.i + 'DestinationArrivalDate';
    ReturningDate : string = this.i + 'ReturningDate';
    TravelModeCv : string = this.i + 'TravelModeCv';
    TraveModeComment : string = this.i + 'TraveModeComment';
    FlightPreference : string = this.i + 'FlightPreference';
    AirportPlanCv : string = this.i + 'AirportPlanCv';
    AirportPlanComment : string = this.i + 'AirportPlanComment';
    TransportationPlanCv : string = this.i + 'TransportationPlanCv';
    TransportationPlanComment : string = this.i + 'TransportationPlanComment';
    LodgingPlanCv : string = this.i + 'LodgingPlanCv';
    LodgingPlanComment : string = this.i + 'LodgingPlanComment';
    TravelRequestComments : string = this.i + 'TravelRequestComments';
    TravelTypeCv : string = this.i + 'TravelTypeCv';
    TravelTypeComment : string = this.i + 'TravelTypeComment';
    ProjectManagerEthosUserId : string = this.i + 'ProjectManagerEthos_UserId';
    Customer : string = this.i + 'Customer';
    CustomerPm : string = this.i + 'CustomerPm';
    TravelReason : string = this.i + 'TravelReason';
    PotentialRevenue : string = this.i + 'PotentialRevenue';
    NumberOfSites : string = this.i + 'NumberOfSites';
    ProjectDuration : string = this.i + 'ProjectDuration';
    MeetingNotes : string = this.i + 'MeetingNotes';
    StatusCv : string = this.i + 'StatusCv';
    TravelerEthosUserId : string = this.i + 'TravelerEthos_UserId';
    Preferences : string = this.i + 'Preferences';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ParkingPassNeeded : string = this.i + 'ParkingPassNeeded';
    ParkingPassReturned : string = this.i + 'ParkingPassReturned';

    Relations = {
            /** Relation: Request */
            TravelRequest : {
                RelationName: 'Travel_Request|Travel_roRequest|RequestId',
                FieldPrefix: 'TravelRequest',
                PropertyName: 'TravelRequest'
            },
            /** Relation: Ro Ethos User - Project Manager Ethos User */
            RoEthosUserByProjectManagerEthosUserId : {
                RelationName: 'roRequest|roEthos_User|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosRoEthosUser',
                PropertyName: 'ProjectManagerEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Created By Ethos User - Many */
            RoEthosUserByUserId : {
                RelationName: 'roRequest|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
    };
}

export class RoRequestContextMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequestContext.';

    constructor() {
        this.ItemDetail.ItemId=3453;
        this.ItemDetail.ItemName='roRequestContext';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    Target : string = this.i + 'Target';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    WJID : string = this.i + 'WJID';
    TargetId : string = this.i + 'TargetId';

    Relations = {
    };
}

export class RoStarRatingAvProjectsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roStarRatingAvProjects.';

    constructor() {
        this.ItemDetail.ItemId=3451;
        this.ItemDetail.ItemName='roStarRatingAvProjects';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Id : string = this.i + 'Id';
    DateSubmitted : string = this.i + 'DateSubmitted';
    WJID : string = this.i + 'WJID';
    JobNumber : string = this.i + 'JobNumber';
    NspPm : string = this.i + 'NspPm';
    NspPmRating : string = this.i + 'NspPmRating';
    NspInstallTech : string = this.i + 'NspInstallTech';
    NspInstallTechRating : string = this.i + 'NspInstallTechRating';
    WtsPm : string = this.i + 'WtsPm';
    WtsPmRating : string = this.i + 'WtsPmRating';
    WtsEngineer : string = this.i + 'WtsEngineer';
    WtsEngineerRating : string = this.i + 'WtsEngineerRating';
    OverallExperience : string = this.i + 'OverallExperience';
    FollowUpRequested : string = this.i + 'FollowUpRequested';

    Relations = {
            /** Relation: Ethos Job - WJID */
            EthosJobByWJID : {
                RelationName: 'roStarRatingAvProjects|Ethos_Job|WJID',
                FieldPrefix: 'WJIDEthosJob',
                PropertyName: 'WJIDEthosJob'
            },
            /** Relation: Star Rating Av Projects - Id */
            StarRatingAvProjectsById : {
                RelationName: 'roStarRatingAvProjects|StarRatingAvProject|Id',
                FieldPrefix: 'IdStarRatingAvProjects',
                PropertyName: 'IdStarRatingAvProjects'
            },
    };
}

export class RoStarRatingAvProjectsPmsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roStarRatingAvProjectsPms.';

    constructor() {
        this.ItemDetail.ItemId=3452;
        this.ItemDetail.ItemName='roStarRatingAvProjectsPms';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Pm : string = this.i + 'Pm';
    UserId : string = this.i + 'UserId';

    Relations = {
    };
}

export class RoStarRatingNotificationTargetsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roStarRatingNotificationTargets.';

    constructor() {
        this.ItemDetail.ItemId=2743;
        this.ItemDetail.ItemName='roStarRatingNotificationTargets';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingFieldExperienceId : string = this.i + 'StarRatingFieldExperienceId';
    Email : string = this.i + 'Email';
    EmailType : string = this.i + 'EmailType';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    UserTypeCv : string = this.i + 'UserTypeCv';

    Relations = {
            /** Relation: Star Rating - Field Experience */
            StarRatingFieldExperience : {
                RelationName: 'Star Rating Notification Targets',
                FieldPrefix: 'StarRatingFieldExperience',
                PropertyName: 'StarRatingFieldExperience'
            },
    };
}

export class RoTerritoryStateProvinceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roTerritoryStateProvince.';

    constructor() {
        this.ItemDetail.ItemId=2372;
        this.ItemDetail.ItemName='roTerritoryStateProvince';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    TerritoryDescription : string = this.i + 'TerritoryDescription';
    TerritoryMeaning : string = this.i + 'TerritoryMeaning';
    TerritoryIsDeleted : string = this.i + 'TerritoryIsDeleted';
    ColorHex : string = this.i + 'ColorHex';
    StateProvinceId : string = this.i + 'StateProvinceId';
    CountryId : string = this.i + 'CountryId';
    StateProvinceName : string = this.i + 'StateProvinceName';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';

    Relations = {
    };
}

export class RoUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roUserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2506;
        this.ItemDetail.ItemName='roUserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    Cost : string = this.i + 'Cost';
    Revenue : string = this.i + 'Revenue';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ProjectionMonth : string = this.i + 'ProjectionMonth';

    Relations = {
    };
}

export class NumbersRoUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'numbers_roUserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2553;
        this.ItemDetail.ItemName='numbers_roUserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    FiscalYear : string = this.i + 'FiscalYear';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ProjectedCost : string = this.i + 'ProjectedCost';
    ProjectedGP : string = this.i + 'ProjectedGP';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoUserProjectionAnalyzedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roUserProjectionAnalyzed.';

    constructor() {
        this.ItemDetail.ItemId=3446;
        this.ItemDetail.ItemName='roUserProjectionAnalyzed';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    UserId : string = this.i + 'UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';
    Gross : string = this.i + 'Gross';
    GrossMargin : string = this.i + 'GrossMargin';
    DateTimeProjected : string = this.i + 'DateTimeProjected';
    DateTimeUtcAnalyzed : string = this.i + 'DateTimeUtcAnalyzed';

    Relations = {
    };
}

export class RoUserSkillListMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roUserSkillList.';

    constructor() {
        this.ItemDetail.ItemId=2774;
        this.ItemDetail.ItemName='roUserSkillList';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    TimerSkillList : string = this.i + 'TimerSkillList';
    FullSkillIst : string = this.i + 'FullSkillIst';

    Relations = {
            /** Relation: Timer - User - Many */
            TimerByTechEthosUserId : {
                RelationName: 'RoUserSkillList|Timer|TechEthos_UserId',
                FieldPrefix: 'TechEthosTimer',
                PropertyName: 'TechEthosTimer'
            },
    };
}

export class RoVehicleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roVehicle.';

    constructor() {
        this.ItemDetail.ItemId=3438;
        this.ItemDetail.ItemName='roVehicle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleStatusCv : string = this.i + 'VehicleStatusCv';
    UnitId : string = this.i + 'UnitId';
    DriverName : string = this.i + 'DriverName';
    DriverUserId : string = this.i + 'DriverUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    IsDot : string = this.i + 'IsDot';
    VehicleTypeCv : string = this.i + 'VehicleTypeCv';
    Year : string = this.i + 'Year';
    Make : string = this.i + 'Make';
    Model : string = this.i + 'Model';
    VIN : string = this.i + 'VIN';
    RegistrationStateProvinceId : string = this.i + 'RegistrationStateProvinceId';
    LicensePlate : string = this.i + 'LicensePlate';
    PlateExpirationDate : string = this.i + 'PlateExpirationDate';
    VehicleId : string = this.i + 'VehicleId';
    Phase : string = this.i + 'Phase';
    SortableUnitId : string = this.i + 'SortableUnitId';
    IsDotDisplay : string = this.i + 'IsDotDisplay';
    Unassigned : string = this.i + 'Unassigned';

    Relations = {
            /** Relation: Vehicle */
            FleetVehicle : {
                RelationName: 'roVehicle|Vehicle|VehicleId OLD',
                FieldPrefix: 'FleetVehicle',
                PropertyName: 'FleetVehicle'
            },
            /** Relation: Vehicle */
            Vehicle : {
                RelationName: 'Vehicle|roVehicle|VehicleId',
                FieldPrefix: 'Vehicle',
                PropertyName: 'Vehicle'
            },
    };
}

export class RoVehicleAccidentsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleAccidents.';

    constructor() {
        this.ItemDetail.ItemId=2519;
        this.ItemDetail.ItemName='roVehicleAccidents';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    EmployeeId : string = this.i + 'EmployeeId';
    PhoneNumber : string = this.i + 'PhoneNumber';
    WJID : string = this.i + 'WJID';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    AuthorityContacted : string = this.i + 'AuthorityContacted';
    ReportNumber : string = this.i + 'ReportNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    AccidentAddress : string = this.i + 'AccidentAddress';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentAtFaultCv : string = this.i + 'AccidentAtFaultCv';
    VehicleRepairedCv : string = this.i + 'VehicleRepairedCv';
    Injuries : string = this.i + 'Injuries';
    OOPClaimExpense : string = this.i + 'OOPClaimExpense';
    InsurancePaidPDLTInsuredVehicle : string = this.i + 'InsurancePaidPDLTInsuredVehicle';
    InsurancePaidPDLTClaimantVehicle : string = this.i + 'InsurancePaidPDLTClaimantVehicle';
    OtherVehiclesInvolved : string = this.i + 'OtherVehiclesInvolved';
    IsDot : string = this.i + 'IsDot';
    AccidentDescription : string = this.i + 'AccidentDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    ClaimInsuranceCompanyCv : string = this.i + 'ClaimInsuranceCompanyCv';
    ClaimInsuranceCompanyText : string = this.i + 'ClaimInsuranceCompanyText';
    AdvisorName : string = this.i + 'AdvisorName';
    AdvisorPhone : string = this.i + 'AdvisorPhone';
    ClaimFiledDate : string = this.i + 'ClaimFiledDate';
    ClaimComments : string = this.i + 'ClaimComments';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointMigrationId : string = this.i + 'SharepointMigrationId';
    AccidentDateMonth : string = this.i + 'AccidentDateMonth';
    StateDisplay : string = this.i + 'StateDisplay';
    IsPoliceReportObtained : string = this.i + 'IsPoliceReportObtained';
    ClaimNumberThirdParty : string = this.i + 'ClaimNumberThirdParty';

    Relations = {
    };
}

export class RoVehicleYearsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleYears.';

    constructor() {
        this.ItemDetail.ItemId=3415;
        this.ItemDetail.ItemName='roVehicleYears';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';

    Relations = {
    };
}

export class RoWorkersCompMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roWorkersComp.';

    constructor() {
        this.ItemDetail.ItemId=3429;
        this.ItemDetail.ItemName='roWorkersComp';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccidentId : string = this.i + 'AccidentId';
    AXId : string = this.i + 'AXId';
    Employee : string = this.i + 'Employee';
    ExpenseType : string = this.i + 'ExpenseType';
    Date : string = this.i + 'Date';
    Details : string = this.i + 'Details';
    Expenses : string = this.i + 'Expenses';

    Relations = {
            /** Relation: Workplace Accident - Accident */
            WorkplaceAccidentByAccidentId : {
                RelationName: 'Workers Comp Expenses',
                FieldPrefix: 'AccidentIdWorkplaceAccident',
                PropertyName: 'AccidentIdWorkplaceAccident'
            },
    };
}

export class RoWorkplaceAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roWorkplaceAccident.';

    constructor() {
        this.ItemDetail.ItemId=2641;
        this.ItemDetail.ItemName='roWorkplaceAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CombinedEmployeeName : string = this.i + 'CombinedEmployeeName';
    CombinedDepartmentName : string = this.i + 'CombinedDepartmentName';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    IsWachterEmployee : string = this.i + 'IsWachterEmployee';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeName : string = this.i + 'EmployeeName';
    DepartmentId : string = this.i + 'DepartmentId';
    JobNumberId : string = this.i + 'JobNumberId';
    WJID : string = this.i + 'WJID';
    Facility : string = this.i + 'Facility';
    WorksiteTypeCv : string = this.i + 'WorksiteTypeCv';
    PriorToAccidentDescription : string = this.i + 'PriorToAccidentDescription';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDescription : string = this.i + 'InjuryDescription';
    ObjectDescription : string = this.i + 'ObjectDescription';
    DeathDescription : string = this.i + 'DeathDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    BodySideCv : string = this.i + 'BodySideCv';
    BodyPartCv : string = this.i + 'BodyPartCv';
    InjuryTypeCv : string = this.i + 'InjuryTypeCv';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    AccidentAddress : string = this.i + 'AccidentAddress';
    MediaGroupId : string = this.i + 'MediaGroupId';
    InjuryOtherExplanation : string = this.i + 'InjuryOtherExplanation';
    EmployeeAddress : string = this.i + 'EmployeeAddress';
    EmployeeCity : string = this.i + 'EmployeeCity';
    EmployeeState : string = this.i + 'EmployeeState';
    EmployeeZip : string = this.i + 'EmployeeZip';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    FatalityInvolved : string = this.i + 'FatalityInvolved';
    FatalityDateTime : string = this.i + 'FatalityDateTime';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimFileDate : string = this.i + 'ClaimFileDate';
    ClaimInsuranceCompany : string = this.i + 'ClaimInsuranceCompany';
    ClaimAdjustorName : string = this.i + 'ClaimAdjustorName';
    ClaimAdjustorPhone : string = this.i + 'ClaimAdjustorPhone';
    ClaimComments : string = this.i + 'ClaimComments';
    EmployeeOnLeave : string = this.i + 'EmployeeOnLeave';
    EmployeeHasAttorney : string = this.i + 'EmployeeHasAttorney';
    EmployeeAttorneyName : string = this.i + 'EmployeeAttorneyName';
    EmployeeAttorneyPhone : string = this.i + 'EmployeeAttorneyPhone';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    MedicalWachter : string = this.i + 'MedicalWachter';
    MedicalAboveDeductible : string = this.i + 'MedicalAboveDeductible';
    WageExpenseWachter : string = this.i + 'WageExpenseWachter';
    WageExpenseAboveDeductible : string = this.i + 'WageExpenseAboveDeductible';
    InHouseClaim : string = this.i + 'InHouseClaim';
    WorkersCompAttachmentId : string = this.i + 'WorkersCompAttachmentId';

    Relations = {
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class RoWorkplaceAccidentNotesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roWorkplaceAccidentNotes.';

    constructor() {
        this.ItemDetail.ItemId=3414;
        this.ItemDetail.ItemName='roWorkplaceAccidentNotes';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Notes : string = this.i + 'Notes';
    OOP : string = this.i + 'OOP';

    Relations = {
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident_WithNote',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class RoYearRangeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roYearRange.';

    constructor() {
        this.ItemDetail.ItemId=2523;
        this.ItemDetail.ItemName='roYearRange';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    YearId : string = this.i + 'YearId';
    Year : string = this.i + 'Year';

    Relations = {
    };
}

export class ServiceTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ServiceType.';

    constructor() {
        this.ItemDetail.ItemId=3442;
        this.ItemDetail.ItemName='ServiceType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ServiceTypeId : string = this.i + 'ServiceTypeId';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Maintenance Service */
            MaintenanceService : {
                RelationName: 'ServiceType|MaintenanceService|ServiceTypeId',
                FieldPrefix: 'MaintenanceService',
                PropertyName: 'MaintenanceService'
            },
    };
}

export class StageAuditLogMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StageAuditLog.';

    constructor() {
        this.ItemDetail.ItemId=2796;
        this.ItemDetail.ItemName='StageAuditLog';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StageAuditLogId : string = this.i + 'StageAuditLogId';
    PermitStatusId : string = this.i + 'PermitStatusId';
    StatusUpdatedByUserId : string = this.i + 'StatusUpdatedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    PermitId : string = this.i + 'PermitId';
    StageCompleted : string = this.i + 'StageCompleted';

    Relations = {
            /** Relation: Permit */
            Permits2Permit : {
                RelationName: 'permits2_Permit|StageAuditLog|PermitId',
                FieldPrefix: 'Permits2Permit',
                PropertyName: 'Permits2Permit'
            },
            /** Relation: Permit Status */
            Permits2PermitStatus : {
                RelationName: 'permits2_PermitStatus|StageAuditLog|PermitStatusId',
                FieldPrefix: 'Permits2PermitStatus',
                PropertyName: 'Permits2PermitStatus'
            },
            /** Relation: Ethos User - Status Updated By User */
            EthosUserByStatusUpdatedByUserId : {
                RelationName: 'Ethos_User|StageAuditLog|StatusUpdatedByUserId',
                FieldPrefix: 'StatusUpdatedByEthosUser',
                PropertyName: 'StatusUpdatedByEthosUser'
            },
    };
}

export class StakeholderMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Stakeholder.';

    constructor() {
        this.ItemDetail.ItemId=3420;
        this.ItemDetail.ItemName='Stakeholder';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StakeholderId : string = this.i + 'StakeholderId';
    KickoffId : string = this.i + 'KickoffId';
    Name : string = this.i + 'Name';
    Title : string = this.i + 'Title';
    Role : string = this.i + 'Role';
    Department : string = this.i + 'Department';
    Company : string = this.i + 'Company';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|Stakeholder|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Stakeholder|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Stakeholder|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class StarRatingAvProjectsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingAvProjects.';

    constructor() {
        this.ItemDetail.ItemId=3444;
        this.ItemDetail.ItemName='StarRatingAvProjects';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingAvProjectsId : string = this.i + 'StarRatingAvProjectsId';
    EthosJobId : string = this.i + 'Ethos_JobId';
    NspPmScore : string = this.i + 'NspPmScore';
    NspInstallTechScore : string = this.i + 'NspInstallTechScore';
    WtsPmScore : string = this.i + 'WtsPmScore';
    WtsEngineerScore : string = this.i + 'WtsEngineerScore';
    OverallScore : string = this.i + 'OverallScore';
    AdditionalComments : string = this.i + 'AdditionalComments';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    FollowUpRequested : string = this.i + 'FollowUpRequested';
    FollowedUpOnDateTime : string = this.i + 'FollowedUpOnDateTime';
    FollowedUpByEthosUserId : string = this.i + 'FollowedUpByEthos_UserId';
    HasBeenReviewed : string = this.i + 'HasBeenReviewed';
    NspInstallTechnicianUserId : string = this.i + 'NspInstallTechnicianUserId';

    Relations = {
            /** Relation: Ethos Job - Job */
            EthosJobByEthosJobId : {
                RelationName: 'Ethos_Job|StarRatingAvProjects|Ethos_JobId',
                FieldPrefix: 'EthosEthosJob',
                PropertyName: 'EthosEthosJob'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Followed Up By Ethos User */
            EthosUserByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosEthosUser',
                PropertyName: 'FollowedUpByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - ProjectManagerEthos_UserId */
            EthosUserByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosEthosUser',
                PropertyName: 'ProjectManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Nsp Install Technician User */
            EthosUserByNspInstallTechnicianUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|NspInstallTechnicianUserId',
                FieldPrefix: 'NspInstallTechnicianEthosUser',
                PropertyName: 'NspInstallTechnicianEthosUser'
            },
            /** Relation: Ro Star Rating Av Projects - Many */
            RoStarRatingAvProjectsById : {
                RelationName: 'roStarRatingAvProjects|StarRatingAvProject|Id',
                FieldPrefix: 'IdRoStarRatingAvProjects',
                PropertyName: 'IdRoStarRatingAvProjects'
            },
    };
}

export class StarRatingFieldExperienceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingFieldExperience.';

    constructor() {
        this.ItemDetail.ItemId=2736;
        this.ItemDetail.ItemName='StarRatingFieldExperience';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingFieldExperienceId : string = this.i + 'StarRatingFieldExperienceId';
    ProjectManagerEthosUserId : string = this.i + 'ProjectManagerEthos_UserId';
    AdditionalComments : string = this.i + 'AdditionalComments';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    EthosJobId : string = this.i + 'Ethos_JobId';
    FollowUpRequested : string = this.i + 'FollowUpRequested';
    OverallScore : string = this.i + 'OverallScore';
    SchedulingScore : string = this.i + 'SchedulingScore';
    ResponsivenessScore : string = this.i + 'ResponsivenessScore';
    SupportScore : string = this.i + 'SupportScore';
    HasBeenReviewed : string = this.i + 'HasBeenReviewed';
    FollowedUpOnDateTime : string = this.i + 'FollowedUpOnDateTime';
    FollowedUpByEthosUserId : string = this.i + 'FollowedUpByEthos_UserId';
    NoteParentId : string = this.i + 'NoteParentId';

    Relations = {
            /** Relation: Ethos Job - WJID */
            EthosJobByEthosJobId : {
                RelationName: 'Ethos_Job|StarRatingFieldExperience|Ethos_JobId',
                FieldPrefix: 'EthosEthosJob',
                PropertyName: 'EthosEthosJob'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|StarRatingFieldExperience|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Ethos User - PM Ethos ID */
            EthosUserByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosEthosUser',
                PropertyName: 'ProjectManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Followed Up By Ethos User */
            EthosUserByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosEthosUser',
                PropertyName: 'FollowedUpByEthosEthosUser'
            },
            /** Relation: Ro Star Rating Notification Targets */
            RoStarRatingNotificationTargets : {
                RelationName: 'Star Rating Notification Targets',
                FieldPrefix: 'RoStarRatingNotificationTargets',
                PropertyName: 'RoStarRatingNotificationTargets'
            },
    };
}

export class StarRatingNotificationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingNotification.';

    constructor() {
        this.ItemDetail.ItemId=2742;
        this.ItemDetail.ItemName='StarRatingNotification';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingNotificationId : string = this.i + 'StarRatingNotificationId';
    StarRatingNotificationTypeId : string = this.i + 'StarRatingNotificationTypeId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    UserTypeCv : string = this.i + 'UserTypeCv';
    Email : string = this.i + 'Email';

    Relations = {
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|StarRatingNotification|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Star Rating Notification Type - Type */
            StarRatingNotificationTypeByStarRatingNotificationTypeId : {
                RelationName: 'StarRatingNotificationType|StarRatingNotification|StarRatingNotificationTypeId',
                FieldPrefix: 'StarRatingNotificationStarRatingNotificationType',
                PropertyName: 'StarRatingNotificationStarRatingNotificationType'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|StarRatingNotification|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
    };
}

export class StarRatingNotificationTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingNotificationType.';

    constructor() {
        this.ItemDetail.ItemId=2741;
        this.ItemDetail.ItemName='StarRatingNotificationType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TypeId : string = this.i + 'TypeId';
    Display : string = this.i + 'Display';
    DisplayShortName : string = this.i + 'DisplayShortName';

    Relations = {
            /** Relation: Star Rating Notification - Many */
            StarRatingNotificationByStarRatingNotificationTypeId : {
                RelationName: 'StarRatingNotificationType|StarRatingNotification|StarRatingNotificationTypeId',
                FieldPrefix: 'StarRatingNotificationStarRatingNotification',
                PropertyName: 'StarRatingNotificationStarRatingNotification'
            },
    };
}

export class SuggestedCompositeIndexesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'SuggestedCompositeIndexes.';

    constructor() {
        this.ItemDetail.ItemId=2764;
        this.ItemDetail.ItemName='SuggestedCompositeIndexes';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CREATECommented : string = this.i + 'CREATE_Commented';
    DROPCommented : string = this.i + 'DROP_Commented';

    Relations = {
    };
}

export class SuggestedForeignKeyIndexesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'SuggestedForeignKeyIndexes.';

    constructor() {
        this.ItemDetail.ItemId=2763;
        this.ItemDetail.ItemName='SuggestedForeignKeyIndexes';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CREATECommented : string = this.i + 'CREATE_Commented';
    DROPCommented : string = this.i + 'DROP_Commented';
    ExistingFKConstraint : string = this.i + 'Existing FK Constraint';
    ONFK : string = this.i + 'ON FK';
    REFERENCINGPK : string = this.i + 'REFERENCING PK';
    SuggestedIndex : string = this.i + 'Suggested Index';
    CREATE : string = this.i + 'CREATE';
    DROP : string = this.i + 'DROP';

    Relations = {
    };
}

export class TeamAssignmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TeamAssignment.';

    constructor() {
        this.ItemDetail.ItemId=3418;
        this.ItemDetail.ItemName='TeamAssignment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TeamAssignmentId : string = this.i + 'TeamAssignmentId';
    KickoffId : string = this.i + 'KickoffId';
    WachterTeamId : string = this.i + 'WachterTeamId';
    HybridKey : string = this.i + 'HybridKey';

    Relations = {
            /** Relation: Kickoff */
            ProjectsKickoff : {
                RelationName: 'projects_Kickoff|TeamAssignment|KickoffId',
                FieldPrefix: 'ProjectsKickoff',
                PropertyName: 'ProjectsKickoff'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|TeamAssignment|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
    };
}

export class TeamYearNumbersMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TeamYearNumbers.';

    constructor() {
        this.ItemDetail.ItemId=2627;
        this.ItemDetail.ItemName='TeamYearNumbers';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosTeamId : string = this.i + 'EthosTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedRevenue : string = this.i + 'CommittedRevenue';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ForecastedRevenue : string = this.i + 'ForecastedRevenue';
    ManagementRevenue : string = this.i + 'ManagementRevenue';
    CommittedGPM : string = this.i + 'CommittedGPM';
    CommittedNPM : string = this.i + 'CommittedNPM';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    ProjectedNPM : string = this.i + 'ProjectedNPM';
    ForecastedGPM : string = this.i + 'ForecastedGPM';
    ForecastedNPM : string = this.i + 'ForecastedNPM';
    ManagementGPM : string = this.i + 'ManagementGPM';
    ManagementNPM : string = this.i + 'ManagementNPM';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    AccountingRevenue : string = this.i + 'AccountingRevenue';
    AccountingGPM : string = this.i + 'AccountingGPM';
    AccountingNPM : string = this.i + 'AccountingNPM';
    CommittedNetProfit : string = this.i + 'CommittedNetProfit';
    ProjectedNetProfit : string = this.i + 'ProjectedNetProfit';
    ForecastedNetProfit : string = this.i + 'ForecastedNetProfit';
    AccountingNetProfit : string = this.i + 'AccountingNetProfit';
    ManagementNetProfit : string = this.i + 'ManagementNetProfit';

    Relations = {
            /** Relation: Wachter Team - Ethos Team */
            EthosWachterTeamByEthosTeamId : {
                RelationName: 'TeamYearNumbers_WachterTeam_WachterTeamId',
                FieldPrefix: 'EthosTeamIdEthosWachterTeam',
                PropertyName: 'EthosTeamIdEthosWachterTeam'
            },
    };
}

export class TemplateMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Template.';

    constructor() {
        this.ItemDetail.ItemId=2354;
        this.ItemDetail.ItemName='Template';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TemplateId : string = this.i + 'TemplateId';
    Name : string = this.i + 'Name';
    SettingsJson : string = this.i + 'SettingsJson';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Template|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Template|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
    };
}

export class TermResignMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TermResign.';

    constructor() {
        this.ItemDetail.ItemId=2470;
        this.ItemDetail.ItemName='TermResign';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TermResignId : string = this.i + 'TermResignId';
    LastDayOfEmployment : string = this.i + 'LastDayOfEmployment';
    EligibleForRehire : string = this.i + 'EligibleForRehire';
    Comments : string = this.i + 'Comments';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    ReasonForLeavingCv : string = this.i + 'ReasonForLeavingCv';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ResendEmail : string = this.i + 'ResendEmail';

    Relations = {
            /** Relation: Trust Code Value - Reason For Leaving */
            CodeValueByReasonForLeavingCv : {
                RelationName: 'CodeValue|TermResign|ReasonForLeavingCv',
                FieldPrefix: 'ReasonForLeavingCvCodeValue',
                PropertyName: 'ReasonForLeavingCvCodeValue'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|TermResign|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|TermResign|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|TermResign|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
    };
}

export class TerritoryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Territory.';

    constructor() {
        this.ItemDetail.ItemId=2369;
        this.ItemDetail.ItemName='Territory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Description : string = this.i + 'Description';
    Meaning : string = this.i + 'Meaning';
    ColorHex : string = this.i + 'ColorHex';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Territory|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Territory|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Territory|roEthos_User|TerritoryId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Territory State Province */
            TerritoryStateProvince : {
                RelationName: 'Territory|TerritoryStateProvince|TerritoryId',
                FieldPrefix: 'TerritoryStateProvince',
                PropertyName: 'TerritoryStateProvince'
            },
            /** Relation: User Extended */
            UserExtended : {
                RelationName: 'Territory|UserExtended|TerritoryId',
                FieldPrefix: 'UserExtended',
                PropertyName: 'UserExtended'
            },
    };
}

export class TerritoryStateProvinceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TerritoryStateProvince.';

    constructor() {
        this.ItemDetail.ItemId=2368;
        this.ItemDetail.ItemName='TerritoryStateProvince';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TerritoryStateProvinceId : string = this.i + 'TerritoryStateProvinceId';
    TerritoryId : string = this.i + 'TerritoryId';
    EthosStateProvinceId : string = this.i + 'Ethos_StateProvinceId';

    Relations = {
            /** Relation: State Province - State Province */
            EthosStateProvinceByEthosStateProvinceId : {
                RelationName: 'Ethos_StateProvince|TerritoryStateProvince|Ethos_StateProvinceId',
                FieldPrefix: 'EthosEthosStateProvince',
                PropertyName: 'EthosEthosStateProvince'
            },
            /** Relation: Territory */
            Territory : {
                RelationName: 'Territory|TerritoryStateProvince|TerritoryId',
                FieldPrefix: 'Territory',
                PropertyName: 'Territory'
            },
    };
}

export class TimerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Timer.';

    constructor() {
        this.ItemDetail.ItemId=2771;
        this.ItemDetail.ItemName='Timer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerId : string = this.i + 'TimerId';
    TimerStatusId : string = this.i + 'TimerStatusId';
    TimerTypeId : string = this.i + 'TimerTypeId';
    EthosJobId : string = this.i + 'Ethos_JobId';
    TechEthosUserId : string = this.i + 'TechEthos_UserId';
    StartDateTime : string = this.i + 'StartDateTime';
    DueDateTime : string = this.i + 'DueDateTime';
    TimerMinutes : string = this.i + 'TimerMinutes';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    EthosJobSiteId : string = this.i + 'Ethos_JobSiteId';
    Notes : string = this.i + 'Notes';

    Relations = {
            /** Relation: Ethos Job - WJID */
            EthosJobByEthosJobId : {
                RelationName: 'Ethos_Job|Timer|Ethos_JobId',
                FieldPrefix: 'EthosEthosJob',
                PropertyName: 'EthosEthosJob'
            },
            /** Relation: Ethos Job Site - Job Site */
            EthosJobSiteByEthosJobSiteId : {
                RelationName: 'Ethos_JobSite|Timer|Ethos_JobSiteId',
                FieldPrefix: 'EthosEthosJobSite',
                PropertyName: 'EthosEthosJobSite'
            },
            /** Relation: Timer Status */
            TimerStatus : {
                RelationName: 'TimerStatus|Timer|TimerStatusId',
                FieldPrefix: 'TimerStatus',
                PropertyName: 'TimerStatus'
            },
            /** Relation: Timer Type */
            TimerType : {
                RelationName: 'TimerType|Timer|TimerTypeId',
                FieldPrefix: 'TimerType',
                PropertyName: 'TimerType'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Timer|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Timer|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Resource */
            EthosUserByTechEthosUserId : {
                RelationName: 'Ethos_User|Timer|TechEthos_UserId',
                FieldPrefix: 'TechEthosEthosUser',
                PropertyName: 'TechEthosEthosUser'
            },
            /** Relation: Ro User Skill List - Resource */
            RoUserSkillListByTechEthosUserId : {
                RelationName: 'RoUserSkillList|Timer|TechEthos_UserId',
                FieldPrefix: 'TechEthosRoUserSkillList',
                PropertyName: 'TechEthosRoUserSkillList'
            },
    };
}

export class TimerSkillMapMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerSkillMap.';

    constructor() {
        this.ItemDetail.ItemId=2775;
        this.ItemDetail.ItemName='TimerSkillMap';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerSkillMapId : string = this.i + 'TimerSkillMapId';
    EthosSkillCv : string = this.i + 'EthosSkillCv';

    Relations = {
            /** Relation: Ethos Code Value - Ethos Skill */
            EthosCodeValueByEthosSkillCv : {
                RelationName: 'Ethos_CodeValue|TimerSkillMap|EthosSkillCv',
                FieldPrefix: 'EthosSkillCvEthosCodeValue',
                PropertyName: 'EthosSkillCvEthosCodeValue'
            },
    };
}

export class TimerStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerStatus.';

    constructor() {
        this.ItemDetail.ItemId=2773;
        this.ItemDetail.ItemName='TimerStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerStatusId : string = this.i + 'TimerStatusId';
    TimerStatus : string = this.i + 'TimerStatus';
    SortOrder : string = this.i + 'SortOrder';

    Relations = {
            /** Relation: Timer */
            Timer : {
                RelationName: 'TimerStatus|Timer|TimerStatusId',
                FieldPrefix: 'Timer',
                PropertyName: 'Timer'
            },
    };
}

export class TimerTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerType.';

    constructor() {
        this.ItemDetail.ItemId=2772;
        this.ItemDetail.ItemName='TimerType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerTypeId : string = this.i + 'TimerTypeId';
    TimerType : string = this.i + 'TimerType';
    IsAscendingTimer : string = this.i + 'IsAscendingTimer';

    Relations = {
            /** Relation: Timer */
            Timer : {
                RelationName: 'TimerType|Timer|TimerTypeId',
                FieldPrefix: 'Timer',
                PropertyName: 'Timer'
            },
    };
}

export class TmpRoAllSupervisorsSubordinatesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'tmpRoAllSupervisorsSubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2758;
        this.ItemDetail.ItemName='tmpRoAllSupervisorsSubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    Depth : string = this.i + 'Depth';

    Relations = {
    };
}

export class TmpSysdiamgrasBackup20230417MetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'tmpSysdiamgrasBackup_2023_04_17.';

    constructor() {
        this.ItemDetail.ItemId=2760;
        this.ItemDetail.ItemName='tmpSysdiamgrasBackup_2023_04_17';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Name : string = this.i + 'name';
    PrincipalId : string = this.i + 'principal_id';
    DiagramId : string = this.i + 'diagram_id';
    Version : string = this.i + 'version';

    Relations = {
    };
}

export class TravelerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Traveler.';

    constructor() {
        this.ItemDetail.ItemId=2555;
        this.ItemDetail.ItemName='Traveler';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TravelerId : string = this.i + 'TravelerId';
    RequestId : string = this.i + 'RequestId';
    TravelerEthosUserId : string = this.i + 'TravelerEthos_UserId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';

    Relations = {
            /** Relation: Request */
            TravelRequest : {
                RelationName: 'travel_Request|Traveler|RequestId',
                FieldPrefix: 'TravelRequest',
                PropertyName: 'TravelRequest'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Traveler|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Traveler Ethos User */
            EthosUserByTravelerEthosUserId : {
                RelationName: 'Ethos_User|Traveler|TravelerEthos_UserId',
                FieldPrefix: 'TravelerEthosEthosUser',
                PropertyName: 'TravelerEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Traveler|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class TrustSyncLogMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TrustSyncLog.';

    constructor() {
        this.ItemDetail.ItemId=2759;
        this.ItemDetail.ItemName='TrustSyncLog';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TrustSyncLogId : string = this.i + 'TrustSyncLogId';
    InsertOnly : string = this.i + 'InsertOnly';
    StartDateTime : string = this.i + 'StartDateTime';
    EndDateTime : string = this.i + 'EndDateTime';
    TotalElapsed : string = this.i + 'Total_Elapsed';
    NoDependencies : string = this.i + 'No_Dependencies';
    RequiresCodeSet : string = this.i + 'Requires_CodeSet';
    EthosUser : string = this.i + 'Ethos_User';
    EthosUserSkill : string = this.i + 'Ethos_UserSkill';
    EthosStateProvince : string = this.i + 'Ethos_StateProvince';
    EthosAddress : string = this.i + 'Ethos_Address';
    EthosStaffingAgency : string = this.i + 'Ethos_StaffingAgency';
    EthosSite : string = this.i + 'Ethos_Site';
    EthosCounty : string = this.i + 'Ethos_County';
    EthosOpportunity : string = this.i + 'Ethos_Opportunity';
    EthosJobNumber : string = this.i + 'Ethos_JobNumber';
    EthosJob : string = this.i + 'Ethos_Job';
    EthosJobSite : string = this.i + 'Ethos_JobSite';
    EthosJobSow : string = this.i + 'Ethos_JobSow';
    EthosJobNumberForecast : string = this.i + 'Ethos_JobNumberForecast';
    EthosJobNumberPhase : string = this.i + 'Ethos_JobNumberPhase';
    EthosWachterDepartment : string = this.i + 'Ethos_WachterDepartment';
    EthosWachterTeam : string = this.i + 'Ethos_WachterTeam';
    RoAllSupervisorsSubordinates : string = this.i + 'RoAllSupervisorsSubordinates';
    RoEthosUser : string = this.i + 'RoEthos_User';
    EthosJobNumberPriority : string = this.i + 'Ethos_JobNumberPriority';
    RoUserLaborSummary : string = this.i + 'RoUserLaborSummary';
    JobNumberMembership : string = this.i + 'JobNumberMembership';

    Relations = {
    };
}

export class TrustUserMergedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TrustUserMerged.';

    constructor() {
        this.ItemDetail.ItemId=2595;
        this.ItemDetail.ItemName='TrustUserMerged';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TrustUserMergedId : string = this.i + 'TrustUserMergedId';
    NewUserId : string = this.i + 'New_UserId';
    OldUserId : string = this.i + 'Old_UserId';

    Relations = {
            /** Relation: Ethos User - New User */
            EthosUserByNewUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|New_UserId',
                FieldPrefix: 'NewEthosUser',
                PropertyName: 'NewEthosUser'
            },
            /** Relation: Ethos User - Old User */
            EthosUserByOldUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|Old_UserId',
                FieldPrefix: 'OldEthosUser',
                PropertyName: 'OldEthosUser'
            },
    };
}

export class UserExtendedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserExtended.';

    constructor() {
        this.ItemDetail.ItemId=2361;
        this.ItemDetail.ItemName='UserExtended';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserExtendedId : string = this.i + 'UserExtendedId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FosEthosUserId : string = this.i + 'FosEthos_UserId';
    TerritoryId : string = this.i + 'TerritoryId';
    TechTypeCv : string = this.i + 'TechTypeCv';
    StartingPayRate : string = this.i + 'StartingPayRate';
    OrientationDate : string = this.i + 'OrientationDate';
    PermDate : string = this.i + 'PermDate';
    Comments : string = this.i + 'Comments';
    SpOsgAttachmentId : string = this.i + 'spOsgAttachmentId';
    IsPersonalVehicleUseAllowed : string = this.i + 'IsPersonalVehicleUseAllowed';
    PersonalVehicleUseExpirationDate : string = this.i + 'PersonalVehicleUseExpirationDate';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    PayChangeDate : string = this.i + 'PayChangeDate';

    Relations = {
            /** Relation: Territory */
            Territory : {
                RelationName: 'Territory|UserExtended|TerritoryId',
                FieldPrefix: 'Territory',
                PropertyName: 'Territory'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class MtlUserExtendedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'mtl_UserExtended.';

    constructor() {
        this.ItemDetail.ItemId=2549;
        this.ItemDetail.ItemName='mtl_UserExtended';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserExtendedId : string = this.i + 'UserExtendedId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FosEthosUserId : string = this.i + 'FosEthos_UserId';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    TerritoryId : string = this.i + 'TerritoryId';
    TechTypeCv : string = this.i + 'TechTypeCv';
    CurrentPayRate : string = this.i + 'CurrentPayRate';
    PayChangeDate : string = this.i + 'PayChangeDate';
    OrientationDate : string = this.i + 'OrientationDate';
    PermDate : string = this.i + 'PermDate';
    Comments : string = this.i + 'Comments';
    SpOsgAttachmentId : string = this.i + 'spOsgAttachmentId';
    IsPersonalVehicleUseAllowed : string = this.i + 'IsPersonalVehicleUseAllowed';
    PersonalVehicleUseExpirationDate : string = this.i + 'PersonalVehicleUseExpirationDate';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Attachment - Sp Osg Attachment */
            AttachmentByspOsgAttachmentId : {
                RelationName: 'Attachment|mtl_UserExtended|spOsgAttachmentId',
                FieldPrefix: 'SpOsgAttachmentAttachment',
                PropertyName: 'SpOsgAttachmentAttachment'
            },
            /** Relation: Trust Code Value - Tech Type */
            CodeValueByTechTypeCv : {
                RelationName: 'CodeValue|mtl_UserExtended|TechTypeCv',
                FieldPrefix: 'TechTypeCvCodeValue',
                PropertyName: 'TechTypeCvCodeValue'
            },
            /** Relation: Ro Ethos User - Ethos User */
            RoEthosUserByEthosUserId : {
                RelationName: 'roEthos_User|mtl_UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosRoEthosUser',
                PropertyName: 'EthosRoEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Ethos User - Fos Ethos User */
            EthosUserByFosEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|FosEthos_UserId',
                FieldPrefix: 'FosEthosEthosUser',
                PropertyName: 'FosEthosEthosUser'
            },
            /** Relation: Ethos User - Hiring Manager Ethos User */
            EthosUserByHiringManagerEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|HiringManagerEthos_UserId',
                FieldPrefix: 'HiringManagerEthosEthosUser',
                PropertyName: 'HiringManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|mtl_UserExtended|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
    };
}

export class EmsUserExtendedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ems_UserExtended.';

    constructor() {
        this.ItemDetail.ItemId=2570;
        this.ItemDetail.ItemName='ems_UserExtended';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserExtendedId : string = this.i + 'UserExtendedId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    OperationsManagerEthosUserId : string = this.i + 'OperationsManagerEthos_UserId';
    FosOfficeSupervisorEthosUserId : string = this.i + 'FosOfficeSupervisorEthos_UserId';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    CareerHistory : string = this.i + 'CareerHistory';
    EmergencyContactInformation : string = this.i + 'EmergencyContactInformation';
    TempStartDate : string = this.i + 'TempStartDate';
    OrientationDate : string = this.i + 'OrientationDate';
    LastEvalDate : string = this.i + 'LastEvalDate';
    NextEvalDate : string = this.i + 'NextEvalDate';
    Skills : string = this.i + 'Skills';
    WorkStatusCv : string = this.i + 'WorkStatusCv';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';
    AttachmentId : string = this.i + 'AttachmentId';
    PreviousManager : string = this.i + 'PreviousManager';
    EmployeeWorkType : string = this.i + 'EmployeeWorkType';
    EmergencyContactPhone : string = this.i + 'EmergencyContactPhone';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|ems_UserExtended|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Trust Code Value - Work Status */
            CodeValueByWorkStatusCv : {
                RelationName: 'CodeValue|ems_UserExtended|WorkStatusCv',
                FieldPrefix: 'WorkStatusCvCodeValue',
                PropertyName: 'WorkStatusCvCodeValue'
            },
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummaryByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|UserExtended|EmployeeId',
                FieldPrefix: 'ProofOfInsuranceSummaryEmployeeEthosUserId',
                PropertyName: 'ProofOfInsuranceSummaryEmployeeEthosUserId'
            },
            /** Relation: Ro All Supervisors Subordinates - Employee */
            RoAllSupervisorsSubordinatesByEmployeeEthosUserId : {
                RelationName: 'RoAllSupervisorsSubordinates|ems_UserExtended|Ethos_UserId',
                FieldPrefix: 'EmployeeEthosRoAllSupervisorsSubordinates',
                PropertyName: 'EmployeeEthosRoAllSupervisorsSubordinates'
            },
            /** Relation: Performance Metrics - Employee */
            PerformanceMetricsByEmployeeEthosUserId : {
                RelationName: 'UserExtended|PerformanceMetrics|UserId',
                FieldPrefix: 'EmployeeEthosPerformanceMetrics',
                PropertyName: 'EmployeeEthosPerformanceMetrics'
            },
            /** Relation: Ethos User - FOS / Office Supervisor */
            EthosUserByFosOfficeSupervisorEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|FosOfficeSupervisorEthos_UserId',
                FieldPrefix: 'FosOfficeSupervisorEthosEthosUser',
                PropertyName: 'FosOfficeSupervisorEthosEthosUser'
            },
            /** Relation: Ethos User - Hiring Manager Ethos User */
            EthosUserByHiringManagerEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|HiringManagerEthos_UserId',
                FieldPrefix: 'HiringManagerEthosEthosUser',
                PropertyName: 'HiringManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Operations Manager */
            EthosUserByOperationsManagerEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|OperationsManagerEthos_UserId',
                FieldPrefix: 'OperationsManagerEthosEthosUser',
                PropertyName: 'OperationsManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Previous Manager */
            EthosUserByPreviousManager : {
                RelationName: 'Ethos_User|ems_UserExtended|PreviousManager',
                FieldPrefix: 'PreviousManagerEthosUser',
                PropertyName: 'PreviousManagerEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'Ethos_User|ems_UserExtended|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
            /** Relation: D W People Pay Summary - Employee - Many */
            DWPeoplePaySummaryByETHOSUserId : {
                RelationName: 'dw_PeoplePaySummary|EmsUserExtended|Ethos_UserId',
                FieldPrefix: 'ETHOSUserIdDWPeoplePaySummary',
                PropertyName: 'ETHOSUserIdDWPeoplePaySummary'
            },
            /** Relation: Employee Review Summary - Employee - Many */
            EmployeeReviewSummaryByEmployeeEthosUserId : {
                RelationName: 'EmployeeReviewSummary|UserExtended|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosUserIdEmployeeReviewSummary',
                PropertyName: 'EmployeeEthosUserIdEmployeeReviewSummary'
            },
            /** Relation: People Pay History Current Previous Initial - Employee - Many */
            PeoplePayHistoryCurrentPreviousInitialByETHOSUserId : {
                RelationName: 'UserExtended|PeoplePayHistoryCurrentPreviousInitial|EthosUserId',
                FieldPrefix: 'ETHOSUserIdPeoplePayHistoryCurrentPreviousInitial',
                PropertyName: 'ETHOSUserIdPeoplePayHistoryCurrentPreviousInitial'
            },
            /** Relation: People Pay History Current Previous Initial V2 - Employee - Many */
            PeoplePayHistoryCurrentPreviousInitialV2ByETHOSUserId : {
                RelationName: 'EMS People Pay Historwy',
                FieldPrefix: 'ETHOSUserIdPeoplePayHistoryCurrentPreviousInitialV2',
                PropertyName: 'ETHOSUserIdPeoplePayHistoryCurrentPreviousInitialV2'
            },
            /** Relation: Ro Ethos User - Employee - Many */
            RoEthosUserByUserId : {
                RelationName: 'EmsUserExtended|roEthos_User|EmployeeEthos_UserId',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
            /** Relation: Ro Ethos User Grid - Employee - Many */
            RoEthosUserGridByEmployeeUserId : {
                RelationName: 'UserExtended|roEthos_UserGrid|EmployeeUserId',
                FieldPrefix: 'EmployeeUserIdRoEthosUserGrid',
                PropertyName: 'EmployeeUserIdRoEthosUserGrid'
            },
            /** Relation: Ro Licenses - Employee - Many */
            RoLicensesByIssuedTo : {
                RelationName: 'EmsUserExtended|roLicenses|EmployeeEthos_UserId',
                FieldPrefix: 'IssuedToRoLicenses',
                PropertyName: 'IssuedToRoLicenses'
            },
            /** Relation: User Extended Ethos Customer */
            UserExtendedEthosCustomer : {
                RelationName: 'UserExtended|UserExtendedEthos_Customer|UserExtendedId',
                FieldPrefix: 'UserExtendedEthosCustomer',
                PropertyName: 'UserExtendedEthosCustomer'
            },
    };
}

export class UserExtendedEthosCustomerMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserExtendedEthos_Customer.';

    constructor() {
        this.ItemDetail.ItemId=2588;
        this.ItemDetail.ItemName='UserExtendedEthos_Customer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserExtendedEthosCustomer : string = this.i + 'UserExtendedEthos_Customer';
    UserExtendedId : string = this.i + 'UserExtendedId';
    CustomerId : string = this.i + 'CustomerId';

    Relations = {
            /** Relation: Customer */
            EthosCustomer : {
                RelationName: 'Ethos_Customer|UserExtendedEthos_Customer|CustomerId',
                FieldPrefix: 'EthosCustomer',
                PropertyName: 'EthosCustomer'
            },
            /** Relation: User Extended */
            EmsUserExtended : {
                RelationName: 'UserExtended|UserExtendedEthos_Customer|UserExtendedId',
                FieldPrefix: 'EmsUserExtended',
                PropertyName: 'EmsUserExtended'
            },
    };
}

export class WcUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wc_UserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2513;
        this.ItemDetail.ItemName='wc_UserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    GrossProfit : string = this.i + 'GrossProfit';
    GrossProfitMargin : string = this.i + 'GrossProfitMargin';

    Relations = {
            /** Relation: Ro Ethos User - Ethos User */
            RoEthosUserByEthosUserId : {
                RelationName: 'roEthos_User|wc_UserProjection|UserId',
                FieldPrefix: 'EthosRoEthosUser',
                PropertyName: 'EthosRoEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Team - Ethos Wachter Team */
            EthosWachterTeamByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|wc_UserProjection|Ethos_WachterTeamId',
                FieldPrefix: 'EthosEthosWachterTeam',
                PropertyName: 'EthosEthosWachterTeam'
            },
    };
}

export class UserReadMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserRead.';

    constructor() {
        this.ItemDetail.ItemId=2496;
        this.ItemDetail.ItemName='UserRead';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserReadId : string = this.i + 'UserReadId';
    MemoOfRecordId : string = this.i + 'MemoOfRecordId';
    EthosUserId : string = this.i + 'Ethos_UserId';

    Relations = {
            /** Relation: Memo Of Record */
            MemoOfRecord : {
                RelationName: 'MemoOfRecord|UserRead|MemoOfRecordId',
                FieldPrefix: 'MemoOfRecord',
                PropertyName: 'MemoOfRecord'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|UserRead|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class WcUserReadMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wc_UserRead.';

    constructor() {
        this.ItemDetail.ItemId=2505;
        this.ItemDetail.ItemName='wc_UserRead';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserReadId : string = this.i + 'UserReadId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeTrainingNeededId : string = this.i + 'EmployeeTrainingNeededId';

    Relations = {
            /** Relation: Employee Training Needed */
            EmployeeTrainingNeeded : {
                RelationName: 'EmployeeTrainingNeeded|UserRead|EmployeeTrainingNeededId',
                FieldPrefix: 'EmployeeTrainingNeeded',
                PropertyName: 'EmployeeTrainingNeeded'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserRead|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class UserTeamLookupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserTeamLookup.';

    constructor() {
        this.ItemDetail.ItemId=2626;
        this.ItemDetail.ItemName='UserTeamLookup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    TeamId : string = this.i + 'TeamId';
    FiscalYear : string = this.i + 'FiscalYear';

    Relations = {
            /** Relation: Wachter Team - Team */
            EthosWachterTeamByTeamId : {
                RelationName: 'Ethos_WachterTeam|UserTeamLookup|TeamId',
                FieldPrefix: 'TeamIdEthosWachterTeam',
                PropertyName: 'TeamIdEthosWachterTeam'
            },
    };
}

export class UserYearNumbersMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserYearNumbers.';

    constructor() {
        this.ItemDetail.ItemId=2625;
        this.ItemDetail.ItemName='UserYearNumbers';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedRevenue : string = this.i + 'CommittedRevenue';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ForecastedRevenue : string = this.i + 'ForecastedRevenue';
    ManagementRevenue : string = this.i + 'ManagementRevenue';
    CommittedGPM : string = this.i + 'CommittedGPM';
    CommittedNPM : string = this.i + 'CommittedNPM';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    ProjectedNPM : string = this.i + 'ProjectedNPM';
    ForecastedGPM : string = this.i + 'ForecastedGPM';
    ForecastedNPM : string = this.i + 'ForecastedNPM';
    ManagementGPM : string = this.i + 'ManagementGPM';
    ManagementNPM : string = this.i + 'ManagementNPM';
    EthosUserId : string = this.i + 'Ethos_UserId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    AccountingRevenue : string = this.i + 'AccountingRevenue';
    AccountingGPM : string = this.i + 'AccountingGPM';
    AccountingNPM : string = this.i + 'AccountingNPM';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CommittedNetProfit : string = this.i + 'CommittedNetProfit';
    ProjectedNetProfit : string = this.i + 'ProjectedNetProfit';
    ForecastedNetProfit : string = this.i + 'ForecastedNetProfit';
    AccountingNetProfit : string = this.i + 'AccountingNetProfit';
    ManagementNetProfit : string = this.i + 'ManagementNetProfit';

    Relations = {
            /** Relation: Ro Ethos User - Ethos User */
            RoEthosUserByEthosUserId : {
                RelationName: 'UserYearNumbers_EthosUser',
                FieldPrefix: 'EthosRoEthosUser',
                PropertyName: 'EthosRoEthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|UserYearNumbers|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
    };
}

export class VehicleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Vehicle.';

    constructor() {
        this.ItemDetail.ItemId=2512;
        this.ItemDetail.ItemName='Vehicle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleId : string = this.i + 'VehicleId';
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    Year : string = this.i + 'Year';
    Make : string = this.i + 'Make';
    Model : string = this.i + 'Model';
    LicensePlateNumber : string = this.i + 'LicensePlateNumber';
    LicensePlateState : string = this.i + 'LicensePlateState';
    DriverName : string = this.i + 'DriverName';
    DriverLicenseNumber : string = this.i + 'DriverLicenseNumber';
    DriverLicenseState : string = this.i + 'DriverLicenseState';
    DriverPhoneNumber : string = this.i + 'DriverPhoneNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    InsuranceCompany : string = this.i + 'InsuranceCompany';
    PolicyNumber : string = this.i + 'PolicyNumber';
    DescriptionOfDamage : string = this.i + 'DescriptionOfDamage';
    PassengerName : string = this.i + 'PassengerName';
    PassengerAddress : string = this.i + 'PassengerAddress';
    PassengerPhone : string = this.i + 'PassengerPhone';
    VIN : string = this.i + 'VIN';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    UnitNumber : string = this.i + 'UnitNumber';
    RentalCompanyName : string = this.i + 'RentalCompanyName';

    Relations = {
            /** Relation: State Province - License Plate State */
            EthosStateProvinceByLicensePlateState : {
                RelationName: 'Ethos_StateProvince|Vehicle|LicensePlateState',
                FieldPrefix: 'LicensePlateStateEthosStateProvince',
                PropertyName: 'LicensePlateStateEthosStateProvince'
            },
            /** Relation: State Province - Driver License State */
            EthosStateProvinceByDriverLicenseState : {
                RelationName: 'Ethos_StateProvince|Vehicle|DriverLicenseState',
                FieldPrefix: 'DriverLicenseStateEthosStateProvince',
                PropertyName: 'DriverLicenseStateEthosStateProvince'
            },
            /** Relation: State Province - Driver State */
            EthosStateProvinceByDriverState : {
                RelationName: 'Ethos_StateProvince|Vehicle|DriverState',
                FieldPrefix: 'DriverStateEthosStateProvince',
                PropertyName: 'DriverStateEthosStateProvince'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Vehicle Accident */
            VehicleAccident : {
                RelationName: 'VehicleAccident|Vehicle|VehicleAccidentId',
                FieldPrefix: 'VehicleAccident',
                PropertyName: 'VehicleAccident'
            },
            /** Relation: Ro Vehicle */
            RoVehicle : {
                RelationName: 'Vehicle|roVehicle|VehicleId',
                FieldPrefix: 'RoVehicle',
                PropertyName: 'RoVehicle'
            },
    };
}

export class FleetVehicleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'fleet_Vehicle.';

    constructor() {
        this.ItemDetail.ItemId=3431;
        this.ItemDetail.ItemName='fleet_Vehicle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleId : string = this.i + 'VehicleId';
    VehicleStatusCv : string = this.i + 'VehicleStatusCv';
    UnitId : string = this.i + 'UnitId';
    JobNumberId : string = this.i + 'JobNumberId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    VehicleTypeCv : string = this.i + 'VehicleTypeCv';
    Year : string = this.i + 'Year';
    Make : string = this.i + 'Make';
    Model : string = this.i + 'Model';
    VIN : string = this.i + 'VIN';
    OwnershipTypeCv : string = this.i + 'OwnershipTypeCv';
    GVWR : string = this.i + 'GVWR';
    DriveTrainCv : string = this.i + 'DriveTrainCv';
    FuelTypeCv : string = this.i + 'FuelTypeCv';
    InsuranceExpirationDate : string = this.i + 'InsuranceExpirationDate';
    LicensePlate : string = this.i + 'LicensePlate';
    PlateExpirationDate : string = this.i + 'PlateExpirationDate';
    RegistrationStateProvinceId : string = this.i + 'RegistrationStateProvinceId';
    AnnualInspectionExpirationDate : string = this.i + 'AnnualInspectionExpirationDate';
    DielectricInspectionExpirationDate : string = this.i + 'DielectricInspectionExpirationDate';
    IsDot : string = this.i + 'IsDot';
    DotInspectionDate : string = this.i + 'DotInspectionDate';
    HasGps : string = this.i + 'HasGps';
    GpsId : string = this.i + 'GpsId';
    FuelCardId : string = this.i + 'FuelCardId';
    DriverAlertId : string = this.i + 'DriverAlertId';
    PafEffectiveDate : string = this.i + 'PafEffectiveDate';
    IsEmployee : string = this.i + 'IsEmployee';
    DriverUserId : string = this.i + 'DriverUserId';
    RawDriverName : string = this.i + 'RawDriverName';
    SendPaf : string = this.i + 'SendPaf';
    PafNotes : string = this.i + 'PafNotes';
    TransponderSerialNumber : string = this.i + 'TransponderSerialNumber';
    PurchasePrice : string = this.i + 'PurchasePrice';
    PurchaseDate : string = this.i + 'PurchaseDate';
    NoteParentId : string = this.i + 'NoteParentId';
    MediaGroupId : string = this.i + 'MediaGroupId';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointId : string = this.i + 'SharepointId';
    PassAccountName : string = this.i + 'PassAccountName';
    PassAccountNumber : string = this.i + 'PassAccountNumber';
    PassActivationDate : string = this.i + 'PassActivationDate';
    Phase : string = this.i + 'Phase';
    SpJobNumber : string = this.i + 'SpJobNumber';

    Relations = {
            /** Relation: Trust Code Value - Status */
            CodeValueByVehicleStatusCv : {
                RelationName: 'CodeValue|fleet_Vehicle|VehicleStatusCv',
                FieldPrefix: 'VehicleStatusCvCodeValue',
                PropertyName: 'VehicleStatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Vehicle Type */
            CodeValueByVehicleTypeCv : {
                RelationName: 'CodeValue|fleet_Vehicle|VehicleTypeCv',
                FieldPrefix: 'VehicleTypeCvCodeValue',
                PropertyName: 'VehicleTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Ownership Type */
            CodeValueByOwnershipTypeCv : {
                RelationName: 'CodeValue|fleet_Vehicle|OwnershipTypeCv',
                FieldPrefix: 'OwnershipTypeCvCodeValue',
                PropertyName: 'OwnershipTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Drive Train */
            CodeValueByDriveTrainCv : {
                RelationName: 'CodeValue|fleet_Vehicle|DriveTrainCv',
                FieldPrefix: 'DriveTrainCvCodeValue',
                PropertyName: 'DriveTrainCvCodeValue'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|fleet_Vehicle|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|fleet_Vehicle|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: State Province - Registration State */
            EthosStateProvinceByRegistrationStateProvinceId : {
                RelationName: 'Ethos_StateProvince|fleet_Vehicle|RegistrationStateProvinceId',
                FieldPrefix: 'RegistrationEthosStateProvince',
                PropertyName: 'RegistrationEthosStateProvince'
            },
            /** Relation: Ethos User - Driver User */
            EthosUserByDriverUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|DriverUserId',
                FieldPrefix: 'DriverEthosUser',
                PropertyName: 'DriverEthosUser'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|fleet_Vehicle|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|fleet_Vehicle|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Auction */
            Auction : {
                RelationName: 'fleet_Vehicle|Auction|VehicleId',
                FieldPrefix: 'Auction',
                PropertyName: 'Auction'
            },
            /** Relation: Maintenance */
            Maintenance : {
                RelationName: 'fleet_Vehicle|Maintenance|VehicleId',
                FieldPrefix: 'Maintenance',
                PropertyName: 'Maintenance'
            },
            /** Relation: Paf History */
            PafHistory : {
                RelationName: 'fleet_Vehicle|PafHistory|VehicleId',
                FieldPrefix: 'PafHistory',
                PropertyName: 'PafHistory'
            },
            /** Relation: Pass History */
            PassHistory : {
                RelationName: 'fleet_Vehicle|PassHistory|VehicleId',
                FieldPrefix: 'PassHistory',
                PropertyName: 'PassHistory'
            },
            /** Relation: Plate History */
            PlateHistory : {
                RelationName: 'fleet_Vehicle|PlateHistory|VehicleId',
                FieldPrefix: 'PlateHistory',
                PropertyName: 'PlateHistory'
            },
            /** Relation: Ro Maintenance */
            RoMaintenance : {
                RelationName: 'roMaintenance|Vehicle|VehicleId',
                FieldPrefix: 'RoMaintenance',
                PropertyName: 'RoMaintenance'
            },
            /** Relation: Ro Vehicle */
            RoVehicle : {
                RelationName: 'roVehicle|Vehicle|VehicleId OLD',
                FieldPrefix: 'RoVehicle',
                PropertyName: 'RoVehicle'
            },
    };
}

export class VehicleAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'VehicleAccident.';

    constructor() {
        this.ItemDetail.ItemId=2510;
        this.ItemDetail.ItemName='VehicleAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    EmployeeId : string = this.i + 'EmployeeId';
    PhoneNumber : string = this.i + 'PhoneNumber';
    WJID : string = this.i + 'WJID';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    AuthorityContacted : string = this.i + 'AuthorityContacted';
    ReportNumber : string = this.i + 'ReportNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    AccidentAddress : string = this.i + 'AccidentAddress';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentAtFaultCv : string = this.i + 'AccidentAtFaultCv';
    VehicleRepairedCv : string = this.i + 'VehicleRepairedCv';
    Injuries : string = this.i + 'Injuries';
    OOPClaimExpense : string = this.i + 'OOPClaimExpense';
    InsurancePaidPDLTInsuredVehicle : string = this.i + 'InsurancePaidPDLTInsuredVehicle';
    InsurancePaidPDLTClaimantVehicle : string = this.i + 'InsurancePaidPDLTClaimantVehicle';
    OtherVehiclesInvolved : string = this.i + 'OtherVehiclesInvolved';
    IsDot : string = this.i + 'IsDot';
    AccidentDescription : string = this.i + 'AccidentDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    ClaimInsuranceCompanyCv : string = this.i + 'ClaimInsuranceCompanyCv';
    ClaimInsuranceCompanyText : string = this.i + 'ClaimInsuranceCompanyText';
    AdvisorName : string = this.i + 'AdvisorName';
    AdvisorPhone : string = this.i + 'AdvisorPhone';
    ClaimFiledDate : string = this.i + 'ClaimFiledDate';
    ClaimComments : string = this.i + 'ClaimComments';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointMigrationId : string = this.i + 'SharepointMigrationId';
    IsPoliceReportObtained : string = this.i + 'IsPoliceReportObtained';
    ClaimNumberThirdParty : string = this.i + 'ClaimNumberThirdParty';
    MediaGroupId : string = this.i + 'MediaGroupId';
    VehicleValue : string = this.i + 'VehicleValue';
    SettlementExpense : string = this.i + 'SettlementExpense';
    InsuredVehiclePDLT : string = this.i + 'InsuredVehiclePDLT';
    ClaimantVehiclePDLT : string = this.i + 'ClaimantVehiclePDLT';
    InsuredObtainedRentalExpense : string = this.i + 'InsuredObtainedRentalExpense';
    ClaimantObtainedRentalExpense : string = this.i + 'ClaimantObtainedRentalExpense';
    StorageTowingFees : string = this.i + 'StorageTowingFees';
    PoliceReportMiscFees : string = this.i + 'PoliceReportMiscFees';
    ClaimHandlingFee : string = this.i + 'ClaimHandlingFee';
    EstimatedCosts : string = this.i + 'EstimatedCosts';
    Recoveries : string = this.i + 'Recoveries';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|VehicleAccident|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Trust Code Value - Accident At Fault */
            CodeValueByAccidentAtFaultCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentAtFaultCv',
                FieldPrefix: 'AccidentAtFaultCvCodeValue',
                PropertyName: 'AccidentAtFaultCvCodeValue'
            },
            /** Relation: Trust Code Value - Accident Type */
            CodeValueByAccidentTypeCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvCodeValue',
                PropertyName: 'AccidentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Insurance Company */
            CodeValueByClaimInsuranceCompanyCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimInsuranceCompanyCv',
                FieldPrefix: 'ClaimInsuranceCompanyCvCodeValue',
                PropertyName: 'ClaimInsuranceCompanyCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Status */
            CodeValueByClaimStatusCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvCodeValue',
                PropertyName: 'ClaimStatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Vehicle Repaired */
            CodeValueByVehicleRepairedCv : {
                RelationName: 'CodeValue|VehicleAccident|VehicleRepairedCv',
                FieldPrefix: 'VehicleRepairedCvCodeValue',
                PropertyName: 'VehicleRepairedCvCodeValue'
            },
            /** Relation: State Province - Accident State */
            EthosStateProvinceByAccidentState : {
                RelationName: 'Ethos_StateProvince|VehicleAccident|AccidentState',
                FieldPrefix: 'AccidentStateEthosStateProvince',
                PropertyName: 'AccidentStateEthosStateProvince'
            },
            /** Relation: State Province - Driver State */
            EthosStateProvinceByDriverState : {
                RelationName: 'Ethos_StateProvince|VehicleAccident|DriverState',
                FieldPrefix: 'DriverStateEthosStateProvince',
                PropertyName: 'DriverStateEthosStateProvince'
            },
            /** Relation: Ro Ethos User - Employee */
            RoEthosUserByEmployeeId : {
                RelationName: 'VehicleAccident|roEthos_User|UserId',
                FieldPrefix: 'EmployeeIdRoEthosUser',
                PropertyName: 'EmployeeIdRoEthosUser'
            },
            /** Relation: Ro Ethos User - Createdby Ethos User */
            RoEthosUserByCreatedbyEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedbyEthosRoEthosUser',
                PropertyName: 'CreatedbyEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Modified By Ethos User */
            RoEthosUserByModifiedByEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRoEthosUser',
                PropertyName: 'ModifiedByEthosRoEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Vehicle */
            Vehicle : {
                RelationName: 'VehicleAccident|Vehicle|VehicleAccidentId',
                FieldPrefix: 'Vehicle',
                PropertyName: 'Vehicle'
            },
            /** Relation: Witness */
            Witness : {
                RelationName: 'VehicleAccident|Witness|VehicleAccidentId',
                FieldPrefix: 'Witness',
                PropertyName: 'Witness'
            },
    };
}

export class VehicleTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'VehicleType.';

    constructor() {
        this.ItemDetail.ItemId=2675;
        this.ItemDetail.ItemName='VehicleType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleTypeId : string = this.i + 'VehicleTypeId';
    VehicleTypeDisplay : string = this.i + 'VehicleTypeDisplay';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'VehicleType|ProofOfInsurance|VehicleTypeId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

export class WachterContainerStyleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WachterContainerStyle.';

    constructor() {
        this.ItemDetail.ItemId=2660;
        this.ItemDetail.ItemName='WachterContainerStyle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterContainerStyleId : string = this.i + 'WachterContainerStyleId';
    StyleDisplay : string = this.i + 'StyleDisplay';
    StyleKey : string = this.i + 'StyleKey';

    Relations = {
            /** Relation: Employee Review Category */
            EmployeeReviewCategory : {
                RelationName: 'WachterContainerStyle|EmployeeReviewCategory|WachterContainerStyleId',
                FieldPrefix: 'EmployeeReviewCategory',
                PropertyName: 'EmployeeReviewCategory'
            },
    };
}

export class WachterTeamDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WachterTeamDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2485;
        this.ItemDetail.ItemName='WachterTeamDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    DepartmentName : string = this.i + 'DepartmentName';
    DivisionShortName : string = this.i + 'DivisionShortName';

    Relations = {
    };
}

export class WachterTeamOrganizationalUnitMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WachterTeamOrganizationalUnit.';

    constructor() {
        this.ItemDetail.ItemId=2622;
        this.ItemDetail.ItemName='WachterTeamOrganizationalUnit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamOrganizationalUnitId : string = this.i + 'WachterTeamOrganizationalUnitId';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    OrganizationalUnitId : string = this.i + 'OrganizationalUnitId';
    HasRevenue : string = this.i + 'HasRevenue';

    Relations = {
            /** Relation: Wachter Team - Ethos Wachter Team */
            EthosWachterTeamByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|WachterTeamOrganizationalUnit|Ethos_WachterTeamId',
                FieldPrefix: 'EthosEthosWachterTeam',
                PropertyName: 'EthosEthosWachterTeam'
            },
    };
}

export class WageExpenseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WageExpense.';

    constructor() {
        this.ItemDetail.ItemId=3412;
        this.ItemDetail.ItemName='WageExpense';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WageExpenseId : string = this.i + 'WageExpenseId';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Details : string = this.i + 'Details';
    PaidDateTime : string = this.i + 'PaidDateTime';
    Wages : string = this.i + 'Wages';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident|WageExpense|WorkplaceAccidentId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class WAppsRolesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wAppsRoles.';

    constructor() {
        this.ItemDetail.ItemId=2768;
        this.ItemDetail.ItemName='wAppsRoles';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RoleId : string = this.i + 'RoleId';
    RoleDisplay : string = this.i + 'RoleDisplay';
    RoleMeaning : string = this.i + 'RoleMeaning';

    Relations = {
            /** Relation: Ethos Role Map - Role - Many */
            EthosRoleMapBywAppsRoleId : {
                RelationName: 'EthosRoleMap|wAppsRole',
                FieldPrefix: 'WAppsEthosRoleMap',
                PropertyName: 'WAppsEthosRoleMap'
            },
    };
}

export class WitnessMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Witness.';

    constructor() {
        this.ItemDetail.ItemId=2511;
        this.ItemDetail.ItemName='Witness';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WitnessId : string = this.i + 'WitnessId';
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    WitnessName : string = this.i + 'WitnessName';
    WitnessAddress : string = this.i + 'WitnessAddress';
    WitnessPhone : string = this.i + 'WitnessPhone';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Witness|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Witness|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Vehicle Accident */
            VehicleAccident : {
                RelationName: 'VehicleAccident|Witness|VehicleAccidentId',
                FieldPrefix: 'VehicleAccident',
                PropertyName: 'VehicleAccident'
            },
    };
}

export class WorkflowStatusMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WorkflowStatus.';

    constructor() {
        this.ItemDetail.ItemId=2584;
        this.ItemDetail.ItemName='WorkflowStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusId : string = this.i + 'WorkflowStatusId';
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatus : string = this.i + 'WorkflowStatus';
    WorkflowStatusMeaning : string = this.i + 'WorkflowStatusMeaning';
    WorkflowStatusOrder : string = this.i + 'WorkflowStatusOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class WorkflowStatusSetMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WorkflowStatusSet.';

    constructor() {
        this.ItemDetail.ItemId=2582;
        this.ItemDetail.ItemName='WorkflowStatusSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatusSetName : string = this.i + 'WorkflowStatusSetName';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class WorkplaceAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'workplaceAccident.';

    constructor() {
        this.ItemDetail.ItemId=2592;
        this.ItemDetail.ItemName='workplaceAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    IsWachterEmployee : string = this.i + 'IsWachterEmployee';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeName : string = this.i + 'EmployeeName';
    DepartmentId : string = this.i + 'DepartmentId';
    JobNumberId : string = this.i + 'JobNumberId';
    WJID : string = this.i + 'WJID';
    Facility : string = this.i + 'Facility';
    WorksiteTypeCv : string = this.i + 'WorksiteTypeCv';
    PriorToAccidentDescription : string = this.i + 'PriorToAccidentDescription';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDescription : string = this.i + 'InjuryDescription';
    DeathDescription : string = this.i + 'DeathDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ObjectDescription : string = this.i + 'ObjectDescription';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    BodySideCv : string = this.i + 'BodySideCv';
    BodyPartCv : string = this.i + 'BodyPartCv';
    InjuryTypeCv : string = this.i + 'InjuryTypeCv';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    MediaGroupId : string = this.i + 'MediaGroupId';
    InjuryOtherExplanation : string = this.i + 'InjuryOtherExplanation';
    EmployeeAddress : string = this.i + 'EmployeeAddress';
    AccidentAddress : string = this.i + 'AccidentAddress';
    EmployeeCity : string = this.i + 'EmployeeCity';
    EmployeeState : string = this.i + 'EmployeeState';
    EmployeeZip : string = this.i + 'EmployeeZip';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    FatalityInvolved : string = this.i + 'FatalityInvolved';
    FatalityDateTime : string = this.i + 'FatalityDateTime';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimFileDate : string = this.i + 'ClaimFileDate';
    ClaimInsuranceCompany : string = this.i + 'ClaimInsuranceCompany';
    ClaimAdjustorName : string = this.i + 'ClaimAdjustorName';
    ClaimAdjustorPhone : string = this.i + 'ClaimAdjustorPhone';
    ClaimComments : string = this.i + 'ClaimComments';
    EmployeeOnLeave : string = this.i + 'EmployeeOnLeave';
    EmployeeHasAttorney : string = this.i + 'EmployeeHasAttorney';
    EmployeeAttorneyName : string = this.i + 'EmployeeAttorneyName';
    EmployeeAttorneyPhone : string = this.i + 'EmployeeAttorneyPhone';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    MedicalWachter : string = this.i + 'MedicalWachter';
    MedicalAboveDeductible : string = this.i + 'MedicalAboveDeductible';
    WageExpenseWachter : string = this.i + 'WageExpenseWachter';
    WageExpenseAboveDeductible : string = this.i + 'WageExpenseAboveDeductible';
    WorkersCompAttachmentId : string = this.i + 'WorkersCompAttachmentId';
    WorkersCompNoteParentId : string = this.i + 'WorkersCompNoteParentId';
    NoteParentId : string = this.i + 'NoteParentId';
    InHouseClaimNumber : string = this.i + 'InHouseClaimNumber';
    InHouseClaimFileDate : string = this.i + 'InHouseClaimFileDate';
    InHouseClaimStatusCv : string = this.i + 'InHouseClaimStatusCv';
    EmployeePhone : string = this.i + 'EmployeePhone';

    Relations = {
            /** Relation: Attachment */
            AttachmentByAttachmentId : {
                RelationName: 'Attachment|workplaceAccident|AttachmentId',
                FieldPrefix: 'AttachmentAttachment',
                PropertyName: 'AttachmentAttachment'
            },
            /** Relation: Attachment - Workers Comp Attachment */
            AttachmentByWorkersCompAttachmentId : {
                RelationName: 'Attachment|workplaceAccident|WorkersCompAttachmentId',
                FieldPrefix: 'WorkersCompAttachmentAttachment',
                PropertyName: 'WorkersCompAttachmentAttachment'
            },
            /** Relation: Trust Code Value - Injury Type */
            CodeValueByInjuryTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|InjuryTypeCv',
                FieldPrefix: 'InjuryTypeCvCodeValue',
                PropertyName: 'InjuryTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Accident Type */
            CodeValueByAccidentTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvCodeValue',
                PropertyName: 'AccidentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Body Part */
            CodeValueByBodyPartCv : {
                RelationName: 'CodeValue|workplaceAccident|BodyPartCv',
                FieldPrefix: 'BodyPartCvCodeValue',
                PropertyName: 'BodyPartCvCodeValue'
            },
            /** Relation: Trust Code Value - Body Side */
            CodeValueByBodySideCv : {
                RelationName: 'CodeValue|workplaceAccident|BodySideCv',
                FieldPrefix: 'BodySideCvCodeValue',
                PropertyName: 'BodySideCvCodeValue'
            },
            /** Relation: Trust Code Value - Worksite Type */
            CodeValueByWorksiteTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|WorksiteTypeCv',
                FieldPrefix: 'WorksiteTypeCvCodeValue',
                PropertyName: 'WorksiteTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Status */
            CodeValueByClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvCodeValue',
                PropertyName: 'ClaimStatusCvCodeValue'
            },
            /** Relation: Trust Code Value - In House Claim Status */
            CodeValueByInHouseClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|InHouseClaimStatusCv',
                FieldPrefix: 'InHouseClaimStatusCvCodeValue',
                PropertyName: 'InHouseClaimStatusCvCodeValue'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|workplaceAccident|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Note Parent */
            NotesNoteParent : {
                RelationName: 'notes_NoteParent|workplaceAccident|NoteParentId',
                FieldPrefix: 'NotesNoteParent',
                PropertyName: 'NotesNoteParent'
            },
            /** Relation: Note Parent - Workers Comp Note Parent */
            NotesNoteParentByWorkersCompNoteParentId : {
                RelationName: 'notes_NoteParent|workplaceAccident|WorkersCompNoteParentId',
                FieldPrefix: 'WorkersCompNotesNoteParent',
                PropertyName: 'WorkersCompNotesNoteParent'
            },
            /** Relation: State Province - Accident State */
            EthosStateProvinceByAccidentState : {
                RelationName: 'Ethos_StateProvince|workplaceAccident|AccidentState',
                FieldPrefix: 'AccidentStateEthosStateProvince',
                PropertyName: 'AccidentStateEthosStateProvince'
            },
            /** Relation: State Province - Employee State */
            EthosStateProvinceByEmployeeState : {
                RelationName: 'Ethos_StateProvince|workplaceAccident|EmployeeState',
                FieldPrefix: 'EmployeeStateEthosStateProvince',
                PropertyName: 'EmployeeStateEthosStateProvince'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Department - Department */
            EthosWachterDepartmentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|workplaceAccident|DepartmentId',
                FieldPrefix: 'DepartmentIdEthosWachterDepartment',
                PropertyName: 'DepartmentIdEthosWachterDepartment'
            },
            /** Relation: Medical Record */
            MedicalRecord : {
                RelationName: 'WorkplaceAccident|MedicalRecord|WorkplaceAccidentId',
                FieldPrefix: 'MedicalRecord',
                PropertyName: 'MedicalRecord'
            },
            /** Relation: Ro Workers Comp - Accident - Many */
            RoWorkersCompByAccidentId : {
                RelationName: 'Workers Comp Expenses',
                FieldPrefix: 'AccidentIdRoWorkersComp',
                PropertyName: 'AccidentIdRoWorkersComp'
            },
            /** Relation: Ro Workplace Accident */
            RoWorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident',
                FieldPrefix: 'RoWorkplaceAccident',
                PropertyName: 'RoWorkplaceAccident'
            },
            /** Relation: Ro Workplace Accident Notes */
            RoWorkplaceAccidentNotes : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident_WithNote',
                FieldPrefix: 'RoWorkplaceAccidentNotes',
                PropertyName: 'RoWorkplaceAccidentNotes'
            },
            /** Relation: Wage Expense */
            WageExpense : {
                RelationName: 'WorkplaceAccident|WageExpense|WorkplaceAccidentId',
                FieldPrefix: 'WageExpense',
                PropertyName: 'WageExpense'
            },
    };
}

export class AppMetaData {

    static AccessControl : AccessControlMetaData = new AccessControlMetaData();
    static Permits2AccessControl : Permits2AccessControlMetaData = new Permits2AccessControlMetaData();
    static Accident : AccidentMetaData = new AccidentMetaData();
    static Attachment : AttachmentMetaData = new AttachmentMetaData();
    static AttachmentConversion : AttachmentConversionMetaData = new AttachmentConversionMetaData();
    static AttachmentConversionPermit : AttachmentConversionPermitMetaData = new AttachmentConversionPermitMetaData();
    static AttachmentConversionPermitMedia : AttachmentConversionPermitMediaMetaData = new AttachmentConversionPermitMediaMetaData();
    static AttachmentFile : AttachmentFileMetaData = new AttachmentFileMetaData();
    static AttachmentAttachmentFile : AttachmentAttachmentFileMetaData = new AttachmentAttachmentFileMetaData();
    static AttachmentFileVersion : AttachmentFileVersionMetaData = new AttachmentFileVersionMetaData();
    static AttachmentFolder : AttachmentFolderMetaData = new AttachmentFolderMetaData();
    static AttachmentAttachmentFolder : AttachmentAttachmentFolderMetaData = new AttachmentAttachmentFolderMetaData();
    static AttachmentObject : AttachmentObjectMetaData = new AttachmentObjectMetaData();
    static Auction : AuctionMetaData = new AuctionMetaData();
    static AuditIssue : AuditIssueMetaData = new AuditIssueMetaData();
    static AuditIssueRating : AuditIssueRatingMetaData = new AuditIssueRatingMetaData();
    static AuditIssueRiskType : AuditIssueRiskTypeMetaData = new AuditIssueRiskTypeMetaData();
    static AuditIssueStatus : AuditIssueStatusMetaData = new AuditIssueStatusMetaData();
    static BidHistory : BidHistoryMetaData = new BidHistoryMetaData();
    static Billing : BillingMetaData = new BillingMetaData();
    static BillingDepartment : BillingDepartmentMetaData = new BillingDepartmentMetaData();
    static ChangeRequest : ChangeRequestMetaData = new ChangeRequestMetaData();
    static Checklist : ChecklistMetaData = new ChecklistMetaData();
    static CodeSet : CodeSetMetaData = new CodeSetMetaData();
    static CodeValue : CodeValueMetaData = new CodeValueMetaData();
    static Collaboration : CollaborationMetaData = new CollaborationMetaData();
    static CollaborationDepartment : CollaborationDepartmentMetaData = new CollaborationDepartmentMetaData();
    static CollaborationPm : CollaborationPmMetaData = new CollaborationPmMetaData();
    static Company : CompanyMetaData = new CompanyMetaData();
    static CompanyLicense : CompanyLicenseMetaData = new CompanyLicenseMetaData();
    static CompanyLicenseType : CompanyLicenseTypeMetaData = new CompanyLicenseTypeMetaData();
    static CovidConfiguration : CovidConfigurationMetaData = new CovidConfigurationMetaData();
    static CovidTestResultType : CovidTestResultTypeMetaData = new CovidTestResultTypeMetaData();
    static CovidTestStatus : CovidTestStatusMetaData = new CovidTestStatusMetaData();
    static CovidTestType : CovidTestTypeMetaData = new CovidTestTypeMetaData();
    static CovidVaccinationStatus : CovidVaccinationStatusMetaData = new CovidVaccinationStatusMetaData();
    static CovidVaccinationSubmissionStatus : CovidVaccinationSubmissionStatusMetaData = new CovidVaccinationSubmissionStatusMetaData();
    static CovidVaccineType : CovidVaccineTypeMetaData = new CovidVaccineTypeMetaData();
    static CovidWorkStatus : CovidWorkStatusMetaData = new CovidWorkStatusMetaData();
    static DevwareCustomAttributeValue : DevwareCustomAttributeValueMetaData = new DevwareCustomAttributeValueMetaData();
    static CustomerSatisfaction : CustomerSatisfactionMetaData = new CustomerSatisfactionMetaData();
    static DepartmentAdditionalBurden : DepartmentAdditionalBurdenMetaData = new DepartmentAdditionalBurdenMetaData();
    static DepartmentMap : DepartmentMapMetaData = new DepartmentMapMetaData();
    static DepartmentRole : DepartmentRoleMetaData = new DepartmentRoleMetaData();
    static DWOSGFinData : DWOSGFinDataMetaData = new DWOSGFinDataMetaData();
    static DWOSGFinDataLatest : DWOSGFinDataLatestMetaData = new DWOSGFinDataLatestMetaData();
    static DWPeoplePaySummary : DWPeoplePaySummaryMetaData = new DWPeoplePaySummaryMetaData();
    static DWPersonMerge : DWPersonMergeMetaData = new DWPersonMergeMetaData();
    static DWPersonMergeLog : DWPersonMergeLogMetaData = new DWPersonMergeLogMetaData();
    static DWTrustForecastData : DWTrustForecastDataMetaData = new DWTrustForecastDataMetaData();
    static DWWorkInProcess : DWWorkInProcessMetaData = new DWWorkInProcessMetaData();
    static EmaulationUser : EmaulationUserMetaData = new EmaulationUserMetaData();
    static EmployeeReminderNotification : EmployeeReminderNotificationMetaData = new EmployeeReminderNotificationMetaData();
    static EmployeeReview : EmployeeReviewMetaData = new EmployeeReviewMetaData();
    static EmployeeReviewAnswer : EmployeeReviewAnswerMetaData = new EmployeeReviewAnswerMetaData();
    static EmployeeReviewAnswerValue : EmployeeReviewAnswerValueMetaData = new EmployeeReviewAnswerValueMetaData();
    static EmployeeReviewCategory : EmployeeReviewCategoryMetaData = new EmployeeReviewCategoryMetaData();
    static EmployeeReviewQuestion : EmployeeReviewQuestionMetaData = new EmployeeReviewQuestionMetaData();
    static EmployeeReviewQuestionRequest : EmployeeReviewQuestionRequestMetaData = new EmployeeReviewQuestionRequestMetaData();
    static EmployeeReviewQuestionRequestDetail : EmployeeReviewQuestionRequestDetailMetaData = new EmployeeReviewQuestionRequestDetailMetaData();
    static EmployeeReviewQuestionRequestStatus : EmployeeReviewQuestionRequestStatusMetaData = new EmployeeReviewQuestionRequestStatusMetaData();
    static EmployeeReviewQuestionSetup : EmployeeReviewQuestionSetupMetaData = new EmployeeReviewQuestionSetupMetaData();
    static EmployeeReviewQuestionSetupDetail : EmployeeReviewQuestionSetupDetailMetaData = new EmployeeReviewQuestionSetupDetailMetaData();
    static EmployeeReviewQuestionSetupLevel : EmployeeReviewQuestionSetupLevelMetaData = new EmployeeReviewQuestionSetupLevelMetaData();
    static EmployeeReviewQuestionSkill : EmployeeReviewQuestionSkillMetaData = new EmployeeReviewQuestionSkillMetaData();
    static EmployeeReviewQuestionType : EmployeeReviewQuestionTypeMetaData = new EmployeeReviewQuestionTypeMetaData();
    static EmployeeReviewStatus : EmployeeReviewStatusMetaData = new EmployeeReviewStatusMetaData();
    static EmployeeReviewSummary : EmployeeReviewSummaryMetaData = new EmployeeReviewSummaryMetaData();
    static EmployeeReviewSummaryStatus : EmployeeReviewSummaryStatusMetaData = new EmployeeReviewSummaryStatusMetaData();
    static EmployeeReviewSummaryType : EmployeeReviewSummaryTypeMetaData = new EmployeeReviewSummaryTypeMetaData();
    static EmployeeServiceDates : EmployeeServiceDatesMetaData = new EmployeeServiceDatesMetaData();
    static EmployeeSummary : EmployeeSummaryMetaData = new EmployeeSummaryMetaData();
    static EmployeeSummaryChangeType : EmployeeSummaryChangeTypeMetaData = new EmployeeSummaryChangeTypeMetaData();
    static EmployeeSummaryHistory : EmployeeSummaryHistoryMetaData = new EmployeeSummaryHistoryMetaData();
    static EmployeeTest : EmployeeTestMetaData = new EmployeeTestMetaData();
    static EmployeeTrainingNeeded : EmployeeTrainingNeededMetaData = new EmployeeTrainingNeededMetaData();
    static EmployeeVaccinationSubmission : EmployeeVaccinationSubmissionMetaData = new EmployeeVaccinationSubmissionMetaData();
    static Equipment : EquipmentMetaData = new EquipmentMetaData();
    static EquipmentCompany : EquipmentCompanyMetaData = new EquipmentCompanyMetaData();
    static Escalation : EscalationMetaData = new EscalationMetaData();
    static EthosAddress : EthosAddressMetaData = new EthosAddressMetaData();
    static EthosCodeSet : EthosCodeSetMetaData = new EthosCodeSetMetaData();
    static EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    static EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    static EthosCountry : EthosCountryMetaData = new EthosCountryMetaData();
    static DboEthosCounty : DboEthosCountyMetaData = new DboEthosCountyMetaData();
    static EthosCustomer : EthosCustomerMetaData = new EthosCustomerMetaData();
    static EthosJob : EthosJobMetaData = new EthosJobMetaData();
    static EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    static EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    static EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    static EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    static EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    static EthosJobSite : EthosJobSiteMetaData = new EthosJobSiteMetaData();
    static EthosJobSow : EthosJobSowMetaData = new EthosJobSowMetaData();
    static EthosLaborMetrics : EthosLaborMetricsMetaData = new EthosLaborMetricsMetaData();
    static EthosOpportunity : EthosOpportunityMetaData = new EthosOpportunityMetaData();
    static EthosRoUserLaborSummary : EthosRoUserLaborSummaryMetaData = new EthosRoUserLaborSummaryMetaData();
    static EthosServiceUser : EthosServiceUserMetaData = new EthosServiceUserMetaData();
    static EthosSite : EthosSiteMetaData = new EthosSiteMetaData();
    static EthosSow : EthosSowMetaData = new EthosSowMetaData();
    static EthosStaffingAgency : EthosStaffingAgencyMetaData = new EthosStaffingAgencyMetaData();
    static EthosStateProvince : EthosStateProvinceMetaData = new EthosStateProvinceMetaData();
    static EthosSubcontractorBranch : EthosSubcontractorBranchMetaData = new EthosSubcontractorBranchMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterCompany : EthosWachterCompanyMetaData = new EthosWachterCompanyMetaData();
    static EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    static EthosWachterDivision : EthosWachterDivisionMetaData = new EthosWachterDivisionMetaData();
    static EthosWachterJobTitle : EthosWachterJobTitleMetaData = new EthosWachterJobTitleMetaData();
    static EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    static EthosWorkflowStatus : EthosWorkflowStatusMetaData = new EthosWorkflowStatusMetaData();
    static EthosWorkflowStatusSet : EthosWorkflowStatusSetMetaData = new EthosWorkflowStatusSetMetaData();
    static EthosRoleMap : EthosRoleMapMetaData = new EthosRoleMapMetaData();
    static EthosRoles : EthosRolesMetaData = new EthosRolesMetaData();
    static EthosUserDetail : EthosUserDetailMetaData = new EthosUserDetailMetaData();
    static EthosUserRole : EthosUserRoleMetaData = new EthosUserRoleMetaData();
    static FieldEmployeesPayRate : FieldEmployeesPayRateMetaData = new FieldEmployeesPayRateMetaData();
    static FiveStarRating : FiveStarRatingMetaData = new FiveStarRatingMetaData();
    static Inspection : InspectionMetaData = new InspectionMetaData();
    static Permits2Inspection : Permits2InspectionMetaData = new Permits2InspectionMetaData();
    static InspectionResult : InspectionResultMetaData = new InspectionResultMetaData();
    static InspectionStatus : InspectionStatusMetaData = new InspectionStatusMetaData();
    static IssueSubtype : IssueSubtypeMetaData = new IssueSubtypeMetaData();
    static IssueSubtypeSeverity : IssueSubtypeSeverityMetaData = new IssueSubtypeSeverityMetaData();
    static IssueType : IssueTypeMetaData = new IssueTypeMetaData();
    static Kickoff : KickoffMetaData = new KickoffMetaData();
    static ProjectsKickoff : ProjectsKickoffMetaData = new ProjectsKickoffMetaData();
    static KickoffChecklist : KickoffChecklistMetaData = new KickoffChecklistMetaData();
    static Licenses : LicensesMetaData = new LicensesMetaData();
    static LicenseType : LicenseTypeMetaData = new LicenseTypeMetaData();
    static Maintenance : MaintenanceMetaData = new MaintenanceMetaData();
    static MaintenanceService : MaintenanceServiceMetaData = new MaintenanceServiceMetaData();
    static MedicalRecord : MedicalRecordMetaData = new MedicalRecordMetaData();
    static MemoOfRecord : MemoOfRecordMetaData = new MemoOfRecordMetaData();
    static MorMemoOfRecordNotificationGroup : MorMemoOfRecordNotificationGroupMetaData = new MorMemoOfRecordNotificationGroupMetaData();
    static Message : MessageMetaData = new MessageMetaData();
    static Milestone : MilestoneMetaData = new MilestoneMetaData();
    static MilestoneCheckpoint : MilestoneCheckpointMetaData = new MilestoneCheckpointMetaData();
    static MissingForeignKeys : MissingForeignKeysMetaData = new MissingForeignKeysMetaData();
    static Note : NoteMetaData = new NoteMetaData();
    static WcNote : WcNoteMetaData = new WcNoteMetaData();
    static EmsNote : EmsNoteMetaData = new EmsNoteMetaData();
    static NumbersNote : NumbersNoteMetaData = new NumbersNoteMetaData();
    static NotesNote : NotesNoteMetaData = new NotesNoteMetaData();
    static NotesNoteParent : NotesNoteParentMetaData = new NotesNoteParentMetaData();
    static NoteType : NoteTypeMetaData = new NoteTypeMetaData();
    static MorNotificationConfig : MorNotificationConfigMetaData = new MorNotificationConfigMetaData();
    static WcNotificationGroup : WcNotificationGroupMetaData = new WcNotificationGroupMetaData();
    static OrganizationalEntity : OrganizationalEntityMetaData = new OrganizationalEntityMetaData();
    static OrganizationalMembership : OrganizationalMembershipMetaData = new OrganizationalMembershipMetaData();
    static OrganizationalType : OrganizationalTypeMetaData = new OrganizationalTypeMetaData();
    static OrganizationalUnit : OrganizationalUnitMetaData = new OrganizationalUnitMetaData();
    static OverheadProjection : OverheadProjectionMetaData = new OverheadProjectionMetaData();
    static OverheadTeamPhase : OverheadTeamPhaseMetaData = new OverheadTeamPhaseMetaData();
    static PafHistory : PafHistoryMetaData = new PafHistoryMetaData();
    static PassHistory : PassHistoryMetaData = new PassHistoryMetaData();
    static PayJobChange : PayJobChangeMetaData = new PayJobChangeMetaData();
    static PayJobChangeEmail : PayJobChangeEmailMetaData = new PayJobChangeEmailMetaData();
    static PayJobChangeUsersRead : PayJobChangeUsersReadMetaData = new PayJobChangeUsersReadMetaData();
    static PayJobChangeWorkflowEmail : PayJobChangeWorkflowEmailMetaData = new PayJobChangeWorkflowEmailMetaData();
    static PeoplePayHistoryCurrentPreviousInitial : PeoplePayHistoryCurrentPreviousInitialMetaData = new PeoplePayHistoryCurrentPreviousInitialMetaData();
    static PeoplePayHistoryCurrentPreviousInitialV2 : PeoplePayHistoryCurrentPreviousInitialV2MetaData = new PeoplePayHistoryCurrentPreviousInitialV2MetaData();
    static PerformanceMetrics : PerformanceMetricsMetaData = new PerformanceMetricsMetaData();
    static Permit : PermitMetaData = new PermitMetaData();
    static Permits2Permit : Permits2PermitMetaData = new Permits2PermitMetaData();
    static PermitPermitType : PermitPermitTypeMetaData = new PermitPermitTypeMetaData();
    static Permits2PermitPermitType : Permits2PermitPermitTypeMetaData = new Permits2PermitPermitTypeMetaData();
    static PermitRequest : PermitRequestMetaData = new PermitRequestMetaData();
    static PermitRequestPermit : PermitRequestPermitMetaData = new PermitRequestPermitMetaData();
    static PermitRequestPermitType : PermitRequestPermitTypeMetaData = new PermitRequestPermitTypeMetaData();
    static PermitStatus : PermitStatusMetaData = new PermitStatusMetaData();
    static Permits2PermitStatus : Permits2PermitStatusMetaData = new Permits2PermitStatusMetaData();
    static PlateHistory : PlateHistoryMetaData = new PlateHistoryMetaData();
    static PolicyType : PolicyTypeMetaData = new PolicyTypeMetaData();
    static ProjectMilestone : ProjectMilestoneMetaData = new ProjectMilestoneMetaData();
    static ProofOfInsurance : ProofOfInsuranceMetaData = new ProofOfInsuranceMetaData();
    static ProofOfInsuranceJobTitles : ProofOfInsuranceJobTitlesMetaData = new ProofOfInsuranceJobTitlesMetaData();
    static ProofOfInsuranceStatus : ProofOfInsuranceStatusMetaData = new ProofOfInsuranceStatusMetaData();
    static ProofOfInsuranceSummary : ProofOfInsuranceSummaryMetaData = new ProofOfInsuranceSummaryMetaData();
    static ProofOfInsuranceSummaryStatus : ProofOfInsuranceSummaryStatusMetaData = new ProofOfInsuranceSummaryStatusMetaData();
    static Rating : RatingMetaData = new RatingMetaData();
    static RatingQuestion : RatingQuestionMetaData = new RatingQuestionMetaData();
    static RatingType : RatingTypeMetaData = new RatingTypeMetaData();
    static Reporting : ReportingMetaData = new ReportingMetaData();
    static Request : RequestMetaData = new RequestMetaData();
    static TravelRequest : TravelRequestMetaData = new TravelRequestMetaData();
    static RequestEquipment : RequestEquipmentMetaData = new RequestEquipmentMetaData();
    static RequestPreferences : RequestPreferencesMetaData = new RequestPreferencesMetaData();
    static RequiredCable : RequiredCableMetaData = new RequiredCableMetaData();
    static Permits2RequiredCable : Permits2RequiredCableMetaData = new Permits2RequiredCableMetaData();
    static ResourceCost : ResourceCostMetaData = new ResourceCostMetaData();
    static Review : ReviewMetaData = new ReviewMetaData();
    static RoEthosUserBurdon : RoEthosUserBurdonMetaData = new RoEthosUserBurdonMetaData();
    static RoAccident : RoAccidentMetaData = new RoAccidentMetaData();
    static RoActiveChangeRequest : RoActiveChangeRequestMetaData = new RoActiveChangeRequestMetaData();
    static RoActiveSubordinates : RoActiveSubordinatesMetaData = new RoActiveSubordinatesMetaData();
    static RoAllSupervisorsSubordinates : RoAllSupervisorsSubordinatesMetaData = new RoAllSupervisorsSubordinatesMetaData();
    static RoAllSupervisorsSubordinatesOptimized : RoAllSupervisorsSubordinatesOptimizedMetaData = new RoAllSupervisorsSubordinatesOptimizedMetaData();
    static RoAllSupervisorsSubordinatesOriginal : RoAllSupervisorsSubordinatesOriginalMetaData = new RoAllSupervisorsSubordinatesOriginalMetaData();
    static RoAttachmentFileNamesCombined : RoAttachmentFileNamesCombinedMetaData = new RoAttachmentFileNamesCombinedMetaData();
    static RoAuction : RoAuctionMetaData = new RoAuctionMetaData();
    static RoAuditIssue : RoAuditIssueMetaData = new RoAuditIssueMetaData();
    static RoAuditSupervisorAccess : RoAuditSupervisorAccessMetaData = new RoAuditSupervisorAccessMetaData();
    static RoAvStarRatingNspTech : RoAvStarRatingNspTechMetaData = new RoAvStarRatingNspTechMetaData();
    static RoCollaboration : RoCollaborationMetaData = new RoCollaborationMetaData();
    static RoCustomerSatisfaction : RoCustomerSatisfactionMetaData = new RoCustomerSatisfactionMetaData();
    static RoEmployeeDetail : RoEmployeeDetailMetaData = new RoEmployeeDetailMetaData();
    static RoEmployeeDetailFull : RoEmployeeDetailFullMetaData = new RoEmployeeDetailFullMetaData();
    static RoEmployeeReviewSummaryCurrent : RoEmployeeReviewSummaryCurrentMetaData = new RoEmployeeReviewSummaryCurrentMetaData();
    static RoEmsPBi : RoEmsPBiMetaData = new RoEmsPBiMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserAddSubTemp : RoEthosUserAddSubTempMetaData = new RoEthosUserAddSubTempMetaData();
    static RoEthosUserGrid : RoEthosUserGridMetaData = new RoEthosUserGridMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoEthosTeamsAndOrganizationalUnits : RoEthosTeamsAndOrganizationalUnitsMetaData = new RoEthosTeamsAndOrganizationalUnitsMetaData();
    static RoFiscalYearRange : RoFiscalYearRangeMetaData = new RoFiscalYearRangeMetaData();
    static RoInspections : RoInspectionsMetaData = new RoInspectionsMetaData();
    static Permits2RoInspections : Permits2RoInspectionsMetaData = new Permits2RoInspectionsMetaData();
    static RoIssueTypeSubtypeSeverity : RoIssueTypeSubtypeSeverityMetaData = new RoIssueTypeSubtypeSeverityMetaData();
    static RoKickoff : RoKickoffMetaData = new RoKickoffMetaData();
    static RoLastAccidentSummary : RoLastAccidentSummaryMetaData = new RoLastAccidentSummaryMetaData();
    static RoLicenseCountPerUser : RoLicenseCountPerUserMetaData = new RoLicenseCountPerUserMetaData();
    static RoLicenses : RoLicensesMetaData = new RoLicensesMetaData();
    static RoMaintenance : RoMaintenanceMetaData = new RoMaintenanceMetaData();
    static RoMilestoneAndMilestoneCheckpoint : RoMilestoneAndMilestoneCheckpointMetaData = new RoMilestoneAndMilestoneCheckpointMetaData();
    static RoNspCommittedByDepartment : RoNspCommittedByDepartmentMetaData = new RoNspCommittedByDepartmentMetaData();
    static RoNspCommittedByProjectManager : RoNspCommittedByProjectManagerMetaData = new RoNspCommittedByProjectManagerMetaData();
    static RoNspCommittedByTeam : RoNspCommittedByTeamMetaData = new RoNspCommittedByTeamMetaData();
    static RoNspCommittedByUnit : RoNspCommittedByUnitMetaData = new RoNspCommittedByUnitMetaData();
    static RoNspDwFinancialsByDepartmentByYear : RoNspDwFinancialsByDepartmentByYearMetaData = new RoNspDwFinancialsByDepartmentByYearMetaData();
    static RoNspDwFinancialsByProjectManagerByYear : RoNspDwFinancialsByProjectManagerByYearMetaData = new RoNspDwFinancialsByProjectManagerByYearMetaData();
    static RoNspDwFinancialsByTeamByYear : RoNspDwFinancialsByTeamByYearMetaData = new RoNspDwFinancialsByTeamByYearMetaData();
    static RoNspDwFinancialsByUnitByYear : RoNspDwFinancialsByUnitByYearMetaData = new RoNspDwFinancialsByUnitByYearMetaData();
    static RoNspDwOverheadByDepartmentByYear : RoNspDwOverheadByDepartmentByYearMetaData = new RoNspDwOverheadByDepartmentByYearMetaData();
    static RoNspDwOverheadByTeamByYear : RoNspDwOverheadByTeamByYearMetaData = new RoNspDwOverheadByTeamByYearMetaData();
    static RoNSPFinancialNumbers : RoNSPFinancialNumbersMetaData = new RoNSPFinancialNumbersMetaData();
    static RoNspFinancialNumbersByTeamByYear : RoNspFinancialNumbersByTeamByYearMetaData = new RoNspFinancialNumbersByTeamByYearMetaData();
    static RoNspFinancialNumbersByTeamByYearBackup : RoNspFinancialNumbersByTeamByYearBackupMetaData = new RoNspFinancialNumbersByTeamByYearBackupMetaData();
    static RoNspFinancialNumbersByTeamByYearOLD : RoNspFinancialNumbersByTeamByYearOLDMetaData = new RoNspFinancialNumbersByTeamByYearOLDMetaData();
    static RoNSPFinancialNumbersByYear : RoNSPFinancialNumbersByYearMetaData = new RoNSPFinancialNumbersByYearMetaData();
    static RoNspOverheadProjectedByDepartmentByYear : RoNspOverheadProjectedByDepartmentByYearMetaData = new RoNspOverheadProjectedByDepartmentByYearMetaData();
    static RoNspOverheadProjectedByTeamByYear : RoNspOverheadProjectedByTeamByYearMetaData = new RoNspOverheadProjectedByTeamByYearMetaData();
    static RoNspProjectedByDepartment : RoNspProjectedByDepartmentMetaData = new RoNspProjectedByDepartmentMetaData();
    static RoNspProjectedByProjectManager : RoNspProjectedByProjectManagerMetaData = new RoNspProjectedByProjectManagerMetaData();
    static RoNspProjectedByTeam : RoNspProjectedByTeamMetaData = new RoNspProjectedByTeamMetaData();
    static RoNspProjectedByUnit : RoNspProjectedByUnitMetaData = new RoNspProjectedByUnitMetaData();
    static RoOrganizationalTeamUnitDept : RoOrganizationalTeamUnitDeptMetaData = new RoOrganizationalTeamUnitDeptMetaData();
    static RoOverheadCommittedByJobPhaseYear : RoOverheadCommittedByJobPhaseYearMetaData = new RoOverheadCommittedByJobPhaseYearMetaData();
    static RoOverheadProjectedByJobPhaseYear : RoOverheadProjectedByJobPhaseYearMetaData = new RoOverheadProjectedByJobPhaseYearMetaData();
    static RoOverheadProjectionByTeam : RoOverheadProjectionByTeamMetaData = new RoOverheadProjectionByTeamMetaData();
    static RoPafAccess : RoPafAccessMetaData = new RoPafAccessMetaData();
    static RoPayJobChangeSubordinates : RoPayJobChangeSubordinatesMetaData = new RoPayJobChangeSubordinatesMetaData();
    static RoPermitRequestLastNote : RoPermitRequestLastNoteMetaData = new RoPermitRequestLastNoteMetaData();
    static RoPermitRequests : RoPermitRequestsMetaData = new RoPermitRequestsMetaData();
    static RoPermits : RoPermitsMetaData = new RoPermitsMetaData();
    static Permits2RoPermits : Permits2RoPermitsMetaData = new Permits2RoPermitsMetaData();
    static RoPermitsBySubordinates : RoPermitsBySubordinatesMetaData = new RoPermitsBySubordinatesMetaData();
    static RoPositionHistory : RoPositionHistoryMetaData = new RoPositionHistoryMetaData();
    static RoProjectKickoff : RoProjectKickoffMetaData = new RoProjectKickoffMetaData();
    static RoProjectManagersTeamUnitDept : RoProjectManagersTeamUnitDeptMetaData = new RoProjectManagersTeamUnitDeptMetaData();
    static RoRequest : RoRequestMetaData = new RoRequestMetaData();
    static RoRequestContext : RoRequestContextMetaData = new RoRequestContextMetaData();
    static RoStarRatingAvProjects : RoStarRatingAvProjectsMetaData = new RoStarRatingAvProjectsMetaData();
    static RoStarRatingAvProjectsPms : RoStarRatingAvProjectsPmsMetaData = new RoStarRatingAvProjectsPmsMetaData();
    static RoStarRatingNotificationTargets : RoStarRatingNotificationTargetsMetaData = new RoStarRatingNotificationTargetsMetaData();
    static RoTerritoryStateProvince : RoTerritoryStateProvinceMetaData = new RoTerritoryStateProvinceMetaData();
    static RoUserProjection : RoUserProjectionMetaData = new RoUserProjectionMetaData();
    static NumbersRoUserProjection : NumbersRoUserProjectionMetaData = new NumbersRoUserProjectionMetaData();
    static RoUserProjectionAnalyzed : RoUserProjectionAnalyzedMetaData = new RoUserProjectionAnalyzedMetaData();
    static RoUserSkillList : RoUserSkillListMetaData = new RoUserSkillListMetaData();
    static RoVehicle : RoVehicleMetaData = new RoVehicleMetaData();
    static RoVehicleAccidents : RoVehicleAccidentsMetaData = new RoVehicleAccidentsMetaData();
    static RoVehicleYears : RoVehicleYearsMetaData = new RoVehicleYearsMetaData();
    static RoWorkersComp : RoWorkersCompMetaData = new RoWorkersCompMetaData();
    static RoWorkplaceAccident : RoWorkplaceAccidentMetaData = new RoWorkplaceAccidentMetaData();
    static RoWorkplaceAccidentNotes : RoWorkplaceAccidentNotesMetaData = new RoWorkplaceAccidentNotesMetaData();
    static RoYearRange : RoYearRangeMetaData = new RoYearRangeMetaData();
    static ServiceType : ServiceTypeMetaData = new ServiceTypeMetaData();
    static StageAuditLog : StageAuditLogMetaData = new StageAuditLogMetaData();
    static Stakeholder : StakeholderMetaData = new StakeholderMetaData();
    static StarRatingAvProjects : StarRatingAvProjectsMetaData = new StarRatingAvProjectsMetaData();
    static StarRatingFieldExperience : StarRatingFieldExperienceMetaData = new StarRatingFieldExperienceMetaData();
    static StarRatingNotification : StarRatingNotificationMetaData = new StarRatingNotificationMetaData();
    static StarRatingNotificationType : StarRatingNotificationTypeMetaData = new StarRatingNotificationTypeMetaData();
    static SuggestedCompositeIndexes : SuggestedCompositeIndexesMetaData = new SuggestedCompositeIndexesMetaData();
    static SuggestedForeignKeyIndexes : SuggestedForeignKeyIndexesMetaData = new SuggestedForeignKeyIndexesMetaData();
    static TeamAssignment : TeamAssignmentMetaData = new TeamAssignmentMetaData();
    static TeamYearNumbers : TeamYearNumbersMetaData = new TeamYearNumbersMetaData();
    static Template : TemplateMetaData = new TemplateMetaData();
    static TermResign : TermResignMetaData = new TermResignMetaData();
    static Territory : TerritoryMetaData = new TerritoryMetaData();
    static TerritoryStateProvince : TerritoryStateProvinceMetaData = new TerritoryStateProvinceMetaData();
    static Timer : TimerMetaData = new TimerMetaData();
    static TimerSkillMap : TimerSkillMapMetaData = new TimerSkillMapMetaData();
    static TimerStatus : TimerStatusMetaData = new TimerStatusMetaData();
    static TimerType : TimerTypeMetaData = new TimerTypeMetaData();
    static TmpRoAllSupervisorsSubordinates : TmpRoAllSupervisorsSubordinatesMetaData = new TmpRoAllSupervisorsSubordinatesMetaData();
    static TmpSysdiamgrasBackup20230417 : TmpSysdiamgrasBackup20230417MetaData = new TmpSysdiamgrasBackup20230417MetaData();
    static Traveler : TravelerMetaData = new TravelerMetaData();
    static TrustSyncLog : TrustSyncLogMetaData = new TrustSyncLogMetaData();
    static TrustUserMerged : TrustUserMergedMetaData = new TrustUserMergedMetaData();
    static UserExtended : UserExtendedMetaData = new UserExtendedMetaData();
    static MtlUserExtended : MtlUserExtendedMetaData = new MtlUserExtendedMetaData();
    static EmsUserExtended : EmsUserExtendedMetaData = new EmsUserExtendedMetaData();
    static UserExtendedEthosCustomer : UserExtendedEthosCustomerMetaData = new UserExtendedEthosCustomerMetaData();
    static WcUserProjection : WcUserProjectionMetaData = new WcUserProjectionMetaData();
    static UserRead : UserReadMetaData = new UserReadMetaData();
    static WcUserRead : WcUserReadMetaData = new WcUserReadMetaData();
    static UserTeamLookup : UserTeamLookupMetaData = new UserTeamLookupMetaData();
    static UserYearNumbers : UserYearNumbersMetaData = new UserYearNumbersMetaData();
    static Vehicle : VehicleMetaData = new VehicleMetaData();
    static FleetVehicle : FleetVehicleMetaData = new FleetVehicleMetaData();
    static VehicleAccident : VehicleAccidentMetaData = new VehicleAccidentMetaData();
    static VehicleType : VehicleTypeMetaData = new VehicleTypeMetaData();
    static WachterContainerStyle : WachterContainerStyleMetaData = new WachterContainerStyleMetaData();
    static WachterTeamDepartment : WachterTeamDepartmentMetaData = new WachterTeamDepartmentMetaData();
    static WachterTeamOrganizationalUnit : WachterTeamOrganizationalUnitMetaData = new WachterTeamOrganizationalUnitMetaData();
    static WageExpense : WageExpenseMetaData = new WageExpenseMetaData();
    static WAppsRoles : WAppsRolesMetaData = new WAppsRolesMetaData();
    static Witness : WitnessMetaData = new WitnessMetaData();
    static WorkflowStatus : WorkflowStatusMetaData = new WorkflowStatusMetaData();
    static WorkflowStatusSet : WorkflowStatusSetMetaData = new WorkflowStatusSetMetaData();
    static WorkplaceAccident : WorkplaceAccidentMetaData = new WorkplaceAccidentMetaData();
}
// Generated Entity Interfaces
export interface AccessControlEntity extends DwOrmData {
    // Attributes
    AccessControlId?: number;
    AccessControlCv?: number;
    Quantity?: number;
    Description?: string;
    PermitRequestId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;

    // Display Attributes
    AccessControlCvDisplay?: string;
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    AccessControlCvCodeValue? : CodeValueEntity;
    Permit? : PermitEntity;
    PermitRequest? : PermitRequestEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface Permits2AccessControlEntity extends DwOrmData {
    // Attributes
    AccessControlId?: number;
    AccessControlCv?: number;
    Quantity?: number;
    Description?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;

    // Display Attributes
    AccessControlCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    AccessControlCvCodeValue? : CodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface AccidentEntity extends DwOrmData {
    // Attributes
    AccidentId?: number;
    TypeCv?: number;
    EmployeeUserId?: number;
    IsAtFault?: boolean;
    IsWachterInjury?: boolean;
    IsOtherInjury?: boolean;
    IsHospitalVisit?: boolean;
    IsDoctorVisit?: boolean;
    IsFirstAidOnly?: boolean;
    AccidentDescription?: string;
    InjuryDetail?: string;
    DamageDetail?: string;
    IsDeleted?: boolean;
    StateProvinceId?: number;
    WJID?: number;
    HasPriorAccidents?: boolean;
    AccidentDateTime?: string;
    RepairEstimate?: number;
    City?: string;
    Address?: string;
    OtherPartiesInjured?: string;
    MedicalNeeded?: string;
    AccidentCalledIntoHotline?: string;
    Customer?: string;
    JobNumber?: string;
    Site?: string;
    JobsWorkedNote?: string;
    ActionLeadingToAccident?: string;
    HoursWorkedDescription?: string;
    RestOnAccidentDate?: string;
    WorkRestDayBefore?: string;
    WorkRestTwoDaysBefore?: string;
    PriorAccidentList?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    TypeCvDisplay?: string;
    EmployeeUserIdDisplay?: string;
    StateProvinceIdDisplay?: string;

    // Relations
    TypeCvCodeValue? : CodeValueEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EmployeeEthosUser? : EthosUserEntity;
}

export interface AttachmentEntity extends DwOrmData {
    // Attributes
    AttachmentId?: number;
    AttachmentFileId?: number;
    Id?: number;

    // Display Attributes
    AttachmentIdDisplay?: string;
    AttachmentFileIdDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    AttachmentFile? : AttachmentFileEntity;
    // Duplicate property excluded
    // AttachmentAttachment : AttachmentEntity[];
    AttachmentAttachmentFolder? : AttachmentFolderEntity[];
    AttachmentEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    AttachmentFileIdLicenses? : LicensesEntity[];
    LicenseIdLicenses? : LicensesEntity[];
    AttachmentFileLicenses? : LicensesEntity[];
    AttachmentMemoOfRecord? : MemoOfRecordEntity[];
    SignedDocumentsAttachmentMemoOfRecord? : MemoOfRecordEntity[];
    AttachmentPermit? : PermitEntity[];
    AttachmentPermitRequest? : PermitRequestEntity[];
    AttachmentEmsUserExtended? : EmsUserExtendedEntity[];
    SpOsgAttachmentMtlUserExtended? : MtlUserExtendedEntity[];
    AttachmentVehicleAccident? : VehicleAccidentEntity[];
    AttachmentWorkplaceAccident? : WorkplaceAccidentEntity[];
    WorkersCompAttachmentWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface AttachmentConversionEntity extends DwOrmData {
    // Attributes
    AttachmentConversionId?: number;
    AttachmentObjectId?: number;
    AttachmentFolderId?: number;
    AttachmentFileId?: number;
    wAppsFullFileName?: string;
    MediaGroupId?: number;
    MediaId?: number;
    CapFullFileName?: string;
    IsFileConverted?: boolean;
    SourceRecordUpdated?: boolean;
    SourceTable?: string;
    SourceKeyValue?: number;

    // Display Attributes
    AttachmentObjectIdDisplay?: string;
    AttachmentFolderIdDisplay?: string;
    AttachmentFileIdDisplay?: string;

    // Relations
    AttachmentAttachmentFile? : AttachmentAttachmentFileEntity;
    AttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity;
    AttachmentObject? : AttachmentObjectEntity;
}

export interface AttachmentConversionPermitEntity extends DwOrmData {
    // Attributes
    AttachmentConversionPermitId?: number;
    PermitsV2Id?: number;
    OriginalPermitId?: number;
    OriginalPermitRequestId?: number;
    PermitMediaGroupId?: number;
    PermitRequestMediaGroupId?: number;
    PermitsV2IdMediaGroupId?: number;
    FilesConverted?: boolean;
    PermitsV2Updated?: boolean;
    PermitFileCount?: number;
    PermitRequestFileCount?: number;

    // Display Attributes
    PermitsV2IdDisplay?: string;

    // Relations
    PermitsV2IdPermits2Permit? : Permits2PermitEntity;
    AttachmentConversionPermitMedia? : AttachmentConversionPermitMediaEntity[];
}

export interface AttachmentConversionPermitMediaEntity extends DwOrmData {
    // Attributes
    AttachmentConversionPermitMediaId?: number;
    AttachmentConversionPermitId?: number;
    SourceMediaId?: number;
    SourceFullFileName?: string;
    DestMediaId?: number;
    DestFullFileName?: string;
    IsFileConverted?: boolean;

    // Display Attributes
    AttachmentConversionPermitIdDisplay?: string;

    // Relations
    AttachmentConversionPermit? : AttachmentConversionPermitEntity;
}

export interface AttachmentFileEntity extends DwOrmData {
    // Attributes
    AttachmentFileId?: number;
    CurrentDisplay?: string;
    FileExtension?: string;
    IsDeleted?: boolean;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    CreatedBy?: number;
    ModifiedBy?: number;
    FileKey?: string;
    AttachmentFolderId?: number;
    Size?: string;
    FileMD5?: string;

    // Display Attributes
    AttachmentFileIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AttachmentFileIdMemoOfRecord? : MemoOfRecordEntity;
    // Duplicate property excluded
    // AttachmentFileIdMemoOfRecord : MemoOfRecordEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    Attachment? : AttachmentEntity[];
    AttachmentFileVersion? : AttachmentFileVersionEntity[];
    Licenses? : LicensesEntity[];
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface AttachmentAttachmentFileEntity extends DwOrmData {
    // Attributes
    AttachmentFileId?: number;
    AttachmentFolderId?: number;
    CurrentDisplay?: string;
    FileExtension?: string;
    FileKey?: string;
    Size?: string;
    IsDeleted?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AttachmentFolderIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    AttachmentConversion? : AttachmentConversionEntity[];
}

export interface AttachmentFileVersionEntity extends DwOrmData {
    // Attributes
    AttachmentFileVersion?: number;
    AttachmentFileId?: number;

    // Display Attributes
    AttachmentFileIdDisplay?: string;

    // Relations
    AttachmentFile? : AttachmentFileEntity;
}

export interface AttachmentFolderEntity extends DwOrmData {
    // Attributes
    AttachmentFolderId?: number;
    AttachmentId?: number;
    FolderName?: string;
    ParentAttachmentFolderId?: number;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    PermissionNeeded?: string;

    // Display Attributes
    AttachmentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface AttachmentAttachmentFolderEntity extends DwOrmData {
    // Attributes
    AttachmentFolderId?: number;
    FolderName?: string;
    ParentAttachmentFolderId?: number;
    PermissionNeeded?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    ParentAttachmentFolderIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ParentAttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    AttachmentConversion? : AttachmentConversionEntity[];
    AttachmentAttachmentFile? : AttachmentAttachmentFileEntity[];
    ParentAttachmentObject? : AttachmentObjectEntity[];
    AttachmentFileIdLicenses? : LicensesEntity[];
    // Duplicate property excluded
    // ParentAttachmentAttachmentFolder : AttachmentAttachmentFolderEntity[];
}

export interface AttachmentObjectEntity extends DwOrmData {
    // Attributes
    ParentAttachmentFolderId?: number;
    AttachmentObjectId?: number;

    // Display Attributes
    ParentAttachmentFolderIdDisplay?: string;

    // Relations
    ParentAttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity;
    AttachmentConversion? : AttachmentConversionEntity[];
}

export interface AuctionEntity extends DwOrmData {
    // Attributes
    AuctionId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    VehicleId?: number;
    Color?: string;
    Mileage?: number;
    ConditionCv?: number;
    Duration?: number;
    LegacyUnitId?: string;
    Description?: string;
    StatusCv?: number;
    LocationCity?: string;
    LocationStateProvinceId?: number;
    LocationZip?: string;
    StartingPrice?: number;
    StartDateTime?: string;
    FinalPrice?: number;
    NoteParentId?: number;
    MediaGroupId?: number;
    Title?: string;
    EndDateTime?: string;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    VehicleIdDisplay?: string;
    ConditionCvDisplay?: string;
    StatusCvDisplay?: string;
    LocationStateProvinceIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    ConditionCvCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    LocationEthosStateProvince? : EthosStateProvinceEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
    BidHistory? : BidHistoryEntity[];
    RoAuction? : RoAuctionEntity[];
}

export interface AuditIssueEntity extends DwOrmData {
    // Attributes
    IssueId?: number;
    AuditName?: string;
    AuditStartDate?: string;
    AuditCompleteDate?: string;
    AuditorEthosUserId?: number;
    Process?: string;
    IssueDetail?: string;
    RecommendationDetail?: string;
    IssueRatingId?: number;
    IssueRatingNote?: string;
    IssueRiskTypeId?: number;
    IssueOwnerEthosUserId?: number;
    ELTManagerEthosUserId?: number;
    OwnerActionPlan?: string;
    ActionPlanDueDate?: string;
    MediaGroupId?: number;
    IssueStatusId?: number;
    RequestUpdate?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    DelegatedOwnerEthosUserid?: number;
    IssueName?: string;

    // Display Attributes
    AuditorEthosUserIdDisplay?: string;
    IssueRatingIdDisplay?: string;
    IssueRiskTypeIdDisplay?: string;
    IssueOwnerEthosUserIdDisplay?: string;
    ELTManagerEthosUserIdDisplay?: string;
    IssueStatusIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    DelegatedOwnerEthosUseridDisplay?: string;

    // Relations
    AuditIssueRating? : AuditIssueRatingEntity;
    AuditIssueRiskType? : AuditIssueRiskTypeEntity;
    AuditIssueStatus? : AuditIssueStatusEntity;
    AuditorEthosEthosUser? : EthosUserEntity;
    IssueOwnerEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    ELTManagerEthosEthosUser? : EthosUserEntity;
    DelegatedOwnerEthosUseridEthosUser? : EthosUserEntity;
    RoAuditSupervisorAccess? : RoAuditSupervisorAccessEntity[];
}

export interface AuditIssueRatingEntity extends DwOrmData {
    // Attributes
    IssueRatingId?: number;
    IssueRating?: string;
    SortOrder?: number;
    IsActive?: boolean;


    // Relations
    AuditIssue? : AuditIssueEntity[];
}

export interface AuditIssueRiskTypeEntity extends DwOrmData {
    // Attributes
    IssueRiskTypeId?: number;
    IssueRiskType?: string;
    SortOrder?: number;
    IsActive?: boolean;


    // Relations
    AuditIssue? : AuditIssueEntity[];
}

export interface AuditIssueStatusEntity extends DwOrmData {
    // Attributes
    IssueStatusId?: number;
    IssueStatus?: string;
    SortOrder?: number;
    IsActive?: boolean;


    // Relations
    AuditIssue? : AuditIssueEntity[];
}

export interface BidHistoryEntity extends DwOrmData {
    // Attributes
    BidHistoryId?: number;
    AuctionId?: number;
    BidderName?: string;
    Amount?: number;
    Notes?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;
    AppUserId?: number;

    // Display Attributes
    AuctionIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    Auction? : AuctionEntity;
    CreatedByEthosUser? : EthosUserEntity;
}

export interface BillingEntity extends DwOrmData {
    // Attributes
    BillingId?: number;
    KickoffId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    BillingTypeCv?: number;
    JobNumberId?: number;
    ParentJobNumberId?: number;
    InvoiceFrequencyCv?: number;
    EstimatedBillingDate?: string;
    Notes?: string;
    HybridKey?: string;
    InterdepartmentalBilling?: boolean;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    BillingTypeCvDisplay?: string;
    JobNumberIdDisplay?: string;
    ParentJobNumberIdDisplay?: string;
    InvoiceFrequencyCvDisplay?: string;

    // Relations
    BillingTypeCvCodeValue? : CodeValueEntity;
    InvoiceFrequencyCvCodeValue? : CodeValueEntity;
    ParentEthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    BillingDepartment? : BillingDepartmentEntity[];
}

export interface BillingDepartmentEntity extends DwOrmData {
    // Attributes
    BillingDeptId?: number;
    BillingId?: number;
    WachterDepartmentId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    BillingIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    Billing? : BillingEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface ChangeRequestEntity extends DwOrmData {
    // Attributes
    ChangeRequestId?: number;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;
    NoteId?: number;
    InProgress?: boolean;
    InitialPermitStatusId?: number;
    CompletedByUserId?: number;
    CompletedOnDateTime?: string;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    NoteIdDisplay?: string;
    InitialPermitStatusIdDisplay?: string;
    CompletedByUserIdDisplay?: string;

    // Relations
    NotesNote? : NotesNoteEntity;
    InitialPermits2PermitStatus? : Permits2PermitStatusEntity;
    CreatedByEthosUser? : EthosUserEntity;
    CompletedByEthosUser? : EthosUserEntity;
    Permits2Permit? : Permits2PermitEntity[];
}

export interface ChecklistEntity extends DwOrmData {
    // Attributes
    ChecklistId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Item?: string;
    Number?: number;

    // Display Attributes
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    KickoffChecklist? : KickoffChecklistEntity[];
}

export interface CodeSetEntity extends DwOrmData {
    // Attributes
    CodeSetId?: number;
    CodeSetName?: string;
    IsCustomCodeSet?: boolean;


    // Relations
    CodeValue? : CodeValueEntity;
}

export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    CodeSet? : CodeSetEntity[];
    AccessControlCvAccessControl? : AccessControlEntity[];
    AccessControlCvPermits2AccessControl? : Permits2AccessControlEntity[];
    TypeCvAccident? : AccidentEntity[];
    ConditionCvAuction? : AuctionEntity[];
    StatusCvAuction? : AuctionEntity[];
    BillingTypeCvBilling? : BillingEntity[];
    InvoiceFrequencyCvBilling? : BillingEntity[];
    StatusCvCompanyLicense? : CompanyLicenseEntity[];
    RoleCvDepartmentRole? : DepartmentRoleEntity[];
    IssueSubTypeIdEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    StatusCvEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    ConclusionCvEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    RatingValueFiveStarRating? : FiveStarRatingEntity[];
    PreferredTimeOfDayCvInspection? : InspectionEntity[];
    ResultCvInspection? : InspectionEntity[];
    PreferredTimeOfDayCvPermits2Inspection? : Permits2InspectionEntity[];
    StatusCvLicenses? : LicensesEntity[];
    EmployeeTypeCvMemoOfRecord? : MemoOfRecordEntity[];
    StatusCvMemoOfRecord? : MemoOfRecordEntity[];
    ConclusionCvMemoOfRecord? : MemoOfRecordEntity[];
    StatusCvPayJobChange? : PayJobChangeEntity[];
    PayChangeTypeCvPayJobChange? : PayJobChangeEntity[];
    StatusCvPayJobChangeWorkflowEmail? : PayJobChangeWorkflowEmailEntity[];
    CableTypeCvPermit? : PermitEntity[];
    ElectricalWorkTypeCvPermit? : PermitEntity[];
    FireAlarmDemoInstallCvPermit? : PermitEntity[];
    AccessControlTypeCvPermit? : PermitEntity[];
    CCTVInstallTypeCvPermit? : PermitEntity[];
    ElectricalDifferentTypeCvPermit? : PermitEntity[];
    ElectricalOutletTypeCvPermit? : PermitEntity[];
    InspectionStateCvPermit? : PermitEntity[];
    PermitRequestTypeCvPermits2Permit? : Permits2PermitEntity[];
    CCTVInstallTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalDifferentTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalOutletTypeCvPermits2Permit? : Permits2PermitEntity[];
    ElectricalWorkTypeCvPermits2Permit? : Permits2PermitEntity[];
    FireAlarmDemoInstallCvPermits2Permit? : Permits2PermitEntity[];
    PermitTypeCvPermitPermitType? : PermitPermitTypeEntity[];
    ElectricalWorkTypeCvPermitRequest? : PermitRequestEntity[];
    FireAlarmDemoInstallCvPermitRequest? : PermitRequestEntity[];
    AccessControlCVPermitRequest? : PermitRequestEntity[];
    AccessControlOtherTypeCvPermitRequest? : PermitRequestEntity[];
    PermitRequestTypeCvPermitRequest? : PermitRequestEntity[];
    AudioCableTypeCVPermitRequest? : PermitRequestEntity[];
    CCTVCableTypeCVPermitRequest? : PermitRequestEntity[];
    CCTVInstallTypeCvPermitRequest? : PermitRequestEntity[];
    StatusCvPermitRequest? : PermitRequestEntity[];
    VoiceDataCableTypeCVPermitRequest? : PermitRequestEntity[];
    ElectricalDifferentTypeCvPermitRequest? : PermitRequestEntity[];
    ElectricalOutletTypeCvPermitRequest? : PermitRequestEntity[];
    PermitTypeCvPermitRequestPermitType? : PermitRequestPermitTypeEntity[];
    DeliveryOptionCvRequest? : RequestEntity[];
    TransportationPlanCvTravelRequest? : TravelRequestEntity[];
    TravelModeCvTravelRequest? : TravelRequestEntity[];
    AirportPlanCvTravelRequest? : TravelRequestEntity[];
    LodgingPlanCvTravelRequest? : TravelRequestEntity[];
    TravelTypeCvTravelRequest? : TravelRequestEntity[];
    CableTypeCvPermits2RequiredCable? : Permits2RequiredCableEntity[];
    ReasonForLeavingCvTermResign? : TermResignEntity[];
    TechTypeCvMtlUserExtended? : MtlUserExtendedEntity[];
    WorkStatusCvEmsUserExtended? : EmsUserExtendedEntity[];
    VehicleStatusCvFleetVehicle? : FleetVehicleEntity[];
    VehicleTypeCvFleetVehicle? : FleetVehicleEntity[];
    OwnershipTypeCvFleetVehicle? : FleetVehicleEntity[];
    DriveTrainCvFleetVehicle? : FleetVehicleEntity[];
    AccidentAtFaultCvVehicleAccident? : VehicleAccidentEntity[];
    AccidentTypeCvVehicleAccident? : VehicleAccidentEntity[];
    ClaimInsuranceCompanyCvVehicleAccident? : VehicleAccidentEntity[];
    ClaimStatusCvVehicleAccident? : VehicleAccidentEntity[];
    VehicleRepairedCvVehicleAccident? : VehicleAccidentEntity[];
    InjuryTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    AccidentTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    BodyPartCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    BodySideCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    WorksiteTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    ClaimStatusCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    InHouseClaimStatusCvWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface CollaborationEntity extends DwOrmData {
    // Attributes
    CollaborationId?: number;
    FromDepartmentId?: number;
    FromPmUserId?: number;
    ToDepartmentId?: number;
    ToPmUserId?: number;
    CustomerName?: string;
    CustomerPm?: string;
    CustomerTitle?: string;
    ProjectName?: string;
    SiteCount?: number;
    RevenuePerSite?: number;
    CollaborationDate?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    FromDepartmentIdDisplay?: string;
    FromPmUserIdDisplay?: string;

    // Relations
    FromPmEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ToPmEthosUser? : EthosUserEntity;
    FromDepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
    ToDepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
    CollaborationDepartment? : CollaborationDepartmentEntity[];
    CollaborationPm? : CollaborationPmEntity[];
}

export interface CollaborationDepartmentEntity extends DwOrmData {
    // Attributes
    CollaborationDepartmentId?: number;
    CollaborationId?: number;
    DepartmentId?: number;

    // Display Attributes
    CollaborationIdDisplay?: string;
    DepartmentIdDisplay?: string;

    // Relations
    Collaboration? : CollaborationEntity;
    DepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface CollaborationPmEntity extends DwOrmData {
    // Attributes
    CollaborationPmId?: number;
    CollaborationId?: number;
    ProjectManagerId?: number;

    // Display Attributes
    CollaborationIdDisplay?: string;
    ProjectManagerIdDisplay?: string;

    // Relations
    Collaboration? : CollaborationEntity;
    ProjectManagerIdEthosUser? : EthosUserEntity;
}

export interface CompanyEntity extends DwOrmData {
    // Attributes
    CompanyId?: number;
    Company?: string;
    AcctNumber?: string;
    Email?: string;
    CompanyOrder?: number;
    IsActive?: boolean;


    // Relations
    Request? : RequestEntity[];
}

export interface CompanyLicenseEntity extends DwOrmData {
    // Attributes
    CompanyLicenseId?: number;
    Title?: string;
    LicenseId?: string;
    CompanyLicenseTypeId?: number;
    ExpirationDate?: string;
    IssueDate?: string;
    IsBond?: boolean;
    StateId?: number;
    County?: string;
    City?: string;
    Authority?: string;
    BondExpirationDate?: string;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    NoteParentId?: number;
    MediaGroupId?: number;
    StatusCv?: number;
    QualifierUserId?: number;
    WachterCompanyId?: number;
    SequenceId?: number;
    IsQualifierExpected?: boolean;

    // Display Attributes
    CompanyLicenseTypeIdDisplay?: string;
    StateIdDisplay?: string;
    StatusCvDisplay?: string;
    QualifierUserIdDisplay?: string;
    WachterCompanyIdDisplay?: string;

    // Relations
    StatusCvCodeValue? : CodeValueEntity;
    CompanyLicenseType? : CompanyLicenseTypeEntity;
    StateIdEthosStateProvince? : EthosStateProvinceEntity;
    QualifierEthosUser? : EthosUserEntity;
    EthosWachterCompany? : EthosWachterCompanyEntity;
}

export interface CompanyLicenseTypeEntity extends DwOrmData {
    // Attributes
    CompanyLicenseTypeId?: number;
    Display?: string;
    IsActive?: boolean;

    // Display Attributes
    CompanyLicenseTypeIdDisplay?: string;

    // Relations
    CompanyLicense? : CompanyLicenseEntity[];
}

export interface CovidConfigurationEntity extends DwOrmData {
    // Attributes
    CovidConfigurationId?: number;
    TestFrequencyDays?: number;
    QuarantineDays?: number;
    TestStartAfterPositiveDays?: number;
    EffectiveStartDate?: string;
    RequireWeeklyTesting?: boolean;
    EffectiveEndDate?: string;
    ShowHomePageContent?: boolean;
    HomePageMessage?: string;
    ReminderEmail1DaysBefore?: number;
    ReminderEmail2DaysBefore?: number;
    ReminderEmail3DaysBefore?: number;


    // Relations
}

export interface CovidTestResultTypeEntity extends DwOrmData {
    // Attributes
    CovidTestResultTypeId?: number;
    CovidTestResultType?: string;


    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidTestStatusEntity extends DwOrmData {
    // Attributes
    CovidTestStatusId?: number;
    CovidTestStatus?: string;
    CovidTestStatusActionTest?: string;
    ButtonClasses?: string;


    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidTestTypeEntity extends DwOrmData {
    // Attributes
    CovidTestTypeId?: number;
    CovidTestType?: string;


    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidVaccinationStatusEntity extends DwOrmData {
    // Attributes
    CovidVaccinationStatusId?: number;
    CovidVaccinationStatus?: string;


    // Relations
    EmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    PreviousEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    EmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface CovidVaccinationSubmissionStatusEntity extends DwOrmData {
    // Attributes
    CovidVaccinationSubmissionStatusId?: number;
    StatusDisplay?: string;
    StatusActionText?: string;
    ButtonClasses?: string;


    // Relations
    EmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface CovidVaccineTypeEntity extends DwOrmData {
    // Attributes
    CovidVaccineTypeId?: number;
    CovidVaccineType?: string;
    RequiredShots?: number;


    // Relations
    BoosterVaccine1TypeIdEmployeeSummary? : EmployeeSummaryEntity[];
    VaccineTypeIdEmployeeSummary? : EmployeeSummaryEntity[];
    VaccinationTypeIdEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    BoosterVaccine1TypeIdEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface CovidWorkStatusEntity extends DwOrmData {
    // Attributes
    CovidWorkStatusId?: number;
    CovidWorkStatus?: string;


    // Relations
    EmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    PreviousEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface DevwareCustomAttributeValueEntity extends DwOrmData {
    // Attributes
    CustomAttributeValueId?: number;
    MetaDataItemId?: number;
    KeyValue?: number;
    RowIndex?: number;
    CustomAttr1Value?: string;
    CustomAttr1Display?: string;
    CustomAttr2Value?: string;
    CustomAttr2Display?: string;
    CustomAttr3Value?: string;
    CustomAttr3Display?: string;
    CustomAttr4Value?: string;
    CustomAttr4Display?: string;
    CustomAttr5Value?: string;
    CustomAttr5Display?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
}

export interface CustomerSatisfactionEntity extends DwOrmData {
    // Attributes
    CustomerSatisfactionId?: number;
    Customer?: string;
    PmUserId?: number;
    City?: string;
    State?: string;
    SiteLocation?: string;
    Description?: string;
    Damage?: number;
    CustomerSatisfactionDate?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    PmUserIdDisplay?: string;

    // Relations
    ModifiedByEthosEthosUser? : EthosUserEntity;
    PmEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface DepartmentAdditionalBurdenEntity extends DwOrmData {
    // Attributes
    DepartmentAdditionalBurdenId?: number;
    Ethos_DepartmentId?: number;
    EmployeeGroupId?: number;
    AdditionalBurdenAmount?: number;

    // Display Attributes
    Ethos_DepartmentIdDisplay?: string;

    // Relations
    EthosDepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface DepartmentMapEntity extends DwOrmData {
    // Attributes
    DepartmentMapId?: number;
    WachterDepartmentId?: number;
    Group?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;

    // Relations
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface DepartmentRoleEntity extends DwOrmData {
    // Attributes
    DepartmentRoleId?: number;
    Ethos_WachterDepartmentId?: number;
    Ethos_UserId?: number;
    RoleCv?: number;

    // Display Attributes
    Ethos_WachterDepartmentIdDisplay?: string;
    Ethos_UserIdDisplay?: string;
    RoleCvDisplay?: string;

    // Relations
    RoleCvCodeValue? : CodeValueEntity;
    EthosEthosUser? : EthosUserEntity;
    EthosEthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface DWOSGFinDataEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    MonthIdALT?: number;
    Period?: string;
    Month?: string;
    MonthShort?: string;
    Section_01?: string;
    OpportunityId?: number;
    OpportunityNo?: string;
    OpportunityName?: string;
    JobNumberId?: number;
    ETHOSJobNumberId?: number;
    JobNumber?: string;
    JobName?: string;
    JobNameLong?: string;
    JobStatus?: string;
    JobGroup?: string;
    JobRestrictedShort?: string;
    JobRestricted?: string;
    RevRecMethod?: string;
    JobCategory?: string;
    JobNumberType?: string;
    JobType?: string;
    JobBillingType?: string;
    JobFacilityType?: string;
    JobInvoiceType?: string;
    JobStartDate?: string;
    JobEndDate?: string;
    JobCloseDate?: string;
    JobDurationDays?: string;
    JobWorkDays?: string;
    ProjectManager?: string;
    SrProjectManager?: string;
    Section_02?: string;
    PhaseCode?: string;
    Phase?: string;
    PhaseLong?: string;
    Section_03?: string;
    TeamId?: number;
    TeamCode?: string;
    Team?: string;
    TeamLong?: string;
    DepartmentCode?: string;
    Department?: string;
    DepartmentLong?: string;
    DivisionCode?: string;
    Division?: string;
    DivisionLong?: string;
    CompanyCode?: string;
    Company?: string;
    CompanyLong?: string;
    Section_04?: string;
    CustomerChildId?: number;
    ETHOSCustomerId?: number;
    CustomerChildNo?: string;
    CustomerChild?: string;
    CustomerId?: number;
    CustomerNo?: string;
    Customer?: string;
    CustomerAlias?: string;
    CustomerNAM?: string;
    Section_05?: string;
    fcHours?: number;
    fcHours_Ytd?: number;
    fcHours_Jtd?: number;
    fcRev?: number;
    fcRev_Ytd?: number;
    fcRev_Jtd?: number;
    fcCost?: number;
    fcCost_Ytd?: number;
    fcCost_Jtd?: number;
    Revenue?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Hours?: number;
    Hours_Ytd?: number;
    Hours_Jtd?: number;
    Cost?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;
    Section_06?: string;
    LatestRecordperPeriod?: boolean;
    LatestRecordperYear?: boolean;
    LatestRecord?: boolean;
    OSGFinDataId?: number;


    // Relations
}

export interface DWOSGFinDataLatestEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    MonthIdALT?: number;
    Period?: string;
    Month?: string;
    MonthShort?: string;
    Section_01?: string;
    OpportunityId?: number;
    OpportunityNo?: string;
    OpportunityName?: string;
    JobNumberId?: number;
    ETHOSJobNumberId?: number;
    JobNumber?: string;
    JobName?: string;
    JobNameLong?: string;
    JobStatus?: string;
    JobGroup?: string;
    JobRestrictedShort?: string;
    JobRestricted?: string;
    RevRecMethod?: string;
    JobCategory?: string;
    JobNumberType?: string;
    JobType?: string;
    JobBillingType?: string;
    JobFacilityType?: string;
    JobInvoiceType?: string;
    JobStartDate?: string;
    JobEndDate?: string;
    JobCloseDate?: string;
    JobDurationDays?: string;
    JobWorkDays?: string;
    ProjectManager?: string;
    SrProjectManager?: string;
    Section_02?: string;
    PhaseCode?: string;
    Phase?: string;
    PhaseLong?: string;
    Section_03?: string;
    TeamId?: number;
    TeamCode?: string;
    Team?: string;
    TeamLong?: string;
    DepartmentCode?: string;
    Department?: string;
    DepartmentLong?: string;
    DivisionCode?: string;
    Division?: string;
    DivisionLong?: string;
    CompanyCode?: string;
    Company?: string;
    CompanyLong?: string;
    Section_04?: string;
    CustomerChildId?: number;
    ETHOSCustomerId?: number;
    CustomerChildNo?: string;
    CustomerChild?: string;
    CustomerChildLong?: string;
    CustomerId?: number;
    CustomerNo?: string;
    Customer?: string;
    CustomerAlias?: string;
    CustomerNAM?: string;
    Section_05?: string;
    fcHours?: number;
    fcHours_Ytd?: number;
    fcHours_Jtd?: number;
    fcRev?: number;
    fcRev_Ytd?: number;
    fcRev_Jtd?: number;
    fcCost?: number;
    fcCost_Ytd?: number;
    fcCost_Jtd?: number;
    Revenue?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Hours?: number;
    Hours_Ytd?: number;
    Hours_Jtd?: number;
    Cost?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;
    Section_06?: string;
    LatestRecordperPeriod?: boolean;
    LatestRecordperYear?: boolean;
    LatestRecord?: boolean;
    OSGFinDataId?: number;
    PmEthos_UserId?: number;
    OrganizationalUnitId?: number;
    PhaseId?: number;
    JobNumberIsOverhead?: boolean;
    TeamUnitId?: number;
    TeamUnitIsTeam?: boolean;
    WachterDepartmentId?: number;
    HasRevenue?: boolean;
    OSGFinDataDateTime?: string;
    // Attribute fcRev-PYs has invalid characters and can't be included
    // Attribute fcpcRev-PYs has invalid characters and can't be included
    // Attribute fcCost-PYs has invalid characters and can't be included
    // Attribute fcGP-PYs has invalid characters and can't be included
    // Attribute fcpcGP-PYs has invalid characters and can't be included
    OrganizationalEntityId?: number;

    // Display Attributes
    OrganizationalEntityIdDisplay?: string;

    // Relations
    OrganizationalEntity? : OrganizationalEntityEntity;
}

export interface DWPeoplePaySummaryEntity extends DwOrmData {
    // Attributes
    PPSId?: number;
    PersonId?: number;
    ETHOSUserId?: number;
    ETHOSLoginId?: string;
    AXPersonnelNo?: string;
    AXWorkerNo?: number;
    Section_PERSON?: string;
    Person?: string;
    PersonLong?: string;
    LastNameFirst?: string;
    LastNameFirstPreferred?: string;
    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    PreferredName?: string;
    EffectiveUserName?: string;
    Email?: string;
    JobTitle?: string;
    PersonwJobTitle?: string;
    Section_TIME?: string;
    BirthMonth?: string;
    BirthDateNoYr?: string;
    HireDate?: string;
    YrsService?: number;
    StartDate?: string;
    AdjStartDate?: string;
    ServiceDate?: string;
    ServiceAwardMonth?: string;
    TermDate?: string;
    ReportDate?: string;
    Section_SUPERVISOR?: string;
    SupervisorId?: number;
    SupETHOSUserId?: number;
    Supervisor?: string;
    SupervisorwJobTitle?: string;
    Section_DIMENSIONs?: string;
    GroupCode?: string;
    Group?: string;
    GroupParent?: string;
    JobFunctionCode?: string;
    JobFunction?: string;
    Office?: string;
    ExemptStatus?: string;
    StaffingAgency?: string;
    Status?: string;
    Type?: string;
    TypeGroup?: string;
    Section_WACHTERORG?: string;
    PeopleTeamCode?: string;
    PeopleTeam?: string;
    PeopleTeamLong?: string;
    PeopleTeamMethod?: string;
    PeopleDepartmentCode?: string;
    PeopleDepartment?: string;
    PeopleDepartmentLong?: string;
    PeopleDivisionCode?: string;
    PeopleDivision?: string;
    PeopleDivisionLong?: string;
    PeopleBusinessCode?: string;
    PeopleBusiness?: string;
    PeopleBusinessLong?: string;
    PeopleGroupCode?: string;
    PeopleGroup?: string;
    PeopleGroupLong?: string;
    Section_FLAGs?: string;
    HasHours?: boolean;
    HasJobTitle?: boolean;
    HasSkillComm?: boolean;
    HasSkillElectrical?: boolean;
    HasSkillSecurity?: boolean;
    HasValidSupervisor?: boolean;
    HasValidTeam?: boolean;
    IsActive?: boolean;
    IsEngineer?: boolean;
    IsTerminated?: boolean;
    IsWachterEmp?: boolean;
    SupForcedAssign?: boolean;
    Section_AMOUNTs?: string;
    PayRate?: number;
    PayRate_cur?: number;
    PayRate_cur_Date?: string;
    PayRate_last?: number;
    PayRate_last_Date?: string;
    PayRate_first?: number;
    PayRate_first_Date?: string;
    SinceLast_RateChg_Date?: string;
    SinceLast_RateChg?: number;
    SinceLast_RateChg_Text?: string;
    BurdenRate?: number;
    BurdenRate_cur?: number;
    BurdenRate_cur_Date?: string;
    BurdenRate_last?: number;
    BurdenRate_last_Date?: string;
    BurdenRate_first?: number;
    BurdenRate_first_Date?: string;
    BillRate?: number;
    BillRate_cur?: number;
    BillRate_cur_Date?: string;
    BillRate_last?: number;
    BillRate_last_Date?: string;
    BillRate_first?: number;
    BillRate_first_Date?: string;
    PersonId_MASTER?: number;
    RowNo?: number;
    Max_Record?: string;
    DataAreaId?: string;
    DriveRate?: number;
    DriveRate_cur?: number;
    DriveRate_cur_Date?: string;
    DriveRate_last?: number;
    DriveRate_last_Date?: string;
    DriveRate_first?: number;
    DriveRate_first_Date?: string;

    // Display Attributes
    ETHOSUserIdDisplay?: string;

    // Relations
    ETHOSUserIdEmsUserExtended? : EmsUserExtendedEntity;
    ETHOSUserIdRoEthosUserGrid? : RoEthosUserGridEntity;
    ETHOSRoEthosUser? : RoEthosUserEntity;
    EthosUserIdResourceCost? : ResourceCostEntity[];
}

export interface DWPersonMergeEntity extends DwOrmData {
    // Attributes
    PMId?: number;
    PersonMergeId?: number;
    Section_FROM?: string;
    FROM_PersonId?: number;
    FROM_ETHOSUserId?: number;
    FROM_Name?: string;
    FROM_PersonGroupCode?: string;
    FROM_PersonGroup?: string;
    FROM_PersonGroupParent?: string;
    FROM_PersonJobTitle?: string;
    FROM_PersonStaffingAgency?: string;
    TermDate?: string;
    Section_TO?: string;
    TO_PersonId?: number;
    TO_ETHOSUserId?: number;
    TO_Name?: string;
    TO_PersonGroupCode?: string;
    TO_PersonGroup?: string;
    TO_PersonGroupParent?: string;
    TO_PersonJobTitle?: string;
    TO_PersonStaffingAgency?: string;
    HireDate?: string;
    Rehire?: boolean;
    RehireDate?: string;


    // Relations
}

export interface DWPersonMergeLogEntity extends DwOrmData {
    // Attributes
    PersonMergeLogId?: number;
    PMId?: number;
    FROM_ETHOSUserId?: number;
    TO_ETHOSUserId?: number;


    // Relations
}

export interface DWTrustForecastDataEntity extends DwOrmData {
    // Attributes
    TransactionId?: string;
    RecId?: number;
    LedgerDimension?: number;
    CategoryCode?: string;
    CurrencyCode?: string;
    DataAreaId?: string;
    DataSourceCode?: string;
    MeasureName?: string;
    ForecastEntryCode?: string;
    ForecastKindCode?: string;
    AXWorkerNo?: string;
    InvoiceNo?: string;
    InvoiceLineNo?: number;
    JobNumber?: string;
    SubJobNumber?: string;
    JobGroupCode?: string;
    JobStatusCode?: string;
    JobRestrictedCode?: string;
    TransComment?: string;
    DepartmentCode?: string;
    TeamCode?: string;
    Year?: number;
    MonthNo?: number;
    MonthIdALT?: number;
    Period?: string;
    ReportDate?: string;
    LedgerTransDate?: string;
    ProjTransDate?: string;
    DateIssue?: boolean;
    WIPPeriodDate?: string;
    CreatedDate?: string;
    ModifiedDate?: string;
    ActualCloseDate?: string;
    TrustIntegrationId?: number;
    TrustSourceId?: number;
    _InPTC?: string;
    LCUR_ForecastRev?: number;
    LCUR_ForecastCost?: number;
    TransactionKey?: string;
    ActivityNo?: string;


    // Relations
}

export interface DWWorkInProcessEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    MonthIdALT?: number;
    Period?: string;
    Section_01?: string;
    DataAreaId?: string;
    JobNumberId?: number;
    JobNumber?: string;
    WachterJobNumberId?: number;
    Stage?: string;
    JobStatusId?: number;
    JobStatus?: string;
    JobGroupId?: number;
    JobGroup?: string;
    JobRestrictedId?: number;
    JobRestrictedShort?: string;
    JobRestricted?: string;
    RevRecMethod?: string;
    ProjectManagerId?: number;
    ProjectManagerUserId?: number;
    ProjectManager?: string;
    WachterTeamId?: number;
    WachterTeamCode?: string;
    WachterTeamUserId?: number;
    WachterTeamSteward?: string;
    WachterDepartmentId?: number;
    WachterDepartmentCode?: string;
    WachterDepartmentUserId?: number;
    WachterDepartmentSteward?: string;
    WachterDivisionId?: number;
    WachterDivisionCode?: string;
    WachterDivisionUserId?: number;
    WachterDivisionSteward?: string;
    Section_02?: string;
    Section_03?: string;
    Section_04?: string;
    Section_05?: string;
    Section_06?: string;
    Section_07?: string;
    Section_08?: string;
    LastProcessed?: string;
    LastForecastRepl?: string;
    Section_09?: string;
    fcRevob?: number;
    fcRevoh?: number;
    fcRevo?: number;
    fcRevab?: number;
    fcRevah?: number;
    fcReva?: number;
    fcRevb?: number;
    fcRevh?: number;
    fcRev?: number;
    fcCostob?: number;
    fcCostoh?: number;
    fcCosto?: number;
    fcCostab?: number;
    fcCostah?: number;
    fcCosta?: number;
    fcCostb?: number;
    fcCosth?: number;
    fcCost?: number;
    fcGPob?: number;
    fcGPoh?: number;
    fcGPo?: number;
    fcGPab?: number;
    fcGPah?: number;
    fcGPa?: number;
    fcGPb?: number;
    fcGPh?: number;
    fcGP?: number;
    fcGPmob?: number;
    fcGPmoh?: number;
    fcGPmo?: number;
    fcGPmab?: number;
    fcGPmah?: number;
    fcGPma?: number;
    fcGPmb?: number;
    fcGPmh?: number;
    fcGPm?: number;
    Cost_Jtd?: number;
    Cost_Ytd?: number;
    Cost_PrYr?: number;
    Cost_PrYrs?: number;
    Overhead_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_PrYr?: number;
    Overhead_PrYrs?: number;
    pcRev_Jtd?: number;
    pcRev_Ytd?: number;
    pcRev_PrYr?: number;
    pcRev_PrYrs?: number;
    pcRevDiff_Jtd?: number;
    pcRevDiff_Ytd?: number;
    pcRevDiff_PrYr?: number;
    pcGP_Jtd?: number;
    pcGP_Ytd?: number;
    pcGP_PrYr?: number;
    pcGPm_Jtd?: number;
    pcGPm_Ytd?: number;
    pcGPm_PrYr?: number;
    Revenue_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_PrYr?: number;
    Revenue_PrYrs?: number;
    GP_Jtd?: number;
    GP_Ytd?: number;
    GP_PrYr?: number;
    GPm_Jtd?: number;
    GPm_Ytd?: number;
    GPm_PrYr?: number;
    Billed_Jtd?: number;
    Billed_Ytd?: number;
    Billed_PrYr?: number;
    Invoiced_Jtd?: number;
    Invoiced_Ytd?: number;
    Invoiced_PrYr?: number;
    Settled_Jtd?: number;
    Settled_Ytd?: number;
    Settled_PrYr?: number;
    // Attribute %Complete has invalid characters and can't be included
    Backlog_Rev?: number;
    Backlog_Cost?: number;
    Backlog_GP?: number;
    Backlog_GPm?: number;
    pcBacklog_Rev?: number;
    pcBacklog_GP?: number;
    pcBacklog_GPm?: number;
    OverUnder?: number;
    pcOverUnder?: number;
    Backlog_Bill?: number;
    // Attribute %Settled has invalid characters and can't be included
    BalanceDue?: number;
    WithinTerms?: number;
    PastDue?: number;
    // Attribute PastDue% has invalid characters and can't be included
    // Attribute 1to30 has invalid characters and can't be included
    // Attribute 31to60 has invalid characters and can't be included
    // Attribute 61to90 has invalid characters and can't be included
    // Attribute 91to120 has invalid characters and can't be included
    // Attribute 121+ has invalid characters and can't be included
    // Attribute fcRev-PYs has invalid characters and can't be included
    // Attribute fcpcRev-PYs has invalid characters and can't be included
    // Attribute fcCost-PYs has invalid characters and can't be included
    // Attribute fcGP-PYs has invalid characters and can't be included
    // Attribute fcpcGP-PYs has invalid characters and can't be included
    // Attribute fcGPm-PYs has invalid characters and can't be included
    // Attribute fcpcGPm-PYs has invalid characters and can't be included
    WOTeamId?: number;


    // Relations
}

export interface EmaulationUserEntity extends DwOrmData {
    // Attributes
    EmulationUserId?: number;
    Ethos_UserId?: number;
    EmulateEthos_UserId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    EmulateEthos_UserIdDisplay?: string;

    // Relations
    EmulateEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface EmployeeReminderNotificationEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryId?: number;
    DaysUntilNextTest?: number;
    NextTestDate?: string;
    CreatedDateTime?: string;
    EmployeeReminderNotificationId?: number;

    // Display Attributes
    EmployeeSummaryIdDisplay?: string;

    // Relations
    EmployeeSummary? : EmployeeSummaryEntity;
}

export interface EmployeeReviewEntity extends DwOrmData {
    // Attributes
    EmployeeReviewId?: number;
    EmployeeReviewStatusId?: number;
    IsSupervisorReview?: boolean;
    ResponsibleForBidding?: boolean;
    EmployeeReviewSummaryId?: number;
    ResponsibleForRevenue?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    DueDate?: string;
    SubmittedDateTime?: string;

    // Display Attributes
    EmployeeReviewStatusIdDisplay?: string;
    EmployeeReviewSummaryIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    EmployeeReviewStatus? : EmployeeReviewStatusEntity;
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
}

export interface EmployeeReviewAnswerEntity extends DwOrmData {
    // Attributes
    EmplyeeReviewAnswerId?: number;
    EmployeeReviewId?: number;
    EmployeeReviewQuestionId?: number;
    EmployeeReviewAnswerValueId?: number;
    AnswerValueText?: string;

    // Display Attributes
    EmployeeReviewIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;
    EmployeeReviewAnswerValueIdDisplay?: string;

    // Relations
    EmployeeReview? : EmployeeReviewEntity;
    EmployeeReviewAnswerValue? : EmployeeReviewAnswerValueEntity;
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
}

export interface EmployeeReviewAnswerValueEntity extends DwOrmData {
    // Attributes
    EmployeeReviewAnswerValueId?: number;
    AnswerDisplay?: string;
    AnswerDescription?: string;
    Weight?: number;


    // Relations
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
}

export interface EmployeeReviewCategoryEntity extends DwOrmData {
    // Attributes
    EmployeeReviewCategoryId?: number;
    ReviewCategory?: string;
    IconClasses?: string;
    WachterContainerStyleId?: number;
    ReviewCategoryDescriptionHtml?: string;

    // Display Attributes
    WachterContainerStyleIdDisplay?: string;

    // Relations
    WachterContainerStyle? : WachterContainerStyleEntity;
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewQuestionEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionId?: number;
    EmployeeReviewCategoryId?: number;
    Question?: string;
    QuestionDetail?: string;
    EmployeeReviewQuestionTypeId?: number;
    QuestionOrder?: number;
    EmployeeReviewQuestionSkillId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;

    // Display Attributes
    EmployeeReviewCategoryIdDisplay?: string;
    EmployeeReviewQuestionTypeIdDisplay?: string;
    EmployeeReviewQuestionSkillIdDisplay?: string;

    // Relations
    EmployeeReviewCategory? : EmployeeReviewCategoryEntity;
    EmployeeReviewQuestionSkill? : EmployeeReviewQuestionSkillEntity;
    EmployeeReviewQuestionType? : EmployeeReviewQuestionTypeEntity;
    EmployeeReviewAnswer? : EmployeeReviewAnswerEntity[];
    EmployeeReviewQuestionRequestDetail? : EmployeeReviewQuestionRequestDetailEntity[];
    EmployeeReviewQuestionSetupDetail? : EmployeeReviewQuestionSetupDetailEntity[];
}

export interface EmployeeReviewQuestionRequestEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestId?: number;
    EmployeeReviewQuestionRequestStatusId?: number;
    SubmittedByEthos_UserId?: number;
    SubmittedByDateTime?: string;
    RejectedByEthos_UserId?: number;
    RejectedByDateTime?: string;
    RejectedNotes?: string;
    ApprovedByEthos_UserId?: number;
    ApprovedByDateTime?: string;

    // Display Attributes
    EmployeeReviewQuestionRequestStatusIdDisplay?: string;
    SubmittedByEthos_UserIdDisplay?: string;
    RejectedByEthos_UserIdDisplay?: string;
    ApprovedByEthos_UserIdDisplay?: string;

    // Relations
    EmployeeReviewQuestionRequestStatus? : EmployeeReviewQuestionRequestStatusEntity;
    SubmittedByEthosRoEthosUser? : RoEthosUserEntity;
    RejectedByEthosRoEthosUser? : RoEthosUserEntity;
    ApprovedByEthosEthosUser? : EthosUserEntity;
    RejectedByEthosEthosUser? : EthosUserEntity;
    SubmittedByEthosEthosUser? : EthosUserEntity;
    EmployeeReviewQuestionRequestDetail? : EmployeeReviewQuestionRequestDetailEntity[];
}

export interface EmployeeReviewQuestionRequestDetailEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestDetailId?: number;
    EmployeeReviewQuestionRequestId?: number;
    Question?: string;
    EmployeeReviewQuestionId?: number;

    // Display Attributes
    EmployeeReviewQuestionRequestIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;

    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
    EmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity;
}

export interface EmployeeReviewQuestionRequestStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionRequestStatusId?: number;
    ReviewStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;
    CurrentStatusActionText?: string;


    // Relations
    EmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
}

export interface EmployeeReviewQuestionSetupEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupId?: number;
    EmployeeReviewQuestionSetupLevelId?: number;
    WachterDepartmentId?: number;
    WachterTeamId?: number;
    ReviewYear?: number;
    HideRevenueQuestions?: boolean;
    HideBiddingQuestions?: boolean;

    // Display Attributes
    EmployeeReviewQuestionSetupLevelIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    WachterTeamIdDisplay?: string;

    // Relations
    EmployeeReviewQuestionSetupLevel? : EmployeeReviewQuestionSetupLevelEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    EmployeeReviewQuestionSetupDetail? : EmployeeReviewQuestionSetupDetailEntity[];
}

export interface EmployeeReviewQuestionSetupDetailEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupDetailId?: number;
    EmployeeReviewQuestionSetupId?: number;
    EmployeeReviewQuestionId?: number;

    // Display Attributes
    EmployeeReviewQuestionSetupIdDisplay?: string;
    EmployeeReviewQuestionIdDisplay?: string;

    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity;
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity;
}

export interface EmployeeReviewQuestionSetupLevelEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSetupLevelId?: number;
    SetupLevel?: string;
    IconClass?: string;


    // Relations
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
}

export interface EmployeeReviewQuestionSkillEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionSkillId?: number;
    SkillName?: string;
    IsSoftSkill?: boolean;


    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewQuestionTypeEntity extends DwOrmData {
    // Attributes
    EmployeeReviewQuestionTypeId?: number;
    QuestionType?: string;
    IsSoftSkill?: boolean;


    // Relations
    EmployeeReviewQuestion? : EmployeeReviewQuestionEntity[];
}

export interface EmployeeReviewStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewStatusId?: number;
    ReviewStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;


    // Relations
    EmployeeReview? : EmployeeReviewEntity[];
}

export interface EmployeeReviewSummaryEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryId?: number;
    EmployeeReviewSummaryStatusId?: number;
    EmployeeReviewSummaryTypeId?: number;
    EmployeeEthosUserId?: number;
    SupervisorEthosUserId?: number;
    ReviewYear?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    DueDate?: string;
    ReviewNotes?: string;
    CompletedByEthos_UserId?: number;
    CompletedByDateTime?: string;
    ShowGraph?: boolean;

    // Display Attributes
    EmployeeReviewSummaryStatusIdDisplay?: string;
    EmployeeReviewSummaryTypeIdDisplay?: string;
    EmployeeEthosUserIdDisplay?: string;
    SupervisorEthosUserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    CompletedByEthos_UserIdDisplay?: string;

    // Relations
    EmployeeEthosUserIdEmsUserExtended? : EmsUserExtendedEntity;
    EmployeeReviewSummaryStatus? : EmployeeReviewSummaryStatusEntity;
    EmployeeReviewSummaryType? : EmployeeReviewSummaryTypeEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    SupervisorEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CompletedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    EmployeeReview? : EmployeeReviewEntity[];
}

export interface EmployeeReviewSummaryStatusEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryStatusId?: number;
    ReviewSummaryStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;


    // Relations
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
}

export interface EmployeeReviewSummaryTypeEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryTypeId?: number;
    ReviewSummaryType?: string;


    // Relations
    EmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
}

export interface EmployeeServiceDatesEntity extends DwOrmData {
    // Attributes
    PersonnelNumber?: string;
    HireDate?: string;
    EmploymentStartDate?: string;
    AdjustedServiceDate?: string;


    // Relations
}

export interface EmployeeSummaryEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryId?: number;
    EmployeeUserId?: number;
    CovidVaccinationStatusId?: number;
    CovidWorkStatusId?: number;
    RequiresWeeklyTesting?: boolean;
    NextTestDate?: string;
    QuarantineStartDate?: string;
    QuarantineEndDate?: string;
    Vaccine1Date?: string;
    Vaccine2Date?: string;
    BoosterVaccine1TypeId?: number;
    BoosterVaccine1Date?: string;
    VaccinationCardFileId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastEmployeeTestId?: number;
    VaccineTypeId?: number;
    LastPositiveTestId?: number;
    MedicalExemptionFileId?: number;

    // Display Attributes
    EmployeeUserIdDisplay?: string;
    CovidVaccinationStatusIdDisplay?: string;
    CovidWorkStatusIdDisplay?: string;
    BoosterVaccine1TypeIdDisplay?: string;
    LastEmployeeTestIdDisplay?: string;
    VaccineTypeIdDisplay?: string;
    LastPositiveTestIdDisplay?: string;

    // Relations
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
    BoosterVaccine1TypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    VaccineTypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    CovidWorkStatus? : CovidWorkStatusEntity;
    LastEmployeeTest? : EmployeeTestEntity;
    LastPositiveTestIdEmployeeTest? : EmployeeTestEntity;
    EmployeeEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    EmployeeReminderNotification? : EmployeeReminderNotificationEntity[];
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface EmployeeSummaryChangeTypeEntity extends DwOrmData {
    // Attributes
    EmplyoeeSummaryChangeTypeId?: number;
    ChangeTypeDisplay?: string;
    EmailEmployee?: boolean;
    EmailSupervisor?: boolean;


    // Relations
    EmployeeSummaryChangeTypeIdEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface EmployeeSummaryHistoryEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryHistoryId?: number;
    EmployeeSummaryId?: number;
    EmployeeSummaryChangeTypeId?: number;
    CovidVaccinationStatusId?: number;
    PreviousCovidVaccinationStatusId?: number;
    CovidWorkStatusId?: number;
    PreviousCovidWorkStatusId?: number;
    QuarantineStartDate?: string;
    QuarantineEndDate?: string;
    DetailNotificationsComplete?: boolean;
    SummaryNotificationsComplete?: boolean;
    RequireWeeklyTesting?: boolean;
    PreviousRequireWeeklyTesting?: boolean;
    CreatedByDateTime?: string;

    // Display Attributes
    EmployeeSummaryIdDisplay?: string;
    EmployeeSummaryChangeTypeIdDisplay?: string;
    CovidVaccinationStatusIdDisplay?: string;
    PreviousCovidVaccinationStatusIdDisplay?: string;
    CovidWorkStatusIdDisplay?: string;
    PreviousCovidWorkStatusIdDisplay?: string;

    // Relations
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
    PreviousCovidVaccinationStatus? : CovidVaccinationStatusEntity;
    CovidWorkStatus? : CovidWorkStatusEntity;
    PreviousCovidWorkStatus? : CovidWorkStatusEntity;
    EmployeeSummary? : EmployeeSummaryEntity;
    EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType? : EmployeeSummaryChangeTypeEntity;
}

export interface EmployeeTestEntity extends DwOrmData {
    // Attributes
    EmployeeTestId?: number;
    EmployeeUserId?: number;
    TestLocation?: string;
    CovidTestTypeId?: number;
    CovidTestResultTypeId?: number;
    CovidTestStatusId?: number;
    VerifiedByUserId?: number;
    VerifiedDateTime?: string;
    RejectedByUserId?: number;
    RejectedDateTime?: string;
    RejectedNotes?: string;
    TestFileId?: number;
    TestDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsProcessed?: boolean;
    ProcessedDateTime?: string;

    // Display Attributes
    EmployeeUserIdDisplay?: string;
    CovidTestTypeIdDisplay?: string;
    CovidTestResultTypeIdDisplay?: string;
    CovidTestStatusIdDisplay?: string;
    VerifiedByUserIdDisplay?: string;
    RejectedByUserIdDisplay?: string;

    // Relations
    CovidTestResultType? : CovidTestResultTypeEntity;
    CovidTestStatus? : CovidTestStatusEntity;
    CovidTestType? : CovidTestTypeEntity;
    EmployeeEthosUser? : EthosUserEntity;
    VerifiedByEthosUser? : EthosUserEntity;
    RejectedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    LastEmployeeSummary? : EmployeeSummaryEntity[];
    LastPositiveTestIdEmployeeSummary? : EmployeeSummaryEntity[];
}

export interface EmployeeTrainingNeededEntity extends DwOrmData {
    // Attributes
    EmployeeTrainingNeededId?: number;
    ConclusionCv?: number;
    IssueSubTypeId?: number;
    StatusCv?: number;
    EmployeeEthos_UserId?: number;
    AssignedToEthos_UserId?: number;
    AttachmentId?: number;
    AssignedToEmailMessageId?: string;
    EventDate?: string;
    ClosedDate?: string;
    ReferenceText?: string;
    Customer?: string;
    EventLocation?: string;
    City?: string;
    State?: string;
    EmailCopyString?: string;
    EventDescription?: string;
    CreatedByEmailMessageId?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    IsDeleted?: boolean;
    CCEmailMessageId?: string;

    // Display Attributes
    ConclusionCvDisplay?: string;
    IssueSubTypeIdDisplay?: string;
    StatusCvDisplay?: string;
    EmployeeEthos_UserIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    IssueSubTypeIdCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    ConclusionCvCodeValue? : CodeValueEntity;
    EmployeeEthosRoEthosUser? : RoEthosUserEntity;
    CreatedByEthosRoEthosUser? : RoEthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    AssignedToEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    WcNote? : WcNoteEntity[];
    WcUserRead? : WcUserReadEntity[];
}

export interface EmployeeVaccinationSubmissionEntity extends DwOrmData {
    // Attributes
    EmployeeVaccinationSubmissionId?: number;
    EmployeeUserId?: number;
    SubmittedDateTime?: string;
    CovidVaccinationStatusId?: number;
    VaccinationTypeId?: number;
    Vaccine1Date?: string;
    Vaccine2Date?: string;
    BoosterVaccine1TypeId?: number;
    BoosterVaccineDate?: string;
    VaccinationCardFileId?: number;
    CovidVaccinationSubmissionStatusId?: number;
    VerifiedDateTime?: string;
    RejectedByUserId?: number;
    RejectedDateTime?: string;
    RejectedNotes?: string;
    VerifiedByUserId?: number;

    // Display Attributes
    EmployeeUserIdDisplay?: string;
    CovidVaccinationStatusIdDisplay?: string;
    VaccinationTypeIdDisplay?: string;
    BoosterVaccine1TypeIdDisplay?: string;
    CovidVaccinationSubmissionStatusIdDisplay?: string;
    RejectedByUserIdDisplay?: string;
    VerifiedByUserIdDisplay?: string;

    // Relations
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
    CovidVaccinationSubmissionStatus? : CovidVaccinationSubmissionStatusEntity;
    VaccinationTypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    BoosterVaccine1TypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    EmployeeEthosUser? : EthosUserEntity;
    RejectedByEthosUser? : EthosUserEntity;
    VerifiedByEthosUser? : EthosUserEntity;
}

export interface EquipmentEntity extends DwOrmData {
    // Attributes
    EquipmentId?: number;
    Description?: string;


    // Relations
    RequestEquipment? : RequestEquipmentEntity[];
}

export interface EquipmentCompanyEntity extends DwOrmData {
    // Attributes
    EquipmentCompanyId?: number;
    CompanyId?: number;
    EquipmentId?: number;
    // Attribute Day Price has invalid characters and can't be included
    // Attribute Week Price has invalid characters and can't be included
    // Attribute Month Price has invalid characters and can't be included


    // Relations
}

export interface EscalationEntity extends DwOrmData {
    // Attributes
    EscalationId?: number;
    KickoffId?: number;
    Order?: number;
    Name?: string;
    Title?: string;
    Department?: string;
    Company?: string;
    Phone?: string;
    Email?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Role?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface EthosAddressEntity extends DwOrmData {
    // Attributes
    AddressId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    PostalCode?: string;
    CountyId?: number;
    CountyName?: string;
    LookUpKey?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CountyIdDisplay?: string;

    // Relations
    DboEthosCounty? : DboEthosCountyEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    EthosSite? : EthosSiteEntity[];
    StaffingAgencyEthosStaffingAgency? : EthosStaffingAgencyEntity[];
}

export interface EthosCodeSetEntity extends DwOrmData {
    // Attributes
    CodeSetId?: number;
    CodeSetName?: string;
    IsCustomCodeSet?: boolean;


    // Relations
    EthosCodeValue? : EthosCodeValueEntity[];
    EthosCodeValueCustom? : EthosCodeValueCustomEntity[];
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    EthosCodeSet? : EthosCodeSetEntity;
    JobCategoryCvEthosJob? : EthosJobEntity[];
    InvoiceDeliveryTypeCVEthosJobNumber? : EthosJobNumberEntity[];
    ForecastStatusCvEthosJobNumber? : EthosJobNumberEntity[];
    JobNumberTypeCvEthosJobNumber? : EthosJobNumberEntity[];
    UserTypeCvEthosUser? : EthosUserEntity[];
    // Duplicate property excluded
    // UserTypeCvEthosUser : EthosUserEntity[];
    ResourceGroupCvEthosUser? : EthosUserEntity[];
    SkillCvEthosUserSkill? : EthosUserSkillEntity[];
    DepartmentTypeCvEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    TeamTypeCvEthosWachterTeam? : EthosWachterTeamEntity[];
    CableTypeCvPermit? : PermitEntity[];
    PermitTypeCvPermit? : PermitEntity[];
    PermitTeamCvPermit? : PermitEntity[];
    PerformingWorkCvPermit? : PermitEntity[];
    PlenumOrRiserCvPermit? : PermitEntity[];
    PermitTeamCvPermits2Permit? : Permits2PermitEntity[];
    PlenumRiserCvPermits2Permit? : Permits2PermitEntity[];
    PermitTypeCvPermitPermitType? : PermitPermitTypeEntity[];
    PermitTypeCvPermits2PermitPermitType? : Permits2PermitPermitTypeEntity[];
    CableTypeCvPermitRequest? : PermitRequestEntity[];
    PermitTeamCvPermitRequest? : PermitRequestEntity[];
    PermitTypeCvPermitRequest? : PermitRequestEntity[];
    PlenumRiserPermitRequest? : PermitRequestEntity[];
    PermitTypeCVPermitRequestPermit? : PermitRequestPermitEntity[];
    PermitTypeCvPermitRequestPermitType? : PermitRequestPermitTypeEntity[];
    PermitTypeCvRequiredCable? : RequiredCableEntity[];
    PermitTypeCvPermits2RequiredCable? : Permits2RequiredCableEntity[];
    ResourceGroupCvRoEthosUser? : RoEthosUserEntity[];
    UserTypeCvRoEthosUser? : RoEthosUserEntity[];
    UserTypeCvStarRatingNotification? : StarRatingNotificationEntity[];
    EthosSkillCvTimerSkillMap? : TimerSkillMapEntity[];
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    EthosCodeSet? : EthosCodeSetEntity;
    SiteTypeCvEthosSite? : EthosSiteEntity[];
}

export interface EthosCountryEntity extends DwOrmData {
    // Attributes
    CountryId?: number;
    CountryName?: string;
    CountryShortName?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    EthosStateProvince? : EthosStateProvinceEntity[];
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface DboEthosCountyEntity extends DwOrmData {
    // Attributes
    CountyId?: number;
    CountyName?: string;
    StateProvinceId?: number;
    CreatedDatetime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifedBy?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifedByDisplay?: string;

    // Relations
    EthosStateProvince? : EthosStateProvinceEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifedByEthosUser? : EthosUserEntity;
    EthosAddress? : EthosAddressEntity[];
    PermitRequest? : PermitRequestEntity[];
}

export interface EthosCustomerEntity extends DwOrmData {
    // Attributes
    CustomerId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    Active?: boolean;


    // Relations
    EndEthosJobNumber? : EthosJobNumberEntity[];
    EthosJobNumber? : EthosJobNumberEntity[];
    EthosOpportunity? : EthosOpportunityEntity[];
    EthosUser? : EthosUserEntity[];
    UserExtendedEthosCustomer? : UserExtendedEthosCustomerEntity[];
}

export interface EthosJobEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    JobNumberId?: number;
    JobEtcDateTime?: string;
    LookUpKey?: string;
    JobStatusWs?: number;
    JobStartDateTime?: string;
    ModifiedDateTime?: string;
    JobDueDateTime?: string;
    CompletedByUserId?: number;
    CompletedByDateTime?: string;
    IsTechOnSite?: boolean;
    JobCategoryCv?: number;
    JobNumberPriorityId?: number;

    // Display Attributes
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobStatusWsDisplay?: string;
    CompletedByUserIdDisplay?: string;
    JobCategoryCvDisplay?: string;
    JobNumberPriorityIdDisplay?: string;

    // Relations
    JobCategoryCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobSiteJobId? : EthosJobSiteEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity;
    CompletedByEthosUser? : EthosUserEntity;
    JobStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosJobNumberJobNumberId? : EthosJobNumberEntity[];
    EthosJobSite? : EthosJobSiteEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    Permit? : PermitEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    PermitRequest? : PermitRequestEntity[];
    WJIDPermitRequest? : PermitRequestEntity[];
    WachterRating? : RatingEntity[];
    WJIDRoStarRatingAvProjects? : RoStarRatingAvProjectsEntity[];
    EthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    EthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    EthosTimer? : TimerEntity[];
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;
    LookUpKey?: number;
    IsDeleted?: boolean;
    JobNumberTypeCv?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    ForecastStatusCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    JobNumberTypeCvDisplay?: string;

    // Relations
    InvoiceDeliveryTypeCVEthosCodeValue? : EthosCodeValueEntity;
    ForecastStatusCvEthosCodeValue? : EthosCodeValueEntity;
    JobNumberTypeCvEthosCodeValue? : EthosCodeValueEntity;
    EndEthosCustomer? : EthosCustomerEntity;
    EthosCustomer? : EthosCustomerEntity;
    EthosJobJobNumberId? : EthosJobEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    JobNumberStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    ParentBilling? : BillingEntity[];
    Billing? : BillingEntity[];
    EthosJob? : EthosJobEntity[];
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
    EthosKickoff? : KickoffEntity[];
    ProjectsKickoff? : ProjectsKickoffEntity[];
    Maintenance? : MaintenanceEntity[];
    OverheadProjection? : OverheadProjectionEntity[];
    OverheadTeamPhase? : OverheadTeamPhaseEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    // Duplicate property excluded
    // Permits2Permit : Permits2PermitEntity[];
    Permits2roPermits? : Permits2RoPermitsEntity[];
    JobNumPermits2roPermits? : Permits2RoPermitsEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
    FleetVehicle? : FleetVehicleEntity[];
    WorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberMembershipEntity extends DwOrmData {
    // Attributes
    JobNumberMembershipId?: number;
    UserId?: number;
    JobNumberId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    JobNumberIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberPhaseStatusWsDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    JobNumberPhaseStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
}

export interface EthosJobNumberPriorityEntity extends DwOrmData {
    // Attributes
    JobNumberPriorityId?: number;
    JobNumberId?: number;
    PriorityName?: string;
    IsDeleted?: boolean;
    ResponseTimeInHours?: number;
    StraightHourlyBillingRate?: number;
    OvertimeHourlyBillingRate?: number;
    HolidayHourlyBillingRate?: number;
    TravelHourlyBillingRate?: number;
    MileageBillingRate?: number;
    MaxTravelInHours?: number;
    CreatedDateTime?: string;
    CreatedByUserId?: number;
    ModifiedDateTime?: string;
    ModifiedByUserId?: number;
    TripCharge?: number;
    ExpediteFee?: number;
    IsEscalationEnabled?: boolean;
    SendPriorityNotification?: boolean;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    EthosJob? : EthosJobEntity[];
}

export interface EthosJobSiteEntity extends DwOrmData {
    // Attributes
    JobSiteId?: number;
    JobId?: number;
    SiteId?: number;
    IsDeleted?: boolean;
    LookUpKey?: string;
    SubJobNumber?: string;
    FullJobNumber?: string;

    // Display Attributes
    JobIdDisplay?: string;
    SiteIdDisplay?: string;

    // Relations
    EthosJob? : EthosJobEntity;
    EthosSite? : EthosSiteEntity;
    EthosJobJobId? : EthosJobEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    Permit? : PermitEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    PermitRequest? : PermitRequestEntity[];
    EthosTimer? : TimerEntity[];
}

export interface EthosJobSowEntity extends DwOrmData {
    // Attributes
    JobSowId?: number;
    SowId?: number;
    JobId?: number;
    JobSiteId?: number;
    LookUpKey?: string;

    // Display Attributes
    SowIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;

    // Relations
    EthosJob? : EthosJobEntity;
    EthosJobSite? : EthosJobSiteEntity;
    EthosSow? : EthosSowEntity;
}

export interface EthosLaborMetricsEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    HoursCurrentWeek?: number;
    HoursLastWeek?: number;
    AverageHours4Week?: number;
    AverageHours52Week?: number;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity;
}

export interface EthosOpportunityEntity extends DwOrmData {
    // Attributes
    OpportunityId?: number;
    OpportunityStatusWs?: number;
    OpportunityName?: string;
    CustomerId?: number;
    ProjectManagerUserId?: number;
    OpportunityManagerUserId?: number;
    ProjectStatusWs?: number;
    StartDate?: string;
    StopDate?: string;

    // Display Attributes
    OpportunityStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    OpportunityManagerUserIdDisplay?: string;
    ProjectStatusWsDisplay?: string;

    // Relations
    EthosCustomer? : EthosCustomerEntity;
    OpportunityManagerEthosUser? : EthosUserEntity;
    ProjectManagerEthosUser? : EthosUserEntity;
    OpportunityStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    PermitRequest? : PermitRequestEntity[];
    PermitIdPermits2roPermits? : Permits2RoPermitsEntity[];
}

export interface EthosRoUserLaborSummaryEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    YTD_AvgWeeklyHrs?: number;
    Last12Months_AvgWeeklyHrs?: number;
    LastMonth_AvgWeeklyHrs?: number;
    LastWeek_Hrs?: number;
    ThisWeek_Hrs?: number;


    // Relations
}

export interface EthosServiceUserEntity extends DwOrmData {
    // Attributes
    EthosServiceUserId?: number;
    Ethos_UserId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosSiteEntity extends DwOrmData {
    // Attributes
    SiteId?: number;
    IsDeleted?: boolean;
    SiteName?: string;
    AddressId?: number;
    SiteTypeCv?: number;
    LookUpKey?: string;

    // Display Attributes
    AddressIdDisplay?: string;
    SiteTypeCvDisplay?: string;

    // Relations
    EthosAddress? : EthosAddressEntity;
    SiteTypeCvEthosCodeValueCustom? : EthosCodeValueCustomEntity;
    EthosJobSite? : EthosJobSiteEntity[];
}

export interface EthosSowEntity extends DwOrmData {
    // Attributes
    SowId?: number;
    SowName?: string;
    SowDescription?: string;
    IsDeleted?: boolean;


    // Relations
    EthosJobSow? : EthosJobSowEntity[];
}

export interface EthosStaffingAgencyEntity extends DwOrmData {
    // Attributes
    StaffingAgencyId?: number;
    StaffingAgencyName?: string;
    ContactName?: string;
    ContactPhone?: string;
    StaffingAgencyAddressId?: number;
    IsActive?: boolean;

    // Display Attributes
    StaffingAgencyAddressIdDisplay?: string;

    // Relations
    StaffingAgencyEthosAddress? : EthosAddressEntity;
    EthosUser? : EthosUserEntity[];
    RoEthosUser? : RoEthosUserEntity[];
}

export interface EthosStateProvinceEntity extends DwOrmData {
    // Attributes
    StateProvinceId?: number;
    CountryId?: number;
    StateProvinceName?: string;
    StateProvinceShortName?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    StateCode?: string;

    // Display Attributes
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosCountry? : EthosCountryEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    Accident? : AccidentEntity[];
    LocationAuction? : AuctionEntity[];
    StateIdCompanyLicense? : CompanyLicenseEntity[];
    EthosAddress? : EthosAddressEntity[];
    DboEthosCounty? : DboEthosCountyEntity[];
    EthosUser? : EthosUserEntity[];
    StateLicenses? : LicensesEntity;
    PropertyOwnerStateIdPermit? : PermitEntity[];
    PropertyOwnerStateIdPermits2Permit? : Permits2PermitEntity[];
    JobNumberPermits2Permit? : Permits2PermitEntity[];
    PropertyOwnerNamePermitRequest? : PermitRequestEntity[];
    PermitRequest? : PermitRequestEntity[];
    ProofOfInsurance? : ProofOfInsuranceEntity[];
    LicenseProofOfInsurance? : ProofOfInsuranceEntity[];
    RoEthosUser? : RoEthosUserEntity[];
    EthosTerritoryStateProvince? : TerritoryStateProvinceEntity[];
    LicensePlateStateVehicle? : VehicleEntity[];
    DriverLicenseStateVehicle? : VehicleEntity[];
    DriverStateVehicle? : VehicleEntity[];
    RegistrationFleetVehicle? : FleetVehicleEntity[];
    AccidentStateVehicleAccident? : VehicleAccidentEntity[];
    DriverStateVehicleAccident? : VehicleAccidentEntity[];
    AccidentStateWorkplaceAccident? : WorkplaceAccidentEntity[];
    EmployeeStateWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosSubcontractorBranchEntity extends DwOrmData {
    // Attributes
    SubcontractorBranchId?: number;
    SubcontractorBranchName?: string;
    SubcontractorBranchIsDeleted?: boolean;
    IsApprovedBranch?: boolean;
    SubcontractorId?: number;
    SubcontractorName?: string;
    SubcontractorIsDeleted?: boolean;
    RowInsertDateTime?: string;

    // Display Attributes
    SubcontractorBranchIdDisplay?: string;

    // Relations
    FiveStarRatingSubcontractorBranchId? : FiveStarRatingEntity;
    EthosMemoOfRecord? : MemoOfRecordEntity[];
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    // Duplicate property excluded
    // UserTypeCvEthosCodeValue : EthosCodeValueEntity;
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    EthosCustomer? : EthosCustomerEntity;
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    EthosStaffingAgency? : EthosStaffingAgencyEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    EthosWachterJobTitle? : EthosWachterJobTitleEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    CreatedByEthosAccessControl? : AccessControlEntity[];
    ModifiedByEthosAccessControl? : AccessControlEntity[];
    CreatedByEthosPermits2AccessControl? : Permits2AccessControlEntity[];
    ModifiedByEthosPermits2AccessControl? : Permits2AccessControlEntity[];
    ModifiedByEthosAccident? : AccidentEntity[];
    CreatedByEthosAccident? : AccidentEntity[];
    EmployeeAccident? : AccidentEntity[];
    ModifiedByAttachmentAttachmentFile? : AttachmentAttachmentFileEntity[];
    ModifiedByAttachmentFile? : AttachmentFileEntity[];
    CreatedByAttachmentAttachmentFile? : AttachmentAttachmentFileEntity[];
    CreatedByAttachmentFile? : AttachmentFileEntity[];
    ModifiedByEthosAttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity[];
    ModifiedByEthosAttachmentFolder? : AttachmentFolderEntity[];
    CreatedByEthosAttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity[];
    CreatedByEthosAttachmentFolder? : AttachmentFolderEntity[];
    CreatedByAuction? : AuctionEntity[];
    ModifiedByAuction? : AuctionEntity[];
    AuditorEthosAuditIssue? : AuditIssueEntity[];
    IssueOwnerEthosAuditIssue? : AuditIssueEntity[];
    CreatedByEthosAuditIssue? : AuditIssueEntity[];
    ModifiedByEthosAuditIssue? : AuditIssueEntity[];
    ELTManagerEthosAuditIssue? : AuditIssueEntity[];
    DelegatedOwnerEthosUseridAuditIssue? : AuditIssueEntity[];
    CreatedByBidHistory? : BidHistoryEntity[];
    CreatedbyEthosBilling? : BillingEntity[];
    ModifiedByEthosBilling? : BillingEntity[];
    CreatedbyEthosBillingDepartment? : BillingDepartmentEntity[];
    ModifiedByEthosBillingDepartment? : BillingDepartmentEntity[];
    CreatedByChangeRequest? : ChangeRequestEntity[];
    CompletedByChangeRequest? : ChangeRequestEntity[];
    CreatedbyEthosChecklist? : ChecklistEntity[];
    ModifiedByEthosChecklist? : ChecklistEntity[];
    FromPmCollaboration? : CollaborationEntity[];
    ModifiedByEthosCollaboration? : CollaborationEntity[];
    CreatedByEthosCollaboration? : CollaborationEntity[];
    ToPmCollaboration? : CollaborationEntity[];
    ProjectManagerIdCollaborationPm? : CollaborationPmEntity[];
    QualifierCompanyLicense? : CompanyLicenseEntity[];
    ModifiedByEthosCustomerSatisfaction? : CustomerSatisfactionEntity[];
    PmCustomerSatisfaction? : CustomerSatisfactionEntity[];
    CreatedByEthosCustomerSatisfaction? : CustomerSatisfactionEntity[];
    EthosDepartmentRole? : DepartmentRoleEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    EmulateEthosEmaulationUser? : EmaulationUserEntity[];
    EthosEmaulationUser? : EmaulationUserEntity[];
    ModifiedByEthosEmployeeReview? : EmployeeReviewEntity[];
    CreatedByEthosEmployeeReview? : EmployeeReviewEntity[];
    ApprovedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    RejectedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    SubmittedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    EmployeeEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    SupervisorEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    ModifiedByEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    CompletedByEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    CreatedbyEthosEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    EmployeeEmployeeSummary? : EmployeeSummaryEntity[];
    ModifiedByEmployeeSummary? : EmployeeSummaryEntity[];
    CreatedByEmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeEmployeeTest? : EmployeeTestEntity[];
    VerifiedByEmployeeTest? : EmployeeTestEntity[];
    RejectedByEmployeeTest? : EmployeeTestEntity[];
    ModifiedByEmployeeTest? : EmployeeTestEntity[];
    CreatedByEmployeeTest? : EmployeeTestEntity[];
    ModifiedByEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    AssignedToEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    CreatedByEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    EmployeeEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    EmployeeEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    RejectedByEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    VerifiedByEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    CreatedbyEthosEscalation? : EscalationEntity[];
    ModifiedByEthosEscalation? : EscalationEntity[];
    ModifiedByEthosCountry? : EthosCountryEntity[];
    CreatedByEthosCountry? : EthosCountryEntity[];
    CreatedByDboEthosCounty? : DboEthosCountyEntity[];
    ModifedByDboEthosCounty? : DboEthosCountyEntity[];
    CompletedByEthosJob? : EthosJobEntity[];
    ProjectMgr1EthosJobNumber? : EthosJobNumberEntity[];
    ProjectMgr2EthosJobNumber? : EthosJobNumberEntity[];
    AsstProjectMgrEthosJobNumber? : EthosJobNumberEntity[];
    SeniorMgrEthosJobNumber? : EthosJobNumberEntity[];
    LeadTech1EthosJobNumber? : EthosJobNumberEntity[];
    LeadTech2EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval1EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval2EthosJobNumber? : EthosJobNumberEntity[];
    CreatedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    ModifiedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    CreatedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    ModifiedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    EthosLaborMetrics? : EthosLaborMetricsEntity[];
    OpportunityManagerEthosOpportunity? : EthosOpportunityEntity[];
    ProjectManagerEthosOpportunity? : EthosOpportunityEntity[];
    EthosEthosServiceUser? : EthosServiceUserEntity[];
    CreatedByEthosStateProvince? : EthosStateProvinceEntity[];
    ModifiedByEthosStateProvince? : EthosStateProvinceEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    DepartmentDirectorEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentAsstManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    TeamLeaderEthosWachterTeam? : EthosWachterTeamEntity[];
    CreatedByEthosEthosRoleMap? : EthosRoleMapEntity[];
    ModifiedByEthosEthosRoleMap? : EthosRoleMapEntity[];
    TechnicianInspection? : InspectionEntity[];
    CreatedByEthosInspection? : InspectionEntity[];
    CreatedByPermits2Inspection? : Permits2InspectionEntity[];
    TechnicianPermits2Inspection? : Permits2InspectionEntity[];
    CreatedbyEthosKickoff? : KickoffEntity[];
    ModifiedByEthosKickoff? : KickoffEntity[];
    CreatedbyEthosProjectsKickoff? : ProjectsKickoffEntity[];
    ModifiedByEthosProjectsKickoff? : ProjectsKickoffEntity[];
    LeadTechProjectsKickoff? : ProjectsKickoffEntity[];
    CreatedbyEthosKickoffChecklist? : KickoffChecklistEntity[];
    ModifiedByEthosKickoffChecklist? : KickoffChecklistEntity[];
    IssuedToLicenses? : LicensesEntity;
    CreatedByEthosLicenses? : LicensesEntity[];
    ModifiedByEthosLicenses? : LicensesEntity[];
    // Duplicate property excluded
    // IssuedToLicenses : LicensesEntity[];
    CreatedByMaintenance? : MaintenanceEntity[];
    ModifiedByMaintenance? : MaintenanceEntity[];
    DriverMaintenance? : MaintenanceEntity[];
    CreatedByEthosMedicalRecord? : MedicalRecordEntity[];
    ModifiedByEthosMedicalRecord? : MedicalRecordEntity[];
    EmployeeEthosMemoOfRecord? : MemoOfRecordEntity[];
    SupervisorEthosMemoOfRecord? : MemoOfRecordEntity[];
    AssignedToEthosMemoOfRecord? : MemoOfRecordEntity[];
    ModifiedByEthosMemoOfRecord? : MemoOfRecordEntity[];
    CreatedByEthosMemoOfRecord? : MemoOfRecordEntity[];
    CreatedByEthosNote? : NoteEntity[];
    CreatedByEthosWcNote? : WcNoteEntity[];
    CreatedByEthosNotesNote? : NotesNoteEntity[];
    EthosNumbersNote? : NumbersNoteEntity[];
    ModifiedByEthosNotesNote? : NotesNoteEntity[];
    SupervisorMorNotificationConfig? : MorNotificationConfigEntity[];
    CreatedByEthosOrganizationalEntity? : OrganizationalEntityEntity[];
    EthosOrganizationalMembership? : OrganizationalMembershipEntity[];
    CreatedByEthosOrganizationalUnit? : OrganizationalUnitEntity[];
    DirectorEthosOrganizationalUnit? : OrganizationalUnitEntity[];
    ModifiedByEthosOverheadProjection? : OverheadProjectionEntity[];
    CreatedByEthosOverheadProjection? : OverheadProjectionEntity[];
    ModifiedByEthosOverheadTeamPhase? : OverheadTeamPhaseEntity[];
    CreatedByEthosOverheadTeamPhase? : OverheadTeamPhaseEntity[];
    CreatedByPafHistory? : PafHistoryEntity[];
    CreatedByPassHistory? : PassHistoryEntity[];
    EmployeeEthosPayJobChange? : PayJobChangeEntity[];
    CreatedbyEthosPayJobChange? : PayJobChangeEntity[];
    NewManagerEthosPayJobChange? : PayJobChangeEntity[];
    ModifiedByEthosPayJobChange? : PayJobChangeEntity[];
    StatusAssignedToEthosPayJobChange? : PayJobChangeEntity[];
    RejectedByEthosPayJobChange? : PayJobChangeEntity[];
    EthosPayJobChangeUsersRead? : PayJobChangeUsersReadEntity[];
    RequestedByUserPermit? : PermitEntity[];
    CreatedByEthosPermit? : PermitEntity[];
    ModifiedByEthosPermit? : PermitEntity[];
    AssignedToUserPermit? : PermitEntity[];
    CreatedByPermits2Permit? : Permits2PermitEntity[];
    ModifiedByPermits2Permit? : Permits2PermitEntity[];
    RequestedByPermits2Permit? : Permits2PermitEntity[];
    AssignedToPermits2Permit? : Permits2PermitEntity[];
    CreatedByEthosPermitRequest? : PermitRequestEntity[];
    AssignedToPermitRequest? : PermitRequestEntity[];
    SecondaryAssignedToPermitRequest? : PermitRequestEntity[];
    RequestedByPermitRequest? : PermitRequestEntity[];
    ModifiedByEthosPermitRequest? : PermitRequestEntity[];
    CreatedByPlateHistory? : PlateHistoryEntity[];
    CreatedbyEthosProjectMilestone? : ProjectMilestoneEntity[];
    ModifiedByEthosProjectMilestone? : ProjectMilestoneEntity[];
    ModifiedByEthosProofOfInsurance? : ProofOfInsuranceEntity[];
    CreatedByEthosProofOfInsurance? : ProofOfInsuranceEntity[];
    ProofOfInsuranceJobTitlesWachterJobTitleId? : ProofOfInsuranceJobTitlesEntity[];
    // Duplicate property excluded
    // ProofOfInsuranceJobTitlesWachterJobTitleId : ProofOfInsuranceJobTitlesEntity[];
    EmployeeEthosProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity[];
    CreatedByEthosRating? : RatingEntity[];
    CreatedbyEthosReporting? : ReportingEntity[];
    ModifiedByEthosReporting? : ReportingEntity[];
    CreatedByEthosRequest? : RequestEntity[];
    ModifiedByEthosRequest? : RequestEntity[];
    ProjectManagerEthosTravelRequest? : TravelRequestEntity[];
    TravelerEthosTravelRequest? : TravelRequestEntity[];
    ModifiedByEthosRequestPreferences? : RequestPreferencesEntity[];
    CreatedByEthosRequestPreferences? : RequestPreferencesEntity[];
    ModifiedByEthosRequiredCable? : RequiredCableEntity[];
    CreatedByEthosRequiredCable? : RequiredCableEntity[];
    CreatedByEthosPermits2RequiredCable? : Permits2RequiredCableEntity[];
    ModifiedByEthosPermits2RequiredCable? : Permits2RequiredCableEntity[];
    CurrentUserEthosIdResourceCost? : ResourceCostEntity[];
    EthosResourceCost? : ResourceCostEntity[];
    ModifiedByReview? : ReviewEntity[];
    CreatedByReview? : ReviewEntity[];
    EthosRoEthosUserBurdon? : RoEthosUserBurdonEntity[];
    RoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity[];
    SupervisorRoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity[];
    EmployeeEthosRoEmployeeReviewSummaryCurrent? : RoEmployeeReviewSummaryCurrentEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    ProjectManagerPermits2roPermits? : Permits2RoPermitsEntity[];
    ProjectManager2Permits2roPermits? : Permits2RoPermitsEntity[];
    StatusUpdatedByStageAuditLog? : StageAuditLogEntity[];
    CreatedbyEthosStakeholder? : StakeholderEntity[];
    ModifiedByEthosStakeholder? : StakeholderEntity[];
    CreatedByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    FollowedUpByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ModifiedByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ProjectManagerEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    NspInstallTechnicianStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ProjectManagerEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    CreatedByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    ModifiedByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    FollowedUpByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    ModifiedByEthosTemplate? : TemplateEntity[];
    CreatedbyEthosTemplate? : TemplateEntity[];
    EmployeeEthosTermResign? : TermResignEntity[];
    ModifiedByEthosTermResign? : TermResignEntity[];
    CreatedbyEthosTermResign? : TermResignEntity[];
    ModifiedByEthosTerritory? : TerritoryEntity[];
    CreatedByEthosTerritory? : TerritoryEntity[];
    CreatedbyEthosTimer? : TimerEntity[];
    ModifiedByEthosTimer? : TimerEntity[];
    TechEthosTimer? : TimerEntity[];
    ModifiedByEthosTraveler? : TravelerEntity[];
    TravelerEthosTraveler? : TravelerEntity[];
    CreatedByEthosTraveler? : TravelerEntity[];
    NewTrustUserMerged? : TrustUserMergedEntity[];
    OldTrustUserMerged? : TrustUserMergedEntity[];
    EthosUserExtended? : UserExtendedEntity[];
    EthosMtlUserExtended? : MtlUserExtendedEntity[];
    FosEthosMtlUserExtended? : MtlUserExtendedEntity[];
    FosOfficeSupervisorEthosEmsUserExtended? : EmsUserExtendedEntity[];
    HiringManagerEthosEmsUserExtended? : EmsUserExtendedEntity[];
    HiringManagerEthosMtlUserExtended? : MtlUserExtendedEntity[];
    ModifiedByEthosEmsUserExtended? : EmsUserExtendedEntity[];
    ModifiedByEthosMtlUserExtended? : MtlUserExtendedEntity[];
    OperationsManagerEthosEmsUserExtended? : EmsUserExtendedEntity[];
    PreviousManagerEmsUserExtended? : EmsUserExtendedEntity[];
    CreatedByEthosEmsUserExtended? : EmsUserExtendedEntity[];
    EmployeeEthosEmsUserExtended? : EmsUserExtendedEntity[];
    ModifiedByEthosWcUserProjection? : WcUserProjectionEntity[];
    CreatedByEthosWcUserProjection? : WcUserProjectionEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity[];
    EthosWcUserRead? : WcUserReadEntity[];
    EthosUserRead? : UserReadEntity[];
    ModifiedByEthosVehicle? : VehicleEntity[];
    CreatedbyEthosVehicle? : VehicleEntity[];
    DriverFleetVehicle? : FleetVehicleEntity[];
    CreatedByFleetVehicle? : FleetVehicleEntity[];
    ModifiedByFleetVehicle? : FleetVehicleEntity[];
    ModifiedByEthosVehicleAccident? : VehicleAccidentEntity[];
    CreatedbyEthosVehicleAccident? : VehicleAccidentEntity[];
    CreatedByEthosWageExpense? : WageExpenseEntity[];
    ModifiedByEthosWageExpense? : WageExpenseEntity[];
    ModifiedByEthosWitness? : WitnessEntity[];
    CreatedbyEthosWitness? : WitnessEntity[];
    ModifiedByEthosWorkplaceAccident? : WorkplaceAccidentEntity[];
    CreatedbyEthosWorkplaceAccident? : WorkplaceAccidentEntity[];
    EthosWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    SkillCvEthosCodeValue? : EthosCodeValueEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterCompanyEntity extends DwOrmData {
    // Attributes
    WachterCompanyId?: number;
    WachterCompanyName?: string;
    WachterCompanyShortName?: string;
    PresidentUserId?: number;
    VicePresidentUserId?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    AxIntegrationId?: string;
    IsActive?: boolean;


    // Relations
    CompanyLicense? : CompanyLicenseEntity[];
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentTypeCvDisplay?: string;
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberPhaseIdDisplay?: string;

    // Relations
    DepartmentTypeCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    DepartmentDirectorEthosUser? : EthosUserEntity;
    DepartmentManagerEthosUser? : EthosUserEntity;
    DepartmentAsstManagerEthosUser? : EthosUserEntity;
    EthosWachterDivision? : EthosWachterDivisionEntity;
    BillingDepartment? : BillingDepartmentEntity[];
    FromDepartmentIdCollaboration? : CollaborationEntity[];
    ToDepartmentIdCollaboration? : CollaborationEntity[];
    DepartmentIdCollaborationDepartment? : CollaborationDepartmentEntity[];
    EthosDepartmentIdDepartmentAdditionalBurden? : DepartmentAdditionalBurdenEntity[];
    DepartmentMap? : DepartmentMapEntity[];
    EthosDepartmentRole? : DepartmentRoleEntity[];
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
    EthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity[];
    EthosMemoOfRecord? : MemoOfRecordEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
    EthosOrganizationalUnit? : OrganizationalUnitEntity[];
    RoEthosUser? : RoEthosUserEntity[];
    StarRatingNotification? : StarRatingNotificationEntity[];
    FleetVehicle? : FleetVehicleEntity[];
    DepartmentIdWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosWachterDivisionEntity extends DwOrmData {
    // Attributes
    WachterDivisionId?: number;
    WachterCompanyId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    PresidentUserId?: number;
    VicePresidentUserId?: number;
    DirectorUserId?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    AxIntegrationId?: string;


    // Relations
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
}

export interface EthosWachterJobTitleEntity extends DwOrmData {
    // Attributes
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    WachterJobTitleDescription?: string;
    AxIntegrationId?: string;
    RowInsertDateTime?: string;


    // Relations
    EthosUser? : EthosUserEntity[];
    EmployeeEthosMemoOfRecord? : MemoOfRecordEntity[];
    OrganizationalMembership? : OrganizationalMembershipEntity[];
    NewJobTitleIdPayJobChange? : PayJobChangeEntity[];
    ProofOfInsuranceJobTitles? : ProofOfInsuranceJobTitlesEntity[];
    RoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWachterTeamEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamTypeCv?: number;
    TeamTypeMeaning?: string;
    TeamName?: string;
    TeamLeaderUserId?: number;
    AxIntegrationId?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    IsDeleted?: boolean;
    OverheadJobNumberId?: number;
    OverheadJobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;
    TeamTypeCvDisplay?: string;
    TeamLeaderUserIdDisplay?: string;
    OverheadJobNumberIdDisplay?: string;
    OverheadJobNumberPhaseIdDisplay?: string;

    // Relations
    TeamTypeCvEthosCodeValue? : EthosCodeValueEntity;
    OverheadEthosJobNumber? : EthosJobNumberEntity;
    OverheadEthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    TeamLeaderEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EmployeeReviewQuestionSetup? : EmployeeReviewQuestionSetupEntity[];
    EthosJobNumber? : EthosJobNumberEntity[];
    EthosUser? : EthosUserEntity[];
    EthosMemoOfRecord? : MemoOfRecordEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
    NewEthosPayJobChange? : PayJobChangeEntity[];
    CurrentUserTeamIdResourceCost? : ResourceCostEntity[];
    RoEthosUser? : RoEthosUserEntity[];
    TeamAssignment? : TeamAssignmentEntity[];
    EthosTeamIdTeamYearNumbers? : TeamYearNumbersEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity[];
    TeamIdUserTeamLookup? : UserTeamLookupEntity[];
    UserYearNumbers? : UserYearNumbersEntity[];
    EthosWachterTeamOrganizationalUnit? : WachterTeamOrganizationalUnitEntity[];
}

export interface EthosWorkflowStatusEntity extends DwOrmData {
    // Attributes
    WorkflowStatusId?: number;
    WorkflowStatusSetId?: number;
    WorkflowStatus?: string;
    WorkflowStatusMeaning?: string;
    WorkflowStatusOrder?: number;
    IsActive?: boolean;
    WorkflowStatusShortName?: string;

    // Display Attributes
    WorkflowStatusSetIdDisplay?: string;

    // Relations
    EthosWorkflowStatusSet? : EthosWorkflowStatusSetEntity;
    JobStatusWsEthosJob? : EthosJobEntity[];
    JobNumberStatusWsEthosJobNumber? : EthosJobNumberEntity[];
    JobNumberPhaseStatusWsEthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    OpportunityStatusWsEthosOpportunity? : EthosOpportunityEntity[];
    UserStatusWsEthosUser? : EthosUserEntity[];
    PermitStatusWsPermit? : PermitEntity[];
    UserStatusWsRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWorkflowStatusSetEntity extends DwOrmData {
    // Attributes
    WorkflowStatusSetId?: number;
    WorkflowStatusSetName?: string;
    MetaDataItemId?: number;
    MetaDataAttributeId?: number;
    RelatedCodeSetId?: number;
    UseTransitions?: boolean;
    IsActive?: boolean;


    // Relations
    EthosWorkflowStatus? : EthosWorkflowStatusEntity[];
}

export interface EthosRoleMapEntity extends DwOrmData {
    // Attributes
    EthosRoleMapId?: number;
    EthosRoleId?: number;
    wAppsRoleId?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    EthosRoleIdDisplay?: string;
    wAppsRoleIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    WAppsWAppsRoles? : WAppsRolesEntity;
    EthosEthosRoles? : EthosRolesEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface EthosRolesEntity extends DwOrmData {
    // Attributes
    RoleId?: number;
    RoleName?: string;
    RoleDescription?: string;


    // Relations
    EthosEthosRoleMap? : EthosRoleMapEntity[];
}

export interface EthosUserDetailEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    ActiveDirectoryUserName?: string;
    AXUserName?: string;
    AXUserRecId?: number;
    UserTypeCV?: number;
    UserType?: string;
    WachterDepartmentId?: number;
    WachterTeamId?: number;


    // Relations
    UseridEthosUserRole? : EthosUserRoleEntity[];
}

export interface EthosUserRoleEntity extends DwOrmData {
    // Attributes
    Userid?: number;
    RoleId?: number;
    RoleName?: string;
    RoleDescription?: string;
    UserRoleId?: number;


    // Relations
    UseridEthosUserDetail? : EthosUserDetailEntity;
}

export interface FieldEmployeesPayRateEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    PayRate?: number;
    Company?: string;


    // Relations
}

export interface FiveStarRatingEntity extends DwOrmData {
    // Attributes
    FiveStarRatingId?: number;
    RatedEthos_UserId?: number;
    SubcontractorBranchId?: number;
    RatingValue?: number;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    IsSubcontractor?: boolean;

    // Display Attributes
    RatedEthos_UserIdDisplay?: string;
    SubcontractorBranchIdDisplay?: string;
    RatingValueDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    RatingValueCodeValue? : CodeValueEntity;
    EthosSubcontractorBranchSubcontractorBranchId? : EthosSubcontractorBranchEntity[];
    UserIdRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // UserIdRoEthosUser : RoEthosUserEntity[];
}

export interface InspectionEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    InspectionType?: string;
    TechnicianOnSite?: boolean;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    AdditionalInspectionNeeded?: boolean;

    // Display Attributes
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ResultCvDisplay?: string;

    // Relations
    PreferredTimeOfDayCvCodeValue? : CodeValueEntity;
    ResultCvCodeValue? : CodeValueEntity;
    Permit? : PermitEntity;
    TechnicianEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface Permits2InspectionEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    InspectionType?: string;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    InspectionStatusId?: number;
    SyncStatus?: boolean;
    Subcontractor?: string;
    UseSub?: boolean;

    // Display Attributes
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    ResultCvDisplay?: string;
    InspectionStatusIdDisplay?: string;

    // Relations
    PreferredTimeOfDayCvCodeValue? : CodeValueEntity;
    ResultCvInspectionResult? : InspectionResultEntity;
    InspectionStatus? : InspectionStatusEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosUser? : EthosUserEntity;
    TechnicianEthosUser? : EthosUserEntity;
}

export interface InspectionResultEntity extends DwOrmData {
    // Attributes
    InspectionResultId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    Order?: number;
    IsActive?: boolean;


    // Relations
    ResultCvPermits2Inspection? : Permits2InspectionEntity[];
}

export interface InspectionStatusEntity extends DwOrmData {
    // Attributes
    InspectionStatusId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    Order?: number;
    IsActive?: boolean;


    // Relations
    Permits2Inspection? : Permits2InspectionEntity[];
}

export interface IssueSubtypeEntity extends DwOrmData {
    // Attributes
    IssueSubtypeId?: number;
    IssueTypeId?: number;
    Display?: string;
    Meaning?: string;
    SortOrder?: number;
    IsActive?: boolean;
    IssueSubtypeSeverityId?: number;

    // Display Attributes
    IssueTypeIdDisplay?: string;
    IssueSubtypeSeverityIdDisplay?: string;

    // Relations
    IssueSubtypeSeverity? : IssueSubtypeSeverityEntity;
    IssueType? : IssueTypeEntity;
    IssueSubTypeIdMemoOfRecord? : MemoOfRecordEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
}

export interface IssueSubtypeSeverityEntity extends DwOrmData {
    // Attributes
    IssueSubtypeSeverityId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    SortOrder?: number;
    IsActive?: boolean;


    // Relations
    IssueSubtype? : IssueSubtypeEntity[];
}

export interface IssueTypeEntity extends DwOrmData {
    // Attributes
    IssueTypeId?: number;
    Display?: string;
    IsNotifyWachterSupervisor?: boolean;
    IsNotifySubcontractorSubervisor?: boolean;
    IsNotifyAgencySupervisor?: boolean;
    IssueTypeOrder?: number;
    IsActive?: boolean;


    // Relations
    IssueSubtype? : IssueSubtypeEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
}

export interface KickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    Ethos_JobNumberId?: number;
    BillingInvoiceDate?: string;
    CloseoutMeetingDate?: string;
    CloseoutDeliverableCompletedByDate?: string;
    ExternalKickoffDate?: string;
    ScheduledStartDate?: string;
    ScheduledEndDate?: string;
    ScopeOfWork?: string;
    ChangeOrderProcessDescription?: string;
    CustomerPaymentProcedure?: string;
    CustomerAccountingContactDetail?: string;
    DeliverablesForBilling?: string;
    EscalationPathDescription?: string;
    IntroductionText?: string;
    CommunicationDescription?: string;
    SafetyPlanDescription?: string;
    SiteContactInformation?: string;
    IsBillingACH?: boolean;
    IsBuyerSignatureRequired?: boolean;
    IsMonthlyBilling?: boolean;
    IsWrittenBillingApprovalRequired?: boolean;
    IsDeleted?: boolean;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    StakeholderInformation?: string;
    AttendeeInformation?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    OtherNotes?: string;

    // Display Attributes
    Ethos_JobNumberIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    EthosEthosJobNumber? : EthosJobNumberEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    Milestone? : MilestoneEntity[];
    RoKickoff? : RoKickoffEntity[];
}

export interface ProjectsKickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    LeadTimeWts?: string;
    StageTime?: string;
    ConfigurationTime?: string;
    CustomerSpoc?: string;
    FollowUpMeetings?: string;
    Ppe?: string;
    SpecialRequirements?: string;
    QualityProgramDetails?: string;
    Scope?: string;
    Deliverables?: string;
    RequiresEquipOrValidation?: boolean;
    ValidationNotes?: string;
    ChangeOrderPlan?: string;
    CopResponsibility?: string;
    HelpDesk?: boolean;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    CompletionDate?: string;
    IsCriticalCare?: boolean;
    ExternalDueDate?: string;
    PermittingProcess?: string;
    BudgetHours?: number;
    IsLicensedRequired?: boolean;
    LeadTechUserId?: number;
    JobNumberId?: number;
    ParentKickoffId?: number;
    LicensingRequired?: string;
    HelpContactDetails?: string;

    // Display Attributes
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    LeadTechUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    ParentKickoffIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ParentProjectsKickoff? : ProjectsKickoffEntity[];
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    LeadTechEthosUser? : EthosUserEntity;
    Billing? : BillingEntity[];
    Escalation? : EscalationEntity[];
    KickoffChecklist? : KickoffChecklistEntity[];
    // Duplicate property excluded
    // ParentProjectsKickoff : ProjectsKickoffEntity;
    ProjectMilestone? : ProjectMilestoneEntity[];
    Reporting? : ReportingEntity[];
    RoProjectKickoff? : RoProjectKickoffEntity[];
    Stakeholder? : StakeholderEntity[];
    TeamAssignment? : TeamAssignmentEntity[];
}

export interface KickoffChecklistEntity extends DwOrmData {
    // Attributes
    KickoffChecklistId?: number;
    KickoffId?: number;
    ChecklistId?: number;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    ChecklistIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    Checklist? : ChecklistEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface LicensesEntity extends DwOrmData {
    // Attributes
    LicenseId?: number;
    LicenseNumber?: string;
    IssueDate?: string;
    ExpirationDate?: string;
    IssuedTo?: number;
    LicenseType?: number;
    State?: number;
    County?: string;
    AttachmentFileId?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    StatusCv?: number;
    NinetyDayNotification?: boolean;
    SixtyDayNotification?: boolean;
    ThirtyDayNotification?: boolean;
    Notes?: string;
    HR217?: boolean;
    IsCertificate?: boolean;
    RejectedReason?: string;
    MediaGroupId?: number;
    CeuRequired?: number;
    CeuDetails?: string;

    // Display Attributes
    LicenseIdDisplay?: string;
    IssuedToDisplay?: string;
    LicenseTypeDisplay?: string;
    StateDisplay?: string;
    AttachmentFileIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    StatusCvDisplay?: string;

    // Relations
    AttachmentFileAttachment? : AttachmentEntity;
    AttachmentFileIdAttachment? : AttachmentEntity;
    LicenseIdAttachment? : AttachmentEntity;
    AttachmentFile? : AttachmentFileEntity;
    AttachmentFileIdAttachmentAttachmentFolder? : AttachmentAttachmentFolderEntity;
    StatusCvCodeValue? : CodeValueEntity;
    LicenseTypeLicenseType? : LicenseTypeEntity;
    StateEthosStateProvince? : EthosStateProvinceEntity;
    IssuedToEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    IssuedToRoEthosUser? : RoEthosUserEntity;
    // Duplicate property excluded
    // IssuedToEthosUser : EthosUserEntity;
    RoAttachmentFileNamesCombined? : RoAttachmentFileNamesCombinedEntity[];
}

export interface LicenseTypeEntity extends DwOrmData {
    // Attributes
    LicenseTypeId?: number;
    LicenseName?: string;
    HideFiles?: boolean;


    // Relations
    LicenseTypeLicenses? : LicensesEntity[];
}

export interface MaintenanceEntity extends DwOrmData {
    // Attributes
    MaintenanceId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    VehicleId?: number;
    Date?: string;
    DriverUserId?: number;
    RawDriverName?: string;
    JobNumberId?: number;
    Odometer?: number;
    Cost?: number;
    PONumber?: string;
    ServiceProvider?: string;
    ServiceType?: string;
    CurrentLicensePlate?: string;
    NoteParentId?: number;
    MediaGroupId?: number;
    Phase?: string;
    IsEmployee?: boolean;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    VehicleIdDisplay?: string;
    DriverUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    DriverEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
    MaintenanceService? : MaintenanceServiceEntity[];
    RoMaintenance? : RoMaintenanceEntity[];
}

export interface MaintenanceServiceEntity extends DwOrmData {
    // Attributes
    MaintenanceServiceId?: number;
    MaintenanceId?: number;
    ServiceTypeId?: number;

    // Display Attributes
    MaintenanceIdDisplay?: string;
    ServiceTypeIdDisplay?: string;

    // Relations
    Maintenance? : MaintenanceEntity;
    ServiceType? : ServiceTypeEntity;
}

export interface MedicalRecordEntity extends DwOrmData {
    // Attributes
    MedicalRecordId?: number;
    WorkplaceAccidentId?: number;
    Details?: string;
    TreatmentDateTime?: string;
    Cost?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface MemoOfRecordEntity extends DwOrmData {
    // Attributes
    MemoOfRecordId?: number;
    ConclusionCv?: number;
    EmployeeTypeCv?: number;
    StatusCv?: number;
    EmployeeEthos_UserId?: number;
    Ethos_SubcontractorBranchId?: number;
    SupervisorEthos_UserId?: number;
    AssignedToEthos_UserId?: number;
    Ethos_WachterDepartmentId?: number;
    Ethos_WachterTeamId?: number;
    EmployeeEthos_WachterJobTitleId?: number;
    AssignedToEmailMessageId?: string;
    EventDate?: string;
    ClosedDate?: string;
    Cost?: number;
    EmployeeName?: string;
    SupervisorName?: string;
    EmployeeDepartment?: string;
    EmployeeTitle?: string;
    ReferenceText?: string;
    Customer?: string;
    EventLocation?: string;
    City?: string;
    State?: string;
    EmailCopyString?: string;
    EventDescription?: string;
    BackgroundDescription?: string;
    BusinessImpactDescription?: string;
    LessonsLearnedDescription?: string;
    CreatedByEmailMessageId?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    IsDeleted?: boolean;
    CCEmailMessageId?: string;
    IssueSubTypeId?: number;
    AttachmentId?: number;
    SignedDocumentsAttachmentId?: number;
    WillUseAgain?: boolean;
    WillUseAgainDescription?: string;

    // Display Attributes
    ConclusionCvDisplay?: string;
    EmployeeTypeCvDisplay?: string;
    StatusCvDisplay?: string;
    EmployeeEthos_UserIdDisplay?: string;
    Ethos_SubcontractorBranchIdDisplay?: string;
    SupervisorEthos_UserIdDisplay?: string;
    AssignedToEthos_UserIdDisplay?: string;
    Ethos_WachterDepartmentIdDisplay?: string;
    Ethos_WachterTeamIdDisplay?: string;
    EmployeeEthos_WachterJobTitleIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    IssueSubTypeIdDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    SignedDocumentsAttachmentAttachment? : AttachmentEntity;
    EmployeeTypeCvCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    ConclusionCvCodeValue? : CodeValueEntity;
    IssueSubTypeIdIssueSubtype? : IssueSubtypeEntity;
    EthosEthosSubcontractorBranch? : EthosSubcontractorBranchEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    SupervisorEthosEthosUser? : EthosUserEntity;
    AssignedToEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosRoEthosUser? : RoEthosUserEntity;
    EthosEthosWachterDepartment? : EthosWachterDepartmentEntity;
    EmployeeEthosEthosWachterJobTitle? : EthosWachterJobTitleEntity;
    EthosEthosWachterTeam? : EthosWachterTeamEntity;
    AttachmentFileIdAttachmentFile? : AttachmentFileEntity[];
    // Duplicate property excluded
    // AttachmentFileIdAttachmentFile : AttachmentFileEntity[];
    MorMemoOfRecordNotificationGroup? : MorMemoOfRecordNotificationGroupEntity[];
    Note? : NoteEntity[];
    UserRead? : UserReadEntity[];
}

export interface MorMemoOfRecordNotificationGroupEntity extends DwOrmData {
    // Attributes
    MemoOfRecordNotificationGroupId?: number;
    MemoOfRecordId?: number;
    NotificationGroupId?: number;

    // Display Attributes
    MemoOfRecordIdDisplay?: string;
    NotificationGroupIdDisplay?: string;

    // Relations
    MemoOfRecord? : MemoOfRecordEntity;
    WcNotificationGroup? : WcNotificationGroupEntity;
}

export interface MessageEntity extends DwOrmData {
    // Attributes
    MessageText?: string;


    // Relations
}

export interface MilestoneEntity extends DwOrmData {
    // Attributes
    MilestoneId?: number;
    KickoffId?: number;
    Description?: string;
    DueDate?: string;
    IsDeleted?: boolean;

    // Display Attributes
    KickoffIdDisplay?: string;

    // Relations
    Kickoff? : KickoffEntity;
    MilestoneCheckpoint? : MilestoneCheckpointEntity[];
}

export interface MilestoneCheckpointEntity extends DwOrmData {
    // Attributes
    MilestoneCheckpointId?: number;
    MilestoneId?: number;
    CheckpointDate?: string;
    IsCheckpointCompleted?: boolean;
    IsDeleted?: boolean;

    // Display Attributes
    MilestoneIdDisplay?: string;

    // Relations
    Milestone? : MilestoneEntity;
}

export interface MissingForeignKeysEntity extends DwOrmData {
    // Attributes
    CREATE_Commented?: string;
    DROP_Commented?: string;
    FQN?: string;
    schema?: string;
    table?: string;
    column_name?: string;
    pk_tbl?: string;
    pk_col?: string;
    CREATE?: string;
    DROP?: string;


    // Relations
}

export interface NoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    MemoOfRecordId?: number;
    Note?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    MemoOfRecordIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    MemoOfRecord? : MemoOfRecordEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface WcNoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    Note?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    EmployeeTrainingNeededId?: number;

    // Display Attributes
    CreatedByEthos_UserIdDisplay?: string;
    EmployeeTrainingNeededIdDisplay?: string;

    // Relations
    EmployeeTrainingNeeded? : EmployeeTrainingNeededEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface EmsNoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    UserExtendedId?: number;
    Note?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    IsDeleted?: boolean;

    // Display Attributes
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
}

export interface NumbersNoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    Note?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    Ethos_UserId?: number;


    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface NotesNoteEntity extends DwOrmData {
    // Attributes
    NoteId?: number;
    NoteParentId?: number;
    Note?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    NoteTypeId?: number;
    AccessoryData?: number;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    NoteParentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    NoteTypeIdDisplay?: string;
    AccessoryDataDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    NotesNoteParent? : NotesNoteParentEntity;
    NoteType? : NoteTypeEntity;
    AccessoryDataPermit? : PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    ChangeRequest? : ChangeRequestEntity[];
}

export interface NotesNoteParentEntity extends DwOrmData {
    // Attributes
    NoteParentId?: number;
    CreatedDateTime?: string;


    // Relations
    Auction? : AuctionEntity[];
    Maintenance? : MaintenanceEntity[];
    NotesNote? : NotesNoteEntity[];
    Permit? : PermitEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    PermitRequest? : PermitRequestEntity[];
    StarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    FleetVehicle? : FleetVehicleEntity[];
    WorkplaceAccident? : WorkplaceAccidentEntity[];
    WorkersCompWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface NoteTypeEntity extends DwOrmData {
    // Attributes
    NoteTypeId?: number;
    NoteType?: string;
    MetaDataLookupId?: number;


    // Relations
    NotesNote? : NotesNoteEntity[];
}

export interface MorNotificationConfigEntity extends DwOrmData {
    // Attributes
    NotificationConfigId?: number;
    NotificationGroupId?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;
    IssueTypeId?: number;
    IssueSubtypeId?: number;
    SupervisorUserId?: number;
    To?: string;
    Cc?: string;
    Bcc?: string;

    // Display Attributes
    NotificationGroupIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    WachterDivisionIdDisplay?: string;
    IssueTypeIdDisplay?: string;
    IssueSubtypeIdDisplay?: string;
    SupervisorUserIdDisplay?: string;

    // Relations
    IssueSubtype? : IssueSubtypeEntity;
    IssueType? : IssueTypeEntity;
    WcNotificationGroup? : WcNotificationGroupEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosWachterDivision? : EthosWachterDivisionEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
}

export interface WcNotificationGroupEntity extends DwOrmData {
    // Attributes
    NotificationGroupId?: number;
    NotificationTypeCv?: number;
    GroupName?: string;
    NotificationEmailAddress?: string;
    NotificationEmailCopy?: string;
    IsDeleted?: boolean;
    SortOrder?: number;


    // Relations
    MorMemoOfRecordNotificationGroup? : MorMemoOfRecordNotificationGroupEntity[];
    MorNotificationConfig? : MorNotificationConfigEntity[];
}

export interface OrganizationalEntityEntity extends DwOrmData {
    // Attributes
    OrganizationalEntityId?: number;
    Name?: string;
    OrganizationalTypeId?: number;
    Alias?: string;
    HasRevenue?: boolean;
    OrganizationalParentEntityId?: number;
    EthosKeyId?: number;
    OverheadParentEntityId?: number;
    IsActive?: boolean;
    AssignmentStartDatetime?: string;
    AssignmentEndDatetime?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    OrganizationalTypeIdDisplay?: string;
    OrganizationalParentEntityIdDisplay?: string;
    OverheadParentEntityIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    OrganizationalParentEntityIdOrganizationalEntity? : OrganizationalEntityEntity;
    OrganizationalType? : OrganizationalTypeEntity;
    OverheadParentEntityIdOrganizationalEntity? : OrganizationalEntityEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    DWOSGFinDataLatest? : DWOSGFinDataLatestEntity[];
    OrganizationalMembership? : OrganizationalMembershipEntity[];
    // Duplicate property excluded
    // OrganizationalParentEntityIdOrganizationalEntity : OrganizationalEntityEntity[];
    // Duplicate property excluded
    // OverheadParentEntityIdOrganizationalEntity : OrganizationalEntityEntity[];
    OverheadTeamPhase? : OverheadTeamPhaseEntity[];
}

export interface OrganizationalMembershipEntity extends DwOrmData {
    // Attributes
    OrganizationalMembershipId?: number;
    OrganizationalEntityId?: number;
    Ethos_UserId?: number;
    LeadershipLevel?: number;
    WachterJobTitleId?: number;
    IsActive?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    OrganizationalEntityIdDisplay?: string;
    Ethos_UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;

    // Relations
    OrganizationalEntity? : OrganizationalEntityEntity;
    EthosEthosUser? : EthosUserEntity;
    EthosWachterJobTitle? : EthosWachterJobTitleEntity;
}

export interface OrganizationalTypeEntity extends DwOrmData {
    // Attributes
    OrganizationalTypeId?: number;
    Name?: string;
    ParentTypeId?: number;
    IsActive?: boolean;

    // Display Attributes
    ParentTypeIdDisplay?: string;

    // Relations
    ParentTypeIdOrganizationalType? : OrganizationalTypeEntity;
    OrganizationalEntity? : OrganizationalEntityEntity[];
    // Duplicate property excluded
    // ParentTypeIdOrganizationalType : OrganizationalTypeEntity[];
}

export interface OrganizationalUnitEntity extends DwOrmData {
    // Attributes
    OrganizationalUnitId?: number;
    UnitName?: string;
    DirectorEthos_UserId?: number;
    Ethos_WachterDepartmentId?: number;
    HasRevenue?: boolean;
    IsActive?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;


    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    DirectorEthosEthosUser? : EthosUserEntity;
    EthosEthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface OverheadProjectionEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    FiscalYear?: number;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Hours?: number;
    Notes?: string;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface OverheadTeamPhaseEntity extends DwOrmData {
    // Attributes
    OverheadTeamPhaseId?: number;
    OrganizationalTeamId?: number;
    TeamUnitId?: number;
    TeamUnitIsTeam?: boolean;
    FiscalYear?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    OrganizationalEntityId?: number;

    // Display Attributes
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    OrganizationalEntityIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    OrganizationalEntity? : OrganizationalEntityEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface PafHistoryEntity extends DwOrmData {
    // Attributes
    PafHistoryId?: number;
    VehicleId?: number;
    Note?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    VehicleIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    CreatedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface PassHistoryEntity extends DwOrmData {
    // Attributes
    PassHistoryId?: number;
    VehicleId?: number;
    ActivationDate?: string;
    AccountNumber?: string;
    AccountName?: string;
    TransponderSerialNumber?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    VehicleIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    CreatedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface PayJobChangeEntity extends DwOrmData {
    // Attributes
    PayJobChangeId?: number;
    EffectiveDate?: string;
    CurrentWage?: number;
    NewWage?: number;
    Notes?: string;
    IsPayChange?: boolean;
    IsOrganizationalChange?: boolean;
    EmployeeEthos_UserId?: number;
    NewManagerEthos_UserId?: number;
    PayChangeTypeCv?: number;
    StatusCv?: number;
    StatusAssignedToEthos_UserId?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    NewJobTitleId?: number;
    WagePercentChange?: number;
    NewEthos_WachterTeamId?: number;
    RejectedNotes?: string;
    RejectedByEthos_UserId?: number;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    NewManagerEthos_UserIdDisplay?: string;
    PayChangeTypeCvDisplay?: string;
    StatusCvDisplay?: string;
    StatusAssignedToEthos_UserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    NewJobTitleIdDisplay?: string;
    NewEthos_WachterTeamIdDisplay?: string;
    RejectedByEthos_UserIdDisplay?: string;

    // Relations
    StatusCvCodeValue? : CodeValueEntity;
    PayChangeTypeCvCodeValue? : CodeValueEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    NewManagerEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    StatusAssignedToEthosEthosUser? : EthosUserEntity;
    EmployeeEthosRoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity;
    CreatedbyEthosRoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity;
    RejectedByEthosEthosUser? : EthosUserEntity;
    NewJobTitleIdEthosWachterJobTitle? : EthosWachterJobTitleEntity;
    NewEthosEthosWachterTeam? : EthosWachterTeamEntity;
    PayJobChangeEmail? : PayJobChangeEmailEntity[];
    PayJobChangeUsersRead? : PayJobChangeUsersReadEntity[];
    PayJobChangeWorkflowEmail? : PayJobChangeWorkflowEmailEntity[];
    RoPafAccess? : RoPafAccessEntity[];
}

export interface PayJobChangeEmailEntity extends DwOrmData {
    // Attributes
    PayJobChangeEmail?: number;
    EmailId?: string;
    PayJobChangeId?: number;

    // Display Attributes
    PayJobChangeIdDisplay?: string;

    // Relations
    PayJobChange? : PayJobChangeEntity;
}

export interface PayJobChangeUsersReadEntity extends DwOrmData {
    // Attributes
    PayJobChangeUsersRead?: number;
    Ethos_UserId?: number;
    PayJobChangeId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    PayJobChangeIdDisplay?: string;

    // Relations
    PayJobChange? : PayJobChangeEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface PayJobChangeWorkflowEmailEntity extends DwOrmData {
    // Attributes
    PayJobChangeWorkflowEmailId?: number;
    PayJobChangeId?: number;
    StatusCv?: number;
    IsOrgChange?: boolean;
    ActionId?: string;
    ActionResult?: boolean;
    PublicKey?: string;

    // Display Attributes
    PayJobChangeIdDisplay?: string;
    StatusCvDisplay?: string;

    // Relations
    StatusCvCodeValue? : CodeValueEntity;
    PayJobChange? : PayJobChangeEntity;
}

export interface PeoplePayHistoryCurrentPreviousInitialEntity extends DwOrmData {
    // Attributes
    ETHOSUserId?: number;
    PayRecord?: number;
    EffectiveDate?: string;
    PayRate?: number;
    PayRateOrder?: string;


    // Relations
    ETHOSUserIdEmsUserExtended? : EmsUserExtendedEntity;
}

export interface PeoplePayHistoryCurrentPreviousInitialV2Entity extends DwOrmData {
    // Attributes
    ETHOSUserId?: number;
    PayRecord?: number;
    EffectiveDate?: string;
    PayRate?: number;
    PayRateOrder?: string;


    // Relations
    ETHOSUserIdEmsUserExtended? : EmsUserExtendedEntity;
}

export interface PerformanceMetricsEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    PerformanceAllTime?: number;
    KudosAllTime?: number;
    BehaiverAllTime?: number;
    MisconductAllTime?: number;
    PerformanceThisYear?: number;
    KudoThisYear?: number;
    BehaiverThisYear?: number;
    MisconductThisYear?: number;
    VehicleAccidentsAllTime?: number;
    VehicleAccidentsThisYear?: number;
    WorkplaceAccidentsAllTime?: number;
    WorkplaceAccidentsThisYear?: number;


    // Relations
    EmployeeEthosEmsUserExtended? : EmsUserExtendedEntity[];
}

export interface PermitEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUser?: number;
    PermitTypeCv?: number;
    DueDate?: string;
    ScopeOfWork?: string;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubcontractorLicense?: string;
    AssignedToUser?: number;
    FloorCount?: number;
    FacilitySquareFeet?: number;
    BuildingPermitNumber?: string;
    UndergroundCablingPresent?: boolean;
    CablingInConduitPresent?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    CableTypeCv?: number;
    PermitStatusWs?: number;
    JobId?: number;
    PermitTeamCv?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    AttachmentId?: number;
    CanBePulledOnline?: boolean;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    JobSiteId?: number;
    SharepointId?: number;
    PropertyOwnerAddress?: string;
    NoteParentId?: number;
    PermitRequestid?: number;
    OverallContractValuation?: number;
    PlenumOrRiserCv?: number;
    CableQuantity?: number;
    HasCameras?: boolean;
    CameraQuantity?: number;
    HasSpeakers?: boolean;
    SpeakerQuantity?: number;
    InitiationDeviceQuantity?: number;
    NACQuantity?: number;
    SwappingOutPanel?: boolean;
    OutletQuantity?: number;
    HasCardReaders?: boolean;
    CardReaderQuantity?: number;
    HasPaging?: boolean;
    AlarmPanelInstallation?: boolean;
    DeviceType?: string;
    OverallSOWValuation?: number;
    TotalAmps?: number;
    ElectricalPanelQuantity?: number;
    CircuitQuantity?: number;
    AccessControlTypeCv?: number;
    AccessControlQuantity?: number;
    AlarmPanelQuantity?: string;
    FilesInSharepoint?: boolean;
    CriticalPower?: boolean;
    RoomCount?: number;
    IsNewFireSystem?: boolean;
    CableTypeOtherName?: string;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalOtherWorkType?: string;
    ElectricalTotalVoltage?: number;
    IsTyingIntoFireAlarm?: boolean;
    AccessControlOther?: string;
    FireAlarmDemoInstallCv?: number;
    FireAlarmInstallRadio?: boolean;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVOtherInstallType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalWorkTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    CCTVInstallTypeCv?: number;
    InfoNeededNote?: string;
    EstimatedStartDate?: string;
    EstimatedJobCompletionDate?: string;
    FireAlarmAdditionalDevices?: number;
    PlenumRated?: boolean;
    WorkplaceSquareFeet?: number;
    ExpirationDate?: string;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    FollowUpDate?: string;
    Jurisdiction?: string;
    FollowUpDescription?: string;
    InspectionStateCv?: number;
    MediaGroupId?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    RequestedByUserDisplay?: string;
    PermitTypeCvDisplay?: string;
    PerformingWorkCvDisplay?: string;
    AssignedToUserDisplay?: string;
    CableTypeCvDisplay?: string;
    PermitStatusWsDisplay?: string;
    JobIdDisplay?: string;
    PermitTeamCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    AttachmentIdDisplay?: string;
    PropertyOwnerStateIdDisplay?: string;
    JobSiteIdDisplay?: string;
    NoteParentIdDisplay?: string;
    PermitRequestidDisplay?: string;
    PlenumOrRiserCvDisplay?: string;
    AccessControlTypeCvDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    InspectionStateCvDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    CableTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    PerformingWorkCvEthosCodeValue? : EthosCodeValueEntity;
    PlenumOrRiserCvEthosCodeValue? : EthosCodeValueEntity;
    CableTypeCvCodeValue? : CodeValueEntity;
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    AccessControlTypeCvCodeValue? : CodeValueEntity;
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    InspectionStateCvCodeValue? : CodeValueEntity;
    EthosJob? : EthosJobEntity;
    EthosJobSite? : EthosJobSiteEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    RoPermits? : RoPermitsEntity;
    PermitRequestidPermitRequest? : PermitRequestEntity;
    PropertyOwnerStateIdEthosStateProvince? : EthosStateProvinceEntity;
    RequestedByUserEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    AssignedToUserEthosUser? : EthosUserEntity;
    PermitStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    AccessControl? : AccessControlEntity[];
    Inspection? : InspectionEntity[];
    AccessoryDataNotesNote? : NotesNoteEntity[];
    PermitPermitType? : PermitPermitTypeEntity[];
    DataCablePermitRequest? : PermitRequestEntity[];
    PermitRequestPermit? : PermitRequestPermitEntity[];
    RequiredCable? : RequiredCableEntity[];
    RoInspections? : RoInspectionsEntity[];
}

export interface Permits2PermitEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    LegacyPermitRequestId?: number;
    LegacyPermitId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    PermitRequestTypeCv?: number;
    PermitTeamCv?: number;
    RushRequested?: boolean;
    DueDate?: string;
    RequestedByUserId?: number;
    EmailCopyString?: string;
    AssignedToUserId?: number;
    FollowUpDate?: string;
    IsLicenceRequired?: boolean;
    HasLicenseFile?: boolean;
    FollowUpDescription?: string;
    EstimatedStartDate?: string;
    EstimatedCompletionDate?: string;
    JobId?: number;
    JobSiteId?: number;
    Jurisdiction?: string;
    NoteParentId?: number;
    PerformingWorkCv?: number;
    SubContractorLicenseNumber?: string;
    CardReader?: boolean;
    CardReaderQuantity?: number;
    Paging?: boolean;
    IsTyingIntoFireAlarm?: boolean;
    VoiceDataPlenumRated?: boolean;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVPlenumRated?: boolean;
    HasCameras?: boolean;
    CamerasQuantity?: number;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVInstallTypeCv?: number;
    CCTVOtherInstallType?: string;
    AudioPlenumRated?: boolean;
    HasSpeakers?: boolean;
    SpeakersQuantity?: number;
    IsSwappingOutPanel?: boolean;
    IsNewFireSystem?: boolean;
    FireAlarmInitiatingDevices?: number;
    FireAlarmDemoInstallCv?: number;
    FireAlarmInstallRadio?: boolean;
    OutletQuantity?: number;
    TotalAmps?: number;
    PanelsQuantity?: number;
    CircuitsQuantity?: number;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    ElectricalWorkTypeCv?: number;
    ElectricalOtherWorkType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalTotalVoltage?: number;
    HasPanelInstallation?: boolean;
    BurglarAlarmPanelQuantity?: number;
    BurglarAlarmDeviceType?: string;
    NumberOfRooms?: number;
    FloorCount?: number;
    PlenumRiserCv?: number;
    HasUndergroundCabling?: boolean;
    HasCableInConduit?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    GCPermitNumber?: string;
    ValuationOverallContract?: number;
    ValuationOverallSOW?: number;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    CountOfNac?: number;
    FacilityFootage?: number;
    WorkplaceFootage?: number;
    ScopeOfWork?: string;
    MergeDeleted?: boolean;
    PropertyOwnerName?: string;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    PropertyOwnerAddress?: string;
    PermitCost?: number;
    CanBePulledOnline?: boolean;
    WachterPermitNumber?: string;
    ExpirationDate?: string;
    InfoNeededNote?: string;
    FilesInSharepoint?: boolean;
    SharepointId?: number;
    PermitStatusId?: number;
    MediaGroupId?: number;
    SubPanelQuantity?: number;
    FixtureQuantity?: number;
    AdditionalNotesElectrical?: string;
    CountAdditionalDevicesFire?: number;
    AdditionalDeviceDescriptionFire?: string;
    CountAdditionalDevicesBurglar?: number;
    AdditionalDeviceDescriptionBurglar?: string;
    CompleteDate?: string;
    TechnicianOnSite?: boolean;
    PermitRequired?: boolean;
    HasExceptions?: boolean;
    InspectionRequired?: boolean;
    ApplyForPermit?: boolean;
    JobNumberId?: number;
    JobNumberAddress1?: string;
    JobNumberAddress2?: string;
    JobNumberCity?: string;
    JobNumberStateProvinceId?: number;
    JobNumberPostalCode?: string;
    ChangeRequestId?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    PermitRequestTypeCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    RequestedByUserIdDisplay?: string;
    AssignedToUserIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;
    NoteParentIdDisplay?: string;
    PerformingWorkCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    PlenumRiserCvDisplay?: string;
    PropertyOwnerStateIdDisplay?: string;
    PermitStatusIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberStateProvinceIdDisplay?: string;
    ChangeRequestIdDisplay?: string;

    // Relations
    ChangeRequest? : ChangeRequestEntity;
    PermitRequestTypeCvCodeValue? : CodeValueEntity;
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    PlenumRiserCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJob? : EthosJobEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity;
    EthosJobSite? : EthosJobSiteEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    Permits2roPermits? : Permits2RoPermitsEntity;
    Permits2PermitStatus? : Permits2PermitStatusEntity;
    PropertyOwnerStateIdEthosStateProvince? : EthosStateProvinceEntity;
    JobNumberEthosStateProvince? : EthosStateProvinceEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    RequestedByEthosUser? : EthosUserEntity;
    AssignedToEthosUser? : EthosUserEntity;
    Permits2AccessControl? : Permits2AccessControlEntity[];
    PermitsV2IdAttachmentConversionPermit? : AttachmentConversionPermitEntity[];
    Permits2Inspection? : Permits2InspectionEntity[];
    Permits2PermitPermitType? : Permits2PermitPermitTypeEntity[];
    Permits2RequiredCable? : Permits2RequiredCableEntity[];
    RoActiveChangeRequest? : RoActiveChangeRequestEntity[];
    Permits2roInspections? : Permits2RoInspectionsEntity[];
    StageAuditLog? : StageAuditLogEntity[];
}

export interface PermitPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitPermitTypeId?: number;
    PermitId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitTypeCvCodeValue? : CodeValueEntity;
    Permit? : PermitEntity;
}

export interface Permits2PermitPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitPermitTypeId?: number;
    PermitId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
}

export interface PermitRequestEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    RequestedByUserId?: number;
    PermitTypeCv?: number;
    StatusCv?: number;
    DueDate?: string;
    WJID?: string;
    ScopeOfWork?: string;
    PulledOnline?: boolean;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    Valuation?: number;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubLicenseNumber?: string;
    PermitTeamCv?: number;
    AssignedToUserId?: number;
    NumberOfFloors?: number;
    FacilitySquareFeet?: number;
    PlenumOrRiser?: number;
    BuildingPermitNumber?: string;
    UndergroundCabling?: boolean;
    CablingInConduit?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    Address?: string;
    City?: string;
    StateProvinceId?: number;
    Zipcode?: string;
    AttachmentId?: number;
    JobSiteId?: number;
    CableTypeCv?: number;
    ConstructionType?: string;
    JobId?: number;
    OpportunityId?: number;
    DataCableQuantity?: number;
    HasCameras?: boolean;
    CamerasQuantity?: number;
    HasSpeakers?: boolean;
    SpeakersQuantity?: number;
    HasFireAlarm?: boolean;
    NumberAditionalDevices?: number;
    NumberNaNC?: number;
    IsSwappingOutPanel?: boolean;
    HasElectrical?: boolean;
    OutletQuantity?: number;
    TotalAmps?: number;
    PanelsQuantity?: number;
    CircuitsQuantity?: number;
    HasAccessControl?: boolean;
    AccessControlCV?: number;
    AccessControlQuantity?: number;
    CardReader?: boolean;
    CardReaderQuantity?: number;
    Paging?: boolean;
    HasPanelInstalation?: boolean;
    BuglarAlarmPanelQuantity?: number;
    BuglarAlarmDeviceType?: string;
    PerformWork?: number;
    SubContractorLicenseNumber?: string;
    SpecificDescription?: string;
    NumberOfRooms?: number;
    FacilitySquareFootage?: number;
    WorkspaceSquareFootage?: number;
    PlenumRiser?: number;
    HasUndergroundCabling?: boolean;
    HasCableInConduit?: boolean;
    ValuationOverallContract?: number;
    ValuationOverallSOW?: number;
    ExpectedStartDate?: string;
    ExpectedCompletion?: string;
    PermitRequestTypeCv?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    DataCablePermitId?: number;
    SecondaryAssignedToUserId?: number;
    CriticalPower?: boolean;
    JobSiteAddress1?: string;
    JobSiteAddress2?: string;
    CountyId?: number;
    PostalCode?: string;
    PermitRequestJobType?: number;
    GCPresent?: boolean;
    HasAudioVisual?: boolean;
    HasBurglarAlarm?: boolean;
    VoiceDataCableTypeCV?: number;
    VoiceDataQuantity?: number;
    VoiceDataPlenumRated?: boolean;
    HasCCTV?: boolean;
    CCTVCableTypeCV?: number;
    CCTVQuantity?: number;
    CCTVPlenumRated?: boolean;
    HasAudio?: boolean;
    AudioCableTypeCV?: number;
    AudioQuantity?: number;
    AudioPlenumRated?: boolean;
    IsNewFireSystem?: boolean;
    HasDataVoice?: boolean;
    GCPermitNumber?: string;
    FloorCount?: number;
    DataVoiceOtherCable?: string;
    CCTVOtherCable?: string;
    AudioVisualOtherCable?: string;
    NoteParentId?: number;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalOtherWorkType?: string;
    ElectricalTotalVoltage?: number;
    IsTyingIntoFireAlarm?: boolean;
    FireAlarmInitiatingDevices?: number;
    FireAlarmDemoInstallCv?: number;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVInstallTypeCv?: number;
    CCTVOtherInstallType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalWorkTypeCv?: number;
    AccessControlOther?: string;
    AccessControlOtherTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    FireAlarmInstallRadio?: boolean;
    IsLicenceRequired?: boolean;
    HasLicenseFile?: boolean;
    WorkplaceSquareFeet?: number;
    FollowUpDate?: string;
    RushRequested?: boolean;
    RequestCompleteDate?: string;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    Jurisdiction?: string;
    FollowUpDescription?: string;
    EmailCopyString?: string;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    RequestedByUserIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    StatusCvDisplay?: string;
    WJIDDisplay?: string;
    PerformingWorkCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    AssignedToUserIdDisplay?: string;
    PropertyOwnerNameDisplay?: string;
    StateProvinceIdDisplay?: string;
    AttachmentIdDisplay?: string;
    JobSiteIdDisplay?: string;
    CableTypeCvDisplay?: string;
    JobIdDisplay?: string;
    OpportunityIdDisplay?: string;
    AccessControlCVDisplay?: string;
    PerformWorkDisplay?: string;
    PlenumRiserDisplay?: string;
    PermitRequestTypeCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    DataCablePermitIdDisplay?: string;
    SecondaryAssignedToUserIdDisplay?: string;
    CountyIdDisplay?: string;
    PermitRequestJobTypeDisplay?: string;
    VoiceDataCableTypeCVDisplay?: string;
    CCTVCableTypeCVDisplay?: string;
    AudioCableTypeCVDisplay?: string;
    NoteParentIdDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    AccessControlOtherTypeCvDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    CableTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PlenumRiserEthosCodeValue? : EthosCodeValueEntity;
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    AccessControlCVCodeValue? : CodeValueEntity;
    AccessControlOtherTypeCvCodeValue? : CodeValueEntity;
    PermitRequestTypeCvCodeValue? : CodeValueEntity;
    AudioCableTypeCVCodeValue? : CodeValueEntity;
    CCTVCableTypeCVCodeValue? : CodeValueEntity;
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    VoiceDataCableTypeCVCodeValue? : CodeValueEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    DboEthosCounty? : DboEthosCountyEntity;
    EthosJob? : EthosJobEntity;
    WJIDEthosJob? : EthosJobEntity;
    EthosJobSite? : EthosJobSiteEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    DataCablePermit? : PermitEntity;
    RoPermitRequests? : RoPermitRequestsEntity;
    RoPermitRequestLastNote? : RoPermitRequestLastNoteEntity;
    PropertyOwnerNameEthosStateProvince? : EthosStateProvinceEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    AssignedToEthosUser? : EthosUserEntity;
    SecondaryAssignedToEthosUser? : EthosUserEntity;
    RequestedByEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    AccessControl? : AccessControlEntity[];
    PermitRequestidPermit? : PermitEntity[];
    PermitRequestPermit? : PermitRequestPermitEntity[];
    PermitRequestPermitType? : PermitRequestPermitTypeEntity[];
    RequiredCable? : RequiredCableEntity[];
}

export interface PermitRequestPermitEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    PermitId?: number;
    PermitTypeCV?: number;
    PermitRequestPermitId?: number;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    PermitTypeCVDisplay?: string;

    // Relations
    PermitTypeCVEthosCodeValue? : EthosCodeValueEntity;
    Permit? : PermitEntity;
    PermitRequest? : PermitRequestEntity;
}

export interface PermitRequestPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitRequestPermitTypeId?: number;
    PermitRequestId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvCodeValue? : CodeValueEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitRequest? : PermitRequestEntity;
}

export interface PermitStatusEntity extends DwOrmData {
    // Attributes
    PermitStatusId?: number;
    PermitStatusDisplay?: string;
    PermitSsatusMeaning?: string;
    PermitStatusOrder?: number;
    IsActive?: boolean;
    PermitStatusShortName?: string;


    // Relations
}

export interface Permits2PermitStatusEntity extends DwOrmData {
    // Attributes
    PermitStatusId?: number;
    PermitStatusDisplay?: string;
    PermitStatusMeaning?: string;
    PermitStatusOrder?: number;
    IsActive?: boolean;
    PermitStatusShortName?: string;


    // Relations
    InitialChangeRequest? : ChangeRequestEntity[];
    Permits2Permit? : Permits2PermitEntity[];
    StageAuditLog? : StageAuditLogEntity[];
}

export interface PlateHistoryEntity extends DwOrmData {
    // Attributes
    PlateHistoryId?: number;
    VehicleId?: number;
    LicensePlate?: string;
    PlateExpirationDate?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    VehicleIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    CreatedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface PolicyTypeEntity extends DwOrmData {
    // Attributes
    PolicyTypeId?: number;
    PolicyType?: string;


    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface ProjectMilestoneEntity extends DwOrmData {
    // Attributes
    ProjectMilestoneId?: number;
    KickoffId?: number;
    Name?: string;
    Description?: string;
    StartDate?: string;
    EndDate?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface ProofOfInsuranceEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceId?: number;
    PolicyNumber?: string;
    PolicyTypeId?: number;
    IssuedTo?: string;
    InsuranceCompany?: string;
    IssueDate?: string;
    ExpirationDate?: string;
    LicenseVerified?: boolean;
    POIStatusId?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    AttachmentFileId?: number;
    Notes?: string;
    CountryId?: number;
    StateProvinceId?: number;
    VehicleTypeId?: number;
    ProofOfInsuranceSummaryId?: number;
    SignedCorpFleetPolicy?: boolean;
    IsCurrent?: boolean;
    LicenseStateProvinceId?: number;
    LicenseIssueDate?: string;
    LicenseExpirationDate?: string;
    LicenseRestrictions?: string;

    // Display Attributes
    PolicyTypeIdDisplay?: string;
    POIStatusIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    AttachmentFileIdDisplay?: string;
    CountryIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    VehicleTypeIdDisplay?: string;
    ProofOfInsuranceSummaryIdDisplay?: string;
    LicenseStateProvinceIdDisplay?: string;

    // Relations
    AttachmentFile? : AttachmentFileEntity;
    EthosCountry? : EthosCountryEntity;
    ProofOfInsuranceStatus? : ProofOfInsuranceStatusEntity;
    PolicyType? : PolicyTypeEntity;
    ProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity;
    // Duplicate property excluded
    // ProofOfInsuranceSummary : ProofOfInsuranceSummaryEntity;
    // Duplicate property excluded
    // ProofOfInsuranceSummary : ProofOfInsuranceSummaryEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    LicenseEthosStateProvince? : EthosStateProvinceEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    VehicleType? : VehicleTypeEntity;
    ProofOfInsuranceSummaryProofOfInsuranceSummaryId? : ProofOfInsuranceSummaryEntity[];
}

export interface ProofOfInsuranceJobTitlesEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceJobTitlesId?: number;
    WachterJobTitleId?: number;

    // Display Attributes
    WachterJobTitleIdDisplay?: string;

    // Relations
    EthosWachterJobTitle? : EthosWachterJobTitleEntity;
    EthosUserWachterJobTitleId? : EthosUserEntity;
    // Duplicate property excluded
    // EthosUserWachterJobTitleId : EthosUserEntity;
}

export interface ProofOfInsuranceStatusEntity extends DwOrmData {
    // Attributes
    POIStatusId?: number;
    POIStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;


    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface ProofOfInsuranceSummaryEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceSummaryId?: number;
    IsApprovedDriver?: boolean;
    CanUsePersonalVehicle?: boolean;
    HasPoiOnPersonalVehicle?: boolean;
    NeedsTrustUpdate?: boolean;
    EmployeeEthos_UserId?: number;
    ProofOfInsuranceSummaryStatusId?: number;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    ProofOfInsuranceSummaryStatusIdDisplay?: string;

    // Relations
    ProofOfInsuranceProofOfInsuranceSummaryId? : ProofOfInsuranceEntity;
    ProofOfInsuranceSummaryStatus? : ProofOfInsuranceSummaryStatusEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    ProofOfInsurance? : ProofOfInsuranceEntity[];
    // Duplicate property excluded
    // ProofOfInsurance : ProofOfInsuranceEntity[];
    // Duplicate property excluded
    // ProofOfInsurance : ProofOfInsuranceEntity[];
    EmsUserExtendedEmployeeEthosUserId? : EmsUserExtendedEntity[];
}

export interface ProofOfInsuranceSummaryStatusEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceSummaryStatusId?: number;
    ProofOfInsuranceSummaryStatusDisplay?: string;


    // Relations
    ProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity[];
}

export interface RatingEntity extends DwOrmData {
    // Attributes
    RatingId?: number;
    RatingTypeId?: number;
    QuestionId?: number;
    ResponseInt?: number;
    ResponseText?: string;
    ResponderName?: string;
    ResponderCompanyId?: number;
    WachterJobId?: number;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    WachterJobIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    WachterEthosJob? : EthosJobEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface RatingQuestionEntity extends DwOrmData {
    // Attributes
    RatingQuestionId?: number;
    RatingTypeId?: number;
    Question?: string;
    QuestionOrder?: number;
    IsActive?: boolean;


    // Relations
}

export interface RatingTypeEntity extends DwOrmData {
    // Attributes
    RatingTypeId?: number;
    Display?: string;
    Description?: string;
    IsActive?: boolean;


    // Relations
}

export interface ReportingEntity extends DwOrmData {
    // Attributes
    ReportingId?: number;
    KickoffId?: number;
    Name?: string;
    Owner?: string;
    Recipient?: string;
    Contents?: string;
    Frequency?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface RequestEntity extends DwOrmData {
    // Attributes
    RequestId?: number;
    CompanyId?: number;
    DeliveryOptionCv?: number;
    CompanyEmail?: string;
    EmailCopyString?: string;
    AcountNumber?: string;
    NeededByDateTime?: string;
    DeliveredByDateTime?: string;
    PickupByDateTime?: string;
    IsAutoPickup?: boolean;
    AreSubstitutionsAllowed?: boolean;
    HasProtectionPlan?: boolean;
    Notes?: string;
    JobNumber?: string;
    JobSiteAddress?: string;
    SiteContactName?: string;
    SiteContactPhoneNumber?: string;
    DropOffArea?: string;
    RequesterNameAndNumber?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    IsDeleted?: boolean;
    AutoPickupText?: string;
    JobName?: string;
    LookUpTarget?: string;

    // Display Attributes
    CompanyIdDisplay?: string;
    DeliveryOptionCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    DeliveryOptionCvCodeValue? : CodeValueEntity;
    Company? : CompanyEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    RequestEquipment? : RequestEquipmentEntity[];
    UserIdRoEthosUser? : RoEthosUserEntity[];
}

export interface TravelRequestEntity extends DwOrmData {
    // Attributes
    RequestId?: number;
    JobNumberWjid?: string;
    DepartureLocation?: string;
    DestinationLocation?: string;
    DestinationArrivalDate?: string;
    ReturningDate?: string;
    TravelModeCv?: number;
    TraveModeComment?: string;
    FlightPreference?: string;
    AirportPlanCv?: number;
    AirportPlanComment?: string;
    TransportationPlanCv?: number;
    TransportationPlanComment?: string;
    LodgingPlanCv?: number;
    LodgingPlanComment?: string;
    TravelRequestComments?: string;
    TravelTypeCv?: number;
    TravelTypeComment?: string;
    ProjectManagerEthos_UserId?: number;
    Customer?: string;
    CustomerPm?: string;
    TravelReason?: string;
    PotentialRevenue?: number;
    NumberOfSites?: number;
    ProjectDuration?: string;
    MeetingNotes?: string;
    TravelerEthos_UserId?: number;
    Preferences?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ParkingPassNeeded?: boolean;
    ParkingPassReturned?: boolean;

    // Display Attributes
    TravelModeCvDisplay?: string;
    AirportPlanCvDisplay?: string;
    TransportationPlanCvDisplay?: string;
    LodgingPlanCvDisplay?: string;
    TravelTypeCvDisplay?: string;
    ProjectManagerEthos_UserIdDisplay?: string;
    TravelerEthos_UserIdDisplay?: string;

    // Relations
    TransportationPlanCvCodeValue? : CodeValueEntity;
    TravelModeCvCodeValue? : CodeValueEntity;
    AirportPlanCvCodeValue? : CodeValueEntity;
    LodgingPlanCvCodeValue? : CodeValueEntity;
    TravelTypeCvCodeValue? : CodeValueEntity;
    ProjectManagerEthosEthosUser? : EthosUserEntity;
    TravelerEthosEthosUser? : EthosUserEntity;
    ProjectManagerEthosRoEthosUser? : RoEthosUserEntity;
    RequestPreferences? : RequestPreferencesEntity[];
    UserIdRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // UserIdRoEthosUser : RoEthosUserEntity[];
    RoRequest? : RoRequestEntity[];
    Traveler? : TravelerEntity[];
}

export interface RequestEquipmentEntity extends DwOrmData {
    // Attributes
    RequestEquipmentId?: number;
    RequestId?: number;
    EquipmentId?: number;
    Quantity?: number;
    Comments?: string;
    EquipmentText?: string;

    // Display Attributes
    RequestIdDisplay?: string;
    EquipmentIdDisplay?: string;

    // Relations
    Equipment? : EquipmentEntity;
    Request? : RequestEntity;
}

export interface RequestPreferencesEntity extends DwOrmData {
    // Attributes
    RequestPreferencesId?: number;
    RequestId?: number;
    PreferenceCv?: number;
    PreferenceComment?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    RequestIdDisplay?: string;

    // Relations
    TravelRequest? : TravelRequestEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface RequiredCableEntity extends DwOrmData {
    // Attributes
    RequiredCableId?: number;
    CableTypeCv?: number;
    Quantity?: number;
    Description?: string;
    PermitRequestId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    CableTypeCvDisplay?: string;
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    Permit? : PermitEntity;
    PermitRequest? : PermitRequestEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface Permits2RequiredCableEntity extends DwOrmData {
    // Attributes
    RequiredCableId?: number;
    CableTypeCv?: number;
    Quantity?: number;
    Description?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    CableTypeCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;

    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    CableTypeCvCodeValue? : CodeValueEntity;
    Permits2Permit? : Permits2PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface ResourceCostEntity extends DwOrmData {
    // Attributes
    resourceCostId?: number;
    Ethos_UserId?: number;
    CurrentUserTeamId?: number;
    CurrentUserEthosId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    CurrentUserTeamIdDisplay?: string;
    CurrentUserEthosIdDisplay?: string;

    // Relations
    RoEthosUserBurdon? : RoEthosUserBurdonEntity;
    EthosUserIdDWPeoplePaySummary? : DWPeoplePaySummaryEntity;
    CurrentUserEthosIdEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    CurrentUserTeamIdEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface ReviewEntity extends DwOrmData {
    // Attributes
    ReviewId?: number;
    ReviewDate?: string;
    FollowUpDate?: string;
    IsDeleted?: boolean;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByUserId?: number;
    ModifiedByDateTime?: string;


    // Relations
    ModifiedByEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
}

export interface RoEthosUserBurdonEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    EmployeeGroupDescription?: string;
    StateProvinceShortName?: string;
    RegularPay?: number;
    OTPay?: number;
    DTPay?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
    ResourceCost? : ResourceCostEntity[];
}

export interface RoAccidentEntity extends DwOrmData {
    // Attributes
    AccidentId?: number;
    TypeCv?: number;
    AccidentType?: string;
    EmployeeUserId?: number;
    EmployeeName?: string;
    WachterDepartmentId?: number;
    WachterDepartment?: string;
    IsAtFault?: string;
    IsWachterInjury?: string;
    IsOtherInjury?: string;
    IsHospitalVisit?: string;
    IsDoctorVisit?: string;
    IsFirstAidOnly?: string;
    Treatment?: string;
    AccidentDescription?: string;
    InjuryDetail?: string;
    DamageDetail?: string;
    IsDeleted?: boolean;
    CreatedByUserId?: number;
    CreatedBy?: string;
    CreatedByDateTime?: string;
    ModifiedByUserId?: number;
    ModifiedBy?: string;
    ModifiedByDateTime?: string;
    ModifiedByDateTimeCentral?: string;
    ModifiedWeekEndingDate?: string;
    ReportDate?: string;
    HasPriorAccidents?: string;
    AccidentDateTime?: string;
    Address?: string;
    CityState?: string;
    WJID?: number;
    OtherPartiesInjured?: string;
    MedicalNeeded?: string;
    AccidentCalledIntoHotline?: string;
    Customer?: string;
    JobNumber?: string;
    Site?: string;
    JobsWorkedNote?: string;
    ActionLeadingToAccident?: string;
    HoursWorkedDescription?: string;
    RestOnAccidentDate?: string;
    WorkRestDayBefore?: string;
    WorkRestTwoDaysBefore?: string;
    PriorAccidentList?: string;
    RepairEstimate?: number;
    CreatedByDateTimeCentral?: string;


    // Relations
}

export interface RoActiveChangeRequestEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    ChangeRequestId?: number;
    CompletedByUserId?: number;
    HasActiveRequest?: boolean;


    // Relations
    Permits2Permit? : Permits2PermitEntity;
}

export interface RoActiveSubordinatesEntity extends DwOrmData {
    // Attributes
    depth?: number;
    SupervisorUserId?: number;
    FirstName?: string;
    LastName?: string;
    NameLastFirstPreferedType?: string;
    Status?: number;
    Terminated?: boolean;
    EmployeeEthos_UserId?: number;


    // Relations
}

export interface RoAllSupervisorsSubordinatesEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    SupervisorUserId?: number;
    NameLastFirstPreferedType?: string;
    Depth?: number;

    // Display Attributes
    UserIdDisplay?: string;
    SupervisorUserIdDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EmployeeEthosPayJobChange? : PayJobChangeEntity[];
    CreatedbyEthosPayJobChange? : PayJobChangeEntity[];
    EmployeeRoEthosUserGrid? : RoEthosUserGridEntity[];
    EmployeeEthosEmsUserExtended? : EmsUserExtendedEntity[];
}

export interface RoAllSupervisorsSubordinatesOptimizedEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    SupervisorUserId?: number;
    NameLastFirstPreferedType?: string;
    Depth?: number;


    // Relations
}

export interface RoAllSupervisorsSubordinatesOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    SupervisorUserId?: number;
    NameLastFirstPreferedType?: string;
    Depth?: number;


    // Relations
}

export interface RoAttachmentFileNamesCombinedEntity extends DwOrmData {
    // Attributes
    LicenseId?: number;
    AttachmentName?: string;

    // Display Attributes
    LicenseIdDisplay?: string;

    // Relations
    Licenses? : LicensesEntity;
}

export interface RoAuctionEntity extends DwOrmData {
    // Attributes
    AuctionId?: number;
    CurrentBid?: number;
    FinalBid?: number;
    CreatedByUserId?: number;
    StatusCv?: number;
    AppUserId?: number;

    // Display Attributes
    AuctionIdDisplay?: string;
    StatusCvDisplay?: string;

    // Relations
    Auction? : AuctionEntity;
}

export interface RoAuditIssueEntity extends DwOrmData {
    // Attributes
    IssueId?: number;
    AuditName?: string;
    AuditStartDate?: string;
    AuditCompleteDate?: string;
    Auditor?: string;
    Process?: string;
    IssueName?: string;
    IssueDetail?: string;
    RecommendationDetail?: string;
    IssueRating?: string;
    IssueRatingNote?: string;
    IssueRiskType?: string;
    IssueOwner?: string;
    ELT?: string;
    DelegatedOwner?: string;
    OwnerActionPlan?: string;
    ActionPlanDueDate?: string;
    IssueStatus?: string;
    RequestUpdate?: boolean;
    CreatedBy?: string;
    CreatedByDateTime?: string;
    ModifiedBy?: string;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoAuditSupervisorAccessEntity extends DwOrmData {
    // Attributes
    IssueId?: number;
    Owner?: number;
    Auditor?: number;
    Delegate?: number;
    CreatedBy?: number;
    ELT?: number;
    ViewableBy?: number;
    FirstName?: string;
    LastName?: string;
    ReportingLevels?: number;


    // Relations
    AuditIssue? : AuditIssueEntity;
}

export interface RoAvStarRatingNspTechEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    TechUserId?: number;

    // Display Attributes
    TechUserIdDisplay?: string;

    // Relations
}

export interface RoCollaborationEntity extends DwOrmData {
    // Attributes
    CollaborationId?: number;
    FromDepartmentId?: number;
    FromDepartment?: string;
    FromPmUserId?: number;
    FromPm?: string;
    ToDepartmentId?: number;
    ToDepartment?: string;
    ToPmUserId?: number;
    ToPm?: string;
    CustomerName?: string;
    CustomerPm?: string;
    CustomerTitle?: string;
    ProjectName?: string;
    SiteCount?: number;
    RevenuePerSite?: number;
    CollaborationDate?: string;
    IsDeleted?: boolean;
    CreatedByUserId?: number;
    CreatedBy?: string;
    CreatedByDateTime?: string;
    ModifiedByUserId?: number;
    ModifiedBy?: string;
    ModifiedByDateTime?: string;
    ModifiedByDateTimeCentral?: string;
    ModifiedWeekEndingDate?: string;
    TotalRevenue?: number;
    ReportDate?: string;
    CreatedByDateTimeCentral?: string;


    // Relations
}

export interface RoCustomerSatisfactionEntity extends DwOrmData {
    // Attributes
    CustomerSatisfactionId?: number;
    Customer?: string;
    PmUserId?: number;
    ProjectManager?: string;
    WachterDepartmentId?: number;
    WachterDepartment?: string;
    City?: string;
    State?: string;
    SiteLocation?: string;
    Description?: string;
    CostOrGain?: number;
    CustomerSatisfactionDate?: string;
    IsDeleted?: boolean;
    CreatedByUserId?: number;
    CreatedBy?: string;
    CreatedByDateTime?: string;
    ModifiedByUserId?: number;
    ModifiedBy?: string;
    ModifiedByDateTime?: string;
    ModifiedByDateTimeCentral?: string;
    ModifiedWeekEndingDate?: string;
    ReportDate?: string;
    CreatedByDateTimeCentral?: string;


    // Relations
}

export interface RoEmployeeDetailEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    NameLastFirstPrefered?: string;
    NameFirstPreferedLast?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    OfficePhone?: string;
    MobilePhone?: string;
    BirthdayAnniversaryDate?: string;
    empHireDate?: string;
    HiredAnniversaryDate?: string;
    AdjustedStartDate?: string;
    StartedAnniversaryDate?: string;
    Email?: string;
    HasVehicle?: boolean;
    WachterJobTitle?: string;
    OfficeName?: string;
    SupervisorUserId?: number;
    SupervisorNameLastFirstPrefered?: string;
    SupervisorNameFirstPreferedLast?: string;
    UserStatusMeaning?: string;
    ResourceGroup?: string;
    EmployeeGroupDescription?: string;
    UserTypeDisplay?: string;
    FosEthos_UserId?: number;
    FosNameLastFirstPrefered?: string;
    FosNameFirstPreferedLast?: string;
    HiringManagerEthos_UserId?: number;
    HiringManagerNameLastFirstPrefered?: string;
    HiringManagerNameFirstPreferedLast?: string;
    CurrentPay?: number;
    LastEvalDate?: string;
    EmployeeType?: string;
    OrientationDate?: string;
    TeamName?: string;
    DepartmentShortName?: string;
    DivisionShortName?: string;
    TechType?: string;
    TerritoryName?: string;
    OperationsManagerEthos_UserId?: number;
    OperationsManagerNameLastFirstPrefered?: string;
    OperationsManagerNameFirstPreferedLast?: string;
    FosDistanceInMiles?: number;
    AXId?: string;


    // Relations
}

export interface RoEmployeeDetailFullEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    HiredAnniversaryDate?: string;
    AdjustedStartDate?: string;
    StartedAnniversaryDate?: string;
    OrientationDate?: string;
    BirthdayAnniversaryDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    WachterTeamId?: number;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    WachterDepartmentId?: number;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Email?: string;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    PostalCode?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    UserExtendedId?: number;
    TechType?: string;
    CurrentPay?: number;
    LastEvalDate?: number;
    PayChangeDate?: string;
    SupervisorUserId?: number;
    SupervisorUserName?: string;
    SupervisorFirstName?: string;
    SupervisorLastName?: string;
    SupervisorMiddleName?: string;
    SupervisorPreferredName?: string;
    SupervisorSuffix?: string;
    SupervisorOfficePhone?: string;
    SupervisorMobilePhone?: string;
    SupervisorJobTitle?: string;
    SupervisorEmail?: string;
    SupervisorPictureAttachmentFileKey?: string;
    SupervisorPictureAttachmentFileExtension?: string;
    Supervisor?: string;
    SupervisorNameLastPrefered?: string;
    SupervisorNameLastFirstPrefered?: string;
    SupervisorNameFirstLast?: string;
    SupervisorNamePreferedLast?: string;
    SupervisorNameFirstPreferedLast?: string;
    SupervisorNameFirstMiddleLast?: string;
    FosEthos_UserId?: number;
    FosOfficePhone?: string;
    FosMobilePhone?: string;
    FosEmail?: string;
    FosPictureAttachmentFileKey?: string;
    FosPictureAttachmentFileExtension?: string;
    FosNameLastFirst?: string;
    FosNameLastPrefered?: string;
    FosNameLastFirstPrefered?: string;
    FosNameFirstLast?: string;
    FosNamePreferedLast?: string;
    FosNameFirstPreferedLast?: string;
    FosNameFirstMiddleLast?: string;
    HiringManagerEthos_UserId?: number;
    HiringManagerOfficePhone?: string;
    HiringManagerMobilePhone?: string;
    HiringManagerEmail?: string;
    HiringManagerPictureAttachmentFileKey?: string;
    HiringManagerPictureAttachmentFileExtension?: string;
    HiringManagerNameLastFirst?: string;
    HiringManagerNameLastPrefered?: string;
    HiringManagerNameLastFirstPrefered?: string;
    HiringManagerNameFirstLast?: string;
    HiringManagerNamePreferedLast?: string;
    HiringManagerNameFirstPreferedLast?: string;
    HiringManagerNameFirstMiddleLast?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    TerritoryDescription?: string;
    OperationsManagerEthos_UserId?: number;
    OperationsManagerOfficePhone?: string;
    OperationsManagerMobilePhone?: string;
    OperationsManagerEmail?: string;
    OperationsManagerPictureAttachmentFileKey?: string;
    OperationsManagerPictureAttachmentFileExtension?: string;
    OperationsManagerNameLastFirst?: string;
    OperationsManagerNameLastPrefered?: string;
    OperationsManagerNameLastFirstPrefered?: string;
    OperationsManagerNameFirstLast?: string;
    OperationsManagerNamePreferedLast?: string;
    OperationsManagerNameFirstPreferedLast?: string;
    OperationsManagerNameFirstMiddleLast?: string;
    AXId?: string;

    // Display Attributes
    UserStatusWsDisplay?: string;

    // Relations
}

export interface RoEmployeeReviewSummaryCurrentEntity extends DwOrmData {
    // Attributes
    EmployeeReviewSummaryId?: number;
    EmployeeReviewSummaryStatusId?: number;
    EmployeeReviewSummaryTypeId?: number;
    EmployeeEthosUserId?: number;
    SupervisorEthosUserId?: number;
    ReviewYear?: number;
    DueDate?: string;
    ReviewNotes?: string;
    CompletedByEthos_UserId?: number;
    CompletedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ShowGraph?: boolean;


    // Relations
    EmployeeEthosEthosUser? : EthosUserEntity;
}

export interface RoEmsPBiEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    SupervisorUserId?: number;
    NameLastFirstPreferedType?: string;
    depth?: string;


    // Relations
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    UserIdTravelRequest? : TravelRequestEntity;
    UserIdRoRequest? : RoRequestEntity;
    UserIdFiveStarRating? : FiveStarRatingEntity;
    UserIdRequest? : RequestEntity;
    UserIdEmsUserExtended? : EmsUserExtendedEntity;
    // Duplicate property excluded
    // UserIdTravelRequest : TravelRequestEntity;
    // Duplicate property excluded
    // UserIdRoRequest : RoRequestEntity;
    // Duplicate property excluded
    // UserIdFiveStarRating : FiveStarRatingEntity;
    EthosStaffingAgency? : EthosStaffingAgencyEntity;
    EthosStateProvince? : EthosStateProvinceEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    Territory? : TerritoryEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosWachterJobTitle? : EthosWachterJobTitleEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    ETHOSDWPeoplePaySummary? : DWPeoplePaySummaryEntity[];
    SubmittedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    RejectedByEthosEmployeeReviewQuestionRequest? : EmployeeReviewQuestionRequestEntity[];
    EmployeeEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    CreatedByEthosEmployeeTrainingNeeded? : EmployeeTrainingNeededEntity[];
    EthosLaborMetrics? : EthosLaborMetricsEntity[];
    IssuedToLicenses? : LicensesEntity[];
    CreatedByEthosMemoOfRecord? : MemoOfRecordEntity[];
    ProjectManagerEthosTravelRequest? : TravelRequestEntity[];
    ProjectManagerEthosRoRequest? : RoRequestEntity[];
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
    EthosMtlUserExtended? : MtlUserExtendedEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity;
    EthosUserYearNumbers? : UserYearNumbersEntity[];
    EmployeeIdVehicleAccident? : VehicleAccidentEntity;
    CreatedbyEthosVehicleAccident? : VehicleAccidentEntity[];
    ModifiedByEthosVehicleAccident? : VehicleAccidentEntity[];
    // Duplicate property excluded
    // EmployeeIdVehicleAccident : VehicleAccidentEntity[];
}

export interface RoEthosUserAddSubTempEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;


    // Relations
}

export interface RoEthosUserGridEntity extends DwOrmData {
    // Attributes
    EmployeeUserId?: number;
    EmployeeProfilePicUserId?: number;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserStatusWs?: number;
    SupUserId?: number;
    Email?: string;
    HasVehicle?: boolean;
    OfficePhone?: string;
    MobilePhone?: string;
    EmployeeType?: string;
    NAME?: string;
    AverageHours52Week?: number;

    // Display Attributes
    EmployeeUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    SupUserIdDisplay?: string;

    // Relations
    EmployeeUserIdEmsUserExtended? : EmsUserExtendedEntity;
    EmployeeRoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity;
    ETHOSUserIdDWPeoplePaySummary? : DWPeoplePaySummaryEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoEthosTeamsAndOrganizationalUnitsEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamName?: string;
    IsTeam?: number;


    // Relations
}

export interface RoFiscalYearRangeEntity extends DwOrmData {
    // Attributes
    YearId?: number;
    FiscalYear?: number;


    // Relations
}

export interface RoInspectionsEntity extends DwOrmData {
    // Attributes
    TechMobile?: string;
    TechOffice?: string;
    TechEmail?: string;
    InspectionId?: number;
    InspectionType?: string;
    TechnicianOnSite?: boolean;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    AdditionalInspectionNeeded?: boolean;
    PreferredTimeOfDay?: string;
    Result?: string;
    TechFirstName?: string;
    TechLastName?: string;

    // Display Attributes
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ResultCvDisplay?: string;

    // Relations
    Permit? : PermitEntity;
}

export interface Permits2RoInspectionsEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    PreferredTimeOfDay?: string;
    PreferredTimeOfDayCv?: number;
    Result?: string;
    ResultCv?: number;
    TechnicianUserId?: number;
    TechFirstName?: string;
    TechLastName?: string;
    TechOffice?: string;
    TechMobile?: string;
    TechEmail?: string;
    InspectionType?: string;
    AvailableDates?: string;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultDateTime?: string;
    ResultNotes?: string;
    InspectionStatusId?: number;
    Subcontractor?: string;
    UseSub?: boolean;

    // Display Attributes
    PreferredTimeOfDayCvDisplay?: string;
    ResultCvDisplay?: string;
    TechnicianUserIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    InspectionStatusIdDisplay?: string;

    // Relations
    Permits2Permit? : Permits2PermitEntity;
}

export interface RoIssueTypeSubtypeSeverityEntity extends DwOrmData {
    // Attributes
    IssueSubtypeId?: number;
    IssueSubtype?: string;
    IssueSubtypeAlt?: string;
    IssueSubtypeSortOrder?: number;
    IssueSubtypeIsActive?: boolean;
    IssueTypeId?: number;
    IssueGroup?: string;
    IssueGroupAlt?: string;
    IsNotifyWachterSupervisor?: boolean;
    IsNotifySubcontractorSubervisor?: boolean;
    IsNotifyAgencySupervisor?: boolean;
    IssueTypeSortOrder?: number;
    IssueTypeIsActive?: boolean;
    IssueSubtypeSeverityId?: number;
    Severity?: string;
    SeveritySortOrder?: number;
    SeverityIsActive?: boolean;
    IssueGroupSubtype?: string;
    IssueGroupSubtypeAlt?: string;


    // Relations
}

export interface RoKickoffEntity extends DwOrmData {
    // Attributes
    KickoffId?: number;
    Ethos_JobNumberId?: number;
    BillingInvoiceDate?: string;
    CloseoutMeetingDate?: string;
    CloseoutDeliverableCompletedByDate?: string;
    ExternalKickoffDate?: string;
    ScheduledStartDate?: string;
    ScheduledEndDate?: string;
    AttendeeInformation?: string;
    ScopeOfWork?: string;
    ChangeOrderProcessDescription?: string;
    CustomerPaymentProcedure?: string;
    CustomerAccountingContactDetail?: string;
    DeliverablesForBilling?: string;
    EscalationPathDescription?: string;
    IntroductionText?: string;
    CommunicationDescription?: string;
    SafetyPlanDescription?: string;
    SiteContactInformation?: string;
    StakeholderInformation?: string;
    OtherNotes?: string;
    IsBillingACH?: boolean;
    IsBuyerSignatureRequired?: boolean;
    IsMonthlyBilling?: boolean;
    IsWrittenBillingApprovalRequired?: boolean;
    IsDeleted?: boolean;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    JobNumber?: string;
    JobYear?: number;
    WachterTeamCode?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    ProjectManager?: string;
    ProjectManagerUserId?: number;
    WachterDepartmentCode?: string;
    WachterDivisionId?: number;
    WachterDivisionCode?: string;

    // Display Attributes
    Ethos_JobNumberIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;

    // Relations
    Kickoff? : KickoffEntity;
}

export interface RoLastAccidentSummaryEntity extends DwOrmData {
    // Attributes
    LastWorkplaceAccidentDateTime?: string;
    DaysSinceWorkplaceAccident?: number;
    LastVehicleAccidentDateTime?: string;
    DaysSinceVehicleAccident?: number;


    // Relations
}

export interface RoLicenseCountPerUserEntity extends DwOrmData {
    // Attributes
    IssuedTo?: number;
    LicenseCount?: number;


    // Relations
}

export interface RoLicensesEntity extends DwOrmData {
    // Attributes
    IssuedTo?: number;
    LicenseTypeId?: number;
    LicenseType?: string;
    ExpirationDate?: string;

    // Display Attributes
    IssuedToDisplay?: string;

    // Relations
    IssuedToEmsUserExtended? : EmsUserExtendedEntity;
}

export interface RoMaintenanceEntity extends DwOrmData {
    // Attributes
    MaintenanceId?: number;
    SortableUnitId?: number;
    DriverName?: string;
    JobNumberId?: number;
    VIN?: string;
    VehicleId?: number;

    // Display Attributes
    MaintenanceIdDisplay?: string;
    JobNumberIdDisplay?: string;
    VehicleIdDisplay?: string;

    // Relations
    Maintenance? : MaintenanceEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface RoMilestoneAndMilestoneCheckpointEntity extends DwOrmData {
    // Attributes
    MilestoneId?: number;
    KickoffId?: number;
    Description?: string;
    DueDate?: string;
    MilestoneCheckpointId?: number;
    CheckpointDate?: string;
    IsCheckpointCompleted?: boolean;


    // Relations
}

export interface RoNspCommittedByDepartmentEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspCommittedByProjectManagerEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    FiscalYear?: number;
    CreatedByDateTime?: string;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspCommittedByTeamEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspCommittedByUnitEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspDwFinancialsByDepartmentByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    DepartmentId?: number;
    fcRev_Jtd?: number;
    fcCost_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;


    // Relations
}

export interface RoNspDwFinancialsByProjectManagerByYearEntity extends DwOrmData {
    // Attributes
    ProjectMgr1UserId?: number;
    Year?: number;
    YearCategory?: string;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    HasRevenue?: boolean;
    fcRev_Jtd?: number;
    fcCost_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;
    // Attribute fcRev-PYs has invalid characters and can't be included
    // Attribute fcpcRev-PYs has invalid characters and can't be included
    // Attribute fcCost-PYs has invalid characters and can't be included
    // Attribute fcGP-PYs has invalid characters and can't be included
    // Attribute fcpcGP-PYs has invalid characters and can't be included


    // Relations
}

export interface RoNspDwFinancialsByTeamByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    HasRevenue?: boolean;
    fcRev_Jtd?: number;
    fcCost_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;


    // Relations
}

export interface RoNspDwFinancialsByUnitByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    UnitId?: number;
    DepartmentId?: number;
    HasRevenue?: boolean;
    fcRev_Jtd?: number;
    fcCost_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;


    // Relations
}

export interface RoNspDwOverheadByDepartmentByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    DepartmentId?: number;
    Overhead_Ytd?: number;


    // Relations
}

export interface RoNspDwOverheadByTeamByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    TeamUnitIsTeam?: boolean;
    Overhead_Ytd?: number;


    // Relations
}

export interface RoNSPFinancialNumbersEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    PMNameFirstPreferredLast?: string;
    PMNameLastFirstPreferred?: string;
    PMNameFirstLast?: string;
    PMNamePreferredLast?: string;
    EthosTitle?: string;
    EthosEmail?: string;
    EthosSupId?: number;
    SupNameFirstPreferredLast?: string;
    SupNameLastFirstPreferred?: string;
    SupNameFirstLast?: string;
    SupNamePreferredLast?: string;
    TeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    DepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;
    PyCommittedRevenue?: number;
    PyCommittedCost?: number;
    PyCommittedTeamRevenue?: number;
    PyCommittedTeamCost?: number;
    PyCommittedTeamPercentage?: number;
    PyCommittedTeamOverhead?: number;
    PyCommittedUnitRevenue?: number;
    PyCommittedUnitCost?: number;
    PyCommittedUnitPercentage?: number;
    PyCommittedUnitOverhead?: number;
    PyCommittedDepartmentRevenue?: number;
    PyCommittedDepartmentCost?: number;
    PyCommittedDepartmentPercentage?: number;
    PyCommittedDepartmentOverhead?: number;
    PyCommittedGrossProfit?: number;
    PyCommittedNetProfit?: number;
    PyProjectedRevenue?: number;
    PyProjectedCost?: number;
    PyProjectedTeamRevenue?: number;
    PyProjectedTeamCost?: number;
    PyProjectedTeamPercentage?: number;
    PyProjectedTeamOverhead?: number;
    PyProjectedUnitRevenue?: number;
    PyProjectedUnitCost?: number;
    PyProjectedUnitPercentage?: number;
    PyProjectedUnitOverhead?: number;
    PyProjectedDepartmentRevenue?: number;
    PyProjectedDepartmentCost?: number;
    PyProjectedDepartmentPercentage?: number;
    PyProjectedDepartmentOverhead?: number;
    PyProjectedGrossProfit?: number;
    PyProjectedNetProfit?: number;
    PyYtdRevenue?: number;
    PyYtdCost?: number;
    PyYtdTeamRevenue?: number;
    PyYtdTeamCost?: number;
    PyYtdTeamPercentage?: number;
    PyYtdTeamOverhead?: number;
    PyYtdUnitRevenue?: number;
    PyYtdUnitCost?: number;
    PyYtdUnitPercentage?: number;
    PyYtdUnitOverhead?: number;
    PyYtdDepartmentRevenue?: number;
    PyYtdDepartmentCost?: number;
    PyYtdDepartmentPercentage?: number;
    PyYtdDepartmentOverhead?: number;
    PyYtdGrossProfit?: number;
    PyYtdNetProfit?: number;
    PyPcRevenue?: number;
    PyPcCost?: number;
    PyPcTeamRevenue?: number;
    PyPcTeamCost?: number;
    PyPcTeamPercentage?: number;
    PyPcTeamOverhead?: number;
    PyPcUnitRevenue?: number;
    PyPcUnitCost?: number;
    PyPcUnitPercentage?: number;
    PyPcUnitOverhead?: number;
    PyPcDepartmentRevenue?: number;
    PyPcDepartmentCost?: number;
    PyPcDepartmentPercentage?: number;
    PyPcDepartmentOverhead?: number;
    PyPcGrossProfit?: number;
    PyPcNetProfit?: number;
    CurYrCommittedRevenue?: number;
    CurYrCommittedCost?: number;
    CurYrCommittedTeamRevenue?: number;
    CurYrCommittedTeamCost?: number;
    CurYrCommittedTeamPercentage?: number;
    CurYrCommittedTeamOverhead?: number;
    CurYrCommittedUnitRevenue?: number;
    CurYrCommittedUnitCost?: number;
    CurYrCommittedUnitPercentage?: number;
    CurYrCommittedUnitOverhead?: number;
    CurYrCommittedDepartmentRevenue?: number;
    CurYrCommittedDepartmentCost?: number;
    CurYrCommittedDepartmentPercentage?: number;
    CurYrCommittedDepartmentOverhead?: number;
    CurYrCommittedGrossProfit?: number;
    CurYrCommittedNetProfit?: number;
    CurYrProjectedRevenue?: number;
    CurYrProjectedCost?: number;
    CurYrProjectedDate?: number;
    CurYrProjectedTeamRevenue?: number;
    CurYrProjectedTeamCost?: number;
    CurYrProjectedTeamPercentage?: number;
    CurYrProjectedTeamOverhead?: number;
    CurYrProjectedUnitRevenue?: number;
    CurYrProjectedUnitCost?: number;
    CurYrProjectedUnitPercentage?: number;
    CurYrProjectedUnitOverhead?: number;
    CurYrProjectedDepartmentRevenue?: number;
    CurYrProjectedDepartmentCost?: number;
    CurYrProjectedDepartmentPercentage?: number;
    CurYrProjectedDepartmentOverhead?: number;
    CurYrProjectedGrossProfit?: number;
    CurYrProjectedNetProfit?: number;
    CurYrYtdRevenue?: number;
    CurYrYtdCost?: number;
    CurYrYtdTeamRevenue?: number;
    CurYrYtdTeamCost?: number;
    CurYrYtdTeamPercentage?: number;
    CurYrYtdTeamOverhead?: number;
    CurYrYtdUnitRevenue?: number;
    CurYrYtdUnitCost?: number;
    CurYrYtdUnitPercentage?: number;
    CurYrYtdUnitOverhead?: number;
    CurYrYtdDepartmentRevenue?: number;
    CurYrYtdDepartmentCost?: number;
    CurYrYtdDepartmentPercentage?: number;
    CurYrYtdDepartmentOverhead?: number;
    CurYrYtdGrossProfit?: number;
    CurYrYtdNetProfit?: number;
    CurYrPcRevenue?: number;
    CurYrPcCost?: number;
    CurYrPcTeamRevenue?: number;
    CurYrPcTeamCost?: number;
    CurYrPcTeamPercentage?: number;
    CurYrPcTeamOverhead?: number;
    CurYrPcUnitRevenue?: number;
    CurYrPcUnitCost?: number;
    CurYrPcUnitPercentage?: number;
    CurYrPcUnitOverhead?: number;
    CurYrPcDepartmentRevenue?: number;
    CurYrPcDepartmentCost?: number;
    CurYrPcDepartmentPercentage?: number;
    CurYrPcDepartmentOverhead?: number;
    CurYrPcGrossProfit?: number;
    CurYrPcNetProfit?: number;
    CurYrForecastedRevenue?: number;
    CurYrForecastedCost?: number;
    CurYrForecastedTeamRevenue?: number;
    CurYrForecastedTeamCost?: number;
    CurYrForecastedTeamPercentage?: number;
    CurYrForecastedTeamOverhead?: number;
    CurYrForecastedUnitRevenue?: number;
    CurYrForecastedUnitCost?: number;
    CurYrForecastedUnitPercentage?: number;
    CurYrForecastedUnitOverhead?: number;
    CurYrForecastedDepartmentRevenue?: number;
    CurYrForecastedDepartmentCost?: number;
    CurYrForecastedDepartmentPercentage?: number;
    CurYrForecastedDepartmentOverhead?: number;
    CurYrForecastedGrossProfit?: number;
    CurYrForecastedNetProfit?: number;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    UnitName?: string;
    WachterDepartmentId?: number;
    FiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfitMargin?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfitMargin?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamNetProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfitMargin?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcUnitOverhead?: number;
    PcDepartmentOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamNetProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfitMargin?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfitMargin?: number;
    SubUnitName?: string;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearBackupEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    UnitName?: string;
    WachterDepartmentId?: number;
    FiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamNetProfitMargin?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentOverhead?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamNetProfitMargin?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentOverhead?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfit?: number;
    YtdTeamNetProfitMargin?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentOverhead?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfit?: number;
    PcTeamNetProfitMargin?: number;
    PcUnitOverhead?: number;
    PcDepartmentOverhead?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamNetProfitMargin?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentOverhead?: number;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearOLDEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    WachterDepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;
    FiscalYear?: number;
    CommittedFiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedUnitRevenue?: number;
    CommittedUnitCost?: number;
    CommittedUnitPercentage?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentRevenue?: number;
    CommittedDepartmentCost?: number;
    CommittedDepartmentPercentage?: number;
    CommittedDepartmentOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfitMargin?: number;
    ProjectedFiscalYear?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedUnitRevenue?: number;
    ProjectedUnitCost?: number;
    ProjectedUnitPercentage?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentRevenue?: number;
    ProjectedDepartmentCost?: number;
    ProjectedDepartmentPercentage?: number;
    ProjectedDepartmentOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfitMargin?: number;
    YtdFiscalYear?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdUnitRevenue?: number;
    YtdUnitCost?: number;
    YtdUnitPercentage?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentRevenue?: number;
    YtdDepartmentCost?: number;
    YtdDepartmentPercentage?: number;
    YtdDepartmentOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamNetProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfitMargin?: number;
    PcFiscalYear?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcUnitRevenue?: number;
    PcUnitCost?: number;
    PcUnitPercentage?: number;
    PcUnitOverhead?: number;
    PcDepartmentRevenue?: number;
    PcDepartmentCost?: number;
    PcDepartmentPercentage?: number;
    PcDepartmentOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamNetProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfitMargin?: number;
    ForecastedFiscalYear?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedUnitRevenue?: number;
    ForecastedUnitCost?: number;
    ForecastedUnitPercentage?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentRevenue?: number;
    ForecastedDepartmentCost?: number;
    ForecastedDepartmentPercentage?: number;
    ForecastedDepartmentOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfitMargin?: number;


    // Relations
}

export interface RoNSPFinancialNumbersByYearEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    PMNameFirstPreferredLast?: string;
    PMNameLastFirstPreferred?: string;
    PMNameFirstLast?: string;
    PMNamePreferredLast?: string;
    EthosTitle?: string;
    EthosEmail?: string;
    EthosSupId?: number;
    SupNameFirstPreferredLast?: string;
    SupNameLastFirstPreferred?: string;
    SupNameFirstLast?: string;
    SupNamePreferredLast?: string;
    WachterTeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    WachterDepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;
    FiscalYear?: number;
    CommittedFiscalYear?: number;
    CommittedRevenue?: number;
    CommittedCost?: number;
    CommittedDate?: string;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamPercentage?: number;
    CommittedTeamOverhead?: number;
    CommittedUnitRevenue?: number;
    CommittedUnitCost?: number;
    CommittedUnitPercentage?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentRevenue?: number;
    CommittedDepartmentCost?: number;
    CommittedDepartmentPercentage?: number;
    CommittedDepartmentOverhead?: number;
    CommittedGrossProfit?: number;
    CommittedNetProfit?: number;
    CommittedGrossProfitMargin?: number;
    CommittedNetProfitMargin?: number;
    ProjectedFiscalYear?: number;
    ProjectedRevenue?: number;
    ProjectedCost?: number;
    ProjectedDate?: string;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamPercentage?: number;
    ProjectedTeamOverhead?: number;
    ProjectedUnitRevenue?: number;
    ProjectedUnitCost?: number;
    ProjectedUnitPercentage?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentRevenue?: number;
    ProjectedDepartmentCost?: number;
    ProjectedDepartmentPercentage?: number;
    ProjectedDepartmentOverhead?: number;
    ProjectedGrossProfit?: number;
    ProjectedNetProfit?: number;
    ProjectedGrossProfitMargin?: number;
    ProjectedNetProfitMargin?: number;
    YtdFiscalYear?: number;
    YtdRevenue?: number;
    YtdCost?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamPercentage?: number;
    YtdTeamOverhead?: number;
    YtdUnitRevenue?: number;
    YtdUnitCost?: number;
    YtdUnitPercentage?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentRevenue?: number;
    YtdDepartmentCost?: number;
    YtdDepartmentPercentage?: number;
    YtdDepartmentOverhead?: number;
    YtdGrossProfit?: number;
    YtdNetProfit?: number;
    YtdGrossProfitMargin?: number;
    YtdNetProfitMargin?: number;
    PcFiscalYear?: number;
    PcRevenue?: number;
    PcCost?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamPercentage?: number;
    PcTeamOverhead?: number;
    PcUnitRevenue?: number;
    PcUnitCost?: number;
    PcUnitPercentage?: number;
    PcUnitOverhead?: number;
    PcDepartmentRevenue?: number;
    PcDepartmentCost?: number;
    PcDepartmentPercentage?: number;
    PcDepartmentOverhead?: number;
    PcGrossProfit?: number;
    PcNetProfit?: number;
    PcGrossProfitMargin?: number;
    PcNetProfitMargin?: number;
    ForecastedFiscalYear?: number;
    ForecastedRevenue?: number;
    ForecastedCost?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamPercentage?: number;
    ForecastedTeamOverhead?: number;
    ForecastedUnitRevenue?: number;
    ForecastedUnitCost?: number;
    ForecastedUnitPercentage?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentRevenue?: number;
    ForecastedDepartmentCost?: number;
    ForecastedDepartmentPercentage?: number;
    ForecastedDepartmentOverhead?: number;
    ForecastedGrossProfit?: number;
    ForecastedNetProfit?: number;
    ForecastedGrossProfitMargin?: number;
    ForecastedNetProfitMargin?: number;
    YtdForecastedFiscalYear?: number;
    YtdForecastedRevenue?: number;
    YtdForecastedCost?: number;
    YtdForecastedTeamRevenue?: number;
    YtdForecastedTeamCost?: number;
    YtdForecastedTeamPercentage?: number;
    YtdForecastedTeamOverhead?: number;
    YtdForecastedUnitRevenue?: number;
    YtdForecastedUnitCost?: number;
    YtdForecastedUnitPercentage?: number;
    YtdForecastedUnitOverhead?: number;
    YtdForecastedDepartmentRevenue?: number;
    YtdForecastedDepartmentCost?: number;
    YtdForecastedDepartmentPercentage?: number;
    YtdForecastedDepartmentOverhead?: number;
    YtdForecastedGrossProfit?: number;
    YtdForecastedNetProfit?: number;
    YtdForecastedGrossProfitMargin?: number;
    YtdForecastedNetProfitMargin?: number;


    // Relations
}

export interface RoNspOverheadProjectedByDepartmentByYearEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    FiscalYear?: number;
    Cost?: number;


    // Relations
}

export interface RoNspOverheadProjectedByTeamByYearEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    OrganizationalUnitId?: number;
    Cost?: number;


    // Relations
}

export interface RoNspProjectedByDepartmentEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspProjectedByProjectManagerEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    FiscalYear?: number;
    CreatedByDateTime?: string;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspProjectedByTeamEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspProjectedByUnitEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoOrganizationalTeamUnitDeptEntity extends DwOrmData {
    // Attributes
    TeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    DepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;


    // Relations
}

export interface RoOverheadCommittedByJobPhaseYearEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoOverheadProjectedByJobPhaseYearEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    WachterDepartmentId?: number;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoOverheadProjectionByTeamEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoPafAccessEntity extends DwOrmData {
    // Attributes
    PayJobChangeId?: number;
    Employee?: number;
    ViewableBy?: number;
    ReportingLevels?: number;

    // Display Attributes
    PayJobChangeIdDisplay?: string;
    EmployeeDisplay?: string;
    ViewableByDisplay?: string;

    // Relations
    PayJobChange? : PayJobChangeEntity;
}

export interface RoPayJobChangeSubordinatesEntity extends DwOrmData {
    // Attributes
    PayJobChangeId?: number;
    EmployeeEthos_UserId?: number;
    CreatedbyEthos_UserId?: number;
    EmployeeSupervisorUserId?: number;
    EmployeeSupervisorName?: string;
    EmployeeSupervisorDepth?: number;
    CreatedBySupervisorUserId?: number;
    CreatedBySupervisorName?: string;
    CreatedBySupervisorDepth?: number;


    // Relations
}

export interface RoPermitRequestLastNoteEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    Note?: string;
    NoteId?: number;


    // Relations
    PermitRequest? : PermitRequestEntity[];
}

export interface RoPermitRequestsEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    RequestedByUserId?: number;
    JobId?: number;
    OpportunityId?: number;
    JobNumberId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    CountyId?: number;
    StateProvinceId?: number;
    CountyName?: string;
    StateProvinceName?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;

    // Display Attributes
    RequestedByUserIdDisplay?: string;
    OpportunityIdDisplay?: string;
    JobNumberIdDisplay?: string;
    StateProvinceIdDisplay?: string;

    // Relations
    PermitRequest? : PermitRequestEntity[];
}

export interface RoPermitsEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUser?: number;
    PermitStatusWs?: number;
    DueDate?: string;
    JobId?: number;
    CanBePulledOnline?: boolean;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubcontractorLicense?: string;
    PermitTeamCv?: number;
    AssignedToUser?: number;
    FloorCount?: number;
    FacilitySquareFeet?: number;
    CableTypeCv?: number;
    BuildingPermitNumber?: string;
    UndergroundCablingPresent?: boolean;
    CablingInConduitPresent?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    AttachmentId?: number;
    JobSiteId?: number;
    ScopeOfWork?: string;
    SharepointId?: number;
    PropertyOwnerAddress?: string;
    PermitTypeCv?: number;
    NoteParentId?: number;
    JobNumberId?: number;
    OpportunityId?: number;
    OverallContractValuation?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    SiteTypeCv?: number;
    JobNumberName?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;
    CountyId?: number;
    CountyName?: string;
    InspectionStateCv?: number;

    // Display Attributes
    RequestedByUserDisplay?: string;
    PermitStatusWsDisplay?: string;
    JobIdDisplay?: string;
    PerformingWorkCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    AssignedToUserDisplay?: string;
    CableTypeCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    JobNumberIdDisplay?: string;
    OpportunityIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    SiteTypeCvDisplay?: string;

    // Relations
    Permit? : PermitEntity[];
}

export interface Permits2RoPermitsEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    JobId?: number;
    JobNumberId?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;
    InspectionNeeded?: boolean;
    HasAssociatedJobId?: boolean;
    JobAddress1?: string;
    JobAddress2?: string;
    JobCity?: string;
    JobCountyId?: number;
    JobCountyName?: string;
    JobStateId?: number;
    JobStateName?: string;
    JobStateShortName?: string;
    JobPostalCode?: string;
    ProjectManagerUserId?: number;
    ProjectManagerEmail?: string;
    CustomerName?: string;
    ProjectManager2UserId?: number;
    JobNumJobNumberId?: number;
    JobNumAddress1?: string;
    JobNumAddress2?: string;
    JobNumCity?: string;
    JobNumStateId?: number;
    JobNumStateName?: string;
    JobNumStateShortName?: string;
    JobNumPostalCode?: string;
    SummaryDescription?: string;
    JobNumber?: string;
    JobSiteId?: number;
    IsActive?: boolean;
    IsComplete?: boolean;
    ProjectManager2Email?: string;
    InspDueDate?: string;

    // Display Attributes
    PermitIdDisplay?: string;
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobStateIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    ProjectManager2UserIdDisplay?: string;
    JobNumJobNumberIdDisplay?: string;
    JobSiteIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    JobNumEthosJobNumber? : EthosJobNumberEntity;
    PermitIdEthosOpportunity? : EthosOpportunityEntity;
    ProjectManagerEthosUser? : EthosUserEntity;
    ProjectManager2EthosUser? : EthosUserEntity;
    Permits2Permit? : Permits2PermitEntity[];
    RoPermitsBySubordinates? : RoPermitsBySubordinatesEntity[];
}

export interface RoPermitsBySubordinatesEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUserId?: number;
    ViewableBy?: number;
    ReportingLevels?: number;

    // Display Attributes
    PermitIdDisplay?: string;

    // Relations
    Permits2roPermits? : Permits2RoPermitsEntity;
}

export interface RoPositionHistoryEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    Title?: string;
    ChangeDate?: string;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
}

export interface RoProjectKickoffEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    Customer?: string;
    JobNumber?: string;
    ProjectName?: string;
    ProjectManagerUserId?: number;
    StartDate?: string;
    EndDate?: string;
    KickoffId?: number;
    CustomerId?: number;
    CustomerShortName?: string;
    SupervisorUserId?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    ProjectManagerUserIdDisplay?: string;
    KickoffIdDisplay?: string;
    CustomerIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ProjectsKickoff? : ProjectsKickoffEntity;
}

export interface RoProjectManagersTeamUnitDeptEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    HasRevenue?: boolean;
    PMNameFirstPreferredLast?: string;
    PMNameLastFirstPreferred?: string;
    PMNameFirstLast?: string;
    PMNamePreferredLast?: string;
    EthosTitle?: string;
    EthosEmail?: string;
    EthosSupId?: number;
    SupNameFirstPreferredLast?: string;
    SupNameLastFirstPreferred?: string;
    SupNameFirstLast?: string;
    SupNamePreferredLast?: string;
    TeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    DepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;


    // Relations
}

export interface RoRequestEntity extends DwOrmData {
    // Attributes
    RequestId?: number;
    JobNumberWjid?: string;
    DepartureLocation?: string;
    DestinationLocation?: string;
    DestinationArrivalDate?: string;
    ReturningDate?: string;
    TravelModeCv?: number;
    TraveModeComment?: string;
    FlightPreference?: string;
    AirportPlanCv?: number;
    AirportPlanComment?: string;
    TransportationPlanCv?: number;
    TransportationPlanComment?: string;
    LodgingPlanCv?: number;
    LodgingPlanComment?: string;
    TravelRequestComments?: string;
    TravelTypeCv?: number;
    TravelTypeComment?: string;
    ProjectManagerEthos_UserId?: number;
    Customer?: string;
    CustomerPm?: string;
    TravelReason?: string;
    PotentialRevenue?: number;
    NumberOfSites?: number;
    ProjectDuration?: string;
    MeetingNotes?: string;
    StatusCv?: number;
    TravelerEthos_UserId?: number;
    Preferences?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ParkingPassNeeded?: boolean;
    ParkingPassReturned?: boolean;

    // Display Attributes
    TravelModeCvDisplay?: string;
    AirportPlanCvDisplay?: string;
    TransportationPlanCvDisplay?: string;
    LodgingPlanCvDisplay?: string;
    TravelTypeCvDisplay?: string;
    ProjectManagerEthos_UserIdDisplay?: string;
    StatusCvDisplay?: string;
    TravelerEthos_UserIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    TravelRequest? : TravelRequestEntity;
    ProjectManagerEthosRoEthosUser? : RoEthosUserEntity;
    UserIdRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // UserIdRoEthosUser : RoEthosUserEntity[];
}

export interface RoRequestContextEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    Target?: string;
    JobNumber?: string;
    JobName?: string;
    WJID?: number;
    TargetId?: number;

    // Display Attributes
    CodeValueIdDisplay?: string;

    // Relations
}

export interface RoStarRatingAvProjectsEntity extends DwOrmData {
    // Attributes
    Id?: number;
    DateSubmitted?: string;
    WJID?: number;
    JobNumber?: string;
    NspPm?: number;
    NspPmRating?: number;
    NspInstallTech?: number;
    NspInstallTechRating?: number;
    WtsPm?: number;
    WtsPmRating?: number;
    WtsEngineer?: number;
    WtsEngineerRating?: number;
    OverallExperience?: number;
    FollowUpRequested?: boolean;

    // Display Attributes
    IdDisplay?: string;
    WJIDDisplay?: string;
    NspPmDisplay?: string;
    NspInstallTechDisplay?: string;
    WtsPmDisplay?: string;
    WtsEngineerDisplay?: string;

    // Relations
    WJIDEthosJob? : EthosJobEntity;
    IdStarRatingAvProjects? : StarRatingAvProjectsEntity;
    // Duplicate property excluded
    // IdStarRatingAvProjects : StarRatingAvProjectsEntity;
}

export interface RoStarRatingAvProjectsPmsEntity extends DwOrmData {
    // Attributes
    Pm?: number;
    UserId?: number;

    // Display Attributes
    PmDisplay?: string;

    // Relations
}

export interface RoStarRatingNotificationTargetsEntity extends DwOrmData {
    // Attributes
    StarRatingFieldExperienceId?: number;
    Email?: string;
    EmailType?: string;
    WachterDepartmentId?: number;
    UserTypeCv?: number;


    // Relations
    StarRatingFieldExperience? : StarRatingFieldExperienceEntity;
}

export interface RoTerritoryStateProvinceEntity extends DwOrmData {
    // Attributes
    TerritoryId?: number;
    TerritoryName?: string;
    TerritoryDescription?: string;
    TerritoryMeaning?: string;
    TerritoryIsDeleted?: boolean;
    ColorHex?: string;
    StateProvinceId?: number;
    CountryId?: number;
    StateProvinceName?: string;
    StateProvinceShortName?: string;


    // Relations
}

export interface RoUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    Cost?: number;
    Revenue?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ProjectionMonth?: string;


    // Relations
}

export interface NumbersRoUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    NameLastFirstPrefered?: string;
    FiscalYear?: number;
    Ethos_WachterTeamId?: number;
    TeamName?: string;
    ProjectedRevenue?: number;
    ProjectedCost?: number;
    ProjectedGP?: number;
    ProjectedGPM?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoUserProjectionAnalyzedEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    UserId?: number;
    FiscalYear?: number;
    Revenue?: number;
    Cost?: number;
    Gross?: number;
    GrossMargin?: number;
    DateTimeProjected?: string;
    DateTimeUtcAnalyzed?: string;


    // Relations
}

export interface RoUserSkillListEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    TimerSkillList?: string;
    FullSkillIst?: string;


    // Relations
    TechEthosTimer? : TimerEntity[];
}

export interface RoVehicleEntity extends DwOrmData {
    // Attributes
    VehicleStatusCv?: number;
    UnitId?: string;
    DriverName?: string;
    DriverUserId?: number;
    JobNumberId?: number;
    WachterDepartmentId?: number;
    IsDot?: boolean;
    VehicleTypeCv?: number;
    Year?: number;
    Make?: string;
    Model?: string;
    VIN?: string;
    RegistrationStateProvinceId?: number;
    LicensePlate?: string;
    PlateExpirationDate?: string;
    VehicleId?: number;
    Phase?: string;
    SortableUnitId?: number;
    IsDotDisplay?: string;
    Unassigned?: boolean;

    // Display Attributes
    VehicleStatusCvDisplay?: string;
    UnitIdDisplay?: string;
    DriverNameDisplay?: string;
    DriverUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    VehicleTypeCvDisplay?: string;
    YearDisplay?: string;
    RegistrationStateProvinceIdDisplay?: string;
    VehicleIdDisplay?: string;

    // Relations
    FleetVehicle? : FleetVehicleEntity;
    Vehicle? : VehicleEntity;
    // Duplicate property excluded
    // FleetVehicle : FleetVehicleEntity;
}

export interface RoVehicleAccidentsEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    AccidentDateMonth?: string;
    StateDisplay?: string;
    IsPoliceReportObtained?: boolean;
    ClaimNumberThirdParty?: string;


    // Relations
}

export interface RoVehicleYearsEntity extends DwOrmData {
    // Attributes
    Year?: number;


    // Relations
}

export interface RoWorkersCompEntity extends DwOrmData {
    // Attributes
    AccidentId?: number;
    AXId?: string;
    Employee?: string;
    ExpenseType?: string;
    Date?: string;
    Details?: string;
    Expenses?: number;

    // Display Attributes
    AccidentIdDisplay?: string;

    // Relations
    AccidentIdWorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface RoWorkplaceAccidentEntity extends DwOrmData {
    // Attributes
    CombinedEmployeeName?: string;
    CombinedDepartmentName?: string;
    WorkplaceAccidentId?: number;
    IsWachterEmployee?: boolean;
    Ethos_UserId?: number;
    EmployeeName?: string;
    DepartmentId?: number;
    JobNumberId?: number;
    WJID?: string;
    Facility?: string;
    WorksiteTypeCv?: number;
    PriorToAccidentDescription?: string;
    AccidentDescription?: string;
    InjuryDescription?: string;
    ObjectDescription?: string;
    DeathDescription?: string;
    AttachmentId?: number;
    AccidentTypeCv?: number;
    AccidentDateTime?: string;
    BodySideCv?: number;
    BodyPartCv?: number;
    InjuryTypeCv?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    AccidentAddress?: string;
    MediaGroupId?: number;
    InjuryOtherExplanation?: string;
    EmployeeAddress?: string;
    EmployeeCity?: string;
    EmployeeState?: number;
    EmployeeZip?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    FatalityInvolved?: boolean;
    FatalityDateTime?: string;
    ClaimNumber?: string;
    ClaimFileDate?: string;
    ClaimInsuranceCompany?: string;
    ClaimAdjustorName?: string;
    ClaimAdjustorPhone?: string;
    ClaimComments?: string;
    EmployeeOnLeave?: boolean;
    EmployeeHasAttorney?: boolean;
    EmployeeAttorneyName?: string;
    EmployeeAttorneyPhone?: string;
    ClaimStatusCv?: number;
    MedicalWachter?: string;
    MedicalAboveDeductible?: string;
    WageExpenseWachter?: string;
    WageExpenseAboveDeductible?: string;
    InHouseClaim?: boolean;
    WorkersCompAttachmentId?: number;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;

    // Relations
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface RoWorkplaceAccidentNotesEntity extends DwOrmData {
    // Attributes
    WorkplaceAccidentId?: number;
    Notes?: string;
    OOP?: number;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;

    // Relations
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface RoYearRangeEntity extends DwOrmData {
    // Attributes
    YearId?: number;
    Year?: number;


    // Relations
}

export interface ServiceTypeEntity extends DwOrmData {
    // Attributes
    ServiceTypeId?: number;
    Display?: string;


    // Relations
    MaintenanceService? : MaintenanceServiceEntity[];
}

export interface StageAuditLogEntity extends DwOrmData {
    // Attributes
    StageAuditLogId?: number;
    PermitStatusId?: number;
    StatusUpdatedByUserId?: number;
    CreatedByDateTime?: string;
    PermitId?: number;
    StageCompleted?: string;

    // Display Attributes
    PermitStatusIdDisplay?: string;
    StatusUpdatedByUserIdDisplay?: string;
    PermitIdDisplay?: string;

    // Relations
    Permits2Permit? : Permits2PermitEntity;
    Permits2PermitStatus? : Permits2PermitStatusEntity;
    StatusUpdatedByEthosUser? : EthosUserEntity;
}

export interface StakeholderEntity extends DwOrmData {
    // Attributes
    StakeholderId?: number;
    KickoffId?: number;
    Name?: string;
    Title?: string;
    Role?: string;
    Department?: string;
    Company?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface StarRatingAvProjectsEntity extends DwOrmData {
    // Attributes
    StarRatingAvProjectsId?: number;
    Ethos_JobId?: number;
    NspPmScore?: number;
    NspInstallTechScore?: number;
    WtsPmScore?: number;
    WtsEngineerScore?: number;
    OverallScore?: number;
    AdditionalComments?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    FollowUpRequested?: boolean;
    FollowedUpOnDateTime?: string;
    FollowedUpByEthos_UserId?: number;
    HasBeenReviewed?: boolean;
    NspInstallTechnicianUserId?: number;

    // Display Attributes
    Ethos_JobIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    FollowedUpByEthos_UserIdDisplay?: string;
    NspInstallTechnicianUserIdDisplay?: string;

    // Relations
    EthosEthosJob? : EthosJobEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    FollowedUpByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    ProjectManagerEthosEthosUser? : EthosUserEntity;
    NspInstallTechnicianEthosUser? : EthosUserEntity;
    IdRoStarRatingAvProjects? : RoStarRatingAvProjectsEntity[];
    // Duplicate property excluded
    // IdRoStarRatingAvProjects : RoStarRatingAvProjectsEntity[];
}

export interface StarRatingFieldExperienceEntity extends DwOrmData {
    // Attributes
    StarRatingFieldExperienceId?: number;
    ProjectManagerEthos_UserId?: number;
    AdditionalComments?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    IsDeleted?: boolean;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Ethos_JobId?: number;
    FollowUpRequested?: boolean;
    OverallScore?: number;
    SchedulingScore?: number;
    ResponsivenessScore?: number;
    SupportScore?: number;
    HasBeenReviewed?: boolean;
    FollowedUpOnDateTime?: string;
    FollowedUpByEthos_UserId?: number;
    NoteParentId?: number;

    // Display Attributes
    ProjectManagerEthos_UserIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    Ethos_JobIdDisplay?: string;
    FollowedUpByEthos_UserIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    EthosEthosJob? : EthosJobEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    ProjectManagerEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    FollowedUpByEthosEthosUser? : EthosUserEntity;
    RoStarRatingNotificationTargets? : RoStarRatingNotificationTargetsEntity[];
}

export interface StarRatingNotificationEntity extends DwOrmData {
    // Attributes
    StarRatingNotificationId?: number;
    StarRatingNotificationTypeId?: number;
    WachterDepartmentId?: number;
    UserTypeCv?: number;
    Email?: string;

    // Display Attributes
    StarRatingNotificationTypeIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    UserTypeCvDisplay?: string;

    // Relations
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    StarRatingNotificationStarRatingNotificationType? : StarRatingNotificationTypeEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface StarRatingNotificationTypeEntity extends DwOrmData {
    // Attributes
    TypeId?: number;
    Display?: string;
    DisplayShortName?: string;


    // Relations
    StarRatingNotificationStarRatingNotification? : StarRatingNotificationEntity[];
}

export interface SuggestedCompositeIndexesEntity extends DwOrmData {
    // Attributes
    CREATE_Commented?: string;
    DROP_Commented?: string;


    // Relations
}

export interface SuggestedForeignKeyIndexesEntity extends DwOrmData {
    // Attributes
    CREATE_Commented?: string;
    DROP_Commented?: string;
    // Attribute Existing FK Constraint has invalid characters and can't be included
    // Attribute ON FK has invalid characters and can't be included
    // Attribute REFERENCING PK has invalid characters and can't be included
    // Attribute Suggested Index has invalid characters and can't be included
    CREATE?: string;
    DROP?: string;


    // Relations
}

export interface TeamAssignmentEntity extends DwOrmData {
    // Attributes
    TeamAssignmentId?: number;
    KickoffId?: number;
    WachterTeamId?: number;
    HybridKey?: string;

    // Display Attributes
    KickoffIdDisplay?: string;
    WachterTeamIdDisplay?: string;

    // Relations
    ProjectsKickoff? : ProjectsKickoffEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
}

export interface TeamYearNumbersEntity extends DwOrmData {
    // Attributes
    EthosTeamId?: number;
    FiscalYear?: number;
    CommittedRevenue?: number;
    ProjectedRevenue?: number;
    ForecastedRevenue?: number;
    ManagementRevenue?: number;
    CommittedGPM?: number;
    CommittedNPM?: number;
    ProjectedGPM?: number;
    ProjectedNPM?: number;
    ForecastedGPM?: number;
    ForecastedNPM?: number;
    ManagementGPM?: number;
    ManagementNPM?: number;
    RowInsertDateTime?: string;
    AccountingRevenue?: number;
    AccountingGPM?: number;
    AccountingNPM?: number;
    CommittedNetProfit?: number;
    ProjectedNetProfit?: number;
    ForecastedNetProfit?: number;
    AccountingNetProfit?: number;
    ManagementNetProfit?: number;

    // Display Attributes
    EthosTeamIdDisplay?: string;

    // Relations
    EthosTeamIdEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface TemplateEntity extends DwOrmData {
    // Attributes
    TemplateId?: number;
    Name?: string;
    SettingsJson?: string;
    IsDeleted?: boolean;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;


    // Relations
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
}

export interface TermResignEntity extends DwOrmData {
    // Attributes
    TermResignId?: number;
    LastDayOfEmployment?: string;
    EligibleForRehire?: boolean;
    Comments?: string;
    EmployeeEthos_UserId?: number;
    ReasonForLeavingCv?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ResendEmail?: boolean;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    ReasonForLeavingCvDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    ReasonForLeavingCvCodeValue? : CodeValueEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
}

export interface TerritoryEntity extends DwOrmData {
    // Attributes
    TerritoryId?: number;
    TerritoryName?: string;
    Description?: string;
    Meaning?: string;
    ColorHex?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity[];
    TerritoryStateProvince? : TerritoryStateProvinceEntity[];
    UserExtended? : UserExtendedEntity[];
}

export interface TerritoryStateProvinceEntity extends DwOrmData {
    // Attributes
    TerritoryStateProvinceId?: number;
    TerritoryId?: number;
    Ethos_StateProvinceId?: number;

    // Display Attributes
    TerritoryIdDisplay?: string;
    Ethos_StateProvinceIdDisplay?: string;

    // Relations
    EthosEthosStateProvince? : EthosStateProvinceEntity;
    Territory? : TerritoryEntity;
}

export interface TimerEntity extends DwOrmData {
    // Attributes
    TimerId?: number;
    TimerStatusId?: number;
    TimerTypeId?: number;
    Ethos_JobId?: number;
    TechEthos_UserId?: number;
    StartDateTime?: string;
    DueDateTime?: string;
    TimerMinutes?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Ethos_JobSiteId?: number;
    Notes?: string;

    // Display Attributes
    TimerStatusIdDisplay?: string;
    TimerTypeIdDisplay?: string;
    Ethos_JobIdDisplay?: string;
    TechEthos_UserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    Ethos_JobSiteIdDisplay?: string;

    // Relations
    EthosEthosJob? : EthosJobEntity;
    EthosEthosJobSite? : EthosJobSiteEntity;
    TimerStatus? : TimerStatusEntity;
    TimerType? : TimerTypeEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    TechEthosEthosUser? : EthosUserEntity;
    TechEthosRoUserSkillList? : RoUserSkillListEntity;
}

export interface TimerSkillMapEntity extends DwOrmData {
    // Attributes
    TimerSkillMapId?: number;
    EthosSkillCv?: number;

    // Display Attributes
    EthosSkillCvDisplay?: string;

    // Relations
    EthosSkillCvEthosCodeValue? : EthosCodeValueEntity;
}

export interface TimerStatusEntity extends DwOrmData {
    // Attributes
    TimerStatusId?: number;
    TimerStatus?: string;
    SortOrder?: number;


    // Relations
    Timer? : TimerEntity[];
}

export interface TimerTypeEntity extends DwOrmData {
    // Attributes
    TimerTypeId?: number;
    TimerType?: string;
    IsAscendingTimer?: boolean;


    // Relations
    Timer? : TimerEntity[];
}

export interface TmpRoAllSupervisorsSubordinatesEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    SupervisorUserId?: number;
    NameLastFirstPreferedType?: string;
    Depth?: number;


    // Relations
}

export interface TmpSysdiamgrasBackup20230417Entity extends DwOrmData {
    // Attributes
    name?: string;
    principal_id?: number;
    diagram_id?: number;
    version?: number;


    // Relations
}

export interface TravelerEntity extends DwOrmData {
    // Attributes
    TravelerId?: number;
    RequestId?: number;
    TravelerEthos_UserId?: number;
    CreatedByEthos_UserId?: number;
    CreatedDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    RequestIdDisplay?: string;

    // Relations
    TravelRequest? : TravelRequestEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    TravelerEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface TrustSyncLogEntity extends DwOrmData {
    // Attributes
    TrustSyncLogId?: number;
    InsertOnly?: boolean;
    StartDateTime?: string;
    EndDateTime?: string;
    Total_Elapsed?: number;
    No_Dependencies?: number;
    Requires_CodeSet?: number;
    Ethos_User?: number;
    Ethos_UserSkill?: number;
    Ethos_StateProvince?: number;
    Ethos_Address?: number;
    Ethos_StaffingAgency?: number;
    Ethos_Site?: number;
    Ethos_County?: number;
    Ethos_Opportunity?: number;
    Ethos_JobNumber?: number;
    Ethos_Job?: number;
    Ethos_JobSite?: number;
    Ethos_JobSow?: number;
    Ethos_JobNumberForecast?: number;
    Ethos_JobNumberPhase?: number;
    Ethos_WachterDepartment?: number;
    Ethos_WachterTeam?: number;
    RoAllSupervisorsSubordinates?: number;
    RoEthos_User?: number;
    Ethos_JobNumberPriority?: number;
    RoUserLaborSummary?: number;
    JobNumberMembership?: number;


    // Relations
}

export interface TrustUserMergedEntity extends DwOrmData {
    // Attributes
    TrustUserMergedId?: number;
    New_UserId?: number;
    Old_UserId?: number;

    // Display Attributes
    New_UserIdDisplay?: string;
    Old_UserIdDisplay?: string;

    // Relations
    NewEthosUser? : EthosUserEntity;
    OldEthosUser? : EthosUserEntity;
}

export interface UserExtendedEntity extends DwOrmData {
    // Attributes
    UserExtendedId?: number;
    Ethos_UserId?: number;
    FosEthos_UserId?: number;
    TerritoryId?: number;
    TechTypeCv?: number;
    StartingPayRate?: number;
    OrientationDate?: string;
    PermDate?: string;
    Comments?: string;
    spOsgAttachmentId?: number;
    IsPersonalVehicleUseAllowed?: boolean;
    PersonalVehicleUseExpirationDate?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    HiringManagerEthos_UserId?: number;
    PayChangeDate?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    Territory? : TerritoryEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface MtlUserExtendedEntity extends DwOrmData {
    // Attributes
    UserExtendedId?: number;
    Ethos_UserId?: number;
    FosEthos_UserId?: number;
    HiringManagerEthos_UserId?: number;
    TerritoryId?: number;
    TechTypeCv?: number;
    CurrentPayRate?: number;
    PayChangeDate?: string;
    OrientationDate?: string;
    PermDate?: string;
    Comments?: string;
    spOsgAttachmentId?: number;
    IsPersonalVehicleUseAllowed?: boolean;
    PersonalVehicleUseExpirationDate?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    FosEthos_UserIdDisplay?: string;
    HiringManagerEthos_UserIdDisplay?: string;
    TechTypeCvDisplay?: string;

    // Relations
    SpOsgAttachmentAttachment? : AttachmentEntity;
    TechTypeCvCodeValue? : CodeValueEntity;
    EthosRoEthosUser? : RoEthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    FosEthosEthosUser? : EthosUserEntity;
    HiringManagerEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
}

export interface EmsUserExtendedEntity extends DwOrmData {
    // Attributes
    UserExtendedId?: number;
    EmployeeEthos_UserId?: number;
    OperationsManagerEthos_UserId?: number;
    FosOfficeSupervisorEthos_UserId?: number;
    HiringManagerEthos_UserId?: number;
    CareerHistory?: string;
    EmergencyContactInformation?: string;
    TempStartDate?: string;
    OrientationDate?: string;
    LastEvalDate?: string;
    NextEvalDate?: string;
    Skills?: string;
    WorkStatusCv?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    IsDeleted?: boolean;
    AttachmentId?: number;
    PreviousManager?: number;
    EmployeeWorkType?: string;
    EmergencyContactPhone?: string;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    OperationsManagerEthos_UserIdDisplay?: string;
    FosOfficeSupervisorEthos_UserIdDisplay?: string;
    HiringManagerEthos_UserIdDisplay?: string;
    WorkStatusCvDisplay?: string;
    PreviousManagerDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    WorkStatusCvCodeValue? : CodeValueEntity;
    ProofOfInsuranceSummaryEmployeeEthosUserId? : ProofOfInsuranceSummaryEntity;
    EmployeeEthosRoAllSupervisorsSubordinates? : RoAllSupervisorsSubordinatesEntity;
    EmployeeEthosPerformanceMetrics? : PerformanceMetricsEntity;
    FosOfficeSupervisorEthosEthosUser? : EthosUserEntity;
    HiringManagerEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    OperationsManagerEthosEthosUser? : EthosUserEntity;
    PreviousManagerEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EmployeeEthosEthosUser? : EthosUserEntity;
    ETHOSUserIdDWPeoplePaySummary? : DWPeoplePaySummaryEntity[];
    EmployeeEthosUserIdEmployeeReviewSummary? : EmployeeReviewSummaryEntity[];
    ETHOSUserIdPeoplePayHistoryCurrentPreviousInitial? : PeoplePayHistoryCurrentPreviousInitialEntity[];
    ETHOSUserIdPeoplePayHistoryCurrentPreviousInitialV2? : PeoplePayHistoryCurrentPreviousInitialV2Entity[];
    UserIdRoEthosUser? : RoEthosUserEntity[];
    EmployeeUserIdRoEthosUserGrid? : RoEthosUserGridEntity[];
    IssuedToRoLicenses? : RoLicensesEntity[];
    UserExtendedEthosCustomer? : UserExtendedEthosCustomerEntity[];
}

export interface UserExtendedEthosCustomerEntity extends DwOrmData {
    // Attributes
    UserExtendedEthos_Customer?: number;
    UserExtendedId?: number;
    CustomerId?: number;

    // Display Attributes
    CustomerIdDisplay?: string;

    // Relations
    EthosCustomer? : EthosCustomerEntity;
    EmsUserExtended? : EmsUserExtendedEntity;
}

export interface WcUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    FiscalYear?: number;
    Ethos_WachterTeamId?: number;
    Revenue?: number;
    Cost?: number;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    GrossProfit?: number;
    GrossProfitMargin?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    Ethos_WachterTeamIdDisplay?: string;

    // Relations
    EthosRoEthosUser? : RoEthosUserEntity[];
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    EthosEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface UserReadEntity extends DwOrmData {
    // Attributes
    UserReadId?: number;
    MemoOfRecordId?: number;
    Ethos_UserId?: number;

    // Display Attributes
    MemoOfRecordIdDisplay?: string;

    // Relations
    MemoOfRecord? : MemoOfRecordEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface WcUserReadEntity extends DwOrmData {
    // Attributes
    UserReadId?: number;
    Ethos_UserId?: number;
    EmployeeTrainingNeededId?: number;

    // Display Attributes
    EmployeeTrainingNeededIdDisplay?: string;

    // Relations
    EmployeeTrainingNeeded? : EmployeeTrainingNeededEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface UserTeamLookupEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    TeamId?: number;
    FiscalYear?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    TeamIdDisplay?: string;
    FiscalYearDisplay?: string;

    // Relations
    TeamIdEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface UserYearNumbersEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    CommittedRevenue?: number;
    ProjectedRevenue?: number;
    ForecastedRevenue?: number;
    ManagementRevenue?: number;
    CommittedGPM?: number;
    CommittedNPM?: number;
    ProjectedGPM?: number;
    ProjectedNPM?: number;
    ForecastedGPM?: number;
    ForecastedNPM?: number;
    ManagementGPM?: number;
    ManagementNPM?: number;
    Ethos_UserId?: number;
    RowInsertDateTime?: string;
    AccountingRevenue?: number;
    AccountingGPM?: number;
    AccountingNPM?: number;
    WachterTeamId?: number;
    CommittedNetProfit?: number;
    ProjectedNetProfit?: number;
    ForecastedNetProfit?: number;
    AccountingNetProfit?: number;
    ManagementNetProfit?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;

    // Relations
    EthosRoEthosUser? : RoEthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
}

export interface VehicleEntity extends DwOrmData {
    // Attributes
    VehicleId?: number;
    VehicleAccidentId?: number;
    Year?: number;
    Make?: string;
    Model?: string;
    LicensePlateNumber?: string;
    LicensePlateState?: number;
    DriverName?: string;
    DriverLicenseNumber?: string;
    DriverLicenseState?: number;
    DriverPhoneNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    InsuranceCompany?: string;
    PolicyNumber?: string;
    DescriptionOfDamage?: string;
    PassengerName?: string;
    PassengerAddress?: string;
    PassengerPhone?: string;
    VIN?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    UnitNumber?: string;
    RentalCompanyName?: string;

    // Display Attributes
    VehicleAccidentIdDisplay?: string;
    LicensePlateStateDisplay?: string;
    DriverLicenseStateDisplay?: string;
    DriverStateDisplay?: string;

    // Relations
    LicensePlateStateEthosStateProvince? : EthosStateProvinceEntity;
    DriverLicenseStateEthosStateProvince? : EthosStateProvinceEntity;
    DriverStateEthosStateProvince? : EthosStateProvinceEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    VehicleAccident? : VehicleAccidentEntity;
    RoVehicle? : RoVehicleEntity[];
}

export interface FleetVehicleEntity extends DwOrmData {
    // Attributes
    VehicleId?: number;
    VehicleStatusCv?: number;
    UnitId?: string;
    JobNumberId?: number;
    WachterDepartmentId?: number;
    VehicleTypeCv?: number;
    Year?: number;
    Make?: string;
    Model?: string;
    VIN?: string;
    OwnershipTypeCv?: number;
    GVWR?: string;
    DriveTrainCv?: number;
    FuelTypeCv?: number;
    InsuranceExpirationDate?: string;
    LicensePlate?: string;
    PlateExpirationDate?: string;
    RegistrationStateProvinceId?: number;
    AnnualInspectionExpirationDate?: string;
    DielectricInspectionExpirationDate?: string;
    IsDot?: boolean;
    DotInspectionDate?: string;
    HasGps?: boolean;
    GpsId?: string;
    FuelCardId?: string;
    DriverAlertId?: string;
    PafEffectiveDate?: string;
    IsEmployee?: boolean;
    DriverUserId?: number;
    RawDriverName?: string;
    SendPaf?: boolean;
    PafNotes?: string;
    TransponderSerialNumber?: string;
    PurchasePrice?: number;
    PurchaseDate?: string;
    NoteParentId?: number;
    MediaGroupId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    PassAccountName?: string;
    PassAccountNumber?: string;
    PassActivationDate?: string;
    Phase?: string;
    SpJobNumber?: string;

    // Display Attributes
    VehicleStatusCvDisplay?: string;
    JobNumberIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    VehicleTypeCvDisplay?: string;
    YearDisplay?: string;
    OwnershipTypeCvDisplay?: string;
    DriveTrainCvDisplay?: string;
    FuelTypeCvDisplay?: string;
    RegistrationStateProvinceIdDisplay?: string;
    DriverUserIdDisplay?: string;
    NoteParentIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    VehicleStatusCvCodeValue? : CodeValueEntity;
    VehicleTypeCvCodeValue? : CodeValueEntity;
    OwnershipTypeCvCodeValue? : CodeValueEntity;
    DriveTrainCvCodeValue? : CodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    RegistrationEthosStateProvince? : EthosStateProvinceEntity;
    DriverEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    Auction? : AuctionEntity[];
    Maintenance? : MaintenanceEntity[];
    PafHistory? : PafHistoryEntity[];
    PassHistory? : PassHistoryEntity[];
    PlateHistory? : PlateHistoryEntity[];
    RoMaintenance? : RoMaintenanceEntity[];
    RoVehicle? : RoVehicleEntity[];
    // Duplicate property excluded
    // RoVehicle : RoVehicleEntity[];
}

export interface VehicleAccidentEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    IsPoliceReportObtained?: boolean;
    ClaimNumberThirdParty?: string;
    MediaGroupId?: number;
    VehicleValue?: number;
    SettlementExpense?: number;
    InsuredVehiclePDLT?: string;
    ClaimantVehiclePDLT?: string;
    InsuredObtainedRentalExpense?: string;
    ClaimantObtainedRentalExpense?: string;
    StorageTowingFees?: string;
    PoliceReportMiscFees?: string;
    ClaimHandlingFee?: number;
    EstimatedCosts?: number;
    Recoveries?: string;

    // Display Attributes
    EmployeeIdDisplay?: string;
    DriverStateDisplay?: string;
    AccidentStateDisplay?: string;
    AccidentTypeCvDisplay?: string;
    AccidentAtFaultCvDisplay?: string;
    VehicleRepairedCvDisplay?: string;
    AttachmentIdDisplay?: string;
    ClaimStatusCvDisplay?: string;
    ClaimInsuranceCompanyCvDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    AccidentAtFaultCvCodeValue? : CodeValueEntity;
    AccidentTypeCvCodeValue? : CodeValueEntity;
    ClaimInsuranceCompanyCvCodeValue? : CodeValueEntity;
    ClaimStatusCvCodeValue? : CodeValueEntity;
    VehicleRepairedCvCodeValue? : CodeValueEntity;
    AccidentStateEthosStateProvince? : EthosStateProvinceEntity;
    DriverStateEthosStateProvince? : EthosStateProvinceEntity;
    EmployeeIdRoEthosUser? : RoEthosUserEntity[];
    CreatedbyEthosRoEthosUser? : RoEthosUserEntity;
    ModifiedByEthosRoEthosUser? : RoEthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // EmployeeIdRoEthosUser : RoEthosUserEntity;
    Vehicle? : VehicleEntity[];
    Witness? : WitnessEntity[];
}

export interface VehicleTypeEntity extends DwOrmData {
    // Attributes
    VehicleTypeId?: number;
    VehicleTypeDisplay?: string;


    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface WachterContainerStyleEntity extends DwOrmData {
    // Attributes
    WachterContainerStyleId?: number;
    StyleDisplay?: string;
    StyleKey?: string;


    // Relations
    EmployeeReviewCategory? : EmployeeReviewCategoryEntity[];
}

export interface WachterTeamDepartmentEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    DepartmentName?: string;
    DivisionShortName?: string;


    // Relations
}

export interface WachterTeamOrganizationalUnitEntity extends DwOrmData {
    // Attributes
    WachterTeamOrganizationalUnitId?: number;
    Ethos_WachterTeamId?: number;
    OrganizationalUnitId?: number;
    HasRevenue?: boolean;


    // Relations
    EthosEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface WageExpenseEntity extends DwOrmData {
    // Attributes
    WageExpenseId?: number;
    WorkplaceAccidentId?: number;
    Details?: string;
    PaidDateTime?: string;
    Wages?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface WAppsRolesEntity extends DwOrmData {
    // Attributes
    RoleId?: number;
    RoleDisplay?: string;
    RoleMeaning?: string;


    // Relations
    WAppsEthosRoleMap? : EthosRoleMapEntity[];
}

export interface WitnessEntity extends DwOrmData {
    // Attributes
    WitnessId?: number;
    VehicleAccidentId?: number;
    WitnessName?: string;
    WitnessAddress?: string;
    WitnessPhone?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    VehicleAccidentIdDisplay?: string;

    // Relations
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    VehicleAccident? : VehicleAccidentEntity;
}

export interface WorkflowStatusEntity extends DwOrmData {
    // Attributes
    WorkflowStatusId?: number;
    WorkflowStatusSetId?: number;
    WorkflowStatus?: string;
    WorkflowStatusMeaning?: string;
    WorkflowStatusOrder?: number;
    IsActive?: boolean;


    // Relations
}

export interface WorkflowStatusSetEntity extends DwOrmData {
    // Attributes
    WorkflowStatusSetId?: number;
    WorkflowStatusSetName?: string;
    IsActive?: boolean;


    // Relations
}

export interface WorkplaceAccidentEntity extends DwOrmData {
    // Attributes
    WorkplaceAccidentId?: number;
    IsWachterEmployee?: boolean;
    Ethos_UserId?: number;
    EmployeeName?: string;
    DepartmentId?: number;
    JobNumberId?: number;
    WJID?: string;
    Facility?: string;
    WorksiteTypeCv?: number;
    PriorToAccidentDescription?: string;
    AccidentDescription?: string;
    InjuryDescription?: string;
    DeathDescription?: string;
    AttachmentId?: number;
    ObjectDescription?: string;
    AccidentTypeCv?: number;
    AccidentDateTime?: string;
    BodySideCv?: number;
    BodyPartCv?: number;
    InjuryTypeCv?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    MediaGroupId?: number;
    InjuryOtherExplanation?: string;
    EmployeeAddress?: string;
    AccidentAddress?: string;
    EmployeeCity?: string;
    EmployeeState?: number;
    EmployeeZip?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    FatalityInvolved?: boolean;
    FatalityDateTime?: string;
    ClaimNumber?: string;
    ClaimFileDate?: string;
    ClaimInsuranceCompany?: string;
    ClaimAdjustorName?: string;
    ClaimAdjustorPhone?: string;
    ClaimComments?: string;
    EmployeeOnLeave?: boolean;
    EmployeeHasAttorney?: boolean;
    EmployeeAttorneyName?: string;
    EmployeeAttorneyPhone?: string;
    ClaimStatusCv?: number;
    MedicalWachter?: string;
    MedicalAboveDeductible?: string;
    WageExpenseWachter?: string;
    WageExpenseAboveDeductible?: string;
    WorkersCompAttachmentId?: number;
    WorkersCompNoteParentId?: number;
    NoteParentId?: number;
    InHouseClaimNumber?: string;
    InHouseClaimFileDate?: string;
    InHouseClaimStatusCv?: number;
    EmployeePhone?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    DepartmentIdDisplay?: string;
    JobNumberIdDisplay?: string;
    WorksiteTypeCvDisplay?: string;
    AttachmentIdDisplay?: string;
    AccidentTypeCvDisplay?: string;
    BodySideCvDisplay?: string;
    BodyPartCvDisplay?: string;
    InjuryTypeCvDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    EmployeeStateDisplay?: string;
    AccidentStateDisplay?: string;
    ClaimStatusCvDisplay?: string;
    WorkersCompAttachmentIdDisplay?: string;
    WorkersCompNoteParentIdDisplay?: string;
    NoteParentIdDisplay?: string;
    InHouseClaimStatusCvDisplay?: string;

    // Relations
    AttachmentAttachment? : AttachmentEntity;
    WorkersCompAttachmentAttachment? : AttachmentEntity;
    InjuryTypeCvCodeValue? : CodeValueEntity;
    AccidentTypeCvCodeValue? : CodeValueEntity;
    BodyPartCvCodeValue? : CodeValueEntity;
    BodySideCvCodeValue? : CodeValueEntity;
    WorksiteTypeCvCodeValue? : CodeValueEntity;
    ClaimStatusCvCodeValue? : CodeValueEntity;
    InHouseClaimStatusCvCodeValue? : CodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    NotesNoteParent? : NotesNoteParentEntity;
    WorkersCompNotesNoteParent? : NotesNoteParentEntity;
    AccidentStateEthosStateProvince? : EthosStateProvinceEntity;
    EmployeeStateEthosStateProvince? : EthosStateProvinceEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    DepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
    MedicalRecord? : MedicalRecordEntity[];
    AccidentIdRoWorkersComp? : RoWorkersCompEntity[];
    RoWorkplaceAccident? : RoWorkplaceAccidentEntity;
    RoWorkplaceAccidentNotes? : RoWorkplaceAccidentNotesEntity[];
    WageExpense? : WageExpenseEntity[];
}



